var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp.call(b4, prop))
      __defNormalProp(a4, prop, b4[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b4)) {
      if (__propIsEnum.call(b4, prop))
        __defNormalProp(a4, prop, b4[prop]);
    }
  return a4;
};
var __spreadProps = (a4, b4) => __defProps(a4, __getOwnPropDescs(b4));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn2, res) => function __init() {
  return fn2 && (res = (0, fn2[Object.keys(fn2)[0]])(fn2 = 0)), res;
};
var __commonJS = (cb, mod2) => function __require() {
  return mod2 || (0, cb[Object.keys(cb)[0]])((mod2 = { exports: {} }).exports, mod2), mod2.exports;
};
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x4) => x4.done ? resolve(x4.value) : Promise.resolve(x4.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// studio/src/getStudio.ts
function setStudio(s3) {
  studio = s3;
}
function getStudio() {
  return studio;
}
var studio;
var init_getStudio = __esm({
  "studio/src/getStudio.ts"() {
  }
});

// shared/src/instanceTypes.ts
function typeAsserter(t3) {
  return (v5) => typeof v5 === "object" && !!v5 && v5.type === t3;
}
var isProject, isSheet, isSheetTemplate, isSheetObject, isSheetObjectTemplate, isProjectPublicAPI, isSheetPublicAPI, isSheetObjectPublicAPI;
var init_instanceTypes = __esm({
  "shared/src/instanceTypes.ts"() {
    isProject = typeAsserter("Theatre_Project");
    isSheet = typeAsserter("Theatre_Sheet");
    isSheetTemplate = typeAsserter("Theatre_SheetTemplate");
    isSheetObject = typeAsserter("Theatre_SheetObject");
    isSheetObjectTemplate = typeAsserter("Theatre_SheetObjectTemplate");
    isProjectPublicAPI = typeAsserter("Theatre_Project_PublicAPI");
    isSheetPublicAPI = typeAsserter("Theatre_Sheet_PublicAPI");
    isSheetObjectPublicAPI = typeAsserter("Theatre_SheetObject_PublicAPI");
  }
});

// ../node_modules/jiff/lib/lcs.js
var require_lcs = __commonJS({
  "../node_modules/jiff/lib/lcs.js"(exports2) {
    exports2.compare = compare;
    exports2.reduce = reduce;
    var REMOVE;
    var RIGHT;
    var ADD;
    var DOWN;
    var SKIP;
    exports2.REMOVE = REMOVE = RIGHT = -1;
    exports2.ADD = ADD = DOWN = 1;
    exports2.EQUAL = SKIP = 0;
    function compare(a4, b4) {
      var cols = a4.length;
      var rows = b4.length;
      var prefix = findPrefix(a4, b4);
      var suffix = prefix < cols && prefix < rows ? findSuffix(a4, b4, prefix) : 0;
      var remove = suffix + prefix - 1;
      cols -= remove;
      rows -= remove;
      var matrix = createMatrix(cols, rows);
      for (var j3 = cols - 1; j3 >= 0; --j3) {
        for (var i3 = rows - 1; i3 >= 0; --i3) {
          matrix[i3][j3] = backtrack(matrix, a4, b4, prefix, j3, i3);
        }
      }
      return {
        prefix,
        matrix,
        suffix
      };
    }
    function reduce(f3, r3, lcs) {
      var i3, j3, k4, op;
      var m3 = lcs.matrix;
      var l4 = lcs.prefix;
      for (i3 = 0; i3 < l4; ++i3) {
        r3 = f3(r3, SKIP, i3, i3);
      }
      k4 = i3;
      l4 = m3.length;
      i3 = 0;
      j3 = 0;
      while (i3 < l4) {
        op = m3[i3][j3].type;
        r3 = f3(r3, op, i3 + k4, j3 + k4);
        switch (op) {
          case SKIP:
            ++i3;
            ++j3;
            break;
          case RIGHT:
            ++j3;
            break;
          case DOWN:
            ++i3;
            break;
        }
      }
      i3 += k4;
      j3 += k4;
      l4 = lcs.suffix;
      for (k4 = 0; k4 < l4; ++k4) {
        r3 = f3(r3, SKIP, i3 + k4, j3 + k4);
      }
      return r3;
    }
    function findPrefix(a4, b4) {
      var i3 = 0;
      var l4 = Math.min(a4.length, b4.length);
      while (i3 < l4 && a4[i3] === b4[i3]) {
        ++i3;
      }
      return i3;
    }
    function findSuffix(a4, b4) {
      var al = a4.length - 1;
      var bl = b4.length - 1;
      var l4 = Math.min(al, bl);
      var i3 = 0;
      while (i3 < l4 && a4[al - i3] === b4[bl - i3]) {
        ++i3;
      }
      return i3;
    }
    function backtrack(matrix, a4, b4, start, j3, i3) {
      if (a4[j3 + start] === b4[i3 + start]) {
        return { value: matrix[i3 + 1][j3 + 1].value, type: SKIP };
      }
      if (matrix[i3][j3 + 1].value < matrix[i3 + 1][j3].value) {
        return { value: matrix[i3][j3 + 1].value + 1, type: RIGHT };
      }
      return { value: matrix[i3 + 1][j3].value + 1, type: DOWN };
    }
    function createMatrix(cols, rows) {
      var m3 = [], i3, j3, lastrow;
      lastrow = m3[rows] = [];
      for (j3 = 0; j3 < cols; ++j3) {
        lastrow[j3] = { value: cols - j3, type: RIGHT };
      }
      for (i3 = 0; i3 < rows; ++i3) {
        m3[i3] = [];
        m3[i3][cols] = { value: rows - i3, type: DOWN };
      }
      m3[rows][cols] = { value: 0, type: SKIP };
      return m3;
    }
  }
});

// ../node_modules/jiff/lib/array.js
var require_array = __commonJS({
  "../node_modules/jiff/lib/array.js"(exports2) {
    exports2.cons = cons;
    exports2.tail = tail;
    exports2.map = map;
    function cons(x4, a4) {
      var l4 = a4.length;
      var b4 = new Array(l4 + 1);
      b4[0] = x4;
      for (var i3 = 0; i3 < l4; ++i3) {
        b4[i3 + 1] = a4[i3];
      }
      return b4;
    }
    function tail(a4) {
      var l4 = a4.length - 1;
      var b4 = new Array(l4);
      for (var i3 = 0; i3 < l4; ++i3) {
        b4[i3] = a4[i3 + 1];
      }
      return b4;
    }
    function map(f3, a4) {
      var b4 = new Array(a4.length);
      for (var i3 = 0; i3 < a4.length; ++i3) {
        b4[i3] = f3(a4[i3]);
      }
      return b4;
    }
  }
});

// ../node_modules/jiff/lib/jsonPointerParse.js
var require_jsonPointerParse = __commonJS({
  "../node_modules/jiff/lib/jsonPointerParse.js"(exports2, module2) {
    module2.exports = jsonPointerParse;
    var parseRx = /\/|~1|~0/g;
    var separator = "/";
    var escapeChar = "~";
    var encodedSeparator = "~1";
    function jsonPointerParse(path, onSegment) {
      var pos, accum, matches2, match;
      pos = path.charAt(0) === separator ? 1 : 0;
      accum = "";
      parseRx.lastIndex = pos;
      while (matches2 = parseRx.exec(path)) {
        match = matches2[0];
        accum += path.slice(pos, parseRx.lastIndex - match.length);
        pos = parseRx.lastIndex;
        if (match === separator) {
          if (onSegment(accum) === false)
            return path;
          accum = "";
        } else {
          accum += match === encodedSeparator ? separator : escapeChar;
        }
      }
      accum += path.slice(pos);
      onSegment(accum);
      return path;
    }
  }
});

// ../node_modules/jiff/lib/jsonPointer.js
var require_jsonPointer = __commonJS({
  "../node_modules/jiff/lib/jsonPointer.js"(exports2) {
    var _parse = require_jsonPointerParse();
    exports2.find = find;
    exports2.join = join;
    exports2.absolute = absolute;
    exports2.parse = parse;
    exports2.contains = contains2;
    exports2.encodeSegment = encodeSegment;
    exports2.decodeSegment = decodeSegment;
    exports2.parseArrayIndex = parseArrayIndex;
    exports2.isValidArrayIndex = isValidArrayIndex;
    var separator = "/";
    var separatorRx = /\//g;
    var encodedSeparator = "~1";
    var encodedSeparatorRx = /~1/g;
    var escapeChar = "~";
    var escapeRx = /~/g;
    var encodedEscape = "~0";
    var encodedEscapeRx = /~0/g;
    function find(x4, path, findContext, context3) {
      if (typeof path !== "string") {
        return;
      }
      if (path === "") {
        return { target: x4, key: void 0 };
      }
      if (path === separator) {
        return { target: x4, key: "" };
      }
      var parent = x4, key;
      var hasContext = context3 !== void 0;
      _parse(path, function(segment) {
        if (x4 == null) {
          parent = null;
          return false;
        }
        if (Array.isArray(x4)) {
          key = hasContext ? findIndex2(findContext, parseArrayIndex(segment), x4, context3) : segment === "-" ? segment : parseArrayIndex(segment);
        } else {
          key = segment;
        }
        parent = x4;
        x4 = x4[key];
      });
      return parent === null ? void 0 : { target: parent, key };
    }
    function absolute(path) {
      return path[0] === separator ? path : separator + path;
    }
    function join(segments) {
      return segments.join(separator);
    }
    function parse(path) {
      var segments = [];
      _parse(path, segments.push.bind(segments));
      return segments;
    }
    function contains2(a4, b4) {
      return b4.indexOf(a4) === 0 && b4[a4.length] === separator;
    }
    function decodeSegment(s3) {
      return s3.replace(encodedSeparatorRx, separator).replace(encodedEscapeRx, escapeChar);
    }
    function encodeSegment(s3) {
      return s3.replace(escapeRx, encodedEscape).replace(separatorRx, encodedSeparator);
    }
    var arrayIndexRx = /^(0|[1-9]\d*)$/;
    function isValidArrayIndex(s3) {
      return arrayIndexRx.test(s3);
    }
    function parseArrayIndex(s3) {
      if (isValidArrayIndex(s3)) {
        return +s3;
      }
      throw new SyntaxError("invalid array index " + s3);
    }
    function findIndex2(findContext, start, array, context3) {
      var index = start;
      if (index < 0) {
        throw new Error("array index out of bounds " + index);
      }
      if (context3 !== void 0 && typeof findContext === "function") {
        index = findContext(start, array, context3);
        if (index < 0) {
          throw new Error("could not find patch context " + context3);
        }
      }
      return index;
    }
  }
});

// ../node_modules/jiff/lib/clone.js
var require_clone = __commonJS({
  "../node_modules/jiff/lib/clone.js"(exports2, module2) {
    module2.exports = clone;
    function clone(x4) {
      if (x4 == null || typeof x4 !== "object") {
        return x4;
      }
      if (Array.isArray(x4)) {
        return cloneArray(x4);
      }
      return cloneObject(x4);
    }
    function cloneArray(x4) {
      var l4 = x4.length;
      var y3 = new Array(l4);
      for (var i3 = 0; i3 < l4; ++i3) {
        y3[i3] = clone(x4[i3]);
      }
      return y3;
    }
    function cloneObject(x4) {
      var keys3 = Object.keys(x4);
      var y3 = {};
      for (var k4, i3 = 0, l4 = keys3.length; i3 < l4; ++i3) {
        k4 = keys3[i3];
        y3[k4] = clone(x4[k4]);
      }
      return y3;
    }
  }
});

// ../node_modules/jiff/lib/deepEquals.js
var require_deepEquals = __commonJS({
  "../node_modules/jiff/lib/deepEquals.js"(exports2, module2) {
    module2.exports = deepEquals;
    function deepEquals(a4, b4) {
      if (a4 === b4) {
        return true;
      }
      if (Array.isArray(a4) && Array.isArray(b4)) {
        return compareArrays(a4, b4);
      }
      if (typeof a4 === "object" && typeof b4 === "object") {
        return compareObjects(a4, b4);
      }
      return false;
    }
    function compareArrays(a4, b4) {
      if (a4.length !== b4.length) {
        return false;
      }
      for (var i3 = 0; i3 < a4.length; ++i3) {
        if (!deepEquals(a4[i3], b4[i3])) {
          return false;
        }
      }
      return true;
    }
    function compareObjects(a4, b4) {
      if (a4 === null && b4 !== null || a4 !== null && b4 === null) {
        return false;
      }
      var akeys = Object.keys(a4);
      var bkeys = Object.keys(b4);
      if (akeys.length !== bkeys.length) {
        return false;
      }
      for (var i3 = 0, k4; i3 < akeys.length; ++i3) {
        k4 = akeys[i3];
        if (!(k4 in b4 && deepEquals(a4[k4], b4[k4]))) {
          return false;
        }
      }
      return true;
    }
  }
});

// ../node_modules/jiff/lib/commutePaths.js
var require_commutePaths = __commonJS({
  "../node_modules/jiff/lib/commutePaths.js"(exports2, module2) {
    var jsonPointer = require_jsonPointer();
    module2.exports = function commutePaths(a4, b4) {
      var left = jsonPointer.parse(a4.path);
      var right = jsonPointer.parse(b4.path);
      var prefix = getCommonPathPrefix(left, right);
      var isArray2 = isArrayPath(left, right, prefix.length);
      var ac = copyPatch(a4);
      var bc = copyPatch(b4);
      if (prefix.length === 0 && !isArray2) {
        return [bc, ac];
      }
      if (isArray2) {
        return commuteArrayPaths(ac, left, bc, right);
      } else {
        return commuteTreePaths(ac, left, bc, right);
      }
    };
    function commuteTreePaths(a4, left, b4, right) {
      if (a4.path === b4.path) {
        throw new TypeError("cannot commute " + a4.op + "," + b4.op + " with identical object paths");
      }
      return [b4, a4];
    }
    function commuteArrayPaths(a4, left, b4, right) {
      if (left.length === right.length) {
        return commuteArraySiblings(a4, left, b4, right);
      }
      if (left.length > right.length) {
        left = commuteArrayAncestor(b4, right, a4, left, -1);
        a4.path = jsonPointer.absolute(jsonPointer.join(left));
      } else {
        right = commuteArrayAncestor(a4, left, b4, right, 1);
        b4.path = jsonPointer.absolute(jsonPointer.join(right));
      }
      return [b4, a4];
    }
    function isArrayPath(left, right, index) {
      return jsonPointer.isValidArrayIndex(left[index]) && jsonPointer.isValidArrayIndex(right[index]);
    }
    function commuteArraySiblings(l4, lpath, r3, rpath) {
      var target = lpath.length - 1;
      var lindex = +lpath[target];
      var rindex = +rpath[target];
      var commuted;
      if (lindex < rindex) {
        if (l4.op === "add" || l4.op === "copy") {
          commuted = rpath.slice();
          commuted[target] = Math.max(0, rindex - 1);
          r3.path = jsonPointer.absolute(jsonPointer.join(commuted));
        } else if (l4.op === "remove") {
          commuted = rpath.slice();
          commuted[target] = rindex + 1;
          r3.path = jsonPointer.absolute(jsonPointer.join(commuted));
        }
      } else if (r3.op === "add" || r3.op === "copy") {
        commuted = lpath.slice();
        commuted[target] = lindex + 1;
        l4.path = jsonPointer.absolute(jsonPointer.join(commuted));
      } else if (lindex > rindex && r3.op === "remove") {
        commuted = lpath.slice();
        commuted[target] = Math.max(0, lindex - 1);
        l4.path = jsonPointer.absolute(jsonPointer.join(commuted));
      }
      return [r3, l4];
    }
    function commuteArrayAncestor(l4, lpath, r3, rpath, direction) {
      var target = lpath.length - 1;
      var lindex = +lpath[target];
      var rindex = +rpath[target];
      var rc = rpath.slice();
      if (lindex > rindex) {
        return rc;
      }
      if (l4.op === "add" || l4.op === "copy") {
        rc[target] = Math.max(0, rindex - direction);
      } else if (l4.op === "remove") {
        rc[target] = Math.max(0, rindex + direction);
      }
      return rc;
    }
    function getCommonPathPrefix(p1, p22) {
      var p1l = p1.length;
      var p2l = p22.length;
      if (p1l === 0 || p2l === 0 || p1l < 2 && p2l < 2) {
        return [];
      }
      var l4 = p1l === p2l ? p1l - 1 : Math.min(p1l, p2l);
      var i3 = 0;
      while (i3 < l4 && p1[i3] === p22[i3]) {
        ++i3;
      }
      return p1.slice(0, i3);
    }
    function copyPatch(p3) {
      if (p3.op === "remove") {
        return { op: p3.op, path: p3.path };
      }
      if (p3.op === "copy" || p3.op === "move") {
        return { op: p3.op, path: p3.path, from: p3.from };
      }
      return { op: p3.op, path: p3.path, value: p3.value };
    }
  }
});

// ../node_modules/jiff/lib/TestFailedError.js
var require_TestFailedError = __commonJS({
  "../node_modules/jiff/lib/TestFailedError.js"(exports2, module2) {
    module2.exports = TestFailedError;
    function TestFailedError(message) {
      Error.call(this);
      this.name = this.constructor.name;
      this.message = message;
      if (typeof Error.captureStackTrace === "function") {
        Error.captureStackTrace(this, this.constructor);
      }
    }
    TestFailedError.prototype = Object.create(Error.prototype);
    TestFailedError.prototype.constructor = TestFailedError;
  }
});

// ../node_modules/jiff/lib/InvalidPatchOperationError.js
var require_InvalidPatchOperationError = __commonJS({
  "../node_modules/jiff/lib/InvalidPatchOperationError.js"(exports2, module2) {
    module2.exports = InvalidPatchOperationError;
    function InvalidPatchOperationError(message) {
      Error.call(this);
      this.name = this.constructor.name;
      this.message = message;
      if (typeof Error.captureStackTrace === "function") {
        Error.captureStackTrace(this, this.constructor);
      }
    }
    InvalidPatchOperationError.prototype = Object.create(Error.prototype);
    InvalidPatchOperationError.prototype.constructor = InvalidPatchOperationError;
  }
});

// ../node_modules/jiff/lib/PatchNotInvertibleError.js
var require_PatchNotInvertibleError = __commonJS({
  "../node_modules/jiff/lib/PatchNotInvertibleError.js"(exports2, module2) {
    module2.exports = PatchNotInvertibleError;
    function PatchNotInvertibleError(message) {
      Error.call(this);
      this.name = this.constructor.name;
      this.message = message;
      if (typeof Error.captureStackTrace === "function") {
        Error.captureStackTrace(this, this.constructor);
      }
    }
    PatchNotInvertibleError.prototype = Object.create(Error.prototype);
    PatchNotInvertibleError.prototype.constructor = PatchNotInvertibleError;
  }
});

// ../node_modules/jiff/lib/patches.js
var require_patches = __commonJS({
  "../node_modules/jiff/lib/patches.js"(exports2) {
    var jsonPointer = require_jsonPointer();
    var clone = require_clone();
    var deepEquals = require_deepEquals();
    var commutePaths = require_commutePaths();
    var array = require_array();
    var TestFailedError = require_TestFailedError();
    var InvalidPatchOperationError = require_InvalidPatchOperationError();
    var PatchNotInvertibleError = require_PatchNotInvertibleError();
    var find = jsonPointer.find;
    var parseArrayIndex = jsonPointer.parseArrayIndex;
    exports2.test = {
      apply: applyTest,
      inverse: invertTest,
      commute: commuteTest
    };
    exports2.add = {
      apply: applyAdd,
      inverse: invertAdd,
      commute: commuteAddOrCopy
    };
    exports2.remove = {
      apply: applyRemove,
      inverse: invertRemove,
      commute: commuteRemove
    };
    exports2.replace = {
      apply: applyReplace,
      inverse: invertReplace,
      commute: commuteReplace
    };
    exports2.move = {
      apply: applyMove,
      inverse: invertMove,
      commute: commuteMove
    };
    exports2.copy = {
      apply: applyCopy,
      inverse: notInvertible,
      commute: commuteAddOrCopy
    };
    function applyTest(x4, test, options2) {
      var pointer2 = find(x4, test.path, options2.findContext, test.context);
      var target = pointer2.target;
      var index, value;
      if (Array.isArray(target)) {
        index = parseArrayIndex(pointer2.key);
        value = target[index];
      } else {
        value = pointer2.key === void 0 ? pointer2.target : pointer2.target[pointer2.key];
      }
      if (!deepEquals(value, test.value)) {
        throw new TestFailedError("test failed " + JSON.stringify(test));
      }
      return x4;
    }
    function invertTest(pr, test) {
      pr.push(test);
      return 1;
    }
    function commuteTest(test, b4) {
      if (test.path === b4.path && b4.op === "remove") {
        throw new TypeError("Can't commute test,remove -> remove,test for same path");
      }
      if (b4.op === "test" || b4.op === "replace") {
        return [b4, test];
      }
      return commutePaths(test, b4);
    }
    function applyAdd(x4, change, options2) {
      var pointer2 = find(x4, change.path, options2.findContext, change.context);
      if (notFound(pointer2)) {
        throw new InvalidPatchOperationError("path does not exist " + change.path);
      }
      if (change.value === void 0) {
        throw new InvalidPatchOperationError("missing value");
      }
      var val59 = clone(change.value);
      if (pointer2.key === void 0) {
        return val59;
      }
      _add(pointer2, val59);
      return x4;
    }
    function _add(pointer2, value) {
      var target = pointer2.target;
      if (Array.isArray(target)) {
        if (pointer2.key === "-") {
          target.push(value);
        } else if (pointer2.key > target.length) {
          throw new InvalidPatchOperationError("target of add outside of array bounds");
        } else {
          target.splice(pointer2.key, 0, value);
        }
      } else if (isValidObject(target)) {
        target[pointer2.key] = value;
      } else {
        throw new InvalidPatchOperationError("target of add must be an object or array " + pointer2.key);
      }
    }
    function invertAdd(pr, add) {
      var context3 = add.context;
      if (context3 !== void 0) {
        context3 = {
          before: context3.before,
          after: array.cons(add.value, context3.after)
        };
      }
      pr.push({ op: "test", path: add.path, value: add.value, context: context3 });
      pr.push({ op: "remove", path: add.path, context: context3 });
      return 1;
    }
    function commuteAddOrCopy(add, b4) {
      if (add.path === b4.path && b4.op === "remove") {
        throw new TypeError("Can't commute add,remove -> remove,add for same path");
      }
      return commutePaths(add, b4);
    }
    function applyReplace(x4, change, options2) {
      var pointer2 = find(x4, change.path, options2.findContext, change.context);
      if (notFound(pointer2) || missingValue(pointer2)) {
        throw new InvalidPatchOperationError("path does not exist " + change.path);
      }
      if (change.value === void 0) {
        throw new InvalidPatchOperationError("missing value");
      }
      var value = clone(change.value);
      if (pointer2.key === void 0) {
        return value;
      }
      var target = pointer2.target;
      if (Array.isArray(target)) {
        target[parseArrayIndex(pointer2.key)] = value;
      } else {
        target[pointer2.key] = value;
      }
      return x4;
    }
    function invertReplace(pr, c3, i3, patch2) {
      var prev = patch2[i3 - 1];
      if (prev === void 0 || prev.op !== "test" || prev.path !== c3.path) {
        throw new PatchNotInvertibleError("cannot invert replace w/o test");
      }
      var context3 = prev.context;
      if (context3 !== void 0) {
        context3 = {
          before: context3.before,
          after: array.cons(prev.value, array.tail(context3.after))
        };
      }
      pr.push({ op: "test", path: prev.path, value: c3.value });
      pr.push({ op: "replace", path: prev.path, value: prev.value });
      return 2;
    }
    function commuteReplace(replace, b4) {
      if (replace.path === b4.path && b4.op === "remove") {
        throw new TypeError("Can't commute replace,remove -> remove,replace for same path");
      }
      if (b4.op === "test" || b4.op === "replace") {
        return [b4, replace];
      }
      return commutePaths(replace, b4);
    }
    function applyRemove(x4, change, options2) {
      var pointer2 = find(x4, change.path, options2.findContext, change.context);
      if (notFound(pointer2) || pointer2.target[pointer2.key] === void 0) {
        throw new InvalidPatchOperationError("path does not exist " + change.path);
      }
      _remove(pointer2);
      return x4;
    }
    function _remove(pointer2) {
      var target = pointer2.target;
      var removed;
      if (Array.isArray(target)) {
        removed = target.splice(parseArrayIndex(pointer2.key), 1);
        return removed[0];
      } else if (isValidObject(target)) {
        removed = target[pointer2.key];
        delete target[pointer2.key];
        return removed;
      } else {
        throw new InvalidPatchOperationError("target of remove must be an object or array");
      }
    }
    function invertRemove(pr, c3, i3, patch2) {
      var prev = patch2[i3 - 1];
      if (prev === void 0 || prev.op !== "test" || prev.path !== c3.path) {
        throw new PatchNotInvertibleError("cannot invert remove w/o test");
      }
      var context3 = prev.context;
      if (context3 !== void 0) {
        context3 = {
          before: context3.before,
          after: array.tail(context3.after)
        };
      }
      pr.push({ op: "add", path: prev.path, value: prev.value, context: context3 });
      return 2;
    }
    function commuteRemove(remove, b4) {
      if (remove.path === b4.path && b4.op === "remove") {
        return [b4, remove];
      }
      return commutePaths(remove, b4);
    }
    function applyMove(x4, change, options2) {
      if (jsonPointer.contains(change.path, change.from)) {
        throw new InvalidPatchOperationError("move.from cannot be ancestor of move.path");
      }
      var pto = find(x4, change.path, options2.findContext, change.context);
      var pfrom = find(x4, change.from, options2.findContext, change.fromContext);
      _add(pto, _remove(pfrom));
      return x4;
    }
    function invertMove(pr, c3) {
      pr.push({
        op: "move",
        path: c3.from,
        context: c3.fromContext,
        from: c3.path,
        fromContext: c3.context
      });
      return 1;
    }
    function commuteMove(move, b4) {
      if (move.path === b4.path && b4.op === "remove") {
        throw new TypeError("Can't commute move,remove -> move,replace for same path");
      }
      return commutePaths(move, b4);
    }
    function applyCopy(x4, change, options2) {
      var pto = find(x4, change.path, options2.findContext, change.context);
      var pfrom = find(x4, change.from, options2.findContext, change.fromContext);
      if (notFound(pfrom) || missingValue(pfrom)) {
        throw new InvalidPatchOperationError("copy.from must exist");
      }
      var target = pfrom.target;
      var value;
      if (Array.isArray(target)) {
        value = target[parseArrayIndex(pfrom.key)];
      } else {
        value = target[pfrom.key];
      }
      _add(pto, clone(value));
      return x4;
    }
    function notInvertible(_3, c3) {
      throw new PatchNotInvertibleError("cannot invert " + c3.op);
    }
    function notFound(pointer2) {
      return pointer2 === void 0 || pointer2.target == null && pointer2.key !== void 0;
    }
    function missingValue(pointer2) {
      return pointer2.key !== void 0 && pointer2.target[pointer2.key] === void 0;
    }
    function isValidObject(x4) {
      return x4 !== null && typeof x4 === "object";
    }
  }
});

// ../node_modules/jiff/lib/jsonPatch.js
var require_jsonPatch = __commonJS({
  "../node_modules/jiff/lib/jsonPatch.js"(exports2) {
    var patches = require_patches();
    var clone = require_clone();
    var InvalidPatchOperationError = require_InvalidPatchOperationError();
    exports2.apply = patch2;
    exports2.applyInPlace = patchInPlace;
    exports2.clone = clone;
    exports2.isValidObject = isValidObject;
    exports2.defaultHash = defaultHash;
    var defaultOptions = {};
    function patch2(changes, x4, options2) {
      return patchInPlace(changes, clone(x4), options2);
    }
    function patchInPlace(changes, x4, options2) {
      if (!options2) {
        options2 = defaultOptions;
      }
      if (!Array.isArray(changes)) {
        return x4;
      }
      var patch3, p3;
      for (var i3 = 0; i3 < changes.length; ++i3) {
        p3 = changes[i3];
        patch3 = patches[p3.op];
        if (patch3 === void 0) {
          throw new InvalidPatchOperationError("invalid op " + JSON.stringify(p3));
        }
        x4 = patch3.apply(x4, p3, options2);
      }
      return x4;
    }
    function defaultHash(x4) {
      return isValidObject(x4) || isArray2(x4) ? JSON.stringify(x4) : x4;
    }
    function isValidObject(x4) {
      return x4 !== null && Object.prototype.toString.call(x4) === "[object Object]";
    }
    function isArray2(x4) {
      return Object.prototype.toString.call(x4) === "[object Array]";
    }
  }
});

// ../node_modules/jiff/lib/inverse.js
var require_inverse = __commonJS({
  "../node_modules/jiff/lib/inverse.js"(exports2, module2) {
    var patches = require_patches();
    module2.exports = function inverse(p3) {
      var pr = [];
      var i3, skip;
      for (i3 = p3.length - 1; i3 >= 0; i3 -= skip) {
        skip = invertOp(pr, p3[i3], i3, p3);
      }
      return pr;
    };
    function invertOp(patch2, c3, i3, context3) {
      var op = patches[c3.op];
      return op !== void 0 && typeof op.inverse === "function" ? op.inverse(patch2, c3, i3, context3) : 1;
    }
  }
});

// ../node_modules/jiff/jiff.js
var require_jiff = __commonJS({
  "../node_modules/jiff/jiff.js"(exports2) {
    var lcs = require_lcs();
    var array = require_array();
    var patch2 = require_jsonPatch();
    var inverse = require_inverse();
    var jsonPointer = require_jsonPointer();
    var encodeSegment = jsonPointer.encodeSegment;
    exports2.diff = diff;
    exports2.patch = patch2.apply;
    exports2.patchInPlace = patch2.applyInPlace;
    exports2.inverse = inverse;
    exports2.clone = patch2.clone;
    exports2.InvalidPatchOperationError = require_InvalidPatchOperationError();
    exports2.TestFailedError = require_TestFailedError();
    exports2.PatchNotInvertibleError = require_PatchNotInvertibleError();
    var isValidObject = patch2.isValidObject;
    var defaultHash = patch2.defaultHash;
    function diff(a4, b4, options2) {
      return appendChanges(a4, b4, "", initState(options2, [])).patch;
    }
    function initState(options2, patch3) {
      if (typeof options2 === "object") {
        return {
          patch: patch3,
          hash: orElse(isFunction2, options2.hash, defaultHash),
          makeContext: orElse(isFunction2, options2.makeContext, defaultContext),
          invertible: !(options2.invertible === false)
        };
      } else {
        return {
          patch: patch3,
          hash: orElse(isFunction2, options2, defaultHash),
          makeContext: defaultContext,
          invertible: true
        };
      }
    }
    function appendChanges(a4, b4, path, state) {
      if (Array.isArray(a4) && Array.isArray(b4)) {
        return appendArrayChanges(a4, b4, path, state);
      }
      if (isValidObject(a4) && isValidObject(b4)) {
        return appendObjectChanges(a4, b4, path, state);
      }
      return appendValueChanges(a4, b4, path, state);
    }
    function appendObjectChanges(o1, o22, path, state) {
      var keys3 = Object.keys(o22);
      var patch3 = state.patch;
      var i3, key;
      for (i3 = keys3.length - 1; i3 >= 0; --i3) {
        key = keys3[i3];
        var keyPath = path + "/" + encodeSegment(key);
        if (o1[key] !== void 0) {
          appendChanges(o1[key], o22[key], keyPath, state);
        } else {
          patch3.push({ op: "add", path: keyPath, value: o22[key] });
        }
      }
      keys3 = Object.keys(o1);
      for (i3 = keys3.length - 1; i3 >= 0; --i3) {
        key = keys3[i3];
        if (o22[key] === void 0) {
          var p3 = path + "/" + encodeSegment(key);
          if (state.invertible) {
            patch3.push({ op: "test", path: p3, value: o1[key] });
          }
          patch3.push({ op: "remove", path: p3 });
        }
      }
      return state;
    }
    function appendArrayChanges(a1, a22, path, state) {
      var a1hash = array.map(state.hash, a1);
      var a2hash = array.map(state.hash, a22);
      var lcsMatrix = lcs.compare(a1hash, a2hash);
      return lcsToJsonPatch(a1, a22, path, state, lcsMatrix);
    }
    function lcsToJsonPatch(a1, a22, path, state, lcsMatrix) {
      var offset = 0;
      return lcs.reduce(function(state2, op, i3, j3) {
        var last2, context3;
        var patch3 = state2.patch;
        var p3 = path + "/" + (j3 + offset);
        if (op === lcs.REMOVE) {
          last2 = patch3[patch3.length - 1];
          context3 = state2.makeContext(j3, a1);
          if (state2.invertible) {
            patch3.push({ op: "test", path: p3, value: a1[j3], context: context3 });
          }
          if (last2 !== void 0 && last2.op === "add" && last2.path === p3) {
            last2.op = "replace";
            last2.context = context3;
          } else {
            patch3.push({ op: "remove", path: p3, context: context3 });
          }
          offset -= 1;
        } else if (op === lcs.ADD) {
          patch3.push({
            op: "add",
            path: p3,
            value: a22[i3],
            context: state2.makeContext(j3, a1)
          });
          offset += 1;
        } else {
          appendChanges(a1[j3], a22[i3], p3, state2);
        }
        return state2;
      }, state, lcsMatrix);
    }
    function appendValueChanges(a4, b4, path, state) {
      if (a4 !== b4) {
        if (state.invertible) {
          state.patch.push({ op: "test", path, value: a4 });
        }
        state.patch.push({ op: "replace", path, value: b4 });
      }
      return state;
    }
    function orElse(predicate, x4, y3) {
      return predicate(x4) ? x4 : y3;
    }
    function defaultContext() {
      return void 0;
    }
    function isFunction2(x4) {
      return typeof x4 === "function";
    }
  }
});

// ../node_modules/json-touch-patch/lib/utils/pluck.js
var require_pluck = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/pluck.js"(exports2, module2) {
    "use strict";
    function pluck(object, keys3) {
      for (var i3 = 0, imax = keys3.length - 1; i3 < imax; i3++) {
        if (!object[keys3[i3]]) {
          return null;
        }
        object = object[keys3[i3]];
      }
      return object;
    }
    module2.exports = pluck;
  }
});

// ../node_modules/json-touch-patch/lib/utils/toKeys.js
var require_toKeys = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/toKeys.js"(exports2, module2) {
    "use strict";
    function esc(m3) {
      return m3 === "~0" ? "~" : "/";
    }
    function toKeys(path) {
      var keys3 = path.split("/");
      if (path.indexOf("~") === -1) {
        return keys3;
      }
      for (var i3 = 0, imax = keys3.length; i3 < imax; i3++) {
        if (keys3[i3].indexOf("~") !== -1) {
          keys3[i3] = keys3[i3].replace(/~[01]/g, esc);
        }
      }
      return keys3;
    }
    module2.exports = toKeys;
  }
});

// ../node_modules/json-touch-patch/lib/get.js
var require_get = __commonJS({
  "../node_modules/json-touch-patch/lib/get.js"(exports2, module2) {
    "use strict";
    var pluck = require_pluck();
    var toKeys = require_toKeys();
    function get2(object, path) {
      var keys3 = toKeys(path);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      return target ? target[lastKey] : void 0;
    }
    module2.exports = get2;
  }
});

// ../node_modules/json-touch-patch/lib/utils/deepEqual.js
var require_deepEqual = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/deepEqual.js"(exports2, module2) {
    "use strict";
    function deepEqual(a4, b4) {
      if (a4 === b4) {
        return true;
      }
      if (!(a4 && b4) || typeof a4 !== "object" || typeof b4 !== "object") {
        return false;
      }
      if (a4.length !== b4.length) {
        return false;
      }
      if (Array.isArray(a4)) {
        if (!Array.isArray(b4)) {
          return false;
        }
        for (var i3 = 0, imax = a4.length; i3 < imax; i3++) {
          if (!deepEqual(a4[i3], b4[i3])) {
            return false;
          }
        }
        return true;
      }
      var aKeys = Object.keys(a4);
      if (aKeys.length !== Object.keys(b4).length) {
        return false;
      }
      for (var j3 = 0, jmax = aKeys.length; j3 < jmax; j3++) {
        var key = aKeys[j3];
        if (!deepEqual(a4[key], b4[key])) {
          return false;
        }
      }
      return true;
    }
    module2.exports = deepEqual;
  }
});

// ../node_modules/json-touch-patch/lib/utils/toArrayIndex.js
var require_toArrayIndex = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/toArrayIndex.js"(exports2, module2) {
    "use strict";
    function toArrayIndex(array, str) {
      if (str === "-") {
        return array.length;
      }
      for (var i3 = 0, imax = str.length; i3 < imax; i3++) {
        var ch = str.charCodeAt(i3);
        if (57 < ch || ch < 48) {
          return Infinity;
        }
      }
      return +str;
    }
    module2.exports = toArrayIndex;
  }
});

// ../node_modules/json-touch-patch/lib/add.js
var require_add = __commonJS({
  "../node_modules/json-touch-patch/lib/add.js"(exports2, module2) {
    "use strict";
    var deepEqual = require_deepEqual();
    var pluck = require_pluck();
    var toArrayIndex = require_toArrayIndex();
    var toKeys = require_toKeys();
    function add(object, path, value, pluckWithShallowCopy) {
      if (typeof value === "undefined") {
        return "[op:add] require value, but got undefined";
      }
      var keys3 = toKeys(path);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      if (target === null) {
        return "[op:add] path not found: " + path;
      }
      if (Array.isArray(target)) {
        var index = toArrayIndex(target, lastKey);
        if (target.length < index) {
          return "[op:add] invalid array index: " + path;
        }
        pluckWithShallowCopy(object, keys3).splice(index, 0, value);
      } else {
        if (!deepEqual(target[lastKey], value)) {
          pluckWithShallowCopy(object, keys3)[lastKey] = value;
        }
      }
    }
    module2.exports = add;
  }
});

// ../node_modules/json-touch-patch/lib/remove.js
var require_remove = __commonJS({
  "../node_modules/json-touch-patch/lib/remove.js"(exports2, module2) {
    "use strict";
    var pluck = require_pluck();
    var toArrayIndex = require_toArrayIndex();
    var toKeys = require_toKeys();
    function remove(object, path, pluckWithShallowCopy) {
      var keys3 = toKeys(path);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      if (target === null) {
        return "[op:remove] path not found: " + path;
      }
      if (Array.isArray(target)) {
        var index = toArrayIndex(target, lastKey);
        if (target.length <= index) {
          return "[op:remove] invalid array index: " + path;
        }
        pluckWithShallowCopy(object, keys3).splice(index, 1);
      } else {
        delete pluckWithShallowCopy(object, keys3)[lastKey];
      }
    }
    module2.exports = remove;
  }
});

// ../node_modules/json-touch-patch/lib/replace.js
var require_replace = __commonJS({
  "../node_modules/json-touch-patch/lib/replace.js"(exports2, module2) {
    "use strict";
    var deepEqual = require_deepEqual();
    var pluck = require_pluck();
    var toArrayIndex = require_toArrayIndex();
    var toKeys = require_toKeys();
    function replace(object, path, value, pluckWithShallowCopy) {
      if (typeof value === "undefined") {
        return "[op:replace] require value, but got undefined";
      }
      var keys3 = toKeys(path);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      if (target === null) {
        return "[op:replace] path not found: " + path;
      }
      if (Array.isArray(target)) {
        var index = toArrayIndex(target, lastKey);
        if (target.length <= index) {
          return "[op:replace] invalid array index: " + path;
        }
        if (!deepEqual(target[index], value)) {
          pluckWithShallowCopy(object, keys3).splice(index, 1, value);
        }
      } else {
        if (!deepEqual(target[lastKey], value)) {
          pluckWithShallowCopy(object, keys3)[lastKey] = value;
        }
      }
    }
    module2.exports = replace;
  }
});

// ../node_modules/json-touch-patch/lib/move.js
var require_move = __commonJS({
  "../node_modules/json-touch-patch/lib/move.js"(exports2, module2) {
    "use strict";
    var add = require_add();
    var pluck = require_pluck();
    var toArrayIndex = require_toArrayIndex();
    var toKeys = require_toKeys();
    function move(object, from, path, pluckWithShallowCopy) {
      if (path !== from) {
        var keys3 = toKeys(from);
        var lastKey = keys3[keys3.length - 1];
        var target = pluck(object, keys3);
        if (target === null) {
          return "[op:move] path not found: " + from;
        }
        var value = void 0;
        if (Array.isArray(target)) {
          var index = toArrayIndex(target, lastKey);
          if (target.length <= index) {
            return "[op:move] invalid array index: " + path;
          }
          value = target[index];
          pluckWithShallowCopy(object, keys3).splice(index, 1);
        } else {
          value = target[lastKey];
          delete pluckWithShallowCopy(object, keys3)[lastKey];
        }
        return add(object, path, value, pluckWithShallowCopy);
      }
    }
    module2.exports = move;
  }
});

// ../node_modules/json-touch-patch/lib/copy.js
var require_copy = __commonJS({
  "../node_modules/json-touch-patch/lib/copy.js"(exports2, module2) {
    "use strict";
    var pluck = require_pluck();
    var toKeys = require_toKeys();
    var add = require_add();
    function copy(object, from, path, pluckWithShallowCopy) {
      var keys3 = toKeys(from);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      if (target === null) {
        return "[op:copy] path not found: " + from;
      }
      return add(object, path, target[lastKey], pluckWithShallowCopy);
    }
    module2.exports = copy;
  }
});

// ../node_modules/json-touch-patch/lib/test.js
var require_test = __commonJS({
  "../node_modules/json-touch-patch/lib/test.js"(exports2, module2) {
    "use strict";
    var deepEqual = require_deepEqual();
    var pluck = require_pluck();
    var toKeys = require_toKeys();
    function test(object, path, expected) {
      var keys3 = toKeys(path);
      var lastKey = keys3[keys3.length - 1];
      var target = pluck(object, keys3);
      if (target === null) {
        return "[op:test] path not found: " + path;
      }
      if (!deepEqual(target[lastKey], expected)) {
        var a4 = JSON.stringify(target[lastKey]);
        var b4 = JSON.stringify(expected);
        return "[op:test] not matched: " + a4 + " " + b4;
      }
    }
    module2.exports = test;
  }
});

// ../node_modules/json-touch-patch/lib/utils/shallowCopy.js
var require_shallowCopy = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/shallowCopy.js"(exports2, module2) {
    "use strict";
    function shallowCopy(obj) {
      if (!obj || typeof obj !== "object") {
        return obj;
      }
      if (Array.isArray(obj)) {
        var len = obj.length;
        var ary = new Array(len);
        for (var i3 = 0; i3 < len; i3++) {
          ary[i3] = obj[i3];
        }
        return ary;
      }
      var keys3 = Object.keys(obj);
      var copy = {};
      for (var j3 = 0, jmax = keys3.length; j3 < jmax; j3++) {
        var key = keys3[j3];
        copy[key] = obj[key];
      }
      return copy;
    }
    module2.exports = shallowCopy;
  }
});

// ../node_modules/json-touch-patch/lib/utils/createAPI.js
var require_createAPI = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/createAPI.js"(exports2, module2) {
    "use strict";
    var get2 = require_get();
    var add = require_add();
    var remove = require_remove();
    var replace = require_replace();
    var move = require_move();
    var copy = require_copy();
    var test = require_test();
    var deepEqual = require_deepEqual();
    var shallowCopy = require_shallowCopy();
    var toKeys = require_toKeys();
    function createAPI(root3, pluckFn) {
      return {
        get: function(path) {
          return get2(root3, path);
        },
        add: function(path, value) {
          return add(root3, path, value, pluckFn);
        },
        remove: function(path) {
          return remove(root3, path, pluckFn);
        },
        replace: function(path, value) {
          return replace(root3, path, value, pluckFn);
        },
        move: function(from, path) {
          return move(root3, from, path, pluckFn);
        },
        copy: function(from, path) {
          return copy(root3, from, path, pluckFn);
        },
        test: function(path, expected) {
          return test(root3, path, expected);
        },
        deepEqual,
        shallowCopy,
        toKeys
      };
    }
    module2.exports = createAPI;
  }
});

// ../node_modules/json-touch-patch/lib/utils/exit.js
var require_exit = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/exit.js"(exports2, module2) {
    "use strict";
    function exit(object, root3, patch2, opts) {
      opts.error = patch2;
      return opts.partial ? root3[""] : object;
    }
    module2.exports = exit;
  }
});

// ../node_modules/json-touch-patch/lib/utils/toBoolean.js
var require_toBoolean = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/toBoolean.js"(exports2, module2) {
    "use strict";
    function toBoolean(value) {
      return !!value;
    }
    module2.exports = toBoolean;
  }
});

// ../node_modules/json-touch-patch/lib/utils/throwException.js
var require_throwException = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/throwException.js"(exports2, module2) {
    "use strict";
    function throwException(message) {
      if (message) {
        throw new TypeError(message);
      }
    }
    module2.exports = throwException;
  }
});

// ../node_modules/json-touch-patch/lib/utils/pluckWithShallowCopy.js
var require_pluckWithShallowCopy = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/pluckWithShallowCopy.js"(exports2, module2) {
    "use strict";
    var shallowCopy = require_shallowCopy();
    function pluckWithShallowCopy(object, keys3) {
      for (var i3 = 0, imax = keys3.length - 1; i3 < imax; i3++) {
        object = object[keys3[i3]] = shallowCopy(object[keys3[i3]]);
      }
      return object;
    }
    module2.exports = pluckWithShallowCopy;
  }
});

// ../node_modules/json-touch-patch/lib/utils/pluckWithCachedShallowCopy.js
var require_pluckWithCachedShallowCopy = __commonJS({
  "../node_modules/json-touch-patch/lib/utils/pluckWithCachedShallowCopy.js"(exports2, module2) {
    "use strict";
    var shallowCopy = require_shallowCopy();
    function fetch2(object, key, cache3) {
      var value = object[key];
      if (!cache3.has(value)) {
        value = shallowCopy(value);
        cache3.add(value);
      }
      return value;
    }
    function pluckWithCachedShallowCopy(object, keys3, cache3) {
      for (var i3 = 0, imax = keys3.length - 1; i3 < imax; i3++) {
        object = object[keys3[i3]] = fetch2(object, keys3[i3], cache3);
      }
      return object;
    }
    module2.exports = pluckWithCachedShallowCopy;
  }
});

// ../node_modules/json-touch-patch/lib/patch.js
var require_patch = __commonJS({
  "../node_modules/json-touch-patch/lib/patch.js"(exports2, module2) {
    "use strict";
    var createAPI = require_createAPI();
    var exit = require_exit();
    var toBoolean = require_toBoolean();
    var throwException = require_throwException();
    var pluckWithShallowCopy = require_pluckWithShallowCopy();
    var pluckWithCachedShallowCopy = require_pluckWithCachedShallowCopy();
    var add = require_add();
    var remove = require_remove();
    var replace = require_replace();
    var move = require_move();
    var copy = require_copy();
    var test = require_test();
    var Cache = Set || function() {
      var set2 = [];
      set2.has = function(value) {
        return this.indexOf(value) !== -1;
      };
      set2.add = function(value) {
        this.push(value);
      };
      return set2;
    };
    function patchFn(object, patches, opts) {
      if (patches.length === 0) {
        return object;
      }
      opts = opts || {};
      var hasError = opts.strict ? throwException : toBoolean;
      var pluckFn = patches.length === 1 ? pluckWithShallowCopy : function(cache3) {
        return function(object2, keys3) {
          return pluckWithCachedShallowCopy(object2, keys3, cache3);
        };
      }(new Cache());
      var root3 = { "": object };
      var api;
      for (var i3 = 0, imax = patches.length; i3 < imax; i3++) {
        var patch2 = patches[i3];
        switch (patch2.op) {
          case "add":
            if (hasError(add(root3, "" + patch2.path, patch2.value, pluckFn))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          case "remove":
            if (hasError(remove(root3, "" + patch2.path, pluckFn))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          case "replace":
            if (hasError(replace(root3, "" + patch2.path, patch2.value, pluckFn))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          case "move":
            if (hasError(move(root3, "" + patch2.from, "" + patch2.path, pluckFn))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          case "copy":
            if (hasError(copy(root3, "" + patch2.from, "" + patch2.path, pluckFn))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          case "test":
            if (hasError(test(root3, "" + patch2.path, patch2.value))) {
              return exit(object, root3, patch2, opts);
            }
            break;
          default:
            if (opts.custom && opts.custom[patch2.op]) {
              api = api || createAPI(root3, pluckFn);
              if (hasError(opts.custom[patch2.op](api, patch2, i3, patches))) {
                return exit(object, root3, patch2, opts);
              }
            } else {
              hasError("[op:" + patch2.op + "] unknown");
              return exit(object, root3, patch2, opts);
            }
            break;
        }
      }
      return root3[""];
    }
    module2.exports = patchFn;
  }
});

// ../node_modules/json-touch-patch/lib/index.js
var require_lib = __commonJS({
  "../node_modules/json-touch-patch/lib/index.js"(exports2, module2) {
    module2.exports = require_patch();
  }
});

// ../node_modules/lodash-es/last.js
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
var last_default;
var init_last = __esm({
  "../node_modules/lodash-es/last.js"() {
    last_default = last;
  }
});

// shared/src/_logger/logger.ts
function lazy(f3) {
  return function lazyLogIncluded(m3, lazyArg) {
    return f3(m3, lazyArg());
  };
}
function getLogMeta(level) {
  return Object.freeze({
    audience: hasFlag(level, 8) ? "internal" : hasFlag(level, 16) ? "dev" : "public",
    category: hasFlag(level, 4) ? "troubleshooting" : hasFlag(level, 2) ? "todo" : "general",
    level: hasFlag(level, 512) ? 512 : hasFlag(level, 256) ? 256 : hasFlag(level, 128) ? 128 : 64
  });
}
function hasFlag(level, flag) {
  return (level & flag) === flag;
}
function shouldLog(includes, level) {
  return ((level & 32) === 32 ? true : (level & 16) === 16 ? includes.dev : (level & 8) === 8 ? includes.internal : false) && includes.min <= level;
}
function createTheatreInternalLogger(useConsole = console, _options = {}) {
  const ref = __spreadProps(__spreadValues({}, DEFAULTS), { includes: __spreadValues({}, DEFAULTS.includes) });
  const createConsole = {
    styled: createConsoleLoggerStyled.bind(ref, useConsole),
    noStyle: createConsoleLoggerNoStyle.bind(ref, useConsole)
  };
  const createExtBound = createExtLogger.bind(ref);
  function getConCreate() {
    return ref.loggingConsoleStyle && ref.loggerConsoleStyle ? createConsole.styled : createConsole.noStyle;
  }
  ref.create = getConCreate();
  return {
    configureLogger(config) {
      var _a2;
      if (config === "console") {
        ref.loggerConsoleStyle = DEFAULTS.loggerConsoleStyle;
        ref.create = getConCreate();
      } else if (config.type === "console") {
        ref.loggerConsoleStyle = (_a2 = config.style) != null ? _a2 : DEFAULTS.loggerConsoleStyle;
        ref.create = getConCreate();
      } else if (config.type === "keyed") {
        ref.creatExt = (source) => config.keyed(source.names);
        ref.create = createExtBound;
      } else if (config.type === "named") {
        ref.creatExt = configNamedToKeyed.bind(null, config.named);
        ref.create = createExtBound;
      }
    },
    configureLogging(config) {
      var _a2, _b, _c, _d, _e2;
      ref.includes.dev = (_a2 = config.dev) != null ? _a2 : DEFAULTS.includes.dev;
      ref.includes.internal = (_b = config.internal) != null ? _b : DEFAULTS.includes.internal;
      ref.includes.min = (_c = config.min) != null ? _c : DEFAULTS.includes.min;
      ref.include = (_d = config.include) != null ? _d : DEFAULTS.include;
      ref.loggingConsoleStyle = (_e2 = config.consoleStyle) != null ? _e2 : DEFAULTS.loggingConsoleStyle;
      ref.create = getConCreate();
    },
    getLogger() {
      return ref.create({ names: [] });
    }
  };
}
function configNamedToKeyed(namedFn, source) {
  const names = [];
  for (let { name, key } of source.names) {
    names.push(key == null ? name : `${name} (${key})`);
  }
  return namedFn(names);
}
function createExtLogger(source) {
  const includes = __spreadValues(__spreadValues({}, this.includes), this.include(source));
  const f3 = this.filtered;
  const named = this.named.bind(this, source);
  const ext = this.creatExt(source);
  const _HMM = shouldLog(includes, 524);
  const _TODO = shouldLog(includes, 522);
  const _ERROR = shouldLog(includes, 521);
  const ERROR_DEV = shouldLog(includes, 529);
  const ERROR_PUBLIC = shouldLog(includes, 545);
  const _WARN = shouldLog(includes, 265);
  const _KAPOW = shouldLog(includes, 268);
  const WARN_DEV = shouldLog(includes, 273);
  const WARN_PUBLIC = shouldLog(includes, 289);
  const _DEBUG = shouldLog(includes, 137);
  const DEBUG_DEV = shouldLog(includes, 145);
  const _TRACE = shouldLog(includes, 73);
  const TRACE_DEV = shouldLog(includes, 81);
  const _hmm = _HMM ? ext.error.bind(ext, LEVELS._hmm) : f3.bind(source, 524);
  const _todo = _TODO ? ext.error.bind(ext, LEVELS._todo) : f3.bind(source, 522);
  const _error = _ERROR ? ext.error.bind(ext, LEVELS._error) : f3.bind(source, 521);
  const errorDev = ERROR_DEV ? ext.error.bind(ext, LEVELS.errorDev) : f3.bind(source, 529);
  const errorPublic = ERROR_PUBLIC ? ext.error.bind(ext, LEVELS.errorPublic) : f3.bind(source, 545);
  const _kapow = _KAPOW ? ext.warn.bind(ext, LEVELS._kapow) : f3.bind(source, 268);
  const _warn = _WARN ? ext.warn.bind(ext, LEVELS._warn) : f3.bind(source, 265);
  const warnDev = WARN_DEV ? ext.warn.bind(ext, LEVELS.warnDev) : f3.bind(source, 273);
  const warnPublic = WARN_PUBLIC ? ext.warn.bind(ext, LEVELS.warnPublic) : f3.bind(source, 273);
  const _debug = _DEBUG ? ext.debug.bind(ext, LEVELS._debug) : f3.bind(source, 137);
  const debugDev = DEBUG_DEV ? ext.debug.bind(ext, LEVELS.debugDev) : f3.bind(source, 145);
  const _trace = _TRACE ? ext.trace.bind(ext, LEVELS._trace) : f3.bind(source, 73);
  const traceDev = TRACE_DEV ? ext.trace.bind(ext, LEVELS.traceDev) : f3.bind(source, 81);
  const logger = {
    _hmm,
    _todo,
    _error,
    errorDev,
    errorPublic,
    _kapow,
    _warn,
    warnDev,
    warnPublic,
    _debug,
    debugDev,
    _trace,
    traceDev,
    lazy: {
      _hmm: _HMM ? lazy(_hmm) : _hmm,
      _todo: _TODO ? lazy(_todo) : _todo,
      _error: _ERROR ? lazy(_error) : _error,
      errorDev: ERROR_DEV ? lazy(errorDev) : errorDev,
      errorPublic: ERROR_PUBLIC ? lazy(errorPublic) : errorPublic,
      _kapow: _KAPOW ? lazy(_kapow) : _kapow,
      _warn: _WARN ? lazy(_warn) : _warn,
      warnDev: WARN_DEV ? lazy(warnDev) : warnDev,
      warnPublic: WARN_PUBLIC ? lazy(warnPublic) : warnPublic,
      _debug: _DEBUG ? lazy(_debug) : _debug,
      debugDev: DEBUG_DEV ? lazy(debugDev) : debugDev,
      _trace: _TRACE ? lazy(_trace) : _trace,
      traceDev: TRACE_DEV ? lazy(traceDev) : traceDev
    },
    named,
    utilFor: {
      internal() {
        return {
          debug: logger._debug,
          error: logger._error,
          warn: logger._warn,
          trace: logger._trace,
          named(name, key) {
            return logger.named(name, key).utilFor.internal();
          }
        };
      },
      dev() {
        return {
          debug: logger.debugDev,
          error: logger.errorDev,
          warn: logger.warnDev,
          trace: logger.traceDev,
          named(name, key) {
            return logger.named(name, key).utilFor.dev();
          }
        };
      },
      public() {
        return {
          error: logger.errorPublic,
          warn: logger.warnPublic,
          debug(message, obj) {
            logger._warn(`(public "debug" filtered out) ${message}`, obj);
          },
          trace(message, obj) {
            logger._warn(`(public "trace" filtered out) ${message}`, obj);
          },
          named(name, key) {
            return logger.named(name, key).utilFor.public();
          }
        };
      }
    }
  };
  return logger;
}
function createConsoleLoggerStyled(con, source) {
  const includes = __spreadValues(__spreadValues({}, this.includes), this.include(source));
  const styleArgs = [];
  let prefix = "";
  for (let i3 = 0; i3 < source.names.length; i3++) {
    const { name, key } = source.names[i3];
    prefix += ` %c${name}`;
    styleArgs.push(this.style.css(name));
    if (key != null) {
      const keyStr = `%c#${key}`;
      prefix += keyStr;
      styleArgs.push(this.style.css(keyStr));
    }
  }
  const f3 = this.filtered;
  const named = this.named.bind(this, source);
  const prefixArr = [prefix, ...styleArgs];
  return _createConsoleLogger(f3, source, includes, con, prefixArr, styledKapowPrefix(prefixArr), named);
}
function styledKapowPrefix(args) {
  const start = args.slice(0);
  for (let i3 = 1; i3 < start.length; i3++)
    start[i3] += ";background-color:#e0005a;padding:2px;color:white";
  return start;
}
function createConsoleLoggerNoStyle(con, source) {
  const includes = __spreadValues(__spreadValues({}, this.includes), this.include(source));
  let prefix = "";
  for (let i3 = 0; i3 < source.names.length; i3++) {
    const { name, key } = source.names[i3];
    prefix += ` ${name}`;
    if (key != null) {
      prefix += `#${key}`;
    }
  }
  const f3 = this.filtered;
  const named = this.named.bind(this, source);
  const prefixArr = [prefix];
  return _createConsoleLogger(f3, source, includes, con, prefixArr, prefixArr, named);
}
function _createConsoleLogger(f3, source, includes, con, prefix, kapowPrefix, named) {
  const _HMM = shouldLog(includes, 524);
  const _TODO = shouldLog(includes, 522);
  const _ERROR = shouldLog(includes, 521);
  const ERROR_DEV = shouldLog(includes, 529);
  const ERROR_PUBLIC = shouldLog(includes, 545);
  const _WARN = shouldLog(includes, 265);
  const _KAPOW = shouldLog(includes, 268);
  const WARN_DEV = shouldLog(includes, 273);
  const WARN_PUBLIC = shouldLog(includes, 289);
  const _DEBUG = shouldLog(includes, 137);
  const DEBUG_DEV = shouldLog(includes, 145);
  const _TRACE = shouldLog(includes, 73);
  const TRACE_DEV = shouldLog(includes, 81);
  const _hmm = _HMM ? con.error.bind(con, ...prefix) : f3.bind(source, 524);
  const _todo = _TODO ? con.error.bind(con, ...prefix) : f3.bind(source, 522);
  const _error = _ERROR ? con.error.bind(con, ...prefix) : f3.bind(source, 521);
  const errorDev = ERROR_DEV ? con.error.bind(con, ...prefix) : f3.bind(source, 529);
  const errorPublic = ERROR_PUBLIC ? con.error.bind(con, ...prefix) : f3.bind(source, 545);
  const _kapow = _KAPOW ? con.warn.bind(con, ...kapowPrefix) : f3.bind(source, 268);
  const _warn = _WARN ? con.warn.bind(con, ...prefix) : f3.bind(source, 265);
  const warnDev = WARN_DEV ? con.warn.bind(con, ...prefix) : f3.bind(source, 273);
  const warnPublic = WARN_PUBLIC ? con.warn.bind(con, ...prefix) : f3.bind(source, 273);
  const _debug = _DEBUG ? con.info.bind(con, ...prefix) : f3.bind(source, 137);
  const debugDev = DEBUG_DEV ? con.info.bind(con, ...prefix) : f3.bind(source, 145);
  const _trace = _TRACE ? con.debug.bind(con, ...prefix) : f3.bind(source, 73);
  const traceDev = TRACE_DEV ? con.debug.bind(con, ...prefix) : f3.bind(source, 81);
  const logger = {
    _hmm,
    _todo,
    _error,
    errorDev,
    errorPublic,
    _kapow,
    _warn,
    warnDev,
    warnPublic,
    _debug,
    debugDev,
    _trace,
    traceDev,
    lazy: {
      _hmm: _HMM ? lazy(_hmm) : _hmm,
      _todo: _TODO ? lazy(_todo) : _todo,
      _error: _ERROR ? lazy(_error) : _error,
      errorDev: ERROR_DEV ? lazy(errorDev) : errorDev,
      errorPublic: ERROR_PUBLIC ? lazy(errorPublic) : errorPublic,
      _kapow: _KAPOW ? lazy(_kapow) : _kapow,
      _warn: _WARN ? lazy(_warn) : _warn,
      warnDev: WARN_DEV ? lazy(warnDev) : warnDev,
      warnPublic: WARN_PUBLIC ? lazy(warnPublic) : warnPublic,
      _debug: _DEBUG ? lazy(_debug) : _debug,
      debugDev: DEBUG_DEV ? lazy(debugDev) : debugDev,
      _trace: _TRACE ? lazy(_trace) : _trace,
      traceDev: TRACE_DEV ? lazy(traceDev) : traceDev
    },
    named,
    utilFor: {
      internal() {
        return {
          debug: logger._debug,
          error: logger._error,
          warn: logger._warn,
          trace: logger._trace,
          named(name, key) {
            return logger.named(name, key).utilFor.internal();
          }
        };
      },
      dev() {
        return {
          debug: logger.debugDev,
          error: logger.errorDev,
          warn: logger.warnDev,
          trace: logger.traceDev,
          named(name, key) {
            return logger.named(name, key).utilFor.dev();
          }
        };
      },
      public() {
        return {
          error: logger.errorPublic,
          warn: logger.warnPublic,
          debug(message, obj) {
            logger._warn(`(public "debug" filtered out) ${message}`, obj);
          },
          trace(message, obj) {
            logger._warn(`(public "trace" filtered out) ${message}`, obj);
          },
          named(name, key) {
            return logger.named(name, key).utilFor.public();
          }
        };
      }
    }
  };
  return logger;
}
var _Category, _Audience, TheatreLoggerLevel, _LoggerLevel, LEVELS, DEFAULTS;
var init_logger = __esm({
  "shared/src/_logger/logger.ts"() {
    (function(_Category2) {
      _Category2[_Category2["GENERAL"] = 1] = "GENERAL";
      _Category2[_Category2["TODO"] = 2] = "TODO";
      _Category2[_Category2["TROUBLESHOOTING"] = 4] = "TROUBLESHOOTING";
    })(_Category || (_Category = {}));
    (function(_Audience2) {
      _Audience2[_Audience2["INTERNAL"] = 8] = "INTERNAL";
      _Audience2[_Audience2["DEV"] = 16] = "DEV";
      _Audience2[_Audience2["PUBLIC"] = 32] = "PUBLIC";
    })(_Audience || (_Audience = {}));
    (function(TheatreLoggerLevel2) {
      TheatreLoggerLevel2[TheatreLoggerLevel2["TRACE"] = 64] = "TRACE";
      TheatreLoggerLevel2[TheatreLoggerLevel2["DEBUG"] = 128] = "DEBUG";
      TheatreLoggerLevel2[TheatreLoggerLevel2["WARN"] = 256] = "WARN";
      TheatreLoggerLevel2[TheatreLoggerLevel2["ERROR"] = 512] = "ERROR";
    })(TheatreLoggerLevel || (TheatreLoggerLevel = {}));
    (function(_LoggerLevel2) {
      _LoggerLevel2[_LoggerLevel2["ERROR_PUBLIC"] = 545] = "ERROR_PUBLIC";
      _LoggerLevel2[_LoggerLevel2["ERROR_DEV"] = 529] = "ERROR_DEV";
      _LoggerLevel2[_LoggerLevel2["_HMM"] = 524] = "_HMM";
      _LoggerLevel2[_LoggerLevel2["_TODO"] = 522] = "_TODO";
      _LoggerLevel2[_LoggerLevel2["_ERROR"] = 521] = "_ERROR";
      _LoggerLevel2[_LoggerLevel2["WARN_PUBLIC"] = 289] = "WARN_PUBLIC";
      _LoggerLevel2[_LoggerLevel2["WARN_DEV"] = 273] = "WARN_DEV";
      _LoggerLevel2[_LoggerLevel2["_KAPOW"] = 268] = "_KAPOW";
      _LoggerLevel2[_LoggerLevel2["_WARN"] = 265] = "_WARN";
      _LoggerLevel2[_LoggerLevel2["DEBUG_DEV"] = 145] = "DEBUG_DEV";
      _LoggerLevel2[_LoggerLevel2["_DEBUG"] = 137] = "_DEBUG";
      _LoggerLevel2[_LoggerLevel2["TRACE_DEV"] = 81] = "TRACE_DEV";
      _LoggerLevel2[_LoggerLevel2["_TRACE"] = 73] = "_TRACE";
    })(_LoggerLevel || (_LoggerLevel = {}));
    LEVELS = {
      _hmm: getLogMeta(524),
      _todo: getLogMeta(522),
      _error: getLogMeta(521),
      errorDev: getLogMeta(529),
      errorPublic: getLogMeta(545),
      _kapow: getLogMeta(268),
      _warn: getLogMeta(265),
      warnDev: getLogMeta(273),
      warnPublic: getLogMeta(289),
      _debug: getLogMeta(137),
      debugDev: getLogMeta(145),
      _trace: getLogMeta(73),
      traceDev: getLogMeta(81)
    };
    DEFAULTS = {
      loggingConsoleStyle: true,
      loggerConsoleStyle: true,
      includes: Object.freeze({
        internal: false,
        dev: false,
        min: 256
      }),
      filtered: function defaultFiltered() {
      },
      include: function defaultInclude() {
        return {};
      },
      create: null,
      creatExt: null,
      named(parent, name, key) {
        return this.create({
          names: [...parent.names, { name, key }]
        });
      },
      style: {
        bold: void 0,
        italic: void 0,
        cssMemo: new Map([
          ["", ""]
        ]),
        collapseOnRE: /[a-z- ]+/g,
        color: void 0,
        collapsed(name) {
          if (name.length < 5)
            return name;
          const collapsed = name.replace(this.collapseOnRE, "");
          if (!this.cssMemo.has(collapsed)) {
            this.cssMemo.set(collapsed, this.css(name));
          }
          return collapsed;
        },
        css(name) {
          var _a2, _b, _c, _d;
          const found = this.cssMemo.get(name);
          if (found)
            return found;
          let css = `color:${(_b = (_a2 = this.color) == null ? void 0 : _a2.call(this, name)) != null ? _b : `hsl(${(name.charCodeAt(0) + name.charCodeAt(name.length - 1)) % 360}, 100%, 60%)`}`;
          if ((_c = this.bold) == null ? void 0 : _c.test(name)) {
            css += ";font-weight:600";
          }
          if ((_d = this.italic) == null ? void 0 : _d.test(name)) {
            css += ";font-style:italic";
          }
          this.cssMemo.set(name, css);
          return css;
        }
      }
    };
  }
});

// shared/src/logger.ts
var internal, logger_default;
var init_logger2 = __esm({
  "shared/src/logger.ts"() {
    init_logger();
    init_logger();
    internal = createTheatreInternalLogger(console, {
      _debug: function() {
      },
      _error: function() {
      }
    });
    internal.configureLogging({
      dev: true,
      min: TheatreLoggerLevel.TRACE
    });
    logger_default = internal.getLogger().named("Theatre.js (default logger)").utilFor.dev();
  }
});

// shared/src/utils/memoizeFn.ts
function memoizeFn(producer) {
  const cache3 = new WeakMap();
  return (k4) => {
    if (!cache3.has(k4)) {
      cache3.set(k4, producer(k4));
    }
    return cache3.get(k4);
  };
}
var init_memoizeFn = __esm({
  "shared/src/utils/memoizeFn.ts"() {
  }
});

// shared/src/utils/addresses.ts
function doesPathStartWith(path, pathPrefix) {
  return pathPrefix.every((pathPart, i3) => pathPart === path[i3]);
}
function arePathsEqual(pathToPropA, pathToPropB) {
  if (pathToPropA.length !== pathToPropB.length)
    return false;
  for (let i3 = 0; i3 < pathToPropA.length; i3++) {
    if (pathToPropA[i3] !== pathToPropB[i3])
      return false;
  }
  return true;
}
function commonRootOfPathsToProps(pathsToProps) {
  var _a2;
  const commonPathToProp = [];
  while (true) {
    const i3 = commonPathToProp.length;
    let candidatePathPart = (_a2 = pathsToProps[0]) == null ? void 0 : _a2[i3];
    if (candidatePathPart === void 0)
      return commonPathToProp;
    for (const pathToProp of pathsToProps) {
      if (candidatePathPart !== pathToProp[i3]) {
        return commonPathToProp;
      }
    }
    commonPathToProp.push(candidatePathPart);
  }
}
var encodePathToProp, decodePathToProp;
var init_addresses = __esm({
  "shared/src/utils/addresses.ts"() {
    init_memoizeFn();
    encodePathToProp = memoizeFn((p3) => JSON.stringify(p3));
    decodePathToProp = (s3) => JSON.parse(s3);
  }
});

// ../node_modules/lodash-es/_freeGlobal.js
var freeGlobal, freeGlobal_default;
var init_freeGlobal = __esm({
  "../node_modules/lodash-es/_freeGlobal.js"() {
    freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    freeGlobal_default = freeGlobal;
  }
});

// ../node_modules/lodash-es/_root.js
var freeSelf, root, root_default;
var init_root = __esm({
  "../node_modules/lodash-es/_root.js"() {
    init_freeGlobal();
    freeSelf = typeof self == "object" && self && self.Object === Object && self;
    root = freeGlobal_default || freeSelf || Function("return this")();
    root_default = root;
  }
});

// ../node_modules/lodash-es/_Symbol.js
var Symbol2, Symbol_default;
var init_Symbol = __esm({
  "../node_modules/lodash-es/_Symbol.js"() {
    init_root();
    Symbol2 = root_default.Symbol;
    Symbol_default = Symbol2;
  }
});

// ../node_modules/lodash-es/_getRawTag.js
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result2 = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result2;
}
var objectProto, hasOwnProperty, nativeObjectToString, symToStringTag, getRawTag_default;
var init_getRawTag = __esm({
  "../node_modules/lodash-es/_getRawTag.js"() {
    init_Symbol();
    objectProto = Object.prototype;
    hasOwnProperty = objectProto.hasOwnProperty;
    nativeObjectToString = objectProto.toString;
    symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
    getRawTag_default = getRawTag;
  }
});

// ../node_modules/lodash-es/_objectToString.js
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectProto2, nativeObjectToString2, objectToString_default;
var init_objectToString = __esm({
  "../node_modules/lodash-es/_objectToString.js"() {
    objectProto2 = Object.prototype;
    nativeObjectToString2 = objectProto2.toString;
    objectToString_default = objectToString;
  }
});

// ../node_modules/lodash-es/_baseGetTag.js
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var nullTag, undefinedTag, symToStringTag2, baseGetTag_default;
var init_baseGetTag = __esm({
  "../node_modules/lodash-es/_baseGetTag.js"() {
    init_Symbol();
    init_getRawTag();
    init_objectToString();
    nullTag = "[object Null]";
    undefinedTag = "[object Undefined]";
    symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
    baseGetTag_default = baseGetTag;
  }
});

// ../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default;
var init_isObjectLike = __esm({
  "../node_modules/lodash-es/isObjectLike.js"() {
    isObjectLike_default = isObjectLike;
  }
});

// ../node_modules/lodash-es/isSymbol.js
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var symbolTag, isSymbol_default;
var init_isSymbol = __esm({
  "../node_modules/lodash-es/isSymbol.js"() {
    init_baseGetTag();
    init_isObjectLike();
    symbolTag = "[object Symbol]";
    isSymbol_default = isSymbol;
  }
});

// ../node_modules/lodash-es/_arrayMap.js
function arrayMap(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index < length) {
    result2[index] = iteratee(array[index], index, array);
  }
  return result2;
}
var arrayMap_default;
var init_arrayMap = __esm({
  "../node_modules/lodash-es/_arrayMap.js"() {
    arrayMap_default = arrayMap;
  }
});

// ../node_modules/lodash-es/isArray.js
var isArray, isArray_default;
var init_isArray = __esm({
  "../node_modules/lodash-es/isArray.js"() {
    isArray = Array.isArray;
    isArray_default = isArray;
  }
});

// ../node_modules/lodash-es/_baseToString.js
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray_default(value)) {
    return arrayMap_default(value, baseToString) + "";
  }
  if (isSymbol_default(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
}
var INFINITY, symbolProto, symbolToString, baseToString_default;
var init_baseToString = __esm({
  "../node_modules/lodash-es/_baseToString.js"() {
    init_Symbol();
    init_arrayMap();
    init_isArray();
    init_isSymbol();
    INFINITY = 1 / 0;
    symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
    symbolToString = symbolProto ? symbolProto.toString : void 0;
    baseToString_default = baseToString;
  }
});

// ../node_modules/lodash-es/_trimmedEndIndex.js
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var reWhitespace, trimmedEndIndex_default;
var init_trimmedEndIndex = __esm({
  "../node_modules/lodash-es/_trimmedEndIndex.js"() {
    reWhitespace = /\s/;
    trimmedEndIndex_default = trimmedEndIndex;
  }
});

// ../node_modules/lodash-es/_baseTrim.js
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
}
var reTrimStart, baseTrim_default;
var init_baseTrim = __esm({
  "../node_modules/lodash-es/_baseTrim.js"() {
    init_trimmedEndIndex();
    reTrimStart = /^\s+/;
    baseTrim_default = baseTrim;
  }
});

// ../node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default;
var init_isObject = __esm({
  "../node_modules/lodash-es/isObject.js"() {
    isObject_default = isObject;
  }
});

// ../node_modules/lodash-es/toNumber.js
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var NAN, reIsBadHex, reIsBinary, reIsOctal, freeParseInt, toNumber_default;
var init_toNumber = __esm({
  "../node_modules/lodash-es/toNumber.js"() {
    init_baseTrim();
    init_isObject();
    init_isSymbol();
    NAN = 0 / 0;
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    reIsBinary = /^0b[01]+$/i;
    reIsOctal = /^0o[0-7]+$/i;
    freeParseInt = parseInt;
    toNumber_default = toNumber;
  }
});

// ../node_modules/lodash-es/toFinite.js
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_default(value);
  if (value === INFINITY2 || value === -INFINITY2) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var INFINITY2, MAX_INTEGER, toFinite_default;
var init_toFinite = __esm({
  "../node_modules/lodash-es/toFinite.js"() {
    init_toNumber();
    INFINITY2 = 1 / 0;
    MAX_INTEGER = 17976931348623157e292;
    toFinite_default = toFinite;
  }
});

// ../node_modules/lodash-es/toInteger.js
function toInteger(value) {
  var result2 = toFinite_default(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
var toInteger_default;
var init_toInteger = __esm({
  "../node_modules/lodash-es/toInteger.js"() {
    init_toFinite();
    toInteger_default = toInteger;
  }
});

// ../node_modules/lodash-es/identity.js
function identity2(value) {
  return value;
}
var identity_default;
var init_identity = __esm({
  "../node_modules/lodash-es/identity.js"() {
    identity_default = identity2;
  }
});

// ../node_modules/lodash-es/isFunction.js
function isFunction(value) {
  if (!isObject_default(value)) {
    return false;
  }
  var tag = baseGetTag_default(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var asyncTag, funcTag, genTag, proxyTag, isFunction_default;
var init_isFunction = __esm({
  "../node_modules/lodash-es/isFunction.js"() {
    init_baseGetTag();
    init_isObject();
    asyncTag = "[object AsyncFunction]";
    funcTag = "[object Function]";
    genTag = "[object GeneratorFunction]";
    proxyTag = "[object Proxy]";
    isFunction_default = isFunction;
  }
});

// ../node_modules/lodash-es/_coreJsData.js
var coreJsData, coreJsData_default;
var init_coreJsData = __esm({
  "../node_modules/lodash-es/_coreJsData.js"() {
    init_root();
    coreJsData = root_default["__core-js_shared__"];
    coreJsData_default = coreJsData;
  }
});

// ../node_modules/lodash-es/_isMasked.js
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var maskSrcKey, isMasked_default;
var init_isMasked = __esm({
  "../node_modules/lodash-es/_isMasked.js"() {
    init_coreJsData();
    maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    isMasked_default = isMasked;
  }
});

// ../node_modules/lodash-es/_toSource.js
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var funcProto, funcToString, toSource_default;
var init_toSource = __esm({
  "../node_modules/lodash-es/_toSource.js"() {
    funcProto = Function.prototype;
    funcToString = funcProto.toString;
    toSource_default = toSource;
  }
});

// ../node_modules/lodash-es/_baseIsNative.js
function baseIsNative(value) {
  if (!isObject_default(value) || isMasked_default(value)) {
    return false;
  }
  var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource_default(value));
}
var reRegExpChar, reIsHostCtor, funcProto2, objectProto3, funcToString2, hasOwnProperty2, reIsNative, baseIsNative_default;
var init_baseIsNative = __esm({
  "../node_modules/lodash-es/_baseIsNative.js"() {
    init_isFunction();
    init_isMasked();
    init_isObject();
    init_toSource();
    reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    reIsHostCtor = /^\[object .+?Constructor\]$/;
    funcProto2 = Function.prototype;
    objectProto3 = Object.prototype;
    funcToString2 = funcProto2.toString;
    hasOwnProperty2 = objectProto3.hasOwnProperty;
    reIsNative = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    baseIsNative_default = baseIsNative;
  }
});

// ../node_modules/lodash-es/_getValue.js
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
var getValue_default;
var init_getValue = __esm({
  "../node_modules/lodash-es/_getValue.js"() {
    getValue_default = getValue;
  }
});

// ../node_modules/lodash-es/_getNative.js
function getNative(object, key) {
  var value = getValue_default(object, key);
  return baseIsNative_default(value) ? value : void 0;
}
var getNative_default;
var init_getNative = __esm({
  "../node_modules/lodash-es/_getNative.js"() {
    init_baseIsNative();
    init_getValue();
    getNative_default = getNative;
  }
});

// ../node_modules/lodash-es/_WeakMap.js
var WeakMap2, WeakMap_default;
var init_WeakMap = __esm({
  "../node_modules/lodash-es/_WeakMap.js"() {
    init_getNative();
    init_root();
    WeakMap2 = getNative_default(root_default, "WeakMap");
    WeakMap_default = WeakMap2;
  }
});

// ../node_modules/lodash-es/_apply.js
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var apply_default;
var init_apply = __esm({
  "../node_modules/lodash-es/_apply.js"() {
    apply_default = apply;
  }
});

// ../node_modules/lodash-es/noop.js
function noop() {
}
var noop_default;
var init_noop = __esm({
  "../node_modules/lodash-es/noop.js"() {
    noop_default = noop;
  }
});

// ../node_modules/lodash-es/_copyArray.js
function copyArray(source, array) {
  var index = -1, length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var copyArray_default;
var init_copyArray = __esm({
  "../node_modules/lodash-es/_copyArray.js"() {
    copyArray_default = copyArray;
  }
});

// ../node_modules/lodash-es/_shortOut.js
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var HOT_COUNT, HOT_SPAN, nativeNow, shortOut_default;
var init_shortOut = __esm({
  "../node_modules/lodash-es/_shortOut.js"() {
    HOT_COUNT = 800;
    HOT_SPAN = 16;
    nativeNow = Date.now;
    shortOut_default = shortOut;
  }
});

// ../node_modules/lodash-es/constant.js
function constant(value) {
  return function() {
    return value;
  };
}
var constant_default;
var init_constant = __esm({
  "../node_modules/lodash-es/constant.js"() {
    constant_default = constant;
  }
});

// ../node_modules/lodash-es/_defineProperty.js
var defineProperty, defineProperty_default;
var init_defineProperty = __esm({
  "../node_modules/lodash-es/_defineProperty.js"() {
    init_getNative();
    defineProperty = function() {
      try {
        var func = getNative_default(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e2) {
      }
    }();
    defineProperty_default = defineProperty;
  }
});

// ../node_modules/lodash-es/_baseSetToString.js
var baseSetToString, baseSetToString_default;
var init_baseSetToString = __esm({
  "../node_modules/lodash-es/_baseSetToString.js"() {
    init_constant();
    init_defineProperty();
    init_identity();
    baseSetToString = !defineProperty_default ? identity_default : function(func, string) {
      return defineProperty_default(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant_default(string),
        "writable": true
      });
    };
    baseSetToString_default = baseSetToString;
  }
});

// ../node_modules/lodash-es/_setToString.js
var setToString, setToString_default;
var init_setToString = __esm({
  "../node_modules/lodash-es/_setToString.js"() {
    init_baseSetToString();
    init_shortOut();
    setToString = shortOut_default(baseSetToString_default);
    setToString_default = setToString;
  }
});

// ../node_modules/lodash-es/_baseFindIndex.js
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var baseFindIndex_default;
var init_baseFindIndex = __esm({
  "../node_modules/lodash-es/_baseFindIndex.js"() {
    baseFindIndex_default = baseFindIndex;
  }
});

// ../node_modules/lodash-es/_baseIsNaN.js
function baseIsNaN(value) {
  return value !== value;
}
var baseIsNaN_default;
var init_baseIsNaN = __esm({
  "../node_modules/lodash-es/_baseIsNaN.js"() {
    baseIsNaN_default = baseIsNaN;
  }
});

// ../node_modules/lodash-es/_strictIndexOf.js
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var strictIndexOf_default;
var init_strictIndexOf = __esm({
  "../node_modules/lodash-es/_strictIndexOf.js"() {
    strictIndexOf_default = strictIndexOf;
  }
});

// ../node_modules/lodash-es/_baseIndexOf.js
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf_default(array, value, fromIndex) : baseFindIndex_default(array, baseIsNaN_default, fromIndex);
}
var baseIndexOf_default;
var init_baseIndexOf = __esm({
  "../node_modules/lodash-es/_baseIndexOf.js"() {
    init_baseFindIndex();
    init_baseIsNaN();
    init_strictIndexOf();
    baseIndexOf_default = baseIndexOf;
  }
});

// ../node_modules/lodash-es/_arrayIncludes.js
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf_default(array, value, 0) > -1;
}
var arrayIncludes_default;
var init_arrayIncludes = __esm({
  "../node_modules/lodash-es/_arrayIncludes.js"() {
    init_baseIndexOf();
    arrayIncludes_default = arrayIncludes;
  }
});

// ../node_modules/lodash-es/_isIndex.js
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var MAX_SAFE_INTEGER, reIsUint, isIndex_default;
var init_isIndex = __esm({
  "../node_modules/lodash-es/_isIndex.js"() {
    MAX_SAFE_INTEGER = 9007199254740991;
    reIsUint = /^(?:0|[1-9]\d*)$/;
    isIndex_default = isIndex;
  }
});

// ../node_modules/lodash-es/_baseAssignValue.js
function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty_default) {
    defineProperty_default(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var baseAssignValue_default;
var init_baseAssignValue = __esm({
  "../node_modules/lodash-es/_baseAssignValue.js"() {
    init_defineProperty();
    baseAssignValue_default = baseAssignValue;
  }
});

// ../node_modules/lodash-es/eq.js
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_default;
var init_eq = __esm({
  "../node_modules/lodash-es/eq.js"() {
    eq_default = eq;
  }
});

// ../node_modules/lodash-es/_assignValue.js
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty3.call(object, key) && eq_default(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue_default(object, key, value);
  }
}
var objectProto4, hasOwnProperty3, assignValue_default;
var init_assignValue = __esm({
  "../node_modules/lodash-es/_assignValue.js"() {
    init_baseAssignValue();
    init_eq();
    objectProto4 = Object.prototype;
    hasOwnProperty3 = objectProto4.hasOwnProperty;
    assignValue_default = assignValue;
  }
});

// ../node_modules/lodash-es/_overRest.js
function overRest(func, start, transform) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply_default(func, this, otherArgs);
  };
}
var nativeMax, overRest_default;
var init_overRest = __esm({
  "../node_modules/lodash-es/_overRest.js"() {
    init_apply();
    nativeMax = Math.max;
    overRest_default = overRest;
  }
});

// ../node_modules/lodash-es/_baseRest.js
function baseRest(func, start) {
  return setToString_default(overRest_default(func, start, identity_default), func + "");
}
var baseRest_default;
var init_baseRest = __esm({
  "../node_modules/lodash-es/_baseRest.js"() {
    init_identity();
    init_overRest();
    init_setToString();
    baseRest_default = baseRest;
  }
});

// ../node_modules/lodash-es/isLength.js
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
}
var MAX_SAFE_INTEGER2, isLength_default;
var init_isLength = __esm({
  "../node_modules/lodash-es/isLength.js"() {
    MAX_SAFE_INTEGER2 = 9007199254740991;
    isLength_default = isLength;
  }
});

// ../node_modules/lodash-es/isArrayLike.js
function isArrayLike(value) {
  return value != null && isLength_default(value.length) && !isFunction_default(value);
}
var isArrayLike_default;
var init_isArrayLike = __esm({
  "../node_modules/lodash-es/isArrayLike.js"() {
    init_isFunction();
    init_isLength();
    isArrayLike_default = isArrayLike;
  }
});

// ../node_modules/lodash-es/_isIterateeCall.js
function isIterateeCall(value, index, object) {
  if (!isObject_default(object)) {
    return false;
  }
  var type = typeof index;
  if (type == "number" ? isArrayLike_default(object) && isIndex_default(index, object.length) : type == "string" && index in object) {
    return eq_default(object[index], value);
  }
  return false;
}
var isIterateeCall_default;
var init_isIterateeCall = __esm({
  "../node_modules/lodash-es/_isIterateeCall.js"() {
    init_eq();
    init_isArrayLike();
    init_isIndex();
    init_isObject();
    isIterateeCall_default = isIterateeCall;
  }
});

// ../node_modules/lodash-es/_isPrototype.js
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto5;
  return value === proto;
}
var objectProto5, isPrototype_default;
var init_isPrototype = __esm({
  "../node_modules/lodash-es/_isPrototype.js"() {
    objectProto5 = Object.prototype;
    isPrototype_default = isPrototype;
  }
});

// ../node_modules/lodash-es/_baseTimes.js
function baseTimes(n3, iteratee) {
  var index = -1, result2 = Array(n3);
  while (++index < n3) {
    result2[index] = iteratee(index);
  }
  return result2;
}
var baseTimes_default;
var init_baseTimes = __esm({
  "../node_modules/lodash-es/_baseTimes.js"() {
    baseTimes_default = baseTimes;
  }
});

// ../node_modules/lodash-es/_baseIsArguments.js
function baseIsArguments(value) {
  return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
}
var argsTag, baseIsArguments_default;
var init_baseIsArguments = __esm({
  "../node_modules/lodash-es/_baseIsArguments.js"() {
    init_baseGetTag();
    init_isObjectLike();
    argsTag = "[object Arguments]";
    baseIsArguments_default = baseIsArguments;
  }
});

// ../node_modules/lodash-es/isArguments.js
var objectProto6, hasOwnProperty4, propertyIsEnumerable, isArguments, isArguments_default;
var init_isArguments = __esm({
  "../node_modules/lodash-es/isArguments.js"() {
    init_baseIsArguments();
    init_isObjectLike();
    objectProto6 = Object.prototype;
    hasOwnProperty4 = objectProto6.hasOwnProperty;
    propertyIsEnumerable = objectProto6.propertyIsEnumerable;
    isArguments = baseIsArguments_default(function() {
      return arguments;
    }()) ? baseIsArguments_default : function(value) {
      return isObjectLike_default(value) && hasOwnProperty4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    isArguments_default = isArguments;
  }
});

// ../node_modules/lodash-es/stubFalse.js
function stubFalse() {
  return false;
}
var stubFalse_default;
var init_stubFalse = __esm({
  "../node_modules/lodash-es/stubFalse.js"() {
    stubFalse_default = stubFalse;
  }
});

// ../node_modules/lodash-es/isBuffer.js
var freeExports, freeModule, moduleExports, Buffer2, nativeIsBuffer, isBuffer, isBuffer_default;
var init_isBuffer = __esm({
  "../node_modules/lodash-es/isBuffer.js"() {
    init_root();
    init_stubFalse();
    freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    moduleExports = freeModule && freeModule.exports === freeExports;
    Buffer2 = moduleExports ? root_default.Buffer : void 0;
    nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    isBuffer = nativeIsBuffer || stubFalse_default;
    isBuffer_default = isBuffer;
  }
});

// ../node_modules/lodash-es/_baseIsTypedArray.js
function baseIsTypedArray(value) {
  return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
}
var argsTag2, arrayTag, boolTag, dateTag, errorTag, funcTag2, mapTag, numberTag, objectTag, regexpTag, setTag, stringTag, weakMapTag, arrayBufferTag, dataViewTag, float32Tag, float64Tag, int8Tag, int16Tag, int32Tag, uint8Tag, uint8ClampedTag, uint16Tag, uint32Tag, typedArrayTags, baseIsTypedArray_default;
var init_baseIsTypedArray = __esm({
  "../node_modules/lodash-es/_baseIsTypedArray.js"() {
    init_baseGetTag();
    init_isLength();
    init_isObjectLike();
    argsTag2 = "[object Arguments]";
    arrayTag = "[object Array]";
    boolTag = "[object Boolean]";
    dateTag = "[object Date]";
    errorTag = "[object Error]";
    funcTag2 = "[object Function]";
    mapTag = "[object Map]";
    numberTag = "[object Number]";
    objectTag = "[object Object]";
    regexpTag = "[object RegExp]";
    setTag = "[object Set]";
    stringTag = "[object String]";
    weakMapTag = "[object WeakMap]";
    arrayBufferTag = "[object ArrayBuffer]";
    dataViewTag = "[object DataView]";
    float32Tag = "[object Float32Array]";
    float64Tag = "[object Float64Array]";
    int8Tag = "[object Int8Array]";
    int16Tag = "[object Int16Array]";
    int32Tag = "[object Int32Array]";
    uint8Tag = "[object Uint8Array]";
    uint8ClampedTag = "[object Uint8ClampedArray]";
    uint16Tag = "[object Uint16Array]";
    uint32Tag = "[object Uint32Array]";
    typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    baseIsTypedArray_default = baseIsTypedArray;
  }
});

// ../node_modules/lodash-es/_baseUnary.js
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var baseUnary_default;
var init_baseUnary = __esm({
  "../node_modules/lodash-es/_baseUnary.js"() {
    baseUnary_default = baseUnary;
  }
});

// ../node_modules/lodash-es/_nodeUtil.js
var freeExports2, freeModule2, moduleExports2, freeProcess, nodeUtil, nodeUtil_default;
var init_nodeUtil = __esm({
  "../node_modules/lodash-es/_nodeUtil.js"() {
    init_freeGlobal();
    freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
    freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
    moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    freeProcess = moduleExports2 && freeGlobal_default.process;
    nodeUtil = function() {
      try {
        var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    nodeUtil_default = nodeUtil;
  }
});

// ../node_modules/lodash-es/isTypedArray.js
var nodeIsTypedArray, isTypedArray, isTypedArray_default;
var init_isTypedArray = __esm({
  "../node_modules/lodash-es/isTypedArray.js"() {
    init_baseIsTypedArray();
    init_baseUnary();
    init_nodeUtil();
    nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
    isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
    isTypedArray_default = isTypedArray;
  }
});

// ../node_modules/lodash-es/_arrayLikeKeys.js
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes_default(value.length, String) : [], length = result2.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty5.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex_default(key, length)))) {
      result2.push(key);
    }
  }
  return result2;
}
var objectProto7, hasOwnProperty5, arrayLikeKeys_default;
var init_arrayLikeKeys = __esm({
  "../node_modules/lodash-es/_arrayLikeKeys.js"() {
    init_baseTimes();
    init_isArguments();
    init_isArray();
    init_isBuffer();
    init_isIndex();
    init_isTypedArray();
    objectProto7 = Object.prototype;
    hasOwnProperty5 = objectProto7.hasOwnProperty;
    arrayLikeKeys_default = arrayLikeKeys;
  }
});

// ../node_modules/lodash-es/_overArg.js
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var overArg_default;
var init_overArg = __esm({
  "../node_modules/lodash-es/_overArg.js"() {
    overArg_default = overArg;
  }
});

// ../node_modules/lodash-es/_nativeKeys.js
var nativeKeys, nativeKeys_default;
var init_nativeKeys = __esm({
  "../node_modules/lodash-es/_nativeKeys.js"() {
    init_overArg();
    nativeKeys = overArg_default(Object.keys, Object);
    nativeKeys_default = nativeKeys;
  }
});

// ../node_modules/lodash-es/_baseKeys.js
function baseKeys(object) {
  if (!isPrototype_default(object)) {
    return nativeKeys_default(object);
  }
  var result2 = [];
  for (var key in Object(object)) {
    if (hasOwnProperty6.call(object, key) && key != "constructor") {
      result2.push(key);
    }
  }
  return result2;
}
var objectProto8, hasOwnProperty6, baseKeys_default;
var init_baseKeys = __esm({
  "../node_modules/lodash-es/_baseKeys.js"() {
    init_isPrototype();
    init_nativeKeys();
    objectProto8 = Object.prototype;
    hasOwnProperty6 = objectProto8.hasOwnProperty;
    baseKeys_default = baseKeys;
  }
});

// ../node_modules/lodash-es/keys.js
function keys(object) {
  return isArrayLike_default(object) ? arrayLikeKeys_default(object) : baseKeys_default(object);
}
var keys_default;
var init_keys = __esm({
  "../node_modules/lodash-es/keys.js"() {
    init_arrayLikeKeys();
    init_baseKeys();
    init_isArrayLike();
    keys_default = keys;
  }
});

// ../node_modules/lodash-es/_isKey.js
function isKey(value, object) {
  if (isArray_default(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol_default(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var reIsDeepProp, reIsPlainProp, isKey_default;
var init_isKey = __esm({
  "../node_modules/lodash-es/_isKey.js"() {
    init_isArray();
    init_isSymbol();
    reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    reIsPlainProp = /^\w*$/;
    isKey_default = isKey;
  }
});

// ../node_modules/lodash-es/_nativeCreate.js
var nativeCreate, nativeCreate_default;
var init_nativeCreate = __esm({
  "../node_modules/lodash-es/_nativeCreate.js"() {
    init_getNative();
    nativeCreate = getNative_default(Object, "create");
    nativeCreate_default = nativeCreate;
  }
});

// ../node_modules/lodash-es/_hashClear.js
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
  this.size = 0;
}
var hashClear_default;
var init_hashClear = __esm({
  "../node_modules/lodash-es/_hashClear.js"() {
    init_nativeCreate();
    hashClear_default = hashClear;
  }
});

// ../node_modules/lodash-es/_hashDelete.js
function hashDelete(key) {
  var result2 = this.has(key) && delete this.__data__[key];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var hashDelete_default;
var init_hashDelete = __esm({
  "../node_modules/lodash-es/_hashDelete.js"() {
    hashDelete_default = hashDelete;
  }
});

// ../node_modules/lodash-es/_hashGet.js
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate_default) {
    var result2 = data[key];
    return result2 === HASH_UNDEFINED ? void 0 : result2;
  }
  return hasOwnProperty7.call(data, key) ? data[key] : void 0;
}
var HASH_UNDEFINED, objectProto9, hasOwnProperty7, hashGet_default;
var init_hashGet = __esm({
  "../node_modules/lodash-es/_hashGet.js"() {
    init_nativeCreate();
    HASH_UNDEFINED = "__lodash_hash_undefined__";
    objectProto9 = Object.prototype;
    hasOwnProperty7 = objectProto9.hasOwnProperty;
    hashGet_default = hashGet;
  }
});

// ../node_modules/lodash-es/_hashHas.js
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate_default ? data[key] !== void 0 : hasOwnProperty8.call(data, key);
}
var objectProto10, hasOwnProperty8, hashHas_default;
var init_hashHas = __esm({
  "../node_modules/lodash-es/_hashHas.js"() {
    init_nativeCreate();
    objectProto10 = Object.prototype;
    hasOwnProperty8 = objectProto10.hasOwnProperty;
    hashHas_default = hashHas;
  }
});

// ../node_modules/lodash-es/_hashSet.js
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
  return this;
}
var HASH_UNDEFINED2, hashSet_default;
var init_hashSet = __esm({
  "../node_modules/lodash-es/_hashSet.js"() {
    init_nativeCreate();
    HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    hashSet_default = hashSet;
  }
});

// ../node_modules/lodash-es/_Hash.js
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
var Hash_default;
var init_Hash = __esm({
  "../node_modules/lodash-es/_Hash.js"() {
    init_hashClear();
    init_hashDelete();
    init_hashGet();
    init_hashHas();
    init_hashSet();
    Hash.prototype.clear = hashClear_default;
    Hash.prototype["delete"] = hashDelete_default;
    Hash.prototype.get = hashGet_default;
    Hash.prototype.has = hashHas_default;
    Hash.prototype.set = hashSet_default;
    Hash_default = Hash;
  }
});

// ../node_modules/lodash-es/_listCacheClear.js
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var listCacheClear_default;
var init_listCacheClear = __esm({
  "../node_modules/lodash-es/_listCacheClear.js"() {
    listCacheClear_default = listCacheClear;
  }
});

// ../node_modules/lodash-es/_assocIndexOf.js
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_default(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var assocIndexOf_default;
var init_assocIndexOf = __esm({
  "../node_modules/lodash-es/_assocIndexOf.js"() {
    init_eq();
    assocIndexOf_default = assocIndexOf;
  }
});

// ../node_modules/lodash-es/_listCacheDelete.js
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf_default(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var arrayProto, splice, listCacheDelete_default;
var init_listCacheDelete = __esm({
  "../node_modules/lodash-es/_listCacheDelete.js"() {
    init_assocIndexOf();
    arrayProto = Array.prototype;
    splice = arrayProto.splice;
    listCacheDelete_default = listCacheDelete;
  }
});

// ../node_modules/lodash-es/_listCacheGet.js
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf_default(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var listCacheGet_default;
var init_listCacheGet = __esm({
  "../node_modules/lodash-es/_listCacheGet.js"() {
    init_assocIndexOf();
    listCacheGet_default = listCacheGet;
  }
});

// ../node_modules/lodash-es/_listCacheHas.js
function listCacheHas(key) {
  return assocIndexOf_default(this.__data__, key) > -1;
}
var listCacheHas_default;
var init_listCacheHas = __esm({
  "../node_modules/lodash-es/_listCacheHas.js"() {
    init_assocIndexOf();
    listCacheHas_default = listCacheHas;
  }
});

// ../node_modules/lodash-es/_listCacheSet.js
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf_default(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var listCacheSet_default;
var init_listCacheSet = __esm({
  "../node_modules/lodash-es/_listCacheSet.js"() {
    init_assocIndexOf();
    listCacheSet_default = listCacheSet;
  }
});

// ../node_modules/lodash-es/_ListCache.js
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
var ListCache_default;
var init_ListCache = __esm({
  "../node_modules/lodash-es/_ListCache.js"() {
    init_listCacheClear();
    init_listCacheDelete();
    init_listCacheGet();
    init_listCacheHas();
    init_listCacheSet();
    ListCache.prototype.clear = listCacheClear_default;
    ListCache.prototype["delete"] = listCacheDelete_default;
    ListCache.prototype.get = listCacheGet_default;
    ListCache.prototype.has = listCacheHas_default;
    ListCache.prototype.set = listCacheSet_default;
    ListCache_default = ListCache;
  }
});

// ../node_modules/lodash-es/_Map.js
var Map2, Map_default;
var init_Map = __esm({
  "../node_modules/lodash-es/_Map.js"() {
    init_getNative();
    init_root();
    Map2 = getNative_default(root_default, "Map");
    Map_default = Map2;
  }
});

// ../node_modules/lodash-es/_mapCacheClear.js
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash_default(),
    "map": new (Map_default || ListCache_default)(),
    "string": new Hash_default()
  };
}
var mapCacheClear_default;
var init_mapCacheClear = __esm({
  "../node_modules/lodash-es/_mapCacheClear.js"() {
    init_Hash();
    init_ListCache();
    init_Map();
    mapCacheClear_default = mapCacheClear;
  }
});

// ../node_modules/lodash-es/_isKeyable.js
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var isKeyable_default;
var init_isKeyable = __esm({
  "../node_modules/lodash-es/_isKeyable.js"() {
    isKeyable_default = isKeyable;
  }
});

// ../node_modules/lodash-es/_getMapData.js
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable_default(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var getMapData_default;
var init_getMapData = __esm({
  "../node_modules/lodash-es/_getMapData.js"() {
    init_isKeyable();
    getMapData_default = getMapData;
  }
});

// ../node_modules/lodash-es/_mapCacheDelete.js
function mapCacheDelete(key) {
  var result2 = getMapData_default(this, key)["delete"](key);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var mapCacheDelete_default;
var init_mapCacheDelete = __esm({
  "../node_modules/lodash-es/_mapCacheDelete.js"() {
    init_getMapData();
    mapCacheDelete_default = mapCacheDelete;
  }
});

// ../node_modules/lodash-es/_mapCacheGet.js
function mapCacheGet(key) {
  return getMapData_default(this, key).get(key);
}
var mapCacheGet_default;
var init_mapCacheGet = __esm({
  "../node_modules/lodash-es/_mapCacheGet.js"() {
    init_getMapData();
    mapCacheGet_default = mapCacheGet;
  }
});

// ../node_modules/lodash-es/_mapCacheHas.js
function mapCacheHas(key) {
  return getMapData_default(this, key).has(key);
}
var mapCacheHas_default;
var init_mapCacheHas = __esm({
  "../node_modules/lodash-es/_mapCacheHas.js"() {
    init_getMapData();
    mapCacheHas_default = mapCacheHas;
  }
});

// ../node_modules/lodash-es/_mapCacheSet.js
function mapCacheSet(key, value) {
  var data = getMapData_default(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var mapCacheSet_default;
var init_mapCacheSet = __esm({
  "../node_modules/lodash-es/_mapCacheSet.js"() {
    init_getMapData();
    mapCacheSet_default = mapCacheSet;
  }
});

// ../node_modules/lodash-es/_MapCache.js
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
var MapCache_default;
var init_MapCache = __esm({
  "../node_modules/lodash-es/_MapCache.js"() {
    init_mapCacheClear();
    init_mapCacheDelete();
    init_mapCacheGet();
    init_mapCacheHas();
    init_mapCacheSet();
    MapCache.prototype.clear = mapCacheClear_default;
    MapCache.prototype["delete"] = mapCacheDelete_default;
    MapCache.prototype.get = mapCacheGet_default;
    MapCache.prototype.has = mapCacheHas_default;
    MapCache.prototype.set = mapCacheSet_default;
    MapCache_default = MapCache;
  }
});

// ../node_modules/lodash-es/memoize.js
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache3 = memoized.cache;
    if (cache3.has(key)) {
      return cache3.get(key);
    }
    var result2 = func.apply(this, args);
    memoized.cache = cache3.set(key, result2) || cache3;
    return result2;
  };
  memoized.cache = new (memoize.Cache || MapCache_default)();
  return memoized;
}
var FUNC_ERROR_TEXT, memoize_default;
var init_memoize = __esm({
  "../node_modules/lodash-es/memoize.js"() {
    init_MapCache();
    FUNC_ERROR_TEXT = "Expected a function";
    memoize.Cache = MapCache_default;
    memoize_default = memoize;
  }
});

// ../node_modules/lodash-es/_memoizeCapped.js
function memoizeCapped(func) {
  var result2 = memoize_default(func, function(key) {
    if (cache3.size === MAX_MEMOIZE_SIZE) {
      cache3.clear();
    }
    return key;
  });
  var cache3 = result2.cache;
  return result2;
}
var MAX_MEMOIZE_SIZE, memoizeCapped_default;
var init_memoizeCapped = __esm({
  "../node_modules/lodash-es/_memoizeCapped.js"() {
    init_memoize();
    MAX_MEMOIZE_SIZE = 500;
    memoizeCapped_default = memoizeCapped;
  }
});

// ../node_modules/lodash-es/_stringToPath.js
var rePropName, reEscapeChar, stringToPath, stringToPath_default;
var init_stringToPath = __esm({
  "../node_modules/lodash-es/_stringToPath.js"() {
    init_memoizeCapped();
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    reEscapeChar = /\\(\\)?/g;
    stringToPath = memoizeCapped_default(function(string) {
      var result2 = [];
      if (string.charCodeAt(0) === 46) {
        result2.push("");
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
      });
      return result2;
    });
    stringToPath_default = stringToPath;
  }
});

// ../node_modules/lodash-es/toString.js
function toString(value) {
  return value == null ? "" : baseToString_default(value);
}
var toString_default;
var init_toString = __esm({
  "../node_modules/lodash-es/toString.js"() {
    init_baseToString();
    toString_default = toString;
  }
});

// ../node_modules/lodash-es/_castPath.js
function castPath(value, object) {
  if (isArray_default(value)) {
    return value;
  }
  return isKey_default(value, object) ? [value] : stringToPath_default(toString_default(value));
}
var castPath_default;
var init_castPath = __esm({
  "../node_modules/lodash-es/_castPath.js"() {
    init_isArray();
    init_isKey();
    init_stringToPath();
    init_toString();
    castPath_default = castPath;
  }
});

// ../node_modules/lodash-es/_toKey.js
function toKey(value) {
  if (typeof value == "string" || isSymbol_default(value)) {
    return value;
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY3 ? "-0" : result2;
}
var INFINITY3, toKey_default;
var init_toKey = __esm({
  "../node_modules/lodash-es/_toKey.js"() {
    init_isSymbol();
    INFINITY3 = 1 / 0;
    toKey_default = toKey;
  }
});

// ../node_modules/lodash-es/_baseGet.js
function baseGet(object, path) {
  path = castPath_default(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey_default(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var baseGet_default;
var init_baseGet = __esm({
  "../node_modules/lodash-es/_baseGet.js"() {
    init_castPath();
    init_toKey();
    baseGet_default = baseGet;
  }
});

// ../node_modules/lodash-es/get.js
function get(object, path, defaultValue) {
  var result2 = object == null ? void 0 : baseGet_default(object, path);
  return result2 === void 0 ? defaultValue : result2;
}
var get_default;
var init_get = __esm({
  "../node_modules/lodash-es/get.js"() {
    init_baseGet();
    get_default = get;
  }
});

// ../node_modules/lodash-es/_arrayPush.js
function arrayPush(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var arrayPush_default;
var init_arrayPush = __esm({
  "../node_modules/lodash-es/_arrayPush.js"() {
    arrayPush_default = arrayPush;
  }
});

// ../node_modules/lodash-es/_isFlattenable.js
function isFlattenable(value) {
  return isArray_default(value) || isArguments_default(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var spreadableSymbol, isFlattenable_default;
var init_isFlattenable = __esm({
  "../node_modules/lodash-es/_isFlattenable.js"() {
    init_Symbol();
    init_isArguments();
    init_isArray();
    spreadableSymbol = Symbol_default ? Symbol_default.isConcatSpreadable : void 0;
    isFlattenable_default = isFlattenable;
  }
});

// ../node_modules/lodash-es/_baseFlatten.js
function baseFlatten(array, depth, predicate, isStrict, result2) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable_default);
  result2 || (result2 = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten(value, depth - 1, predicate, isStrict, result2);
      } else {
        arrayPush_default(result2, value);
      }
    } else if (!isStrict) {
      result2[result2.length] = value;
    }
  }
  return result2;
}
var baseFlatten_default;
var init_baseFlatten = __esm({
  "../node_modules/lodash-es/_baseFlatten.js"() {
    init_arrayPush();
    init_isFlattenable();
    baseFlatten_default = baseFlatten;
  }
});

// ../node_modules/lodash-es/_getPrototype.js
var getPrototype, getPrototype_default;
var init_getPrototype = __esm({
  "../node_modules/lodash-es/_getPrototype.js"() {
    init_overArg();
    getPrototype = overArg_default(Object.getPrototypeOf, Object);
    getPrototype_default = getPrototype;
  }
});

// ../node_modules/lodash-es/isPlainObject.js
function isPlainObject(value) {
  if (!isObjectLike_default(value) || baseGetTag_default(value) != objectTag2) {
    return false;
  }
  var proto = getPrototype_default(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty9.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString3.call(Ctor) == objectCtorString;
}
var objectTag2, funcProto3, objectProto11, funcToString3, hasOwnProperty9, objectCtorString, isPlainObject_default;
var init_isPlainObject = __esm({
  "../node_modules/lodash-es/isPlainObject.js"() {
    init_baseGetTag();
    init_getPrototype();
    init_isObjectLike();
    objectTag2 = "[object Object]";
    funcProto3 = Function.prototype;
    objectProto11 = Object.prototype;
    funcToString3 = funcProto3.toString;
    hasOwnProperty9 = objectProto11.hasOwnProperty;
    objectCtorString = funcToString3.call(Object);
    isPlainObject_default = isPlainObject;
  }
});

// ../node_modules/lodash-es/_createRound.js
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber_default(number);
    precision = precision == null ? 0 : nativeMin(toInteger_default(precision), 292);
    if (precision && nativeIsFinite(number)) {
      var pair = (toString_default(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
      pair = (toString_default(value) + "e").split("e");
      return +(pair[0] + "e" + (+pair[1] - precision));
    }
    return func(number);
  };
}
var nativeIsFinite, nativeMin, createRound_default;
var init_createRound = __esm({
  "../node_modules/lodash-es/_createRound.js"() {
    init_root();
    init_toInteger();
    init_toNumber();
    init_toString();
    nativeIsFinite = root_default.isFinite;
    nativeMin = Math.min;
    createRound_default = createRound;
  }
});

// ../node_modules/lodash-es/_baseClamp.js
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== void 0) {
      number = number <= upper ? number : upper;
    }
    if (lower !== void 0) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}
var baseClamp_default;
var init_baseClamp = __esm({
  "../node_modules/lodash-es/_baseClamp.js"() {
    baseClamp_default = baseClamp;
  }
});

// ../node_modules/lodash-es/clamp.js
function clamp(number, lower, upper) {
  if (upper === void 0) {
    upper = lower;
    lower = void 0;
  }
  if (upper !== void 0) {
    upper = toNumber_default(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== void 0) {
    lower = toNumber_default(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp_default(toNumber_default(number), lower, upper);
}
var clamp_default;
var init_clamp = __esm({
  "../node_modules/lodash-es/clamp.js"() {
    init_baseClamp();
    init_toNumber();
    clamp_default = clamp;
  }
});

// ../node_modules/lodash-es/_stackClear.js
function stackClear() {
  this.__data__ = new ListCache_default();
  this.size = 0;
}
var stackClear_default;
var init_stackClear = __esm({
  "../node_modules/lodash-es/_stackClear.js"() {
    init_ListCache();
    stackClear_default = stackClear;
  }
});

// ../node_modules/lodash-es/_stackDelete.js
function stackDelete(key) {
  var data = this.__data__, result2 = data["delete"](key);
  this.size = data.size;
  return result2;
}
var stackDelete_default;
var init_stackDelete = __esm({
  "../node_modules/lodash-es/_stackDelete.js"() {
    stackDelete_default = stackDelete;
  }
});

// ../node_modules/lodash-es/_stackGet.js
function stackGet(key) {
  return this.__data__.get(key);
}
var stackGet_default;
var init_stackGet = __esm({
  "../node_modules/lodash-es/_stackGet.js"() {
    stackGet_default = stackGet;
  }
});

// ../node_modules/lodash-es/_stackHas.js
function stackHas(key) {
  return this.__data__.has(key);
}
var stackHas_default;
var init_stackHas = __esm({
  "../node_modules/lodash-es/_stackHas.js"() {
    stackHas_default = stackHas;
  }
});

// ../node_modules/lodash-es/_stackSet.js
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache_default) {
    var pairs = data.__data__;
    if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache_default(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var LARGE_ARRAY_SIZE, stackSet_default;
var init_stackSet = __esm({
  "../node_modules/lodash-es/_stackSet.js"() {
    init_ListCache();
    init_Map();
    init_MapCache();
    LARGE_ARRAY_SIZE = 200;
    stackSet_default = stackSet;
  }
});

// ../node_modules/lodash-es/_Stack.js
function Stack(entries) {
  var data = this.__data__ = new ListCache_default(entries);
  this.size = data.size;
}
var Stack_default;
var init_Stack = __esm({
  "../node_modules/lodash-es/_Stack.js"() {
    init_ListCache();
    init_stackClear();
    init_stackDelete();
    init_stackGet();
    init_stackHas();
    init_stackSet();
    Stack.prototype.clear = stackClear_default;
    Stack.prototype["delete"] = stackDelete_default;
    Stack.prototype.get = stackGet_default;
    Stack.prototype.has = stackHas_default;
    Stack.prototype.set = stackSet_default;
    Stack_default = Stack;
  }
});

// ../node_modules/lodash-es/_arrayFilter.js
function arrayFilter(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result2[resIndex++] = value;
    }
  }
  return result2;
}
var arrayFilter_default;
var init_arrayFilter = __esm({
  "../node_modules/lodash-es/_arrayFilter.js"() {
    arrayFilter_default = arrayFilter;
  }
});

// ../node_modules/lodash-es/stubArray.js
function stubArray() {
  return [];
}
var stubArray_default;
var init_stubArray = __esm({
  "../node_modules/lodash-es/stubArray.js"() {
    stubArray_default = stubArray;
  }
});

// ../node_modules/lodash-es/_getSymbols.js
var objectProto12, propertyIsEnumerable2, nativeGetSymbols, getSymbols, getSymbols_default;
var init_getSymbols = __esm({
  "../node_modules/lodash-es/_getSymbols.js"() {
    init_arrayFilter();
    init_stubArray();
    objectProto12 = Object.prototype;
    propertyIsEnumerable2 = objectProto12.propertyIsEnumerable;
    nativeGetSymbols = Object.getOwnPropertySymbols;
    getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter_default(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable2.call(object, symbol);
      });
    };
    getSymbols_default = getSymbols;
  }
});

// ../node_modules/lodash-es/_baseGetAllKeys.js
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object);
  return isArray_default(object) ? result2 : arrayPush_default(result2, symbolsFunc(object));
}
var baseGetAllKeys_default;
var init_baseGetAllKeys = __esm({
  "../node_modules/lodash-es/_baseGetAllKeys.js"() {
    init_arrayPush();
    init_isArray();
    baseGetAllKeys_default = baseGetAllKeys;
  }
});

// ../node_modules/lodash-es/_getAllKeys.js
function getAllKeys(object) {
  return baseGetAllKeys_default(object, keys_default, getSymbols_default);
}
var getAllKeys_default;
var init_getAllKeys = __esm({
  "../node_modules/lodash-es/_getAllKeys.js"() {
    init_baseGetAllKeys();
    init_getSymbols();
    init_keys();
    getAllKeys_default = getAllKeys;
  }
});

// ../node_modules/lodash-es/_DataView.js
var DataView, DataView_default;
var init_DataView = __esm({
  "../node_modules/lodash-es/_DataView.js"() {
    init_getNative();
    init_root();
    DataView = getNative_default(root_default, "DataView");
    DataView_default = DataView;
  }
});

// ../node_modules/lodash-es/_Promise.js
var Promise2, Promise_default;
var init_Promise = __esm({
  "../node_modules/lodash-es/_Promise.js"() {
    init_getNative();
    init_root();
    Promise2 = getNative_default(root_default, "Promise");
    Promise_default = Promise2;
  }
});

// ../node_modules/lodash-es/_Set.js
var Set2, Set_default;
var init_Set = __esm({
  "../node_modules/lodash-es/_Set.js"() {
    init_getNative();
    init_root();
    Set2 = getNative_default(root_default, "Set");
    Set_default = Set2;
  }
});

// ../node_modules/lodash-es/_getTag.js
var mapTag2, objectTag3, promiseTag, setTag2, weakMapTag2, dataViewTag2, dataViewCtorString, mapCtorString, promiseCtorString, setCtorString, weakMapCtorString, getTag, getTag_default;
var init_getTag = __esm({
  "../node_modules/lodash-es/_getTag.js"() {
    init_DataView();
    init_Map();
    init_Promise();
    init_Set();
    init_WeakMap();
    init_baseGetTag();
    init_toSource();
    mapTag2 = "[object Map]";
    objectTag3 = "[object Object]";
    promiseTag = "[object Promise]";
    setTag2 = "[object Set]";
    weakMapTag2 = "[object WeakMap]";
    dataViewTag2 = "[object DataView]";
    dataViewCtorString = toSource_default(DataView_default);
    mapCtorString = toSource_default(Map_default);
    promiseCtorString = toSource_default(Promise_default);
    setCtorString = toSource_default(Set_default);
    weakMapCtorString = toSource_default(WeakMap_default);
    getTag = baseGetTag_default;
    if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
      getTag = function(value) {
        var result2 = baseGetTag_default(value), Ctor = result2 == objectTag3 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag2;
            case mapCtorString:
              return mapTag2;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag2;
            case weakMapCtorString:
              return weakMapTag2;
          }
        }
        return result2;
      };
    }
    getTag_default = getTag;
  }
});

// ../node_modules/lodash-es/_Uint8Array.js
var Uint8Array2, Uint8Array_default;
var init_Uint8Array = __esm({
  "../node_modules/lodash-es/_Uint8Array.js"() {
    init_root();
    Uint8Array2 = root_default.Uint8Array;
    Uint8Array_default = Uint8Array2;
  }
});

// ../node_modules/lodash-es/_setCacheAdd.js
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED3);
  return this;
}
var HASH_UNDEFINED3, setCacheAdd_default;
var init_setCacheAdd = __esm({
  "../node_modules/lodash-es/_setCacheAdd.js"() {
    HASH_UNDEFINED3 = "__lodash_hash_undefined__";
    setCacheAdd_default = setCacheAdd;
  }
});

// ../node_modules/lodash-es/_setCacheHas.js
function setCacheHas(value) {
  return this.__data__.has(value);
}
var setCacheHas_default;
var init_setCacheHas = __esm({
  "../node_modules/lodash-es/_setCacheHas.js"() {
    setCacheHas_default = setCacheHas;
  }
});

// ../node_modules/lodash-es/_SetCache.js
function SetCache(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache_default();
  while (++index < length) {
    this.add(values[index]);
  }
}
var SetCache_default;
var init_SetCache = __esm({
  "../node_modules/lodash-es/_SetCache.js"() {
    init_MapCache();
    init_setCacheAdd();
    init_setCacheHas();
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
    SetCache.prototype.has = setCacheHas_default;
    SetCache_default = SetCache;
  }
});

// ../node_modules/lodash-es/_arraySome.js
function arraySome(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var arraySome_default;
var init_arraySome = __esm({
  "../node_modules/lodash-es/_arraySome.js"() {
    arraySome_default = arraySome;
  }
});

// ../node_modules/lodash-es/_cacheHas.js
function cacheHas(cache3, key) {
  return cache3.has(key);
}
var cacheHas_default;
var init_cacheHas = __esm({
  "../node_modules/lodash-es/_cacheHas.js"() {
    cacheHas_default = cacheHas;
  }
});

// ../node_modules/lodash-es/_equalArrays.js
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result2 = false;
      break;
    }
    if (seen) {
      if (!arraySome_default(other, function(othValue2, othIndex) {
        if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result2 = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result2 = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result2;
}
var COMPARE_PARTIAL_FLAG, COMPARE_UNORDERED_FLAG, equalArrays_default;
var init_equalArrays = __esm({
  "../node_modules/lodash-es/_equalArrays.js"() {
    init_SetCache();
    init_arraySome();
    init_cacheHas();
    COMPARE_PARTIAL_FLAG = 1;
    COMPARE_UNORDERED_FLAG = 2;
    equalArrays_default = equalArrays;
  }
});

// ../node_modules/lodash-es/_mapToArray.js
function mapToArray(map) {
  var index = -1, result2 = Array(map.size);
  map.forEach(function(value, key) {
    result2[++index] = [key, value];
  });
  return result2;
}
var mapToArray_default;
var init_mapToArray = __esm({
  "../node_modules/lodash-es/_mapToArray.js"() {
    mapToArray_default = mapToArray;
  }
});

// ../node_modules/lodash-es/_setToArray.js
function setToArray(set2) {
  var index = -1, result2 = Array(set2.size);
  set2.forEach(function(value) {
    result2[++index] = value;
  });
  return result2;
}
var setToArray_default;
var init_setToArray = __esm({
  "../node_modules/lodash-es/_setToArray.js"() {
    setToArray_default = setToArray;
  }
});

// ../node_modules/lodash-es/_equalByTag.js
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag3:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag2:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object), new Uint8Array_default(other))) {
        return false;
      }
      return true;
    case boolTag2:
    case dateTag2:
    case numberTag2:
      return eq_default(+object, +other);
    case errorTag2:
      return object.name == other.name && object.message == other.message;
    case regexpTag2:
    case stringTag2:
      return object == other + "";
    case mapTag3:
      var convert = mapToArray_default;
    case setTag3:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
      convert || (convert = setToArray_default);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG2;
      stack.set(object, other);
      var result2 = equalArrays_default(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result2;
    case symbolTag2:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG2, COMPARE_UNORDERED_FLAG2, boolTag2, dateTag2, errorTag2, mapTag3, numberTag2, regexpTag2, setTag3, stringTag2, symbolTag2, arrayBufferTag2, dataViewTag3, symbolProto2, symbolValueOf, equalByTag_default;
var init_equalByTag = __esm({
  "../node_modules/lodash-es/_equalByTag.js"() {
    init_Symbol();
    init_Uint8Array();
    init_eq();
    init_equalArrays();
    init_mapToArray();
    init_setToArray();
    COMPARE_PARTIAL_FLAG2 = 1;
    COMPARE_UNORDERED_FLAG2 = 2;
    boolTag2 = "[object Boolean]";
    dateTag2 = "[object Date]";
    errorTag2 = "[object Error]";
    mapTag3 = "[object Map]";
    numberTag2 = "[object Number]";
    regexpTag2 = "[object RegExp]";
    setTag3 = "[object Set]";
    stringTag2 = "[object String]";
    symbolTag2 = "[object Symbol]";
    arrayBufferTag2 = "[object ArrayBuffer]";
    dataViewTag3 = "[object DataView]";
    symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
    symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
    equalByTag_default = equalByTag;
  }
});

// ../node_modules/lodash-es/_equalObjects.js
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty10.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result2 = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result2 = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result2 = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result2;
}
var COMPARE_PARTIAL_FLAG3, objectProto13, hasOwnProperty10, equalObjects_default;
var init_equalObjects = __esm({
  "../node_modules/lodash-es/_equalObjects.js"() {
    init_getAllKeys();
    COMPARE_PARTIAL_FLAG3 = 1;
    objectProto13 = Object.prototype;
    hasOwnProperty10 = objectProto13.hasOwnProperty;
    equalObjects_default = equalObjects;
  }
});

// ../node_modules/lodash-es/_baseIsEqualDeep.js
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_default(object), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag2 : getTag_default(object), othTag = othIsArr ? arrayTag2 : getTag_default(other);
  objTag = objTag == argsTag3 ? objectTag4 : objTag;
  othTag = othTag == argsTag3 ? objectTag4 : othTag;
  var objIsObj = objTag == objectTag4, othIsObj = othTag == objectTag4, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer_default(object)) {
    if (!isBuffer_default(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack_default());
    return objIsArr || isTypedArray_default(object) ? equalArrays_default(object, other, bitmask, customizer, equalFunc, stack) : equalByTag_default(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
    var objIsWrapped = objIsObj && hasOwnProperty11.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty11.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack_default());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack_default());
  return equalObjects_default(object, other, bitmask, customizer, equalFunc, stack);
}
var COMPARE_PARTIAL_FLAG4, argsTag3, arrayTag2, objectTag4, objectProto14, hasOwnProperty11, baseIsEqualDeep_default;
var init_baseIsEqualDeep = __esm({
  "../node_modules/lodash-es/_baseIsEqualDeep.js"() {
    init_Stack();
    init_equalArrays();
    init_equalByTag();
    init_equalObjects();
    init_getTag();
    init_isArray();
    init_isBuffer();
    init_isTypedArray();
    COMPARE_PARTIAL_FLAG4 = 1;
    argsTag3 = "[object Arguments]";
    arrayTag2 = "[object Array]";
    objectTag4 = "[object Object]";
    objectProto14 = Object.prototype;
    hasOwnProperty11 = objectProto14.hasOwnProperty;
    baseIsEqualDeep_default = baseIsEqualDeep;
  }
});

// ../node_modules/lodash-es/_baseIsEqual.js
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep_default(value, other, bitmask, customizer, baseIsEqual, stack);
}
var baseIsEqual_default;
var init_baseIsEqual = __esm({
  "../node_modules/lodash-es/_baseIsEqual.js"() {
    init_baseIsEqualDeep();
    init_isObjectLike();
    baseIsEqual_default = baseIsEqual;
  }
});

// ../node_modules/lodash-es/_baseIsMatch.js
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length, length = index, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack_default();
      if (customizer) {
        var result2 = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result2 === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer, stack) : result2)) {
        return false;
      }
    }
  }
  return true;
}
var COMPARE_PARTIAL_FLAG5, COMPARE_UNORDERED_FLAG3, baseIsMatch_default;
var init_baseIsMatch = __esm({
  "../node_modules/lodash-es/_baseIsMatch.js"() {
    init_Stack();
    init_baseIsEqual();
    COMPARE_PARTIAL_FLAG5 = 1;
    COMPARE_UNORDERED_FLAG3 = 2;
    baseIsMatch_default = baseIsMatch;
  }
});

// ../node_modules/lodash-es/_isStrictComparable.js
function isStrictComparable(value) {
  return value === value && !isObject_default(value);
}
var isStrictComparable_default;
var init_isStrictComparable = __esm({
  "../node_modules/lodash-es/_isStrictComparable.js"() {
    init_isObject();
    isStrictComparable_default = isStrictComparable;
  }
});

// ../node_modules/lodash-es/_getMatchData.js
function getMatchData(object) {
  var result2 = keys_default(object), length = result2.length;
  while (length--) {
    var key = result2[length], value = object[key];
    result2[length] = [key, value, isStrictComparable_default(value)];
  }
  return result2;
}
var getMatchData_default;
var init_getMatchData = __esm({
  "../node_modules/lodash-es/_getMatchData.js"() {
    init_isStrictComparable();
    init_keys();
    getMatchData_default = getMatchData;
  }
});

// ../node_modules/lodash-es/_matchesStrictComparable.js
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var matchesStrictComparable_default;
var init_matchesStrictComparable = __esm({
  "../node_modules/lodash-es/_matchesStrictComparable.js"() {
    matchesStrictComparable_default = matchesStrictComparable;
  }
});

// ../node_modules/lodash-es/_baseMatches.js
function baseMatches(source) {
  var matchData = getMatchData_default(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch_default(object, source, matchData);
  };
}
var baseMatches_default;
var init_baseMatches = __esm({
  "../node_modules/lodash-es/_baseMatches.js"() {
    init_baseIsMatch();
    init_getMatchData();
    init_matchesStrictComparable();
    baseMatches_default = baseMatches;
  }
});

// ../node_modules/lodash-es/_baseHasIn.js
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}
var baseHasIn_default;
var init_baseHasIn = __esm({
  "../node_modules/lodash-es/_baseHasIn.js"() {
    baseHasIn_default = baseHasIn;
  }
});

// ../node_modules/lodash-es/_hasPath.js
function hasPath(object, path, hasFunc) {
  path = castPath_default(path, object);
  var index = -1, length = path.length, result2 = false;
  while (++index < length) {
    var key = toKey_default(path[index]);
    if (!(result2 = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result2 || ++index != length) {
    return result2;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_default(length) && isIndex_default(key, length) && (isArray_default(object) || isArguments_default(object));
}
var hasPath_default;
var init_hasPath = __esm({
  "../node_modules/lodash-es/_hasPath.js"() {
    init_castPath();
    init_isArguments();
    init_isArray();
    init_isIndex();
    init_isLength();
    init_toKey();
    hasPath_default = hasPath;
  }
});

// ../node_modules/lodash-es/hasIn.js
function hasIn(object, path) {
  return object != null && hasPath_default(object, path, baseHasIn_default);
}
var hasIn_default;
var init_hasIn = __esm({
  "../node_modules/lodash-es/hasIn.js"() {
    init_baseHasIn();
    init_hasPath();
    hasIn_default = hasIn;
  }
});

// ../node_modules/lodash-es/_baseMatchesProperty.js
function baseMatchesProperty(path, srcValue) {
  if (isKey_default(path) && isStrictComparable_default(srcValue)) {
    return matchesStrictComparable_default(toKey_default(path), srcValue);
  }
  return function(object) {
    var objValue = get_default(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn_default(object, path) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
  };
}
var COMPARE_PARTIAL_FLAG6, COMPARE_UNORDERED_FLAG4, baseMatchesProperty_default;
var init_baseMatchesProperty = __esm({
  "../node_modules/lodash-es/_baseMatchesProperty.js"() {
    init_baseIsEqual();
    init_get();
    init_hasIn();
    init_isKey();
    init_isStrictComparable();
    init_matchesStrictComparable();
    init_toKey();
    COMPARE_PARTIAL_FLAG6 = 1;
    COMPARE_UNORDERED_FLAG4 = 2;
    baseMatchesProperty_default = baseMatchesProperty;
  }
});

// ../node_modules/lodash-es/_baseProperty.js
function baseProperty(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var baseProperty_default;
var init_baseProperty = __esm({
  "../node_modules/lodash-es/_baseProperty.js"() {
    baseProperty_default = baseProperty;
  }
});

// ../node_modules/lodash-es/_basePropertyDeep.js
function basePropertyDeep(path) {
  return function(object) {
    return baseGet_default(object, path);
  };
}
var basePropertyDeep_default;
var init_basePropertyDeep = __esm({
  "../node_modules/lodash-es/_basePropertyDeep.js"() {
    init_baseGet();
    basePropertyDeep_default = basePropertyDeep;
  }
});

// ../node_modules/lodash-es/property.js
function property(path) {
  return isKey_default(path) ? baseProperty_default(toKey_default(path)) : basePropertyDeep_default(path);
}
var property_default;
var init_property = __esm({
  "../node_modules/lodash-es/property.js"() {
    init_baseProperty();
    init_basePropertyDeep();
    init_isKey();
    init_toKey();
    property_default = property;
  }
});

// ../node_modules/lodash-es/_baseIteratee.js
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity_default;
  }
  if (typeof value == "object") {
    return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
  }
  return property_default(value);
}
var baseIteratee_default;
var init_baseIteratee = __esm({
  "../node_modules/lodash-es/_baseIteratee.js"() {
    init_baseMatches();
    init_baseMatchesProperty();
    init_identity();
    init_isArray();
    init_property();
    baseIteratee_default = baseIteratee;
  }
});

// ../node_modules/lodash-es/_arrayAggregator.js
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}
var arrayAggregator_default;
var init_arrayAggregator = __esm({
  "../node_modules/lodash-es/_arrayAggregator.js"() {
    arrayAggregator_default = arrayAggregator;
  }
});

// ../node_modules/lodash-es/_createBaseFor.js
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var createBaseFor_default;
var init_createBaseFor = __esm({
  "../node_modules/lodash-es/_createBaseFor.js"() {
    createBaseFor_default = createBaseFor;
  }
});

// ../node_modules/lodash-es/_baseFor.js
var baseFor, baseFor_default;
var init_baseFor = __esm({
  "../node_modules/lodash-es/_baseFor.js"() {
    init_createBaseFor();
    baseFor = createBaseFor_default();
    baseFor_default = baseFor;
  }
});

// ../node_modules/lodash-es/_baseForOwn.js
function baseForOwn(object, iteratee) {
  return object && baseFor_default(object, iteratee, keys_default);
}
var baseForOwn_default;
var init_baseForOwn = __esm({
  "../node_modules/lodash-es/_baseForOwn.js"() {
    init_baseFor();
    init_keys();
    baseForOwn_default = baseForOwn;
  }
});

// ../node_modules/lodash-es/_createBaseEach.js
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_default(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var createBaseEach_default;
var init_createBaseEach = __esm({
  "../node_modules/lodash-es/_createBaseEach.js"() {
    init_isArrayLike();
    createBaseEach_default = createBaseEach;
  }
});

// ../node_modules/lodash-es/_baseEach.js
var baseEach, baseEach_default;
var init_baseEach = __esm({
  "../node_modules/lodash-es/_baseEach.js"() {
    init_baseForOwn();
    init_createBaseEach();
    baseEach = createBaseEach_default(baseForOwn_default);
    baseEach_default = baseEach;
  }
});

// ../node_modules/lodash-es/_baseAggregator.js
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach_default(collection, function(value, key, collection2) {
    setter(accumulator, value, iteratee(value), collection2);
  });
  return accumulator;
}
var baseAggregator_default;
var init_baseAggregator = __esm({
  "../node_modules/lodash-es/_baseAggregator.js"() {
    init_baseEach();
    baseAggregator_default = baseAggregator;
  }
});

// ../node_modules/lodash-es/_createAggregator.js
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray_default(collection) ? arrayAggregator_default : baseAggregator_default, accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee_default(iteratee, 2), accumulator);
  };
}
var createAggregator_default;
var init_createAggregator = __esm({
  "../node_modules/lodash-es/_createAggregator.js"() {
    init_arrayAggregator();
    init_baseAggregator();
    init_baseIteratee();
    init_isArray();
    createAggregator_default = createAggregator;
  }
});

// ../node_modules/lodash-es/now.js
var now, now_default;
var init_now = __esm({
  "../node_modules/lodash-es/now.js"() {
    init_root();
    now = function() {
      return root_default.Date.now();
    };
    now_default = now;
  }
});

// ../node_modules/lodash-es/debounce.js
function debounce(func, wait2, options2) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT2);
  }
  wait2 = toNumber_default(wait2) || 0;
  if (isObject_default(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax2(toNumber_default(options2.maxWait) || 0, wait2) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result2 = func.apply(thisArg, args);
    return result2;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait2);
    return leading ? invokeFunc(time) : result2;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait2 - timeSinceLastCall;
    return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait2 || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_default();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result2;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now_default());
  }
  function debounced() {
    var time = now_default(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait2);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait2);
    }
    return result2;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var FUNC_ERROR_TEXT2, nativeMax2, nativeMin2, debounce_default;
var init_debounce = __esm({
  "../node_modules/lodash-es/debounce.js"() {
    init_isObject();
    init_now();
    init_toNumber();
    FUNC_ERROR_TEXT2 = "Expected a function";
    nativeMax2 = Math.max;
    nativeMin2 = Math.min;
    debounce_default = debounce;
  }
});

// ../node_modules/lodash-es/_arrayIncludesWith.js
function arrayIncludesWith(array, value, comparator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var arrayIncludesWith_default;
var init_arrayIncludesWith = __esm({
  "../node_modules/lodash-es/_arrayIncludesWith.js"() {
    arrayIncludesWith_default = arrayIncludesWith;
  }
});

// ../node_modules/lodash-es/findIndex.js
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
  if (index < 0) {
    index = nativeMax3(length + index, 0);
  }
  return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index);
}
var nativeMax3, findIndex_default;
var init_findIndex = __esm({
  "../node_modules/lodash-es/findIndex.js"() {
    init_baseFindIndex();
    init_baseIteratee();
    init_toInteger();
    nativeMax3 = Math.max;
    findIndex_default = findIndex;
  }
});

// ../node_modules/lodash-es/findLastIndex.js
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== void 0) {
    index = toInteger_default(fromIndex);
    index = fromIndex < 0 ? nativeMax4(length + index, 0) : nativeMin3(index, length - 1);
  }
  return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index, true);
}
var nativeMax4, nativeMin3, findLastIndex_default;
var init_findLastIndex = __esm({
  "../node_modules/lodash-es/findLastIndex.js"() {
    init_baseFindIndex();
    init_baseIteratee();
    init_toInteger();
    nativeMax4 = Math.max;
    nativeMin3 = Math.min;
    findLastIndex_default = findLastIndex;
  }
});

// ../node_modules/lodash-es/_baseMap.js
function baseMap(collection, iteratee) {
  var index = -1, result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
  baseEach_default(collection, function(value, key, collection2) {
    result2[++index] = iteratee(value, key, collection2);
  });
  return result2;
}
var baseMap_default;
var init_baseMap = __esm({
  "../node_modules/lodash-es/_baseMap.js"() {
    init_baseEach();
    init_isArrayLike();
    baseMap_default = baseMap;
  }
});

// ../node_modules/lodash-es/_baseInRange.js
function baseInRange(number, start, end) {
  return number >= nativeMin4(start, end) && number < nativeMax5(start, end);
}
var nativeMax5, nativeMin4, baseInRange_default;
var init_baseInRange = __esm({
  "../node_modules/lodash-es/_baseInRange.js"() {
    nativeMax5 = Math.max;
    nativeMin4 = Math.min;
    baseInRange_default = baseInRange;
  }
});

// ../node_modules/lodash-es/inRange.js
function inRange(number, start, end) {
  start = toFinite_default(start);
  if (end === void 0) {
    end = start;
    start = 0;
  } else {
    end = toFinite_default(end);
  }
  number = toNumber_default(number);
  return baseInRange_default(number, start, end);
}
var inRange_default;
var init_inRange = __esm({
  "../node_modules/lodash-es/inRange.js"() {
    init_baseInRange();
    init_toFinite();
    init_toNumber();
    inRange_default = inRange;
  }
});

// ../node_modules/lodash-es/isInteger.js
function isInteger(value) {
  return typeof value == "number" && value == toInteger_default(value);
}
var isInteger_default;
var init_isInteger = __esm({
  "../node_modules/lodash-es/isInteger.js"() {
    init_toInteger();
    isInteger_default = isInteger;
  }
});

// ../node_modules/lodash-es/keyBy.js
var keyBy, keyBy_default;
var init_keyBy = __esm({
  "../node_modules/lodash-es/keyBy.js"() {
    init_baseAssignValue();
    init_createAggregator();
    keyBy = createAggregator_default(function(result2, value, key) {
      baseAssignValue_default(result2, key, value);
    });
    keyBy_default = keyBy;
  }
});

// ../node_modules/lodash-es/mapValues.js
function mapValues(object, iteratee) {
  var result2 = {};
  iteratee = baseIteratee_default(iteratee, 3);
  baseForOwn_default(object, function(value, key, object2) {
    baseAssignValue_default(result2, key, iteratee(value, key, object2));
  });
  return result2;
}
var mapValues_default;
var init_mapValues = __esm({
  "../node_modules/lodash-es/mapValues.js"() {
    init_baseAssignValue();
    init_baseForOwn();
    init_baseIteratee();
    mapValues_default = mapValues;
  }
});

// ../node_modules/lodash-es/_baseSet.js
function baseSet(object, path, value, customizer) {
  if (!isObject_default(object)) {
    return object;
  }
  path = castPath_default(path, object);
  var index = -1, length = path.length, lastIndex = length - 1, nested = object;
  while (nested != null && ++index < length) {
    var key = toKey_default(path[index]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject_default(objValue) ? objValue : isIndex_default(path[index + 1]) ? [] : {};
      }
    }
    assignValue_default(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
var baseSet_default;
var init_baseSet = __esm({
  "../node_modules/lodash-es/_baseSet.js"() {
    init_assignValue();
    init_castPath();
    init_isIndex();
    init_isObject();
    init_toKey();
    baseSet_default = baseSet;
  }
});

// ../node_modules/lodash-es/_baseSortBy.js
function baseSortBy(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var baseSortBy_default;
var init_baseSortBy = __esm({
  "../node_modules/lodash-es/_baseSortBy.js"() {
    baseSortBy_default = baseSortBy;
  }
});

// ../node_modules/lodash-es/_compareAscending.js
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol_default(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol_default(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var compareAscending_default;
var init_compareAscending = __esm({
  "../node_modules/lodash-es/_compareAscending.js"() {
    init_isSymbol();
    compareAscending_default = compareAscending;
  }
});

// ../node_modules/lodash-es/_compareMultiple.js
function compareMultiple(object, other, orders) {
  var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
  while (++index < length) {
    var result2 = compareAscending_default(objCriteria[index], othCriteria[index]);
    if (result2) {
      if (index >= ordersLength) {
        return result2;
      }
      var order = orders[index];
      return result2 * (order == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
var compareMultiple_default;
var init_compareMultiple = __esm({
  "../node_modules/lodash-es/_compareMultiple.js"() {
    init_compareAscending();
    compareMultiple_default = compareMultiple;
  }
});

// ../node_modules/lodash-es/_baseOrderBy.js
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap_default(iteratees, function(iteratee) {
      if (isArray_default(iteratee)) {
        return function(value) {
          return baseGet_default(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity_default];
  }
  var index = -1;
  iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
  var result2 = baseMap_default(collection, function(value, key, collection2) {
    var criteria = arrayMap_default(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index, "value": value };
  });
  return baseSortBy_default(result2, function(object, other) {
    return compareMultiple_default(object, other, orders);
  });
}
var baseOrderBy_default;
var init_baseOrderBy = __esm({
  "../node_modules/lodash-es/_baseOrderBy.js"() {
    init_arrayMap();
    init_baseGet();
    init_baseIteratee();
    init_baseMap();
    init_baseSortBy();
    init_baseUnary();
    init_compareMultiple();
    init_identity();
    init_isArray();
    baseOrderBy_default = baseOrderBy;
  }
});

// ../node_modules/lodash-es/_baseIndexOfWith.js
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}
var baseIndexOfWith_default;
var init_baseIndexOfWith = __esm({
  "../node_modules/lodash-es/_baseIndexOfWith.js"() {
    baseIndexOfWith_default = baseIndexOfWith;
  }
});

// ../node_modules/lodash-es/_basePullAll.js
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith_default : baseIndexOf_default, index = -1, length = values.length, seen = array;
  if (array === values) {
    values = copyArray_default(values);
  }
  if (iteratee) {
    seen = arrayMap_default(array, baseUnary_default(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice2.call(seen, fromIndex, 1);
      }
      splice2.call(array, fromIndex, 1);
    }
  }
  return array;
}
var arrayProto2, splice2, basePullAll_default;
var init_basePullAll = __esm({
  "../node_modules/lodash-es/_basePullAll.js"() {
    init_arrayMap();
    init_baseIndexOf();
    init_baseIndexOfWith();
    init_baseUnary();
    init_copyArray();
    arrayProto2 = Array.prototype;
    splice2 = arrayProto2.splice;
    basePullAll_default = basePullAll;
  }
});

// ../node_modules/lodash-es/pullAll.js
function pullAll(array, values) {
  return array && array.length && values && values.length ? basePullAll_default(array, values) : array;
}
var pullAll_default;
var init_pullAll = __esm({
  "../node_modules/lodash-es/pullAll.js"() {
    init_basePullAll();
    pullAll_default = pullAll;
  }
});

// ../node_modules/lodash-es/pull.js
var pull, pull_default;
var init_pull = __esm({
  "../node_modules/lodash-es/pull.js"() {
    init_baseRest();
    init_pullAll();
    pull = baseRest_default(pullAll_default);
    pull_default = pull;
  }
});

// ../node_modules/lodash-es/round.js
var round, round_default;
var init_round = __esm({
  "../node_modules/lodash-es/round.js"() {
    init_createRound();
    round = createRound_default("round");
    round_default = round;
  }
});

// ../node_modules/lodash-es/set.js
function set(object, path, value) {
  return object == null ? object : baseSet_default(object, path, value);
}
var set_default;
var init_set = __esm({
  "../node_modules/lodash-es/set.js"() {
    init_baseSet();
    set_default = set;
  }
});

// ../node_modules/lodash-es/sortBy.js
var sortBy, sortBy_default;
var init_sortBy = __esm({
  "../node_modules/lodash-es/sortBy.js"() {
    init_baseFlatten();
    init_baseOrderBy();
    init_baseRest();
    init_isIterateeCall();
    sortBy = baseRest_default(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall_default(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall_default(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy_default(collection, baseFlatten_default(iteratees, 1), []);
    });
    sortBy_default = sortBy;
  }
});

// ../node_modules/lodash-es/_createSet.js
var INFINITY4, createSet, createSet_default;
var init_createSet = __esm({
  "../node_modules/lodash-es/_createSet.js"() {
    init_Set();
    init_noop();
    init_setToArray();
    INFINITY4 = 1 / 0;
    createSet = !(Set_default && 1 / setToArray_default(new Set_default([, -0]))[1] == INFINITY4) ? noop_default : function(values) {
      return new Set_default(values);
    };
    createSet_default = createSet;
  }
});

// ../node_modules/lodash-es/_baseUniq.js
function baseUniq(array, iteratee, comparator) {
  var index = -1, includes = arrayIncludes_default, length = array.length, isCommon = true, result2 = [], seen = result2;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith_default;
  } else if (length >= LARGE_ARRAY_SIZE2) {
    var set2 = iteratee ? null : createSet_default(array);
    if (set2) {
      return setToArray_default(set2);
    }
    isCommon = false;
    includes = cacheHas_default;
    seen = new SetCache_default();
  } else {
    seen = iteratee ? [] : result2;
  }
  outer:
    while (++index < length) {
      var value = array[index], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result2.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result2) {
          seen.push(computed);
        }
        result2.push(value);
      }
    }
  return result2;
}
var LARGE_ARRAY_SIZE2, baseUniq_default;
var init_baseUniq = __esm({
  "../node_modules/lodash-es/_baseUniq.js"() {
    init_SetCache();
    init_arrayIncludes();
    init_arrayIncludesWith();
    init_cacheHas();
    init_createSet();
    init_setToArray();
    LARGE_ARRAY_SIZE2 = 200;
    baseUniq_default = baseUniq;
  }
});

// ../node_modules/lodash-es/uniq.js
function uniq(array) {
  return array && array.length ? baseUniq_default(array) : [];
}
var uniq_default;
var init_uniq = __esm({
  "../node_modules/lodash-es/uniq.js"() {
    init_baseUniq();
    uniq_default = uniq;
  }
});

// ../node_modules/lodash-es/lodash.js
var init_lodash = __esm({
  "../node_modules/lodash-es/lodash.js"() {
    init_clamp();
    init_debounce();
    init_findIndex();
    init_inRange();
    init_isInteger();
    init_isPlainObject();
    init_last();
    init_mapValues();
    init_memoize();
    init_round();
    init_uniq();
  }
});

// shared/src/utils/stableJsonStringify.ts
function stableValueHash(value) {
  return JSON.stringify(deepSortValue(value));
}
function deepSortValue(val59) {
  return isPlainObject_default(val59) ? Object.keys(val59).sort().reduce((result2, key) => {
    result2[key] = deepSortValue(val59[key]);
    return result2;
  }, {}) : Array.isArray(val59) ? val59.map(deepSortValue) : val59;
}
var init_stableJsonStringify = __esm({
  "shared/src/utils/stableJsonStringify.ts"() {
    init_lodash();
  }
});

// ../node_modules/nanoid/non-secure/index.js
var urlAlphabet, nanoid;
var init_non_secure = __esm({
  "../node_modules/nanoid/non-secure/index.js"() {
    urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
    nanoid = (size = 21) => {
      let id = "";
      let i3 = size;
      while (i3--) {
        id += urlAlphabet[Math.random() * 64 | 0];
      }
      return id;
    };
  }
});

// shared/src/utils/ids.ts
function generateKeyframeId() {
  return nanoid(10);
}
function generateSequenceTrackId() {
  return nanoid(10);
}
function generateSequenceMarkerId() {
  return nanoid(10);
}
var createStudioSheetItemKey;
var init_ids = __esm({
  "shared/src/utils/ids.ts"() {
    init_stableJsonStringify();
    init_non_secure();
    createStudioSheetItemKey = {
      forSheet() {
        return "sheet";
      },
      forSheetObject(obj) {
        return stableValueHash({
          o: obj.address.objectKey
        });
      },
      forSheetObjectProp(obj, pathToProp) {
        return stableValueHash({
          o: obj.address.objectKey,
          p: pathToProp
        });
      },
      forTrackKeyframe(obj, trackId, keyframeId) {
        return stableValueHash({
          o: obj.address.objectKey,
          t: trackId,
          k: keyframeId
        });
      },
      forSheetObjectAggregateKeyframe(obj, position2) {
        return createStudioSheetItemKey.forCompoundPropAggregateKeyframe(obj, [], position2);
      },
      forSheetAggregateKeyframe(obj, position2) {
        return stableValueHash({
          o: obj.address.sheetId,
          pos: position2
        });
      },
      forCompoundPropAggregateKeyframe(obj, pathToProp, position2) {
        return stableValueHash({
          o: obj.address.objectKey,
          p: pathToProp,
          pos: position2
        });
      }
    };
  }
});

// shared/src/utils/getDeep.ts
function getDeep(v5, path) {
  if (path.length === 0)
    return v5;
  return get_default(v5, path);
}
var init_getDeep = __esm({
  "shared/src/utils/getDeep.ts"() {
    init_get();
  }
});

// ../node_modules/queue-microtask/index.js
var require_queue_microtask = __commonJS({
  "../node_modules/queue-microtask/index.js"(exports2, module2) {
    var promise;
    module2.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : global) : (cb) => (promise || (promise = Promise.resolve())).then(cb).catch((err) => setTimeout(() => {
      throw err;
    }, 0));
  }
});

// ../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../node_modules/object-assign/index.js"(exports2, module2) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty12 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val59) {
      if (val59 === null || val59 === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val59);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i3 = 0; i3 < 10; i3++) {
          test2["_" + String.fromCharCode(i3)] = i3;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n3) {
          return test2[n3];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s3 = 1; s3 < arguments.length; s3++) {
        from = Object(arguments[s3]);
        for (var key in from) {
          if (hasOwnProperty12.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i3 = 0; i3 < symbols.length; i3++) {
            if (propIsEnumerable.call(from, symbols[i3])) {
              to[symbols[i3]] = from[symbols[i3]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../node_modules/react/cjs/react.development.js
var require_react_development = __commonJS({
  "../node_modules/react/cjs/react.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var _assign = require_object_assign();
        var ReactVersion = "17.0.2";
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports2.Fragment = 60107;
        exports2.StrictMode = 60108;
        exports2.Profiler = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        exports2.Suspense = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_OPAQUE_ID_TYPE = 60128;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          exports2.Fragment = symbolFor("react.fragment");
          exports2.StrictMode = symbolFor("react.strict_mode");
          exports2.Profiler = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          exports2.Suspense = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          REACT_SCOPE_TYPE = symbolFor("react.scope");
          REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactCurrentDispatcher = {
          current: null
        };
        var ReactCurrentBatchConfig = {
          transition: 0
        };
        var ReactCurrentOwner = {
          current: null
        };
        var ReactDebugCurrentFrame = {};
        var currentExtraStackFrame = null;
        function setExtraStackFrame(stack) {
          {
            currentExtraStackFrame = stack;
          }
        }
        {
          ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
            {
              currentExtraStackFrame = stack;
            }
          };
          ReactDebugCurrentFrame.getCurrentStack = null;
          ReactDebugCurrentFrame.getStackAddendum = function() {
            var stack = "";
            if (currentExtraStackFrame) {
              stack += currentExtraStackFrame;
            }
            var impl = ReactDebugCurrentFrame.getCurrentStack;
            if (impl) {
              stack += impl() || "";
            }
            return stack;
          };
        }
        var IsSomeRendererActing = {
          current: false
        };
        var ReactSharedInternals = {
          ReactCurrentDispatcher,
          ReactCurrentBatchConfig,
          ReactCurrentOwner,
          IsSomeRendererActing,
          assign: _assign
        };
        {
          ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
        }
        function warn(format4) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format4, args);
          }
        }
        function error(format4) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format4, args);
          }
        }
        function printWarning(level, format4, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack !== "") {
              format4 += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format4);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var didWarnStateUpdateForUnmountedComponent = {};
        function warnNoop(publicInstance, callerName) {
          {
            var _constructor = publicInstance.constructor;
            var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
            var warningKey = componentName + "." + callerName;
            if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
              return;
            }
            error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
            didWarnStateUpdateForUnmountedComponent[warningKey] = true;
          }
        }
        var ReactNoopUpdateQueue = {
          isMounted: function(publicInstance) {
            return false;
          },
          enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
          },
          enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
          },
          enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
          }
        };
        var emptyObject2 = {};
        {
          Object.freeze(emptyObject2);
        }
        function Component(props, context3, updater) {
          this.props = props;
          this.context = context3;
          this.refs = emptyObject2;
          this.updater = updater || ReactNoopUpdateQueue;
        }
        Component.prototype.isReactComponent = {};
        Component.prototype.setState = function(partialState, callback) {
          if (!(typeof partialState === "object" || typeof partialState === "function" || partialState == null)) {
            {
              throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            }
          }
          this.updater.enqueueSetState(this, partialState, callback, "setState");
        };
        Component.prototype.forceUpdate = function(callback) {
          this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
        };
        {
          var deprecatedAPIs = {
            isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
            replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
          };
          var defineDeprecationWarning = function(methodName, info) {
            Object.defineProperty(Component.prototype, methodName, {
              get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return void 0;
              }
            });
          };
          for (var fnName in deprecatedAPIs) {
            if (deprecatedAPIs.hasOwnProperty(fnName)) {
              defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
            }
          }
        }
        function ComponentDummy() {
        }
        ComponentDummy.prototype = Component.prototype;
        function PureComponent(props, context3, updater) {
          this.props = props;
          this.context = context3;
          this.refs = emptyObject2;
          this.updater = updater || ReactNoopUpdateQueue;
        }
        var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
        pureComponentPrototype.constructor = PureComponent;
        _assign(pureComponentPrototype, Component.prototype);
        pureComponentPrototype.isPureReactComponent = true;
        function createRef() {
          var refObject = {
            current: null
          };
          {
            Object.seal(refObject);
          }
          return refObject;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type) {
          return type.displayName || "Context";
        }
        function getComponentName(type) {
          if (type == null) {
            return null;
          }
          {
            if (typeof type.tag === "number") {
              error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type === "function") {
            return type.displayName || type.name || null;
          }
          if (typeof type === "string") {
            return type;
          }
          switch (type) {
            case exports2.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case exports2.Profiler:
              return "Profiler";
            case exports2.StrictMode:
              return "StrictMode";
            case exports2.Suspense:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context3 = type;
                return getContextName(context3) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentName(init(payload));
                } catch (x4) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var hasOwnProperty12 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config) {
          {
            if (hasOwnProperty12.call(config, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== void 0;
        }
        function hasValidKey(config) {
          {
            if (hasOwnProperty12.call(config, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== void 0;
        }
        function defineKeyPropWarningGetter(props, displayName) {
          var warnAboutAccessingKey = function() {
            {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
        function defineRefPropWarningGetter(props, displayName) {
          var warnAboutAccessingRef = function() {
            {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
        function warnIfStringRefCannotBeAutoConverted(config) {
          {
            if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        var ReactElement = function(type, key, ref, self2, source, owner, props) {
          var element = {
            $$typeof: REACT_ELEMENT_TYPE,
            type,
            key,
            ref,
            props,
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function createElement11(type, config, children) {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          var self2 = null;
          var source = null;
          if (config != null) {
            if (hasValidRef(config)) {
              ref = config.ref;
              {
                warnIfStringRefCannotBeAutoConverted(config);
              }
            }
            if (hasValidKey(config)) {
              key = "" + config.key;
            }
            self2 = config.__self === void 0 ? null : config.__self;
            source = config.__source === void 0 ? null : config.__source;
            for (propName in config) {
              if (hasOwnProperty12.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
          }
          var childrenLength = arguments.length - 2;
          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for (var i3 = 0; i3 < childrenLength; i3++) {
              childArray[i3] = arguments[i3 + 2];
            }
            {
              if (Object.freeze) {
                Object.freeze(childArray);
              }
            }
            props.children = childArray;
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          {
            if (key || ref) {
              var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
        function cloneAndReplaceKey(oldElement, newKey) {
          var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
          return newElement;
        }
        function cloneElement2(element, config, children) {
          if (!!(element === null || element === void 0)) {
            {
              throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
            }
          }
          var propName;
          var props = _assign({}, element.props);
          var key = element.key;
          var ref = element.ref;
          var self2 = element._self;
          var source = element._source;
          var owner = element._owner;
          if (config != null) {
            if (hasValidRef(config)) {
              ref = config.ref;
              owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
              key = "" + config.key;
            }
            var defaultProps;
            if (element.type && element.type.defaultProps) {
              defaultProps = element.type.defaultProps;
            }
            for (propName in config) {
              if (hasOwnProperty12.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === void 0 && defaultProps !== void 0) {
                  props[propName] = defaultProps[propName];
                } else {
                  props[propName] = config[propName];
                }
              }
            }
          }
          var childrenLength = arguments.length - 2;
          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for (var i3 = 0; i3 < childrenLength; i3++) {
              childArray[i3] = arguments[i3 + 2];
            }
            props.children = childArray;
          }
          return ReactElement(element.type, key, ref, self2, source, owner, props);
        }
        function isValidElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        var SEPARATOR = ".";
        var SUBSEPARATOR = ":";
        function escape2(key) {
          var escapeRegex = /[=:]/g;
          var escaperLookup = {
            "=": "=0",
            ":": "=2"
          };
          var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
          });
          return "$" + escapedString;
        }
        var didWarnAboutMaps = false;
        var userProvidedKeyEscapeRegex = /\/+/g;
        function escapeUserProvidedKey(text) {
          return text.replace(userProvidedKeyEscapeRegex, "$&/");
        }
        function getElementKey(element, index) {
          if (typeof element === "object" && element !== null && element.key != null) {
            return escape2("" + element.key);
          }
          return index.toString(36);
        }
        function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
          var type = typeof children;
          if (type === "undefined" || type === "boolean") {
            children = null;
          }
          var invokeCallback = false;
          if (children === null) {
            invokeCallback = true;
          } else {
            switch (type) {
              case "string":
              case "number":
                invokeCallback = true;
                break;
              case "object":
                switch (children.$$typeof) {
                  case REACT_ELEMENT_TYPE:
                  case REACT_PORTAL_TYPE:
                    invokeCallback = true;
                }
            }
          }
          if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child);
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (Array.isArray(mappedChild)) {
              var escapedChildKey = "";
              if (childKey != null) {
                escapedChildKey = escapeUserProvidedKey(childKey) + "/";
              }
              mapIntoArray(mappedChild, array, escapedChildKey, "", function(c3) {
                return c3;
              });
            } else if (mappedChild != null) {
              if (isValidElement(mappedChild)) {
                mappedChild = cloneAndReplaceKey(mappedChild, escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
              }
              array.push(mappedChild);
            }
            return 1;
          }
          var child;
          var nextName;
          var subtreeCount = 0;
          var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
          if (Array.isArray(children)) {
            for (var i3 = 0; i3 < children.length; i3++) {
              child = children[i3];
              nextName = nextNamePrefix + getElementKey(child, i3);
              subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
            }
          } else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
              var iterableChildren = children;
              {
                if (iteratorFn === iterableChildren.entries) {
                  if (!didWarnAboutMaps) {
                    warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                  }
                  didWarnAboutMaps = true;
                }
              }
              var iterator = iteratorFn.call(iterableChildren);
              var step;
              var ii = 0;
              while (!(step = iterator.next()).done) {
                child = step.value;
                nextName = nextNamePrefix + getElementKey(child, ii++);
                subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
              }
            } else if (type === "object") {
              var childrenString = "" + children;
              {
                {
                  throw Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). If you meant to render a collection of children, use an array instead.");
                }
              }
            }
          }
          return subtreeCount;
        }
        function mapChildren(children, func, context3) {
          if (children == null) {
            return children;
          }
          var result2 = [];
          var count = 0;
          mapIntoArray(children, result2, "", "", function(child) {
            return func.call(context3, child, count++);
          });
          return result2;
        }
        function countChildren(children) {
          var n3 = 0;
          mapChildren(children, function() {
            n3++;
          });
          return n3;
        }
        function forEachChildren(children, forEachFunc, forEachContext) {
          mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
          }, forEachContext);
        }
        function toArray2(children) {
          return mapChildren(children, function(child) {
            return child;
          }) || [];
        }
        function onlyChild(children) {
          if (!isValidElement(children)) {
            {
              throw Error("React.Children.only expected to receive a single React element child.");
            }
          }
          return children;
        }
        function createContext10(defaultValue, calculateChangedBits) {
          if (calculateChangedBits === void 0) {
            calculateChangedBits = null;
          } else {
            {
              if (calculateChangedBits !== null && typeof calculateChangedBits !== "function") {
                error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
              }
            }
          }
          var context3 = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          };
          context3.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context3
          };
          var hasWarnedAboutUsingNestedContextConsumers = false;
          var hasWarnedAboutUsingConsumerProvider = false;
          var hasWarnedAboutDisplayNameOnConsumer = false;
          {
            var Consumer = {
              $$typeof: REACT_CONTEXT_TYPE,
              _context: context3,
              _calculateChangedBits: context3._calculateChangedBits
            };
            Object.defineProperties(Consumer, {
              Provider: {
                get: function() {
                  if (!hasWarnedAboutUsingConsumerProvider) {
                    hasWarnedAboutUsingConsumerProvider = true;
                    error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                  }
                  return context3.Provider;
                },
                set: function(_Provider) {
                  context3.Provider = _Provider;
                }
              },
              _currentValue: {
                get: function() {
                  return context3._currentValue;
                },
                set: function(_currentValue) {
                  context3._currentValue = _currentValue;
                }
              },
              _currentValue2: {
                get: function() {
                  return context3._currentValue2;
                },
                set: function(_currentValue2) {
                  context3._currentValue2 = _currentValue2;
                }
              },
              _threadCount: {
                get: function() {
                  return context3._threadCount;
                },
                set: function(_threadCount) {
                  context3._threadCount = _threadCount;
                }
              },
              Consumer: {
                get: function() {
                  if (!hasWarnedAboutUsingNestedContextConsumers) {
                    hasWarnedAboutUsingNestedContextConsumers = true;
                    error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                  }
                  return context3.Consumer;
                }
              },
              displayName: {
                get: function() {
                  return context3.displayName;
                },
                set: function(displayName) {
                  if (!hasWarnedAboutDisplayNameOnConsumer) {
                    warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                    hasWarnedAboutDisplayNameOnConsumer = true;
                  }
                }
              }
            });
            context3.Consumer = Consumer;
          }
          {
            context3._currentRenderer = null;
            context3._currentRenderer2 = null;
          }
          return context3;
        }
        var Uninitialized = -1;
        var Pending = 0;
        var Resolved = 1;
        var Rejected = 2;
        function lazyInitializer(payload) {
          if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor();
            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function(moduleObject) {
              if (payload._status === Pending) {
                var defaultExport = moduleObject.default;
                {
                  if (defaultExport === void 0) {
                    error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                  }
                }
                var resolved = payload;
                resolved._status = Resolved;
                resolved._result = defaultExport;
              }
            }, function(error2) {
              if (payload._status === Pending) {
                var rejected = payload;
                rejected._status = Rejected;
                rejected._result = error2;
              }
            });
          }
          if (payload._status === Resolved) {
            return payload._result;
          } else {
            throw payload._result;
          }
        }
        function lazy2(ctor) {
          var payload = {
            _status: -1,
            _result: ctor
          };
          var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
          };
          {
            var defaultProps;
            var propTypes;
            Object.defineProperties(lazyType, {
              defaultProps: {
                configurable: true,
                get: function() {
                  return defaultProps;
                },
                set: function(newDefaultProps) {
                  error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                  defaultProps = newDefaultProps;
                  Object.defineProperty(lazyType, "defaultProps", {
                    enumerable: true
                  });
                }
              },
              propTypes: {
                configurable: true,
                get: function() {
                  return propTypes;
                },
                set: function(newPropTypes) {
                  error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                  propTypes = newPropTypes;
                  Object.defineProperty(lazyType, "propTypes", {
                    enumerable: true
                  });
                }
              }
            });
          }
          return lazyType;
        }
        function forwardRef4(render) {
          {
            if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
              error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
            } else if (typeof render !== "function") {
              error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
            } else {
              if (render.length !== 0 && render.length !== 2) {
                error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
              }
            }
            if (render != null) {
              if (render.defaultProps != null || render.propTypes != null) {
                error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
              }
            }
          }
          var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render
          };
          {
            var ownName;
            Object.defineProperty(elementType, "displayName", {
              enumerable: false,
              configurable: true,
              get: function() {
                return ownName;
              },
              set: function(name) {
                ownName = name;
                if (render.displayName == null) {
                  render.displayName = name;
                }
              }
            });
          }
          return elementType;
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === exports2.Fragment || type === exports2.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports2.StrictMode || type === exports2.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function memo2(type, compare) {
          {
            if (!isValidElementType(type)) {
              error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
            }
          }
          var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type,
            compare: compare === void 0 ? null : compare
          };
          {
            var ownName;
            Object.defineProperty(elementType, "displayName", {
              enumerable: false,
              configurable: true,
              get: function() {
                return ownName;
              },
              set: function(name) {
                ownName = name;
                if (type.displayName == null) {
                  type.displayName = name;
                }
              }
            });
          }
          return elementType;
        }
        function resolveDispatcher() {
          var dispatcher = ReactCurrentDispatcher.current;
          if (!(dispatcher !== null)) {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
          return dispatcher;
        }
        function useContext18(Context, unstable_observedBits) {
          var dispatcher = resolveDispatcher();
          {
            if (unstable_observedBits !== void 0) {
              error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === "number" && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : "");
            }
            if (Context._context !== void 0) {
              var realContext = Context._context;
              if (realContext.Consumer === Context) {
                error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
              } else if (realContext.Provider === Context) {
                error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
              }
            }
          }
          return dispatcher.useContext(Context, unstable_observedBits);
        }
        function useState36(initialState2) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useState(initialState2);
        }
        function useReducer(reducer, initialArg, init) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useReducer(reducer, initialArg, init);
        }
        function useRef42(initialValue) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useRef(initialValue);
        }
        function useEffect30(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useEffect(create, deps);
        }
        function useLayoutEffect22(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useLayoutEffect(create, deps);
        }
        function useCallback24(callback, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useCallback(callback, deps);
        }
        function useMemo49(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useMemo(create, deps);
        }
        function useImperativeHandle(ref, create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useImperativeHandle(ref, create, deps);
        }
        function useDebugValue4(value, formatterFn) {
          {
            var dispatcher = resolveDispatcher();
            return dispatcher.useDebugValue(value, formatterFn);
          }
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;
        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === void 0) {
              try {
                throw Error();
              } catch (x4) {
                var match = x4.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || "";
              }
            }
            return "\n" + prefix + name;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn2, construct) {
          if (!fn2 || reentry) {
            return "";
          }
          {
            var frame = componentFrameCache.get(fn2);
            if (frame !== void 0) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x4) {
                  control = x4;
                }
                Reflect.construct(fn2, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x4) {
                  control = x4;
                }
                fn2.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x4) {
                control = x4;
              }
              fn2();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s3 = sampleLines.length - 1;
              var c3 = controlLines.length - 1;
              while (s3 >= 1 && c3 >= 0 && sampleLines[s3] !== controlLines[c3]) {
                c3--;
              }
              for (; s3 >= 1 && c3 >= 0; s3--, c3--) {
                if (sampleLines[s3] !== controlLines[c3]) {
                  if (s3 !== 1 || c3 !== 1) {
                    do {
                      s3--;
                      c3--;
                      if (c3 < 0 || sampleLines[s3] !== controlLines[c3]) {
                        var _frame = "\n" + sampleLines[s3].replace(" at new ", " at ");
                        {
                          if (typeof fn2 === "function") {
                            componentFrameCache.set(fn2, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s3 >= 1 && c3 >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher$1.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name = fn2 ? fn2.displayName || fn2.name : "";
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
          {
            if (typeof fn2 === "function") {
              componentFrameCache.set(fn2, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeFunctionComponentFrame(fn2, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn2, false);
          }
        }
        function shouldConstruct(Component2) {
          var prototype = Component2.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return "";
          }
          if (typeof type === "function") {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }
          if (typeof type === "string") {
            return describeBuiltInComponentFrame(type);
          }
          switch (type) {
            case exports2.Suspense:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x4) {
                }
              }
            }
          }
          return "";
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              setExtraStackFrame(stack);
            } else {
              setExtraStackFrame(null);
            }
          }
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function getDeclarationErrorAddendum() {
          if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
        function getSourceInfoErrorAddendum(source) {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
        function getSourceInfoErrorAddendumForProps(elementProps) {
          if (elementProps !== null && elementProps !== void 0) {
            return getSourceInfoErrorAddendum(elementProps.__source);
          }
          return "";
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
        function validateExplicitKey(element, parentType) {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }
          {
            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node, parentType) {
          if (typeof node !== "object") {
            return;
          }
          if (Array.isArray(node)) {
            for (var i3 = 0; i3 < node.length; i3++) {
              var child = node[i3];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type = element.type;
            if (type === null || type === void 0 || typeof type === "string") {
              return;
            }
            var propTypes;
            if (typeof type === "function") {
              propTypes = type.propTypes;
            } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type.propTypes;
            } else {
              return;
            }
            if (propTypes) {
              var name = getComponentName(type);
              checkPropTypes(propTypes, element.props, "prop", name, element);
            } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type);
              error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
              error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys3 = Object.keys(fragment.props);
            for (var i3 = 0; i3 < keys3.length; i3++) {
              var key = keys3[i3];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function createElementWithValidation(type, props, children) {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (Array.isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            {
              error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
          }
          var element = createElement11.apply(this, arguments);
          if (element == null) {
            return element;
          }
          if (validType) {
            for (var i3 = 2; i3 < arguments.length; i3++) {
              validateChildKeys(arguments[i3], type);
            }
          }
          if (type === exports2.Fragment) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
        var didWarnAboutDeprecatedCreateFactory = false;
        function createFactoryWithValidation(type) {
          var validatedFactory = createElementWithValidation.bind(null, type);
          validatedFactory.type = type;
          {
            if (!didWarnAboutDeprecatedCreateFactory) {
              didWarnAboutDeprecatedCreateFactory = true;
              warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
            }
            Object.defineProperty(validatedFactory, "type", {
              enumerable: false,
              get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                  value: type
                });
                return type;
              }
            });
          }
          return validatedFactory;
        }
        function cloneElementWithValidation(element, props, children) {
          var newElement = cloneElement2.apply(this, arguments);
          for (var i3 = 2; i3 < arguments.length; i3++) {
            validateChildKeys(arguments[i3], newElement.type);
          }
          validatePropTypes(newElement);
          return newElement;
        }
        {
          try {
            var frozenObject = Object.freeze({});
            new Map([[frozenObject, null]]);
            new Set([frozenObject]);
          } catch (e2) {
          }
        }
        var createElement$1 = createElementWithValidation;
        var cloneElement$1 = cloneElementWithValidation;
        var createFactory = createFactoryWithValidation;
        var Children = {
          map: mapChildren,
          forEach: forEachChildren,
          count: countChildren,
          toArray: toArray2,
          only: onlyChild
        };
        exports2.Children = Children;
        exports2.Component = Component;
        exports2.PureComponent = PureComponent;
        exports2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
        exports2.cloneElement = cloneElement$1;
        exports2.createContext = createContext10;
        exports2.createElement = createElement$1;
        exports2.createFactory = createFactory;
        exports2.createRef = createRef;
        exports2.forwardRef = forwardRef4;
        exports2.isValidElement = isValidElement;
        exports2.lazy = lazy2;
        exports2.memo = memo2;
        exports2.useCallback = useCallback24;
        exports2.useContext = useContext18;
        exports2.useDebugValue = useDebugValue4;
        exports2.useEffect = useEffect30;
        exports2.useImperativeHandle = useImperativeHandle;
        exports2.useLayoutEffect = useLayoutEffect22;
        exports2.useMemo = useMemo49;
        exports2.useReducer = useReducer;
        exports2.useRef = useRef42;
        exports2.useState = useState36;
        exports2.version = ReactVersion;
      })();
    }
  }
});

// ../node_modules/react/index.js
var require_react = __commonJS({
  "../node_modules/react/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_development();
    }
  }
});

// ../node_modules/scheduler/cjs/scheduler.development.js
var require_scheduler_development = __commonJS({
  "../node_modules/scheduler/cjs/scheduler.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var enableSchedulerDebugging = false;
        var enableProfiling = false;
        var requestHostCallback;
        var requestHostTimeout;
        var cancelHostTimeout;
        var requestPaint;
        var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
        if (hasPerformanceNow) {
          var localPerformance = performance;
          exports2.unstable_now = function() {
            return localPerformance.now();
          };
        } else {
          var localDate = Date;
          var initialTime = localDate.now();
          exports2.unstable_now = function() {
            return localDate.now() - initialTime;
          };
        }
        if (typeof window === "undefined" || typeof MessageChannel !== "function") {
          var _callback = null;
          var _timeoutID = null;
          var _flushCallback = function() {
            if (_callback !== null) {
              try {
                var currentTime = exports2.unstable_now();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
              } catch (e2) {
                setTimeout(_flushCallback, 0);
                throw e2;
              }
            }
          };
          requestHostCallback = function(cb) {
            if (_callback !== null) {
              setTimeout(requestHostCallback, 0, cb);
            } else {
              _callback = cb;
              setTimeout(_flushCallback, 0);
            }
          };
          requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
          };
          cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
          };
          exports2.unstable_shouldYield = function() {
            return false;
          };
          requestPaint = exports2.unstable_forceFrameRate = function() {
          };
        } else {
          var _setTimeout = window.setTimeout;
          var _clearTimeout = window.clearTimeout;
          if (typeof console !== "undefined") {
            var requestAnimationFrame2 = window.requestAnimationFrame;
            var cancelAnimationFrame2 = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame2 !== "function") {
              console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            }
            if (typeof cancelAnimationFrame2 !== "function") {
              console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            }
          }
          var isMessageLoopRunning = false;
          var scheduledHostCallback = null;
          var taskTimeoutID = -1;
          var yieldInterval = 5;
          var deadline = 0;
          {
            exports2.unstable_shouldYield = function() {
              return exports2.unstable_now() >= deadline;
            };
            requestPaint = function() {
            };
          }
          exports2.unstable_forceFrameRate = function(fps) {
            if (fps < 0 || fps > 125) {
              console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
              return;
            }
            if (fps > 0) {
              yieldInterval = Math.floor(1e3 / fps);
            } else {
              yieldInterval = 5;
            }
          };
          var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
              var currentTime = exports2.unstable_now();
              deadline = currentTime + yieldInterval;
              var hasTimeRemaining = true;
              try {
                var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) {
                  isMessageLoopRunning = false;
                  scheduledHostCallback = null;
                } else {
                  port.postMessage(null);
                }
              } catch (error) {
                port.postMessage(null);
                throw error;
              }
            } else {
              isMessageLoopRunning = false;
            }
          };
          var channel = new MessageChannel();
          var port = channel.port2;
          channel.port1.onmessage = performWorkUntilDeadline;
          requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
              isMessageLoopRunning = true;
              port.postMessage(null);
            }
          };
          requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
              callback(exports2.unstable_now());
            }, ms);
          };
          cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
          };
        }
        function push(heap, node) {
          var index = heap.length;
          heap.push(node);
          siftUp(heap, node, index);
        }
        function peek(heap) {
          var first = heap[0];
          return first === void 0 ? null : first;
        }
        function pop(heap) {
          var first = heap[0];
          if (first !== void 0) {
            var last2 = heap.pop();
            if (last2 !== first) {
              heap[0] = last2;
              siftDown(heap, last2, 0);
            }
            return first;
          } else {
            return null;
          }
        }
        function siftUp(heap, node, i3) {
          var index = i3;
          while (true) {
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== void 0 && compare(parent, node) > 0) {
              heap[parentIndex] = node;
              heap[index] = parent;
              index = parentIndex;
            } else {
              return;
            }
          }
        }
        function siftDown(heap, node, i3) {
          var index = i3;
          var length = heap.length;
          while (index < length) {
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex];
            if (left !== void 0 && compare(left, node) < 0) {
              if (right !== void 0 && compare(right, left) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
              } else {
                heap[index] = left;
                heap[leftIndex] = node;
                index = leftIndex;
              }
            } else if (right !== void 0 && compare(right, node) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              return;
            }
          }
        }
        function compare(a4, b4) {
          var diff = a4.sortIndex - b4.sortIndex;
          return diff !== 0 ? diff : a4.id - b4.id;
        }
        var ImmediatePriority = 1;
        var UserBlockingPriority = 2;
        var NormalPriority = 3;
        var LowPriority = 4;
        var IdlePriority = 5;
        function markTaskErrored(task, ms) {
        }
        var maxSigned31BitInt = 1073741823;
        var IMMEDIATE_PRIORITY_TIMEOUT = -1;
        var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
        var NORMAL_PRIORITY_TIMEOUT = 5e3;
        var LOW_PRIORITY_TIMEOUT = 1e4;
        var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
        var taskQueue = [];
        var timerQueue = [];
        var taskIdCounter = 1;
        var currentTask = null;
        var currentPriorityLevel = NormalPriority;
        var isPerformingWork = false;
        var isHostCallbackScheduled = false;
        var isHostTimeoutScheduled = false;
        function advanceTimers(currentTime) {
          var timer = peek(timerQueue);
          while (timer !== null) {
            if (timer.callback === null) {
              pop(timerQueue);
            } else if (timer.startTime <= currentTime) {
              pop(timerQueue);
              timer.sortIndex = timer.expirationTime;
              push(taskQueue, timer);
            } else {
              return;
            }
            timer = peek(timerQueue);
          }
        }
        function handleTimeout(currentTime) {
          isHostTimeoutScheduled = false;
          advanceTimers(currentTime);
          if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            } else {
              var firstTimer = peek(timerQueue);
              if (firstTimer !== null) {
                requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
              }
            }
          }
        }
        function flushWork(hasTimeRemaining, initialTime2) {
          isHostCallbackScheduled = false;
          if (isHostTimeoutScheduled) {
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
          }
          isPerformingWork = true;
          var previousPriorityLevel = currentPriorityLevel;
          try {
            if (enableProfiling) {
              try {
                return workLoop(hasTimeRemaining, initialTime2);
              } catch (error) {
                if (currentTask !== null) {
                  var currentTime = exports2.unstable_now();
                  markTaskErrored(currentTask, currentTime);
                  currentTask.isQueued = false;
                }
                throw error;
              }
            } else {
              return workLoop(hasTimeRemaining, initialTime2);
            }
          } finally {
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
          }
        }
        function workLoop(hasTimeRemaining, initialTime2) {
          var currentTime = initialTime2;
          advanceTimers(currentTime);
          currentTask = peek(taskQueue);
          while (currentTask !== null && !enableSchedulerDebugging) {
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports2.unstable_shouldYield())) {
              break;
            }
            var callback = currentTask.callback;
            if (typeof callback === "function") {
              currentTask.callback = null;
              currentPriorityLevel = currentTask.priorityLevel;
              var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
              var continuationCallback = callback(didUserCallbackTimeout);
              currentTime = exports2.unstable_now();
              if (typeof continuationCallback === "function") {
                currentTask.callback = continuationCallback;
              } else {
                if (currentTask === peek(taskQueue)) {
                  pop(taskQueue);
                }
              }
              advanceTimers(currentTime);
            } else {
              pop(taskQueue);
            }
            currentTask = peek(taskQueue);
          }
          if (currentTask !== null) {
            return true;
          } else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
            return false;
          }
        }
        function unstable_runWithPriority(priorityLevel, eventHandler) {
          switch (priorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
              break;
            default:
              priorityLevel = NormalPriority;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_next(eventHandler) {
          var priorityLevel;
          switch (currentPriorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
              priorityLevel = NormalPriority;
              break;
            default:
              priorityLevel = currentPriorityLevel;
              break;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_wrapCallback(callback) {
          var parentPriorityLevel = currentPriorityLevel;
          return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
              return callback.apply(this, arguments);
            } finally {
              currentPriorityLevel = previousPriorityLevel;
            }
          };
        }
        function unstable_scheduleCallback(priorityLevel, callback, options2) {
          var currentTime = exports2.unstable_now();
          var startTime;
          if (typeof options2 === "object" && options2 !== null) {
            var delay = options2.delay;
            if (typeof delay === "number" && delay > 0) {
              startTime = currentTime + delay;
            } else {
              startTime = currentTime;
            }
          } else {
            startTime = currentTime;
          }
          var timeout;
          switch (priorityLevel) {
            case ImmediatePriority:
              timeout = IMMEDIATE_PRIORITY_TIMEOUT;
              break;
            case UserBlockingPriority:
              timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
              break;
            case IdlePriority:
              timeout = IDLE_PRIORITY_TIMEOUT;
              break;
            case LowPriority:
              timeout = LOW_PRIORITY_TIMEOUT;
              break;
            case NormalPriority:
            default:
              timeout = NORMAL_PRIORITY_TIMEOUT;
              break;
          }
          var expirationTime = startTime + timeout;
          var newTask = {
            id: taskIdCounter++,
            callback,
            priorityLevel,
            startTime,
            expirationTime,
            sortIndex: -1
          };
          if (startTime > currentTime) {
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
              if (isHostTimeoutScheduled) {
                cancelHostTimeout();
              } else {
                isHostTimeoutScheduled = true;
              }
              requestHostTimeout(handleTimeout, startTime - currentTime);
            }
          } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            if (!isHostCallbackScheduled && !isPerformingWork) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            }
          }
          return newTask;
        }
        function unstable_pauseExecution() {
        }
        function unstable_continueExecution() {
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        function unstable_getFirstCallbackNode() {
          return peek(taskQueue);
        }
        function unstable_cancelCallback(task) {
          task.callback = null;
        }
        function unstable_getCurrentPriorityLevel() {
          return currentPriorityLevel;
        }
        var unstable_requestPaint = requestPaint;
        var unstable_Profiling = null;
        exports2.unstable_IdlePriority = IdlePriority;
        exports2.unstable_ImmediatePriority = ImmediatePriority;
        exports2.unstable_LowPriority = LowPriority;
        exports2.unstable_NormalPriority = NormalPriority;
        exports2.unstable_Profiling = unstable_Profiling;
        exports2.unstable_UserBlockingPriority = UserBlockingPriority;
        exports2.unstable_cancelCallback = unstable_cancelCallback;
        exports2.unstable_continueExecution = unstable_continueExecution;
        exports2.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
        exports2.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
        exports2.unstable_next = unstable_next;
        exports2.unstable_pauseExecution = unstable_pauseExecution;
        exports2.unstable_requestPaint = unstable_requestPaint;
        exports2.unstable_runWithPriority = unstable_runWithPriority;
        exports2.unstable_scheduleCallback = unstable_scheduleCallback;
        exports2.unstable_wrapCallback = unstable_wrapCallback;
      })();
    }
  }
});

// ../node_modules/scheduler/index.js
var require_scheduler = __commonJS({
  "../node_modules/scheduler/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_scheduler_development();
    }
  }
});

// ../node_modules/scheduler/cjs/scheduler-tracing.development.js
var require_scheduler_tracing_development = __commonJS({
  "../node_modules/scheduler/cjs/scheduler-tracing.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var DEFAULT_THREAD_ID = 0;
        var interactionIDCounter = 0;
        var threadIDCounter = 0;
        exports2.__interactionsRef = null;
        exports2.__subscriberRef = null;
        {
          exports2.__interactionsRef = {
            current: new Set()
          };
          exports2.__subscriberRef = {
            current: null
          };
        }
        function unstable_clear(callback) {
          var prevInteractions = exports2.__interactionsRef.current;
          exports2.__interactionsRef.current = new Set();
          try {
            return callback();
          } finally {
            exports2.__interactionsRef.current = prevInteractions;
          }
        }
        function unstable_getCurrent() {
          {
            return exports2.__interactionsRef.current;
          }
        }
        function unstable_getThreadID() {
          return ++threadIDCounter;
        }
        function unstable_trace(name, timestamp, callback) {
          var threadID = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : DEFAULT_THREAD_ID;
          var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name,
            timestamp
          };
          var prevInteractions = exports2.__interactionsRef.current;
          var interactions = new Set(prevInteractions);
          interactions.add(interaction);
          exports2.__interactionsRef.current = interactions;
          var subscriber = exports2.__subscriberRef.current;
          var returnValue;
          try {
            if (subscriber !== null) {
              subscriber.onInteractionTraced(interaction);
            }
          } finally {
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(interactions, threadID);
              }
            } finally {
              try {
                returnValue = callback();
              } finally {
                exports2.__interactionsRef.current = prevInteractions;
                try {
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(interactions, threadID);
                  }
                } finally {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                }
              }
            }
          }
          return returnValue;
        }
        function unstable_wrap(callback) {
          var threadID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_THREAD_ID;
          var wrappedInteractions = exports2.__interactionsRef.current;
          var subscriber = exports2.__subscriberRef.current;
          if (subscriber !== null) {
            subscriber.onWorkScheduled(wrappedInteractions, threadID);
          }
          wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
          });
          var hasRun = false;
          function wrapped() {
            var prevInteractions = exports2.__interactionsRef.current;
            exports2.__interactionsRef.current = wrappedInteractions;
            subscriber = exports2.__subscriberRef.current;
            try {
              var returnValue;
              try {
                if (subscriber !== null) {
                  subscriber.onWorkStarted(wrappedInteractions, threadID);
                }
              } finally {
                try {
                  returnValue = callback.apply(void 0, arguments);
                } finally {
                  exports2.__interactionsRef.current = prevInteractions;
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(wrappedInteractions, threadID);
                  }
                }
              }
              return returnValue;
            } finally {
              if (!hasRun) {
                hasRun = true;
                wrappedInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                });
              }
            }
          }
          wrapped.cancel = function cancel() {
            subscriber = exports2.__subscriberRef.current;
            try {
              if (subscriber !== null) {
                subscriber.onWorkCanceled(wrappedInteractions, threadID);
              }
            } finally {
              wrappedInteractions.forEach(function(interaction) {
                interaction.__count--;
                if (subscriber && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          };
          return wrapped;
        }
        var subscribers = null;
        {
          subscribers = new Set();
        }
        function unstable_subscribe(subscriber) {
          {
            subscribers.add(subscriber);
            if (subscribers.size === 1) {
              exports2.__subscriberRef.current = {
                onInteractionScheduledWorkCompleted,
                onInteractionTraced,
                onWorkCanceled,
                onWorkScheduled,
                onWorkStarted,
                onWorkStopped
              };
            }
          }
        }
        function unstable_unsubscribe(subscriber) {
          {
            subscribers.delete(subscriber);
            if (subscribers.size === 0) {
              exports2.__subscriberRef.current = null;
            }
          }
        }
        function onInteractionTraced(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionTraced(interaction);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onInteractionScheduledWorkCompleted(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkScheduled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStarted(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStopped(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkCanceled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        exports2.unstable_clear = unstable_clear;
        exports2.unstable_getCurrent = unstable_getCurrent;
        exports2.unstable_getThreadID = unstable_getThreadID;
        exports2.unstable_subscribe = unstable_subscribe;
        exports2.unstable_trace = unstable_trace;
        exports2.unstable_unsubscribe = unstable_unsubscribe;
        exports2.unstable_wrap = unstable_wrap;
      })();
    }
  }
});

// ../node_modules/scheduler/tracing.js
var require_tracing = __commonJS({
  "../node_modules/scheduler/tracing.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_scheduler_tracing_development();
    }
  }
});

// ../node_modules/react-dom/cjs/react-dom.development.js
var require_react_dom_development = __commonJS({
  "../node_modules/react-dom/cjs/react-dom.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var React149 = require_react();
        var _assign = require_object_assign();
        var Scheduler = require_scheduler();
        var tracing = require_tracing();
        var ReactSharedInternals = React149.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function warn(format4) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format4, args);
          }
        }
        function error(format4) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format4, args);
          }
        }
        function printWarning(level, format4, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack !== "") {
              format4 += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format4);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        if (!React149) {
          {
            throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
          }
        }
        var FunctionComponent = 0;
        var ClassComponent = 1;
        var IndeterminateComponent = 2;
        var HostRoot = 3;
        var HostPortal = 4;
        var HostComponent = 5;
        var HostText = 6;
        var Fragment3 = 7;
        var Mode = 8;
        var ContextConsumer = 9;
        var ContextProvider = 10;
        var ForwardRef = 11;
        var Profiler = 12;
        var SuspenseComponent = 13;
        var MemoComponent = 14;
        var SimpleMemoComponent = 15;
        var LazyComponent = 16;
        var IncompleteClassComponent = 17;
        var DehydratedFragment = 18;
        var SuspenseListComponent = 19;
        var FundamentalComponent = 20;
        var ScopeComponent = 21;
        var Block = 22;
        var OffscreenComponent = 23;
        var LegacyHiddenComponent = 24;
        var enableProfilerTimer = true;
        var enableFundamentalAPI = false;
        var enableNewReconciler = false;
        var warnAboutStringRefs = false;
        var allNativeEvents = new Set();
        var registrationNameDependencies = {};
        var possibleRegistrationNames = {};
        function registerTwoPhaseEvent(registrationName, dependencies) {
          registerDirectEvent(registrationName, dependencies);
          registerDirectEvent(registrationName + "Capture", dependencies);
        }
        function registerDirectEvent(registrationName, dependencies) {
          {
            if (registrationNameDependencies[registrationName]) {
              error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
            }
          }
          registrationNameDependencies[registrationName] = dependencies;
          {
            var lowerCasedName = registrationName.toLowerCase();
            possibleRegistrationNames[lowerCasedName] = registrationName;
            if (registrationName === "onDoubleClick") {
              possibleRegistrationNames.ondblclick = registrationName;
            }
          }
          for (var i3 = 0; i3 < dependencies.length; i3++) {
            allNativeEvents.add(dependencies[i3]);
          }
        }
        var canUseDOM2 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
        var RESERVED = 0;
        var STRING = 1;
        var BOOLEANISH_STRING = 2;
        var BOOLEAN = 3;
        var OVERLOADED_BOOLEAN = 4;
        var NUMERIC = 5;
        var POSITIVE_NUMERIC = 6;
        var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
        var ROOT_ATTRIBUTE_NAME = "data-reactroot";
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
        var hasOwnProperty12 = Object.prototype.hasOwnProperty;
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};
        function isAttributeNameSafe(attributeName) {
          if (hasOwnProperty12.call(validatedAttributeNameCache, attributeName)) {
            return true;
          }
          if (hasOwnProperty12.call(illegalAttributeNameCache, attributeName)) {
            return false;
          }
          if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
          }
          illegalAttributeNameCache[attributeName] = true;
          {
            error("Invalid attribute name: `%s`", attributeName);
          }
          return false;
        }
        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null) {
            return propertyInfo.type === RESERVED;
          }
          if (isCustomComponentTag) {
            return false;
          }
          if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) {
            return true;
          }
          return false;
        }
        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null && propertyInfo.type === RESERVED) {
            return false;
          }
          switch (typeof value) {
            case "function":
            case "symbol":
              return true;
            case "boolean": {
              if (isCustomComponentTag) {
                return false;
              }
              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix2 = name.toLowerCase().slice(0, 5);
                return prefix2 !== "data-" && prefix2 !== "aria-";
              }
            }
            default:
              return false;
          }
        }
        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
          if (value === null || typeof value === "undefined") {
            return true;
          }
          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
            return true;
          }
          if (isCustomComponentTag) {
            return false;
          }
          if (propertyInfo !== null) {
            switch (propertyInfo.type) {
              case BOOLEAN:
                return !value;
              case OVERLOADED_BOOLEAN:
                return value === false;
              case NUMERIC:
                return isNaN(value);
              case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
            }
          }
          return false;
        }
        function getPropertyInfo(name) {
          return properties.hasOwnProperty(name) ? properties[name] : null;
        }
        function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2, removeEmptyString) {
          this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
          this.attributeName = attributeName;
          this.attributeNamespace = attributeNamespace;
          this.mustUseProperty = mustUseProperty;
          this.propertyName = name;
          this.type = type;
          this.sanitizeURL = sanitizeURL2;
          this.removeEmptyString = removeEmptyString;
        }
        var properties = {};
        var reservedProps = [
          "children",
          "dangerouslySetInnerHTML",
          "defaultValue",
          "defaultChecked",
          "innerHTML",
          "suppressContentEditableWarning",
          "suppressHydrationWarning",
          "style"
        ];
        reservedProps.forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
        });
        [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(_ref) {
          var name = _ref[0], attributeName = _ref[1];
          properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
        });
        ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
        });
        ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
        });
        [
          "allowFullScreen",
          "async",
          "autoFocus",
          "autoPlay",
          "controls",
          "default",
          "defer",
          "disabled",
          "disablePictureInPicture",
          "disableRemotePlayback",
          "formNoValidate",
          "hidden",
          "loop",
          "noModule",
          "noValidate",
          "open",
          "playsInline",
          "readOnly",
          "required",
          "reversed",
          "scoped",
          "seamless",
          "itemScope"
        ].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
        });
        [
          "checked",
          "multiple",
          "muted",
          "selected"
        ].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
        });
        [
          "capture",
          "download"
        ].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
        });
        [
          "cols",
          "rows",
          "size",
          "span"
        ].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
        });
        ["rowSpan", "start"].forEach(function(name) {
          properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
        });
        var CAMELIZE = /[\-\:]([a-z])/g;
        var capitalize = function(token) {
          return token[1].toUpperCase();
        };
        [
          "accent-height",
          "alignment-baseline",
          "arabic-form",
          "baseline-shift",
          "cap-height",
          "clip-path",
          "clip-rule",
          "color-interpolation",
          "color-interpolation-filters",
          "color-profile",
          "color-rendering",
          "dominant-baseline",
          "enable-background",
          "fill-opacity",
          "fill-rule",
          "flood-color",
          "flood-opacity",
          "font-family",
          "font-size",
          "font-size-adjust",
          "font-stretch",
          "font-style",
          "font-variant",
          "font-weight",
          "glyph-name",
          "glyph-orientation-horizontal",
          "glyph-orientation-vertical",
          "horiz-adv-x",
          "horiz-origin-x",
          "image-rendering",
          "letter-spacing",
          "lighting-color",
          "marker-end",
          "marker-mid",
          "marker-start",
          "overline-position",
          "overline-thickness",
          "paint-order",
          "panose-1",
          "pointer-events",
          "rendering-intent",
          "shape-rendering",
          "stop-color",
          "stop-opacity",
          "strikethrough-position",
          "strikethrough-thickness",
          "stroke-dasharray",
          "stroke-dashoffset",
          "stroke-linecap",
          "stroke-linejoin",
          "stroke-miterlimit",
          "stroke-opacity",
          "stroke-width",
          "text-anchor",
          "text-decoration",
          "text-rendering",
          "underline-position",
          "underline-thickness",
          "unicode-bidi",
          "unicode-range",
          "units-per-em",
          "v-alphabetic",
          "v-hanging",
          "v-ideographic",
          "v-mathematical",
          "vector-effect",
          "vert-adv-y",
          "vert-origin-x",
          "vert-origin-y",
          "word-spacing",
          "writing-mode",
          "xmlns:xlink",
          "x-height"
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
        });
        [
          "xlink:actuate",
          "xlink:arcrole",
          "xlink:role",
          "xlink:show",
          "xlink:title",
          "xlink:type"
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
        });
        [
          "xml:base",
          "xml:lang",
          "xml:space"
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
        });
        ["tabIndex", "crossOrigin"].forEach(function(attributeName) {
          properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
        });
        var xlinkHref = "xlinkHref";
        properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
        ["src", "href", "action", "formAction"].forEach(function(attributeName) {
          properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
        });
        var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
        var didWarn = false;
        function sanitizeURL(url) {
          {
            if (!didWarn && isJavaScriptProtocol.test(url)) {
              didWarn = true;
              error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
            }
          }
        }
        function getValueForProperty(node, name, expected, propertyInfo) {
          {
            if (propertyInfo.mustUseProperty) {
              var propertyName = propertyInfo.propertyName;
              return node[propertyName];
            } else {
              if (propertyInfo.sanitizeURL) {
                sanitizeURL("" + expected);
              }
              var attributeName = propertyInfo.attributeName;
              var stringValue = null;
              if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                  var value = node.getAttribute(attributeName);
                  if (value === "") {
                    return true;
                  }
                  if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                    return value;
                  }
                  if (value === "" + expected) {
                    return expected;
                  }
                  return value;
                }
              } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return node.getAttribute(attributeName);
                }
                if (propertyInfo.type === BOOLEAN) {
                  return expected;
                }
                stringValue = node.getAttribute(attributeName);
              }
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return stringValue === null ? expected : stringValue;
              } else if (stringValue === "" + expected) {
                return expected;
              } else {
                return stringValue;
              }
            }
          }
        }
        function getValueForAttribute(node, name, expected) {
          {
            if (!isAttributeNameSafe(name)) {
              return;
            }
            if (isOpaqueHydratingObject(expected)) {
              return expected;
            }
            if (!node.hasAttribute(name)) {
              return expected === void 0 ? void 0 : null;
            }
            var value = node.getAttribute(name);
            if (value === "" + expected) {
              return expected;
            }
            return value;
          }
        }
        function setValueForProperty(node, name, value, isCustomComponentTag) {
          var propertyInfo = getPropertyInfo(name);
          if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
            return;
          }
          if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
            value = null;
          }
          if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
              var _attributeName = name;
              if (value === null) {
                node.removeAttribute(_attributeName);
              } else {
                node.setAttribute(_attributeName, "" + value);
              }
            }
            return;
          }
          var mustUseProperty = propertyInfo.mustUseProperty;
          if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
              var type = propertyInfo.type;
              node[propertyName] = type === BOOLEAN ? false : "";
            } else {
              node[propertyName] = value;
            }
            return;
          }
          var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
          if (value === null) {
            node.removeAttribute(attributeName);
          } else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
              attributeValue = "";
            } else {
              {
                attributeValue = "" + value;
              }
              if (propertyInfo.sanitizeURL) {
                sanitizeURL(attributeValue.toString());
              }
            }
            if (attributeNamespace) {
              node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            } else {
              node.setAttribute(attributeName, attributeValue);
            }
          }
        }
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        var REACT_FRAGMENT_TYPE = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_OPAQUE_ID_TYPE = 60128;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          REACT_SCOPE_TYPE = symbolFor("react.scope");
          REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;
        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === void 0) {
              try {
                throw Error();
              } catch (x4) {
                var match = x4.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || "";
              }
            }
            return "\n" + prefix + name;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn2, construct) {
          if (!fn2 || reentry) {
            return "";
          }
          {
            var frame = componentFrameCache.get(fn2);
            if (frame !== void 0) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x4) {
                  control = x4;
                }
                Reflect.construct(fn2, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x4) {
                  control = x4;
                }
                fn2.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x4) {
                control = x4;
              }
              fn2();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s3 = sampleLines.length - 1;
              var c3 = controlLines.length - 1;
              while (s3 >= 1 && c3 >= 0 && sampleLines[s3] !== controlLines[c3]) {
                c3--;
              }
              for (; s3 >= 1 && c3 >= 0; s3--, c3--) {
                if (sampleLines[s3] !== controlLines[c3]) {
                  if (s3 !== 1 || c3 !== 1) {
                    do {
                      s3--;
                      c3--;
                      if (c3 < 0 || sampleLines[s3] !== controlLines[c3]) {
                        var _frame = "\n" + sampleLines[s3].replace(" at new ", " at ");
                        {
                          if (typeof fn2 === "function") {
                            componentFrameCache.set(fn2, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s3 >= 1 && c3 >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name = fn2 ? fn2.displayName || fn2.name : "";
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
          {
            if (typeof fn2 === "function") {
              componentFrameCache.set(fn2, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeClassComponentFrame(ctor, source, ownerFn) {
          {
            return describeNativeComponentFrame(ctor, true);
          }
        }
        function describeFunctionComponentFrame(fn2, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn2, false);
          }
        }
        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return "";
          }
          if (typeof type === "function") {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }
          if (typeof type === "string") {
            return describeBuiltInComponentFrame(type);
          }
          switch (type) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x4) {
                }
              }
            }
          }
          return "";
        }
        function describeFiber(fiber) {
          var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
          var source = fiber._debugSource;
          switch (fiber.tag) {
            case HostComponent:
              return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
              return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
              return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
              return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
              return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
              return describeFunctionComponentFrame(fiber.type.render);
            case Block:
              return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
              return describeClassComponentFrame(fiber.type);
            default:
              return "";
          }
        }
        function getStackByFiberInDevAndProd(workInProgress2) {
          try {
            var info = "";
            var node = workInProgress2;
            do {
              info += describeFiber(node);
              node = node.return;
            } while (node);
            return info;
          } catch (x4) {
            return "\nError generating stack: " + x4.message + "\n" + x4.stack;
          }
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type) {
          return type.displayName || "Context";
        }
        function getComponentName(type) {
          if (type == null) {
            return null;
          }
          {
            if (typeof type.tag === "number") {
              error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type === "function") {
            return type.displayName || type.name || null;
          }
          if (typeof type === "string") {
            return type;
          }
          switch (type) {
            case REACT_FRAGMENT_TYPE:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context3 = type;
                return getContextName(context3) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentName(init(payload));
                } catch (x4) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var current = null;
        var isRendering = false;
        function getCurrentFiberOwnerNameInDevOrNull() {
          {
            if (current === null) {
              return null;
            }
            var owner = current._debugOwner;
            if (owner !== null && typeof owner !== "undefined") {
              return getComponentName(owner.type);
            }
          }
          return null;
        }
        function getCurrentFiberStackInDev() {
          {
            if (current === null) {
              return "";
            }
            return getStackByFiberInDevAndProd(current);
          }
        }
        function resetCurrentFiber() {
          {
            ReactDebugCurrentFrame.getCurrentStack = null;
            current = null;
            isRendering = false;
          }
        }
        function setCurrentFiber(fiber) {
          {
            ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
            current = fiber;
            isRendering = false;
          }
        }
        function setIsRendering(rendering) {
          {
            isRendering = rendering;
          }
        }
        function getIsRendering() {
          {
            return isRendering;
          }
        }
        function toString2(value) {
          return "" + value;
        }
        function getToStringValue(value) {
          switch (typeof value) {
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
              return value;
            default:
              return "";
          }
        }
        var hasReadOnlyValue = {
          button: true,
          checkbox: true,
          image: true,
          hidden: true,
          radio: true,
          reset: true,
          submit: true
        };
        function checkControlledValueProps(tagName, props) {
          {
            if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
              error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
            }
            if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
              error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
            }
          }
        }
        function isCheckable(elem) {
          var type = elem.type;
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
        }
        function getTracker(node) {
          return node._valueTracker;
        }
        function detachTracker(node) {
          node._valueTracker = null;
        }
        function getValueFromNode(node) {
          var value = "";
          if (!node) {
            return value;
          }
          if (isCheckable(node)) {
            value = node.checked ? "true" : "false";
          } else {
            value = node.value;
          }
          return value;
        }
        function trackValueOnNode(node) {
          var valueField = isCheckable(node) ? "checked" : "value";
          var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
          var currentValue = "" + node[valueField];
          if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") {
            return;
          }
          var get3 = descriptor.get, set3 = descriptor.set;
          Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
              return get3.call(this);
            },
            set: function(value) {
              currentValue = "" + value;
              set3.call(this, value);
            }
          });
          Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
          });
          var tracker = {
            getValue: function() {
              return currentValue;
            },
            setValue: function(value) {
              currentValue = "" + value;
            },
            stopTracking: function() {
              detachTracker(node);
              delete node[valueField];
            }
          };
          return tracker;
        }
        function track(node) {
          if (getTracker(node)) {
            return;
          }
          node._valueTracker = trackValueOnNode(node);
        }
        function updateValueIfChanged(node) {
          if (!node) {
            return false;
          }
          var tracker = getTracker(node);
          if (!tracker) {
            return true;
          }
          var lastValue = tracker.getValue();
          var nextValue = getValueFromNode(node);
          if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
          }
          return false;
        }
        function getActiveElement2(doc) {
          doc = doc || (typeof document !== "undefined" ? document : void 0);
          if (typeof doc === "undefined") {
            return null;
          }
          try {
            return doc.activeElement || doc.body;
          } catch (e2) {
            return doc.body;
          }
        }
        var didWarnValueDefaultValue = false;
        var didWarnCheckedDefaultChecked = false;
        var didWarnControlledToUncontrolled = false;
        var didWarnUncontrolledToControlled = false;
        function isControlled(props) {
          var usesChecked = props.type === "checkbox" || props.type === "radio";
          return usesChecked ? props.checked != null : props.value != null;
        }
        function getHostProps(element, props) {
          var node = element;
          var checked = props.checked;
          var hostProps = _assign({}, props, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: checked != null ? checked : node._wrapperState.initialChecked
          });
          return hostProps;
        }
        function initWrapperState(element, props) {
          {
            checkControlledValueProps("input", props);
            if (props.checked !== void 0 && props.defaultChecked !== void 0 && !didWarnCheckedDefaultChecked) {
              error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
              didWarnCheckedDefaultChecked = true;
            }
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValueDefaultValue) {
              error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
              didWarnValueDefaultValue = true;
            }
          }
          var node = element;
          var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
          node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
          };
        }
        function updateChecked(element, props) {
          var node = element;
          var checked = props.checked;
          if (checked != null) {
            setValueForProperty(node, "checked", checked, false);
          }
        }
        function updateWrapper(element, props) {
          var node = element;
          {
            var controlled = isControlled(props);
            if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
              error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
              didWarnUncontrolledToControlled = true;
            }
            if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
              error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
              didWarnControlledToUncontrolled = true;
            }
          }
          updateChecked(element, props);
          var value = getToStringValue(props.value);
          var type = props.type;
          if (value != null) {
            if (type === "number") {
              if (value === 0 && node.value === "" || node.value != value) {
                node.value = toString2(value);
              }
            } else if (node.value !== toString2(value)) {
              node.value = toString2(value);
            }
          } else if (type === "submit" || type === "reset") {
            node.removeAttribute("value");
            return;
          }
          {
            if (props.hasOwnProperty("value")) {
              setDefaultValue(node, props.type, value);
            } else if (props.hasOwnProperty("defaultValue")) {
              setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
            }
          }
          {
            if (props.checked == null && props.defaultChecked != null) {
              node.defaultChecked = !!props.defaultChecked;
            }
          }
        }
        function postMountWrapper(element, props, isHydrating2) {
          var node = element;
          if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton2 = type === "submit" || type === "reset";
            if (isButton2 && (props.value === void 0 || props.value === null)) {
              return;
            }
            var initialValue = toString2(node._wrapperState.initialValue);
            if (!isHydrating2) {
              {
                if (initialValue !== node.value) {
                  node.value = initialValue;
                }
              }
            }
            {
              node.defaultValue = initialValue;
            }
          }
          var name = node.name;
          if (name !== "") {
            node.name = "";
          }
          {
            node.defaultChecked = !node.defaultChecked;
            node.defaultChecked = !!node._wrapperState.initialChecked;
          }
          if (name !== "") {
            node.name = name;
          }
        }
        function restoreControlledState(element, props) {
          var node = element;
          updateWrapper(node, props);
          updateNamedCousins(node, props);
        }
        function updateNamedCousins(rootNode, props) {
          var name = props.name;
          if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while (queryRoot.parentNode) {
              queryRoot = queryRoot.parentNode;
            }
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for (var i3 = 0; i3 < group.length; i3++) {
              var otherNode = group[i3];
              if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                continue;
              }
              var otherProps = getFiberCurrentPropsFromNode(otherNode);
              if (!otherProps) {
                {
                  throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                }
              }
              updateValueIfChanged(otherNode);
              updateWrapper(otherNode, otherProps);
            }
          }
        }
        function setDefaultValue(node, type, value) {
          if (type !== "number" || getActiveElement2(node.ownerDocument) !== node) {
            if (value == null) {
              node.defaultValue = toString2(node._wrapperState.initialValue);
            } else if (node.defaultValue !== toString2(value)) {
              node.defaultValue = toString2(value);
            }
          }
        }
        var didWarnSelectedSetOnOption = false;
        var didWarnInvalidChild = false;
        function flattenChildren(children) {
          var content = "";
          React149.Children.forEach(children, function(child) {
            if (child == null) {
              return;
            }
            content += child;
          });
          return content;
        }
        function validateProps(element, props) {
          {
            if (typeof props.children === "object" && props.children !== null) {
              React149.Children.forEach(props.children, function(child) {
                if (child == null) {
                  return;
                }
                if (typeof child === "string" || typeof child === "number") {
                  return;
                }
                if (typeof child.type !== "string") {
                  return;
                }
                if (!didWarnInvalidChild) {
                  didWarnInvalidChild = true;
                  error("Only strings and numbers are supported as <option> children.");
                }
              });
            }
            if (props.selected != null && !didWarnSelectedSetOnOption) {
              error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
              didWarnSelectedSetOnOption = true;
            }
          }
        }
        function postMountWrapper$1(element, props) {
          if (props.value != null) {
            element.setAttribute("value", toString2(getToStringValue(props.value)));
          }
        }
        function getHostProps$1(element, props) {
          var hostProps = _assign({
            children: void 0
          }, props);
          var content = flattenChildren(props.children);
          if (content) {
            hostProps.children = content;
          }
          return hostProps;
        }
        var didWarnValueDefaultValue$1;
        {
          didWarnValueDefaultValue$1 = false;
        }
        function getDeclarationErrorAddendum() {
          var ownerName = getCurrentFiberOwnerNameInDevOrNull();
          if (ownerName) {
            return "\n\nCheck the render method of `" + ownerName + "`.";
          }
          return "";
        }
        var valuePropNames = ["value", "defaultValue"];
        function checkSelectPropTypes(props) {
          {
            checkControlledValueProps("select", props);
            for (var i3 = 0; i3 < valuePropNames.length; i3++) {
              var propName = valuePropNames[i3];
              if (props[propName] == null) {
                continue;
              }
              var isArray3 = Array.isArray(props[propName]);
              if (props.multiple && !isArray3) {
                error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
              } else if (!props.multiple && isArray3) {
                error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
              }
            }
          }
        }
        function updateOptions(node, multiple, propValue, setDefaultSelected) {
          var options3 = node.options;
          if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for (var i3 = 0; i3 < selectedValues.length; i3++) {
              selectedValue["$" + selectedValues[i3]] = true;
            }
            for (var _i = 0; _i < options3.length; _i++) {
              var selected = selectedValue.hasOwnProperty("$" + options3[_i].value);
              if (options3[_i].selected !== selected) {
                options3[_i].selected = selected;
              }
              if (selected && setDefaultSelected) {
                options3[_i].defaultSelected = true;
              }
            }
          } else {
            var _selectedValue = toString2(getToStringValue(propValue));
            var defaultSelected = null;
            for (var _i2 = 0; _i2 < options3.length; _i2++) {
              if (options3[_i2].value === _selectedValue) {
                options3[_i2].selected = true;
                if (setDefaultSelected) {
                  options3[_i2].defaultSelected = true;
                }
                return;
              }
              if (defaultSelected === null && !options3[_i2].disabled) {
                defaultSelected = options3[_i2];
              }
            }
            if (defaultSelected !== null) {
              defaultSelected.selected = true;
            }
          }
        }
        function getHostProps$2(element, props) {
          return _assign({}, props, {
            value: void 0
          });
        }
        function initWrapperState$1(element, props) {
          var node = element;
          {
            checkSelectPropTypes(props);
          }
          node._wrapperState = {
            wasMultiple: !!props.multiple
          };
          {
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValueDefaultValue$1) {
              error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
              didWarnValueDefaultValue$1 = true;
            }
          }
        }
        function postMountWrapper$2(element, props) {
          var node = element;
          node.multiple = !!props.multiple;
          var value = props.value;
          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          }
        }
        function postUpdateWrapper(element, props) {
          var node = element;
          var wasMultiple = node._wrapperState.wasMultiple;
          node._wrapperState.wasMultiple = !!props.multiple;
          var value = props.value;
          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (wasMultiple !== !!props.multiple) {
            if (props.defaultValue != null) {
              updateOptions(node, !!props.multiple, props.defaultValue, true);
            } else {
              updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
            }
          }
        }
        function restoreControlledState$1(element, props) {
          var node = element;
          var value = props.value;
          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          }
        }
        var didWarnValDefaultVal = false;
        function getHostProps$3(element, props) {
          var node = element;
          if (!(props.dangerouslySetInnerHTML == null)) {
            {
              throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            }
          }
          var hostProps = _assign({}, props, {
            value: void 0,
            defaultValue: void 0,
            children: toString2(node._wrapperState.initialValue)
          });
          return hostProps;
        }
        function initWrapperState$2(element, props) {
          var node = element;
          {
            checkControlledValueProps("textarea", props);
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValDefaultVal) {
              error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
              didWarnValDefaultVal = true;
            }
          }
          var initialValue = props.value;
          if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
              {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
              }
              {
                if (!(defaultValue == null)) {
                  {
                    throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                  }
                }
                if (Array.isArray(children)) {
                  if (!(children.length <= 1)) {
                    {
                      throw Error("<textarea> can only have at most one child.");
                    }
                  }
                  children = children[0];
                }
                defaultValue = children;
              }
            }
            if (defaultValue == null) {
              defaultValue = "";
            }
            initialValue = defaultValue;
          }
          node._wrapperState = {
            initialValue: getToStringValue(initialValue)
          };
        }
        function updateWrapper$1(element, props) {
          var node = element;
          var value = getToStringValue(props.value);
          var defaultValue = getToStringValue(props.defaultValue);
          if (value != null) {
            var newValue = toString2(value);
            if (newValue !== node.value) {
              node.value = newValue;
            }
            if (props.defaultValue == null && node.defaultValue !== newValue) {
              node.defaultValue = newValue;
            }
          }
          if (defaultValue != null) {
            node.defaultValue = toString2(defaultValue);
          }
        }
        function postMountWrapper$3(element, props) {
          var node = element;
          var textContent = node.textContent;
          if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) {
              node.value = textContent;
            }
          }
        }
        function restoreControlledState$2(element, props) {
          updateWrapper$1(element, props);
        }
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var Namespaces = {
          html: HTML_NAMESPACE,
          mathml: MATH_NAMESPACE,
          svg: SVG_NAMESPACE
        };
        function getIntrinsicNamespace(type) {
          switch (type) {
            case "svg":
              return SVG_NAMESPACE;
            case "math":
              return MATH_NAMESPACE;
            default:
              return HTML_NAMESPACE;
          }
        }
        function getChildNamespace(parentNamespace, type) {
          if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
            return getIntrinsicNamespace(type);
          }
          if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") {
            return HTML_NAMESPACE;
          }
          return parentNamespace;
        }
        var createMicrosoftUnsafeLocalFunction = function(func) {
          if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) {
            return function(arg0, arg1, arg2, arg3) {
              MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
              });
            };
          } else {
            return func;
          }
        };
        var reusableSVGContainer;
        var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
          if (node.namespaceURI === Namespaces.svg) {
            if (!("innerHTML" in node)) {
              reusableSVGContainer = reusableSVGContainer || document.createElement("div");
              reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
              var svgNode = reusableSVGContainer.firstChild;
              while (node.firstChild) {
                node.removeChild(node.firstChild);
              }
              while (svgNode.firstChild) {
                node.appendChild(svgNode.firstChild);
              }
              return;
            }
          }
          node.innerHTML = html;
        });
        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;
        var DOCUMENT_NODE = 9;
        var DOCUMENT_FRAGMENT_NODE = 11;
        var setTextContent = function(node, text) {
          if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
              firstChild.nodeValue = text;
              return;
            }
          }
          node.textContent = text;
        };
        var shorthandToLonghand = {
          animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
          background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
          backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
          border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
          borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
          borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
          borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
          borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
          borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
          borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
          borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
          borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
          borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
          borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
          borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
          columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
          columns: ["columnCount", "columnWidth"],
          flex: ["flexBasis", "flexGrow", "flexShrink"],
          flexFlow: ["flexDirection", "flexWrap"],
          font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
          fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
          gap: ["columnGap", "rowGap"],
          grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
          gridColumn: ["gridColumnEnd", "gridColumnStart"],
          gridColumnGap: ["columnGap"],
          gridGap: ["columnGap", "rowGap"],
          gridRow: ["gridRowEnd", "gridRowStart"],
          gridRowGap: ["rowGap"],
          gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
          margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
          marker: ["markerEnd", "markerMid", "markerStart"],
          mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
          maskPosition: ["maskPositionX", "maskPositionY"],
          outline: ["outlineColor", "outlineStyle", "outlineWidth"],
          overflow: ["overflowX", "overflowY"],
          padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
          placeContent: ["alignContent", "justifyContent"],
          placeItems: ["alignItems", "justifyItems"],
          placeSelf: ["alignSelf", "justifySelf"],
          textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
          textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
          transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
          wordWrap: ["overflowWrap"]
        };
        var isUnitlessNumber = {
          animationIterationCount: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridArea: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        };
        function prefixKey(prefix2, key) {
          return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
        }
        var prefixes = ["Webkit", "ms", "Moz", "O"];
        Object.keys(isUnitlessNumber).forEach(function(prop) {
          prefixes.forEach(function(prefix2) {
            isUnitlessNumber[prefixKey(prefix2, prop)] = isUnitlessNumber[prop];
          });
        });
        function dangerousStyleValue(name, value, isCustomProperty) {
          var isEmpty = value == null || typeof value === "boolean" || value === "";
          if (isEmpty) {
            return "";
          }
          if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
            return value + "px";
          }
          return ("" + value).trim();
        }
        var uppercasePattern = /([A-Z])/g;
        var msPattern = /^ms-/;
        function hyphenateStyleName(name) {
          return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
        }
        var warnValidStyle = function() {
        };
        {
          var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
          var msPattern$1 = /^-ms-/;
          var hyphenPattern = /-(.)/g;
          var badStyleValueWithSemicolonPattern = /;\s*$/;
          var warnedStyleNames = {};
          var warnedStyleValues = {};
          var warnedForNaNValue = false;
          var warnedForInfinityValue = false;
          var camelize = function(string) {
            return string.replace(hyphenPattern, function(_3, character) {
              return character.toUpperCase();
            });
          };
          var warnHyphenatedStyleName = function(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }
            warnedStyleNames[name] = true;
            error("Unsupported style property %s. Did you mean %s?", name, camelize(name.replace(msPattern$1, "ms-")));
          };
          var warnBadVendoredStyleName = function(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }
            warnedStyleNames[name] = true;
            error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
          };
          var warnStyleValueWithSemicolon = function(name, value) {
            if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
              return;
            }
            warnedStyleValues[value] = true;
            error(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, name, value.replace(badStyleValueWithSemicolonPattern, ""));
          };
          var warnStyleValueIsNaN = function(name, value) {
            if (warnedForNaNValue) {
              return;
            }
            warnedForNaNValue = true;
            error("`NaN` is an invalid value for the `%s` css style property.", name);
          };
          var warnStyleValueIsInfinity = function(name, value) {
            if (warnedForInfinityValue) {
              return;
            }
            warnedForInfinityValue = true;
            error("`Infinity` is an invalid value for the `%s` css style property.", name);
          };
          warnValidStyle = function(name, value) {
            if (name.indexOf("-") > -1) {
              warnHyphenatedStyleName(name);
            } else if (badVendoredStyleNamePattern.test(name)) {
              warnBadVendoredStyleName(name);
            } else if (badStyleValueWithSemicolonPattern.test(value)) {
              warnStyleValueWithSemicolon(name, value);
            }
            if (typeof value === "number") {
              if (isNaN(value)) {
                warnStyleValueIsNaN(name, value);
              } else if (!isFinite(value)) {
                warnStyleValueIsInfinity(name, value);
              }
            }
          };
        }
        var warnValidStyle$1 = warnValidStyle;
        function createDangerousStringForStyles(styles) {
          {
            var serialized = "";
            var delimiter = "";
            for (var styleName in styles) {
              if (!styles.hasOwnProperty(styleName)) {
                continue;
              }
              var styleValue = styles[styleName];
              if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
              }
            }
            return serialized || null;
          }
        }
        function setValueForStyles(node, styles) {
          var style2 = node.style;
          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }
            var isCustomProperty = styleName.indexOf("--") === 0;
            {
              if (!isCustomProperty) {
                warnValidStyle$1(styleName, styles[styleName]);
              }
            }
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") {
              styleName = "cssFloat";
            }
            if (isCustomProperty) {
              style2.setProperty(styleName, styleValue);
            } else {
              style2[styleName] = styleValue;
            }
          }
        }
        function isValueEmpty(value) {
          return value == null || typeof value === "boolean" || value === "";
        }
        function expandShorthandMap(styles) {
          var expanded = {};
          for (var key in styles) {
            var longhands = shorthandToLonghand[key] || [key];
            for (var i3 = 0; i3 < longhands.length; i3++) {
              expanded[longhands[i3]] = key;
            }
          }
          return expanded;
        }
        function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
          {
            if (!nextStyles) {
              return;
            }
            var expandedUpdates = expandShorthandMap(styleUpdates);
            var expandedStyles = expandShorthandMap(nextStyles);
            var warnedAbout = {};
            for (var key in expandedUpdates) {
              var originalKey = expandedUpdates[key];
              var correctOriginalKey = expandedStyles[key];
              if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) {
                  continue;
                }
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
              }
            }
          }
        }
        var omittedCloseTags = {
          area: true,
          base: true,
          br: true,
          col: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true
        };
        var voidElementTags = _assign({
          menuitem: true
        }, omittedCloseTags);
        var HTML = "__html";
        function assertValidProps(tag, props) {
          if (!props) {
            return;
          }
          if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
              {
                throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
              }
            }
          }
          if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) {
              {
                throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
              }
            }
            if (!(typeof props.dangerouslySetInnerHTML === "object" && HTML in props.dangerouslySetInnerHTML)) {
              {
                throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
              }
            }
          }
          {
            if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
              error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
            }
          }
          if (!(props.style == null || typeof props.style === "object")) {
            {
              throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
            }
          }
        }
        function isCustomComponent(tagName, props) {
          if (tagName.indexOf("-") === -1) {
            return typeof props.is === "string";
          }
          switch (tagName) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return false;
            default:
              return true;
          }
        }
        var possibleStandardNames = {
          accept: "accept",
          acceptcharset: "acceptCharset",
          "accept-charset": "acceptCharset",
          accesskey: "accessKey",
          action: "action",
          allowfullscreen: "allowFullScreen",
          alt: "alt",
          as: "as",
          async: "async",
          autocapitalize: "autoCapitalize",
          autocomplete: "autoComplete",
          autocorrect: "autoCorrect",
          autofocus: "autoFocus",
          autoplay: "autoPlay",
          autosave: "autoSave",
          capture: "capture",
          cellpadding: "cellPadding",
          cellspacing: "cellSpacing",
          challenge: "challenge",
          charset: "charSet",
          checked: "checked",
          children: "children",
          cite: "cite",
          class: "className",
          classid: "classID",
          classname: "className",
          cols: "cols",
          colspan: "colSpan",
          content: "content",
          contenteditable: "contentEditable",
          contextmenu: "contextMenu",
          controls: "controls",
          controlslist: "controlsList",
          coords: "coords",
          crossorigin: "crossOrigin",
          dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
          data: "data",
          datetime: "dateTime",
          default: "default",
          defaultchecked: "defaultChecked",
          defaultvalue: "defaultValue",
          defer: "defer",
          dir: "dir",
          disabled: "disabled",
          disablepictureinpicture: "disablePictureInPicture",
          disableremoteplayback: "disableRemotePlayback",
          download: "download",
          draggable: "draggable",
          enctype: "encType",
          enterkeyhint: "enterKeyHint",
          for: "htmlFor",
          form: "form",
          formmethod: "formMethod",
          formaction: "formAction",
          formenctype: "formEncType",
          formnovalidate: "formNoValidate",
          formtarget: "formTarget",
          frameborder: "frameBorder",
          headers: "headers",
          height: "height",
          hidden: "hidden",
          high: "high",
          href: "href",
          hreflang: "hrefLang",
          htmlfor: "htmlFor",
          httpequiv: "httpEquiv",
          "http-equiv": "httpEquiv",
          icon: "icon",
          id: "id",
          innerhtml: "innerHTML",
          inputmode: "inputMode",
          integrity: "integrity",
          is: "is",
          itemid: "itemID",
          itemprop: "itemProp",
          itemref: "itemRef",
          itemscope: "itemScope",
          itemtype: "itemType",
          keyparams: "keyParams",
          keytype: "keyType",
          kind: "kind",
          label: "label",
          lang: "lang",
          list: "list",
          loop: "loop",
          low: "low",
          manifest: "manifest",
          marginwidth: "marginWidth",
          marginheight: "marginHeight",
          max: "max",
          maxlength: "maxLength",
          media: "media",
          mediagroup: "mediaGroup",
          method: "method",
          min: "min",
          minlength: "minLength",
          multiple: "multiple",
          muted: "muted",
          name: "name",
          nomodule: "noModule",
          nonce: "nonce",
          novalidate: "noValidate",
          open: "open",
          optimum: "optimum",
          pattern: "pattern",
          placeholder: "placeholder",
          playsinline: "playsInline",
          poster: "poster",
          preload: "preload",
          profile: "profile",
          radiogroup: "radioGroup",
          readonly: "readOnly",
          referrerpolicy: "referrerPolicy",
          rel: "rel",
          required: "required",
          reversed: "reversed",
          role: "role",
          rows: "rows",
          rowspan: "rowSpan",
          sandbox: "sandbox",
          scope: "scope",
          scoped: "scoped",
          scrolling: "scrolling",
          seamless: "seamless",
          selected: "selected",
          shape: "shape",
          size: "size",
          sizes: "sizes",
          span: "span",
          spellcheck: "spellCheck",
          src: "src",
          srcdoc: "srcDoc",
          srclang: "srcLang",
          srcset: "srcSet",
          start: "start",
          step: "step",
          style: "style",
          summary: "summary",
          tabindex: "tabIndex",
          target: "target",
          title: "title",
          type: "type",
          usemap: "useMap",
          value: "value",
          width: "width",
          wmode: "wmode",
          wrap: "wrap",
          about: "about",
          accentheight: "accentHeight",
          "accent-height": "accentHeight",
          accumulate: "accumulate",
          additive: "additive",
          alignmentbaseline: "alignmentBaseline",
          "alignment-baseline": "alignmentBaseline",
          allowreorder: "allowReorder",
          alphabetic: "alphabetic",
          amplitude: "amplitude",
          arabicform: "arabicForm",
          "arabic-form": "arabicForm",
          ascent: "ascent",
          attributename: "attributeName",
          attributetype: "attributeType",
          autoreverse: "autoReverse",
          azimuth: "azimuth",
          basefrequency: "baseFrequency",
          baselineshift: "baselineShift",
          "baseline-shift": "baselineShift",
          baseprofile: "baseProfile",
          bbox: "bbox",
          begin: "begin",
          bias: "bias",
          by: "by",
          calcmode: "calcMode",
          capheight: "capHeight",
          "cap-height": "capHeight",
          clip: "clip",
          clippath: "clipPath",
          "clip-path": "clipPath",
          clippathunits: "clipPathUnits",
          cliprule: "clipRule",
          "clip-rule": "clipRule",
          color: "color",
          colorinterpolation: "colorInterpolation",
          "color-interpolation": "colorInterpolation",
          colorinterpolationfilters: "colorInterpolationFilters",
          "color-interpolation-filters": "colorInterpolationFilters",
          colorprofile: "colorProfile",
          "color-profile": "colorProfile",
          colorrendering: "colorRendering",
          "color-rendering": "colorRendering",
          contentscripttype: "contentScriptType",
          contentstyletype: "contentStyleType",
          cursor: "cursor",
          cx: "cx",
          cy: "cy",
          d: "d",
          datatype: "datatype",
          decelerate: "decelerate",
          descent: "descent",
          diffuseconstant: "diffuseConstant",
          direction: "direction",
          display: "display",
          divisor: "divisor",
          dominantbaseline: "dominantBaseline",
          "dominant-baseline": "dominantBaseline",
          dur: "dur",
          dx: "dx",
          dy: "dy",
          edgemode: "edgeMode",
          elevation: "elevation",
          enablebackground: "enableBackground",
          "enable-background": "enableBackground",
          end: "end",
          exponent: "exponent",
          externalresourcesrequired: "externalResourcesRequired",
          fill: "fill",
          fillopacity: "fillOpacity",
          "fill-opacity": "fillOpacity",
          fillrule: "fillRule",
          "fill-rule": "fillRule",
          filter: "filter",
          filterres: "filterRes",
          filterunits: "filterUnits",
          floodopacity: "floodOpacity",
          "flood-opacity": "floodOpacity",
          floodcolor: "floodColor",
          "flood-color": "floodColor",
          focusable: "focusable",
          fontfamily: "fontFamily",
          "font-family": "fontFamily",
          fontsize: "fontSize",
          "font-size": "fontSize",
          fontsizeadjust: "fontSizeAdjust",
          "font-size-adjust": "fontSizeAdjust",
          fontstretch: "fontStretch",
          "font-stretch": "fontStretch",
          fontstyle: "fontStyle",
          "font-style": "fontStyle",
          fontvariant: "fontVariant",
          "font-variant": "fontVariant",
          fontweight: "fontWeight",
          "font-weight": "fontWeight",
          format: "format",
          from: "from",
          fx: "fx",
          fy: "fy",
          g1: "g1",
          g2: "g2",
          glyphname: "glyphName",
          "glyph-name": "glyphName",
          glyphorientationhorizontal: "glyphOrientationHorizontal",
          "glyph-orientation-horizontal": "glyphOrientationHorizontal",
          glyphorientationvertical: "glyphOrientationVertical",
          "glyph-orientation-vertical": "glyphOrientationVertical",
          glyphref: "glyphRef",
          gradienttransform: "gradientTransform",
          gradientunits: "gradientUnits",
          hanging: "hanging",
          horizadvx: "horizAdvX",
          "horiz-adv-x": "horizAdvX",
          horizoriginx: "horizOriginX",
          "horiz-origin-x": "horizOriginX",
          ideographic: "ideographic",
          imagerendering: "imageRendering",
          "image-rendering": "imageRendering",
          in2: "in2",
          in: "in",
          inlist: "inlist",
          intercept: "intercept",
          k1: "k1",
          k2: "k2",
          k3: "k3",
          k4: "k4",
          k: "k",
          kernelmatrix: "kernelMatrix",
          kernelunitlength: "kernelUnitLength",
          kerning: "kerning",
          keypoints: "keyPoints",
          keysplines: "keySplines",
          keytimes: "keyTimes",
          lengthadjust: "lengthAdjust",
          letterspacing: "letterSpacing",
          "letter-spacing": "letterSpacing",
          lightingcolor: "lightingColor",
          "lighting-color": "lightingColor",
          limitingconeangle: "limitingConeAngle",
          local: "local",
          markerend: "markerEnd",
          "marker-end": "markerEnd",
          markerheight: "markerHeight",
          markermid: "markerMid",
          "marker-mid": "markerMid",
          markerstart: "markerStart",
          "marker-start": "markerStart",
          markerunits: "markerUnits",
          markerwidth: "markerWidth",
          mask: "mask",
          maskcontentunits: "maskContentUnits",
          maskunits: "maskUnits",
          mathematical: "mathematical",
          mode: "mode",
          numoctaves: "numOctaves",
          offset: "offset",
          opacity: "opacity",
          operator: "operator",
          order: "order",
          orient: "orient",
          orientation: "orientation",
          origin: "origin",
          overflow: "overflow",
          overlineposition: "overlinePosition",
          "overline-position": "overlinePosition",
          overlinethickness: "overlineThickness",
          "overline-thickness": "overlineThickness",
          paintorder: "paintOrder",
          "paint-order": "paintOrder",
          panose1: "panose1",
          "panose-1": "panose1",
          pathlength: "pathLength",
          patterncontentunits: "patternContentUnits",
          patterntransform: "patternTransform",
          patternunits: "patternUnits",
          pointerevents: "pointerEvents",
          "pointer-events": "pointerEvents",
          points: "points",
          pointsatx: "pointsAtX",
          pointsaty: "pointsAtY",
          pointsatz: "pointsAtZ",
          prefix: "prefix",
          preservealpha: "preserveAlpha",
          preserveaspectratio: "preserveAspectRatio",
          primitiveunits: "primitiveUnits",
          property: "property",
          r: "r",
          radius: "radius",
          refx: "refX",
          refy: "refY",
          renderingintent: "renderingIntent",
          "rendering-intent": "renderingIntent",
          repeatcount: "repeatCount",
          repeatdur: "repeatDur",
          requiredextensions: "requiredExtensions",
          requiredfeatures: "requiredFeatures",
          resource: "resource",
          restart: "restart",
          result: "result",
          results: "results",
          rotate: "rotate",
          rx: "rx",
          ry: "ry",
          scale: "scale",
          security: "security",
          seed: "seed",
          shaperendering: "shapeRendering",
          "shape-rendering": "shapeRendering",
          slope: "slope",
          spacing: "spacing",
          specularconstant: "specularConstant",
          specularexponent: "specularExponent",
          speed: "speed",
          spreadmethod: "spreadMethod",
          startoffset: "startOffset",
          stddeviation: "stdDeviation",
          stemh: "stemh",
          stemv: "stemv",
          stitchtiles: "stitchTiles",
          stopcolor: "stopColor",
          "stop-color": "stopColor",
          stopopacity: "stopOpacity",
          "stop-opacity": "stopOpacity",
          strikethroughposition: "strikethroughPosition",
          "strikethrough-position": "strikethroughPosition",
          strikethroughthickness: "strikethroughThickness",
          "strikethrough-thickness": "strikethroughThickness",
          string: "string",
          stroke: "stroke",
          strokedasharray: "strokeDasharray",
          "stroke-dasharray": "strokeDasharray",
          strokedashoffset: "strokeDashoffset",
          "stroke-dashoffset": "strokeDashoffset",
          strokelinecap: "strokeLinecap",
          "stroke-linecap": "strokeLinecap",
          strokelinejoin: "strokeLinejoin",
          "stroke-linejoin": "strokeLinejoin",
          strokemiterlimit: "strokeMiterlimit",
          "stroke-miterlimit": "strokeMiterlimit",
          strokewidth: "strokeWidth",
          "stroke-width": "strokeWidth",
          strokeopacity: "strokeOpacity",
          "stroke-opacity": "strokeOpacity",
          suppresscontenteditablewarning: "suppressContentEditableWarning",
          suppresshydrationwarning: "suppressHydrationWarning",
          surfacescale: "surfaceScale",
          systemlanguage: "systemLanguage",
          tablevalues: "tableValues",
          targetx: "targetX",
          targety: "targetY",
          textanchor: "textAnchor",
          "text-anchor": "textAnchor",
          textdecoration: "textDecoration",
          "text-decoration": "textDecoration",
          textlength: "textLength",
          textrendering: "textRendering",
          "text-rendering": "textRendering",
          to: "to",
          transform: "transform",
          typeof: "typeof",
          u1: "u1",
          u2: "u2",
          underlineposition: "underlinePosition",
          "underline-position": "underlinePosition",
          underlinethickness: "underlineThickness",
          "underline-thickness": "underlineThickness",
          unicode: "unicode",
          unicodebidi: "unicodeBidi",
          "unicode-bidi": "unicodeBidi",
          unicoderange: "unicodeRange",
          "unicode-range": "unicodeRange",
          unitsperem: "unitsPerEm",
          "units-per-em": "unitsPerEm",
          unselectable: "unselectable",
          valphabetic: "vAlphabetic",
          "v-alphabetic": "vAlphabetic",
          values: "values",
          vectoreffect: "vectorEffect",
          "vector-effect": "vectorEffect",
          version: "version",
          vertadvy: "vertAdvY",
          "vert-adv-y": "vertAdvY",
          vertoriginx: "vertOriginX",
          "vert-origin-x": "vertOriginX",
          vertoriginy: "vertOriginY",
          "vert-origin-y": "vertOriginY",
          vhanging: "vHanging",
          "v-hanging": "vHanging",
          videographic: "vIdeographic",
          "v-ideographic": "vIdeographic",
          viewbox: "viewBox",
          viewtarget: "viewTarget",
          visibility: "visibility",
          vmathematical: "vMathematical",
          "v-mathematical": "vMathematical",
          vocab: "vocab",
          widths: "widths",
          wordspacing: "wordSpacing",
          "word-spacing": "wordSpacing",
          writingmode: "writingMode",
          "writing-mode": "writingMode",
          x1: "x1",
          x2: "x2",
          x: "x",
          xchannelselector: "xChannelSelector",
          xheight: "xHeight",
          "x-height": "xHeight",
          xlinkactuate: "xlinkActuate",
          "xlink:actuate": "xlinkActuate",
          xlinkarcrole: "xlinkArcrole",
          "xlink:arcrole": "xlinkArcrole",
          xlinkhref: "xlinkHref",
          "xlink:href": "xlinkHref",
          xlinkrole: "xlinkRole",
          "xlink:role": "xlinkRole",
          xlinkshow: "xlinkShow",
          "xlink:show": "xlinkShow",
          xlinktitle: "xlinkTitle",
          "xlink:title": "xlinkTitle",
          xlinktype: "xlinkType",
          "xlink:type": "xlinkType",
          xmlbase: "xmlBase",
          "xml:base": "xmlBase",
          xmllang: "xmlLang",
          "xml:lang": "xmlLang",
          xmlns: "xmlns",
          "xml:space": "xmlSpace",
          xmlnsxlink: "xmlnsXlink",
          "xmlns:xlink": "xmlnsXlink",
          xmlspace: "xmlSpace",
          y1: "y1",
          y2: "y2",
          y: "y",
          ychannelselector: "yChannelSelector",
          z: "z",
          zoomandpan: "zoomAndPan"
        };
        var ariaProperties = {
          "aria-current": 0,
          "aria-details": 0,
          "aria-disabled": 0,
          "aria-hidden": 0,
          "aria-invalid": 0,
          "aria-keyshortcuts": 0,
          "aria-label": 0,
          "aria-roledescription": 0,
          "aria-autocomplete": 0,
          "aria-checked": 0,
          "aria-expanded": 0,
          "aria-haspopup": 0,
          "aria-level": 0,
          "aria-modal": 0,
          "aria-multiline": 0,
          "aria-multiselectable": 0,
          "aria-orientation": 0,
          "aria-placeholder": 0,
          "aria-pressed": 0,
          "aria-readonly": 0,
          "aria-required": 0,
          "aria-selected": 0,
          "aria-sort": 0,
          "aria-valuemax": 0,
          "aria-valuemin": 0,
          "aria-valuenow": 0,
          "aria-valuetext": 0,
          "aria-atomic": 0,
          "aria-busy": 0,
          "aria-live": 0,
          "aria-relevant": 0,
          "aria-dropeffect": 0,
          "aria-grabbed": 0,
          "aria-activedescendant": 0,
          "aria-colcount": 0,
          "aria-colindex": 0,
          "aria-colspan": 0,
          "aria-controls": 0,
          "aria-describedby": 0,
          "aria-errormessage": 0,
          "aria-flowto": 0,
          "aria-labelledby": 0,
          "aria-owns": 0,
          "aria-posinset": 0,
          "aria-rowcount": 0,
          "aria-rowindex": 0,
          "aria-rowspan": 0,
          "aria-setsize": 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
        var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
        var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
        function validateProperty(tagName, name) {
          {
            if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
              return true;
            }
            if (rARIACamel.test(name)) {
              var ariaName = "aria-" + name.slice(4).toLowerCase();
              var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;
              if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
              }
              if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
              }
            }
            if (rARIA.test(name)) {
              var lowerCasedName = name.toLowerCase();
              var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;
              if (standardName == null) {
                warnedProperties[name] = true;
                return false;
              }
              if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
              }
            }
          }
          return true;
        }
        function warnInvalidARIAProps(type, props) {
          {
            var invalidProps = [];
            for (var key in props) {
              var isValid = validateProperty(type, key);
              if (!isValid) {
                invalidProps.push(key);
              }
            }
            var unknownPropString = invalidProps.map(function(prop) {
              return "`" + prop + "`";
            }).join(", ");
            if (invalidProps.length === 1) {
              error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
            } else if (invalidProps.length > 1) {
              error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
            }
          }
        }
        function validateProperties(type, props) {
          if (isCustomComponent(type, props)) {
            return;
          }
          warnInvalidARIAProps(type, props);
        }
        var didWarnValueNull = false;
        function validateProperties$1(type, props) {
          {
            if (type !== "input" && type !== "textarea" && type !== "select") {
              return;
            }
            if (props != null && props.value === null && !didWarnValueNull) {
              didWarnValueNull = true;
              if (type === "select" && props.multiple) {
                error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
              } else {
                error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
              }
            }
          }
        }
        var validateProperty$1 = function() {
        };
        {
          var warnedProperties$1 = {};
          var _hasOwnProperty = Object.prototype.hasOwnProperty;
          var EVENT_NAME_REGEX = /^on./;
          var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
          var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
          var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
          validateProperty$1 = function(tagName, name, value, eventRegistry) {
            if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
              return true;
            }
            var lowerCasedName = name.toLowerCase();
            if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
              error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (eventRegistry != null) {
              var registrationNameDependencies2 = eventRegistry.registrationNameDependencies, possibleRegistrationNames2 = eventRegistry.possibleRegistrationNames;
              if (registrationNameDependencies2.hasOwnProperty(name)) {
                return true;
              }
              var registrationName = possibleRegistrationNames2.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames2[lowerCasedName] : null;
              if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
              }
              if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (EVENT_NAME_REGEX.test(name)) {
              if (INVALID_EVENT_NAME_REGEX.test(name)) {
                error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
              }
              warnedProperties$1[name] = true;
              return true;
            }
            if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
              return true;
            }
            if (lowerCasedName === "innerhtml") {
              error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (lowerCasedName === "aria") {
              error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (lowerCasedName === "is" && value !== null && value !== void 0 && typeof value !== "string") {
              error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
              warnedProperties$1[name] = true;
              return true;
            }
            if (typeof value === "number" && isNaN(value)) {
              error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
              warnedProperties$1[name] = true;
              return true;
            }
            var propertyInfo = getPropertyInfo(name);
            var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;
            if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              var standardName = possibleStandardNames[lowerCasedName];
              if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (!isReserved && name !== lowerCasedName) {
              error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
              warnedProperties$1[name] = true;
              return true;
            }
            if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              if (value) {
                error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
              } else {
                error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
              }
              warnedProperties$1[name] = true;
              return true;
            }
            if (isReserved) {
              return true;
            }
            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              warnedProperties$1[name] = true;
              return false;
            }
            if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
              error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
              warnedProperties$1[name] = true;
              return true;
            }
            return true;
          };
        }
        var warnUnknownProperties = function(type, props, eventRegistry) {
          {
            var unknownProps = [];
            for (var key in props) {
              var isValid = validateProperty$1(type, key, props[key], eventRegistry);
              if (!isValid) {
                unknownProps.push(key);
              }
            }
            var unknownPropString = unknownProps.map(function(prop) {
              return "`" + prop + "`";
            }).join(", ");
            if (unknownProps.length === 1) {
              error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
            } else if (unknownProps.length > 1) {
              error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
            }
          }
        };
        function validateProperties$2(type, props, eventRegistry) {
          if (isCustomComponent(type, props)) {
            return;
          }
          warnUnknownProperties(type, props, eventRegistry);
        }
        var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
        var IS_NON_DELEGATED = 1 << 1;
        var IS_CAPTURE_PHASE = 1 << 2;
        var IS_REPLAYED = 1 << 4;
        var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
        function getEventTarget(nativeEvent) {
          var target = nativeEvent.target || nativeEvent.srcElement || window;
          if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
          }
          return target.nodeType === TEXT_NODE ? target.parentNode : target;
        }
        var restoreImpl = null;
        var restoreTarget = null;
        var restoreQueue = null;
        function restoreStateOfTarget(target) {
          var internalInstance = getInstanceFromNode(target);
          if (!internalInstance) {
            return;
          }
          if (!(typeof restoreImpl === "function")) {
            {
              throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var stateNode = internalInstance.stateNode;
          if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
          }
        }
        function setRestoreImplementation(impl) {
          restoreImpl = impl;
        }
        function enqueueStateRestore(target) {
          if (restoreTarget) {
            if (restoreQueue) {
              restoreQueue.push(target);
            } else {
              restoreQueue = [target];
            }
          } else {
            restoreTarget = target;
          }
        }
        function needsStateRestore() {
          return restoreTarget !== null || restoreQueue !== null;
        }
        function restoreStateIfNeeded() {
          if (!restoreTarget) {
            return;
          }
          var target = restoreTarget;
          var queuedTargets = restoreQueue;
          restoreTarget = null;
          restoreQueue = null;
          restoreStateOfTarget(target);
          if (queuedTargets) {
            for (var i3 = 0; i3 < queuedTargets.length; i3++) {
              restoreStateOfTarget(queuedTargets[i3]);
            }
          }
        }
        var batchedUpdatesImpl = function(fn2, bookkeeping) {
          return fn2(bookkeeping);
        };
        var discreteUpdatesImpl = function(fn2, a4, b4, c3, d3) {
          return fn2(a4, b4, c3, d3);
        };
        var flushDiscreteUpdatesImpl = function() {
        };
        var batchedEventUpdatesImpl = batchedUpdatesImpl;
        var isInsideEventHandler = false;
        var isBatchingEventUpdates = false;
        function finishEventHandler() {
          var controlledComponentsHavePendingUpdates = needsStateRestore();
          if (controlledComponentsHavePendingUpdates) {
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
          }
        }
        function batchedUpdates(fn2, bookkeeping) {
          if (isInsideEventHandler) {
            return fn2(bookkeeping);
          }
          isInsideEventHandler = true;
          try {
            return batchedUpdatesImpl(fn2, bookkeeping);
          } finally {
            isInsideEventHandler = false;
            finishEventHandler();
          }
        }
        function batchedEventUpdates(fn2, a4, b4) {
          if (isBatchingEventUpdates) {
            return fn2(a4, b4);
          }
          isBatchingEventUpdates = true;
          try {
            return batchedEventUpdatesImpl(fn2, a4, b4);
          } finally {
            isBatchingEventUpdates = false;
            finishEventHandler();
          }
        }
        function discreteUpdates(fn2, a4, b4, c3, d3) {
          var prevIsInsideEventHandler = isInsideEventHandler;
          isInsideEventHandler = true;
          try {
            return discreteUpdatesImpl(fn2, a4, b4, c3, d3);
          } finally {
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) {
              finishEventHandler();
            }
          }
        }
        function flushDiscreteUpdatesIfNeeded(timeStamp) {
          {
            if (!isInsideEventHandler) {
              flushDiscreteUpdatesImpl();
            }
          }
        }
        function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
          batchedUpdatesImpl = _batchedUpdatesImpl;
          discreteUpdatesImpl = _discreteUpdatesImpl;
          flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
          batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
        }
        function isInteractive(tag) {
          return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
        }
        function shouldPreventMouseEvent(name, type, props) {
          switch (name) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              return !!(props.disabled && isInteractive(type));
            default:
              return false;
          }
        }
        function getListener(inst, registrationName) {
          var stateNode = inst.stateNode;
          if (stateNode === null) {
            return null;
          }
          var props = getFiberCurrentPropsFromNode(stateNode);
          if (props === null) {
            return null;
          }
          var listener = props[registrationName];
          if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
            return null;
          }
          if (!(!listener || typeof listener === "function")) {
            {
              throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
            }
          }
          return listener;
        }
        var passiveBrowserEventsSupported = false;
        if (canUseDOM2) {
          try {
            var options2 = {};
            Object.defineProperty(options2, "passive", {
              get: function() {
                passiveBrowserEventsSupported = true;
              }
            });
            window.addEventListener("test", options2, options2);
            window.removeEventListener("test", options2, options2);
          } catch (e2) {
            passiveBrowserEventsSupported = false;
          }
        }
        function invokeGuardedCallbackProd(name, func, context3, a4, b4, c3, d3, e2, f3) {
          var funcArgs = Array.prototype.slice.call(arguments, 3);
          try {
            func.apply(context3, funcArgs);
          } catch (error2) {
            this.onError(error2);
          }
        }
        var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
        {
          if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
            var fakeNode = document.createElement("react");
            invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context3, a4, b4, c3, d3, e2, f3) {
              if (!(typeof document !== "undefined")) {
                {
                  throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
                }
              }
              var evt = document.createEvent("Event");
              var didCall = false;
              var didError = true;
              var windowEvent = window.event;
              var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
              function restoreAfterDispatch() {
                fakeNode.removeEventListener(evtType, callCallback2, false);
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) {
                  window.event = windowEvent;
                }
              }
              var funcArgs = Array.prototype.slice.call(arguments, 3);
              function callCallback2() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context3, funcArgs);
                didError = false;
              }
              var error2;
              var didSetError = false;
              var isCrossOriginError = false;
              function handleWindowError(event) {
                error2 = event.error;
                didSetError = true;
                if (error2 === null && event.colno === 0 && event.lineno === 0) {
                  isCrossOriginError = true;
                }
                if (event.defaultPrevented) {
                  if (error2 != null && typeof error2 === "object") {
                    try {
                      error2._suppressLogging = true;
                    } catch (inner) {
                    }
                  }
                }
              }
              var evtType = "react-" + (name ? name : "invokeguardedcallback");
              window.addEventListener("error", handleWindowError);
              fakeNode.addEventListener(evtType, callCallback2, false);
              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);
              if (windowEventDescriptor) {
                Object.defineProperty(window, "event", windowEventDescriptor);
              }
              if (didCall && didError) {
                if (!didSetError) {
                  error2 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`);
                } else if (isCrossOriginError) {
                  error2 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                }
                this.onError(error2);
              }
              window.removeEventListener("error", handleWindowError);
              if (!didCall) {
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
              }
            };
          }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null;
        var hasRethrowError = false;
        var rethrowError = null;
        var reporter = {
          onError: function(error2) {
            hasError = true;
            caughtError = error2;
          }
        };
        function invokeGuardedCallback(name, func, context3, a4, b4, c3, d3, e2, f3) {
          hasError = false;
          caughtError = null;
          invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        function invokeGuardedCallbackAndCatchFirstError(name, func, context3, a4, b4, c3, d3, e2, f3) {
          invokeGuardedCallback.apply(this, arguments);
          if (hasError) {
            var error2 = clearCaughtError();
            if (!hasRethrowError) {
              hasRethrowError = true;
              rethrowError = error2;
            }
          }
        }
        function rethrowCaughtError() {
          if (hasRethrowError) {
            var error2 = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error2;
          }
        }
        function hasCaughtError() {
          return hasError;
        }
        function clearCaughtError() {
          if (hasError) {
            var error2 = caughtError;
            hasError = false;
            caughtError = null;
            return error2;
          } else {
            {
              {
                throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        function get2(key) {
          return key._reactInternals;
        }
        function has(key) {
          return key._reactInternals !== void 0;
        }
        function set2(key, value) {
          key._reactInternals = value;
        }
        var NoFlags = 0;
        var PerformedWork = 1;
        var Placement = 2;
        var Update = 4;
        var PlacementAndUpdate = 6;
        var Deletion = 8;
        var ContentReset = 16;
        var Callback = 32;
        var DidCapture = 64;
        var Ref = 128;
        var Snapshot = 256;
        var Passive = 512;
        var PassiveUnmountPendingDev = 8192;
        var Hydrating = 1024;
        var HydratingAndUpdate = 1028;
        var LifecycleEffectMask = 932;
        var HostEffectMask = 2047;
        var Incomplete = 2048;
        var ShouldCapture = 4096;
        var ForceUpdateForLegacySuspense = 16384;
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        function getNearestMountedFiber(fiber) {
          var node = fiber;
          var nearestMounted = fiber;
          if (!fiber.alternate) {
            var nextNode = node;
            do {
              node = nextNode;
              if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
                nearestMounted = node.return;
              }
              nextNode = node.return;
            } while (nextNode);
          } else {
            while (node.return) {
              node = node.return;
            }
          }
          if (node.tag === HostRoot) {
            return nearestMounted;
          }
          return null;
        }
        function getSuspenseInstanceFromFiber(fiber) {
          if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
              var current2 = fiber.alternate;
              if (current2 !== null) {
                suspenseState = current2.memoizedState;
              }
            }
            if (suspenseState !== null) {
              return suspenseState.dehydrated;
            }
          }
          return null;
        }
        function getContainerFromFiber(fiber) {
          return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
        }
        function isFiberMounted(fiber) {
          return getNearestMountedFiber(fiber) === fiber;
        }
        function isMounted(component) {
          {
            var owner = ReactCurrentOwner.current;
            if (owner !== null && owner.tag === ClassComponent) {
              var ownerFiber = owner;
              var instance = ownerFiber.stateNode;
              if (!instance._warnedAboutRefsInRender) {
                error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
              }
              instance._warnedAboutRefsInRender = true;
            }
          }
          var fiber = get2(component);
          if (!fiber) {
            return false;
          }
          return getNearestMountedFiber(fiber) === fiber;
        }
        function assertIsMounted(fiber) {
          if (!(getNearestMountedFiber(fiber) === fiber)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
        }
        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;
          if (!alternate) {
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
            if (nearestMounted !== fiber) {
              return null;
            }
            return fiber;
          }
          var a4 = fiber;
          var b4 = alternate;
          while (true) {
            var parentA = a4.return;
            if (parentA === null) {
              break;
            }
            var parentB = parentA.alternate;
            if (parentB === null) {
              var nextParent = parentA.return;
              if (nextParent !== null) {
                a4 = b4 = nextParent;
                continue;
              }
              break;
            }
            if (parentA.child === parentB.child) {
              var child = parentA.child;
              while (child) {
                if (child === a4) {
                  assertIsMounted(parentA);
                  return fiber;
                }
                if (child === b4) {
                  assertIsMounted(parentA);
                  return alternate;
                }
                child = child.sibling;
              }
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            }
            if (a4.return !== b4.return) {
              a4 = parentA;
              b4 = parentB;
            } else {
              var didFindChild = false;
              var _child = parentA.child;
              while (_child) {
                if (_child === a4) {
                  didFindChild = true;
                  a4 = parentA;
                  b4 = parentB;
                  break;
                }
                if (_child === b4) {
                  didFindChild = true;
                  b4 = parentA;
                  a4 = parentB;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                _child = parentB.child;
                while (_child) {
                  if (_child === a4) {
                    didFindChild = true;
                    a4 = parentB;
                    b4 = parentA;
                    break;
                  }
                  if (_child === b4) {
                    didFindChild = true;
                    b4 = parentB;
                    a4 = parentA;
                    break;
                  }
                  _child = _child.sibling;
                }
                if (!didFindChild) {
                  {
                    throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                  }
                }
              }
            }
            if (!(a4.alternate === b4)) {
              {
                throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (!(a4.tag === HostRoot)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (a4.stateNode.current === a4) {
            return fiber;
          }
          return alternate;
        }
        function findCurrentHostFiber(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);
          if (!currentParent) {
            return null;
          }
          var node = currentParent;
          while (true) {
            if (node.tag === HostComponent || node.tag === HostText) {
              return node;
            } else if (node.child) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === currentParent) {
              return null;
            }
            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
          return null;
        }
        function findCurrentHostFiberWithNoPortals(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);
          if (!currentParent) {
            return null;
          }
          var node = currentParent;
          while (true) {
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) {
              return node;
            } else if (node.child && node.tag !== HostPortal) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === currentParent) {
              return null;
            }
            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
          return null;
        }
        function doesFiberContain(parentFiber, childFiber) {
          var node = childFiber;
          var parentFiberAlternate = parentFiber.alternate;
          while (node !== null) {
            if (node === parentFiber || node === parentFiberAlternate) {
              return true;
            }
            node = node.return;
          }
          return false;
        }
        var attemptUserBlockingHydration;
        function setAttemptUserBlockingHydration(fn2) {
          attemptUserBlockingHydration = fn2;
        }
        var attemptContinuousHydration;
        function setAttemptContinuousHydration(fn2) {
          attemptContinuousHydration = fn2;
        }
        var attemptHydrationAtCurrentPriority;
        function setAttemptHydrationAtCurrentPriority(fn2) {
          attemptHydrationAtCurrentPriority = fn2;
        }
        var attemptHydrationAtPriority;
        function setAttemptHydrationAtPriority(fn2) {
          attemptHydrationAtPriority = fn2;
        }
        var hasScheduledReplayAttempt = false;
        var queuedDiscreteEvents = [];
        var queuedFocus = null;
        var queuedDrag = null;
        var queuedMouse = null;
        var queuedPointers = new Map();
        var queuedPointerCaptures = new Map();
        var queuedExplicitHydrationTargets = [];
        function hasQueuedDiscreteEvents() {
          return queuedDiscreteEvents.length > 0;
        }
        var discreteReplayableEvents = [
          "mousedown",
          "mouseup",
          "touchcancel",
          "touchend",
          "touchstart",
          "auxclick",
          "dblclick",
          "pointercancel",
          "pointerdown",
          "pointerup",
          "dragend",
          "dragstart",
          "drop",
          "compositionend",
          "compositionstart",
          "keydown",
          "keypress",
          "keyup",
          "input",
          "textInput",
          "copy",
          "cut",
          "paste",
          "click",
          "change",
          "contextmenu",
          "reset",
          "submit"
        ];
        function isReplayableDiscreteEvent(eventType) {
          return discreteReplayableEvents.indexOf(eventType) > -1;
        }
        function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          return {
            blockedOn,
            domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent,
            targetContainers: [targetContainer]
          };
        }
        function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
          queuedDiscreteEvents.push(queuedEvent);
        }
        function clearIfContinuousEvent(domEventName, nativeEvent) {
          switch (domEventName) {
            case "focusin":
            case "focusout":
              queuedFocus = null;
              break;
            case "dragenter":
            case "dragleave":
              queuedDrag = null;
              break;
            case "mouseover":
            case "mouseout":
              queuedMouse = null;
              break;
            case "pointerover":
            case "pointerout": {
              var pointerId = nativeEvent.pointerId;
              queuedPointers.delete(pointerId);
              break;
            }
            case "gotpointercapture":
            case "lostpointercapture": {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures.delete(_pointerId);
              break;
            }
          }
        }
        function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
              var _fiber2 = getInstanceFromNode(blockedOn);
              if (_fiber2 !== null) {
                attemptContinuousHydration(_fiber2);
              }
            }
            return queuedEvent;
          }
          existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
          var targetContainers = existingQueuedEvent.targetContainers;
          if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
            targetContainers.push(targetContainer);
          }
          return existingQueuedEvent;
        }
        function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          switch (domEventName) {
            case "focusin": {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
              return true;
            }
            case "dragenter": {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
              return true;
            }
            case "mouseover": {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
              return true;
            }
            case "pointerover": {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
              return true;
            }
            case "gotpointercapture": {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
              return true;
            }
          }
          return false;
        }
        function attemptExplicitHydrationTarget(queuedTarget) {
          var targetInst = getClosestInstanceFromNode(queuedTarget.target);
          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
              var tag = nearestMounted.tag;
              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);
                if (instance !== null) {
                  queuedTarget.blockedOn = instance;
                  attemptHydrationAtPriority(queuedTarget.lanePriority, function() {
                    Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                      attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                  });
                  return;
                }
              } else if (tag === HostRoot) {
                var root4 = nearestMounted.stateNode;
                if (root4.hydrate) {
                  queuedTarget.blockedOn = getContainerFromFiber(nearestMounted);
                  return;
                }
              }
            }
          }
          queuedTarget.blockedOn = null;
        }
        function attemptReplayContinuousQueuedEvent(queuedEvent) {
          if (queuedEvent.blockedOn !== null) {
            return false;
          }
          var targetContainers = queuedEvent.targetContainers;
          while (targetContainers.length > 0) {
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn !== null) {
              var _fiber3 = getInstanceFromNode(nextBlockedOn);
              if (_fiber3 !== null) {
                attemptContinuousHydration(_fiber3);
              }
              queuedEvent.blockedOn = nextBlockedOn;
              return false;
            }
            targetContainers.shift();
          }
          return true;
        }
        function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
          if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
            map.delete(key);
          }
        }
        function replayUnblockedEvents() {
          hasScheduledReplayAttempt = false;
          while (queuedDiscreteEvents.length > 0) {
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
              var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
              if (_fiber4 !== null) {
                attemptUserBlockingHydration(_fiber4);
              }
              break;
            }
            var targetContainers = nextDiscreteEvent.targetContainers;
            while (targetContainers.length > 0) {
              var targetContainer = targetContainers[0];
              var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
              if (nextBlockedOn !== null) {
                nextDiscreteEvent.blockedOn = nextBlockedOn;
                break;
              }
              targetContainers.shift();
            }
            if (nextDiscreteEvent.blockedOn === null) {
              queuedDiscreteEvents.shift();
            }
          }
          if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
            queuedFocus = null;
          }
          if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
            queuedDrag = null;
          }
          if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
            queuedMouse = null;
          }
          queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
          queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
        }
        function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
          if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
              hasScheduledReplayAttempt = true;
              Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
          }
        }
        function retryIfBlockedOn(unblocked) {
          if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked);
            for (var i3 = 1; i3 < queuedDiscreteEvents.length; i3++) {
              var queuedEvent = queuedDiscreteEvents[i3];
              if (queuedEvent.blockedOn === unblocked) {
                queuedEvent.blockedOn = null;
              }
            }
          }
          if (queuedFocus !== null) {
            scheduleCallbackIfUnblocked(queuedFocus, unblocked);
          }
          if (queuedDrag !== null) {
            scheduleCallbackIfUnblocked(queuedDrag, unblocked);
          }
          if (queuedMouse !== null) {
            scheduleCallbackIfUnblocked(queuedMouse, unblocked);
          }
          var unblock = function(queuedEvent2) {
            return scheduleCallbackIfUnblocked(queuedEvent2, unblocked);
          };
          queuedPointers.forEach(unblock);
          queuedPointerCaptures.forEach(unblock);
          for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) {
              queuedTarget.blockedOn = null;
            }
          }
          while (queuedExplicitHydrationTargets.length > 0) {
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) {
              break;
            } else {
              attemptExplicitHydrationTarget(nextExplicitTarget);
              if (nextExplicitTarget.blockedOn === null) {
                queuedExplicitHydrationTargets.shift();
              }
            }
          }
        }
        var DiscreteEvent = 0;
        var UserBlockingEvent = 1;
        var ContinuousEvent = 2;
        function makePrefixMap(styleProp, eventName) {
          var prefixes2 = {};
          prefixes2[styleProp.toLowerCase()] = eventName.toLowerCase();
          prefixes2["Webkit" + styleProp] = "webkit" + eventName;
          prefixes2["Moz" + styleProp] = "moz" + eventName;
          return prefixes2;
        }
        var vendorPrefixes = {
          animationend: makePrefixMap("Animation", "AnimationEnd"),
          animationiteration: makePrefixMap("Animation", "AnimationIteration"),
          animationstart: makePrefixMap("Animation", "AnimationStart"),
          transitionend: makePrefixMap("Transition", "TransitionEnd")
        };
        var prefixedEventNames = {};
        var style = {};
        if (canUseDOM2) {
          style = document.createElement("div").style;
          if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
          }
          if (!("TransitionEvent" in window)) {
            delete vendorPrefixes.transitionend.transition;
          }
        }
        function getVendorPrefixedEventName(eventName) {
          if (prefixedEventNames[eventName]) {
            return prefixedEventNames[eventName];
          } else if (!vendorPrefixes[eventName]) {
            return eventName;
          }
          var prefixMap = vendorPrefixes[eventName];
          for (var styleProp in prefixMap) {
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
              return prefixedEventNames[eventName] = prefixMap[styleProp];
            }
          }
          return eventName;
        }
        var ANIMATION_END = getVendorPrefixedEventName("animationend");
        var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
        var ANIMATION_START = getVendorPrefixedEventName("animationstart");
        var TRANSITION_END = getVendorPrefixedEventName("transitionend");
        var topLevelEventsToReactNames = new Map();
        var eventPriorities = new Map();
        var discreteEventPairsForSimpleEventPlugin = [
          "cancel",
          "cancel",
          "click",
          "click",
          "close",
          "close",
          "contextmenu",
          "contextMenu",
          "copy",
          "copy",
          "cut",
          "cut",
          "auxclick",
          "auxClick",
          "dblclick",
          "doubleClick",
          "dragend",
          "dragEnd",
          "dragstart",
          "dragStart",
          "drop",
          "drop",
          "focusin",
          "focus",
          "focusout",
          "blur",
          "input",
          "input",
          "invalid",
          "invalid",
          "keydown",
          "keyDown",
          "keypress",
          "keyPress",
          "keyup",
          "keyUp",
          "mousedown",
          "mouseDown",
          "mouseup",
          "mouseUp",
          "paste",
          "paste",
          "pause",
          "pause",
          "play",
          "play",
          "pointercancel",
          "pointerCancel",
          "pointerdown",
          "pointerDown",
          "pointerup",
          "pointerUp",
          "ratechange",
          "rateChange",
          "reset",
          "reset",
          "seeked",
          "seeked",
          "submit",
          "submit",
          "touchcancel",
          "touchCancel",
          "touchend",
          "touchEnd",
          "touchstart",
          "touchStart",
          "volumechange",
          "volumeChange"
        ];
        var otherDiscreteEvents = ["change", "selectionchange", "textInput", "compositionstart", "compositionend", "compositionupdate"];
        var userBlockingPairsForSimpleEventPlugin = ["drag", "drag", "dragenter", "dragEnter", "dragexit", "dragExit", "dragleave", "dragLeave", "dragover", "dragOver", "mousemove", "mouseMove", "mouseout", "mouseOut", "mouseover", "mouseOver", "pointermove", "pointerMove", "pointerout", "pointerOut", "pointerover", "pointerOver", "scroll", "scroll", "toggle", "toggle", "touchmove", "touchMove", "wheel", "wheel"];
        var continuousPairsForSimpleEventPlugin = ["abort", "abort", ANIMATION_END, "animationEnd", ANIMATION_ITERATION, "animationIteration", ANIMATION_START, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", TRANSITION_END, "transitionEnd", "waiting", "waiting"];
        function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
          for (var i3 = 0; i3 < eventTypes.length; i3 += 2) {
            var topEvent = eventTypes[i3];
            var event = eventTypes[i3 + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = "on" + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [topEvent]);
          }
        }
        function setEventPriorities(eventTypes, priority) {
          for (var i3 = 0; i3 < eventTypes.length; i3++) {
            eventPriorities.set(eventTypes[i3], priority);
          }
        }
        function getEventPriorityForPluginSystem(domEventName) {
          var priority = eventPriorities.get(domEventName);
          return priority === void 0 ? ContinuousEvent : priority;
        }
        function registerSimpleEvents() {
          registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
          registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
          registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
          setEventPriorities(otherDiscreteEvents, DiscreteEvent);
        }
        var Scheduler_now = Scheduler.unstable_now;
        {
          if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        }
        var ImmediatePriority = 99;
        var UserBlockingPriority = 98;
        var NormalPriority = 97;
        var LowPriority = 96;
        var IdlePriority = 95;
        var NoPriority = 90;
        var initialTimeMs = Scheduler_now();
        var SyncLanePriority = 15;
        var SyncBatchedLanePriority = 14;
        var InputDiscreteHydrationLanePriority = 13;
        var InputDiscreteLanePriority = 12;
        var InputContinuousHydrationLanePriority = 11;
        var InputContinuousLanePriority = 10;
        var DefaultHydrationLanePriority = 9;
        var DefaultLanePriority = 8;
        var TransitionHydrationPriority = 7;
        var TransitionPriority = 6;
        var RetryLanePriority = 5;
        var SelectiveHydrationLanePriority = 4;
        var IdleHydrationLanePriority = 3;
        var IdleLanePriority = 2;
        var OffscreenLanePriority = 1;
        var NoLanePriority = 0;
        var TotalLanes = 31;
        var NoLanes = 0;
        var NoLane = 0;
        var SyncLane = 1;
        var SyncBatchedLane = 2;
        var InputDiscreteHydrationLane = 4;
        var InputDiscreteLanes = 24;
        var InputContinuousHydrationLane = 32;
        var InputContinuousLanes = 192;
        var DefaultHydrationLane = 256;
        var DefaultLanes = 3584;
        var TransitionHydrationLane = 4096;
        var TransitionLanes = 4186112;
        var RetryLanes = 62914560;
        var SomeRetryLane = 33554432;
        var SelectiveHydrationLane = 67108864;
        var NonIdleLanes = 134217727;
        var IdleHydrationLane = 134217728;
        var IdleLanes = 805306368;
        var OffscreenLane = 1073741824;
        var NoTimestamp = -1;
        function setCurrentUpdateLanePriority(newLanePriority) {
        }
        var return_highestLanePriority = DefaultLanePriority;
        function getHighestPriorityLanes(lanes) {
          if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
          }
          if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
          }
          if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
          }
          var inputDiscreteLanes = InputDiscreteLanes & lanes;
          if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
          }
          if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
          }
          var inputContinuousLanes = InputContinuousLanes & lanes;
          if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
          }
          if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
          }
          var defaultLanes = DefaultLanes & lanes;
          if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
          }
          if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
          }
          var transitionLanes = TransitionLanes & lanes;
          if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
          }
          var retryLanes = RetryLanes & lanes;
          if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
          }
          if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
          }
          if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
          }
          var idleLanes = IdleLanes & lanes;
          if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
          }
          if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
          }
          {
            error("Should have found matching lanes. This is a bug in React.");
          }
          return_highestLanePriority = DefaultLanePriority;
          return lanes;
        }
        function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
          switch (schedulerPriorityLevel) {
            case ImmediatePriority:
              return SyncLanePriority;
            case UserBlockingPriority:
              return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
              return DefaultLanePriority;
            case IdlePriority:
              return IdleLanePriority;
            default:
              return NoLanePriority;
          }
        }
        function lanePriorityToSchedulerPriority(lanePriority) {
          switch (lanePriority) {
            case SyncLanePriority:
            case SyncBatchedLanePriority:
              return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
              return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
              return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
              return IdlePriority;
            case NoLanePriority:
              return NoPriority;
            default: {
              {
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
              }
            }
          }
        }
        function getNextLanes(root4, wipLanes) {
          var pendingLanes = root4.pendingLanes;
          if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
          }
          var nextLanes = NoLanes;
          var nextLanePriority = NoLanePriority;
          var expiredLanes = root4.expiredLanes;
          var suspendedLanes = root4.suspendedLanes;
          var pingedLanes = root4.pingedLanes;
          if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
          } else {
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
              var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
              if (nonIdleUnblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            } else {
              var unblockedLanes = pendingLanes & ~suspendedLanes;
              if (unblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(unblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                if (pingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(pingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            }
          }
          if (nextLanes === NoLanes) {
            return NoLanes;
          }
          nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes);
          if (wipLanes !== NoLanes && wipLanes !== nextLanes && (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) {
              return wipLanes;
            } else {
              return_highestLanePriority = nextLanePriority;
            }
          }
          var entangledLanes = root4.entangledLanes;
          if (entangledLanes !== NoLanes) {
            var entanglements = root4.entanglements;
            var lanes = nextLanes & entangledLanes;
            while (lanes > 0) {
              var index2 = pickArbitraryLaneIndex(lanes);
              var lane = 1 << index2;
              nextLanes |= entanglements[index2];
              lanes &= ~lane;
            }
          }
          return nextLanes;
        }
        function getMostRecentEventTime(root4, lanes) {
          var eventTimes = root4.eventTimes;
          var mostRecentEventTime = NoTimestamp;
          while (lanes > 0) {
            var index2 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index2;
            var eventTime = eventTimes[index2];
            if (eventTime > mostRecentEventTime) {
              mostRecentEventTime = eventTime;
            }
            lanes &= ~lane;
          }
          return mostRecentEventTime;
        }
        function computeExpirationTime(lane, currentTime) {
          getHighestPriorityLanes(lane);
          var priority = return_highestLanePriority;
          if (priority >= InputContinuousLanePriority) {
            return currentTime + 250;
          } else if (priority >= TransitionPriority) {
            return currentTime + 5e3;
          } else {
            return NoTimestamp;
          }
        }
        function markStarvedLanesAsExpired(root4, currentTime) {
          var pendingLanes = root4.pendingLanes;
          var suspendedLanes = root4.suspendedLanes;
          var pingedLanes = root4.pingedLanes;
          var expirationTimes = root4.expirationTimes;
          var lanes = pendingLanes;
          while (lanes > 0) {
            var index2 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index2;
            var expirationTime = expirationTimes[index2];
            if (expirationTime === NoTimestamp) {
              if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
                expirationTimes[index2] = computeExpirationTime(lane, currentTime);
              }
            } else if (expirationTime <= currentTime) {
              root4.expiredLanes |= lane;
            }
            lanes &= ~lane;
          }
        }
        function getLanesToRetrySynchronouslyOnError(root4) {
          var everythingButOffscreen = root4.pendingLanes & ~OffscreenLane;
          if (everythingButOffscreen !== NoLanes) {
            return everythingButOffscreen;
          }
          if (everythingButOffscreen & OffscreenLane) {
            return OffscreenLane;
          }
          return NoLanes;
        }
        function returnNextLanesPriority() {
          return return_highestLanePriority;
        }
        function includesNonIdleWork(lanes) {
          return (lanes & NonIdleLanes) !== NoLanes;
        }
        function includesOnlyRetries(lanes) {
          return (lanes & RetryLanes) === lanes;
        }
        function includesOnlyTransitions(lanes) {
          return (lanes & TransitionLanes) === lanes;
        }
        function findUpdateLane(lanePriority, wipLanes) {
          switch (lanePriority) {
            case NoLanePriority:
              break;
            case SyncLanePriority:
              return SyncLane;
            case SyncBatchedLanePriority:
              return SyncBatchedLane;
            case InputDiscreteLanePriority: {
              var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
              if (_lane === NoLane) {
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
              }
              return _lane;
            }
            case InputContinuousLanePriority: {
              var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
              if (_lane2 === NoLane) {
                return findUpdateLane(DefaultLanePriority, wipLanes);
              }
              return _lane2;
            }
            case DefaultLanePriority: {
              var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
              if (_lane3 === NoLane) {
                _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                  _lane3 = pickArbitraryLane(DefaultLanes);
                }
              }
              return _lane3;
            }
            case TransitionPriority:
            case RetryLanePriority:
              break;
            case IdleLanePriority:
              var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
              if (lane === NoLane) {
                lane = pickArbitraryLane(IdleLanes);
              }
              return lane;
          }
          {
            {
              throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
            }
          }
        }
        function findTransitionLane(wipLanes, pendingLanes) {
          var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
          if (lane === NoLane) {
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) {
              lane = pickArbitraryLane(TransitionLanes);
            }
          }
          return lane;
        }
        function findRetryLane(wipLanes) {
          var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
          if (lane === NoLane) {
            lane = pickArbitraryLane(RetryLanes);
          }
          return lane;
        }
        function getHighestPriorityLane(lanes) {
          return lanes & -lanes;
        }
        function getLowestPriorityLane(lanes) {
          var index2 = 31 - clz32(lanes);
          return index2 < 0 ? NoLanes : 1 << index2;
        }
        function getEqualOrHigherPriorityLanes(lanes) {
          return (getLowestPriorityLane(lanes) << 1) - 1;
        }
        function pickArbitraryLane(lanes) {
          return getHighestPriorityLane(lanes);
        }
        function pickArbitraryLaneIndex(lanes) {
          return 31 - clz32(lanes);
        }
        function laneToIndex(lane) {
          return pickArbitraryLaneIndex(lane);
        }
        function includesSomeLane(a4, b4) {
          return (a4 & b4) !== NoLanes;
        }
        function isSubsetOfLanes(set3, subset) {
          return (set3 & subset) === subset;
        }
        function mergeLanes(a4, b4) {
          return a4 | b4;
        }
        function removeLanes(set3, subset) {
          return set3 & ~subset;
        }
        function laneToLanes(lane) {
          return lane;
        }
        function higherPriorityLane(a4, b4) {
          return a4 !== NoLane && a4 < b4 ? a4 : b4;
        }
        function createLaneMap(initial) {
          var laneMap = [];
          for (var i3 = 0; i3 < TotalLanes; i3++) {
            laneMap.push(initial);
          }
          return laneMap;
        }
        function markRootUpdated(root4, updateLane, eventTime) {
          root4.pendingLanes |= updateLane;
          var higherPriorityLanes = updateLane - 1;
          root4.suspendedLanes &= higherPriorityLanes;
          root4.pingedLanes &= higherPriorityLanes;
          var eventTimes = root4.eventTimes;
          var index2 = laneToIndex(updateLane);
          eventTimes[index2] = eventTime;
        }
        function markRootSuspended(root4, suspendedLanes) {
          root4.suspendedLanes |= suspendedLanes;
          root4.pingedLanes &= ~suspendedLanes;
          var expirationTimes = root4.expirationTimes;
          var lanes = suspendedLanes;
          while (lanes > 0) {
            var index2 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index2;
            expirationTimes[index2] = NoTimestamp;
            lanes &= ~lane;
          }
        }
        function markRootPinged(root4, pingedLanes, eventTime) {
          root4.pingedLanes |= root4.suspendedLanes & pingedLanes;
        }
        function markDiscreteUpdatesExpired(root4) {
          root4.expiredLanes |= InputDiscreteLanes & root4.pendingLanes;
        }
        function hasDiscreteLanes(lanes) {
          return (lanes & InputDiscreteLanes) !== NoLanes;
        }
        function markRootMutableRead(root4, updateLane) {
          root4.mutableReadLanes |= updateLane & root4.pendingLanes;
        }
        function markRootFinished(root4, remainingLanes) {
          var noLongerPendingLanes = root4.pendingLanes & ~remainingLanes;
          root4.pendingLanes = remainingLanes;
          root4.suspendedLanes = 0;
          root4.pingedLanes = 0;
          root4.expiredLanes &= remainingLanes;
          root4.mutableReadLanes &= remainingLanes;
          root4.entangledLanes &= remainingLanes;
          var entanglements = root4.entanglements;
          var eventTimes = root4.eventTimes;
          var expirationTimes = root4.expirationTimes;
          var lanes = noLongerPendingLanes;
          while (lanes > 0) {
            var index2 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index2;
            entanglements[index2] = NoLanes;
            eventTimes[index2] = NoTimestamp;
            expirationTimes[index2] = NoTimestamp;
            lanes &= ~lane;
          }
        }
        function markRootEntangled(root4, entangledLanes) {
          root4.entangledLanes |= entangledLanes;
          var entanglements = root4.entanglements;
          var lanes = entangledLanes;
          while (lanes > 0) {
            var index2 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index2;
            entanglements[index2] |= entangledLanes;
            lanes &= ~lane;
          }
        }
        var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
        var log = Math.log;
        var LN2 = Math.LN2;
        function clz32Fallback(lanes) {
          if (lanes === 0) {
            return 32;
          }
          return 31 - (log(lanes) / LN2 | 0) | 0;
        }
        var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority;
        var _enabled = true;
        function setEnabled(enabled) {
          _enabled = !!enabled;
        }
        function isEnabled() {
          return _enabled;
        }
        function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
          var eventPriority = getEventPriorityForPluginSystem(domEventName);
          var listenerWrapper;
          switch (eventPriority) {
            case DiscreteEvent:
              listenerWrapper = dispatchDiscreteEvent;
              break;
            case UserBlockingEvent:
              listenerWrapper = dispatchUserBlockingUpdate;
              break;
            case ContinuousEvent:
            default:
              listenerWrapper = dispatchEvent;
              break;
          }
          return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        }
        function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
          {
            flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
          }
          discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
        }
        function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
          {
            runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
          }
        }
        function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          if (!_enabled) {
            return;
          }
          var allowReplay = true;
          {
            allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
          }
          if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
          }
          var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
          if (blockedOn === null) {
            if (allowReplay) {
              clearIfContinuousEvent(domEventName, nativeEvent);
            }
            return;
          }
          if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
              queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
              return;
            }
            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
              return;
            }
            clearIfContinuousEvent(domEventName, nativeEvent);
          }
          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
        function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          var nativeEventTarget = getEventTarget(nativeEvent);
          var targetInst = getClosestInstanceFromNode(nativeEventTarget);
          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) {
              targetInst = null;
            } else {
              var tag = nearestMounted.tag;
              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);
                if (instance !== null) {
                  return instance;
                }
                targetInst = null;
              } else if (tag === HostRoot) {
                var root4 = nearestMounted.stateNode;
                if (root4.hydrate) {
                  return getContainerFromFiber(nearestMounted);
                }
                targetInst = null;
              } else if (nearestMounted !== targetInst) {
                targetInst = null;
              }
            }
          }
          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer);
          return null;
        }
        function addEventBubbleListener(target, eventType, listener) {
          target.addEventListener(eventType, listener, false);
          return listener;
        }
        function addEventCaptureListener(target, eventType, listener) {
          target.addEventListener(eventType, listener, true);
          return listener;
        }
        function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
          target.addEventListener(eventType, listener, {
            capture: true,
            passive
          });
          return listener;
        }
        function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
          target.addEventListener(eventType, listener, {
            passive
          });
          return listener;
        }
        var root3 = null;
        var startText = null;
        var fallbackText = null;
        function initialize(nativeEventTarget) {
          root3 = nativeEventTarget;
          startText = getText();
          return true;
        }
        function reset() {
          root3 = null;
          startText = null;
          fallbackText = null;
        }
        function getData() {
          if (fallbackText) {
            return fallbackText;
          }
          var start;
          var startValue = startText;
          var startLength = startValue.length;
          var end;
          var endValue = getText();
          var endLength = endValue.length;
          for (start = 0; start < startLength; start++) {
            if (startValue[start] !== endValue[start]) {
              break;
            }
          }
          var minEnd = startLength - start;
          for (end = 1; end <= minEnd; end++) {
            if (startValue[startLength - end] !== endValue[endLength - end]) {
              break;
            }
          }
          var sliceTail = end > 1 ? 1 - end : void 0;
          fallbackText = endValue.slice(start, sliceTail);
          return fallbackText;
        }
        function getText() {
          if ("value" in root3) {
            return root3.value;
          }
          return root3.textContent;
        }
        function getEventCharCode(nativeEvent) {
          var charCode;
          var keyCode = nativeEvent.keyCode;
          if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode;
            if (charCode === 0 && keyCode === 13) {
              charCode = 13;
            }
          } else {
            charCode = keyCode;
          }
          if (charCode === 10) {
            charCode = 13;
          }
          if (charCode >= 32 || charCode === 13) {
            return charCode;
          }
          return 0;
        }
        function functionThatReturnsTrue() {
          return true;
        }
        function functionThatReturnsFalse() {
          return false;
        }
        function createSyntheticEvent(Interface) {
          function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for (var _propName in Interface) {
              if (!Interface.hasOwnProperty(_propName)) {
                continue;
              }
              var normalize2 = Interface[_propName];
              if (normalize2) {
                this[_propName] = normalize2(nativeEvent);
              } else {
                this[_propName] = nativeEvent[_propName];
              }
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) {
              this.isDefaultPrevented = functionThatReturnsTrue;
            } else {
              this.isDefaultPrevented = functionThatReturnsFalse;
            }
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
          }
          _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
              this.defaultPrevented = true;
              var event = this.nativeEvent;
              if (!event) {
                return;
              }
              if (event.preventDefault) {
                event.preventDefault();
              } else if (typeof event.returnValue !== "unknown") {
                event.returnValue = false;
              }
              this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
              var event = this.nativeEvent;
              if (!event) {
                return;
              }
              if (event.stopPropagation) {
                event.stopPropagation();
              } else if (typeof event.cancelBubble !== "unknown") {
                event.cancelBubble = true;
              }
              this.isPropagationStopped = functionThatReturnsTrue;
            },
            persist: function() {
            },
            isPersistent: functionThatReturnsTrue
          });
          return SyntheticBaseEvent;
        }
        var EventInterface = {
          eventPhase: 0,
          bubbles: 0,
          cancelable: 0,
          timeStamp: function(event) {
            return event.timeStamp || Date.now();
          },
          defaultPrevented: 0,
          isTrusted: 0
        };
        var SyntheticEvent = createSyntheticEvent(EventInterface);
        var UIEventInterface = _assign({}, EventInterface, {
          view: 0,
          detail: 0
        });
        var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
        var lastMovementX;
        var lastMovementY;
        var lastMouseEvent;
        function updateMouseMovementPolyfillState(event) {
          if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
              lastMovementX = event.screenX - lastMouseEvent.screenX;
              lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
              lastMovementX = 0;
              lastMovementY = 0;
            }
            lastMouseEvent = event;
          }
        }
        var MouseEventInterface = _assign({}, UIEventInterface, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          pageX: 0,
          pageY: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          getModifierState: getEventModifierState,
          button: 0,
          buttons: 0,
          relatedTarget: function(event) {
            if (event.relatedTarget === void 0)
              return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
          },
          movementX: function(event) {
            if ("movementX" in event) {
              return event.movementX;
            }
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
          },
          movementY: function(event) {
            if ("movementY" in event) {
              return event.movementY;
            }
            return lastMovementY;
          }
        });
        var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
        var DragEventInterface = _assign({}, MouseEventInterface, {
          dataTransfer: 0
        });
        var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
        var FocusEventInterface = _assign({}, UIEventInterface, {
          relatedTarget: 0
        });
        var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
        var AnimationEventInterface = _assign({}, EventInterface, {
          animationName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });
        var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
        var ClipboardEventInterface = _assign({}, EventInterface, {
          clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
          }
        });
        var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
        var CompositionEventInterface = _assign({}, EventInterface, {
          data: 0
        });
        var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
        var SyntheticInputEvent = SyntheticCompositionEvent;
        var normalizeKey = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        };
        var translateToKey = {
          "8": "Backspace",
          "9": "Tab",
          "12": "Clear",
          "13": "Enter",
          "16": "Shift",
          "17": "Control",
          "18": "Alt",
          "19": "Pause",
          "20": "CapsLock",
          "27": "Escape",
          "32": " ",
          "33": "PageUp",
          "34": "PageDown",
          "35": "End",
          "36": "Home",
          "37": "ArrowLeft",
          "38": "ArrowUp",
          "39": "ArrowRight",
          "40": "ArrowDown",
          "45": "Insert",
          "46": "Delete",
          "112": "F1",
          "113": "F2",
          "114": "F3",
          "115": "F4",
          "116": "F5",
          "117": "F6",
          "118": "F7",
          "119": "F8",
          "120": "F9",
          "121": "F10",
          "122": "F11",
          "123": "F12",
          "144": "NumLock",
          "145": "ScrollLock",
          "224": "Meta"
        };
        function getEventKey(nativeEvent) {
          if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") {
              return key;
            }
          }
          if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent);
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
          }
          if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") {
            return translateToKey[nativeEvent.keyCode] || "Unidentified";
          }
          return "";
        }
        var modifierKeyToProp = {
          Alt: "altKey",
          Control: "ctrlKey",
          Meta: "metaKey",
          Shift: "shiftKey"
        };
        function modifierStateGetter(keyArg) {
          var syntheticEvent = this;
          var nativeEvent = syntheticEvent.nativeEvent;
          if (nativeEvent.getModifierState) {
            return nativeEvent.getModifierState(keyArg);
          }
          var keyProp = modifierKeyToProp[keyArg];
          return keyProp ? !!nativeEvent[keyProp] : false;
        }
        function getEventModifierState(nativeEvent) {
          return modifierStateGetter;
        }
        var KeyboardEventInterface = _assign({}, UIEventInterface, {
          key: getEventKey,
          code: 0,
          location: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          repeat: 0,
          locale: 0,
          getModifierState: getEventModifierState,
          charCode: function(event) {
            if (event.type === "keypress") {
              return getEventCharCode(event);
            }
            return 0;
          },
          keyCode: function(event) {
            if (event.type === "keydown" || event.type === "keyup") {
              return event.keyCode;
            }
            return 0;
          },
          which: function(event) {
            if (event.type === "keypress") {
              return getEventCharCode(event);
            }
            if (event.type === "keydown" || event.type === "keyup") {
              return event.keyCode;
            }
            return 0;
          }
        });
        var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
        var PointerEventInterface = _assign({}, MouseEventInterface, {
          pointerId: 0,
          width: 0,
          height: 0,
          pressure: 0,
          tangentialPressure: 0,
          tiltX: 0,
          tiltY: 0,
          twist: 0,
          pointerType: 0,
          isPrimary: 0
        });
        var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
        var TouchEventInterface = _assign({}, UIEventInterface, {
          touches: 0,
          targetTouches: 0,
          changedTouches: 0,
          altKey: 0,
          metaKey: 0,
          ctrlKey: 0,
          shiftKey: 0,
          getModifierState: getEventModifierState
        });
        var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
        var TransitionEventInterface = _assign({}, EventInterface, {
          propertyName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });
        var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
        var WheelEventInterface = _assign({}, MouseEventInterface, {
          deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
          },
          deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
          },
          deltaZ: 0,
          deltaMode: 0
        });
        var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
        var END_KEYCODES = [9, 13, 27, 32];
        var START_KEYCODE = 229;
        var canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window;
        var documentMode = null;
        if (canUseDOM2 && "documentMode" in document) {
          documentMode = document.documentMode;
        }
        var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode;
        var useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
        var SPACEBAR_CODE = 32;
        var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
        function registerEvents() {
          registerTwoPhaseEvent("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
          registerTwoPhaseEvent("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
          registerTwoPhaseEvent("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
          registerTwoPhaseEvent("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
        }
        var hasSpaceKeypress = false;
        function isKeypressCommand(nativeEvent) {
          return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && !(nativeEvent.ctrlKey && nativeEvent.altKey);
        }
        function getCompositionEventType(domEventName) {
          switch (domEventName) {
            case "compositionstart":
              return "onCompositionStart";
            case "compositionend":
              return "onCompositionEnd";
            case "compositionupdate":
              return "onCompositionUpdate";
          }
        }
        function isFallbackCompositionStart(domEventName, nativeEvent) {
          return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
        }
        function isFallbackCompositionEnd(domEventName, nativeEvent) {
          switch (domEventName) {
            case "keyup":
              return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
              return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
              return true;
            default:
              return false;
          }
        }
        function getDataFromCustomEvent(nativeEvent) {
          var detail = nativeEvent.detail;
          if (typeof detail === "object" && "data" in detail) {
            return detail.data;
          }
          return null;
        }
        function isUsingKoreanIME(nativeEvent) {
          return nativeEvent.locale === "ko";
        }
        var isComposing = false;
        function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
          var eventType;
          var fallbackData;
          if (canUseCompositionEvent) {
            eventType = getCompositionEventType(domEventName);
          } else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) {
              eventType = "onCompositionStart";
            }
          } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
            eventType = "onCompositionEnd";
          }
          if (!eventType) {
            return null;
          }
          if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            if (!isComposing && eventType === "onCompositionStart") {
              isComposing = initialize(nativeEventTarget);
            } else if (eventType === "onCompositionEnd") {
              if (isComposing) {
                fallbackData = getData();
              }
            }
          }
          var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
          if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event,
              listeners
            });
            if (fallbackData) {
              event.data = fallbackData;
            } else {
              var customData = getDataFromCustomEvent(nativeEvent);
              if (customData !== null) {
                event.data = customData;
              }
            }
          }
        }
        function getNativeBeforeInputChars(domEventName, nativeEvent) {
          switch (domEventName) {
            case "compositionend":
              return getDataFromCustomEvent(nativeEvent);
            case "keypress":
              var which = nativeEvent.which;
              if (which !== SPACEBAR_CODE) {
                return null;
              }
              hasSpaceKeypress = true;
              return SPACEBAR_CHAR;
            case "textInput":
              var chars = nativeEvent.data;
              if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                return null;
              }
              return chars;
            default:
              return null;
          }
        }
        function getFallbackBeforeInputChars(domEventName, nativeEvent) {
          if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
              var chars = getData();
              reset();
              isComposing = false;
              return chars;
            }
            return null;
          }
          switch (domEventName) {
            case "paste":
              return null;
            case "keypress":
              if (!isKeypressCommand(nativeEvent)) {
                if (nativeEvent.char && nativeEvent.char.length > 1) {
                  return nativeEvent.char;
                } else if (nativeEvent.which) {
                  return String.fromCharCode(nativeEvent.which);
                }
              }
              return null;
            case "compositionend":
              return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
              return null;
          }
        }
        function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
          var chars;
          if (canUseTextInputEvent) {
            chars = getNativeBeforeInputChars(domEventName, nativeEvent);
          } else {
            chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
          }
          if (!chars) {
            return null;
          }
          var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
          if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event,
              listeners
            });
            event.data = chars;
          }
        }
        function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        var supportedInputTypes = {
          color: true,
          date: true,
          datetime: true,
          "datetime-local": true,
          email: true,
          month: true,
          number: true,
          password: true,
          range: true,
          search: true,
          tel: true,
          text: true,
          time: true,
          url: true,
          week: true
        };
        function isTextInputElement(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          if (nodeName === "input") {
            return !!supportedInputTypes[elem.type];
          }
          if (nodeName === "textarea") {
            return true;
          }
          return false;
        }
        function isEventSupported(eventNameSuffix) {
          if (!canUseDOM2) {
            return false;
          }
          var eventName = "on" + eventNameSuffix;
          var isSupported = eventName in document;
          if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
          }
          return isSupported;
        }
        function registerEvents$1() {
          registerTwoPhaseEvent("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
        }
        function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
          enqueueStateRestore(target);
          var listeners = accumulateTwoPhaseListeners(inst, "onChange");
          if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
              event,
              listeners
            });
          }
        }
        var activeElement = null;
        var activeElementInst = null;
        function shouldUseChangeEvent(elem) {
          var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName === "select" || nodeName === "input" && elem.type === "file";
        }
        function manualDispatchChangeEvent(nativeEvent) {
          var dispatchQueue = [];
          createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
          batchedUpdates(runEventInBatch, dispatchQueue);
        }
        function runEventInBatch(dispatchQueue) {
          processDispatchQueue(dispatchQueue, 0);
        }
        function getInstIfValueChanged(targetInst) {
          var targetNode = getNodeFromInstance(targetInst);
          if (updateValueIfChanged(targetNode)) {
            return targetInst;
          }
        }
        function getTargetInstForChangeEvent(domEventName, targetInst) {
          if (domEventName === "change") {
            return targetInst;
          }
        }
        var isInputEventSupported = false;
        if (canUseDOM2) {
          isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
        }
        function startWatchingForValueChange(target, targetInst) {
          activeElement = target;
          activeElementInst = targetInst;
          activeElement.attachEvent("onpropertychange", handlePropertyChange);
        }
        function stopWatchingForValueChange() {
          if (!activeElement) {
            return;
          }
          activeElement.detachEvent("onpropertychange", handlePropertyChange);
          activeElement = null;
          activeElementInst = null;
        }
        function handlePropertyChange(nativeEvent) {
          if (nativeEvent.propertyName !== "value") {
            return;
          }
          if (getInstIfValueChanged(activeElementInst)) {
            manualDispatchChangeEvent(nativeEvent);
          }
        }
        function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
          if (domEventName === "focusin") {
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
          } else if (domEventName === "focusout") {
            stopWatchingForValueChange();
          }
        }
        function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
          if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") {
            return getInstIfValueChanged(activeElementInst);
          }
        }
        function shouldUseClickEvent(elem) {
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
        }
        function getTargetInstForClickEvent(domEventName, targetInst) {
          if (domEventName === "click") {
            return getInstIfValueChanged(targetInst);
          }
        }
        function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
          if (domEventName === "input" || domEventName === "change") {
            return getInstIfValueChanged(targetInst);
          }
        }
        function handleControlledInputBlur(node) {
          var state = node._wrapperState;
          if (!state || !state.controlled || node.type !== "number") {
            return;
          }
          {
            setDefaultValue(node, "number", node.value);
          }
        }
        function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
          var getTargetInstFunc, handleEventFunc;
          if (shouldUseChangeEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForChangeEvent;
          } else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) {
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            } else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              handleEventFunc = handleEventsForInputEventPolyfill;
            }
          } else if (shouldUseClickEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForClickEvent;
          }
          if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
              createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
              return;
            }
          }
          if (handleEventFunc) {
            handleEventFunc(domEventName, targetNode, targetInst);
          }
          if (domEventName === "focusout") {
            handleControlledInputBlur(targetNode);
          }
        }
        function registerEvents$2() {
          registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
          registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
          registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
          registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
        }
        function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
          var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
          if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
              if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
                return;
              }
            }
          }
          if (!isOutEvent && !isOverEvent) {
            return;
          }
          var win;
          if (nativeEventTarget.window === nativeEventTarget) {
            win = nativeEventTarget;
          } else {
            var doc = nativeEventTarget.ownerDocument;
            if (doc) {
              win = doc.defaultView || doc.parentWindow;
            } else {
              win = window;
            }
          }
          var from;
          var to;
          if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
              var nearestMounted = getNearestMountedFiber(to);
              if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                to = null;
              }
            }
          } else {
            from = null;
            to = targetInst;
          }
          if (from === to) {
            return;
          }
          var SyntheticEventCtor = SyntheticMouseEvent;
          var leaveEventType = "onMouseLeave";
          var enterEventType = "onMouseEnter";
          var eventTypePrefix = "mouse";
          if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
          }
          var fromNode = from == null ? win : getNodeFromInstance(from);
          var toNode = to == null ? win : getNodeFromInstance(to);
          var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
          leave.target = fromNode;
          leave.relatedTarget = toNode;
          var enter = null;
          var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
          if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
          }
          accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
        }
        function is(x4, y3) {
          return x4 === y3 && (x4 !== 0 || 1 / x4 === 1 / y3) || x4 !== x4 && y3 !== y3;
        }
        var objectIs = typeof Object.is === "function" ? Object.is : is;
        var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
        function shallowEqual3(objA, objB) {
          if (objectIs(objA, objB)) {
            return true;
          }
          if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }
          for (var i3 = 0; i3 < keysA.length; i3++) {
            if (!hasOwnProperty$2.call(objB, keysA[i3]) || !objectIs(objA[keysA[i3]], objB[keysA[i3]])) {
              return false;
            }
          }
          return true;
        }
        function getLeafNode(node) {
          while (node && node.firstChild) {
            node = node.firstChild;
          }
          return node;
        }
        function getSiblingNode(node) {
          while (node) {
            if (node.nextSibling) {
              return node.nextSibling;
            }
            node = node.parentNode;
          }
        }
        function getNodeForCharacterOffset(root4, offset) {
          var node = getLeafNode(root4);
          var nodeStart = 0;
          var nodeEnd = 0;
          while (node) {
            if (node.nodeType === TEXT_NODE) {
              nodeEnd = nodeStart + node.textContent.length;
              if (nodeStart <= offset && nodeEnd >= offset) {
                return {
                  node,
                  offset: offset - nodeStart
                };
              }
              nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
          }
        }
        function getOffsets(outerNode) {
          var ownerDocument = outerNode.ownerDocument;
          var win = ownerDocument && ownerDocument.defaultView || window;
          var selection = win.getSelection && win.getSelection();
          if (!selection || selection.rangeCount === 0) {
            return null;
          }
          var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset;
          try {
            anchorNode.nodeType;
            focusNode.nodeType;
          } catch (e2) {
            return null;
          }
          return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
        }
        function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
          var length = 0;
          var start = -1;
          var end = -1;
          var indexWithinAnchor = 0;
          var indexWithinFocus = 0;
          var node = outerNode;
          var parentNode = null;
          outer:
            while (true) {
              var next = null;
              while (true) {
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
                  start = length + anchorOffset;
                }
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
                  end = length + focusOffset;
                }
                if (node.nodeType === TEXT_NODE) {
                  length += node.nodeValue.length;
                }
                if ((next = node.firstChild) === null) {
                  break;
                }
                parentNode = node;
                node = next;
              }
              while (true) {
                if (node === outerNode) {
                  break outer;
                }
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
                  start = length;
                }
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
                  end = length;
                }
                if ((next = node.nextSibling) !== null) {
                  break;
                }
                node = parentNode;
                parentNode = node.parentNode;
              }
              node = next;
            }
          if (start === -1 || end === -1) {
            return null;
          }
          return {
            start,
            end
          };
        }
        function setOffsets(node, offsets) {
          var doc = node.ownerDocument || document;
          var win = doc && doc.defaultView || window;
          if (!win.getSelection) {
            return;
          }
          var selection = win.getSelection();
          var length = node.textContent.length;
          var start = Math.min(offsets.start, length);
          var end = offsets.end === void 0 ? start : Math.min(offsets.end, length);
          if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
          }
          var startMarker = getNodeForCharacterOffset(node, start);
          var endMarker = getNodeForCharacterOffset(node, end);
          if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
              return;
            }
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
              selection.addRange(range);
              selection.extend(endMarker.node, endMarker.offset);
            } else {
              range.setEnd(endMarker.node, endMarker.offset);
              selection.addRange(range);
            }
          }
        }
        function isTextNode(node) {
          return node && node.nodeType === TEXT_NODE;
        }
        function containsNode(outerNode, innerNode) {
          if (!outerNode || !innerNode) {
            return false;
          } else if (outerNode === innerNode) {
            return true;
          } else if (isTextNode(outerNode)) {
            return false;
          } else if (isTextNode(innerNode)) {
            return containsNode(outerNode, innerNode.parentNode);
          } else if ("contains" in outerNode) {
            return outerNode.contains(innerNode);
          } else if (outerNode.compareDocumentPosition) {
            return !!(outerNode.compareDocumentPosition(innerNode) & 16);
          } else {
            return false;
          }
        }
        function isInDocument(node) {
          return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
        }
        function isSameOriginFrame(iframe) {
          try {
            return typeof iframe.contentWindow.location.href === "string";
          } catch (err) {
            return false;
          }
        }
        function getActiveElementDeep() {
          var win = window;
          var element = getActiveElement2();
          while (element instanceof win.HTMLIFrameElement) {
            if (isSameOriginFrame(element)) {
              win = element.contentWindow;
            } else {
              return element;
            }
            element = getActiveElement2(win.document);
          }
          return element;
        }
        function hasSelectionCapabilities(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
        }
        function getSelectionInformation() {
          var focusedElem = getActiveElementDeep();
          return {
            focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
          };
        }
        function restoreSelection(priorSelectionInformation) {
          var curFocusedElem = getActiveElementDeep();
          var priorFocusedElem = priorSelectionInformation.focusedElem;
          var priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
              setSelection(priorFocusedElem, priorSelectionRange);
            }
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while (ancestor = ancestor.parentNode) {
              if (ancestor.nodeType === ELEMENT_NODE) {
                ancestors.push({
                  element: ancestor,
                  left: ancestor.scrollLeft,
                  top: ancestor.scrollTop
                });
              }
            }
            if (typeof priorFocusedElem.focus === "function") {
              priorFocusedElem.focus();
            }
            for (var i3 = 0; i3 < ancestors.length; i3++) {
              var info = ancestors[i3];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
        }
        function getSelection(input) {
          var selection;
          if ("selectionStart" in input) {
            selection = {
              start: input.selectionStart,
              end: input.selectionEnd
            };
          } else {
            selection = getOffsets(input);
          }
          return selection || {
            start: 0,
            end: 0
          };
        }
        function setSelection(input, offsets) {
          var start = offsets.start;
          var end = offsets.end;
          if (end === void 0) {
            end = start;
          }
          if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
          } else {
            setOffsets(input, offsets);
          }
        }
        var skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && document.documentMode <= 11;
        function registerEvents$3() {
          registerTwoPhaseEvent("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
        }
        var activeElement$1 = null;
        var activeElementInst$1 = null;
        var lastSelection = null;
        var mouseDown = false;
        function getSelection$1(node) {
          if ("selectionStart" in node && hasSelectionCapabilities(node)) {
            return {
              start: node.selectionStart,
              end: node.selectionEnd
            };
          } else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
              anchorNode: selection.anchorNode,
              anchorOffset: selection.anchorOffset,
              focusNode: selection.focusNode,
              focusOffset: selection.focusOffset
            };
          }
        }
        function getEventTargetDocument(eventTarget) {
          return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
        }
        function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
          var doc = getEventTargetDocument(nativeEventTarget);
          if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement2(doc)) {
            return;
          }
          var currentSelection = getSelection$1(activeElement$1);
          if (!lastSelection || !shallowEqual3(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
              var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
              dispatchQueue.push({
                event,
                listeners
              });
              event.target = activeElement$1;
            }
          }
        }
        function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
          switch (domEventName) {
            case "focusin":
              if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                activeElement$1 = targetNode;
                activeElementInst$1 = targetInst;
                lastSelection = null;
              }
              break;
            case "focusout":
              activeElement$1 = null;
              activeElementInst$1 = null;
              lastSelection = null;
              break;
            case "mousedown":
              mouseDown = true;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              mouseDown = false;
              constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
              break;
            case "selectionchange":
              if (skipSelectionChangeEvent) {
                break;
              }
            case "keydown":
            case "keyup":
              constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
          }
        }
        function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var reactName = topLevelEventsToReactNames.get(domEventName);
          if (reactName === void 0) {
            return;
          }
          var SyntheticEventCtor = SyntheticEvent;
          var reactEventType = domEventName;
          switch (domEventName) {
            case "keypress":
              if (getEventCharCode(nativeEvent) === 0) {
                return;
              }
            case "keydown":
            case "keyup":
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;
            case "focusin":
              reactEventType = "focus";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "focusout":
              reactEventType = "blur";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "beforeblur":
            case "afterblur":
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "click":
              if (nativeEvent.button === 2) {
                return;
              }
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              SyntheticEventCtor = SyntheticMouseEvent;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              SyntheticEventCtor = SyntheticDragEvent;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              SyntheticEventCtor = SyntheticTouchEvent;
              break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;
            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;
            case "scroll":
              SyntheticEventCtor = SyntheticUIEvent;
              break;
            case "wheel":
              SyntheticEventCtor = SyntheticWheelEvent;
              break;
            case "copy":
            case "cut":
            case "paste":
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
          }
          var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
          {
            var accumulateTargetOnly = !inCapturePhase && domEventName === "scroll";
            var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
            if (_listeners.length > 0) {
              var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
              dispatchQueue.push({
                event: _event,
                listeners: _listeners
              });
            }
          }
        }
        registerSimpleEvents();
        registerEvents$2();
        registerEvents$1();
        registerEvents$3();
        registerEvents();
        function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
          var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0;
          if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          }
        }
        var mediaEventTypes = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"];
        var nonDelegatedEvents = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(mediaEventTypes));
        function executeDispatch(event, listener, currentTarget) {
          var type = event.type || "unknown-event";
          event.currentTarget = currentTarget;
          invokeGuardedCallbackAndCatchFirstError(type, listener, void 0, event);
          event.currentTarget = null;
        }
        function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
          var previousInstance;
          if (inCapturePhase) {
            for (var i3 = dispatchListeners.length - 1; i3 >= 0; i3--) {
              var _dispatchListeners$i = dispatchListeners[i3], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped()) {
                return;
              }
              executeDispatch(event, listener, currentTarget);
              previousInstance = instance;
            }
          } else {
            for (var _i = 0; _i < dispatchListeners.length; _i++) {
              var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
              if (_instance !== previousInstance && event.isPropagationStopped()) {
                return;
              }
              executeDispatch(event, _listener, _currentTarget);
              previousInstance = _instance;
            }
          }
        }
        function processDispatchQueue(dispatchQueue, eventSystemFlags) {
          var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
          for (var i3 = 0; i3 < dispatchQueue.length; i3++) {
            var _dispatchQueue$i = dispatchQueue[i3], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase);
          }
          rethrowCaughtError();
        }
        function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
          var nativeEventTarget = getEventTarget(nativeEvent);
          var dispatchQueue = [];
          extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
          processDispatchQueue(dispatchQueue, eventSystemFlags);
        }
        function listenToNonDelegatedEvent(domEventName, targetElement) {
          var isCapturePhaseListener = false;
          var listenerSet = getEventListenerSet(targetElement);
          var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
          if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
          }
        }
        var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
        function listenToAllSupportedEvents(rootContainerElement) {
          {
            if (rootContainerElement[listeningMarker]) {
              return;
            }
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
              if (!nonDelegatedEvents.has(domEventName)) {
                listenToNativeEvent(domEventName, false, rootContainerElement, null);
              }
              listenToNativeEvent(domEventName, true, rootContainerElement, null);
            });
          }
        }
        function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
          var eventSystemFlags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
          var target = rootContainerElement;
          if (domEventName === "selectionchange" && rootContainerElement.nodeType !== DOCUMENT_NODE) {
            target = rootContainerElement.ownerDocument;
          }
          if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            if (domEventName !== "scroll") {
              return;
            }
            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
          }
          var listenerSet = getEventListenerSet(target);
          var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
          if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) {
              eventSystemFlags |= IS_CAPTURE_PHASE;
            }
            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
          }
        }
        function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
          var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags);
          var isPassiveListener = void 0;
          if (passiveBrowserEventsSupported) {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") {
              isPassiveListener = true;
            }
          }
          targetContainer = targetContainer;
          var unsubscribeListener;
          if (isCapturePhaseListener) {
            if (isPassiveListener !== void 0) {
              unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            } else {
              unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
            }
          } else {
            if (isPassiveListener !== void 0) {
              unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            } else {
              unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
            }
          }
        }
        function isMatchingRootContainer(grandContainer, targetContainer) {
          return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
        }
        function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
          var ancestorInst = targetInst;
          if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer;
            if (targetInst !== null) {
              var node = targetInst;
              mainLoop:
                while (true) {
                  if (node === null) {
                    return;
                  }
                  var nodeTag = node.tag;
                  if (nodeTag === HostRoot || nodeTag === HostPortal) {
                    var container = node.stateNode.containerInfo;
                    if (isMatchingRootContainer(container, targetContainerNode)) {
                      break;
                    }
                    if (nodeTag === HostPortal) {
                      var grandNode = node.return;
                      while (grandNode !== null) {
                        var grandTag = grandNode.tag;
                        if (grandTag === HostRoot || grandTag === HostPortal) {
                          var grandContainer = grandNode.stateNode.containerInfo;
                          if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                            return;
                          }
                        }
                        grandNode = grandNode.return;
                      }
                    }
                    while (container !== null) {
                      var parentNode = getClosestInstanceFromNode(container);
                      if (parentNode === null) {
                        return;
                      }
                      var parentTag = parentNode.tag;
                      if (parentTag === HostComponent || parentTag === HostText) {
                        node = ancestorInst = parentNode;
                        continue mainLoop;
                      }
                      container = container.parentNode;
                    }
                  }
                  node = node.return;
                }
            }
          }
          batchedEventUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
          });
        }
        function createDispatchListener(instance, listener, currentTarget) {
          return {
            instance,
            listener,
            currentTarget
          };
        }
        function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
          var captureName = reactName !== null ? reactName + "Capture" : null;
          var reactEventName = inCapturePhase ? captureName : reactName;
          var listeners = [];
          var instance = targetFiber;
          var lastHostComponent = null;
          while (instance !== null) {
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag;
            if (tag === HostComponent && stateNode !== null) {
              lastHostComponent = stateNode;
              if (reactEventName !== null) {
                var listener = getListener(instance, reactEventName);
                if (listener != null) {
                  listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
              }
            }
            if (accumulateTargetOnly) {
              break;
            }
            instance = instance.return;
          }
          return listeners;
        }
        function accumulateTwoPhaseListeners(targetFiber, reactName) {
          var captureName = reactName + "Capture";
          var listeners = [];
          var instance = targetFiber;
          while (instance !== null) {
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag;
            if (tag === HostComponent && stateNode !== null) {
              var currentTarget = stateNode;
              var captureListener = getListener(instance, captureName);
              if (captureListener != null) {
                listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
              }
              var bubbleListener = getListener(instance, reactName);
              if (bubbleListener != null) {
                listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
              }
            }
            instance = instance.return;
          }
          return listeners;
        }
        function getParent(inst) {
          if (inst === null) {
            return null;
          }
          do {
            inst = inst.return;
          } while (inst && inst.tag !== HostComponent);
          if (inst) {
            return inst;
          }
          return null;
        }
        function getLowestCommonAncestor(instA, instB) {
          var nodeA = instA;
          var nodeB = instB;
          var depthA = 0;
          for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
            depthA++;
          }
          var depthB = 0;
          for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
            depthB++;
          }
          while (depthA - depthB > 0) {
            nodeA = getParent(nodeA);
            depthA--;
          }
          while (depthB - depthA > 0) {
            nodeB = getParent(nodeB);
            depthB--;
          }
          var depth = depthA;
          while (depth--) {
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
              return nodeA;
            }
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
          }
          return null;
        }
        function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
          var registrationName = event._reactName;
          var listeners = [];
          var instance = target;
          while (instance !== null) {
            if (instance === common) {
              break;
            }
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) {
              break;
            }
            if (tag === HostComponent && stateNode !== null) {
              var currentTarget = stateNode;
              if (inCapturePhase) {
                var captureListener = getListener(instance, registrationName);
                if (captureListener != null) {
                  listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                }
              } else if (!inCapturePhase) {
                var bubbleListener = getListener(instance, registrationName);
                if (bubbleListener != null) {
                  listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
              }
            }
            instance = instance.return;
          }
          if (listeners.length !== 0) {
            dispatchQueue.push({
              event,
              listeners
            });
          }
        }
        function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
          var common = from && to ? getLowestCommonAncestor(from, to) : null;
          if (from !== null) {
            accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
          }
          if (to !== null && enterEvent !== null) {
            accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
          }
        }
        function getListenerSetKey(domEventName, capture) {
          return domEventName + "__" + (capture ? "capture" : "bubble");
        }
        var didWarnInvalidHydration = false;
        var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
        var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
        var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
        var AUTOFOCUS = "autoFocus";
        var CHILDREN = "children";
        var STYLE = "style";
        var HTML$1 = "__html";
        var HTML_NAMESPACE$1 = Namespaces.html;
        var warnedUnknownTags;
        var suppressHydrationWarning;
        var validatePropertiesInDevelopment;
        var warnForTextDifference;
        var warnForPropDifference;
        var warnForExtraAttributes;
        var warnForInvalidEventListener;
        var canDiffStyleForHydrationWarning;
        var normalizeMarkupForTextOrAttribute;
        var normalizeHTML;
        {
          warnedUnknownTags = {
            dialog: true,
            webview: true
          };
          validatePropertiesInDevelopment = function(type, props) {
            validateProperties(type, props);
            validateProperties$1(type, props);
            validateProperties$2(type, props, {
              registrationNameDependencies,
              possibleRegistrationNames
            });
          };
          canDiffStyleForHydrationWarning = canUseDOM2 && !document.documentMode;
          var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
          var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
          normalizeMarkupForTextOrAttribute = function(markup) {
            var markupString = typeof markup === "string" ? markup : "" + markup;
            return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
          };
          warnForTextDifference = function(serverText, clientText) {
            if (didWarnInvalidHydration) {
              return;
            }
            var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
            var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
            if (normalizedServerText === normalizedClientText) {
              return;
            }
            didWarnInvalidHydration = true;
            error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
          };
          warnForPropDifference = function(propName, serverValue, clientValue) {
            if (didWarnInvalidHydration) {
              return;
            }
            var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
            var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
            if (normalizedServerValue === normalizedClientValue) {
              return;
            }
            didWarnInvalidHydration = true;
            error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
          };
          warnForExtraAttributes = function(attributeNames) {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            var names = [];
            attributeNames.forEach(function(name) {
              names.push(name);
            });
            error("Extra attributes from the server: %s", names);
          };
          warnForInvalidEventListener = function(registrationName, listener) {
            if (listener === false) {
              error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
            } else {
              error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
            }
          };
          normalizeHTML = function(parent, html) {
            var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
            testElement.innerHTML = html;
            return testElement.innerHTML;
          };
        }
        function getOwnerDocumentFromRootContainer(rootContainerElement) {
          return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
        }
        function noop4() {
        }
        function trapClickOnNonInteractiveElement(node) {
          node.onclick = noop4;
        }
        function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
          for (var propKey in nextProps) {
            if (!nextProps.hasOwnProperty(propKey)) {
              continue;
            }
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
              {
                if (nextProp) {
                  Object.freeze(nextProp);
                }
              }
              setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
              if (nextHtml != null) {
                setInnerHTML(domElement, nextHtml);
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === "string") {
                var canSetTextContent = tag !== "textarea" || nextProp !== "";
                if (canSetTextContent) {
                  setTextContent(domElement, nextProp);
                }
              } else if (typeof nextProp === "number") {
                setTextContent(domElement, "" + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING)
              ;
            else if (propKey === AUTOFOCUS)
              ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                if (propKey === "onScroll") {
                  listenToNonDelegatedEvent("scroll", domElement);
                }
              }
            } else if (nextProp != null) {
              setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
            }
          }
        }
        function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
          for (var i3 = 0; i3 < updatePayload.length; i3 += 2) {
            var propKey = updatePayload[i3];
            var propValue = updatePayload[i3 + 1];
            if (propKey === STYLE) {
              setValueForStyles(domElement, propValue);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              setInnerHTML(domElement, propValue);
            } else if (propKey === CHILDREN) {
              setTextContent(domElement, propValue);
            } else {
              setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
            }
          }
        }
        function createElement11(type, props, rootContainerElement, parentNamespace) {
          var isCustomComponentTag;
          var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
          var domElement;
          var namespaceURI = parentNamespace;
          if (namespaceURI === HTML_NAMESPACE$1) {
            namespaceURI = getIntrinsicNamespace(type);
          }
          if (namespaceURI === HTML_NAMESPACE$1) {
            {
              isCustomComponentTag = isCustomComponent(type, props);
              if (!isCustomComponentTag && type !== type.toLowerCase()) {
                error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
              }
            }
            if (type === "script") {
              var div = ownerDocument.createElement("div");
              div.innerHTML = "<script><\/script>";
              var firstChild = div.firstChild;
              domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") {
              domElement = ownerDocument.createElement(type, {
                is: props.is
              });
            } else {
              domElement = ownerDocument.createElement(type);
              if (type === "select") {
                var node = domElement;
                if (props.multiple) {
                  node.multiple = true;
                } else if (props.size) {
                  node.size = props.size;
                }
              }
            }
          } else {
            domElement = ownerDocument.createElementNS(namespaceURI, type);
          }
          {
            if (namespaceURI === HTML_NAMESPACE$1) {
              if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
              }
            }
          }
          return domElement;
        }
        function createTextNode(text, rootContainerElement) {
          return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
        }
        function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
          var isCustomComponentTag = isCustomComponent(tag, rawProps);
          {
            validatePropertiesInDevelopment(tag, rawProps);
          }
          var props;
          switch (tag) {
            case "dialog":
              listenToNonDelegatedEvent("cancel", domElement);
              listenToNonDelegatedEvent("close", domElement);
              props = rawProps;
              break;
            case "iframe":
            case "object":
            case "embed":
              listenToNonDelegatedEvent("load", domElement);
              props = rawProps;
              break;
            case "video":
            case "audio":
              for (var i3 = 0; i3 < mediaEventTypes.length; i3++) {
                listenToNonDelegatedEvent(mediaEventTypes[i3], domElement);
              }
              props = rawProps;
              break;
            case "source":
              listenToNonDelegatedEvent("error", domElement);
              props = rawProps;
              break;
            case "img":
            case "image":
            case "link":
              listenToNonDelegatedEvent("error", domElement);
              listenToNonDelegatedEvent("load", domElement);
              props = rawProps;
              break;
            case "details":
              listenToNonDelegatedEvent("toggle", domElement);
              props = rawProps;
              break;
            case "input":
              initWrapperState(domElement, rawProps);
              props = getHostProps(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
            case "option":
              validateProps(domElement, rawProps);
              props = getHostProps$1(domElement, rawProps);
              break;
            case "select":
              initWrapperState$1(domElement, rawProps);
              props = getHostProps$2(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
            case "textarea":
              initWrapperState$2(domElement, rawProps);
              props = getHostProps$3(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
            default:
              props = rawProps;
          }
          assertValidProps(tag, props);
          setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
          switch (tag) {
            case "input":
              track(domElement);
              postMountWrapper(domElement, rawProps, false);
              break;
            case "textarea":
              track(domElement);
              postMountWrapper$3(domElement);
              break;
            case "option":
              postMountWrapper$1(domElement, rawProps);
              break;
            case "select":
              postMountWrapper$2(domElement, rawProps);
              break;
            default:
              if (typeof props.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
        }
        function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
          {
            validatePropertiesInDevelopment(tag, nextRawProps);
          }
          var updatePayload = null;
          var lastProps;
          var nextProps;
          switch (tag) {
            case "input":
              lastProps = getHostProps(domElement, lastRawProps);
              nextProps = getHostProps(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "option":
              lastProps = getHostProps$1(domElement, lastRawProps);
              nextProps = getHostProps$1(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "select":
              lastProps = getHostProps$2(domElement, lastRawProps);
              nextProps = getHostProps$2(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "textarea":
              lastProps = getHostProps$3(domElement, lastRawProps);
              nextProps = getHostProps$3(domElement, nextRawProps);
              updatePayload = [];
              break;
            default:
              lastProps = lastRawProps;
              nextProps = nextRawProps;
              if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
          assertValidProps(tag, nextProps);
          var propKey;
          var styleName;
          var styleUpdates = null;
          for (propKey in lastProps) {
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
              continue;
            }
            if (propKey === STYLE) {
              var lastStyle = lastProps[propKey];
              for (styleName in lastStyle) {
                if (lastStyle.hasOwnProperty(styleName)) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = "";
                }
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN)
              ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING)
              ;
            else if (propKey === AUTOFOCUS)
              ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (!updatePayload) {
                updatePayload = [];
              }
            } else {
              (updatePayload = updatePayload || []).push(propKey, null);
            }
          }
          for (propKey in nextProps) {
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : void 0;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
              continue;
            }
            if (propKey === STYLE) {
              {
                if (nextProp) {
                  Object.freeze(nextProp);
                }
              }
              if (lastProp) {
                for (styleName in lastProp) {
                  if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }
                    styleUpdates[styleName] = "";
                  }
                }
                for (styleName in nextProp) {
                  if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }
                    styleUpdates[styleName] = nextProp[styleName];
                  }
                }
              } else {
                if (!styleUpdates) {
                  if (!updatePayload) {
                    updatePayload = [];
                  }
                  updatePayload.push(propKey, styleUpdates);
                }
                styleUpdates = nextProp;
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
              var lastHtml = lastProp ? lastProp[HTML$1] : void 0;
              if (nextHtml != null) {
                if (lastHtml !== nextHtml) {
                  (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === "string" || typeof nextProp === "number") {
                (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING)
              ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                if (propKey === "onScroll") {
                  listenToNonDelegatedEvent("scroll", domElement);
                }
              }
              if (!updatePayload && lastProp !== nextProp) {
                updatePayload = [];
              }
            } else if (typeof nextProp === "object" && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
              nextProp.toString();
            } else {
              (updatePayload = updatePayload || []).push(propKey, nextProp);
            }
          }
          if (styleUpdates) {
            {
              validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            }
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
          }
          return updatePayload;
        }
        function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
          if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) {
            updateChecked(domElement, nextRawProps);
          }
          var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
          var isCustomComponentTag = isCustomComponent(tag, nextRawProps);
          updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag);
          switch (tag) {
            case "input":
              updateWrapper(domElement, nextRawProps);
              break;
            case "textarea":
              updateWrapper$1(domElement, nextRawProps);
              break;
            case "select":
              postUpdateWrapper(domElement, nextRawProps);
              break;
          }
        }
        function getPossibleStandardName(propName) {
          {
            var lowerCasedName = propName.toLowerCase();
            if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              return null;
            }
            return possibleStandardNames[lowerCasedName] || null;
          }
        }
        function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
          var isCustomComponentTag;
          var extraAttributeNames;
          {
            suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
            isCustomComponentTag = isCustomComponent(tag, rawProps);
            validatePropertiesInDevelopment(tag, rawProps);
          }
          switch (tag) {
            case "dialog":
              listenToNonDelegatedEvent("cancel", domElement);
              listenToNonDelegatedEvent("close", domElement);
              break;
            case "iframe":
            case "object":
            case "embed":
              listenToNonDelegatedEvent("load", domElement);
              break;
            case "video":
            case "audio":
              for (var i3 = 0; i3 < mediaEventTypes.length; i3++) {
                listenToNonDelegatedEvent(mediaEventTypes[i3], domElement);
              }
              break;
            case "source":
              listenToNonDelegatedEvent("error", domElement);
              break;
            case "img":
            case "image":
            case "link":
              listenToNonDelegatedEvent("error", domElement);
              listenToNonDelegatedEvent("load", domElement);
              break;
            case "details":
              listenToNonDelegatedEvent("toggle", domElement);
              break;
            case "input":
              initWrapperState(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
            case "option":
              validateProps(domElement, rawProps);
              break;
            case "select":
              initWrapperState$1(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
            case "textarea":
              initWrapperState$2(domElement, rawProps);
              listenToNonDelegatedEvent("invalid", domElement);
              break;
          }
          assertValidProps(tag, rawProps);
          {
            extraAttributeNames = new Set();
            var attributes = domElement.attributes;
            for (var _i = 0; _i < attributes.length; _i++) {
              var name = attributes[_i].name.toLowerCase();
              switch (name) {
                case "data-reactroot":
                  break;
                case "value":
                  break;
                case "checked":
                  break;
                case "selected":
                  break;
                default:
                  extraAttributeNames.add(attributes[_i].name);
              }
            }
          }
          var updatePayload = null;
          for (var propKey in rawProps) {
            if (!rawProps.hasOwnProperty(propKey)) {
              continue;
            }
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
              if (typeof nextProp === "string") {
                if (domElement.textContent !== nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }
                  updatePayload = [CHILDREN, nextProp];
                }
              } else if (typeof nextProp === "number") {
                if (domElement.textContent !== "" + nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }
                  updatePayload = [CHILDREN, "" + nextProp];
                }
              }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                if (propKey === "onScroll") {
                  listenToNonDelegatedEvent("scroll", domElement);
                }
              }
            } else if (typeof isCustomComponentTag === "boolean") {
              var serverValue = void 0;
              var propertyInfo = getPropertyInfo(propKey);
              if (suppressHydrationWarning)
                ;
              else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || propKey === "value" || propKey === "checked" || propKey === "selected")
                ;
              else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var serverHTML = domElement.innerHTML;
                var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
                if (nextHtml != null) {
                  var expectedHTML = normalizeHTML(domElement, nextHtml);
                  if (expectedHTML !== serverHTML) {
                    warnForPropDifference(propKey, serverHTML, expectedHTML);
                  }
                }
              } else if (propKey === STYLE) {
                extraAttributeNames.delete(propKey);
                if (canDiffStyleForHydrationWarning) {
                  var expectedStyle = createDangerousStringForStyles(nextProp);
                  serverValue = domElement.getAttribute("style");
                  if (expectedStyle !== serverValue) {
                    warnForPropDifference(propKey, serverValue, expectedStyle);
                  }
                }
              } else if (isCustomComponentTag) {
                extraAttributeNames.delete(propKey.toLowerCase());
                serverValue = getValueForAttribute(domElement, propKey, nextProp);
                if (nextProp !== serverValue) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                var isMismatchDueToBadCasing = false;
                if (propertyInfo !== null) {
                  extraAttributeNames.delete(propertyInfo.attributeName);
                  serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                } else {
                  var ownNamespace = parentNamespace;
                  if (ownNamespace === HTML_NAMESPACE$1) {
                    ownNamespace = getIntrinsicNamespace(tag);
                  }
                  if (ownNamespace === HTML_NAMESPACE$1) {
                    extraAttributeNames.delete(propKey.toLowerCase());
                  } else {
                    var standardName = getPossibleStandardName(propKey);
                    if (standardName !== null && standardName !== propKey) {
                      isMismatchDueToBadCasing = true;
                      extraAttributeNames.delete(standardName);
                    }
                    extraAttributeNames.delete(propKey);
                  }
                  serverValue = getValueForAttribute(domElement, propKey, nextProp);
                }
                if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              }
            }
          }
          {
            if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
              warnForExtraAttributes(extraAttributeNames);
            }
          }
          switch (tag) {
            case "input":
              track(domElement);
              postMountWrapper(domElement, rawProps, true);
              break;
            case "textarea":
              track(domElement);
              postMountWrapper$3(domElement);
              break;
            case "select":
            case "option":
              break;
            default:
              if (typeof rawProps.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
          return updatePayload;
        }
        function diffHydratedText(textNode, text) {
          var isDifferent = textNode.nodeValue !== text;
          return isDifferent;
        }
        function warnForUnmatchedText(textNode, text) {
          {
            warnForTextDifference(textNode.nodeValue, text);
          }
        }
        function warnForDeletedHydratableElement(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
          }
        }
        function warnForDeletedHydratableText(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
          }
        }
        function warnForInsertedHydratedElement(parentNode, tag, props) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
          }
        }
        function warnForInsertedHydratedText(parentNode, text) {
          {
            if (text === "") {
              return;
            }
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
          }
        }
        function restoreControlledState$3(domElement, tag, props) {
          switch (tag) {
            case "input":
              restoreControlledState(domElement, props);
              return;
            case "textarea":
              restoreControlledState$2(domElement, props);
              return;
            case "select":
              restoreControlledState$1(domElement, props);
              return;
          }
        }
        var validateDOMNesting = function() {
        };
        var updatedAncestorInfo = function() {
        };
        {
          var specialTags = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"];
          var inScopeTags = [
            "applet",
            "caption",
            "html",
            "table",
            "td",
            "th",
            "marquee",
            "object",
            "template",
            "foreignObject",
            "desc",
            "title"
          ];
          var buttonScopeTags = inScopeTags.concat(["button"]);
          var impliedEndTags = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"];
          var emptyAncestorInfo = {
            current: null,
            formTag: null,
            aTagInScope: null,
            buttonTagInScope: null,
            nobrTagInScope: null,
            pTagInButtonScope: null,
            listItemTagAutoclosing: null,
            dlItemTagAutoclosing: null
          };
          updatedAncestorInfo = function(oldInfo, tag) {
            var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
            var info = {
              tag
            };
            if (inScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.aTagInScope = null;
              ancestorInfo.buttonTagInScope = null;
              ancestorInfo.nobrTagInScope = null;
            }
            if (buttonScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.pTagInButtonScope = null;
            }
            if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
              ancestorInfo.listItemTagAutoclosing = null;
              ancestorInfo.dlItemTagAutoclosing = null;
            }
            ancestorInfo.current = info;
            if (tag === "form") {
              ancestorInfo.formTag = info;
            }
            if (tag === "a") {
              ancestorInfo.aTagInScope = info;
            }
            if (tag === "button") {
              ancestorInfo.buttonTagInScope = info;
            }
            if (tag === "nobr") {
              ancestorInfo.nobrTagInScope = info;
            }
            if (tag === "p") {
              ancestorInfo.pTagInButtonScope = info;
            }
            if (tag === "li") {
              ancestorInfo.listItemTagAutoclosing = info;
            }
            if (tag === "dd" || tag === "dt") {
              ancestorInfo.dlItemTagAutoclosing = info;
            }
            return ancestorInfo;
          };
          var isTagValidWithParent = function(tag, parentTag) {
            switch (parentTag) {
              case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
              case "optgroup":
                return tag === "option" || tag === "#text";
              case "option":
                return tag === "#text";
              case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
              case "tbody":
              case "thead":
              case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
              case "colgroup":
                return tag === "col" || tag === "template";
              case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
              case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
              case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
              case "frameset":
                return tag === "frame";
              case "#document":
                return tag === "html";
            }
            switch (tag) {
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
              case "rp":
              case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
              case "body":
              case "caption":
              case "col":
              case "colgroup":
              case "frameset":
              case "frame":
              case "head":
              case "html":
              case "tbody":
              case "td":
              case "tfoot":
              case "th":
              case "thead":
              case "tr":
                return parentTag == null;
            }
            return true;
          };
          var findInvalidAncestorForTag = function(tag, ancestorInfo) {
            switch (tag) {
              case "address":
              case "article":
              case "aside":
              case "blockquote":
              case "center":
              case "details":
              case "dialog":
              case "dir":
              case "div":
              case "dl":
              case "fieldset":
              case "figcaption":
              case "figure":
              case "footer":
              case "header":
              case "hgroup":
              case "main":
              case "menu":
              case "nav":
              case "ol":
              case "p":
              case "section":
              case "summary":
              case "ul":
              case "pre":
              case "listing":
              case "table":
              case "hr":
              case "xmp":
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return ancestorInfo.pTagInButtonScope;
              case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
              case "li":
                return ancestorInfo.listItemTagAutoclosing;
              case "dd":
              case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
              case "button":
                return ancestorInfo.buttonTagInScope;
              case "a":
                return ancestorInfo.aTagInScope;
              case "nobr":
                return ancestorInfo.nobrTagInScope;
            }
            return null;
          };
          var didWarn$1 = {};
          validateDOMNesting = function(childTag, childText, ancestorInfo) {
            ancestorInfo = ancestorInfo || emptyAncestorInfo;
            var parentInfo = ancestorInfo.current;
            var parentTag = parentInfo && parentInfo.tag;
            if (childText != null) {
              if (childTag != null) {
                error("validateDOMNesting: when childText is passed, childTag should be null");
              }
              childTag = "#text";
            }
            var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
            var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
            var invalidParentOrAncestor = invalidParent || invalidAncestor;
            if (!invalidParentOrAncestor) {
              return;
            }
            var ancestorTag = invalidParentOrAncestor.tag;
            var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
            if (didWarn$1[warnKey]) {
              return;
            }
            didWarn$1[warnKey] = true;
            var tagDisplayName = childTag;
            var whitespaceInfo = "";
            if (childTag === "#text") {
              if (/\S/.test(childText)) {
                tagDisplayName = "Text nodes";
              } else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
              }
            } else {
              tagDisplayName = "<" + childTag + ">";
            }
            if (invalidParent) {
              var info = "";
              if (ancestorTag === "table" && childTag === "tr") {
                info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
              }
              error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
            } else {
              error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
            }
          };
        }
        var SUPPRESS_HYDRATION_WARNING$1;
        {
          SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
        }
        var SUSPENSE_START_DATA = "$";
        var SUSPENSE_END_DATA = "/$";
        var SUSPENSE_PENDING_START_DATA = "$?";
        var SUSPENSE_FALLBACK_START_DATA = "$!";
        var STYLE$1 = "style";
        var eventsEnabled = null;
        var selectionInformation = null;
        function shouldAutoFocusHostComponent(type, props) {
          switch (type) {
            case "button":
            case "input":
            case "select":
            case "textarea":
              return !!props.autoFocus;
          }
          return false;
        }
        function getRootHostContext(rootContainerInstance) {
          var type;
          var namespace;
          var nodeType = rootContainerInstance.nodeType;
          switch (nodeType) {
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE: {
              type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
              var root4 = rootContainerInstance.documentElement;
              namespace = root4 ? root4.namespaceURI : getChildNamespace(null, "");
              break;
            }
            default: {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type = container.tagName;
              namespace = getChildNamespace(ownNamespace, type);
              break;
            }
          }
          {
            var validatedTag = type.toLowerCase();
            var ancestorInfo = updatedAncestorInfo(null, validatedTag);
            return {
              namespace,
              ancestorInfo
            };
          }
        }
        function getChildHostContext(parentHostContext, type, rootContainerInstance) {
          {
            var parentHostContextDev = parentHostContext;
            var namespace = getChildNamespace(parentHostContextDev.namespace, type);
            var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
            return {
              namespace,
              ancestorInfo
            };
          }
        }
        function getPublicInstance(instance) {
          return instance;
        }
        function prepareForCommit(containerInfo) {
          eventsEnabled = isEnabled();
          selectionInformation = getSelectionInformation();
          var activeInstance = null;
          setEnabled(false);
          return activeInstance;
        }
        function resetAfterCommit(containerInfo) {
          restoreSelection(selectionInformation);
          setEnabled(eventsEnabled);
          eventsEnabled = null;
          selectionInformation = null;
        }
        function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          var parentNamespace;
          {
            var hostContextDev = hostContext;
            validateDOMNesting(type, null, hostContextDev.ancestorInfo);
            if (typeof props.children === "string" || typeof props.children === "number") {
              var string = "" + props.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
              validateDOMNesting(null, string, ownAncestorInfo);
            }
            parentNamespace = hostContextDev.namespace;
          }
          var domElement = createElement11(type, props, rootContainerInstance, parentNamespace);
          precacheFiberNode(internalInstanceHandle, domElement);
          updateFiberProps(domElement, props);
          return domElement;
        }
        function appendInitialChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }
        function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
          setInitialProperties(domElement, type, props, rootContainerInstance);
          return shouldAutoFocusHostComponent(type, props);
        }
        function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
          {
            var hostContextDev = hostContext;
            if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
              var string = "" + newProps.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
              validateDOMNesting(null, string, ownAncestorInfo);
            }
          }
          return diffProperties(domElement, type, oldProps, newProps);
        }
        function shouldSetTextContent(type, props) {
          return type === "textarea" || type === "option" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
        }
        function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
          {
            var hostContextDev = hostContext;
            validateDOMNesting(null, text, hostContextDev.ancestorInfo);
          }
          var textNode = createTextNode(text, rootContainerInstance);
          precacheFiberNode(internalInstanceHandle, textNode);
          return textNode;
        }
        var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : void 0;
        var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : void 0;
        var noTimeout = -1;
        function commitMount(domElement, type, newProps, internalInstanceHandle) {
          if (shouldAutoFocusHostComponent(type, newProps)) {
            domElement.focus();
          }
        }
        function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
          updateFiberProps(domElement, newProps);
          updateProperties(domElement, updatePayload, type, oldProps, newProps);
        }
        function resetTextContent(domElement) {
          setTextContent(domElement, "");
        }
        function commitTextUpdate(textInstance, oldText, newText) {
          textInstance.nodeValue = newText;
        }
        function appendChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }
        function appendChildToContainer(container, child) {
          var parentNode;
          if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
          } else {
            parentNode = container;
            parentNode.appendChild(child);
          }
          var reactRootContainer = container._reactRootContainer;
          if ((reactRootContainer === null || reactRootContainer === void 0) && parentNode.onclick === null) {
            trapClickOnNonInteractiveElement(parentNode);
          }
        }
        function insertBefore(parentInstance, child, beforeChild) {
          parentInstance.insertBefore(child, beforeChild);
        }
        function insertInContainerBefore(container, child, beforeChild) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.insertBefore(child, beforeChild);
          } else {
            container.insertBefore(child, beforeChild);
          }
        }
        function removeChild(parentInstance, child) {
          parentInstance.removeChild(child);
        }
        function removeChildFromContainer(container, child) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.removeChild(child);
          } else {
            container.removeChild(child);
          }
        }
        function hideInstance(instance) {
          instance = instance;
          var style2 = instance.style;
          if (typeof style2.setProperty === "function") {
            style2.setProperty("display", "none", "important");
          } else {
            style2.display = "none";
          }
        }
        function hideTextInstance(textInstance) {
          textInstance.nodeValue = "";
        }
        function unhideInstance(instance, props) {
          instance = instance;
          var styleProp = props[STYLE$1];
          var display = styleProp !== void 0 && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
          instance.style.display = dangerousStyleValue("display", display);
        }
        function unhideTextInstance(textInstance, text) {
          textInstance.nodeValue = text;
        }
        function clearContainer(container) {
          if (container.nodeType === ELEMENT_NODE) {
            container.textContent = "";
          } else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;
            if (body != null) {
              body.textContent = "";
            }
          }
        }
        function canHydrateInstance(instance, type, props) {
          if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
            return null;
          }
          return instance;
        }
        function canHydrateTextInstance(instance, text) {
          if (text === "" || instance.nodeType !== TEXT_NODE) {
            return null;
          }
          return instance;
        }
        function isSuspenseInstancePending(instance) {
          return instance.data === SUSPENSE_PENDING_START_DATA;
        }
        function isSuspenseInstanceFallback(instance) {
          return instance.data === SUSPENSE_FALLBACK_START_DATA;
        }
        function getNextHydratable(node) {
          for (; node != null; node = node.nextSibling) {
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
              break;
            }
          }
          return node;
        }
        function getNextHydratableSibling(instance) {
          return getNextHydratable(instance.nextSibling);
        }
        function getFirstHydratableChild(parentInstance) {
          return getNextHydratable(parentInstance.firstChild);
        }
        function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, instance);
          updateFiberProps(instance, props);
          var parentNamespace;
          {
            var hostContextDev = hostContext;
            parentNamespace = hostContextDev.namespace;
          }
          return diffHydratedProperties(instance, type, props, parentNamespace);
        }
        function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, textInstance);
          return diffHydratedText(textInstance, text);
        }
        function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
          var node = suspenseInstance.nextSibling;
          var depth = 0;
          while (node) {
            if (node.nodeType === COMMENT_NODE) {
              var data = node.data;
              if (data === SUSPENSE_END_DATA) {
                if (depth === 0) {
                  return getNextHydratableSibling(node);
                } else {
                  depth--;
                }
              } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                depth++;
              }
            }
            node = node.nextSibling;
          }
          return null;
        }
        function getParentSuspenseInstance(targetInstance) {
          var node = targetInstance.previousSibling;
          var depth = 0;
          while (node) {
            if (node.nodeType === COMMENT_NODE) {
              var data = node.data;
              if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                if (depth === 0) {
                  return node;
                } else {
                  depth--;
                }
              } else if (data === SUSPENSE_END_DATA) {
                depth++;
              }
            }
            node = node.previousSibling;
          }
          return null;
        }
        function commitHydratedContainer(container) {
          retryIfBlockedOn(container);
        }
        function commitHydratedSuspenseInstance(suspenseInstance) {
          retryIfBlockedOn(suspenseInstance);
        }
        function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
          {
            warnForUnmatchedText(textInstance, text);
          }
        }
        function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForUnmatchedText(textInstance, text);
          }
        }
        function didNotHydrateContainerInstance(parentContainer, instance) {
          {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentContainer, instance);
            } else if (instance.nodeType === COMMENT_NODE)
              ;
            else {
              warnForDeletedHydratableText(parentContainer, instance);
            }
          }
        }
        function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else if (instance.nodeType === COMMENT_NODE)
              ;
            else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }
        function didNotFindHydratableContainerInstance(parentContainer, type, props) {
          {
            warnForInsertedHydratedElement(parentContainer, type);
          }
        }
        function didNotFindHydratableContainerTextInstance(parentContainer, text) {
          {
            warnForInsertedHydratedText(parentContainer, text);
          }
        }
        function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedElement(parentInstance, type);
          }
        }
        function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        }
        function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true)
            ;
        }
        var clientId = 0;
        function makeClientIdInDEV(warnOnAccessInDEV) {
          var id = "r:" + (clientId++).toString(36);
          return {
            toString: function() {
              warnOnAccessInDEV();
              return id;
            },
            valueOf: function() {
              warnOnAccessInDEV();
              return id;
            }
          };
        }
        function isOpaqueHydratingObject(value) {
          return value !== null && typeof value === "object" && value.$$typeof === REACT_OPAQUE_ID_TYPE;
        }
        function makeOpaqueHydratingObject(attemptToReadValue) {
          return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
          };
        }
        function preparePortalMount(portalInstance) {
          {
            listenToAllSupportedEvents(portalInstance);
          }
        }
        var randomKey = Math.random().toString(36).slice(2);
        var internalInstanceKey = "__reactFiber$" + randomKey;
        var internalPropsKey = "__reactProps$" + randomKey;
        var internalContainerInstanceKey = "__reactContainer$" + randomKey;
        var internalEventHandlersKey = "__reactEvents$" + randomKey;
        function precacheFiberNode(hostInst, node) {
          node[internalInstanceKey] = hostInst;
        }
        function markContainerAsRoot(hostRoot, node) {
          node[internalContainerInstanceKey] = hostRoot;
        }
        function unmarkContainerAsRoot(node) {
          node[internalContainerInstanceKey] = null;
        }
        function isContainerMarkedAsRoot(node) {
          return !!node[internalContainerInstanceKey];
        }
        function getClosestInstanceFromNode(targetNode) {
          var targetInst = targetNode[internalInstanceKey];
          if (targetInst) {
            return targetInst;
          }
          var parentNode = targetNode.parentNode;
          while (parentNode) {
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
              var alternate = targetInst.alternate;
              if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                var suspenseInstance = getParentSuspenseInstance(targetNode);
                while (suspenseInstance !== null) {
                  var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                  if (targetSuspenseInst) {
                    return targetSuspenseInst;
                  }
                  suspenseInstance = getParentSuspenseInstance(suspenseInstance);
                }
              }
              return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
          }
          return null;
        }
        function getInstanceFromNode(node) {
          var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
          if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
              return inst;
            } else {
              return null;
            }
          }
          return null;
        }
        function getNodeFromInstance(inst) {
          if (inst.tag === HostComponent || inst.tag === HostText) {
            return inst.stateNode;
          }
          {
            {
              throw Error("getNodeFromInstance: Invalid argument.");
            }
          }
        }
        function getFiberCurrentPropsFromNode(node) {
          return node[internalPropsKey] || null;
        }
        function updateFiberProps(node, props) {
          node[internalPropsKey] = props;
        }
        function getEventListenerSet(node) {
          var elementListenerSet = node[internalEventHandlersKey];
          if (elementListenerSet === void 0) {
            elementListenerSet = node[internalEventHandlersKey] = new Set();
          }
          return elementListenerSet;
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has2 = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has2(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var valueStack = [];
        var fiberStack;
        {
          fiberStack = [];
        }
        var index = -1;
        function createCursor(defaultValue) {
          return {
            current: defaultValue
          };
        }
        function pop(cursor, fiber) {
          if (index < 0) {
            {
              error("Unexpected pop.");
            }
            return;
          }
          {
            if (fiber !== fiberStack[index]) {
              error("Unexpected Fiber popped.");
            }
          }
          cursor.current = valueStack[index];
          valueStack[index] = null;
          {
            fiberStack[index] = null;
          }
          index--;
        }
        function push(cursor, value, fiber) {
          index++;
          valueStack[index] = cursor.current;
          {
            fiberStack[index] = fiber;
          }
          cursor.current = value;
        }
        var warnedAboutMissingGetChildContext;
        {
          warnedAboutMissingGetChildContext = {};
        }
        var emptyContextObject = {};
        {
          Object.freeze(emptyContextObject);
        }
        var contextStackCursor = createCursor(emptyContextObject);
        var didPerformWorkStackCursor = createCursor(false);
        var previousContext = emptyContextObject;
        function getUnmaskedContext(workInProgress2, Component, didPushOwnContextIfProvider) {
          {
            if (didPushOwnContextIfProvider && isContextProvider(Component)) {
              return previousContext;
            }
            return contextStackCursor.current;
          }
        }
        function cacheContext(workInProgress2, unmaskedContext, maskedContext) {
          {
            var instance = workInProgress2.stateNode;
            instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
            instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
          }
        }
        function getMaskedContext(workInProgress2, unmaskedContext) {
          {
            var type = workInProgress2.type;
            var contextTypes = type.contextTypes;
            if (!contextTypes) {
              return emptyContextObject;
            }
            var instance = workInProgress2.stateNode;
            if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
              return instance.__reactInternalMemoizedMaskedChildContext;
            }
            var context3 = {};
            for (var key in contextTypes) {
              context3[key] = unmaskedContext[key];
            }
            {
              var name = getComponentName(type) || "Unknown";
              checkPropTypes(contextTypes, context3, "context", name);
            }
            if (instance) {
              cacheContext(workInProgress2, unmaskedContext, context3);
            }
            return context3;
          }
        }
        function hasContextChanged() {
          {
            return didPerformWorkStackCursor.current;
          }
        }
        function isContextProvider(type) {
          {
            var childContextTypes = type.childContextTypes;
            return childContextTypes !== null && childContextTypes !== void 0;
          }
        }
        function popContext(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function popTopLevelContextObject(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function pushTopLevelContextObject(fiber, context3, didChange) {
          {
            if (!(contextStackCursor.current === emptyContextObject)) {
              {
                throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            push(contextStackCursor, context3, fiber);
            push(didPerformWorkStackCursor, didChange, fiber);
          }
        }
        function processChildContext(fiber, type, parentContext) {
          {
            var instance = fiber.stateNode;
            var childContextTypes = type.childContextTypes;
            if (typeof instance.getChildContext !== "function") {
              {
                var componentName = getComponentName(type) || "Unknown";
                if (!warnedAboutMissingGetChildContext[componentName]) {
                  warnedAboutMissingGetChildContext[componentName] = true;
                  error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
                }
              }
              return parentContext;
            }
            var childContext = instance.getChildContext();
            for (var contextKey in childContext) {
              if (!(contextKey in childContextTypes)) {
                {
                  throw Error((getComponentName(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
                }
              }
            }
            {
              var name = getComponentName(type) || "Unknown";
              checkPropTypes(childContextTypes, childContext, "child context", name);
            }
            return _assign({}, parentContext, childContext);
          }
        }
        function pushContextProvider(workInProgress2) {
          {
            var instance = workInProgress2.stateNode;
            var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
            previousContext = contextStackCursor.current;
            push(contextStackCursor, memoizedMergedChildContext, workInProgress2);
            push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress2);
            return true;
          }
        }
        function invalidateContextProvider(workInProgress2, type, didChange) {
          {
            var instance = workInProgress2.stateNode;
            if (!instance) {
              {
                throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            if (didChange) {
              var mergedContext = processChildContext(workInProgress2, type, previousContext);
              instance.__reactInternalMemoizedMergedChildContext = mergedContext;
              pop(didPerformWorkStackCursor, workInProgress2);
              pop(contextStackCursor, workInProgress2);
              push(contextStackCursor, mergedContext, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            } else {
              pop(didPerformWorkStackCursor, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            }
          }
        }
        function findCurrentUnmaskedContext(fiber) {
          {
            if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
              {
                throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var node = fiber;
            do {
              switch (node.tag) {
                case HostRoot:
                  return node.stateNode.context;
                case ClassComponent: {
                  var Component = node.type;
                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
              }
              node = node.return;
            } while (node !== null);
            {
              {
                throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var LegacyRoot = 0;
        var BlockingRoot = 1;
        var ConcurrentRoot = 2;
        var rendererID = null;
        var injectedHook = null;
        var hasLoggedError = false;
        var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
        function injectInternals(internals) {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
            return false;
          }
          var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (hook.isDisabled) {
            return true;
          }
          if (!hook.supportsFiber) {
            {
              error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            }
            return true;
          }
          try {
            rendererID = hook.inject(internals);
            injectedHook = hook;
          } catch (err) {
            {
              error("React instrumentation encountered an error: %s.", err);
            }
          }
          return true;
        }
        function onScheduleRoot(root4, children) {
          {
            if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") {
              try {
                injectedHook.onScheduleFiberRoot(rendererID, root4, children);
              } catch (err) {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        function onCommitRoot(root4, priorityLevel) {
          if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") {
            try {
              var didError = (root4.current.flags & DidCapture) === DidCapture;
              if (enableProfilerTimer) {
                injectedHook.onCommitFiberRoot(rendererID, root4, priorityLevel, didError);
              } else {
                injectedHook.onCommitFiberRoot(rendererID, root4, void 0, didError);
              }
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        function onCommitUnmount(fiber) {
          if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") {
            try {
              injectedHook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
        {
          if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        }
        var fakeCallbackNode = {};
        var ImmediatePriority$1 = 99;
        var UserBlockingPriority$2 = 98;
        var NormalPriority$1 = 97;
        var LowPriority$1 = 96;
        var IdlePriority$1 = 95;
        var NoPriority$1 = 90;
        var shouldYield = Scheduler_shouldYield;
        var requestPaint = Scheduler_requestPaint !== void 0 ? Scheduler_requestPaint : function() {
        };
        var syncQueue = null;
        var immediateQueueCallbackNode = null;
        var isFlushingSyncQueue = false;
        var initialTimeMs$1 = Scheduler_now$1();
        var now2 = initialTimeMs$1 < 1e4 ? Scheduler_now$1 : function() {
          return Scheduler_now$1() - initialTimeMs$1;
        };
        function getCurrentPriorityLevel() {
          switch (Scheduler_getCurrentPriorityLevel()) {
            case Scheduler_ImmediatePriority:
              return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
              return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
              return NormalPriority$1;
            case Scheduler_LowPriority:
              return LowPriority$1;
            case Scheduler_IdlePriority:
              return IdlePriority$1;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function reactPriorityToSchedulerPriority(reactPriorityLevel) {
          switch (reactPriorityLevel) {
            case ImmediatePriority$1:
              return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
              return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
              return Scheduler_NormalPriority;
            case LowPriority$1:
              return Scheduler_LowPriority;
            case IdlePriority$1:
              return Scheduler_IdlePriority;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function runWithPriority$1(reactPriorityLevel, fn2) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_runWithPriority(priorityLevel, fn2);
        }
        function scheduleCallback(reactPriorityLevel, callback, options3) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_scheduleCallback(priorityLevel, callback, options3);
        }
        function scheduleSyncCallback(callback) {
          if (syncQueue === null) {
            syncQueue = [callback];
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
          } else {
            syncQueue.push(callback);
          }
          return fakeCallbackNode;
        }
        function cancelCallback(callbackNode) {
          if (callbackNode !== fakeCallbackNode) {
            Scheduler_cancelCallback(callbackNode);
          }
        }
        function flushSyncCallbackQueue() {
          if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
          }
          flushSyncCallbackQueueImpl();
        }
        function flushSyncCallbackQueueImpl() {
          if (!isFlushingSyncQueue && syncQueue !== null) {
            isFlushingSyncQueue = true;
            var i3 = 0;
            {
              try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function() {
                  for (; i3 < _queue.length; i3++) {
                    var callback = _queue[i3];
                    do {
                      callback = callback(_isSync2);
                    } while (callback !== null);
                  }
                });
                syncQueue = null;
              } catch (error2) {
                if (syncQueue !== null) {
                  syncQueue = syncQueue.slice(i3 + 1);
                }
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error2;
              } finally {
                isFlushingSyncQueue = false;
              }
            }
          }
        }
        var ReactVersion = "17.0.2";
        var NoMode = 0;
        var StrictMode = 1;
        var BlockingMode = 2;
        var ConcurrentMode = 4;
        var ProfileMode = 8;
        var DebugTracingMode = 16;
        var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
        var NoTransition = 0;
        function requestCurrentTransition() {
          return ReactCurrentBatchConfig.transition;
        }
        var ReactStrictModeWarnings = {
          recordUnsafeLifecycleWarnings: function(fiber, instance) {
          },
          flushPendingUnsafeLifecycleWarnings: function() {
          },
          recordLegacyContextWarning: function(fiber, instance) {
          },
          flushLegacyContextWarning: function() {
          },
          discardPendingWarnings: function() {
          }
        };
        {
          var findStrictRoot = function(fiber) {
            var maybeStrictRoot = null;
            var node = fiber;
            while (node !== null) {
              if (node.mode & StrictMode) {
                maybeStrictRoot = node;
              }
              node = node.return;
            }
            return maybeStrictRoot;
          };
          var setToSortedString = function(set3) {
            var array = [];
            set3.forEach(function(value) {
              array.push(value);
            });
            return array.sort().join(", ");
          };
          var pendingComponentWillMountWarnings = [];
          var pendingUNSAFE_ComponentWillMountWarnings = [];
          var pendingComponentWillReceivePropsWarnings = [];
          var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          var pendingComponentWillUpdateWarnings = [];
          var pendingUNSAFE_ComponentWillUpdateWarnings = [];
          var didWarnAboutUnsafeLifecycles = new Set();
          ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
            if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
              return;
            }
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              pendingComponentWillMountWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") {
              pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
            }
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              pendingComponentWillReceivePropsWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
            }
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              pendingComponentWillUpdateWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") {
              pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
            var componentWillMountUniqueNames = new Set();
            if (pendingComponentWillMountWarnings.length > 0) {
              pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillMountWarnings = [];
            }
            var UNSAFE_componentWillMountUniqueNames = new Set();
            if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
              pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillMountWarnings = [];
            }
            var componentWillReceivePropsUniqueNames = new Set();
            if (pendingComponentWillReceivePropsWarnings.length > 0) {
              pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillReceivePropsWarnings = [];
            }
            var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
            if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            }
            var componentWillUpdateUniqueNames = new Set();
            if (pendingComponentWillUpdateWarnings.length > 0) {
              pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillUpdateWarnings = [];
            }
            var UNSAFE_componentWillUpdateUniqueNames = new Set();
            if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
              pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillUpdateWarnings = [];
            }
            if (UNSAFE_componentWillMountUniqueNames.size > 0) {
              var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
              error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
            }
            if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
              error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
            }
            if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
              error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
            }
            if (componentWillMountUniqueNames.size > 0) {
              var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
              warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
            }
            if (componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
              warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
            }
            if (componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
              warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
            }
          };
          var pendingLegacyContextWarning = new Map();
          var didWarnAboutLegacyContext = new Set();
          ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
            var strictRoot = findStrictRoot(fiber);
            if (strictRoot === null) {
              error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
              return;
            }
            if (didWarnAboutLegacyContext.has(fiber.type)) {
              return;
            }
            var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
            if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
              if (warningsForRoot === void 0) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
              }
              warningsForRoot.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushLegacyContextWarning = function() {
            pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
              if (fiberArray.length === 0) {
                return;
              }
              var firstFiber = fiberArray[0];
              var uniqueNames = new Set();
              fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);
              try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
              } finally {
                resetCurrentFiber();
              }
            });
          };
          ReactStrictModeWarnings.discardPendingWarnings = function() {
            pendingComponentWillMountWarnings = [];
            pendingUNSAFE_ComponentWillMountWarnings = [];
            pendingComponentWillReceivePropsWarnings = [];
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            pendingComponentWillUpdateWarnings = [];
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
            pendingLegacyContextWarning = new Map();
          };
        }
        function resolveDefaultProps(Component, baseProps) {
          if (Component && Component.defaultProps) {
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for (var propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
            return props;
          }
          return baseProps;
        }
        var MAX_SIGNED_31_BIT_INT = 1073741823;
        var valueCursor = createCursor(null);
        var rendererSigil;
        {
          rendererSigil = {};
        }
        var currentlyRenderingFiber = null;
        var lastContextDependency = null;
        var lastContextWithAllBitsObserved = null;
        var isDisallowedContextReadInDEV = false;
        function resetContextDependencies() {
          currentlyRenderingFiber = null;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function enterDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = true;
          }
        }
        function exitDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function pushProvider(providerFiber, nextValue) {
          var context3 = providerFiber.type._context;
          {
            push(valueCursor, context3._currentValue, providerFiber);
            context3._currentValue = nextValue;
            {
              if (context3._currentRenderer !== void 0 && context3._currentRenderer !== null && context3._currentRenderer !== rendererSigil) {
                error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
              }
              context3._currentRenderer = rendererSigil;
            }
          }
        }
        function popProvider(providerFiber) {
          var currentValue = valueCursor.current;
          pop(valueCursor, providerFiber);
          var context3 = providerFiber.type._context;
          {
            context3._currentValue = currentValue;
          }
        }
        function calculateChangedBits(context3, newValue, oldValue) {
          if (objectIs(oldValue, newValue)) {
            return 0;
          } else {
            var changedBits = typeof context3._calculateChangedBits === "function" ? context3._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            {
              if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
                error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
              }
            }
            return changedBits | 0;
          }
        }
        function scheduleWorkOnParentPath(parent, renderLanes2) {
          var node = parent;
          while (node !== null) {
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes2)) {
              node.childLanes = mergeLanes(node.childLanes, renderLanes2);
              if (alternate !== null) {
                alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
              }
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes2)) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
            } else {
              break;
            }
            node = node.return;
          }
        }
        function propagateContextChange(workInProgress2, context3, changedBits, renderLanes2) {
          var fiber = workInProgress2.child;
          if (fiber !== null) {
            fiber.return = workInProgress2;
          }
          while (fiber !== null) {
            var nextFiber = void 0;
            var list = fiber.dependencies;
            if (list !== null) {
              nextFiber = fiber.child;
              var dependency = list.firstContext;
              while (dependency !== null) {
                if (dependency.context === context3 && (dependency.observedBits & changedBits) !== 0) {
                  if (fiber.tag === ClassComponent) {
                    var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes2));
                    update.tag = ForceUpdate;
                    enqueueUpdate(fiber, update);
                  }
                  fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
                  var alternate = fiber.alternate;
                  if (alternate !== null) {
                    alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
                  }
                  scheduleWorkOnParentPath(fiber.return, renderLanes2);
                  list.lanes = mergeLanes(list.lanes, renderLanes2);
                  break;
                }
                dependency = dependency.next;
              }
            } else if (fiber.tag === ContextProvider) {
              nextFiber = fiber.type === workInProgress2.type ? null : fiber.child;
            } else {
              nextFiber = fiber.child;
            }
            if (nextFiber !== null) {
              nextFiber.return = fiber;
            } else {
              nextFiber = fiber;
              while (nextFiber !== null) {
                if (nextFiber === workInProgress2) {
                  nextFiber = null;
                  break;
                }
                var sibling = nextFiber.sibling;
                if (sibling !== null) {
                  sibling.return = nextFiber.return;
                  nextFiber = sibling;
                  break;
                }
                nextFiber = nextFiber.return;
              }
            }
            fiber = nextFiber;
          }
        }
        function prepareToReadContext(workInProgress2, renderLanes2) {
          currentlyRenderingFiber = workInProgress2;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          var dependencies = workInProgress2.dependencies;
          if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
              if (includesSomeLane(dependencies.lanes, renderLanes2)) {
                markWorkInProgressReceivedUpdate();
              }
              dependencies.firstContext = null;
            }
          }
        }
        function readContext(context3, observedBits) {
          {
            if (isDisallowedContextReadInDEV) {
              error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            }
          }
          if (lastContextWithAllBitsObserved === context3)
            ;
          else if (observedBits === false || observedBits === 0)
            ;
          else {
            var resolvedObservedBits;
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
              lastContextWithAllBitsObserved = context3;
              resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else {
              resolvedObservedBits = observedBits;
            }
            var contextItem = {
              context: context3,
              observedBits: resolvedObservedBits,
              next: null
            };
            if (lastContextDependency === null) {
              if (!(currentlyRenderingFiber !== null)) {
                {
                  throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                }
              }
              lastContextDependency = contextItem;
              currentlyRenderingFiber.dependencies = {
                lanes: NoLanes,
                firstContext: contextItem,
                responders: null
              };
            } else {
              lastContextDependency = lastContextDependency.next = contextItem;
            }
          }
          return context3._currentValue;
        }
        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3;
        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate;
        var currentlyProcessingQueue;
        {
          didWarnUpdateInsideUpdate = false;
          currentlyProcessingQueue = null;
        }
        function initializeUpdateQueue(fiber) {
          var queue2 = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
              pending: null
            },
            effects: null
          };
          fiber.updateQueue = queue2;
        }
        function cloneUpdateQueue(current2, workInProgress2) {
          var queue2 = workInProgress2.updateQueue;
          var currentQueue = current2.updateQueue;
          if (queue2 === currentQueue) {
            var clone = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: currentQueue.firstBaseUpdate,
              lastBaseUpdate: currentQueue.lastBaseUpdate,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress2.updateQueue = clone;
          }
        }
        function createUpdate(eventTime, lane) {
          var update = {
            eventTime,
            lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
          };
          return update;
        }
        function enqueueUpdate(fiber, update) {
          var updateQueue = fiber.updateQueue;
          if (updateQueue === null) {
            return;
          }
          var sharedQueue = updateQueue.shared;
          var pending = sharedQueue.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          sharedQueue.pending = update;
          {
            if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
              error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
              didWarnUpdateInsideUpdate = true;
            }
          }
        }
        function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
          var queue2 = workInProgress2.updateQueue;
          var current2 = workInProgress2.alternate;
          if (current2 !== null) {
            var currentQueue = current2.updateQueue;
            if (queue2 === currentQueue) {
              var newFirst = null;
              var newLast = null;
              var firstBaseUpdate = queue2.firstBaseUpdate;
              if (firstBaseUpdate !== null) {
                var update = firstBaseUpdate;
                do {
                  var clone = {
                    eventTime: update.eventTime,
                    lane: update.lane,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  if (newLast === null) {
                    newFirst = newLast = clone;
                  } else {
                    newLast.next = clone;
                    newLast = clone;
                  }
                  update = update.next;
                } while (update !== null);
                if (newLast === null) {
                  newFirst = newLast = capturedUpdate;
                } else {
                  newLast.next = capturedUpdate;
                  newLast = capturedUpdate;
                }
              } else {
                newFirst = newLast = capturedUpdate;
              }
              queue2 = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: currentQueue.shared,
                effects: currentQueue.effects
              };
              workInProgress2.updateQueue = queue2;
              return;
            }
          }
          var lastBaseUpdate = queue2.lastBaseUpdate;
          if (lastBaseUpdate === null) {
            queue2.firstBaseUpdate = capturedUpdate;
          } else {
            lastBaseUpdate.next = capturedUpdate;
          }
          queue2.lastBaseUpdate = capturedUpdate;
        }
        function getStateFromUpdate(workInProgress2, queue2, update, prevState, nextProps, instance) {
          switch (update.tag) {
            case ReplaceState: {
              var payload = update.payload;
              if (typeof payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress2.mode & StrictMode) {
                    disableLogs();
                    try {
                      payload.call(instance, prevState, nextProps);
                    } finally {
                      reenableLogs();
                    }
                  }
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              }
              return payload;
            }
            case CaptureUpdate: {
              workInProgress2.flags = workInProgress2.flags & ~ShouldCapture | DidCapture;
            }
            case UpdateState: {
              var _payload = update.payload;
              var partialState;
              if (typeof _payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress2.mode & StrictMode) {
                    disableLogs();
                    try {
                      _payload.call(instance, prevState, nextProps);
                    } finally {
                      reenableLogs();
                    }
                  }
                  exitDisallowedContextReadInDEV();
                }
              } else {
                partialState = _payload;
              }
              if (partialState === null || partialState === void 0) {
                return prevState;
              }
              return _assign({}, prevState, partialState);
            }
            case ForceUpdate: {
              hasForceUpdate = true;
              return prevState;
            }
          }
          return prevState;
        }
        function processUpdateQueue(workInProgress2, props, instance, renderLanes2) {
          var queue2 = workInProgress2.updateQueue;
          hasForceUpdate = false;
          {
            currentlyProcessingQueue = queue2.shared;
          }
          var firstBaseUpdate = queue2.firstBaseUpdate;
          var lastBaseUpdate = queue2.lastBaseUpdate;
          var pendingQueue = queue2.shared.pending;
          if (pendingQueue !== null) {
            queue2.shared.pending = null;
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            if (lastBaseUpdate === null) {
              firstBaseUpdate = firstPendingUpdate;
            } else {
              lastBaseUpdate.next = firstPendingUpdate;
            }
            lastBaseUpdate = lastPendingUpdate;
            var current2 = workInProgress2.alternate;
            if (current2 !== null) {
              var currentQueue = current2.updateQueue;
              var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
              if (currentLastBaseUpdate !== lastBaseUpdate) {
                if (currentLastBaseUpdate === null) {
                  currentQueue.firstBaseUpdate = firstPendingUpdate;
                } else {
                  currentLastBaseUpdate.next = firstPendingUpdate;
                }
                currentQueue.lastBaseUpdate = lastPendingUpdate;
              }
            }
          }
          if (firstBaseUpdate !== null) {
            var newState = queue2.baseState;
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
              var updateLane = update.lane;
              var updateEventTime = update.eventTime;
              if (!isSubsetOfLanes(renderLanes2, updateLane)) {
                var clone = {
                  eventTime: updateEventTime,
                  lane: updateLane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                if (newLastBaseUpdate === null) {
                  newFirstBaseUpdate = newLastBaseUpdate = clone;
                  newBaseState = newState;
                } else {
                  newLastBaseUpdate = newLastBaseUpdate.next = clone;
                }
                newLanes = mergeLanes(newLanes, updateLane);
              } else {
                if (newLastBaseUpdate !== null) {
                  var _clone = {
                    eventTime: updateEventTime,
                    lane: NoLane,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                }
                newState = getStateFromUpdate(workInProgress2, queue2, update, newState, props, instance);
                var callback = update.callback;
                if (callback !== null) {
                  workInProgress2.flags |= Callback;
                  var effects = queue2.effects;
                  if (effects === null) {
                    queue2.effects = [update];
                  } else {
                    effects.push(update);
                  }
                }
              }
              update = update.next;
              if (update === null) {
                pendingQueue = queue2.shared.pending;
                if (pendingQueue === null) {
                  break;
                } else {
                  var _lastPendingUpdate = pendingQueue;
                  var _firstPendingUpdate = _lastPendingUpdate.next;
                  _lastPendingUpdate.next = null;
                  update = _firstPendingUpdate;
                  queue2.lastBaseUpdate = _lastPendingUpdate;
                  queue2.shared.pending = null;
                }
              }
            } while (true);
            if (newLastBaseUpdate === null) {
              newBaseState = newState;
            }
            queue2.baseState = newBaseState;
            queue2.firstBaseUpdate = newFirstBaseUpdate;
            queue2.lastBaseUpdate = newLastBaseUpdate;
            markSkippedUpdateLanes(newLanes);
            workInProgress2.lanes = newLanes;
            workInProgress2.memoizedState = newState;
          }
          {
            currentlyProcessingQueue = null;
          }
        }
        function callCallback(callback, context3) {
          if (!(typeof callback === "function")) {
            {
              throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
            }
          }
          callback.call(context3);
        }
        function resetHasForceUpdateBeforeProcessing() {
          hasForceUpdate = false;
        }
        function checkHasForceUpdateAfterProcessing() {
          return hasForceUpdate;
        }
        function commitUpdateQueue(finishedWork, finishedQueue, instance) {
          var effects = finishedQueue.effects;
          finishedQueue.effects = null;
          if (effects !== null) {
            for (var i3 = 0; i3 < effects.length; i3++) {
              var effect = effects[i3];
              var callback = effect.callback;
              if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
              }
            }
          }
        }
        var fakeInternalInstance = {};
        var isArray2 = Array.isArray;
        var emptyRefsObject = new React149.Component().refs;
        var didWarnAboutStateAssignmentForComponent;
        var didWarnAboutUninitializedState;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
        var didWarnAboutLegacyLifecyclesAndDerivedState;
        var didWarnAboutUndefinedDerivedState;
        var warnOnUndefinedDerivedState;
        var warnOnInvalidCallback;
        var didWarnAboutDirectlyAssigningPropsToState;
        var didWarnAboutContextTypeAndContextTypes;
        var didWarnAboutInvalidateContextType;
        {
          didWarnAboutStateAssignmentForComponent = new Set();
          didWarnAboutUninitializedState = new Set();
          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
          didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
          didWarnAboutDirectlyAssigningPropsToState = new Set();
          didWarnAboutUndefinedDerivedState = new Set();
          didWarnAboutContextTypeAndContextTypes = new Set();
          didWarnAboutInvalidateContextType = new Set();
          var didWarnOnInvalidCallback = new Set();
          warnOnInvalidCallback = function(callback, callerName) {
            if (callback === null || typeof callback === "function") {
              return;
            }
            var key = callerName + "_" + callback;
            if (!didWarnOnInvalidCallback.has(key)) {
              didWarnOnInvalidCallback.add(key);
              error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
            }
          };
          warnOnUndefinedDerivedState = function(type, partialState) {
            if (partialState === void 0) {
              var componentName = getComponentName(type) || "Component";
              if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
              }
            }
          };
          Object.defineProperty(fakeInternalInstance, "_processChildContext", {
            enumerable: false,
            value: function() {
              {
                {
                  throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
                }
              }
            }
          });
          Object.freeze(fakeInternalInstance);
        }
        function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
          var prevState = workInProgress2.memoizedState;
          {
            if (workInProgress2.mode & StrictMode) {
              disableLogs();
              try {
                getDerivedStateFromProps(nextProps, prevState);
              } finally {
                reenableLogs();
              }
            }
          }
          var partialState = getDerivedStateFromProps(nextProps, prevState);
          {
            warnOnUndefinedDerivedState(ctor, partialState);
          }
          var memoizedState = partialState === null || partialState === void 0 ? prevState : _assign({}, prevState, partialState);
          workInProgress2.memoizedState = memoizedState;
          if (workInProgress2.lanes === NoLanes) {
            var updateQueue = workInProgress2.updateQueue;
            updateQueue.baseState = memoizedState;
          }
        }
        var classComponentUpdater = {
          isMounted,
          enqueueSetState: function(inst, payload, callback) {
            var fiber = get2(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "setState");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get2(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "replaceState");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueForceUpdate: function(inst, callback) {
            var fiber = get2(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "forceUpdate");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        };
        function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
          var instance = workInProgress2.stateNode;
          if (typeof instance.shouldComponentUpdate === "function") {
            {
              if (workInProgress2.mode & StrictMode) {
                disableLogs();
                try {
                  instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally {
                  reenableLogs();
                }
              }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            {
              if (shouldUpdate === void 0) {
                error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
              }
            }
            return shouldUpdate;
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent) {
            return !shallowEqual3(oldProps, newProps) || !shallowEqual3(oldState, newState);
          }
          return true;
        }
        function checkClassInstance(workInProgress2, ctor, newProps) {
          var instance = workInProgress2.stateNode;
          {
            var name = getComponentName(ctor) || "Component";
            var renderPresent = instance.render;
            if (!renderPresent) {
              if (ctor.prototype && typeof ctor.prototype.render === "function") {
                error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
              } else {
                error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
              }
            }
            if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
              error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
            }
            if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
              error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
            }
            if (instance.propTypes) {
              error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
            }
            if (instance.contextType) {
              error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
            }
            {
              if (instance.contextTypes) {
                error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
              }
              if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                didWarnAboutContextTypeAndContextTypes.add(ctor);
                error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
              }
            }
            if (typeof instance.componentShouldUpdate === "function") {
              error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
            }
            if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
              error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
            }
            if (typeof instance.componentDidUnmount === "function") {
              error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
            }
            if (typeof instance.componentDidReceiveProps === "function") {
              error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
            }
            if (typeof instance.componentWillRecieveProps === "function") {
              error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
            }
            if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
              error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
            }
            var hasMutatedProps = instance.props !== newProps;
            if (instance.props !== void 0 && hasMutatedProps) {
              error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
            }
            if (instance.defaultProps) {
              error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
              didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
              error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
            }
            if (typeof instance.getDerivedStateFromProps === "function") {
              error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
            }
            if (typeof instance.getDerivedStateFromError === "function") {
              error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
            }
            if (typeof ctor.getSnapshotBeforeUpdate === "function") {
              error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
            }
            var _state = instance.state;
            if (_state && (typeof _state !== "object" || isArray2(_state))) {
              error("%s.state: must be set to an object or null", name);
            }
            if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
              error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
            }
          }
        }
        function adoptClassInstance(workInProgress2, instance) {
          instance.updater = classComponentUpdater;
          workInProgress2.stateNode = instance;
          set2(instance, workInProgress2);
          {
            instance._reactInternalInstance = fakeInternalInstance;
          }
        }
        function constructClassInstance(workInProgress2, ctor, props) {
          var isLegacyContextConsumer = false;
          var unmaskedContext = emptyContextObject;
          var context3 = emptyContextObject;
          var contextType = ctor.contextType;
          {
            if ("contextType" in ctor) {
              var isValid = contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0;
              if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === void 0) {
                  addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                } else if (typeof contextType !== "object") {
                  addendum = " However, it is set to a " + typeof contextType + ".";
                } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                  addendum = " Did you accidentally pass the Context.Provider instead?";
                } else if (contextType._context !== void 0) {
                  addendum = " Did you accidentally pass the Context.Consumer instead?";
                } else {
                  addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                }
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
              }
            }
          }
          if (typeof contextType === "object" && contextType !== null) {
            context3 = readContext(contextType);
          } else {
            unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== void 0;
            context3 = isLegacyContextConsumer ? getMaskedContext(workInProgress2, unmaskedContext) : emptyContextObject;
          }
          {
            if (workInProgress2.mode & StrictMode) {
              disableLogs();
              try {
                new ctor(props, context3);
              } finally {
                reenableLogs();
              }
            }
          }
          var instance = new ctor(props, context3);
          var state = workInProgress2.memoizedState = instance.state !== null && instance.state !== void 0 ? instance.state : null;
          adoptClassInstance(workInProgress2, instance);
          {
            if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
              }
            }
            if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
              var foundWillMountName = null;
              var foundWillReceivePropsName = null;
              var foundWillUpdateName = null;
              if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                foundWillMountName = "componentWillMount";
              } else if (typeof instance.UNSAFE_componentWillMount === "function") {
                foundWillMountName = "UNSAFE_componentWillMount";
              }
              if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                foundWillReceivePropsName = "componentWillReceiveProps";
              } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
                foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
              }
              if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                foundWillUpdateName = "componentWillUpdate";
              } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                foundWillUpdateName = "UNSAFE_componentWillUpdate";
              }
              if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                  didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                  error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
              }
            }
          }
          if (isLegacyContextConsumer) {
            cacheContext(workInProgress2, unmaskedContext, context3);
          }
          return instance;
        }
        function callComponentWillMount(workInProgress2, instance) {
          var oldState = instance.state;
          if (typeof instance.componentWillMount === "function") {
            instance.componentWillMount();
          }
          if (typeof instance.UNSAFE_componentWillMount === "function") {
            instance.UNSAFE_componentWillMount();
          }
          if (oldState !== instance.state) {
            {
              error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress2.type) || "Component");
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
          var oldState = instance.state;
          if (typeof instance.componentWillReceiveProps === "function") {
            instance.componentWillReceiveProps(newProps, nextContext);
          }
          if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
            instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
          }
          if (instance.state !== oldState) {
            {
              var componentName = getComponentName(workInProgress2.type) || "Component";
              if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
              }
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function mountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
          {
            checkClassInstance(workInProgress2, ctor, newProps);
          }
          var instance = workInProgress2.stateNode;
          instance.props = newProps;
          instance.state = workInProgress2.memoizedState;
          instance.refs = emptyRefsObject;
          initializeUpdateQueue(workInProgress2);
          var contextType = ctor.contextType;
          if (typeof contextType === "object" && contextType !== null) {
            instance.context = readContext(contextType);
          } else {
            var unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            instance.context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          {
            if (instance.state === newProps) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, instance);
            }
            {
              ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress2, instance);
            }
          }
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          instance.state = workInProgress2.memoizedState;
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress2, instance);
            processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof instance.componentDidMount === "function") {
            workInProgress2.flags |= Update;
          }
        }
        function resumeMountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
          var instance = workInProgress2.stateNode;
          var oldProps = workInProgress2.memoizedProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextLegacyUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          newState = workInProgress2.memoizedState;
          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
              if (typeof instance.componentWillMount === "function") {
                instance.componentWillMount();
              }
              if (typeof instance.UNSAFE_componentWillMount === "function") {
                instance.UNSAFE_componentWillMount();
              }
            }
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
          } else {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        function updateClassInstance(current2, workInProgress2, ctor, newProps, renderLanes2) {
          var instance = workInProgress2.stateNode;
          cloneUpdateQueue(current2, workInProgress2);
          var unresolvedOldProps = workInProgress2.memoizedProps;
          var oldProps = workInProgress2.type === workInProgress2.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress2.type, unresolvedOldProps);
          instance.props = oldProps;
          var unresolvedNewProps = workInProgress2.pendingProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          newState = workInProgress2.memoizedState;
          if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Snapshot;
              }
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
              if (typeof instance.componentWillUpdate === "function") {
                instance.componentWillUpdate(newProps, newState, nextContext);
              }
              if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
              }
            }
            if (typeof instance.componentDidUpdate === "function") {
              workInProgress2.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              workInProgress2.flags |= Snapshot;
            }
          } else {
            if (typeof instance.componentDidUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Snapshot;
              }
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        var didWarnAboutMaps;
        var didWarnAboutGenerators;
        var didWarnAboutStringRefs;
        var ownerHasKeyUseWarning;
        var ownerHasFunctionTypeWarning;
        var warnForMissingKey = function(child, returnFiber) {
        };
        {
          didWarnAboutMaps = false;
          didWarnAboutGenerators = false;
          didWarnAboutStringRefs = {};
          ownerHasKeyUseWarning = {};
          ownerHasFunctionTypeWarning = {};
          warnForMissingKey = function(child, returnFiber) {
            if (child === null || typeof child !== "object") {
              return;
            }
            if (!child._store || child._store.validated || child.key != null) {
              return;
            }
            if (!(typeof child._store === "object")) {
              {
                throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            child._store.validated = true;
            var componentName = getComponentName(returnFiber.type) || "Component";
            if (ownerHasKeyUseWarning[componentName]) {
              return;
            }
            ownerHasKeyUseWarning[componentName] = true;
            error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
          };
        }
        var isArray$1 = Array.isArray;
        function coerceRef(returnFiber, current2, element) {
          var mixedRef = element.ref;
          if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            {
              if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                  {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                  }
                  didWarnAboutStringRefs[componentName] = true;
                }
              }
            }
            if (element._owner) {
              var owner = element._owner;
              var inst;
              if (owner) {
                var ownerFiber = owner;
                if (!(ownerFiber.tag === ClassComponent)) {
                  {
                    throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                  }
                }
                inst = ownerFiber.stateNode;
              }
              if (!inst) {
                {
                  throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var stringRef = "" + mixedRef;
              if (current2 !== null && current2.ref !== null && typeof current2.ref === "function" && current2.ref._stringRef === stringRef) {
                return current2.ref;
              }
              var ref = function(value) {
                var refs = inst.refs;
                if (refs === emptyRefsObject) {
                  refs = inst.refs = {};
                }
                if (value === null) {
                  delete refs[stringRef];
                } else {
                  refs[stringRef] = value;
                }
              };
              ref._stringRef = stringRef;
              return ref;
            } else {
              if (!(typeof mixedRef === "string")) {
                {
                  throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                }
              }
              if (!element._owner) {
                {
                  throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
                }
              }
            }
          }
          return mixedRef;
        }
        function throwOnInvalidObjectType(returnFiber, newChild) {
          if (returnFiber.type !== "textarea") {
            {
              {
                throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + "). If you meant to render a collection of children, use an array instead.");
              }
            }
          }
        }
        function warnOnFunctionType(returnFiber) {
          {
            var componentName = getComponentName(returnFiber.type) || "Component";
            if (ownerHasFunctionTypeWarning[componentName]) {
              return;
            }
            ownerHasFunctionTypeWarning[componentName] = true;
            error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
          }
        }
        function ChildReconciler(shouldTrackSideEffects) {
          function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) {
              return;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = childToDelete;
              returnFiber.lastEffect = childToDelete;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
          }
          function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) {
              return null;
            }
            var childToDelete = currentFirstChild;
            while (childToDelete !== null) {
              deleteChild(returnFiber, childToDelete);
              childToDelete = childToDelete.sibling;
            }
            return null;
          }
          function mapRemainingChildren(returnFiber, currentFirstChild) {
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while (existingChild !== null) {
              if (existingChild.key !== null) {
                existingChildren.set(existingChild.key, existingChild);
              } else {
                existingChildren.set(existingChild.index, existingChild);
              }
              existingChild = existingChild.sibling;
            }
            return existingChildren;
          }
          function useFiber(fiber, pendingProps) {
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
          }
          function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
              return lastPlacedIndex;
            }
            var current2 = newFiber.alternate;
            if (current2 !== null) {
              var oldIndex = current2.index;
              if (oldIndex < lastPlacedIndex) {
                newFiber.flags = Placement;
                return lastPlacedIndex;
              } else {
                return oldIndex;
              }
            } else {
              newFiber.flags = Placement;
              return lastPlacedIndex;
            }
          }
          function placeSingleChild(newFiber) {
            if (shouldTrackSideEffects && newFiber.alternate === null) {
              newFiber.flags = Placement;
            }
            return newFiber;
          }
          function updateTextNode(returnFiber, current2, textContent, lanes) {
            if (current2 === null || current2.tag !== HostText) {
              var created = createFiberFromText(textContent, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, textContent);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateElement(returnFiber, current2, element, lanes) {
            if (current2 !== null) {
              if (current2.elementType === element.type || isCompatibleFamilyForHotReloading(current2, element)) {
                var existing = useFiber(current2, element.props);
                existing.ref = coerceRef(returnFiber, current2, element);
                existing.return = returnFiber;
                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }
                return existing;
              }
            }
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current2, element);
            created.return = returnFiber;
            return created;
          }
          function updatePortal(returnFiber, current2, portal, lanes) {
            if (current2 === null || current2.tag !== HostPortal || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation) {
              var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, portal.children || []);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateFragment2(returnFiber, current2, fragment, lanes, key) {
            if (current2 === null || current2.tag !== Fragment3) {
              var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, fragment);
              existing.return = returnFiber;
              return existing;
            }
          }
          function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
                case REACT_PORTAL_TYPE: {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                  _created2.return = returnFiber;
                  return _created2;
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                _created3.return = returnFiber;
                return _created3;
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
              if (key !== null) {
                return null;
              }
              return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment2(returnFiber, oldFiber, newChild.props.children, lanes, key);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }
                case REACT_PORTAL_TYPE: {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                if (key !== null) {
                  return null;
                }
                return updateFragment2(returnFiber, oldFiber, newChild, lanes, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var matchedFiber = existingChildren.get(newIdx) || null;
              return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment2(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                }
                case REACT_PORTAL_TYPE: {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _matchedFiber3 = existingChildren.get(newIdx) || null;
                return updateFragment2(returnFiber, _matchedFiber3, newChild, lanes, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function warnOnInvalidKey(child, knownKeys, returnFiber) {
            {
              if (typeof child !== "object" || child === null) {
                return knownKeys;
              }
              switch (child.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  warnForMissingKey(child, returnFiber);
                  var key = child.key;
                  if (typeof key !== "string") {
                    break;
                  }
                  if (knownKeys === null) {
                    knownKeys = new Set();
                    knownKeys.add(key);
                    break;
                  }
                  if (!knownKeys.has(key)) {
                    knownKeys.add(key);
                    break;
                  }
                  error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                  break;
              }
            }
            return knownKeys;
          }
          function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            {
              var knownKeys = null;
              for (var i3 = 0; i3 < newChildren.length; i3++) {
                var child = newChildren[i3];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; newIdx < newChildren.length; newIdx++) {
                var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                if (_newFiber === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber;
                } else {
                  previousNewFiber.sibling = _newFiber;
                }
                previousNewFiber = _newFiber;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
              if (_newFiber2 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber2.alternate !== null) {
                    existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber2;
                } else {
                  previousNewFiber.sibling = _newFiber2;
                }
                previousNewFiber = _newFiber2;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) {
              {
                throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            {
              if (typeof Symbol === "function" && newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) {
                  error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                }
                didWarnAboutGenerators = true;
              }
              if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) {
                  error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                }
                didWarnAboutMaps = true;
              }
              var _newChildren = iteratorFn.call(newChildrenIterable);
              if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for (; !_step.done; _step = _newChildren.next()) {
                  var child = _step.value;
                  knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
              }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) {
              {
                throw Error("An iterable object provided no iterator.");
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (step.done) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; !step.done; newIdx++, step = newChildren.next()) {
                var _newFiber3 = createChild(returnFiber, step.value, lanes);
                if (_newFiber3 === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber3;
                } else {
                  previousNewFiber.sibling = _newFiber3;
                }
                previousNewFiber = _newFiber3;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
              if (_newFiber4 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber4.alternate !== null) {
                    existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber4;
                } else {
                  previousNewFiber.sibling = _newFiber4;
                }
                previousNewFiber = _newFiber4;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
              deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
              var existing = useFiber(currentFirstChild, textContent);
              existing.return = returnFiber;
              return existing;
            }
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }
          function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key) {
                switch (child.tag) {
                  case Fragment3: {
                    if (element.type === REACT_FRAGMENT_TYPE) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                  case Block:
                  default: {
                    if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
                }
                deleteRemainingChildren(returnFiber, child);
                break;
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
              var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
              created.return = returnFiber;
              return created;
            } else {
              var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
              _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
              _created4.return = returnFiber;
              return _created4;
            }
          }
          function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key) {
                if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, portal.children || []);
                  existing.return = returnFiber;
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }
          function reconcileChildFibers2(returnFiber, currentFirstChild, newChild, lanes) {
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) {
              newChild = newChild.props.children;
            }
            var isObject3 = typeof newChild === "object" && newChild !== null;
            if (isObject3) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                  return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
              }
            }
            if (typeof newChild === "string" || typeof newChild === "number") {
              return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            }
            if (isArray$1(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isObject3) {
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) {
              switch (returnFiber.tag) {
                case ClassComponent: {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      break;
                    }
                  }
                }
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent: {
                  {
                    {
                      throw Error((getComponentName(returnFiber.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
              }
            }
            return deleteRemainingChildren(returnFiber, currentFirstChild);
          }
          return reconcileChildFibers2;
        }
        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);
        function cloneChildFibers(current2, workInProgress2) {
          if (!(current2 === null || workInProgress2.child === current2.child)) {
            {
              throw Error("Resuming work not yet implemented.");
            }
          }
          if (workInProgress2.child === null) {
            return;
          }
          var currentChild = workInProgress2.child;
          var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
          workInProgress2.child = newChild;
          newChild.return = workInProgress2;
          while (currentChild.sibling !== null) {
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress2;
          }
          newChild.sibling = null;
        }
        function resetChildFibers(workInProgress2, lanes) {
          var child = workInProgress2.child;
          while (child !== null) {
            resetWorkInProgress(child, lanes);
            child = child.sibling;
          }
        }
        var NO_CONTEXT = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT);
        var contextFiberStackCursor = createCursor(NO_CONTEXT);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT);
        function requiredContext(c3) {
          if (!(c3 !== NO_CONTEXT)) {
            {
              throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return c3;
        }
        function getRootHostContainer() {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          return rootInstance;
        }
        function pushHostContainer(fiber, nextRootInstance) {
          push(rootInstanceStackCursor, nextRootInstance, fiber);
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, NO_CONTEXT, fiber);
          var nextRootContext = getRootHostContext(nextRootInstance);
          pop(contextStackCursor$1, fiber);
          push(contextStackCursor$1, nextRootContext, fiber);
        }
        function popHostContainer(fiber) {
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
          pop(rootInstanceStackCursor, fiber);
        }
        function getHostContext() {
          var context3 = requiredContext(contextStackCursor$1.current);
          return context3;
        }
        function pushHostContext(fiber) {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          var context3 = requiredContext(contextStackCursor$1.current);
          var nextContext = getChildHostContext(context3, fiber.type);
          if (context3 === nextContext) {
            return;
          }
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, nextContext, fiber);
        }
        function popHostContext(fiber) {
          if (contextFiberStackCursor.current !== fiber) {
            return;
          }
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
        }
        var DefaultSuspenseContext = 0;
        var SubtreeSuspenseContextMask = 1;
        var InvisibleParentSuspenseContext = 1;
        var ForceSuspenseFallback = 2;
        var suspenseStackCursor = createCursor(DefaultSuspenseContext);
        function hasSuspenseContext(parentContext, flag) {
          return (parentContext & flag) !== 0;
        }
        function setDefaultShallowSuspenseContext(parentContext) {
          return parentContext & SubtreeSuspenseContextMask;
        }
        function setShallowSuspenseContext(parentContext, shallowContext) {
          return parentContext & SubtreeSuspenseContextMask | shallowContext;
        }
        function addSubtreeSuspenseContext(parentContext, subtreeContext) {
          return parentContext | subtreeContext;
        }
        function pushSuspenseContext(fiber, newContext) {
          push(suspenseStackCursor, newContext, fiber);
        }
        function popSuspenseContext(fiber) {
          pop(suspenseStackCursor, fiber);
        }
        function shouldCaptureSuspense(workInProgress2, hasInvisibleParent) {
          var nextState = workInProgress2.memoizedState;
          if (nextState !== null) {
            if (nextState.dehydrated !== null) {
              return true;
            }
            return false;
          }
          var props = workInProgress2.memoizedProps;
          if (props.fallback === void 0) {
            return false;
          }
          if (props.unstable_avoidThisFallback !== true) {
            return true;
          }
          if (hasInvisibleParent) {
            return false;
          }
          return true;
        }
        function findFirstSuspended(row) {
          var node = row;
          while (node !== null) {
            if (node.tag === SuspenseComponent) {
              var state = node.memoizedState;
              if (state !== null) {
                var dehydrated = state.dehydrated;
                if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                  return node;
                }
              }
            } else if (node.tag === SuspenseListComponent && node.memoizedProps.revealOrder !== void 0) {
              var didSuspend = (node.flags & DidCapture) !== NoFlags;
              if (didSuspend) {
                return node;
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === row) {
              return null;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === row) {
                return null;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
          return null;
        }
        var NoFlags$1 = 0;
        var HasEffect = 1;
        var Layout = 2;
        var Passive$1 = 4;
        var hydrationParentFiber = null;
        var nextHydratableInstance = null;
        var isHydrating = false;
        function enterHydrationState(fiber) {
          var parentInstance = fiber.stateNode.containerInfo;
          nextHydratableInstance = getFirstHydratableChild(parentInstance);
          hydrationParentFiber = fiber;
          isHydrating = true;
          return true;
        }
        function deleteHydratableInstance(returnFiber, instance) {
          {
            switch (returnFiber.tag) {
              case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
              case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
            }
          }
          var childToDelete = createFiberFromHostInstanceForDeletion();
          childToDelete.stateNode = instance;
          childToDelete.return = returnFiber;
          childToDelete.flags = Deletion;
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
        }
        function insertNonHydratedInstance(returnFiber, fiber) {
          fiber.flags = fiber.flags & ~Hydrating | Placement;
          {
            switch (returnFiber.tag) {
              case HostRoot: {
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    var props = fiber.pendingProps;
                    didNotFindHydratableContainerInstance(parentContainer, type);
                    break;
                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableContainerTextInstance(parentContainer, text);
                    break;
                }
                break;
              }
              case HostComponent: {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch (fiber.tag) {
                  case HostComponent:
                    var _type = fiber.type;
                    var _props = fiber.pendingProps;
                    didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                    break;
                  case HostText:
                    var _text = fiber.pendingProps;
                    didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                    break;
                  case SuspenseComponent:
                    didNotFindHydratableSuspenseInstance(parentType, parentProps);
                    break;
                }
                break;
              }
              default:
                return;
            }
          }
        }
        function tryHydrate(fiber, nextInstance) {
          switch (fiber.tag) {
            case HostComponent: {
              var type = fiber.type;
              var props = fiber.pendingProps;
              var instance = canHydrateInstance(nextInstance, type);
              if (instance !== null) {
                fiber.stateNode = instance;
                return true;
              }
              return false;
            }
            case HostText: {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);
              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                return true;
              }
              return false;
            }
            case SuspenseComponent: {
              return false;
            }
            default:
              return false;
          }
        }
        function tryToClaimNextHydratableInstance(fiber) {
          if (!isHydrating) {
            return;
          }
          var nextInstance = nextHydratableInstance;
          if (!nextInstance) {
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }
          var firstAttemptedInstance = nextInstance;
          if (!tryHydrate(fiber, nextInstance)) {
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
              insertNonHydratedInstance(hydrationParentFiber, fiber);
              isHydrating = false;
              hydrationParentFiber = fiber;
              return;
            }
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
          }
          hydrationParentFiber = fiber;
          nextHydratableInstance = getFirstHydratableChild(nextInstance);
        }
        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
          var instance = fiber.stateNode;
          var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber);
          fiber.updateQueue = updatePayload;
          if (updatePayload !== null) {
            return true;
          }
          return false;
        }
        function prepareToHydrateHostTextInstance(fiber) {
          var textInstance = fiber.stateNode;
          var textContent = fiber.memoizedProps;
          var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
          {
            if (shouldUpdate) {
              var returnFiber = hydrationParentFiber;
              if (returnFiber !== null) {
                switch (returnFiber.tag) {
                  case HostRoot: {
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                  }
                  case HostComponent: {
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
                  }
                }
              }
            }
          }
          return shouldUpdate;
        }
        function skipPastDehydratedSuspenseInstance(fiber) {
          var suspenseState = fiber.memoizedState;
          var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
          if (!suspenseInstance) {
            {
              throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
        }
        function popToNextHostParent(fiber) {
          var parent = fiber.return;
          while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
            parent = parent.return;
          }
          hydrationParentFiber = parent;
        }
        function popHydrationState(fiber) {
          if (fiber !== hydrationParentFiber) {
            return false;
          }
          if (!isHydrating) {
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
          }
          var type = fiber.type;
          if (fiber.tag !== HostComponent || type !== "head" && type !== "body" && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while (nextInstance) {
              deleteHydratableInstance(fiber, nextInstance);
              nextInstance = getNextHydratableSibling(nextInstance);
            }
          }
          popToNextHostParent(fiber);
          if (fiber.tag === SuspenseComponent) {
            nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
          } else {
            nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
          }
          return true;
        }
        function resetHydrationState() {
          hydrationParentFiber = null;
          nextHydratableInstance = null;
          isHydrating = false;
        }
        function getIsHydrating() {
          return isHydrating;
        }
        var workInProgressSources = [];
        var rendererSigil$1;
        {
          rendererSigil$1 = {};
        }
        function markSourceAsDirty(mutableSource) {
          workInProgressSources.push(mutableSource);
        }
        function resetWorkInProgressVersions() {
          for (var i3 = 0; i3 < workInProgressSources.length; i3++) {
            var mutableSource = workInProgressSources[i3];
            {
              mutableSource._workInProgressVersionPrimary = null;
            }
          }
          workInProgressSources.length = 0;
        }
        function getWorkInProgressVersion(mutableSource) {
          {
            return mutableSource._workInProgressVersionPrimary;
          }
        }
        function setWorkInProgressVersion(mutableSource, version2) {
          {
            mutableSource._workInProgressVersionPrimary = version2;
          }
          workInProgressSources.push(mutableSource);
        }
        function warnAboutMultipleRenderersDEV(mutableSource) {
          {
            {
              if (mutableSource._currentPrimaryRenderer == null) {
                mutableSource._currentPrimaryRenderer = rendererSigil$1;
              } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
                error("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
              }
            }
          }
        }
        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
        var didWarnAboutMismatchedHooksForComponent;
        var didWarnAboutUseOpaqueIdentifier;
        {
          didWarnAboutUseOpaqueIdentifier = {};
          didWarnAboutMismatchedHooksForComponent = new Set();
        }
        var renderLanes = NoLanes;
        var currentlyRenderingFiber$1 = null;
        var currentHook = null;
        var workInProgressHook = null;
        var didScheduleRenderPhaseUpdate = false;
        var didScheduleRenderPhaseUpdateDuringThisPass = false;
        var RE_RENDER_LIMIT = 25;
        var currentHookNameInDev = null;
        var hookTypesDev = null;
        var hookTypesUpdateIndexDev = -1;
        var ignorePreviousDependencies = false;
        function mountHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev === null) {
              hookTypesDev = [hookName];
            } else {
              hookTypesDev.push(hookName);
            }
          }
        }
        function updateHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev !== null) {
              hookTypesUpdateIndexDev++;
              if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
                warnOnHookMismatchInDev(hookName);
              }
            }
          }
        }
        function checkDepsAreArrayDev(deps) {
          {
            if (deps !== void 0 && deps !== null && !Array.isArray(deps)) {
              error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
            }
          }
        }
        function warnOnHookMismatchInDev(currentHookName) {
          {
            var componentName = getComponentName(currentlyRenderingFiber$1.type);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
              didWarnAboutMismatchedHooksForComponent.add(componentName);
              if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for (var i3 = 0; i3 <= hookTypesUpdateIndexDev; i3++) {
                  var oldHookName = hookTypesDev[i3];
                  var newHookName = i3 === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                  var row = i3 + 1 + ". " + oldHookName;
                  while (row.length < secondColumnStart) {
                    row += " ";
                  }
                  row += newHookName + "\n";
                  table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
              }
            }
          }
        }
        function throwInvalidHookError() {
          {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
        }
        function areHookInputsEqual(nextDeps, prevDeps) {
          {
            if (ignorePreviousDependencies) {
              return false;
            }
          }
          if (prevDeps === null) {
            {
              error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            }
            return false;
          }
          {
            if (nextDeps.length !== prevDeps.length) {
              error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
            }
          }
          for (var i3 = 0; i3 < prevDeps.length && i3 < nextDeps.length; i3++) {
            if (objectIs(nextDeps[i3], prevDeps[i3])) {
              continue;
            }
            return false;
          }
          return true;
        }
        function renderWithHooks(current2, workInProgress2, Component, props, secondArg, nextRenderLanes) {
          renderLanes = nextRenderLanes;
          currentlyRenderingFiber$1 = workInProgress2;
          {
            hookTypesDev = current2 !== null ? current2._debugHookTypes : null;
            hookTypesUpdateIndexDev = -1;
            ignorePreviousDependencies = current2 !== null && current2.type !== workInProgress2.type;
          }
          workInProgress2.memoizedState = null;
          workInProgress2.updateQueue = null;
          workInProgress2.lanes = NoLanes;
          {
            if (current2 !== null && current2.memoizedState !== null) {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
            } else if (hookTypesDev !== null) {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
            } else {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
            }
          }
          var children = Component(props, secondArg);
          if (didScheduleRenderPhaseUpdateDuringThisPass) {
            var numberOfReRenders = 0;
            do {
              didScheduleRenderPhaseUpdateDuringThisPass = false;
              if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
                {
                  throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                }
              }
              numberOfReRenders += 1;
              {
                ignorePreviousDependencies = false;
              }
              currentHook = null;
              workInProgressHook = null;
              workInProgress2.updateQueue = null;
              {
                hookTypesUpdateIndexDev = -1;
              }
              ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
              children = Component(props, secondArg);
            } while (didScheduleRenderPhaseUpdateDuringThisPass);
          }
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          {
            workInProgress2._debugHookTypes = hookTypesDev;
          }
          var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            currentHookNameInDev = null;
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
          }
          didScheduleRenderPhaseUpdate = false;
          if (!!didRenderTooFewHooks) {
            {
              throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
            }
          }
          return children;
        }
        function bailoutHooks(current2, workInProgress2, lanes) {
          workInProgress2.updateQueue = current2.updateQueue;
          workInProgress2.flags &= ~(Passive | Update);
          current2.lanes = removeLanes(current2.lanes, lanes);
        }
        function resetHooksAfterThrow() {
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          if (didScheduleRenderPhaseUpdate) {
            var hook = currentlyRenderingFiber$1.memoizedState;
            while (hook !== null) {
              var queue2 = hook.queue;
              if (queue2 !== null) {
                queue2.pending = null;
              }
              hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
          }
          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
            currentHookNameInDev = null;
            isUpdatingOpaqueValueInRenderPhase = false;
          }
          didScheduleRenderPhaseUpdateDuringThisPass = false;
        }
        function mountWorkInProgressHook() {
          var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
          };
          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
          } else {
            workInProgressHook = workInProgressHook.next = hook;
          }
          return workInProgressHook;
        }
        function updateWorkInProgressHook() {
          var nextCurrentHook;
          if (currentHook === null) {
            var current2 = currentlyRenderingFiber$1.alternate;
            if (current2 !== null) {
              nextCurrentHook = current2.memoizedState;
            } else {
              nextCurrentHook = null;
            }
          } else {
            nextCurrentHook = currentHook.next;
          }
          var nextWorkInProgressHook;
          if (workInProgressHook === null) {
            nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
          } else {
            nextWorkInProgressHook = workInProgressHook.next;
          }
          if (nextWorkInProgressHook !== null) {
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
          } else {
            if (!(nextCurrentHook !== null)) {
              {
                throw Error("Rendered more hooks than during the previous render.");
              }
            }
            currentHook = nextCurrentHook;
            var newHook = {
              memoizedState: currentHook.memoizedState,
              baseState: currentHook.baseState,
              baseQueue: currentHook.baseQueue,
              queue: currentHook.queue,
              next: null
            };
            if (workInProgressHook === null) {
              currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            } else {
              workInProgressHook = workInProgressHook.next = newHook;
            }
          }
          return workInProgressHook;
        }
        function createFunctionComponentUpdateQueue() {
          return {
            lastEffect: null
          };
        }
        function basicStateReducer(state, action) {
          return typeof action === "function" ? action(state) : action;
        }
        function mountReducer(reducer, initialArg, init) {
          var hook = mountWorkInProgressHook();
          var initialState2;
          if (init !== void 0) {
            initialState2 = init(initialArg);
          } else {
            initialState2 = initialArg;
          }
          hook.memoizedState = hook.baseState = initialState2;
          var queue2 = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState2
          };
          var dispatch = queue2.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue2);
          return [hook.memoizedState, dispatch];
        }
        function updateReducer(reducer, initialArg, init) {
          var hook = updateWorkInProgressHook();
          var queue2 = hook.queue;
          if (!(queue2 !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue2.lastRenderedReducer = reducer;
          var current2 = currentHook;
          var baseQueue = current2.baseQueue;
          var pendingQueue = queue2.pending;
          if (pendingQueue !== null) {
            if (baseQueue !== null) {
              var baseFirst = baseQueue.next;
              var pendingFirst = pendingQueue.next;
              baseQueue.next = pendingFirst;
              pendingQueue.next = baseFirst;
            }
            {
              if (current2.baseQueue !== baseQueue) {
                error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
              }
            }
            current2.baseQueue = baseQueue = pendingQueue;
            queue2.pending = null;
          }
          if (baseQueue !== null) {
            var first = baseQueue.next;
            var newState = current2.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
              var updateLane = update.lane;
              if (!isSubsetOfLanes(renderLanes, updateLane)) {
                var clone = {
                  lane: updateLane,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                }
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                markSkippedUpdateLanes(updateLane);
              } else {
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    lane: NoLane,
                    action: update.action,
                    eagerReducer: update.eagerReducer,
                    eagerState: update.eagerState,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                }
                if (update.eagerReducer === reducer) {
                  newState = update.eagerState;
                } else {
                  var action = update.action;
                  newState = reducer(newState, action);
                }
              }
              update = update.next;
            } while (update !== null && update !== first);
            if (newBaseQueueLast === null) {
              newBaseState = newState;
            } else {
              newBaseQueueLast.next = newBaseQueueFirst;
            }
            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue2.lastRenderedState = newState;
          }
          var dispatch = queue2.dispatch;
          return [hook.memoizedState, dispatch];
        }
        function rerenderReducer(reducer, initialArg, init) {
          var hook = updateWorkInProgressHook();
          var queue2 = hook.queue;
          if (!(queue2 !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue2.lastRenderedReducer = reducer;
          var dispatch = queue2.dispatch;
          var lastRenderPhaseUpdate = queue2.pending;
          var newState = hook.memoizedState;
          if (lastRenderPhaseUpdate !== null) {
            queue2.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
              var action = update.action;
              newState = reducer(newState, action);
              update = update.next;
            } while (update !== firstRenderPhaseUpdate);
            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            if (hook.baseQueue === null) {
              hook.baseState = newState;
            }
            queue2.lastRenderedState = newState;
          }
          return [newState, dispatch];
        }
        function readFromUnsubcribedMutableSource(root4, source, getSnapshot) {
          {
            warnAboutMultipleRenderersDEV(source);
          }
          var getVersion = source._getVersion;
          var version2 = getVersion(source._source);
          var isSafeToReadFromSource = false;
          var currentRenderVersion = getWorkInProgressVersion(source);
          if (currentRenderVersion !== null) {
            isSafeToReadFromSource = currentRenderVersion === version2;
          } else {
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root4.mutableReadLanes);
            if (isSafeToReadFromSource) {
              setWorkInProgressVersion(source, version2);
            }
          }
          if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            {
              if (typeof snapshot === "function") {
                error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
              }
            }
            return snapshot;
          } else {
            markSourceAsDirty(source);
            {
              {
                throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
              }
            }
          }
        }
        function useMutableSource(hook, source, getSnapshot, subscribe) {
          var root4 = getWorkInProgressRoot();
          if (!(root4 !== null)) {
            {
              throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            }
          }
          var getVersion = source._getVersion;
          var version2 = getVersion(source._source);
          var dispatcher = ReactCurrentDispatcher$1.current;
          var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root4, source, getSnapshot);
          }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
          var snapshot = currentSnapshot;
          var stateHook = workInProgressHook;
          var memoizedState = hook.memoizedState;
          var refs = memoizedState.refs;
          var prevGetSnapshot = refs.getSnapshot;
          var prevSource = memoizedState.source;
          var prevSubscribe = memoizedState.subscribe;
          var fiber = currentlyRenderingFiber$1;
          hook.memoizedState = {
            refs,
            source,
            subscribe
          };
          dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot;
            refs.setSnapshot = setSnapshot;
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs(version2, maybeNewVersion)) {
              var maybeNewSnapshot = getSnapshot(source._source);
              {
                if (typeof maybeNewSnapshot === "function") {
                  error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                }
              }
              if (!objectIs(snapshot, maybeNewSnapshot)) {
                setSnapshot(maybeNewSnapshot);
                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root4, lane);
              }
              markRootEntangled(root4, root4.mutableReadLanes);
            }
          }, [getSnapshot, source, subscribe]);
          dispatcher.useEffect(function() {
            var handleChange = function() {
              var latestGetSnapshot = refs.getSnapshot;
              var latestSetSnapshot = refs.setSnapshot;
              try {
                latestSetSnapshot(latestGetSnapshot(source._source));
                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root4, lane);
              } catch (error2) {
                latestSetSnapshot(function() {
                  throw error2;
                });
              }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            {
              if (typeof unsubscribe !== "function") {
                error("Mutable source subscribe function must return an unsubscribe function.");
              }
            }
            return unsubscribe;
          }, [source, subscribe]);
          if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            var newQueue = {
              pending: null,
              dispatch: null,
              lastRenderedReducer: basicStateReducer,
              lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root4, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
          }
          return snapshot;
        }
        function mountMutableSource(source, getSnapshot, subscribe) {
          var hook = mountWorkInProgressHook();
          hook.memoizedState = {
            refs: {
              getSnapshot,
              setSnapshot: null
            },
            source,
            subscribe
          };
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function updateMutableSource(source, getSnapshot, subscribe) {
          var hook = updateWorkInProgressHook();
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function mountState(initialState2) {
          var hook = mountWorkInProgressHook();
          if (typeof initialState2 === "function") {
            initialState2 = initialState2();
          }
          hook.memoizedState = hook.baseState = initialState2;
          var queue2 = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState2
          };
          var dispatch = queue2.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue2);
          return [hook.memoizedState, dispatch];
        }
        function updateState(initialState2) {
          return updateReducer(basicStateReducer);
        }
        function rerenderState(initialState2) {
          return rerenderReducer(basicStateReducer);
        }
        function pushEffect(tag, create, destroy, deps) {
          var effect = {
            tag,
            create,
            destroy,
            deps,
            next: null
          };
          var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
          if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) {
              componentUpdateQueue.lastEffect = effect.next = effect;
            } else {
              var firstEffect = lastEffect.next;
              lastEffect.next = effect;
              effect.next = firstEffect;
              componentUpdateQueue.lastEffect = effect;
            }
          }
          return effect;
        }
        function mountRef(initialValue) {
          var hook = mountWorkInProgressHook();
          var ref = {
            current: initialValue
          };
          {
            Object.seal(ref);
          }
          hook.memoizedState = ref;
          return ref;
        }
        function updateRef(initialValue) {
          var hook = updateWorkInProgressHook();
          return hook.memoizedState;
        }
        function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create, void 0, nextDeps);
        }
        function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var destroy = void 0;
          if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
              var prevDeps = prevEffect.deps;
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                pushEffect(hookFlags, create, destroy, nextDeps);
                return;
              }
            }
          }
          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
        }
        function mountEffect(create, deps) {
          {
            if (typeof jest !== "undefined") {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return mountEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function updateEffect(create, deps) {
          {
            if (typeof jest !== "undefined") {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return updateEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function mountLayoutEffect(create, deps) {
          return mountEffectImpl(Update, Layout, create, deps);
        }
        function updateLayoutEffect(create, deps) {
          return updateEffectImpl(Update, Layout, create, deps);
        }
        function imperativeHandleEffect(create, ref) {
          if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
              refCallback(null);
            };
          } else if (ref !== null && ref !== void 0) {
            var refObject = ref;
            {
              if (!refObject.hasOwnProperty("current")) {
                error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
              }
            }
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
              refObject.current = null;
            };
          }
        }
        function mountImperativeHandle(ref, create, deps) {
          {
            if (typeof create !== "function") {
              error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref]) : null;
          return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }
        function updateImperativeHandle(ref, create, deps) {
          {
            if (typeof create !== "function") {
              error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref]) : null;
          return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }
        function mountDebugValue(value, formatterFn) {
        }
        var updateDebugValue = mountDebugValue;
        function mountCallback(callback, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function updateCallback(callback, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function mountMemo(nextCreate, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function updateMemo(nextCreate, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function mountDeferredValue(value) {
          var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
          mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function updateDeferredValue(value) {
          var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
          updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function rerenderDeferredValue(value) {
          var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
          updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function startTransition(setPending, callback) {
          var priorityLevel = getCurrentPriorityLevel();
          {
            runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function() {
              setPending(true);
            });
            runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
              var prevTransition = ReactCurrentBatchConfig$1.transition;
              ReactCurrentBatchConfig$1.transition = 1;
              try {
                setPending(false);
                callback();
              } finally {
                ReactCurrentBatchConfig$1.transition = prevTransition;
              }
            });
          }
        }
        function mountTransition() {
          var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
          var start = startTransition.bind(null, setPending);
          mountRef(start);
          return [start, isPending];
        }
        function updateTransition() {
          var _updateState2 = updateState(), isPending = _updateState2[0];
          var startRef = updateRef();
          var start = startRef.current;
          return [start, isPending];
        }
        function rerenderTransition() {
          var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
          var startRef = updateRef();
          var start = startRef.current;
          return [start, isPending];
        }
        var isUpdatingOpaqueValueInRenderPhase = false;
        function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
          {
            return isUpdatingOpaqueValueInRenderPhase;
          }
        }
        function warnOnOpaqueIdentifierAccessInDEV(fiber) {
          {
            var name = getComponentName(fiber.type) || "Unknown";
            if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
              error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
              didWarnAboutUseOpaqueIdentifier[name] = true;
            }
          }
        }
        function mountOpaqueIdentifier() {
          var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
          if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;
            var readValue = function() {
              if (!didUpgrade) {
                didUpgrade = true;
                {
                  isUpdatingOpaqueValueInRenderPhase = true;
                  setId(makeId());
                  isUpdatingOpaqueValueInRenderPhase = false;
                  warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
              }
              {
                {
                  throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
                }
              }
            };
            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];
            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
              currentlyRenderingFiber$1.flags |= Update | Passive;
              pushEffect(HasEffect | Passive$1, function() {
                setId(makeId());
              }, void 0, null);
            }
            return id;
          } else {
            var _id = makeId();
            mountState(_id);
            return _id;
          }
        }
        function updateOpaqueIdentifier() {
          var id = updateState()[0];
          return id;
        }
        function rerenderOpaqueIdentifier() {
          var id = rerenderState()[0];
          return id;
        }
        function dispatchAction(fiber, queue2, action) {
          {
            if (typeof arguments[3] === "function") {
              error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
            }
          }
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = {
            lane,
            action,
            eagerReducer: null,
            eagerState: null,
            next: null
          };
          var pending = queue2.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          queue2.pending = update;
          var alternate = fiber.alternate;
          if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
          } else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
              var lastRenderedReducer = queue2.lastRenderedReducer;
              if (lastRenderedReducer !== null) {
                var prevDispatcher;
                {
                  prevDispatcher = ReactCurrentDispatcher$1.current;
                  ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                }
                try {
                  var currentState = queue2.lastRenderedState;
                  var eagerState = lastRenderedReducer(currentState, action);
                  update.eagerReducer = lastRenderedReducer;
                  update.eagerState = eagerState;
                  if (objectIs(eagerState, currentState)) {
                    return;
                  }
                } catch (error2) {
                } finally {
                  {
                    ReactCurrentDispatcher$1.current = prevDispatcher;
                  }
                }
              }
            }
            {
              if (typeof jest !== "undefined") {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
              }
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        }
        var ContextOnlyDispatcher = {
          readContext,
          useCallback: throwInvalidHookError,
          useContext: throwInvalidHookError,
          useEffect: throwInvalidHookError,
          useImperativeHandle: throwInvalidHookError,
          useLayoutEffect: throwInvalidHookError,
          useMemo: throwInvalidHookError,
          useReducer: throwInvalidHookError,
          useRef: throwInvalidHookError,
          useState: throwInvalidHookError,
          useDebugValue: throwInvalidHookError,
          useDeferredValue: throwInvalidHookError,
          useTransition: throwInvalidHookError,
          useMutableSource: throwInvalidHookError,
          useOpaqueIdentifier: throwInvalidHookError,
          unstable_isNewReconciler: enableNewReconciler
        };
        var HooksDispatcherOnMountInDEV = null;
        var HooksDispatcherOnMountWithHookTypesInDEV = null;
        var HooksDispatcherOnUpdateInDEV = null;
        var HooksDispatcherOnRerenderInDEV = null;
        var InvalidNestedHooksDispatcherOnMountInDEV = null;
        var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
        var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
        {
          var warnInvalidContextAccess = function() {
            error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          };
          var warnInvalidHookAccess = function() {
            error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
          };
          HooksDispatcherOnMountInDEV = {
            readContext: function(context3, observedBits) {
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              mountHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnMountWithHookTypesInDEV = {
            readContext: function(context3, observedBits) {
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnUpdateInDEV = {
            readContext: function(context3, observedBits) {
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnRerenderInDEV = {
            readContext: function(context3, observedBits) {
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnMountInDEV = {
            readContext: function(context3, observedBits) {
              warnInvalidContextAccess();
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnUpdateInDEV = {
            readContext: function(context3, observedBits) {
              warnInvalidContextAccess();
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnRerenderInDEV = {
            readContext: function(context3, observedBits) {
              warnInvalidContextAccess();
              return readContext(context3, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context3, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context3, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer, initialArg, init) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
        }
        var now$1 = Scheduler.unstable_now;
        var commitTime = 0;
        var profilerStartTime = -1;
        function getCommitTime() {
          return commitTime;
        }
        function recordCommitTime() {
          commitTime = now$1();
        }
        function startProfilerTimer(fiber) {
          profilerStartTime = now$1();
          if (fiber.actualStartTime < 0) {
            fiber.actualStartTime = now$1();
          }
        }
        function stopProfilerTimerIfRunning(fiber) {
          profilerStartTime = -1;
        }
        function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
          if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) {
              fiber.selfBaseDuration = elapsedTime;
            }
            profilerStartTime = -1;
          }
        }
        function transferActualDuration(fiber) {
          var child = fiber.child;
          while (child) {
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var didReceiveUpdate = false;
        var didWarnAboutBadClass;
        var didWarnAboutModulePatternComponent;
        var didWarnAboutContextTypeOnFunctionComponent;
        var didWarnAboutGetDerivedStateOnFunctionComponent;
        var didWarnAboutFunctionRefs;
        var didWarnAboutReassigningProps;
        var didWarnAboutRevealOrder;
        var didWarnAboutTailOptions;
        {
          didWarnAboutBadClass = {};
          didWarnAboutModulePatternComponent = {};
          didWarnAboutContextTypeOnFunctionComponent = {};
          didWarnAboutGetDerivedStateOnFunctionComponent = {};
          didWarnAboutFunctionRefs = {};
          didWarnAboutReassigningProps = false;
          didWarnAboutRevealOrder = {};
          didWarnAboutTailOptions = {};
        }
        function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
          if (current2 === null) {
            workInProgress2.child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
          } else {
            workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, nextChildren, renderLanes2);
          }
        }
        function forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2) {
          workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
          workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
        }
        function updateForwardRef(current2, workInProgress2, Component, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component.propTypes;
              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
              }
            }
          }
          var render2 = Component.render;
          var ref = workInProgress2.ref;
          var nextChildren;
          prepareToReadContext(workInProgress2, renderLanes2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current2, workInProgress2, render2, nextProps, ref, renderLanes2);
            if (workInProgress2.mode & StrictMode) {
              disableLogs();
              try {
                nextChildren = renderWithHooks(current2, workInProgress2, render2, nextProps, ref, renderLanes2);
              } finally {
                reenableLogs();
              }
            }
            setIsRendering(false);
          }
          if (current2 !== null && !didReceiveUpdate) {
            bailoutHooks(current2, workInProgress2, renderLanes2);
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateMemoComponent(current2, workInProgress2, Component, nextProps, updateLanes, renderLanes2) {
          if (current2 === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && Component.defaultProps === void 0) {
              var resolvedType = type;
              {
                resolvedType = resolveFunctionForHotReloading(type);
              }
              workInProgress2.tag = SimpleMemoComponent;
              workInProgress2.type = resolvedType;
              {
                validateFunctionComponentInDev(workInProgress2, type);
              }
              return updateSimpleMemoComponent(current2, workInProgress2, resolvedType, nextProps, updateLanes, renderLanes2);
            }
            {
              var innerPropTypes = type.propTypes;
              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(type));
              }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress2, workInProgress2.mode, renderLanes2);
            child.ref = workInProgress2.ref;
            child.return = workInProgress2;
            workInProgress2.child = child;
            return child;
          }
          {
            var _type = Component.type;
            var _innerPropTypes = _type.propTypes;
            if (_innerPropTypes) {
              checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentName(_type));
            }
          }
          var currentChild = current2.child;
          if (!includesSomeLane(updateLanes, renderLanes2)) {
            var prevProps = currentChild.memoizedProps;
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual3;
            if (compare(prevProps, nextProps) && current2.ref === workInProgress2.ref) {
              return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
            }
          }
          workInProgress2.flags |= PerformedWork;
          var newChild = createWorkInProgress(currentChild, nextProps);
          newChild.ref = workInProgress2.ref;
          newChild.return = workInProgress2;
          workInProgress2.child = newChild;
          return newChild;
        }
        function updateSimpleMemoComponent(current2, workInProgress2, Component, nextProps, updateLanes, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var outerMemoType = workInProgress2.elementType;
              if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  outerMemoType = init(payload);
                } catch (x4) {
                  outerMemoType = null;
                }
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) {
                  checkPropTypes(outerPropTypes, nextProps, "prop", getComponentName(outerMemoType));
                }
              }
            }
          }
          if (current2 !== null) {
            var prevProps = current2.memoizedProps;
            if (shallowEqual3(prevProps, nextProps) && current2.ref === workInProgress2.ref && workInProgress2.type === current2.type) {
              didReceiveUpdate = false;
              if (!includesSomeLane(renderLanes2, updateLanes)) {
                workInProgress2.lanes = current2.lanes;
                return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
              } else if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                didReceiveUpdate = true;
              }
            }
          }
          return updateFunctionComponent(current2, workInProgress2, Component, nextProps, renderLanes2);
        }
        function updateOffscreenComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          var nextChildren = nextProps.children;
          var prevState = current2 !== null ? current2.memoizedState : null;
          if (nextProps.mode === "hidden" || nextProps.mode === "unstable-defer-without-hiding") {
            if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
              var nextState = {
                baseLanes: NoLanes
              };
              workInProgress2.memoizedState = nextState;
              pushRenderLanes(workInProgress2, renderLanes2);
            } else if (!includesSomeLane(renderLanes2, OffscreenLane)) {
              var nextBaseLanes;
              if (prevState !== null) {
                var prevBaseLanes = prevState.baseLanes;
                nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes2);
              } else {
                nextBaseLanes = renderLanes2;
              }
              {
                markSpawnedWork(OffscreenLane);
              }
              workInProgress2.lanes = workInProgress2.childLanes = laneToLanes(OffscreenLane);
              var _nextState = {
                baseLanes: nextBaseLanes
              };
              workInProgress2.memoizedState = _nextState;
              pushRenderLanes(workInProgress2, nextBaseLanes);
              return null;
            } else {
              var _nextState2 = {
                baseLanes: NoLanes
              };
              workInProgress2.memoizedState = _nextState2;
              var subtreeRenderLanes2 = prevState !== null ? prevState.baseLanes : renderLanes2;
              pushRenderLanes(workInProgress2, subtreeRenderLanes2);
            }
          } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
              _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes2);
              workInProgress2.memoizedState = null;
            } else {
              _subtreeRenderLanes = renderLanes2;
            }
            pushRenderLanes(workInProgress2, _subtreeRenderLanes);
          }
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        var updateLegacyHiddenComponent = updateOffscreenComponent;
        function updateFragment(current2, workInProgress2, renderLanes2) {
          var nextChildren = workInProgress2.pendingProps;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateMode(current2, workInProgress2, renderLanes2) {
          var nextChildren = workInProgress2.pendingProps.children;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateProfiler(current2, workInProgress2, renderLanes2) {
          {
            workInProgress2.flags |= Update;
            var stateNode = workInProgress2.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
          var nextProps = workInProgress2.pendingProps;
          var nextChildren = nextProps.children;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function markRef(current2, workInProgress2) {
          var ref = workInProgress2.ref;
          if (current2 === null && ref !== null || current2 !== null && current2.ref !== ref) {
            workInProgress2.flags |= Ref;
          }
        }
        function updateFunctionComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component.propTypes;
              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
              }
            }
          }
          var context3;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component, true);
            context3 = getMaskedContext(workInProgress2, unmaskedContext);
          }
          var nextChildren;
          prepareToReadContext(workInProgress2, renderLanes2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current2, workInProgress2, Component, nextProps, context3, renderLanes2);
            if (workInProgress2.mode & StrictMode) {
              disableLogs();
              try {
                nextChildren = renderWithHooks(current2, workInProgress2, Component, nextProps, context3, renderLanes2);
              } finally {
                reenableLogs();
              }
            }
            setIsRendering(false);
          }
          if (current2 !== null && !didReceiveUpdate) {
            bailoutHooks(current2, workInProgress2, renderLanes2);
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateClassComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component.propTypes;
              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
              }
            }
          }
          var hasContext;
          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var instance = workInProgress2.stateNode;
          var shouldUpdate;
          if (instance === null) {
            if (current2 !== null) {
              current2.alternate = null;
              workInProgress2.alternate = null;
              workInProgress2.flags |= Placement;
            }
            constructClassInstance(workInProgress2, Component, nextProps);
            mountClassInstance(workInProgress2, Component, nextProps, renderLanes2);
            shouldUpdate = true;
          } else if (current2 === null) {
            shouldUpdate = resumeMountClassInstance(workInProgress2, Component, nextProps, renderLanes2);
          } else {
            shouldUpdate = updateClassInstance(current2, workInProgress2, Component, nextProps, renderLanes2);
          }
          var nextUnitOfWork = finishClassComponent(current2, workInProgress2, Component, shouldUpdate, hasContext, renderLanes2);
          {
            var inst = workInProgress2.stateNode;
            if (shouldUpdate && inst.props !== nextProps) {
              if (!didWarnAboutReassigningProps) {
                error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress2.type) || "a component");
              }
              didWarnAboutReassigningProps = true;
            }
          }
          return nextUnitOfWork;
        }
        function finishClassComponent(current2, workInProgress2, Component, shouldUpdate, hasContext, renderLanes2) {
          markRef(current2, workInProgress2);
          var didCaptureError = (workInProgress2.flags & DidCapture) !== NoFlags;
          if (!shouldUpdate && !didCaptureError) {
            if (hasContext) {
              invalidateContextProvider(workInProgress2, Component, false);
            }
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          var instance = workInProgress2.stateNode;
          ReactCurrentOwner$1.current = workInProgress2;
          var nextChildren;
          if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            nextChildren = null;
            {
              stopProfilerTimerIfRunning();
            }
          } else {
            {
              setIsRendering(true);
              nextChildren = instance.render();
              if (workInProgress2.mode & StrictMode) {
                disableLogs();
                try {
                  instance.render();
                } finally {
                  reenableLogs();
                }
              }
              setIsRendering(false);
            }
          }
          workInProgress2.flags |= PerformedWork;
          if (current2 !== null && didCaptureError) {
            forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2);
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          }
          workInProgress2.memoizedState = instance.state;
          if (hasContext) {
            invalidateContextProvider(workInProgress2, Component, true);
          }
          return workInProgress2.child;
        }
        function pushHostRootContext(workInProgress2) {
          var root4 = workInProgress2.stateNode;
          if (root4.pendingContext) {
            pushTopLevelContextObject(workInProgress2, root4.pendingContext, root4.pendingContext !== root4.context);
          } else if (root4.context) {
            pushTopLevelContextObject(workInProgress2, root4.context, false);
          }
          pushHostContainer(workInProgress2, root4.containerInfo);
        }
        function updateHostRoot(current2, workInProgress2, renderLanes2) {
          pushHostRootContext(workInProgress2);
          var updateQueue = workInProgress2.updateQueue;
          if (!(current2 !== null && updateQueue !== null)) {
            {
              throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var nextProps = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          var prevChildren = prevState !== null ? prevState.element : null;
          cloneUpdateQueue(current2, workInProgress2);
          processUpdateQueue(workInProgress2, nextProps, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          var nextChildren = nextState.element;
          if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          var root4 = workInProgress2.stateNode;
          if (root4.hydrate && enterHydrationState(workInProgress2)) {
            {
              var mutableSourceEagerHydrationData = root4.mutableSourceEagerHydrationData;
              if (mutableSourceEagerHydrationData != null) {
                for (var i3 = 0; i3 < mutableSourceEagerHydrationData.length; i3 += 2) {
                  var mutableSource = mutableSourceEagerHydrationData[i3];
                  var version2 = mutableSourceEagerHydrationData[i3 + 1];
                  setWorkInProgressVersion(mutableSource, version2);
                }
              }
            }
            var child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
            workInProgress2.child = child;
            var node = child;
            while (node) {
              node.flags = node.flags & ~Placement | Hydrating;
              node = node.sibling;
            }
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
            resetHydrationState();
          }
          return workInProgress2.child;
        }
        function updateHostComponent(current2, workInProgress2, renderLanes2) {
          pushHostContext(workInProgress2);
          if (current2 === null) {
            tryToClaimNextHydratableInstance(workInProgress2);
          }
          var type = workInProgress2.type;
          var nextProps = workInProgress2.pendingProps;
          var prevProps = current2 !== null ? current2.memoizedProps : null;
          var nextChildren = nextProps.children;
          var isDirectTextChild = shouldSetTextContent(type, nextProps);
          if (isDirectTextChild) {
            nextChildren = null;
          } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
            workInProgress2.flags |= ContentReset;
          }
          markRef(current2, workInProgress2);
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateHostText(current2, workInProgress2) {
          if (current2 === null) {
            tryToClaimNextHydratableInstance(workInProgress2);
          }
          return null;
        }
        function mountLazyComponent(_current, workInProgress2, elementType, updateLanes, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          var props = workInProgress2.pendingProps;
          var lazyComponent = elementType;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;
          var Component = init(payload);
          workInProgress2.type = Component;
          var resolvedTag = workInProgress2.tag = resolveLazyComponentTag(Component);
          var resolvedProps = resolveDefaultProps(Component, props);
          var child;
          switch (resolvedTag) {
            case FunctionComponent: {
              {
                validateFunctionComponentInDev(workInProgress2, Component);
                workInProgress2.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress2, Component, resolvedProps, renderLanes2);
              return child;
            }
            case ClassComponent: {
              {
                workInProgress2.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress2, Component, resolvedProps, renderLanes2);
              return child;
            }
            case ForwardRef: {
              {
                workInProgress2.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress2, Component, resolvedProps, renderLanes2);
              return child;
            }
            case MemoComponent: {
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = Component.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentName(Component));
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress2, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes2);
              return child;
            }
          }
          var hint = "";
          {
            if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) {
              hint = " Did you wrap a component in React.lazy() more than once?";
            }
          }
          {
            {
              throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
            }
          }
        }
        function mountIncompleteClassComponent(_current, workInProgress2, Component, nextProps, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          workInProgress2.tag = ClassComponent;
          var hasContext;
          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          constructClassInstance(workInProgress2, Component, nextProps);
          mountClassInstance(workInProgress2, Component, nextProps, renderLanes2);
          return finishClassComponent(null, workInProgress2, Component, true, hasContext, renderLanes2);
        }
        function mountIndeterminateComponent(_current, workInProgress2, Component, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          var props = workInProgress2.pendingProps;
          var context3;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component, false);
            context3 = getMaskedContext(workInProgress2, unmaskedContext);
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var value;
          {
            if (Component.prototype && typeof Component.prototype.render === "function") {
              var componentName = getComponentName(Component) || "Unknown";
              if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, null);
            }
            setIsRendering(true);
            ReactCurrentOwner$1.current = workInProgress2;
            value = renderWithHooks(null, workInProgress2, Component, props, context3, renderLanes2);
            setIsRendering(false);
          }
          workInProgress2.flags |= PerformedWork;
          {
            if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
              var _componentName = getComponentName(Component) || "Unknown";
              if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
              }
            }
          }
          if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
            {
              var _componentName2 = getComponentName(Component) || "Unknown";
              if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
              }
            }
            workInProgress2.tag = ClassComponent;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            var hasContext = false;
            if (isContextProvider(Component)) {
              hasContext = true;
              pushContextProvider(workInProgress2);
            } else {
              hasContext = false;
            }
            workInProgress2.memoizedState = value.state !== null && value.state !== void 0 ? value.state : null;
            initializeUpdateQueue(workInProgress2);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") {
              applyDerivedStateFromProps(workInProgress2, Component, getDerivedStateFromProps, props);
            }
            adoptClassInstance(workInProgress2, value);
            mountClassInstance(workInProgress2, Component, props, renderLanes2);
            return finishClassComponent(null, workInProgress2, Component, true, hasContext, renderLanes2);
          } else {
            workInProgress2.tag = FunctionComponent;
            {
              if (workInProgress2.mode & StrictMode) {
                disableLogs();
                try {
                  value = renderWithHooks(null, workInProgress2, Component, props, context3, renderLanes2);
                } finally {
                  reenableLogs();
                }
              }
            }
            reconcileChildren(null, workInProgress2, value, renderLanes2);
            {
              validateFunctionComponentInDev(workInProgress2, Component);
            }
            return workInProgress2.child;
          }
        }
        function validateFunctionComponentInDev(workInProgress2, Component) {
          {
            if (Component) {
              if (Component.childContextTypes) {
                error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
              }
            }
            if (workInProgress2.ref !== null) {
              var info = "";
              var ownerName = getCurrentFiberOwnerNameInDevOrNull();
              if (ownerName) {
                info += "\n\nCheck the render method of `" + ownerName + "`.";
              }
              var warningKey = ownerName || workInProgress2._debugID || "";
              var debugSource = workInProgress2._debugSource;
              if (debugSource) {
                warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
              }
              if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
              }
            }
            if (typeof Component.getDerivedStateFromProps === "function") {
              var _componentName3 = getComponentName(Component) || "Unknown";
              if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
              }
            }
            if (typeof Component.contextType === "object" && Component.contextType !== null) {
              var _componentName4 = getComponentName(Component) || "Unknown";
              if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
              }
            }
          }
        }
        var SUSPENDED_MARKER = {
          dehydrated: null,
          retryLane: NoLane
        };
        function mountSuspenseOffscreenState(renderLanes2) {
          return {
            baseLanes: renderLanes2
          };
        }
        function updateSuspenseOffscreenState(prevOffscreenState, renderLanes2) {
          return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes2)
          };
        }
        function shouldRemainOnFallback(suspenseContext, current2, workInProgress2, renderLanes2) {
          if (current2 !== null) {
            var suspenseState = current2.memoizedState;
            if (suspenseState === null) {
              return false;
            }
          }
          return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        }
        function getRemainingWorkInPrimaryTree(current2, renderLanes2) {
          return removeLanes(current2.childLanes, renderLanes2);
        }
        function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          {
            if (shouldSuspend(workInProgress2)) {
              workInProgress2.flags |= DidCapture;
            }
          }
          var suspenseContext = suspenseStackCursor.current;
          var showFallback = false;
          var didSuspend = (workInProgress2.flags & DidCapture) !== NoFlags;
          if (didSuspend || shouldRemainOnFallback(suspenseContext, current2)) {
            showFallback = true;
            workInProgress2.flags &= ~DidCapture;
          } else {
            if (current2 === null || current2.memoizedState !== null) {
              if (nextProps.fallback !== void 0 && nextProps.unstable_avoidThisFallback !== true) {
                suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
              }
            }
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          pushSuspenseContext(workInProgress2, suspenseContext);
          if (current2 === null) {
            if (nextProps.fallback !== void 0) {
              tryToClaimNextHydratableInstance(workInProgress2);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
              var fallbackFragment = mountSuspenseFallbackChildren(workInProgress2, nextPrimaryChildren, nextFallbackChildren, renderLanes2);
              var primaryChildFragment = workInProgress2.child;
              primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === "number") {
              var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress2, nextPrimaryChildren, nextFallbackChildren, renderLanes2);
              var _primaryChildFragment = workInProgress2.child;
              _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              workInProgress2.lanes = SomeRetryLane;
              {
                markSpawnedWork(SomeRetryLane);
              }
              return _fallbackFragment;
            } else {
              return mountSuspensePrimaryChildren(workInProgress2, nextPrimaryChildren, renderLanes2);
            }
          } else {
            var prevState = current2.memoizedState;
            if (prevState !== null) {
              if (showFallback) {
                var _nextFallbackChildren2 = nextProps.fallback;
                var _nextPrimaryChildren2 = nextProps.children;
                var _fallbackChildFragment = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes2);
                var _primaryChildFragment3 = workInProgress2.child;
                var prevOffscreenState = current2.child.memoizedState;
                _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes2);
                _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment;
              } else {
                var _nextPrimaryChildren3 = nextProps.children;
                var _primaryChildFragment4 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren3, renderLanes2);
                workInProgress2.memoizedState = null;
                return _primaryChildFragment4;
              }
            } else {
              if (showFallback) {
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes2);
                var _primaryChildFragment5 = workInProgress2.child;
                var _prevOffscreenState = current2.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes2);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
              } else {
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren5, renderLanes2);
                workInProgress2.memoizedState = null;
                return _primaryChildFragment6;
              }
            }
          }
        }
        function mountSuspensePrimaryChildren(workInProgress2, primaryChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
          };
          var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes2, null);
          primaryChildFragment.return = workInProgress2;
          workInProgress2.child = primaryChildFragment;
          return primaryChildFragment;
        }
        function mountSuspenseFallbackChildren(workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var progressedPrimaryFragment = workInProgress2.child;
          var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
          };
          var primaryChildFragment;
          var fallbackChildFragment;
          if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress2.mode & ProfileMode) {
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = 0;
              primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
          } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
          }
          primaryChildFragment.return = workInProgress2;
          fallbackChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress2.child = primaryChildFragment;
          return fallbackChildFragment;
        }
        function createWorkInProgressOffscreenFiber(current2, offscreenProps) {
          return createWorkInProgress(current2, offscreenProps);
        }
        function updateSuspensePrimaryChildren(current2, workInProgress2, primaryChildren, renderLanes2) {
          var currentPrimaryChildFragment = current2.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
          });
          if ((workInProgress2.mode & BlockingMode) === NoMode) {
            primaryChildFragment.lanes = renderLanes2;
          }
          primaryChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = null;
          if (currentFallbackChildFragment !== null) {
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress2.firstEffect = workInProgress2.lastEffect = currentFallbackChildFragment;
          }
          workInProgress2.child = primaryChildFragment;
          return primaryChildFragment;
        }
        function updateSuspenseFallbackChildren(current2, workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var currentPrimaryChildFragment = current2.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
          };
          var primaryChildFragment;
          if ((mode & BlockingMode) === NoMode && workInProgress2.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress2.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress2.mode & ProfileMode) {
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
              primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            }
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
              workInProgress2.firstEffect = primaryChildFragment.firstEffect;
              workInProgress2.lastEffect = progressedLastEffect;
              progressedLastEffect.nextEffect = null;
            } else {
              workInProgress2.firstEffect = workInProgress2.lastEffect = null;
            }
          } else {
            primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          }
          var fallbackChildFragment;
          if (currentFallbackChildFragment !== null) {
            fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
          } else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
            fallbackChildFragment.flags |= Placement;
          }
          fallbackChildFragment.return = workInProgress2;
          primaryChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress2.child = primaryChildFragment;
          return fallbackChildFragment;
        }
        function scheduleWorkOnFiber(fiber, renderLanes2) {
          fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
          var alternate = fiber.alternate;
          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
          }
          scheduleWorkOnParentPath(fiber.return, renderLanes2);
        }
        function propagateSuspenseContextChange(workInProgress2, firstChild, renderLanes2) {
          var node = firstChild;
          while (node !== null) {
            if (node.tag === SuspenseComponent) {
              var state = node.memoizedState;
              if (state !== null) {
                scheduleWorkOnFiber(node, renderLanes2);
              }
            } else if (node.tag === SuspenseListComponent) {
              scheduleWorkOnFiber(node, renderLanes2);
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === workInProgress2) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress2) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        function findLastContentRow(firstChild) {
          var row = firstChild;
          var lastContentRow = null;
          while (row !== null) {
            var currentRow = row.alternate;
            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              lastContentRow = row;
            }
            row = row.sibling;
          }
          return lastContentRow;
        }
        function validateRevealOrder(revealOrder) {
          {
            if (revealOrder !== void 0 && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
              didWarnAboutRevealOrder[revealOrder] = true;
              if (typeof revealOrder === "string") {
                switch (revealOrder.toLowerCase()) {
                  case "together":
                  case "forwards":
                  case "backwards": {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  case "forward":
                  case "backward": {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
                }
              } else {
                error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
              }
            }
          }
        }
        function validateTailOptions(tailMode, revealOrder) {
          {
            if (tailMode !== void 0 && !didWarnAboutTailOptions[tailMode]) {
              if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
              } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
              }
            }
          }
        }
        function validateSuspenseListNestedChild(childSlot, index2) {
          {
            var isArray3 = Array.isArray(childSlot);
            var isIterable = !isArray3 && typeof getIteratorFn(childSlot) === "function";
            if (isArray3 || isIterable) {
              var type = isArray3 ? "array" : "iterable";
              error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index2, type);
              return false;
            }
          }
          return true;
        }
        function validateSuspenseListChildren(children, revealOrder) {
          {
            if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== void 0 && children !== null && children !== false) {
              if (Array.isArray(children)) {
                for (var i3 = 0; i3 < children.length; i3++) {
                  if (!validateSuspenseListNestedChild(children[i3], i3)) {
                    return;
                  }
                }
              } else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                  var childrenIterator = iteratorFn.call(children);
                  if (childrenIterator) {
                    var step = childrenIterator.next();
                    var _i = 0;
                    for (; !step.done; step = childrenIterator.next()) {
                      if (!validateSuspenseListNestedChild(step.value, _i)) {
                        return;
                      }
                      _i++;
                    }
                  }
                } else {
                  error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
                }
              }
            }
          }
        }
        function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
          var renderState = workInProgress2.memoizedState;
          if (renderState === null) {
            workInProgress2.memoizedState = {
              isBackwards,
              rendering: null,
              renderingStartTime: 0,
              last: lastContentRow,
              tail,
              tailMode,
              lastEffect: lastEffectBeforeRendering
            };
          } else {
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
          }
        }
        function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          var revealOrder = nextProps.revealOrder;
          var tailMode = nextProps.tail;
          var newChildren = nextProps.children;
          validateRevealOrder(revealOrder);
          validateTailOptions(tailMode, revealOrder);
          validateSuspenseListChildren(newChildren, revealOrder);
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          var suspenseContext = suspenseStackCursor.current;
          var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
          if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress2.flags |= DidCapture;
          } else {
            var didSuspendBefore = current2 !== null && (current2.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) {
              propagateSuspenseContextChange(workInProgress2, workInProgress2.child, renderLanes2);
            }
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }
          pushSuspenseContext(workInProgress2, suspenseContext);
          if ((workInProgress2.mode & BlockingMode) === NoMode) {
            workInProgress2.memoizedState = null;
          } else {
            switch (revealOrder) {
              case "forwards": {
                var lastContentRow = findLastContentRow(workInProgress2.child);
                var tail;
                if (lastContentRow === null) {
                  tail = workInProgress2.child;
                  workInProgress2.child = null;
                } else {
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress2, false, tail, lastContentRow, tailMode, workInProgress2.lastEffect);
                break;
              }
              case "backwards": {
                var _tail = null;
                var row = workInProgress2.child;
                workInProgress2.child = null;
                while (row !== null) {
                  var currentRow = row.alternate;
                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    workInProgress2.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                }
                initSuspenseListRenderState(workInProgress2, true, _tail, null, tailMode, workInProgress2.lastEffect);
                break;
              }
              case "together": {
                initSuspenseListRenderState(workInProgress2, false, null, null, void 0, workInProgress2.lastEffect);
                break;
              }
              default: {
                workInProgress2.memoizedState = null;
              }
            }
          }
          return workInProgress2.child;
        }
        function updatePortalComponent(current2, workInProgress2, renderLanes2) {
          pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
          var nextChildren = workInProgress2.pendingProps;
          if (current2 === null) {
            workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          }
          return workInProgress2.child;
        }
        var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
        function updateContextProvider(current2, workInProgress2, renderLanes2) {
          var providerType = workInProgress2.type;
          var context3 = providerType._context;
          var newProps = workInProgress2.pendingProps;
          var oldProps = workInProgress2.memoizedProps;
          var newValue = newProps.value;
          {
            if (!("value" in newProps)) {
              if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
              }
            }
            var providerPropTypes = workInProgress2.type.propTypes;
            if (providerPropTypes) {
              checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
            }
          }
          pushProvider(workInProgress2, newValue);
          if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context3, newValue, oldValue);
            if (changedBits === 0) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
              }
            } else {
              propagateContextChange(workInProgress2, context3, changedBits, renderLanes2);
            }
          }
          var newChildren = newProps.children;
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          return workInProgress2.child;
        }
        var hasWarnedAboutUsingContextAsConsumer = false;
        function updateContextConsumer(current2, workInProgress2, renderLanes2) {
          var context3 = workInProgress2.type;
          {
            if (context3._context === void 0) {
              if (context3 !== context3.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                  hasWarnedAboutUsingContextAsConsumer = true;
                  error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
              }
            } else {
              context3 = context3._context;
            }
          }
          var newProps = workInProgress2.pendingProps;
          var render2 = newProps.children;
          {
            if (typeof render2 !== "function") {
              error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
            }
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var newValue = readContext(context3, newProps.unstable_observedBits);
          var newChildren;
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            newChildren = render2(newValue);
            setIsRendering(false);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          return workInProgress2.child;
        }
        function markWorkInProgressReceivedUpdate() {
          didReceiveUpdate = true;
        }
        function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
          if (current2 !== null) {
            workInProgress2.dependencies = current2.dependencies;
          }
          {
            stopProfilerTimerIfRunning();
          }
          markSkippedUpdateLanes(workInProgress2.lanes);
          if (!includesSomeLane(renderLanes2, workInProgress2.childLanes)) {
            return null;
          } else {
            cloneChildFibers(current2, workInProgress2);
            return workInProgress2.child;
          }
        }
        function remountFiber(current2, oldWorkInProgress, newWorkInProgress) {
          {
            var returnFiber = oldWorkInProgress.return;
            if (returnFiber === null) {
              throw new Error("Cannot swap the root fiber.");
            }
            current2.alternate = null;
            oldWorkInProgress.alternate = null;
            newWorkInProgress.index = oldWorkInProgress.index;
            newWorkInProgress.sibling = oldWorkInProgress.sibling;
            newWorkInProgress.return = oldWorkInProgress.return;
            newWorkInProgress.ref = oldWorkInProgress.ref;
            if (oldWorkInProgress === returnFiber.child) {
              returnFiber.child = newWorkInProgress;
            } else {
              var prevSibling = returnFiber.child;
              if (prevSibling === null) {
                throw new Error("Expected parent to have a child.");
              }
              while (prevSibling.sibling !== oldWorkInProgress) {
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) {
                  throw new Error("Expected to find the previous sibling.");
                }
              }
              prevSibling.sibling = newWorkInProgress;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = current2;
              returnFiber.lastEffect = current2;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = current2;
            }
            current2.nextEffect = null;
            current2.flags = Deletion;
            newWorkInProgress.flags |= Placement;
            return newWorkInProgress;
          }
        }
        function beginWork(current2, workInProgress2, renderLanes2) {
          var updateLanes = workInProgress2.lanes;
          {
            if (workInProgress2._debugNeedsRemount && current2 !== null) {
              return remountFiber(current2, workInProgress2, createFiberFromTypeAndProps(workInProgress2.type, workInProgress2.key, workInProgress2.pendingProps, workInProgress2._debugOwner || null, workInProgress2.mode, workInProgress2.lanes));
            }
          }
          if (current2 !== null) {
            var oldProps = current2.memoizedProps;
            var newProps = workInProgress2.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress2.type !== current2.type) {
              didReceiveUpdate = true;
            } else if (!includesSomeLane(renderLanes2, updateLanes)) {
              didReceiveUpdate = false;
              switch (workInProgress2.tag) {
                case HostRoot:
                  pushHostRootContext(workInProgress2);
                  resetHydrationState();
                  break;
                case HostComponent:
                  pushHostContext(workInProgress2);
                  break;
                case ClassComponent: {
                  var Component = workInProgress2.type;
                  if (isContextProvider(Component)) {
                    pushContextProvider(workInProgress2);
                  }
                  break;
                }
                case HostPortal:
                  pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
                  break;
                case ContextProvider: {
                  var newValue = workInProgress2.memoizedProps.value;
                  pushProvider(workInProgress2, newValue);
                  break;
                }
                case Profiler:
                  {
                    var hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
                    if (hasChildWork) {
                      workInProgress2.flags |= Update;
                    }
                    var stateNode = workInProgress2.stateNode;
                    stateNode.effectDuration = 0;
                    stateNode.passiveEffectDuration = 0;
                  }
                  break;
                case SuspenseComponent: {
                  var state = workInProgress2.memoizedState;
                  if (state !== null) {
                    var primaryChildFragment = workInProgress2.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes2, primaryChildLanes)) {
                      return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
                    } else {
                      pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                      var child = bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
                      if (child !== null) {
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
                case SuspenseListComponent: {
                  var didSuspendBefore = (current2.flags & DidCapture) !== NoFlags;
                  var _hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
                    }
                    workInProgress2.flags |= DidCapture;
                  }
                  var renderState = workInProgress2.memoizedState;
                  if (renderState !== null) {
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                  }
                  pushSuspenseContext(workInProgress2, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    return null;
                  }
                }
                case OffscreenComponent:
                case LegacyHiddenComponent: {
                  workInProgress2.lanes = NoLanes;
                  return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
                }
              }
              return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
            } else {
              if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                didReceiveUpdate = true;
              } else {
                didReceiveUpdate = false;
              }
            }
          } else {
            didReceiveUpdate = false;
          }
          workInProgress2.lanes = NoLanes;
          switch (workInProgress2.tag) {
            case IndeterminateComponent: {
              return mountIndeterminateComponent(current2, workInProgress2, workInProgress2.type, renderLanes2);
            }
            case LazyComponent: {
              var elementType = workInProgress2.elementType;
              return mountLazyComponent(current2, workInProgress2, elementType, updateLanes, renderLanes2);
            }
            case FunctionComponent: {
              var _Component = workInProgress2.type;
              var unresolvedProps = workInProgress2.pendingProps;
              var resolvedProps = workInProgress2.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current2, workInProgress2, _Component, resolvedProps, renderLanes2);
            }
            case ClassComponent: {
              var _Component2 = workInProgress2.type;
              var _unresolvedProps = workInProgress2.pendingProps;
              var _resolvedProps = workInProgress2.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current2, workInProgress2, _Component2, _resolvedProps, renderLanes2);
            }
            case HostRoot:
              return updateHostRoot(current2, workInProgress2, renderLanes2);
            case HostComponent:
              return updateHostComponent(current2, workInProgress2, renderLanes2);
            case HostText:
              return updateHostText(current2, workInProgress2);
            case SuspenseComponent:
              return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
            case HostPortal:
              return updatePortalComponent(current2, workInProgress2, renderLanes2);
            case ForwardRef: {
              var type = workInProgress2.type;
              var _unresolvedProps2 = workInProgress2.pendingProps;
              var _resolvedProps2 = workInProgress2.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
              return updateForwardRef(current2, workInProgress2, type, _resolvedProps2, renderLanes2);
            }
            case Fragment3:
              return updateFragment(current2, workInProgress2, renderLanes2);
            case Mode:
              return updateMode(current2, workInProgress2, renderLanes2);
            case Profiler:
              return updateProfiler(current2, workInProgress2, renderLanes2);
            case ContextProvider:
              return updateContextProvider(current2, workInProgress2, renderLanes2);
            case ContextConsumer:
              return updateContextConsumer(current2, workInProgress2, renderLanes2);
            case MemoComponent: {
              var _type2 = workInProgress2.type;
              var _unresolvedProps3 = workInProgress2.pendingProps;
              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentName(_type2));
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current2, workInProgress2, _type2, _resolvedProps3, updateLanes, renderLanes2);
            }
            case SimpleMemoComponent: {
              return updateSimpleMemoComponent(current2, workInProgress2, workInProgress2.type, workInProgress2.pendingProps, updateLanes, renderLanes2);
            }
            case IncompleteClassComponent: {
              var _Component3 = workInProgress2.type;
              var _unresolvedProps4 = workInProgress2.pendingProps;
              var _resolvedProps4 = workInProgress2.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current2, workInProgress2, _Component3, _resolvedProps4, renderLanes2);
            }
            case SuspenseListComponent: {
              return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case Block: {
              break;
            }
            case OffscreenComponent: {
              return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
            }
            case LegacyHiddenComponent: {
              return updateLegacyHiddenComponent(current2, workInProgress2, renderLanes2);
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function markUpdate(workInProgress2) {
          workInProgress2.flags |= Update;
        }
        function markRef$1(workInProgress2) {
          workInProgress2.flags |= Ref;
        }
        var appendAllChildren;
        var updateHostContainer;
        var updateHostComponent$1;
        var updateHostText$1;
        {
          appendAllChildren = function(parent, workInProgress2, needsVisibilityToggle, isHidden) {
            var node = workInProgress2.child;
            while (node !== null) {
              if (node.tag === HostComponent || node.tag === HostText) {
                appendInitialChild(parent, node.stateNode);
              } else if (node.tag === HostPortal)
                ;
              else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
              if (node === workInProgress2) {
                return;
              }
              while (node.sibling === null) {
                if (node.return === null || node.return === workInProgress2) {
                  return;
                }
                node = node.return;
              }
              node.sibling.return = node.return;
              node = node.sibling;
            }
          };
          updateHostContainer = function(workInProgress2) {
          };
          updateHostComponent$1 = function(current2, workInProgress2, type, newProps, rootContainerInstance) {
            var oldProps = current2.memoizedProps;
            if (oldProps === newProps) {
              return;
            }
            var instance = workInProgress2.stateNode;
            var currentHostContext = getHostContext();
            var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
            workInProgress2.updateQueue = updatePayload;
            if (updatePayload) {
              markUpdate(workInProgress2);
            }
          };
          updateHostText$1 = function(current2, workInProgress2, oldText, newText) {
            if (oldText !== newText) {
              markUpdate(workInProgress2);
            }
          };
        }
        function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
          if (getIsHydrating()) {
            return;
          }
          switch (renderState.tailMode) {
            case "hidden": {
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              }
              if (lastTailNode === null) {
                renderState.tail = null;
              } else {
                lastTailNode.sibling = null;
              }
              break;
            }
            case "collapsed": {
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              }
              if (_lastTailNode === null) {
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                _lastTailNode.sibling = null;
              }
              break;
            }
          }
        }
        function completeWork(current2, workInProgress2, renderLanes2) {
          var newProps = workInProgress2.pendingProps;
          switch (workInProgress2.tag) {
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment3:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
              return null;
            case ClassComponent: {
              var Component = workInProgress2.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              resetWorkInProgressVersions();
              var fiberRoot = workInProgress2.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current2 === null || current2.child === null) {
                var wasHydrated = popHydrationState(workInProgress2);
                if (wasHydrated) {
                  markUpdate(workInProgress2);
                } else if (!fiberRoot.hydrate) {
                  workInProgress2.flags |= Snapshot;
                }
              }
              updateHostContainer(workInProgress2);
              return null;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress2.type;
              if (current2 !== null && workInProgress2.stateNode != null) {
                updateHostComponent$1(current2, workInProgress2, type, newProps, rootContainerInstance);
                if (current2.ref !== workInProgress2.ref) {
                  markRef$1(workInProgress2);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                  return null;
                }
                var currentHostContext = getHostContext();
                var _wasHydrated = popHydrationState(workInProgress2);
                if (_wasHydrated) {
                  if (prepareToHydrateHostInstance(workInProgress2, rootContainerInstance, currentHostContext)) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress2);
                  appendAllChildren(instance, workInProgress2, false, false);
                  workInProgress2.stateNode = instance;
                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress2);
                  }
                }
                if (workInProgress2.ref !== null) {
                  markRef$1(workInProgress2);
                }
              }
              return null;
            }
            case HostText: {
              var newText = newProps;
              if (current2 && workInProgress2.stateNode != null) {
                var oldText = current2.memoizedProps;
                updateHostText$1(current2, workInProgress2, oldText, newText);
              } else {
                if (typeof newText !== "string") {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                }
                var _rootContainerInstance = getRootHostContainer();
                var _currentHostContext = getHostContext();
                var _wasHydrated2 = popHydrationState(workInProgress2);
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress2)) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  workInProgress2.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress2);
                }
              }
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var nextState = workInProgress2.memoizedState;
              if ((workInProgress2.flags & DidCapture) !== NoFlags) {
                workInProgress2.lanes = renderLanes2;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current2 === null) {
                if (workInProgress2.memoizedProps.fallback !== void 0) {
                  popHydrationState(workInProgress2);
                }
              } else {
                var prevState = current2.memoizedState;
                prevDidTimeout = prevState !== null;
              }
              if (nextDidTimeout && !prevDidTimeout) {
                if ((workInProgress2.mode & BlockingMode) !== NoMode) {
                  var hasInvisibleChildContext = current2 === null && workInProgress2.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    renderDidSuspend();
                  } else {
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                if (nextDidTimeout || prevDidTimeout) {
                  workInProgress2.flags |= Update;
                }
              }
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              updateHostContainer(workInProgress2);
              if (current2 === null) {
                preparePortalMount(workInProgress2.stateNode.containerInfo);
              }
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            case IncompleteClassComponent: {
              var _Component = workInProgress2.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              var renderState = workInProgress2.memoizedState;
              if (renderState === null) {
                return null;
              }
              var didSuspendAlready = (workInProgress2.flags & DidCapture) !== NoFlags;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                if (!didSuspendAlready) {
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current2 === null || (current2.flags & DidCapture) === NoFlags);
                  if (!cannotBeSuspended) {
                    var row = workInProgress2.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress2.flags |= DidCapture;
                        cutOffTailIfNeeded(renderState, false);
                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress2.updateQueue = newThennables;
                          workInProgress2.flags |= Update;
                        }
                        if (renderState.lastEffect === null) {
                          workInProgress2.firstEffect = null;
                        }
                        workInProgress2.lastEffect = renderState.lastEffect;
                        resetChildFibers(workInProgress2, renderLanes2);
                        pushSuspenseContext(workInProgress2, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress2.child;
                      }
                      row = row.sibling;
                    }
                  }
                  if (renderState.tail !== null && now2() > getRenderTargetTime()) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress2.lanes = SomeRetryLane;
                    {
                      markSpawnedWork(SomeRetryLane);
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                }
              } else {
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress2.updateQueue = _newThennables;
                      workInProgress2.flags |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true);
                    if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating()) {
                      var lastEffect = workInProgress2.lastEffect = renderState.lastEffect;
                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      }
                      return null;
                    }
                  } else if (now2() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes2 !== OffscreenLane) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress2.lanes = SomeRetryLane;
                    {
                      markSpawnedWork(SomeRetryLane);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  renderedTail.sibling = workInProgress2.child;
                  workInProgress2.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress2.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.lastEffect = workInProgress2.lastEffect;
                renderState.renderingStartTime = now2();
                next.sibling = null;
                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress2, suspenseContext);
                return next;
              }
              return null;
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case Block:
              break;
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              popRenderLanes(workInProgress2);
              if (current2 !== null) {
                var _nextState = workInProgress2.memoizedState;
                var _prevState = current2.memoizedState;
                var prevIsHidden = _prevState !== null;
                var nextIsHidden = _nextState !== null;
                if (prevIsHidden !== nextIsHidden && newProps.mode !== "unstable-defer-without-hiding") {
                  workInProgress2.flags |= Update;
                }
              }
              return null;
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function unwindWork(workInProgress2, renderLanes2) {
          switch (workInProgress2.tag) {
            case ClassComponent: {
              var Component = workInProgress2.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress2);
              }
              var flags = workInProgress2.flags;
              if (flags & ShouldCapture) {
                workInProgress2.flags = flags & ~ShouldCapture | DidCapture;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              resetWorkInProgressVersions();
              var _flags = workInProgress2.flags;
              if (!((_flags & DidCapture) === NoFlags)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress2.flags = _flags & ~ShouldCapture | DidCapture;
              return workInProgress2;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var _flags2 = workInProgress2.flags;
              if (_flags2 & ShouldCapture) {
                workInProgress2.flags = _flags2 & ~ShouldCapture | DidCapture;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(workInProgress2);
              return null;
            default:
              return null;
          }
        }
        function unwindInterruptedWork(interruptedWork) {
          switch (interruptedWork.tag) {
            case ClassComponent: {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== void 0) {
                popContext(interruptedWork);
              }
              break;
            }
            case HostRoot: {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              resetWorkInProgressVersions();
              break;
            }
            case HostComponent: {
              popHostContext(interruptedWork);
              break;
            }
            case HostPortal:
              popHostContainer(interruptedWork);
              break;
            case SuspenseComponent:
              popSuspenseContext(interruptedWork);
              break;
            case SuspenseListComponent:
              popSuspenseContext(interruptedWork);
              break;
            case ContextProvider:
              popProvider(interruptedWork);
              break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(interruptedWork);
              break;
          }
        }
        function createCapturedValue(value, source) {
          return {
            value,
            source,
            stack: getStackByFiberInDevAndProd(source)
          };
        }
        function showErrorDialog(boundary, errorInfo) {
          return true;
        }
        function logCapturedError(boundary, errorInfo) {
          try {
            var logError = showErrorDialog(boundary, errorInfo);
            if (logError === false) {
              return;
            }
            var error2 = errorInfo.value;
            if (true) {
              var source = errorInfo.source;
              var stack = errorInfo.stack;
              var componentStack = stack !== null ? stack : "";
              if (error2 != null && error2._suppressLogging) {
                if (boundary.tag === ClassComponent) {
                  return;
                }
                console["error"](error2);
              }
              var componentName = source ? getComponentName(source.type) : null;
              var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
              var errorBoundaryMessage;
              var errorBoundaryName = getComponentName(boundary.type);
              if (errorBoundaryName) {
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
              } else {
                errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
              }
              var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage);
              console["error"](combinedMessage);
            } else {
              console["error"](error2);
            }
          } catch (e2) {
            setTimeout(function() {
              throw e2;
            });
          }
        }
        var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
        function createRootErrorUpdate(fiber, errorInfo, lane) {
          var update = createUpdate(NoTimestamp, lane);
          update.tag = CaptureUpdate;
          update.payload = {
            element: null
          };
          var error2 = errorInfo.value;
          update.callback = function() {
            onUncaughtError(error2);
            logCapturedError(fiber, errorInfo);
          };
          return update;
        }
        function createClassErrorUpdate(fiber, errorInfo, lane) {
          var update = createUpdate(NoTimestamp, lane);
          update.tag = CaptureUpdate;
          var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
          if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
              logCapturedError(fiber, errorInfo);
              return getDerivedStateFromError(error$1);
            };
          }
          var inst = fiber.stateNode;
          if (inst !== null && typeof inst.componentDidCatch === "function") {
            update.callback = function callback() {
              {
                markFailedErrorBoundaryForHotReloading(fiber);
              }
              if (typeof getDerivedStateFromError !== "function") {
                markLegacyErrorBoundaryAsFailed(this);
                logCapturedError(fiber, errorInfo);
              }
              var error$12 = errorInfo.value;
              var stack = errorInfo.stack;
              this.componentDidCatch(error$12, {
                componentStack: stack !== null ? stack : ""
              });
              {
                if (typeof getDerivedStateFromError !== "function") {
                  if (!includesSomeLane(fiber.lanes, SyncLane)) {
                    error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
                  }
                }
              }
            };
          } else {
            update.callback = function() {
              markFailedErrorBoundaryForHotReloading(fiber);
            };
          }
          return update;
        }
        function attachPingListener(root4, wakeable, lanes) {
          var pingCache = root4.pingCache;
          var threadIDs;
          if (pingCache === null) {
            pingCache = root4.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
          } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === void 0) {
              threadIDs = new Set();
              pingCache.set(wakeable, threadIDs);
            }
          }
          if (!threadIDs.has(lanes)) {
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root4, wakeable, lanes);
            wakeable.then(ping, ping);
          }
        }
        function throwException(root4, returnFiber, sourceFiber, value, rootRenderLanes) {
          sourceFiber.flags |= Incomplete;
          sourceFiber.firstEffect = sourceFiber.lastEffect = null;
          if (value !== null && typeof value === "object" && typeof value.then === "function") {
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
              var currentSource = sourceFiber.alternate;
              if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
              } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
              }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext);
            var _workInProgress = returnFiber;
            do {
              if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                var wakeables = _workInProgress.updateQueue;
                if (wakeables === null) {
                  var updateQueue = new Set();
                  updateQueue.add(wakeable);
                  _workInProgress.updateQueue = updateQueue;
                } else {
                  wakeables.add(wakeable);
                }
                if ((_workInProgress.mode & BlockingMode) === NoMode) {
                  _workInProgress.flags |= DidCapture;
                  sourceFiber.flags |= ForceUpdateForLegacySuspense;
                  sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                  if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) {
                      sourceFiber.tag = IncompleteClassComponent;
                    } else {
                      var update = createUpdate(NoTimestamp, SyncLane);
                      update.tag = ForceUpdate;
                      enqueueUpdate(sourceFiber, update);
                    }
                  }
                  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
                  return;
                }
                attachPingListener(root4, wakeable, rootRenderLanes);
                _workInProgress.flags |= ShouldCapture;
                _workInProgress.lanes = rootRenderLanes;
                return;
              }
              _workInProgress = _workInProgress.return;
            } while (_workInProgress !== null);
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
          }
          renderDidError();
          value = createCapturedValue(value, sourceFiber);
          var workInProgress2 = returnFiber;
          do {
            switch (workInProgress2.tag) {
              case HostRoot: {
                var _errorInfo = value;
                workInProgress2.flags |= ShouldCapture;
                var lane = pickArbitraryLane(rootRenderLanes);
                workInProgress2.lanes = mergeLanes(workInProgress2.lanes, lane);
                var _update = createRootErrorUpdate(workInProgress2, _errorInfo, lane);
                enqueueCapturedUpdate(workInProgress2, _update);
                return;
              }
              case ClassComponent:
                var errorInfo = value;
                var ctor = workInProgress2.type;
                var instance = workInProgress2.stateNode;
                if ((workInProgress2.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                  workInProgress2.flags |= ShouldCapture;
                  var _lane = pickArbitraryLane(rootRenderLanes);
                  workInProgress2.lanes = mergeLanes(workInProgress2.lanes, _lane);
                  var _update2 = createClassErrorUpdate(workInProgress2, errorInfo, _lane);
                  enqueueCapturedUpdate(workInProgress2, _update2);
                  return;
                }
                break;
            }
            workInProgress2 = workInProgress2.return;
          } while (workInProgress2 !== null);
        }
        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
          didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
        }
        var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
        var callComponentWillUnmountWithTimer = function(current2, instance) {
          instance.props = current2.memoizedProps;
          instance.state = current2.memoizedState;
          {
            instance.componentWillUnmount();
          }
        };
        function safelyCallComponentWillUnmount(current2, instance) {
          {
            invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current2, instance);
            if (hasCaughtError()) {
              var unmountError = clearCaughtError();
              captureCommitPhaseError(current2, unmountError);
            }
          }
        }
        function safelyDetachRef(current2) {
          var ref = current2.ref;
          if (ref !== null) {
            if (typeof ref === "function") {
              {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                  var refError = clearCaughtError();
                  captureCommitPhaseError(current2, refError);
                }
              }
            } else {
              ref.current = null;
            }
          }
        }
        function safelyCallDestroy(current2, destroy) {
          {
            invokeGuardedCallback(null, destroy, null);
            if (hasCaughtError()) {
              var error2 = clearCaughtError();
              captureCommitPhaseError(current2, error2);
            }
          }
        }
        function commitBeforeMutationLifeCycles(current2, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
              return;
            }
            case ClassComponent: {
              if (finishedWork.flags & Snapshot) {
                if (current2 !== null) {
                  var prevProps = current2.memoizedProps;
                  var prevState = current2.memoizedState;
                  var instance = finishedWork.stateNode;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === void 0 && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                }
              }
              return;
            }
            case HostRoot: {
              {
                if (finishedWork.flags & Snapshot) {
                  var root4 = finishedWork.stateNode;
                  clearContainer(root4.containerInfo);
                }
              }
              return;
            }
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitHookEffectListUnmount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
              if ((effect.tag & tag) === tag) {
                var destroy = effect.destroy;
                effect.destroy = void 0;
                if (destroy !== void 0) {
                  destroy();
                }
              }
              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }
        function commitHookEffectListMount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
              if ((effect.tag & tag) === tag) {
                var create = effect.create;
                effect.destroy = create();
                {
                  var destroy = effect.destroy;
                  if (destroy !== void 0 && typeof destroy !== "function") {
                    var addendum = void 0;
                    if (destroy === null) {
                      addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                    } else if (typeof destroy.then === "function") {
                      addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                    } else {
                      addendum = " You returned: " + destroy;
                    }
                    error("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                  }
                }
              }
              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }
        function schedulePassiveEffects(finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
              var _effect = effect, next = _effect.next, tag = _effect.tag;
              if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                enqueuePendingPassiveHookEffectMount(finishedWork, effect);
              }
              effect = next;
            } while (effect !== firstEffect);
          }
        }
        function commitLifeCycles(finishedRoot, current2, finishedWork, committedLanes) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
              {
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
              }
              schedulePassiveEffects(finishedWork);
              return;
            }
            case ClassComponent: {
              var instance = finishedWork.stateNode;
              if (finishedWork.flags & Update) {
                if (current2 === null) {
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  {
                    instance.componentDidMount();
                  }
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current2.memoizedProps : resolveDefaultProps(finishedWork.type, current2.memoizedProps);
                  var prevState = current2.memoizedState;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  {
                    instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  }
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                  }
                }
                commitUpdateQueue(finishedWork, updateQueue, instance);
              }
              return;
            }
            case HostRoot: {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
            case HostComponent: {
              var _instance2 = finishedWork.stateNode;
              if (current2 === null && finishedWork.flags & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type, props);
              }
              return;
            }
            case HostText: {
              return;
            }
            case HostPortal: {
              return;
            }
            case Profiler: {
              {
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime2 = getCommitTime();
                if (typeof onRender === "function") {
                  {
                    onRender(finishedWork.memoizedProps.id, current2 === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime2, finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
            case SuspenseComponent: {
              commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
              return;
            }
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function hideOrUnhideAllChildren(finishedWork, isHidden) {
          {
            var node = finishedWork;
            while (true) {
              if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) {
                  hideInstance(instance);
                } else {
                  unhideInstance(node.stateNode, node.memoizedProps);
                }
              } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) {
                  hideTextInstance(_instance3);
                } else {
                  unhideTextInstance(_instance3, node.memoizedProps);
                }
              } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork)
                ;
              else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
              if (node === finishedWork) {
                return;
              }
              while (node.sibling === null) {
                if (node.return === null || node.return === finishedWork) {
                  return;
                }
                node = node.return;
              }
              node.sibling.return = node.return;
              node = node.sibling;
            }
          }
        }
        function commitAttachRef(finishedWork) {
          var ref = finishedWork.ref;
          if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch (finishedWork.tag) {
              case HostComponent:
                instanceToUse = getPublicInstance(instance);
                break;
              default:
                instanceToUse = instance;
            }
            if (typeof ref === "function") {
              ref(instanceToUse);
            } else {
              {
                if (!ref.hasOwnProperty("current")) {
                  error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                }
              }
              ref.current = instanceToUse;
            }
          }
        }
        function commitDetachRef(current2) {
          var currentRef = current2.ref;
          if (currentRef !== null) {
            if (typeof currentRef === "function") {
              currentRef(null);
            } else {
              currentRef.current = null;
            }
          }
        }
        function commitUnmount(finishedRoot, current2, renderPriorityLevel) {
          onCommitUnmount(current2);
          switch (current2.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
              var updateQueue = current2.updateQueue;
              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  var effect = firstEffect;
                  do {
                    var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                    if (destroy !== void 0) {
                      if ((tag & Passive$1) !== NoFlags$1) {
                        enqueuePendingPassiveHookEffectUnmount(current2, effect);
                      } else {
                        {
                          safelyCallDestroy(current2, destroy);
                        }
                      }
                    }
                    effect = effect.next;
                  } while (effect !== firstEffect);
                }
              }
              return;
            }
            case ClassComponent: {
              safelyDetachRef(current2);
              var instance = current2.stateNode;
              if (typeof instance.componentWillUnmount === "function") {
                safelyCallComponentWillUnmount(current2, instance);
              }
              return;
            }
            case HostComponent: {
              safelyDetachRef(current2);
              return;
            }
            case HostPortal: {
              {
                unmountHostComponents(finishedRoot, current2);
              }
              return;
            }
            case FundamentalComponent: {
              return;
            }
            case DehydratedFragment: {
              return;
            }
            case ScopeComponent: {
              return;
            }
          }
        }
        function commitNestedUnmounts(finishedRoot, root4, renderPriorityLevel) {
          var node = root4;
          while (true) {
            commitUnmount(finishedRoot, node);
            if (node.child !== null && node.tag !== HostPortal) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === root4) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === root4) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        function detachFiberMutation(fiber) {
          fiber.alternate = null;
          fiber.child = null;
          fiber.dependencies = null;
          fiber.firstEffect = null;
          fiber.lastEffect = null;
          fiber.memoizedProps = null;
          fiber.memoizedState = null;
          fiber.pendingProps = null;
          fiber.return = null;
          fiber.updateQueue = null;
          {
            fiber._debugOwner = null;
          }
        }
        function getHostParentFiber(fiber) {
          var parent = fiber.return;
          while (parent !== null) {
            if (isHostParent(parent)) {
              return parent;
            }
            parent = parent.return;
          }
          {
            {
              throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function isHostParent(fiber) {
          return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }
        function getHostSibling(fiber) {
          var node = fiber;
          siblings:
            while (true) {
              while (node.sibling === null) {
                if (node.return === null || isHostParent(node.return)) {
                  return null;
                }
                node = node.return;
              }
              node.sibling.return = node.return;
              node = node.sibling;
              while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
                if (node.flags & Placement) {
                  continue siblings;
                }
                if (node.child === null || node.tag === HostPortal) {
                  continue siblings;
                } else {
                  node.child.return = node;
                  node = node.child;
                }
              }
              if (!(node.flags & Placement)) {
                return node.stateNode;
              }
            }
        }
        function commitPlacement(finishedWork) {
          var parentFiber = getHostParentFiber(finishedWork);
          var parent;
          var isContainer;
          var parentStateNode = parentFiber.stateNode;
          switch (parentFiber.tag) {
            case HostComponent:
              parent = parentStateNode;
              isContainer = false;
              break;
            case HostRoot:
              parent = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case HostPortal:
              parent = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case FundamentalComponent:
            default: {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (parentFiber.flags & ContentReset) {
            resetTextContent(parent);
            parentFiber.flags &= ~ContentReset;
          }
          var before = getHostSibling(finishedWork);
          if (isContainer) {
            insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
          } else {
            insertOrAppendPlacementNode(finishedWork, before, parent);
          }
        }
        function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
          var tag = node.tag;
          var isHost = tag === HostComponent || tag === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) {
              insertInContainerBefore(parent, stateNode, before);
            } else {
              appendChildToContainer(parent, stateNode);
            }
          } else if (tag === HostPortal)
            ;
          else {
            var child = node.child;
            if (child !== null) {
              insertOrAppendPlacementNodeIntoContainer(child, before, parent);
              var sibling = child.sibling;
              while (sibling !== null) {
                insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                sibling = sibling.sibling;
              }
            }
          }
        }
        function insertOrAppendPlacementNode(node, before, parent) {
          var tag = node.tag;
          var isHost = tag === HostComponent || tag === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) {
              insertBefore(parent, stateNode, before);
            } else {
              appendChild(parent, stateNode);
            }
          } else if (tag === HostPortal)
            ;
          else {
            var child = node.child;
            if (child !== null) {
              insertOrAppendPlacementNode(child, before, parent);
              var sibling = child.sibling;
              while (sibling !== null) {
                insertOrAppendPlacementNode(sibling, before, parent);
                sibling = sibling.sibling;
              }
            }
          }
        }
        function unmountHostComponents(finishedRoot, current2, renderPriorityLevel) {
          var node = current2;
          var currentParentIsValid = false;
          var currentParent;
          var currentParentIsContainer;
          while (true) {
            if (!currentParentIsValid) {
              var parent = node.return;
              findParent:
                while (true) {
                  if (!(parent !== null)) {
                    {
                      throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                  var parentStateNode = parent.stateNode;
                  switch (parent.tag) {
                    case HostComponent:
                      currentParent = parentStateNode;
                      currentParentIsContainer = false;
                      break findParent;
                    case HostRoot:
                      currentParent = parentStateNode.containerInfo;
                      currentParentIsContainer = true;
                      break findParent;
                    case HostPortal:
                      currentParent = parentStateNode.containerInfo;
                      currentParentIsContainer = true;
                      break findParent;
                  }
                  parent = parent.return;
                }
              currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
              commitNestedUnmounts(finishedRoot, node);
              if (currentParentIsContainer) {
                removeChildFromContainer(currentParent, node.stateNode);
              } else {
                removeChild(currentParent, node.stateNode);
              }
            } else if (node.tag === HostPortal) {
              if (node.child !== null) {
                currentParent = node.stateNode.containerInfo;
                currentParentIsContainer = true;
                node.child.return = node;
                node = node.child;
                continue;
              }
            } else {
              commitUnmount(finishedRoot, node);
              if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
            }
            if (node === current2) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === current2) {
                return;
              }
              node = node.return;
              if (node.tag === HostPortal) {
                currentParentIsValid = false;
              }
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        function commitDeletion(finishedRoot, current2, renderPriorityLevel) {
          {
            unmountHostComponents(finishedRoot, current2);
          }
          var alternate = current2.alternate;
          detachFiberMutation(current2);
          if (alternate !== null) {
            detachFiberMutation(alternate);
          }
        }
        function commitWork(current2, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
              {
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              }
              return;
            }
            case ClassComponent: {
              return;
            }
            case HostComponent: {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                var newProps = finishedWork.memoizedProps;
                var oldProps = current2 !== null ? current2.memoizedProps : newProps;
                var type = finishedWork.type;
                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
              }
              return;
            }
            case HostText: {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps;
              var oldText = current2 !== null ? current2.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
            case HostRoot: {
              {
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                  _root.hydrate = false;
                  commitHydratedContainer(_root.containerInfo);
                }
              }
              return;
            }
            case Profiler: {
              return;
            }
            case SuspenseComponent: {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case SuspenseListComponent: {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case IncompleteClassComponent: {
              return;
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              var newState = finishedWork.memoizedState;
              var isHidden = newState !== null;
              hideOrUnhideAllChildren(finishedWork, isHidden);
              return;
            }
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitSuspenseComponent(finishedWork) {
          var newState = finishedWork.memoizedState;
          if (newState !== null) {
            markCommitTimeOfFallback();
            {
              var primaryChildParent = finishedWork.child;
              hideOrUnhideAllChildren(primaryChildParent, true);
            }
          }
        }
        function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
          var newState = finishedWork.memoizedState;
          if (newState === null) {
            var current2 = finishedWork.alternate;
            if (current2 !== null) {
              var prevState = current2.memoizedState;
              if (prevState !== null) {
                var suspenseInstance = prevState.dehydrated;
                if (suspenseInstance !== null) {
                  commitHydratedSuspenseInstance(suspenseInstance);
                }
              }
            }
          }
        }
        function attachSuspenseRetryListeners(finishedWork) {
          var wakeables = finishedWork.updateQueue;
          if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) {
              retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            }
            wakeables.forEach(function(wakeable) {
              var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
              if (!retryCache.has(wakeable)) {
                {
                  if (wakeable.__reactDoNotTraceInteractions !== true) {
                    retry = tracing.unstable_wrap(retry);
                  }
                }
                retryCache.add(wakeable);
                wakeable.then(retry, retry);
              }
            });
          }
        }
        function isSuspenseBoundaryBeingHidden(current2, finishedWork) {
          if (current2 !== null) {
            var oldState = current2.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
              var newState = finishedWork.memoizedState;
              return newState !== null && newState.dehydrated === null;
            }
          }
          return false;
        }
        function commitResetTextContent(current2) {
          resetTextContent(current2.stateNode);
        }
        var COMPONENT_TYPE = 0;
        var HAS_PSEUDO_CLASS_TYPE = 1;
        var ROLE_TYPE = 2;
        var TEST_NAME_TYPE = 3;
        var TEXT_TYPE = 4;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor$1 = Symbol.for;
          COMPONENT_TYPE = symbolFor$1("selector.component");
          HAS_PSEUDO_CLASS_TYPE = symbolFor$1("selector.has_pseudo_class");
          ROLE_TYPE = symbolFor$1("selector.role");
          TEST_NAME_TYPE = symbolFor$1("selector.test_id");
          TEXT_TYPE = symbolFor$1("selector.text");
        }
        var commitHooks = [];
        function onCommitRoot$1() {
          {
            commitHooks.forEach(function(commitHook) {
              return commitHook();
            });
          }
        }
        var ceil = Math.ceil;
        var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var NoContext = 0;
        var BatchedContext = 1;
        var EventContext = 2;
        var DiscreteEventContext = 4;
        var LegacyUnbatchedContext = 8;
        var RenderContext = 16;
        var CommitContext = 32;
        var RetryAfterError = 64;
        var RootIncomplete = 0;
        var RootFatalErrored = 1;
        var RootErrored = 2;
        var RootSuspended = 3;
        var RootSuspendedWithDelay = 4;
        var RootCompleted = 5;
        var executionContext = NoContext;
        var workInProgressRoot = null;
        var workInProgress = null;
        var workInProgressRootRenderLanes = NoLanes;
        var subtreeRenderLanes = NoLanes;
        var subtreeRenderLanesCursor = createCursor(NoLanes);
        var workInProgressRootExitStatus = RootIncomplete;
        var workInProgressRootFatalError = null;
        var workInProgressRootIncludedLanes = NoLanes;
        var workInProgressRootSkippedLanes = NoLanes;
        var workInProgressRootUpdatedLanes = NoLanes;
        var workInProgressRootPingedLanes = NoLanes;
        var mostRecentlyUpdatedRoot = null;
        var globalMostRecentFallbackTime = 0;
        var FALLBACK_THROTTLE_MS = 500;
        var workInProgressRootRenderTargetTime = Infinity;
        var RENDER_TIMEOUT_MS = 500;
        function resetRenderTimer() {
          workInProgressRootRenderTargetTime = now2() + RENDER_TIMEOUT_MS;
        }
        function getRenderTargetTime() {
          return workInProgressRootRenderTargetTime;
        }
        var nextEffect = null;
        var hasUncaughtError = false;
        var firstUncaughtError = null;
        var legacyErrorBoundariesThatAlreadyFailed = null;
        var rootDoesHavePassiveEffects = false;
        var rootWithPendingPassiveEffects = null;
        var pendingPassiveEffectsRenderPriority = NoPriority$1;
        var pendingPassiveEffectsLanes = NoLanes;
        var pendingPassiveHookEffectsMount = [];
        var pendingPassiveHookEffectsUnmount = [];
        var rootsWithPendingDiscreteUpdates = null;
        var NESTED_UPDATE_LIMIT = 50;
        var nestedUpdateCount = 0;
        var rootWithNestedUpdates = null;
        var NESTED_PASSIVE_UPDATE_LIMIT = 50;
        var nestedPassiveUpdateCount = 0;
        var spawnedWorkDuringRender = null;
        var currentEventTime = NoTimestamp;
        var currentEventWipLanes = NoLanes;
        var currentEventPendingLanes = NoLanes;
        var isFlushingPassiveEffects = false;
        var focusedInstanceHandle = null;
        var shouldFireAfterActiveInstanceBlur = false;
        function getWorkInProgressRoot() {
          return workInProgressRoot;
        }
        function requestEventTime() {
          if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
            return now2();
          }
          if (currentEventTime !== NoTimestamp) {
            return currentEventTime;
          }
          currentEventTime = now2();
          return currentEventTime;
        }
        function requestUpdateLane(fiber) {
          var mode = fiber.mode;
          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          }
          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }
          var isTransition = requestCurrentTransition() !== NoTransition;
          if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) {
              currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            }
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
          }
          var schedulerPriority = getCurrentPriorityLevel();
          var lane;
          if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
            lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
          } else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
          }
          return lane;
        }
        function requestRetryLane(fiber) {
          var mode = fiber.mode;
          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          }
          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }
          return findRetryLane(currentEventWipLanes);
        }
        function scheduleUpdateOnFiber(fiber, lane, eventTime) {
          checkForNestedUpdates();
          warnAboutRenderPhaseUpdatesInDEV(fiber);
          var root4 = markUpdateLaneFromFiberToRoot(fiber, lane);
          if (root4 === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
          }
          markRootUpdated(root4, lane, eventTime);
          if (root4 === workInProgressRoot) {
            {
              workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            }
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              markRootSuspended$1(root4, workInProgressRootRenderLanes);
            }
          }
          var priorityLevel = getCurrentPriorityLevel();
          if (lane === SyncLane) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && (executionContext & (RenderContext | CommitContext)) === NoContext) {
              schedulePendingInteractions(root4, lane);
              performSyncWorkOnRoot(root4);
            } else {
              ensureRootIsScheduled(root4, eventTime);
              schedulePendingInteractions(root4, lane);
              if (executionContext === NoContext) {
                resetRenderTimer();
                flushSyncCallbackQueue();
              }
            }
          } else {
            if ((executionContext & DiscreteEventContext) !== NoContext && (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
              if (rootsWithPendingDiscreteUpdates === null) {
                rootsWithPendingDiscreteUpdates = new Set([root4]);
              } else {
                rootsWithPendingDiscreteUpdates.add(root4);
              }
            }
            ensureRootIsScheduled(root4, eventTime);
            schedulePendingInteractions(root4, lane);
          }
          mostRecentlyUpdatedRoot = root4;
        }
        function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
          var alternate = sourceFiber.alternate;
          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, lane);
          }
          {
            if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
              warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            }
          }
          var node = sourceFiber;
          var parent = sourceFiber.return;
          while (parent !== null) {
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            } else {
              {
                if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                  warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
                }
              }
            }
            node = parent;
            parent = parent.return;
          }
          if (node.tag === HostRoot) {
            var root4 = node.stateNode;
            return root4;
          } else {
            return null;
          }
        }
        function ensureRootIsScheduled(root4, currentTime) {
          var existingCallbackNode = root4.callbackNode;
          markStarvedLanesAsExpired(root4, currentTime);
          var nextLanes = getNextLanes(root4, root4 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
          var newCallbackPriority = returnNextLanesPriority();
          if (nextLanes === NoLanes) {
            if (existingCallbackNode !== null) {
              cancelCallback(existingCallbackNode);
              root4.callbackNode = null;
              root4.callbackPriority = NoLanePriority;
            }
            return;
          }
          if (existingCallbackNode !== null) {
            var existingCallbackPriority = root4.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) {
              return;
            }
            cancelCallback(existingCallbackNode);
          }
          var newCallbackNode;
          if (newCallbackPriority === SyncLanePriority) {
            newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root4));
          } else if (newCallbackPriority === SyncBatchedLanePriority) {
            newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root4));
          } else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root4));
          }
          root4.callbackPriority = newCallbackPriority;
          root4.callbackNode = newCallbackNode;
        }
        function performConcurrentWorkOnRoot(root4) {
          currentEventTime = NoTimestamp;
          currentEventWipLanes = NoLanes;
          currentEventPendingLanes = NoLanes;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          var originalCallbackNode = root4.callbackNode;
          var didFlushPassiveEffects = flushPassiveEffects();
          if (didFlushPassiveEffects) {
            if (root4.callbackNode !== originalCallbackNode) {
              return null;
            }
          }
          var lanes = getNextLanes(root4, root4 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
          if (lanes === NoLanes) {
            return null;
          }
          var exitStatus = renderRootConcurrent(root4, lanes);
          if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
            prepareFreshStack(root4, NoLanes);
          } else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
              executionContext |= RetryAfterError;
              if (root4.hydrate) {
                root4.hydrate = false;
                clearContainer(root4.containerInfo);
              }
              lanes = getLanesToRetrySynchronouslyOnError(root4);
              if (lanes !== NoLanes) {
                exitStatus = renderRootSync(root4, lanes);
              }
            }
            if (exitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              prepareFreshStack(root4, NoLanes);
              markRootSuspended$1(root4, lanes);
              ensureRootIsScheduled(root4, now2());
              throw fatalError;
            }
            var finishedWork = root4.current.alternate;
            root4.finishedWork = finishedWork;
            root4.finishedLanes = lanes;
            finishConcurrentRender(root4, exitStatus, lanes);
          }
          ensureRootIsScheduled(root4, now2());
          if (root4.callbackNode === originalCallbackNode) {
            return performConcurrentWorkOnRoot.bind(null, root4);
          }
          return null;
        }
        function finishConcurrentRender(root4, exitStatus, lanes) {
          switch (exitStatus) {
            case RootIncomplete:
            case RootFatalErrored: {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
            case RootErrored: {
              commitRoot(root4);
              break;
            }
            case RootSuspended: {
              markRootSuspended$1(root4, lanes);
              if (includesOnlyRetries(lanes) && !shouldForceFlushFallbacksInDEV()) {
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now2();
                if (msUntilTimeout > 10) {
                  var nextLanes = getNextLanes(root4, NoLanes);
                  if (nextLanes !== NoLanes) {
                    break;
                  }
                  var suspendedLanes = root4.suspendedLanes;
                  if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                    var eventTime = requestEventTime();
                    markRootPinged(root4, suspendedLanes);
                    break;
                  }
                  root4.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root4), msUntilTimeout);
                  break;
                }
              }
              commitRoot(root4);
              break;
            }
            case RootSuspendedWithDelay: {
              markRootSuspended$1(root4, lanes);
              if (includesOnlyTransitions(lanes)) {
                break;
              }
              if (!shouldForceFlushFallbacksInDEV()) {
                var mostRecentEventTime = getMostRecentEventTime(root4, lanes);
                var eventTimeMs = mostRecentEventTime;
                var timeElapsedMs = now2() - eventTimeMs;
                var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;
                if (_msUntilTimeout > 10) {
                  root4.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root4), _msUntilTimeout);
                  break;
                }
              }
              commitRoot(root4);
              break;
            }
            case RootCompleted: {
              commitRoot(root4);
              break;
            }
            default: {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
          }
        }
        function markRootSuspended$1(root4, suspendedLanes) {
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
          markRootSuspended(root4, suspendedLanes);
        }
        function performSyncWorkOnRoot(root4) {
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects();
          var lanes;
          var exitStatus;
          if (root4 === workInProgressRoot && includesSomeLane(root4.expiredLanes, workInProgressRootRenderLanes)) {
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root4, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
              lanes = getNextLanes(root4, lanes);
              exitStatus = renderRootSync(root4, lanes);
            }
          } else {
            lanes = getNextLanes(root4, NoLanes);
            exitStatus = renderRootSync(root4, lanes);
          }
          if (root4.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError;
            if (root4.hydrate) {
              root4.hydrate = false;
              clearContainer(root4.containerInfo);
            }
            lanes = getLanesToRetrySynchronouslyOnError(root4);
            if (lanes !== NoLanes) {
              exitStatus = renderRootSync(root4, lanes);
            }
          }
          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root4, NoLanes);
            markRootSuspended$1(root4, lanes);
            ensureRootIsScheduled(root4, now2());
            throw fatalError;
          }
          var finishedWork = root4.current.alternate;
          root4.finishedWork = finishedWork;
          root4.finishedLanes = lanes;
          commitRoot(root4);
          ensureRootIsScheduled(root4, now2());
          return null;
        }
        function flushDiscreteUpdates() {
          if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            {
              if ((executionContext & RenderContext) !== NoContext) {
                error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
              }
            }
            return;
          }
          flushPendingDiscreteUpdates();
          flushPassiveEffects();
        }
        function flushPendingDiscreteUpdates() {
          if (rootsWithPendingDiscreteUpdates !== null) {
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(root4) {
              markDiscreteUpdatesExpired(root4);
              ensureRootIsScheduled(root4, now2());
            });
          }
          flushSyncCallbackQueue();
        }
        function batchedUpdates$1(fn2, a4) {
          var prevExecutionContext = executionContext;
          executionContext |= BatchedContext;
          try {
            return fn2(a4);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }
        function batchedEventUpdates$1(fn2, a4) {
          var prevExecutionContext = executionContext;
          executionContext |= EventContext;
          try {
            return fn2(a4);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }
        function discreteUpdates$1(fn2, a4, b4, c3, d3) {
          var prevExecutionContext = executionContext;
          executionContext |= DiscreteEventContext;
          {
            try {
              return runWithPriority$1(UserBlockingPriority$2, fn2.bind(null, a4, b4, c3, d3));
            } finally {
              executionContext = prevExecutionContext;
              if (executionContext === NoContext) {
                resetRenderTimer();
                flushSyncCallbackQueue();
              }
            }
          }
        }
        function unbatchedUpdates(fn2, a4) {
          var prevExecutionContext = executionContext;
          executionContext &= ~BatchedContext;
          executionContext |= LegacyUnbatchedContext;
          try {
            return fn2(a4);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }
        function flushSync(fn2, a4) {
          var prevExecutionContext = executionContext;
          if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            {
              error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            }
            return fn2(a4);
          }
          executionContext |= BatchedContext;
          {
            try {
              if (fn2) {
                return runWithPriority$1(ImmediatePriority$1, fn2.bind(null, a4));
              } else {
                return void 0;
              }
            } finally {
              executionContext = prevExecutionContext;
              flushSyncCallbackQueue();
            }
          }
        }
        function pushRenderLanes(fiber, lanes) {
          push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
          subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
          workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
        }
        function popRenderLanes(fiber) {
          subtreeRenderLanes = subtreeRenderLanesCursor.current;
          pop(subtreeRenderLanesCursor, fiber);
        }
        function prepareFreshStack(root4, lanes) {
          root4.finishedWork = null;
          root4.finishedLanes = NoLanes;
          var timeoutHandle = root4.timeoutHandle;
          if (timeoutHandle !== noTimeout) {
            root4.timeoutHandle = noTimeout;
            cancelTimeout(timeoutHandle);
          }
          if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while (interruptedWork !== null) {
              unwindInterruptedWork(interruptedWork);
              interruptedWork = interruptedWork.return;
            }
          }
          workInProgressRoot = root4;
          workInProgress = createWorkInProgress(root4.current, null);
          workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
          workInProgressRootExitStatus = RootIncomplete;
          workInProgressRootFatalError = null;
          workInProgressRootSkippedLanes = NoLanes;
          workInProgressRootUpdatedLanes = NoLanes;
          workInProgressRootPingedLanes = NoLanes;
          {
            spawnedWorkDuringRender = null;
          }
          {
            ReactStrictModeWarnings.discardPendingWarnings();
          }
        }
        function handleError(root4, thrownValue) {
          do {
            var erroredWork = workInProgress;
            try {
              resetContextDependencies();
              resetHooksAfterThrow();
              resetCurrentFiber();
              ReactCurrentOwner$2.current = null;
              if (erroredWork === null || erroredWork.return === null) {
                workInProgressRootExitStatus = RootFatalErrored;
                workInProgressRootFatalError = thrownValue;
                workInProgress = null;
                return;
              }
              if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
              }
              throwException(root4, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
              completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
              thrownValue = yetAnotherThrownValue;
              if (workInProgress === erroredWork && erroredWork !== null) {
                erroredWork = erroredWork.return;
                workInProgress = erroredWork;
              } else {
                erroredWork = workInProgress;
              }
              continue;
            }
            return;
          } while (true);
        }
        function pushDispatcher() {
          var prevDispatcher = ReactCurrentDispatcher$2.current;
          ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
          if (prevDispatcher === null) {
            return ContextOnlyDispatcher;
          } else {
            return prevDispatcher;
          }
        }
        function popDispatcher(prevDispatcher) {
          ReactCurrentDispatcher$2.current = prevDispatcher;
        }
        function pushInteractions(root4) {
          {
            var prevInteractions = tracing.__interactionsRef.current;
            tracing.__interactionsRef.current = root4.memoizedInteractions;
            return prevInteractions;
          }
        }
        function popInteractions(prevInteractions) {
          {
            tracing.__interactionsRef.current = prevInteractions;
          }
        }
        function markCommitTimeOfFallback() {
          globalMostRecentFallbackTime = now2();
        }
        function markSkippedUpdateLanes(lane) {
          workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
        }
        function renderDidSuspend() {
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootSuspended;
          }
        }
        function renderDidSuspendDelayIfPossible() {
          if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
            workInProgressRootExitStatus = RootSuspendedWithDelay;
          }
          if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
            markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
          }
        }
        function renderDidError() {
          if (workInProgressRootExitStatus !== RootCompleted) {
            workInProgressRootExitStatus = RootErrored;
          }
        }
        function renderHasNotSuspendedYet() {
          return workInProgressRootExitStatus === RootIncomplete;
        }
        function renderRootSync(root4, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          if (workInProgressRoot !== root4 || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root4, lanes);
            startWorkOnPendingInteractions(root4, lanes);
          }
          var prevInteractions = pushInteractions(root4);
          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root4, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);
          if (workInProgress !== null) {
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        }
        function workLoopSync() {
          while (workInProgress !== null) {
            performUnitOfWork(workInProgress);
          }
        }
        function renderRootConcurrent(root4, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          if (workInProgressRoot !== root4 || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root4, lanes);
            startWorkOnPendingInteractions(root4, lanes);
          }
          var prevInteractions = pushInteractions(root4);
          do {
            try {
              workLoopConcurrent();
              break;
            } catch (thrownValue) {
              handleError(root4, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          popDispatcher(prevDispatcher);
          executionContext = prevExecutionContext;
          if (workInProgress !== null) {
            return RootIncomplete;
          } else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes;
            return workInProgressRootExitStatus;
          }
        }
        function workLoopConcurrent() {
          while (workInProgress !== null && !shouldYield()) {
            performUnitOfWork(workInProgress);
          }
        }
        function performUnitOfWork(unitOfWork) {
          var current2 = unitOfWork.alternate;
          setCurrentFiber(unitOfWork);
          var next;
          if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
          } else {
            next = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
          }
          resetCurrentFiber();
          unitOfWork.memoizedProps = unitOfWork.pendingProps;
          if (next === null) {
            completeUnitOfWork(unitOfWork);
          } else {
            workInProgress = next;
          }
          ReactCurrentOwner$2.current = null;
        }
        function completeUnitOfWork(unitOfWork) {
          var completedWork = unitOfWork;
          do {
            var current2 = completedWork.alternate;
            var returnFiber = completedWork.return;
            if ((completedWork.flags & Incomplete) === NoFlags) {
              setCurrentFiber(completedWork);
              var next = void 0;
              if ((completedWork.mode & ProfileMode) === NoMode) {
                next = completeWork(current2, completedWork, subtreeRenderLanes);
              } else {
                startProfilerTimer(completedWork);
                next = completeWork(current2, completedWork, subtreeRenderLanes);
                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              }
              resetCurrentFiber();
              if (next !== null) {
                workInProgress = next;
                return;
              }
              resetChildLanes(completedWork);
              if (returnFiber !== null && (returnFiber.flags & Incomplete) === NoFlags) {
                if (returnFiber.firstEffect === null) {
                  returnFiber.firstEffect = completedWork.firstEffect;
                }
                if (completedWork.lastEffect !== null) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                  }
                  returnFiber.lastEffect = completedWork.lastEffect;
                }
                var flags = completedWork.flags;
                if (flags > PerformedWork) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork;
                  } else {
                    returnFiber.firstEffect = completedWork;
                  }
                  returnFiber.lastEffect = completedWork;
                }
              }
            } else {
              var _next = unwindWork(completedWork);
              if (_next !== null) {
                _next.flags &= HostEffectMask;
                workInProgress = _next;
                return;
              }
              if ((completedWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                var actualDuration = completedWork.actualDuration;
                var child = completedWork.child;
                while (child !== null) {
                  actualDuration += child.actualDuration;
                  child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
              }
              if (returnFiber !== null) {
                returnFiber.firstEffect = returnFiber.lastEffect = null;
                returnFiber.flags |= Incomplete;
              }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
              workInProgress = siblingFiber;
              return;
            }
            completedWork = returnFiber;
            workInProgress = completedWork;
          } while (completedWork !== null);
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootCompleted;
          }
        }
        function resetChildLanes(completedWork) {
          if ((completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
            return;
          }
          var newChildLanes = NoLanes;
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
              if (shouldBubbleActualDurations) {
                actualDuration += child.actualDuration;
              }
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
              var primaryChildFragment = completedWork.child;
              if (primaryChildFragment !== null) {
                treeBaseDuration -= primaryChildFragment.treeBaseDuration;
              }
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;
            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              _child = _child.sibling;
            }
          }
          completedWork.childLanes = newChildLanes;
        }
        function commitRoot(root4) {
          var renderPriorityLevel = getCurrentPriorityLevel();
          runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root4, renderPriorityLevel));
          return null;
        }
        function commitRootImpl(root4, renderPriorityLevel) {
          do {
            flushPassiveEffects();
          } while (rootWithPendingPassiveEffects !== null);
          flushRenderPhaseStrictModeWarningsInDEV();
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          var finishedWork = root4.finishedWork;
          var lanes = root4.finishedLanes;
          if (finishedWork === null) {
            return null;
          }
          root4.finishedWork = null;
          root4.finishedLanes = NoLanes;
          if (!(finishedWork !== root4.current)) {
            {
              throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          root4.callbackNode = null;
          var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
          markRootFinished(root4, remainingLanes);
          if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root4)) {
              rootsWithPendingDiscreteUpdates.delete(root4);
            }
          }
          if (root4 === workInProgressRoot) {
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
          }
          var firstEffect;
          if (finishedWork.flags > PerformedWork) {
            if (finishedWork.lastEffect !== null) {
              finishedWork.lastEffect.nextEffect = finishedWork;
              firstEffect = finishedWork.firstEffect;
            } else {
              firstEffect = finishedWork;
            }
          } else {
            firstEffect = finishedWork.firstEffect;
          }
          if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root4);
            ReactCurrentOwner$2.current = null;
            focusedInstanceHandle = prepareForCommit(root4.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var error2 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, error2);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            focusedInstanceHandle = null;
            {
              recordCommitTime();
            }
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitMutationEffects, null, root4, renderPriorityLevel);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            resetAfterCommit(root4.containerInfo);
            root4.current = finishedWork;
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitLayoutEffects, null, root4, lanes);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error2 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error2);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            nextEffect = null;
            requestPaint();
            {
              popInteractions(prevInteractions);
            }
            executionContext = prevExecutionContext;
          } else {
            root4.current = finishedWork;
            {
              recordCommitTime();
            }
          }
          var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
          if (rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root4;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
          } else {
            nextEffect = firstEffect;
            while (nextEffect !== null) {
              var nextNextEffect = nextEffect.nextEffect;
              nextEffect.nextEffect = null;
              if (nextEffect.flags & Deletion) {
                detachFiberAfterEffects(nextEffect);
              }
              nextEffect = nextNextEffect;
            }
          }
          remainingLanes = root4.pendingLanes;
          if (remainingLanes !== NoLanes) {
            {
              if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for (var i3 = 0; i3 < expirationTimes.length; i3++) {
                  scheduleInteractions(root4, expirationTimes[i3], root4.memoizedInteractions);
                }
              }
              schedulePendingInteractions(root4, remainingLanes);
            }
          } else {
            legacyErrorBoundariesThatAlreadyFailed = null;
          }
          {
            if (!rootDidHavePassiveEffects) {
              finishPendingInteractions(root4, lanes);
            }
          }
          if (remainingLanes === SyncLane) {
            if (root4 === rootWithNestedUpdates) {
              nestedUpdateCount++;
            } else {
              nestedUpdateCount = 0;
              rootWithNestedUpdates = root4;
            }
          } else {
            nestedUpdateCount = 0;
          }
          onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
          {
            onCommitRoot$1();
          }
          ensureRootIsScheduled(root4, now2());
          if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
          }
          if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
            return null;
          }
          flushSyncCallbackQueue();
          return null;
        }
        function commitBeforeMutationEffects() {
          while (nextEffect !== null) {
            var current2 = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
              if ((nextEffect.flags & Deletion) !== NoFlags) {
                if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              } else {
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current2, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              }
            }
            var flags = nextEffect.flags;
            if ((flags & Snapshot) !== NoFlags) {
              setCurrentFiber(nextEffect);
              commitBeforeMutationLifeCycles(current2, nextEffect);
              resetCurrentFiber();
            }
            if ((flags & Passive) !== NoFlags) {
              if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority$1, function() {
                  flushPassiveEffects();
                  return null;
                });
              }
            }
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitMutationEffects(root4, renderPriorityLevel) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & ContentReset) {
              commitResetTextContent(nextEffect);
            }
            if (flags & Ref) {
              var current2 = nextEffect.alternate;
              if (current2 !== null) {
                commitDetachRef(current2);
              }
            }
            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
            switch (primaryFlags) {
              case Placement: {
                commitPlacement(nextEffect);
                nextEffect.flags &= ~Placement;
                break;
              }
              case PlacementAndUpdate: {
                commitPlacement(nextEffect);
                nextEffect.flags &= ~Placement;
                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
              case Hydrating: {
                nextEffect.flags &= ~Hydrating;
                break;
              }
              case HydratingAndUpdate: {
                nextEffect.flags &= ~Hydrating;
                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
              case Update: {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
              case Deletion: {
                commitDeletion(root4, nextEffect);
                break;
              }
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitLayoutEffects(root4, committedLanes) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & (Update | Callback)) {
              var current2 = nextEffect.alternate;
              commitLifeCycles(root4, current2, nextEffect);
            }
            {
              if (flags & Ref) {
                commitAttachRef(nextEffect);
              }
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function flushPassiveEffects() {
          if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            {
              return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
            }
          }
          return false;
        }
        function enqueuePendingPassiveHookEffectMount(fiber, effect) {
          pendingPassiveHookEffectsMount.push(effect, fiber);
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
        function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
          pendingPassiveHookEffectsUnmount.push(effect, fiber);
          {
            fiber.flags |= PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) {
              alternate.flags |= PassiveUnmountPendingDev;
            }
          }
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
        function invokePassiveEffectCreate(effect) {
          var create = effect.create;
          effect.destroy = create();
        }
        function flushPassiveEffectsImpl() {
          if (rootWithPendingPassiveEffects === null) {
            return false;
          }
          var root4 = rootWithPendingPassiveEffects;
          var lanes = pendingPassiveEffectsLanes;
          rootWithPendingPassiveEffects = null;
          pendingPassiveEffectsLanes = NoLanes;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Cannot flush passive effects while already rendering.");
            }
          }
          {
            isFlushingPassiveEffects = true;
          }
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root4);
          var unmountEffects = pendingPassiveHookEffectsUnmount;
          pendingPassiveHookEffectsUnmount = [];
          for (var i3 = 0; i3 < unmountEffects.length; i3 += 2) {
            var _effect = unmountEffects[i3];
            var fiber = unmountEffects[i3 + 1];
            var destroy = _effect.destroy;
            _effect.destroy = void 0;
            {
              fiber.flags &= ~PassiveUnmountPendingDev;
              var alternate = fiber.alternate;
              if (alternate !== null) {
                alternate.flags &= ~PassiveUnmountPendingDev;
              }
            }
            if (typeof destroy === "function") {
              {
                setCurrentFiber(fiber);
                {
                  invokeGuardedCallback(null, destroy, null);
                }
                if (hasCaughtError()) {
                  if (!(fiber !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var error2 = clearCaughtError();
                  captureCommitPhaseError(fiber, error2);
                }
                resetCurrentFiber();
              }
            }
          }
          var mountEffects = pendingPassiveHookEffectsMount;
          pendingPassiveHookEffectsMount = [];
          for (var _i = 0; _i < mountEffects.length; _i += 2) {
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            {
              setCurrentFiber(_fiber);
              {
                invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
              }
              if (hasCaughtError()) {
                if (!(_fiber !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
              }
              resetCurrentFiber();
            }
          }
          var effect = root4.current.firstEffect;
          while (effect !== null) {
            var nextNextEffect = effect.nextEffect;
            effect.nextEffect = null;
            if (effect.flags & Deletion) {
              detachFiberAfterEffects(effect);
            }
            effect = nextNextEffect;
          }
          {
            popInteractions(prevInteractions);
            finishPendingInteractions(root4, lanes);
          }
          {
            isFlushingPassiveEffects = false;
          }
          executionContext = prevExecutionContext;
          flushSyncCallbackQueue();
          nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
          return true;
        }
        function isAlreadyFailedLegacyErrorBoundary(instance) {
          return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }
        function markLegacyErrorBoundaryAsFailed(instance) {
          if (legacyErrorBoundariesThatAlreadyFailed === null) {
            legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
          } else {
            legacyErrorBoundariesThatAlreadyFailed.add(instance);
          }
        }
        function prepareToThrowUncaughtError(error2) {
          if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error2;
          }
        }
        var onUncaughtError = prepareToThrowUncaughtError;
        function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error2) {
          var errorInfo = createCapturedValue(error2, sourceFiber);
          var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
          enqueueUpdate(rootFiber, update);
          var eventTime = requestEventTime();
          var root4 = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
          if (root4 !== null) {
            markRootUpdated(root4, SyncLane, eventTime);
            ensureRootIsScheduled(root4, eventTime);
            schedulePendingInteractions(root4, SyncLane);
          }
        }
        function captureCommitPhaseError(sourceFiber, error2) {
          if (sourceFiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error2);
            return;
          }
          var fiber = sourceFiber.return;
          while (fiber !== null) {
            if (fiber.tag === HostRoot) {
              captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error2);
              return;
            } else if (fiber.tag === ClassComponent) {
              var ctor = fiber.type;
              var instance = fiber.stateNode;
              if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                var errorInfo = createCapturedValue(error2, sourceFiber);
                var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                enqueueUpdate(fiber, update);
                var eventTime = requestEventTime();
                var root4 = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                if (root4 !== null) {
                  markRootUpdated(root4, SyncLane, eventTime);
                  ensureRootIsScheduled(root4, eventTime);
                  schedulePendingInteractions(root4, SyncLane);
                } else {
                  if (typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    try {
                      instance.componentDidCatch(error2, errorInfo);
                    } catch (errorToIgnore) {
                    }
                  }
                }
                return;
              }
            }
            fiber = fiber.return;
          }
        }
        function pingSuspendedRoot(root4, wakeable, pingedLanes) {
          var pingCache = root4.pingCache;
          if (pingCache !== null) {
            pingCache.delete(wakeable);
          }
          var eventTime = requestEventTime();
          markRootPinged(root4, pingedLanes);
          if (workInProgressRoot === root4 && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now2() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
              prepareFreshStack(root4, NoLanes);
            } else {
              workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
            }
          }
          ensureRootIsScheduled(root4, eventTime);
          schedulePendingInteractions(root4, pingedLanes);
        }
        function retryTimedOutBoundary(boundaryFiber, retryLane) {
          if (retryLane === NoLane) {
            retryLane = requestRetryLane(boundaryFiber);
          }
          var eventTime = requestEventTime();
          var root4 = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
          if (root4 !== null) {
            markRootUpdated(root4, retryLane, eventTime);
            ensureRootIsScheduled(root4, eventTime);
            schedulePendingInteractions(root4, retryLane);
          }
        }
        function resolveRetryWakeable(boundaryFiber, wakeable) {
          var retryLane = NoLane;
          var retryCache;
          {
            retryCache = boundaryFiber.stateNode;
          }
          if (retryCache !== null) {
            retryCache.delete(wakeable);
          }
          retryTimedOutBoundary(boundaryFiber, retryLane);
        }
        function jnd(timeElapsed) {
          return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3e3 ? 3e3 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
        }
        function checkForNestedUpdates() {
          if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            {
              {
                throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
              }
            }
          }
          {
            if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
              nestedPassiveUpdateCount = 0;
              error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
            }
          }
        }
        function flushRenderPhaseStrictModeWarningsInDEV() {
          {
            ReactStrictModeWarnings.flushLegacyContextWarning();
            {
              ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
            }
          }
        }
        var didWarnStateUpdateForNotYetMountedComponent = null;
        function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
          {
            if ((executionContext & RenderContext) !== NoContext) {
              return;
            }
            if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
              return;
            }
            var tag = fiber.tag;
            if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
              return;
            }
            var componentName = getComponentName(fiber.type) || "ReactComponent";
            if (didWarnStateUpdateForNotYetMountedComponent !== null) {
              if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
                return;
              }
              didWarnStateUpdateForNotYetMountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
            }
            var previousFiber = current;
            try {
              setCurrentFiber(fiber);
              error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }
        var didWarnStateUpdateForUnmountedComponent = null;
        function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
          {
            var tag = fiber.tag;
            if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
              return;
            }
            if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
              return;
            }
            var componentName = getComponentName(fiber.type) || "ReactComponent";
            if (didWarnStateUpdateForUnmountedComponent !== null) {
              if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
                return;
              }
              didWarnStateUpdateForUnmountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
            }
            if (isFlushingPassiveEffects)
              ;
            else {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function");
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        var beginWork$1;
        {
          var dummyFiber = null;
          beginWork$1 = function(current2, unitOfWork, lanes) {
            var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
            try {
              return beginWork(current2, unitOfWork, lanes);
            } catch (originalError) {
              if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") {
                throw originalError;
              }
              resetContextDependencies();
              resetHooksAfterThrow();
              unwindInterruptedWork(unitOfWork);
              assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
              if (unitOfWork.mode & ProfileMode) {
                startProfilerTimer(unitOfWork);
              }
              invokeGuardedCallback(null, beginWork, null, current2, unitOfWork, lanes);
              if (hasCaughtError()) {
                var replayError = clearCaughtError();
                throw replayError;
              } else {
                throw originalError;
              }
            }
          };
        }
        var didWarnAboutUpdateInRender = false;
        var didWarnAboutUpdateInRenderForAnotherComponent;
        {
          didWarnAboutUpdateInRenderForAnotherComponent = new Set();
        }
        function warnAboutRenderPhaseUpdatesInDEV(fiber) {
          {
            if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
              switch (fiber.tag) {
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent: {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown";
                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
                case ClassComponent: {
                  if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
              }
            }
          }
        }
        var IsThisRendererActing = {
          current: false
        };
        function warnIfNotScopedWithMatchingAct(fiber) {
          {
            if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
          {
            if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            }
          }
        }
        function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
          {
            if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV;
        var didWarnAboutUnmockedScheduler = false;
        function warnIfUnmockedScheduler(fiber) {
          {
            if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === void 0) {
              if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error(`In Concurrent or Sync modes, the "scheduler" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: 
jest.mock('scheduler', () => require('scheduler/unstable_mock'));

For more info, visit https://reactjs.org/link/mock-scheduler`);
              }
            }
          }
        }
        function computeThreadID(root4, lane) {
          return lane * 1e3 + root4.interactionThreadID;
        }
        function markSpawnedWork(lane) {
          if (spawnedWorkDuringRender === null) {
            spawnedWorkDuringRender = [lane];
          } else {
            spawnedWorkDuringRender.push(lane);
          }
        }
        function scheduleInteractions(root4, lane, interactions) {
          if (interactions.size > 0) {
            var pendingInteractionMap = root4.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) {
              interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) {
                  interaction.__count++;
                }
                pendingInteractions.add(interaction);
              });
            } else {
              pendingInteractionMap.set(lane, new Set(interactions));
              interactions.forEach(function(interaction) {
                interaction.__count++;
              });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root4, lane);
              subscriber.onWorkScheduled(interactions, threadID);
            }
          }
        }
        function schedulePendingInteractions(root4, lane) {
          scheduleInteractions(root4, lane, tracing.__interactionsRef.current);
        }
        function startWorkOnPendingInteractions(root4, lanes) {
          var interactions = new Set();
          root4.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) {
              scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
              });
            }
          });
          root4.memoizedInteractions = interactions;
          if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root4, lanes);
              try {
                subscriber.onWorkStarted(interactions, threadID);
              } catch (error2) {
                scheduleCallback(ImmediatePriority$1, function() {
                  throw error2;
                });
              }
            }
          }
        }
        function finishPendingInteractions(root4, committedLanes) {
          var remainingLanesAfterCommit = root4.pendingLanes;
          var subscriber;
          try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root4.memoizedInteractions.size > 0) {
              var threadID = computeThreadID(root4, committedLanes);
              subscriber.onWorkStopped(root4.memoizedInteractions, threadID);
            }
          } catch (error2) {
            scheduleCallback(ImmediatePriority$1, function() {
              throw error2;
            });
          } finally {
            var pendingInteractionMap = root4.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
              if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                pendingInteractionMap.delete(lane);
                scheduledInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    try {
                      subscriber.onInteractionScheduledWorkCompleted(interaction);
                    } catch (error2) {
                      scheduleCallback(ImmediatePriority$1, function() {
                        throw error2;
                      });
                    }
                  }
                });
              }
            });
          }
        }
        function shouldForceFlushFallbacksInDEV() {
          return actingUpdatesScopeDepth > 0;
        }
        var actingUpdatesScopeDepth = 0;
        function detachFiberAfterEffects(fiber) {
          fiber.sibling = null;
          fiber.stateNode = null;
        }
        var resolveFamily = null;
        var failedBoundaries = null;
        var setRefreshHandler = function(handler) {
          {
            resolveFamily = handler;
          }
        };
        function resolveFunctionForHotReloading(type) {
          {
            if (resolveFamily === null) {
              return type;
            }
            var family = resolveFamily(type);
            if (family === void 0) {
              return type;
            }
            return family.current;
          }
        }
        function resolveClassForHotReloading(type) {
          return resolveFunctionForHotReloading(type);
        }
        function resolveForwardRefForHotReloading(type) {
          {
            if (resolveFamily === null) {
              return type;
            }
            var family = resolveFamily(type);
            if (family === void 0) {
              if (type !== null && type !== void 0 && typeof type.render === "function") {
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                  var syntheticType = {
                    $$typeof: REACT_FORWARD_REF_TYPE,
                    render: currentRender
                  };
                  if (type.displayName !== void 0) {
                    syntheticType.displayName = type.displayName;
                  }
                  return syntheticType;
                }
              }
              return type;
            }
            return family.current;
          }
        }
        function isCompatibleFamilyForHotReloading(fiber, element) {
          {
            if (resolveFamily === null) {
              return false;
            }
            var prevType = fiber.elementType;
            var nextType = element.type;
            var needsCompareFamilies = false;
            var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
            switch (fiber.tag) {
              case ClassComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                }
                break;
              }
              case FunctionComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case ForwardRef: {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case MemoComponent:
              case SimpleMemoComponent: {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              default:
                return false;
            }
            if (needsCompareFamilies) {
              var prevFamily = resolveFamily(prevType);
              if (prevFamily !== void 0 && prevFamily === resolveFamily(nextType)) {
                return true;
              }
            }
            return false;
          }
        }
        function markFailedErrorBoundaryForHotReloading(fiber) {
          {
            if (resolveFamily === null) {
              return;
            }
            if (typeof WeakSet !== "function") {
              return;
            }
            if (failedBoundaries === null) {
              failedBoundaries = new WeakSet();
            }
            failedBoundaries.add(fiber);
          }
        }
        var scheduleRefresh = function(root4, update) {
          {
            if (resolveFamily === null) {
              return;
            }
            var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
            flushPassiveEffects();
            flushSync(function() {
              scheduleFibersWithFamiliesRecursively(root4.current, updatedFamilies, staleFamilies);
            });
          }
        };
        var scheduleRoot = function(root4, element) {
          {
            if (root4.context !== emptyContextObject) {
              return;
            }
            flushPassiveEffects();
            flushSync(function() {
              updateContainer(element, root4, null, null);
            });
          }
        };
        function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
          {
            var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
            var candidateType = null;
            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type;
                break;
              case ForwardRef:
                candidateType = type.render;
                break;
            }
            if (resolveFamily === null) {
              throw new Error("Expected resolveFamily to be set during hot reload.");
            }
            var needsRender = false;
            var needsRemount = false;
            if (candidateType !== null) {
              var family = resolveFamily(candidateType);
              if (family !== void 0) {
                if (staleFamilies.has(family)) {
                  needsRemount = true;
                } else if (updatedFamilies.has(family)) {
                  if (tag === ClassComponent) {
                    needsRemount = true;
                  } else {
                    needsRender = true;
                  }
                }
              }
            }
            if (failedBoundaries !== null) {
              if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
                needsRemount = true;
              }
            }
            if (needsRemount) {
              fiber._debugNeedsRemount = true;
            }
            if (needsRemount || needsRender) {
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
            if (child !== null && !needsRemount) {
              scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            }
            if (sibling !== null) {
              scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
            }
          }
        }
        var findHostInstancesForRefresh = function(root4, families) {
          {
            var hostInstances = new Set();
            var types = new Set(families.map(function(family) {
              return family.current;
            }));
            findHostInstancesForMatchingFibersRecursively(root4.current, types, hostInstances);
            return hostInstances;
          }
        };
        function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
          {
            var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
            var candidateType = null;
            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type;
                break;
              case ForwardRef:
                candidateType = type.render;
                break;
            }
            var didMatch = false;
            if (candidateType !== null) {
              if (types.has(candidateType)) {
                didMatch = true;
              }
            }
            if (didMatch) {
              findHostInstancesForFiberShallowly(fiber, hostInstances);
            } else {
              if (child !== null) {
                findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
              }
            }
            if (sibling !== null) {
              findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
            }
          }
        }
        function findHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
            if (foundHostInstances) {
              return;
            }
            var node = fiber;
            while (true) {
              switch (node.tag) {
                case HostComponent:
                  hostInstances.add(node.stateNode);
                  return;
                case HostPortal:
                  hostInstances.add(node.stateNode.containerInfo);
                  return;
                case HostRoot:
                  hostInstances.add(node.stateNode.containerInfo);
                  return;
              }
              if (node.return === null) {
                throw new Error("Expected to reach root first.");
              }
              node = node.return;
            }
          }
        }
        function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var node = fiber;
            var foundHostInstances = false;
            while (true) {
              if (node.tag === HostComponent) {
                foundHostInstances = true;
                hostInstances.add(node.stateNode);
              } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
              if (node === fiber) {
                return foundHostInstances;
              }
              while (node.sibling === null) {
                if (node.return === null || node.return === fiber) {
                  return foundHostInstances;
                }
                node = node.return;
              }
              node.sibling.return = node.return;
              node = node.sibling;
            }
          }
          return false;
        }
        var hasBadMapPolyfill;
        {
          hasBadMapPolyfill = false;
          try {
            var nonExtensibleObject = Object.preventExtensions({});
            new Map([[nonExtensibleObject, null]]);
            new Set([nonExtensibleObject]);
          } catch (e2) {
            hasBadMapPolyfill = true;
          }
        }
        var debugCounter = 1;
        function FiberNode(tag, pendingProps, key, mode) {
          this.tag = tag;
          this.key = key;
          this.elementType = null;
          this.type = null;
          this.stateNode = null;
          this.return = null;
          this.child = null;
          this.sibling = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = pendingProps;
          this.memoizedProps = null;
          this.updateQueue = null;
          this.memoizedState = null;
          this.dependencies = null;
          this.mode = mode;
          this.flags = NoFlags;
          this.nextEffect = null;
          this.firstEffect = null;
          this.lastEffect = null;
          this.lanes = NoLanes;
          this.childLanes = NoLanes;
          this.alternate = null;
          {
            this.actualDuration = Number.NaN;
            this.actualStartTime = Number.NaN;
            this.selfBaseDuration = Number.NaN;
            this.treeBaseDuration = Number.NaN;
            this.actualDuration = 0;
            this.actualStartTime = -1;
            this.selfBaseDuration = 0;
            this.treeBaseDuration = 0;
          }
          {
            this._debugID = debugCounter++;
            this._debugSource = null;
            this._debugOwner = null;
            this._debugNeedsRemount = false;
            this._debugHookTypes = null;
            if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") {
              Object.preventExtensions(this);
            }
          }
        }
        var createFiber = function(tag, pendingProps, key, mode) {
          return new FiberNode(tag, pendingProps, key, mode);
        };
        function shouldConstruct$1(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function isSimpleFunctionComponent(type) {
          return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === void 0;
        }
        function resolveLazyComponentTag(Component) {
          if (typeof Component === "function") {
            return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
          } else if (Component !== void 0 && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) {
              return ForwardRef;
            }
            if ($$typeof === REACT_MEMO_TYPE) {
              return MemoComponent;
            }
          }
          return IndeterminateComponent;
        }
        function createWorkInProgress(current2, pendingProps) {
          var workInProgress2 = current2.alternate;
          if (workInProgress2 === null) {
            workInProgress2 = createFiber(current2.tag, pendingProps, current2.key, current2.mode);
            workInProgress2.elementType = current2.elementType;
            workInProgress2.type = current2.type;
            workInProgress2.stateNode = current2.stateNode;
            {
              workInProgress2._debugID = current2._debugID;
              workInProgress2._debugSource = current2._debugSource;
              workInProgress2._debugOwner = current2._debugOwner;
              workInProgress2._debugHookTypes = current2._debugHookTypes;
            }
            workInProgress2.alternate = current2;
            current2.alternate = workInProgress2;
          } else {
            workInProgress2.pendingProps = pendingProps;
            workInProgress2.type = current2.type;
            workInProgress2.flags = NoFlags;
            workInProgress2.nextEffect = null;
            workInProgress2.firstEffect = null;
            workInProgress2.lastEffect = null;
            {
              workInProgress2.actualDuration = 0;
              workInProgress2.actualStartTime = -1;
            }
          }
          workInProgress2.childLanes = current2.childLanes;
          workInProgress2.lanes = current2.lanes;
          workInProgress2.child = current2.child;
          workInProgress2.memoizedProps = current2.memoizedProps;
          workInProgress2.memoizedState = current2.memoizedState;
          workInProgress2.updateQueue = current2.updateQueue;
          var currentDependencies = current2.dependencies;
          workInProgress2.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          };
          workInProgress2.sibling = current2.sibling;
          workInProgress2.index = current2.index;
          workInProgress2.ref = current2.ref;
          {
            workInProgress2.selfBaseDuration = current2.selfBaseDuration;
            workInProgress2.treeBaseDuration = current2.treeBaseDuration;
          }
          {
            workInProgress2._debugNeedsRemount = current2._debugNeedsRemount;
            switch (workInProgress2.tag) {
              case IndeterminateComponent:
              case FunctionComponent:
              case SimpleMemoComponent:
                workInProgress2.type = resolveFunctionForHotReloading(current2.type);
                break;
              case ClassComponent:
                workInProgress2.type = resolveClassForHotReloading(current2.type);
                break;
              case ForwardRef:
                workInProgress2.type = resolveForwardRefForHotReloading(current2.type);
                break;
            }
          }
          return workInProgress2;
        }
        function resetWorkInProgress(workInProgress2, renderLanes2) {
          workInProgress2.flags &= Placement;
          workInProgress2.nextEffect = null;
          workInProgress2.firstEffect = null;
          workInProgress2.lastEffect = null;
          var current2 = workInProgress2.alternate;
          if (current2 === null) {
            workInProgress2.childLanes = NoLanes;
            workInProgress2.lanes = renderLanes2;
            workInProgress2.child = null;
            workInProgress2.memoizedProps = null;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            workInProgress2.dependencies = null;
            workInProgress2.stateNode = null;
            {
              workInProgress2.selfBaseDuration = 0;
              workInProgress2.treeBaseDuration = 0;
            }
          } else {
            workInProgress2.childLanes = current2.childLanes;
            workInProgress2.lanes = current2.lanes;
            workInProgress2.child = current2.child;
            workInProgress2.memoizedProps = current2.memoizedProps;
            workInProgress2.memoizedState = current2.memoizedState;
            workInProgress2.updateQueue = current2.updateQueue;
            workInProgress2.type = current2.type;
            var currentDependencies = current2.dependencies;
            workInProgress2.dependencies = currentDependencies === null ? null : {
              lanes: currentDependencies.lanes,
              firstContext: currentDependencies.firstContext
            };
            {
              workInProgress2.selfBaseDuration = current2.selfBaseDuration;
              workInProgress2.treeBaseDuration = current2.treeBaseDuration;
            }
          }
          return workInProgress2;
        }
        function createHostRootFiber(tag) {
          var mode;
          if (tag === ConcurrentRoot) {
            mode = ConcurrentMode | BlockingMode | StrictMode;
          } else if (tag === BlockingRoot) {
            mode = BlockingMode | StrictMode;
          } else {
            mode = NoMode;
          }
          if (isDevToolsPresent) {
            mode |= ProfileMode;
          }
          return createFiber(HostRoot, null, null, mode);
        }
        function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
          var fiberTag = IndeterminateComponent;
          var resolvedType = type;
          if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
              fiberTag = ClassComponent;
              {
                resolvedType = resolveClassForHotReloading(resolvedType);
              }
            } else {
              {
                resolvedType = resolveFunctionForHotReloading(resolvedType);
              }
            }
          } else if (typeof type === "string") {
            fiberTag = HostComponent;
          } else {
            getTag:
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                  return createFiberFromFragment(pendingProps.children, mode, lanes, key);
                case REACT_DEBUG_TRACING_MODE_TYPE:
                  fiberTag = Mode;
                  mode |= DebugTracingMode;
                  break;
                case REACT_STRICT_MODE_TYPE:
                  fiberTag = Mode;
                  mode |= StrictMode;
                  break;
                case REACT_PROFILER_TYPE:
                  return createFiberFromProfiler(pendingProps, mode, lanes, key);
                case REACT_SUSPENSE_TYPE:
                  return createFiberFromSuspense(pendingProps, mode, lanes, key);
                case REACT_SUSPENSE_LIST_TYPE:
                  return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
                case REACT_OFFSCREEN_TYPE:
                  return createFiberFromOffscreen(pendingProps, mode, lanes, key);
                case REACT_LEGACY_HIDDEN_TYPE:
                  return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
                case REACT_SCOPE_TYPE:
                default: {
                  if (typeof type === "object" && type !== null) {
                    switch (type.$$typeof) {
                      case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                      case REACT_CONTEXT_TYPE:
                        fiberTag = ContextConsumer;
                        break getTag;
                      case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        {
                          resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        }
                        break getTag;
                      case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                      case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                      case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                    }
                  }
                  var info = "";
                  {
                    if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
                      info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                    }
                    var ownerName = owner ? getComponentName(owner.type) : null;
                    if (ownerName) {
                      info += "\n\nCheck the render method of `" + ownerName + "`.";
                    }
                  }
                  {
                    {
                      throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
                    }
                  }
                }
              }
          }
          var fiber = createFiber(fiberTag, pendingProps, key, mode);
          fiber.elementType = type;
          fiber.type = resolvedType;
          fiber.lanes = lanes;
          {
            fiber._debugOwner = owner;
          }
          return fiber;
        }
        function createFiberFromElement(element, mode, lanes) {
          var owner = null;
          {
            owner = element._owner;
          }
          var type = element.type;
          var key = element.key;
          var pendingProps = element.props;
          var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
          {
            fiber._debugSource = element._source;
            fiber._debugOwner = element._owner;
          }
          return fiber;
        }
        function createFiberFromFragment(elements, mode, lanes, key) {
          var fiber = createFiber(Fragment3, elements, key, mode);
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromProfiler(pendingProps, mode, lanes, key) {
          {
            if (typeof pendingProps.id !== "string") {
              error('Profiler must specify an "id" as a prop');
            }
          }
          var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
          fiber.elementType = REACT_PROFILER_TYPE;
          fiber.type = REACT_PROFILER_TYPE;
          fiber.lanes = lanes;
          {
            fiber.stateNode = {
              effectDuration: 0,
              passiveEffectDuration: 0
            };
          }
          return fiber;
        }
        function createFiberFromSuspense(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
          fiber.type = REACT_SUSPENSE_TYPE;
          fiber.elementType = REACT_SUSPENSE_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_SUSPENSE_LIST_TYPE;
          }
          fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
          var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_OFFSCREEN_TYPE;
          }
          fiber.elementType = REACT_OFFSCREEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
          var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_LEGACY_HIDDEN_TYPE;
          }
          fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromText(content, mode, lanes) {
          var fiber = createFiber(HostText, content, null, mode);
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromHostInstanceForDeletion() {
          var fiber = createFiber(HostComponent, null, null, NoMode);
          fiber.elementType = "DELETED";
          fiber.type = "DELETED";
          return fiber;
        }
        function createFiberFromPortal(portal, mode, lanes) {
          var pendingProps = portal.children !== null ? portal.children : [];
          var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
          fiber.lanes = lanes;
          fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
          };
          return fiber;
        }
        function assignFiberPropertiesInDEV(target, source) {
          if (target === null) {
            target = createFiber(IndeterminateComponent, null, null, NoMode);
          }
          target.tag = source.tag;
          target.key = source.key;
          target.elementType = source.elementType;
          target.type = source.type;
          target.stateNode = source.stateNode;
          target.return = source.return;
          target.child = source.child;
          target.sibling = source.sibling;
          target.index = source.index;
          target.ref = source.ref;
          target.pendingProps = source.pendingProps;
          target.memoizedProps = source.memoizedProps;
          target.updateQueue = source.updateQueue;
          target.memoizedState = source.memoizedState;
          target.dependencies = source.dependencies;
          target.mode = source.mode;
          target.flags = source.flags;
          target.nextEffect = source.nextEffect;
          target.firstEffect = source.firstEffect;
          target.lastEffect = source.lastEffect;
          target.lanes = source.lanes;
          target.childLanes = source.childLanes;
          target.alternate = source.alternate;
          {
            target.actualDuration = source.actualDuration;
            target.actualStartTime = source.actualStartTime;
            target.selfBaseDuration = source.selfBaseDuration;
            target.treeBaseDuration = source.treeBaseDuration;
          }
          target._debugID = source._debugID;
          target._debugSource = source._debugSource;
          target._debugOwner = source._debugOwner;
          target._debugNeedsRemount = source._debugNeedsRemount;
          target._debugHookTypes = source._debugHookTypes;
          return target;
        }
        function FiberRootNode(containerInfo, tag, hydrate2) {
          this.tag = tag;
          this.containerInfo = containerInfo;
          this.pendingChildren = null;
          this.current = null;
          this.pingCache = null;
          this.finishedWork = null;
          this.timeoutHandle = noTimeout;
          this.context = null;
          this.pendingContext = null;
          this.hydrate = hydrate2;
          this.callbackNode = null;
          this.callbackPriority = NoLanePriority;
          this.eventTimes = createLaneMap(NoLanes);
          this.expirationTimes = createLaneMap(NoTimestamp);
          this.pendingLanes = NoLanes;
          this.suspendedLanes = NoLanes;
          this.pingedLanes = NoLanes;
          this.expiredLanes = NoLanes;
          this.mutableReadLanes = NoLanes;
          this.finishedLanes = NoLanes;
          this.entangledLanes = NoLanes;
          this.entanglements = createLaneMap(NoLanes);
          {
            this.mutableSourceEagerHydrationData = null;
          }
          {
            this.interactionThreadID = tracing.unstable_getThreadID();
            this.memoizedInteractions = new Set();
            this.pendingInteractionMap = new Map();
          }
          {
            switch (tag) {
              case BlockingRoot:
                this._debugRootType = "createBlockingRoot()";
                break;
              case ConcurrentRoot:
                this._debugRootType = "createRoot()";
                break;
              case LegacyRoot:
                this._debugRootType = "createLegacyRoot()";
                break;
            }
          }
        }
        function createFiberRoot(containerInfo, tag, hydrate2, hydrationCallbacks) {
          var root4 = new FiberRootNode(containerInfo, tag, hydrate2);
          var uninitializedFiber = createHostRootFiber(tag);
          root4.current = uninitializedFiber;
          uninitializedFiber.stateNode = root4;
          initializeUpdateQueue(uninitializedFiber);
          return root4;
        }
        function registerMutableSourceForHydration(root4, mutableSource) {
          var getVersion = mutableSource._getVersion;
          var version2 = getVersion(mutableSource._source);
          if (root4.mutableSourceEagerHydrationData == null) {
            root4.mutableSourceEagerHydrationData = [mutableSource, version2];
          } else {
            root4.mutableSourceEagerHydrationData.push(mutableSource, version2);
          }
        }
        function createPortal6(children, containerInfo, implementation) {
          var key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
          return {
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children,
            containerInfo,
            implementation
          };
        }
        var didWarnAboutNestedUpdates;
        var didWarnAboutFindNodeInStrictMode;
        {
          didWarnAboutNestedUpdates = false;
          didWarnAboutFindNodeInStrictMode = {};
        }
        function getContextForSubtree(parentComponent) {
          if (!parentComponent) {
            return emptyContextObject;
          }
          var fiber = get2(parentComponent);
          var parentContext = findCurrentUnmaskedContext(fiber);
          if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) {
              return processChildContext(fiber, Component, parentContext);
            }
          }
          return parentContext;
        }
        function findHostInstanceWithWarning(component, methodName) {
          {
            var fiber = get2(component);
            if (fiber === void 0) {
              if (typeof component.render === "function") {
                {
                  {
                    throw Error("Unable to find node on an unmounted component.");
                  }
                }
              } else {
                {
                  {
                    throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
                  }
                }
              }
            }
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
              return null;
            }
            if (hostFiber.mode & StrictMode) {
              var componentName = getComponentName(fiber.type) || "Component";
              if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                  setCurrentFiber(hostFiber);
                  if (fiber.mode & StrictMode) {
                    error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                  } else {
                    error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                  }
                } finally {
                  if (previousFiber) {
                    setCurrentFiber(previousFiber);
                  } else {
                    resetCurrentFiber();
                  }
                }
              }
            }
            return hostFiber.stateNode;
          }
        }
        function createContainer(containerInfo, tag, hydrate2, hydrationCallbacks) {
          return createFiberRoot(containerInfo, tag, hydrate2);
        }
        function updateContainer(element, container, parentComponent, callback) {
          {
            onScheduleRoot(container, element);
          }
          var current$1 = container.current;
          var eventTime = requestEventTime();
          {
            if (typeof jest !== "undefined") {
              warnIfUnmockedScheduler(current$1);
              warnIfNotScopedWithMatchingAct(current$1);
            }
          }
          var lane = requestUpdateLane(current$1);
          var context3 = getContextForSubtree(parentComponent);
          if (container.context === null) {
            container.context = context3;
          } else {
            container.pendingContext = context3;
          }
          {
            if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
              didWarnAboutNestedUpdates = true;
              error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || "Unknown");
            }
          }
          var update = createUpdate(eventTime, lane);
          update.payload = {
            element
          };
          callback = callback === void 0 ? null : callback;
          if (callback !== null) {
            {
              if (typeof callback !== "function") {
                error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
              }
            }
            update.callback = callback;
          }
          enqueueUpdate(current$1, update);
          scheduleUpdateOnFiber(current$1, lane, eventTime);
          return lane;
        }
        function getPublicRootInstance(container) {
          var containerFiber = container.current;
          if (!containerFiber.child) {
            return null;
          }
          switch (containerFiber.child.tag) {
            case HostComponent:
              return getPublicInstance(containerFiber.child.stateNode);
            default:
              return containerFiber.child.stateNode;
          }
        }
        function markRetryLaneImpl(fiber, retryLane) {
          var suspenseState = fiber.memoizedState;
          if (suspenseState !== null && suspenseState.dehydrated !== null) {
            suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
          }
        }
        function markRetryLaneIfNotHydrated(fiber, retryLane) {
          markRetryLaneImpl(fiber, retryLane);
          var alternate = fiber.alternate;
          if (alternate) {
            markRetryLaneImpl(alternate, retryLane);
          }
        }
        function attemptUserBlockingHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          var eventTime = requestEventTime();
          var lane = InputDiscreteHydrationLane;
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }
        function attemptContinuousHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          var eventTime = requestEventTime();
          var lane = SelectiveHydrationLane;
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }
        function attemptHydrationAtCurrentPriority$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }
        function runWithPriority$2(priority, fn2) {
          try {
            setCurrentUpdateLanePriority(priority);
            return fn2();
          } finally {
          }
        }
        function findHostInstanceWithNoPortals(fiber) {
          var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
          if (hostFiber === null) {
            return null;
          }
          if (hostFiber.tag === FundamentalComponent) {
            return hostFiber.stateNode.instance;
          }
          return hostFiber.stateNode;
        }
        var shouldSuspendImpl = function(fiber) {
          return false;
        };
        function shouldSuspend(fiber) {
          return shouldSuspendImpl(fiber);
        }
        var overrideHookState = null;
        var overrideHookStateDeletePath = null;
        var overrideHookStateRenamePath = null;
        var overrideProps = null;
        var overridePropsDeletePath = null;
        var overridePropsRenamePath = null;
        var scheduleUpdate = null;
        var setSuspenseHandler = null;
        {
          var copyWithDeleteImpl = function(obj, path, index2) {
            var key = path[index2];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
            if (index2 + 1 === path.length) {
              if (Array.isArray(updated)) {
                updated.splice(key, 1);
              } else {
                delete updated[key];
              }
              return updated;
            }
            updated[key] = copyWithDeleteImpl(obj[key], path, index2 + 1);
            return updated;
          };
          var copyWithDelete = function(obj, path) {
            return copyWithDeleteImpl(obj, path, 0);
          };
          var copyWithRenameImpl = function(obj, oldPath, newPath, index2) {
            var oldKey = oldPath[index2];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
            if (index2 + 1 === oldPath.length) {
              var newKey = newPath[index2];
              updated[newKey] = updated[oldKey];
              if (Array.isArray(updated)) {
                updated.splice(oldKey, 1);
              } else {
                delete updated[oldKey];
              }
            } else {
              updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index2 + 1);
            }
            return updated;
          };
          var copyWithRename = function(obj, oldPath, newPath) {
            if (oldPath.length !== newPath.length) {
              warn("copyWithRename() expects paths of the same length");
              return;
            } else {
              for (var i3 = 0; i3 < newPath.length - 1; i3++) {
                if (oldPath[i3] !== newPath[i3]) {
                  warn("copyWithRename() expects paths to be the same except for the deepest key");
                  return;
                }
              }
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
          };
          var copyWithSetImpl = function(obj, path, index2, value) {
            if (index2 >= path.length) {
              return value;
            }
            var key = path[index2];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
            updated[key] = copyWithSetImpl(obj[key], path, index2 + 1, value);
            return updated;
          };
          var copyWithSet = function(obj, path, value) {
            return copyWithSetImpl(obj, path, 0, value);
          };
          var findHook = function(fiber, id) {
            var currentHook2 = fiber.memoizedState;
            while (currentHook2 !== null && id > 0) {
              currentHook2 = currentHook2.next;
              id--;
            }
            return currentHook2;
          };
          overrideHookState = function(fiber, id, path, value) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithSet(hook.memoizedState, path, value);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideHookStateDeletePath = function(fiber, id, path) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithDelete(hook.memoizedState, path);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideProps = function(fiber, path, value) {
            fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          overridePropsDeletePath = function(fiber, path) {
            fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          overridePropsRenamePath = function(fiber, oldPath, newPath) {
            fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          scheduleUpdate = function(fiber) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          setSuspenseHandler = function(newShouldSuspendImpl) {
            shouldSuspendImpl = newShouldSuspendImpl;
          };
        }
        function findHostInstanceByFiber(fiber) {
          var hostFiber = findCurrentHostFiber(fiber);
          if (hostFiber === null) {
            return null;
          }
          return hostFiber.stateNode;
        }
        function emptyFindFiberByHostInstance(instance) {
          return null;
        }
        function getCurrentFiberForDevTools() {
          return current;
        }
        function injectIntoDevTools(devToolsConfig) {
          var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
          var ReactCurrentDispatcher2 = ReactSharedInternals.ReactCurrentDispatcher;
          return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState,
            overrideHookStateDeletePath,
            overrideHookStateRenamePath,
            overrideProps,
            overridePropsDeletePath,
            overridePropsRenamePath,
            setSuspenseHandler,
            scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher2,
            findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            findHostInstancesForRefresh,
            scheduleRefresh,
            scheduleRoot,
            setRefreshHandler,
            getCurrentFiber: getCurrentFiberForDevTools
          });
        }
        function ReactDOMRoot(container, options3) {
          this._internalRoot = createRootImpl(container, ConcurrentRoot, options3);
        }
        function ReactDOMBlockingRoot(container, tag, options3) {
          this._internalRoot = createRootImpl(container, tag, options3);
        }
        ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
          var root4 = this._internalRoot;
          {
            if (typeof arguments[1] === "function") {
              error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
            }
            var container = root4.containerInfo;
            if (container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(root4.current);
              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
                }
              }
            }
          }
          updateContainer(children, root4, null, null);
        };
        ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
          {
            if (typeof arguments[0] === "function") {
              error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
            }
          }
          var root4 = this._internalRoot;
          var container = root4.containerInfo;
          updateContainer(null, root4, null, function() {
            unmarkContainerAsRoot(container);
          });
        };
        function createRootImpl(container, tag, options3) {
          var hydrate2 = options3 != null && options3.hydrate === true;
          var hydrationCallbacks = options3 != null && options3.hydrationOptions || null;
          var mutableSources = options3 != null && options3.hydrationOptions != null && options3.hydrationOptions.mutableSources || null;
          var root4 = createContainer(container, tag, hydrate2);
          markContainerAsRoot(root4.current, container);
          var containerNodeType = container.nodeType;
          {
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
          }
          if (mutableSources) {
            for (var i3 = 0; i3 < mutableSources.length; i3++) {
              var mutableSource = mutableSources[i3];
              registerMutableSourceForHydration(root4, mutableSource);
            }
          }
          return root4;
        }
        function createLegacyRoot(container, options3) {
          return new ReactDOMBlockingRoot(container, LegacyRoot, options3);
        }
        function isValidContainer(node) {
          return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
        }
        var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
        var topLevelUpdateWarnings;
        var warnedAboutHydrateAPI = false;
        {
          topLevelUpdateWarnings = function(container) {
            if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
                }
              }
            }
            var isRootRenderedBySomeReact = !!container._reactRootContainer;
            var rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
            if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
              error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
            }
            if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") {
              error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
            }
          };
        }
        function getReactRootElementInContainer(container) {
          if (!container) {
            return null;
          }
          if (container.nodeType === DOCUMENT_NODE) {
            return container.documentElement;
          } else {
            return container.firstChild;
          }
        }
        function shouldHydrateDueToLegacyHeuristic(container) {
          var rootElement = getReactRootElementInContainer(container);
          return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
        }
        function legacyCreateRootFromDOMContainer(container, forceHydrate) {
          var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container);
          if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while (rootSibling = container.lastChild) {
              {
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                  warned = true;
                  error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
              }
              container.removeChild(rootSibling);
            }
          }
          {
            if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
              warnedAboutHydrateAPI = true;
              warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
            }
          }
          return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
          } : void 0);
        }
        function warnOnInvalidCallback$1(callback, callerName) {
          {
            if (callback !== null && typeof callback !== "function") {
              error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
            }
          }
        }
        function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
          {
            topLevelUpdateWarnings(container);
            warnOnInvalidCallback$1(callback === void 0 ? null : callback, "render");
          }
          var root4 = container._reactRootContainer;
          var fiberRoot;
          if (!root4) {
            root4 = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root4._internalRoot;
            if (typeof callback === "function") {
              var originalCallback = callback;
              callback = function() {
                var instance = getPublicRootInstance(fiberRoot);
                originalCallback.call(instance);
              };
            }
            unbatchedUpdates(function() {
              updateContainer(children, fiberRoot, parentComponent, callback);
            });
          } else {
            fiberRoot = root4._internalRoot;
            if (typeof callback === "function") {
              var _originalCallback = callback;
              callback = function() {
                var instance = getPublicRootInstance(fiberRoot);
                _originalCallback.call(instance);
              };
            }
            updateContainer(children, fiberRoot, parentComponent, callback);
          }
          return getPublicRootInstance(fiberRoot);
        }
        function findDOMNode(componentOrElement) {
          {
            var owner = ReactCurrentOwner$3.current;
            if (owner !== null && owner.stateNode !== null) {
              var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
              if (!warnedAboutRefsInRender) {
                error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || "A component");
              }
              owner.stateNode._warnedAboutRefsInRender = true;
            }
          }
          if (componentOrElement == null) {
            return null;
          }
          if (componentOrElement.nodeType === ELEMENT_NODE) {
            return componentOrElement;
          }
          {
            return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
          }
        }
        function hydrate(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
            }
          }
          return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
        }
        function render(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
            }
          }
          return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
        }
        function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          if (!isValidContainer(containerNode)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          if (!(parentComponent != null && has(parentComponent))) {
            {
              throw Error("parentComponent must be a valid React Component");
            }
          }
          return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
        }
        function unmountComponentAtNode(container) {
          if (!isValidContainer(container)) {
            {
              throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
            }
          }
          if (container._reactRootContainer) {
            {
              var rootEl = getReactRootElementInContainer(container);
              var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
              if (renderedByDifferentReact) {
                error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
              }
            }
            unbatchedUpdates(function() {
              legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                container._reactRootContainer = null;
                unmarkContainerAsRoot(container);
              });
            });
            return true;
          } else {
            {
              var _rootEl = getReactRootElementInContainer(container);
              var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl));
              var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
              if (hasNonRootReactChild) {
                error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
              }
            }
            return false;
          }
        }
        setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
        setAttemptContinuousHydration(attemptContinuousHydration$1);
        setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
        setAttemptHydrationAtPriority(runWithPriority$2);
        var didWarnAboutUnstableCreatePortal = false;
        {
          if (typeof Map !== "function" || Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") {
            error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
          }
        }
        setRestoreImplementation(restoreControlledState$3);
        setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
        function createPortal$1(children, container) {
          var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          return createPortal6(children, container, null, key);
        }
        function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
        }
        function unstable_createPortal(children, container) {
          var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
          {
            if (!didWarnAboutUnstableCreatePortal) {
              didWarnAboutUnstableCreatePortal = true;
              warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
            }
          }
          return createPortal$1(children, container, key);
        }
        var Internals = {
          Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            flushPassiveEffects,
            IsThisRendererActing
          ]
        };
        var foundDevTools = injectIntoDevTools({
          findFiberByHostInstance: getClosestInstanceFromNode,
          bundleType: 1,
          version: ReactVersion,
          rendererPackageName: "react-dom"
        });
        {
          if (!foundDevTools && canUseDOM2 && window.top === window.self) {
            if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
              var protocol2 = window.location.protocol;
              if (/^(https?|file):$/.test(protocol2)) {
                console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol2 === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
              }
            }
          }
        }
        exports2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
        exports2.createPortal = createPortal$1;
        exports2.findDOMNode = findDOMNode;
        exports2.flushSync = flushSync;
        exports2.hydrate = hydrate;
        exports2.render = render;
        exports2.unmountComponentAtNode = unmountComponentAtNode;
        exports2.unstable_batchedUpdates = batchedUpdates$1;
        exports2.unstable_createPortal = unstable_createPortal;
        exports2.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
        exports2.version = ReactVersion;
      })();
    }
  }
});

// ../node_modules/react-dom/index.js
var require_react_dom = __commonJS({
  "../node_modules/react-dom/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      checkDCE();
      module2.exports = null;
    } else {
      module2.exports = require_react_dom_development();
    }
  }
});

// ../packages/react/src/index.ts
function useForceUpdate(debugLabel) {
  const [, setTick] = (0, import_react.useState)(0);
  const update = (0, import_react.useCallback)(() => {
    setTick((tick) => tick + 1);
  }, []);
  return update;
}
function usePrism(fn2, deps, debugLabel) {
  const fnAsCallback = (0, import_react.useCallback)(fn2, deps);
  const boxRef = (0, import_react.useRef)(null);
  if (!boxRef.current) {
    boxRef.current = new import_dataverse2.Box(fnAsCallback);
  } else {
    boxRef.current.set(fnAsCallback);
  }
  const derivation = (0, import_react.useMemo)(() => (0, import_dataverse3.prism)(() => {
    const fn3 = boxRef.current.derivation.getValue();
    return fn3();
  }), []);
  return useDerivation(derivation, debugLabel);
}
function queueIfNeeded() {
  if (microtaskIsQueued)
    return;
  microtaskIsQueued = true;
  (0, import_queue_microtask.default)(() => {
    (0, import_react_dom.unstable_batchedUpdates)(function runQueue() {
      var _a2, _b;
      while (queue.length > 0) {
        const item = queue.shift();
        setOfQueuedItems.delete(item);
        let newValue;
        if (TRACE) {
          (_a2 = item.debug) == null ? void 0 : _a2.history.push(`queue reached`);
        }
        try {
          newValue = item.der.getValue();
        } catch (error) {
          if (TRACE) {
            (_b = item.debug) == null ? void 0 : _b.history.push(`queue: der.getValue() errored`);
          }
          console.error("A `der.getValue()` in `useDerivation(der)` threw an error. This may be a zombie child issue, so we're gonna try to get its value again in a normal react render phase.If you see the same error again, then you either have an error in your prism code, or the deps array in `usePrism(fn, deps)` is missing a dependency and causing the prism to read stale values.");
          console.error(error);
          item.runUpdate();
          continue;
        }
        if (newValue !== item.lastValue) {
          item.lastValue = newValue;
          item.runUpdate();
        }
      }
    }, 1);
    microtaskIsQueued = false;
  });
}
function useDerivation(der, debugLabel) {
  var _a2;
  const _forceUpdate = useForceUpdate(debugLabel);
  const ref = (0, import_react.useRef)(void 0);
  if (!ref.current) {
    lastOrder++;
    ref.current = {
      order: lastOrder,
      runUpdate: () => {
        if (!ref.current.unmounted) {
          _forceUpdate();
        }
      },
      der,
      lastValue: void 0,
      unmounted: false,
      queueUpdate: () => {
        var _a3;
        if (TRACE) {
          (_a3 = ref.current.debug) == null ? void 0 : _a3.history.push(`queueUpdate()`);
        }
        pushToQueue(ref.current);
      },
      untap: der.changesWithoutValues().tap(() => {
        if (TRACE) {
          ref.current.debug.history.push(`changesWithoutValues(cb)`);
        }
        ref.current.queueUpdate();
      })
    };
    if (TRACE) {
      ref.current.debug = {
        label: debugLabel,
        traceOfFirstTimeRender: new Error(),
        history: []
      };
    }
  }
  if (true) {
    if (der !== ref.current.der) {
      console.error("Argument `der` in `useDerivation(der)` should not change between renders.");
    }
  }
  (0, import_react.useLayoutEffect)(() => {
    return function onUnmount() {
      ref.current.unmounted = true;
      ref.current.untap();
      removeFromQueue(ref.current);
    };
  }, []);
  removeFromQueue(ref.current);
  const newValue = ref.current.der.getValue();
  ref.current.lastValue = newValue;
  if (TRACE) {
    (_a2 = ref.current.debug) == null ? void 0 : _a2.history.push(`rendered`);
  }
  return newValue;
}
var import_dataverse2, import_dataverse3, import_queue_microtask, import_react, import_react_dom, TRACE, useVal, lastOrder, queue, setOfQueuedItems, microtaskIsQueued, pushToQueue, _pushToQueue, removeFromQueue;
var init_src = __esm({
  "../packages/react/src/index.ts"() {
    import_dataverse2 = __toModule(require("@theatre/dataverse"));
    import_dataverse3 = __toModule(require("@theatre/dataverse"));
    init_lodash();
    import_queue_microtask = __toModule(require_queue_microtask());
    import_react = __toModule(require_react());
    import_react_dom = __toModule(require_react_dom());
    TRACE = false;
    useVal = (p3, debugLabel) => {
      return usePrism(() => (0, import_dataverse3.val)(p3), [p3], debugLabel);
    };
    lastOrder = 0;
    queue = [];
    setOfQueuedItems = new Set();
    microtaskIsQueued = false;
    pushToQueue = (item) => {
      _pushToQueue(item);
      queueIfNeeded();
    };
    _pushToQueue = (item) => {
      if (setOfQueuedItems.has(item))
        return;
      setOfQueuedItems.add(item);
      if (queue.length === 0) {
        queue.push(item);
      } else {
        const index = findIndex_default(queue, (existingItem) => existingItem.order >= item.order);
        if (index === -1) {
          queue.push(item);
        } else {
          const right = queue[index];
          if (right.order > item.order) {
            queue.splice(index, 0, item);
          }
        }
      }
    };
    removeFromQueue = (item) => {
      if (!setOfQueuedItems.has(item))
        return;
      setOfQueuedItems.delete(item);
      const index = findIndex_default(queue, (o3) => o3 === item);
      queue.splice(index, 1);
    };
  }
});

// ../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../node_modules/react-is/cjs/react-is.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        var REACT_FRAGMENT_TYPE = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_OPAQUE_ID_TYPE = 60128;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          REACT_SCOPE_TYPE = symbolFor("react.scope");
          REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment3 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element2;
        exports2.ForwardRef = ForwardRef;
        exports2.Fragment = Fragment3;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal2;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// ../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../node_modules/react-is/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// ../node_modules/shallowequal/index.js
var require_shallowequal = __commonJS({
  "../node_modules/shallowequal/index.js"(exports2, module2) {
    module2.exports = function shallowEqual3(objA, objB, compare, compareContext) {
      var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
      if (ret !== void 0) {
        return !!ret;
      }
      if (objA === objB) {
        return true;
      }
      if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
        return false;
      }
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) {
        return false;
      }
      var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
      for (var idx = 0; idx < keysA.length; idx++) {
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) {
          return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) {
          return false;
        }
      }
      return true;
    };
  }
});

// ../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min(W3) {
  function M4(d3, c3, e2, h4, a4) {
    for (var m3 = 0, b4 = 0, v5 = 0, n3 = 0, q3, g4, x4 = 0, K2 = 0, k4, u3 = k4 = q3 = 0, l4 = 0, r3 = 0, I4 = 0, t3 = 0, B4 = e2.length, J2 = B4 - 1, y3, f3 = "", p3 = "", F4 = "", G4 = "", C2; l4 < B4; ) {
      g4 = e2.charCodeAt(l4);
      l4 === J2 && b4 + n3 + v5 + m3 !== 0 && (b4 !== 0 && (g4 = b4 === 47 ? 10 : 47), n3 = v5 = m3 = 0, B4++, J2++);
      if (b4 + n3 + v5 + m3 === 0) {
        if (l4 === J2 && (0 < r3 && (f3 = f3.replace(N3, "")), 0 < f3.trim().length)) {
          switch (g4) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f3 += e2.charAt(l4);
          }
          g4 = 59;
        }
        switch (g4) {
          case 123:
            f3 = f3.trim();
            q3 = f3.charCodeAt(0);
            k4 = 1;
            for (t3 = ++l4; l4 < B4; ) {
              switch (g4 = e2.charCodeAt(l4)) {
                case 123:
                  k4++;
                  break;
                case 125:
                  k4--;
                  break;
                case 47:
                  switch (g4 = e2.charCodeAt(l4 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u3 = l4 + 1; u3 < J2; ++u3) {
                          switch (e2.charCodeAt(u3)) {
                            case 47:
                              if (g4 === 42 && e2.charCodeAt(u3 - 1) === 42 && l4 + 2 !== u3) {
                                l4 = u3 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g4 === 47) {
                                l4 = u3 + 1;
                                break a;
                              }
                          }
                        }
                        l4 = u3;
                      }
                  }
                  break;
                case 91:
                  g4++;
                case 40:
                  g4++;
                case 34:
                case 39:
                  for (; l4++ < J2 && e2.charCodeAt(l4) !== g4; ) {
                  }
              }
              if (k4 === 0)
                break;
              l4++;
            }
            k4 = e2.substring(t3, l4);
            q3 === 0 && (q3 = (f3 = f3.replace(ca, "").trim()).charCodeAt(0));
            switch (q3) {
              case 64:
                0 < r3 && (f3 = f3.replace(N3, ""));
                g4 = f3.charCodeAt(1);
                switch (g4) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r3 = c3;
                    break;
                  default:
                    r3 = O4;
                }
                k4 = M4(c3, r3, k4, g4, a4 + 1);
                t3 = k4.length;
                0 < A3 && (r3 = X4(O4, f3, I4), C2 = H4(3, k4, r3, c3, D3, z3, t3, g4, a4, h4), f3 = r3.join(""), C2 !== void 0 && (t3 = (k4 = C2.trim()).length) === 0 && (g4 = 0, k4 = ""));
                if (0 < t3)
                  switch (g4) {
                    case 115:
                      f3 = f3.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k4 = f3 + "{" + k4 + "}";
                      break;
                    case 107:
                      f3 = f3.replace(fa, "$1 $2");
                      k4 = f3 + "{" + k4 + "}";
                      k4 = w4 === 1 || w4 === 2 && L3("@" + k4, 3) ? "@-webkit-" + k4 + "@" + k4 : "@" + k4;
                      break;
                    default:
                      k4 = f3 + k4, h4 === 112 && (k4 = (p3 += k4, ""));
                  }
                else
                  k4 = "";
                break;
              default:
                k4 = M4(c3, X4(c3, f3, I4), k4, h4, a4 + 1);
            }
            F4 += k4;
            k4 = I4 = r3 = u3 = q3 = 0;
            f3 = "";
            g4 = e2.charCodeAt(++l4);
            break;
          case 125:
          case 59:
            f3 = (0 < r3 ? f3.replace(N3, "") : f3).trim();
            if (1 < (t3 = f3.length))
              switch (u3 === 0 && (q3 = f3.charCodeAt(0), q3 === 45 || 96 < q3 && 123 > q3) && (t3 = (f3 = f3.replace(" ", ":")).length), 0 < A3 && (C2 = H4(1, f3, c3, d3, D3, z3, p3.length, h4, a4, h4)) !== void 0 && (t3 = (f3 = C2.trim()).length) === 0 && (f3 = "\0\0"), q3 = f3.charCodeAt(0), g4 = f3.charCodeAt(1), q3) {
                case 0:
                  break;
                case 64:
                  if (g4 === 105 || g4 === 99) {
                    G4 += f3 + e2.charAt(l4);
                    break;
                  }
                default:
                  f3.charCodeAt(t3 - 1) !== 58 && (p3 += P3(f3, q3, g4, f3.charCodeAt(2)));
              }
            I4 = r3 = u3 = q3 = 0;
            f3 = "";
            g4 = e2.charCodeAt(++l4);
        }
      }
      switch (g4) {
        case 13:
        case 10:
          b4 === 47 ? b4 = 0 : 1 + q3 === 0 && h4 !== 107 && 0 < f3.length && (r3 = 1, f3 += "\0");
          0 < A3 * Y3 && H4(0, f3, c3, d3, D3, z3, p3.length, h4, a4, h4);
          z3 = 1;
          D3++;
          break;
        case 59:
        case 125:
          if (b4 + n3 + v5 + m3 === 0) {
            z3++;
            break;
          }
        default:
          z3++;
          y3 = e2.charAt(l4);
          switch (g4) {
            case 9:
            case 32:
              if (n3 + m3 + b4 === 0)
                switch (x4) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y3 = "";
                    break;
                  default:
                    g4 !== 32 && (y3 = " ");
                }
              break;
            case 0:
              y3 = "\\0";
              break;
            case 12:
              y3 = "\\f";
              break;
            case 11:
              y3 = "\\v";
              break;
            case 38:
              n3 + b4 + m3 === 0 && (r3 = I4 = 1, y3 = "\f" + y3);
              break;
            case 108:
              if (n3 + b4 + m3 + E4 === 0 && 0 < u3)
                switch (l4 - u3) {
                  case 2:
                    x4 === 112 && e2.charCodeAt(l4 - 3) === 58 && (E4 = x4);
                  case 8:
                    K2 === 111 && (E4 = K2);
                }
              break;
            case 58:
              n3 + b4 + m3 === 0 && (u3 = l4);
              break;
            case 44:
              b4 + v5 + n3 + m3 === 0 && (r3 = 1, y3 += "\r");
              break;
            case 34:
            case 39:
              b4 === 0 && (n3 = n3 === g4 ? 0 : n3 === 0 ? g4 : n3);
              break;
            case 91:
              n3 + b4 + v5 === 0 && m3++;
              break;
            case 93:
              n3 + b4 + v5 === 0 && m3--;
              break;
            case 41:
              n3 + b4 + m3 === 0 && v5--;
              break;
            case 40:
              if (n3 + b4 + m3 === 0) {
                if (q3 === 0)
                  switch (2 * x4 + 3 * K2) {
                    case 533:
                      break;
                    default:
                      q3 = 1;
                  }
                v5++;
              }
              break;
            case 64:
              b4 + v5 + n3 + m3 + u3 + k4 === 0 && (k4 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n3 + m3 + v5))
                switch (b4) {
                  case 0:
                    switch (2 * g4 + 3 * e2.charCodeAt(l4 + 1)) {
                      case 235:
                        b4 = 47;
                        break;
                      case 220:
                        t3 = l4, b4 = 42;
                    }
                    break;
                  case 42:
                    g4 === 47 && x4 === 42 && t3 + 2 !== l4 && (e2.charCodeAt(t3 + 2) === 33 && (p3 += e2.substring(t3, l4 + 1)), y3 = "", b4 = 0);
                }
          }
          b4 === 0 && (f3 += y3);
      }
      K2 = x4;
      x4 = g4;
      l4++;
    }
    t3 = p3.length;
    if (0 < t3) {
      r3 = c3;
      if (0 < A3 && (C2 = H4(2, p3, r3, d3, D3, z3, t3, h4, a4, h4), C2 !== void 0 && (p3 = C2).length === 0))
        return G4 + p3 + F4;
      p3 = r3.join(",") + "{" + p3 + "}";
      if (w4 * E4 !== 0) {
        w4 !== 2 || L3(p3, 2) || (E4 = 0);
        switch (E4) {
          case 111:
            p3 = p3.replace(ha, ":-moz-$1") + p3;
            break;
          case 112:
            p3 = p3.replace(Q3, "::-webkit-input-$1") + p3.replace(Q3, "::-moz-$1") + p3.replace(Q3, ":-ms-input-$1") + p3;
        }
        E4 = 0;
      }
    }
    return G4 + p3 + F4;
  }
  function X4(d3, c3, e2) {
    var h4 = c3.trim().split(ia);
    c3 = h4;
    var a4 = h4.length, m3 = d3.length;
    switch (m3) {
      case 0:
      case 1:
        var b4 = 0;
        for (d3 = m3 === 0 ? "" : d3[0] + " "; b4 < a4; ++b4) {
          c3[b4] = Z3(d3, c3[b4], e2).trim();
        }
        break;
      default:
        var v5 = b4 = 0;
        for (c3 = []; b4 < a4; ++b4) {
          for (var n3 = 0; n3 < m3; ++n3) {
            c3[v5++] = Z3(d3[n3] + " ", h4[b4], e2).trim();
          }
        }
    }
    return c3;
  }
  function Z3(d3, c3, e2) {
    var h4 = c3.charCodeAt(0);
    33 > h4 && (h4 = (c3 = c3.trim()).charCodeAt(0));
    switch (h4) {
      case 38:
        return c3.replace(F3, "$1" + d3.trim());
      case 58:
        return d3.trim() + c3.replace(F3, "$1" + d3.trim());
      default:
        if (0 < 1 * e2 && 0 < c3.indexOf("\f"))
          return c3.replace(F3, (d3.charCodeAt(0) === 58 ? "" : "$1") + d3.trim());
    }
    return d3 + c3;
  }
  function P3(d3, c3, e2, h4) {
    var a4 = d3 + ";", m3 = 2 * c3 + 3 * e2 + 4 * h4;
    if (m3 === 944) {
      d3 = a4.indexOf(":", 9) + 1;
      var b4 = a4.substring(d3, a4.length - 1).trim();
      b4 = a4.substring(0, d3).trim() + b4 + ";";
      return w4 === 1 || w4 === 2 && L3(b4, 1) ? "-webkit-" + b4 + b4 : b4;
    }
    if (w4 === 0 || w4 === 2 && !L3(a4, 1))
      return a4;
    switch (m3) {
      case 1015:
        return a4.charCodeAt(10) === 97 ? "-webkit-" + a4 + a4 : a4;
      case 951:
        return a4.charCodeAt(3) === 116 ? "-webkit-" + a4 + a4 : a4;
      case 963:
        return a4.charCodeAt(5) === 110 ? "-webkit-" + a4 + a4 : a4;
      case 1009:
        if (a4.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a4 + a4;
      case 978:
        return "-webkit-" + a4 + "-moz-" + a4 + a4;
      case 1019:
      case 983:
        return "-webkit-" + a4 + "-moz-" + a4 + "-ms-" + a4 + a4;
      case 883:
        if (a4.charCodeAt(8) === 45)
          return "-webkit-" + a4 + a4;
        if (0 < a4.indexOf("image-set(", 11))
          return a4.replace(ja, "$1-webkit-$2") + a4;
        break;
      case 932:
        if (a4.charCodeAt(4) === 45)
          switch (a4.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a4.replace("-grow", "") + "-webkit-" + a4 + "-ms-" + a4.replace("grow", "positive") + a4;
            case 115:
              return "-webkit-" + a4 + "-ms-" + a4.replace("shrink", "negative") + a4;
            case 98:
              return "-webkit-" + a4 + "-ms-" + a4.replace("basis", "preferred-size") + a4;
          }
        return "-webkit-" + a4 + "-ms-" + a4 + a4;
      case 964:
        return "-webkit-" + a4 + "-ms-flex-" + a4 + a4;
      case 1023:
        if (a4.charCodeAt(8) !== 99)
          break;
        b4 = a4.substring(a4.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b4 + "-webkit-" + a4 + "-ms-flex-pack" + b4 + a4;
      case 1005:
        return ka.test(a4) ? a4.replace(aa, ":-webkit-") + a4.replace(aa, ":-moz-") + a4 : a4;
      case 1e3:
        b4 = a4.substring(13).trim();
        c3 = b4.indexOf("-") + 1;
        switch (b4.charCodeAt(0) + b4.charCodeAt(c3)) {
          case 226:
            b4 = a4.replace(G3, "tb");
            break;
          case 232:
            b4 = a4.replace(G3, "tb-rl");
            break;
          case 220:
            b4 = a4.replace(G3, "lr");
            break;
          default:
            return a4;
        }
        return "-webkit-" + a4 + "-ms-" + b4 + a4;
      case 1017:
        if (a4.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c3 = (a4 = d3).length - 10;
        b4 = (a4.charCodeAt(c3) === 33 ? a4.substring(0, c3) : a4).substring(d3.indexOf(":", 7) + 1).trim();
        switch (m3 = b4.charCodeAt(0) + (b4.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b4.charCodeAt(8))
              break;
          case 115:
            a4 = a4.replace(b4, "-webkit-" + b4) + ";" + a4;
            break;
          case 207:
          case 102:
            a4 = a4.replace(b4, "-webkit-" + (102 < m3 ? "inline-" : "") + "box") + ";" + a4.replace(b4, "-webkit-" + b4) + ";" + a4.replace(b4, "-ms-" + b4 + "box") + ";" + a4;
        }
        return a4 + ";";
      case 938:
        if (a4.charCodeAt(5) === 45)
          switch (a4.charCodeAt(6)) {
            case 105:
              return b4 = a4.replace("-items", ""), "-webkit-" + a4 + "-webkit-box-" + b4 + "-ms-flex-" + b4 + a4;
            case 115:
              return "-webkit-" + a4 + "-ms-flex-item-" + a4.replace(ba, "") + a4;
            default:
              return "-webkit-" + a4 + "-ms-flex-line-pack" + a4.replace("align-content", "").replace(ba, "") + a4;
          }
        break;
      case 973:
      case 989:
        if (a4.charCodeAt(3) !== 45 || a4.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d3) === true)
          return (b4 = d3.substring(d3.indexOf(":") + 1)).charCodeAt(0) === 115 ? P3(d3.replace("stretch", "fill-available"), c3, e2, h4).replace(":fill-available", ":stretch") : a4.replace(b4, "-webkit-" + b4) + a4.replace(b4, "-moz-" + b4.replace("fill-", "")) + a4;
        break;
      case 962:
        if (a4 = "-webkit-" + a4 + (a4.charCodeAt(5) === 102 ? "-ms-" + a4 : "") + a4, e2 + h4 === 211 && a4.charCodeAt(13) === 105 && 0 < a4.indexOf("transform", 10))
          return a4.substring(0, a4.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a4;
    }
    return a4;
  }
  function L3(d3, c3) {
    var e2 = d3.indexOf(c3 === 1 ? ":" : "{"), h4 = d3.substring(0, c3 !== 3 ? e2 : 10);
    e2 = d3.substring(e2 + 1, d3.length - 1);
    return R4(c3 !== 2 ? h4 : h4.replace(na, "$1"), e2, c3);
  }
  function ea(d3, c3) {
    var e2 = P3(c3, c3.charCodeAt(0), c3.charCodeAt(1), c3.charCodeAt(2));
    return e2 !== c3 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c3 + ")";
  }
  function H4(d3, c3, e2, h4, a4, m3, b4, v5, n3, q3) {
    for (var g4 = 0, x4 = c3, w5; g4 < A3; ++g4) {
      switch (w5 = S4[g4].call(B3, d3, x4, e2, h4, a4, m3, b4, v5, n3, q3)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x4 = w5;
      }
    }
    if (x4 !== c3)
      return x4;
  }
  function T3(d3) {
    switch (d3) {
      case void 0:
      case null:
        A3 = S4.length = 0;
        break;
      default:
        if (typeof d3 === "function")
          S4[A3++] = d3;
        else if (typeof d3 === "object")
          for (var c3 = 0, e2 = d3.length; c3 < e2; ++c3) {
            T3(d3[c3]);
          }
        else
          Y3 = !!d3 | 0;
    }
    return T3;
  }
  function U4(d3) {
    d3 = d3.prefix;
    d3 !== void 0 && (R4 = null, d3 ? typeof d3 !== "function" ? w4 = 1 : (w4 = 2, R4 = d3) : w4 = 0);
    return U4;
  }
  function B3(d3, c3) {
    var e2 = d3;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V4 = e2;
    e2 = [V4];
    if (0 < A3) {
      var h4 = H4(-1, c3, e2, e2, D3, z3, 0, 0, 0, 0);
      h4 !== void 0 && typeof h4 === "string" && (c3 = h4);
    }
    var a4 = M4(O4, e2, c3, 0, 0);
    0 < A3 && (h4 = H4(-2, a4, e2, e2, D3, z3, a4.length, 0, 0, 0), h4 !== void 0 && (a4 = h4));
    V4 = "";
    E4 = 0;
    z3 = D3 = 1;
    return a4;
  }
  var ca = /^\0+/g, N3 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F3 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q3 = /::(place)/g, ha = /:(read-only)/g, G3 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z3 = 1, D3 = 1, E4 = 0, w4 = 1, O4 = [], S4 = [], A3 = 0, R4 = null, Y3 = 0, V4 = "";
  B3.use = T3;
  B3.set = U4;
  W3 !== void 0 && U4(W3);
  return B3;
}
var stylis_browser_esm_default;
var init_stylis_browser_esm = __esm({
  "../node_modules/@emotion/stylis/dist/stylis.browser.esm.js"() {
    stylis_browser_esm_default = stylis_min;
  }
});

// ../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys, unitless_browser_esm_default;
var init_unitless_browser_esm = __esm({
  "../node_modules/@emotion/unitless/dist/unitless.browser.esm.js"() {
    unitlessKeys = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    };
    unitless_browser_esm_default = unitlessKeys;
  }
});

// ../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.dev.js
var require_emotion_memoize_cjs_dev = __commonJS({
  "../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.dev.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    function memoize2(fn2) {
      var cache3 = Object.create(null);
      return function(arg) {
        if (cache3[arg] === void 0)
          cache3[arg] = fn2(arg);
        return cache3[arg];
      };
    }
    exports2.default = memoize2;
  }
});

// ../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.js
var require_emotion_memoize_cjs = __commonJS({
  "../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_emotion_memoize_cjs_dev();
    }
  }
});

// ../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.dev.js
var require_emotion_is_prop_valid_cjs_dev = __commonJS({
  "../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.dev.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var memoize2 = require_emotion_memoize_cjs();
    function _interopDefault(e2) {
      return e2 && e2.__esModule ? e2 : { "default": e2 };
    }
    var memoize__default = /* @__PURE__ */ _interopDefault(memoize2);
    var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    var isPropValid = /* @__PURE__ */ memoize__default["default"](function(prop) {
      return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
    });
    exports2.default = isPropValid;
  }
});

// ../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js
var require_emotion_is_prop_valid_cjs = __commonJS({
  "../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_emotion_is_prop_valid_cjs_dev();
    }
  }
});

// ../node_modules/hoist-non-react-statics/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development2 = __commonJS({
  "../node_modules/hoist-non-react-statics/node_modules/react-is/cjs/react-is.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment3 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports2.AsyncMode = AsyncMode;
        exports2.ConcurrentMode = ConcurrentMode;
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element2;
        exports2.ForwardRef = ForwardRef;
        exports2.Fragment = Fragment3;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal2;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// ../node_modules/hoist-non-react-statics/node_modules/react-is/index.js
var require_react_is2 = __commonJS({
  "../node_modules/hoist-non-react-statics/node_modules/react-is/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development2();
    }
  }
});

// ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var require_hoist_non_react_statics_cjs = __commonJS({
  "../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(exports2, module2) {
    "use strict";
    var reactIs = require_react_is2();
    var REACT_STATICS = {
      childContextTypes: true,
      contextType: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromError: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var FORWARD_REF_STATICS = {
      "$$typeof": true,
      render: true,
      defaultProps: true,
      displayName: true,
      propTypes: true
    };
    var MEMO_STATICS = {
      "$$typeof": true,
      compare: true,
      defaultProps: true,
      displayName: true,
      propTypes: true,
      type: true
    };
    var TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
      if (reactIs.isMemo(component)) {
        return MEMO_STATICS;
      }
      return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
    }
    var defineProperty2 = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = Object.prototype;
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);
          if (inheritedComponent && inheritedComponent !== objectPrototype) {
            hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
          }
        }
        var keys3 = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) {
          keys3 = keys3.concat(getOwnPropertySymbols(sourceComponent));
        }
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for (var i3 = 0; i3 < keys3.length; ++i3) {
          var key = keys3[i3];
          if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
            try {
              defineProperty2(targetComponent, key, descriptor);
            } catch (e2) {
            }
          }
        }
      }
      return targetComponent;
    }
    module2.exports = hoistNonReactStatics;
  }
});

// ../node_modules/styled-components/dist/styled-components.browser.esm.js
function v2() {
  return (v2 = Object.assign || function(e2) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = arguments[t3];
      for (var r3 in n3)
        Object.prototype.hasOwnProperty.call(n3, r3) && (e2[r3] = n3[r3]);
    }
    return e2;
  }).apply(this, arguments);
}
function b2(e2) {
  return typeof e2 == "function";
}
function _2(e2) {
  return typeof e2 == "string" && e2 || e2.displayName || e2.name || "Component";
}
function N(e2) {
  return e2 && typeof e2.styledComponentId == "string";
}
function D2() {
  for (var e2 = arguments.length <= 0 ? void 0 : arguments[0], t3 = [], n3 = 1, r3 = arguments.length; n3 < r3; n3 += 1)
    t3.push(n3 < 0 || arguments.length <= n3 ? void 0 : arguments[n3]);
  return t3.forEach(function(t4) {
    e2 = e2.replace(/%[a-z]/, t4);
  }), e2;
}
function j2(e2) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  throw false ? new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n3.length > 0 ? " Args: " + n3.join(", ") : "")) : new Error(D2.apply(void 0, [R2[e2]].concat(n3)).trim());
}
function ee(e2) {
  var t3, n3 = "";
  for (t3 = Math.abs(e2); t3 > 52; t3 = t3 / 52 | 0)
    n3 = Q2(t3 % 52) + n3;
  return (Q2(t3 % 52) + n3).replace(K, "$1-$2");
}
function re(e2) {
  for (var t3 = 0; t3 < e2.length; t3 += 1) {
    var n3 = e2[t3];
    if (b2(n3) && !N(n3))
      return false;
  }
  return true;
}
function ce(e2) {
  var t3, n3, r3, o3, s3 = e2 === void 0 ? E2 : e2, i3 = s3.options, a4 = i3 === void 0 ? E2 : i3, c3 = s3.plugins, u3 = c3 === void 0 ? w2 : c3, l4 = new stylis_browser_esm_default(a4), d3 = [], h4 = function(e3) {
    function t4(t5) {
      if (t5)
        try {
          e3(t5 + "}");
        } catch (e4) {
        }
    }
    return function(n4, r4, o4, s4, i4, a5, c4, u4, l5, d4) {
      switch (n4) {
        case 1:
          if (l5 === 0 && r4.charCodeAt(0) === 64)
            return e3(r4 + ";"), "";
          break;
        case 2:
          if (u4 === 0)
            return r4 + "/*|*/";
          break;
        case 3:
          switch (u4) {
            case 102:
            case 112:
              return e3(o4[0] + r4), "";
            default:
              return r4 + (d4 === 0 ? "/*|*/" : "");
          }
        case -2:
          r4.split("/*|*/}").forEach(t4);
      }
    };
  }(function(e3) {
    d3.push(e3);
  }), f3 = function(e3, r4, s4) {
    return r4 === 0 && ae.indexOf(s4[n3.length]) !== -1 || s4.match(o3) ? e3 : "." + t3;
  };
  function m3(e3, s4, i4, a5) {
    a5 === void 0 && (a5 = "&");
    var c4 = e3.replace(ie, ""), u4 = s4 && i4 ? i4 + " " + s4 + " { " + c4 + " }" : c4;
    return t3 = a5, n3 = s4, r3 = new RegExp("\\" + n3 + "\\b", "g"), o3 = new RegExp("(\\" + n3 + "\\b){2,}"), l4(i4 || !s4 ? "" : s4, u4);
  }
  return l4.use([].concat(u3, [function(e3, t4, o4) {
    e3 === 2 && o4.length && o4[0].lastIndexOf(n3) > 0 && (o4[0] = o4[0].replace(r3, f3));
  }, h4, function(e3) {
    if (e3 === -2) {
      var t4 = d3;
      return d3 = [], t4;
    }
  }])), m3.hash = u3.length ? u3.reduce(function(e3, t4) {
    return t4.name || j2(15), te(e3, t4.name);
  }, 5381).toString() : "", m3;
}
function fe() {
  return (0, import_react2.useContext)(ue) || he;
}
function me() {
  return (0, import_react2.useContext)(de) || pe;
}
function ye(e2) {
  var t3 = (0, import_react2.useState)(e2.stylisPlugins), n3 = t3[0], s3 = t3[1], c3 = fe(), u3 = (0, import_react2.useMemo)(function() {
    var t4 = c3;
    return e2.sheet ? t4 = e2.sheet : e2.target && (t4 = t4.reconstructWithOptions({ target: e2.target }, false)), e2.disableCSSOMInjection && (t4 = t4.reconstructWithOptions({ useCSSOMInjection: false })), t4;
  }, [e2.disableCSSOMInjection, e2.sheet, e2.target]), l4 = (0, import_react2.useMemo)(function() {
    return ce({ options: { prefix: !e2.disableVendorPrefixes }, plugins: n3 });
  }, [e2.disableVendorPrefixes, n3]);
  return (0, import_react2.useEffect)(function() {
    (0, import_shallowequal.default)(n3, e2.stylisPlugins) || s3(e2.stylisPlugins);
  }, [e2.stylisPlugins]), import_react2.default.createElement(ue.Provider, { value: u3 }, import_react2.default.createElement(de.Provider, { value: l4 }, true ? import_react2.default.Children.only(e2.children) : e2.children));
}
function be(e2) {
  return ge.test(e2) ? e2.replace(Se, Ee).replace(we, "-ms-") : e2;
}
function Ne(e2, n3, r3, o3) {
  if (Array.isArray(e2)) {
    for (var s3, i3 = [], a4 = 0, c3 = e2.length; a4 < c3; a4 += 1)
      (s3 = Ne(e2[a4], n3, r3, o3)) !== "" && (Array.isArray(s3) ? i3.push.apply(i3, s3) : i3.push(s3));
    return i3;
  }
  if (_e(e2))
    return "";
  if (N(e2))
    return "." + e2.styledComponentId;
  if (b2(e2)) {
    if (typeof (l4 = e2) != "function" || l4.prototype && l4.prototype.isReactComponent || !n3)
      return e2;
    var u3 = e2(n3);
    return (0, import_react_is.isElement)(u3) && console.warn(_2(e2) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Ne(u3, n3, r3, o3);
  }
  var l4;
  return e2 instanceof ve ? r3 ? (e2.inject(r3, o3), e2.getName(o3)) : e2 : S2(e2) ? function e3(t3, n4) {
    var r4, o4, s4 = [];
    for (var i4 in t3)
      t3.hasOwnProperty(i4) && !_e(t3[i4]) && (Array.isArray(t3[i4]) && t3[i4].isCss || b2(t3[i4]) ? s4.push(be(i4) + ":", t3[i4], ";") : S2(t3[i4]) ? s4.push.apply(s4, e3(t3[i4], i4)) : s4.push(be(i4) + ": " + (r4 = i4, (o4 = t3[i4]) == null || typeof o4 == "boolean" || o4 === "" ? "" : typeof o4 != "number" || o4 === 0 || r4 in unitless_browser_esm_default ? String(o4).trim() : o4 + "px") + ";"));
    return n4 ? [n4 + " {"].concat(s4, ["}"]) : s4;
  }(e2) : e2.toString();
}
function Ce(e2) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  return b2(e2) || S2(e2) ? Ae(Ne(g2(w2, [e2].concat(n3)))) : n3.length === 0 && e2.length === 1 && typeof e2[0] == "string" ? e2 : Ae(Ne(g2(e2, n3)));
}
function Te(e2) {
  return e2.replace(De, "-").replace(je, "");
}
function ke(e2) {
  return typeof e2 == "string" && e2.charAt(0) === e2.charAt(0).toLowerCase();
}
function ze(e2, t3, n3) {
  var r3 = e2[n3];
  Ve(t3) && Ve(r3) ? Me(r3, t3) : e2[n3] = t3;
}
function Me(e2) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  for (var o3 = 0, s3 = n3; o3 < s3.length; o3++) {
    var i3 = s3[o3];
    if (Ve(i3))
      for (var a4 in i3)
        Be(a4) && ze(e2, i3[a4], a4);
  }
  return e2;
}
function qe(e2, t3, n3) {
  var o3 = N(e2), i3 = !ke(e2), a4 = t3.attrs, c3 = a4 === void 0 ? w2 : a4, d3 = t3.componentId, h4 = d3 === void 0 ? function(e3, t4) {
    var n4 = typeof e3 != "string" ? "sc" : Te(e3);
    Ye[n4] = (Ye[n4] || 0) + 1;
    var r3 = n4 + "-" + xe("5.3.5" + n4 + Ye[n4]);
    return t4 ? t4 + "-" + r3 : r3;
  }(t3.displayName, t3.parentComponentId) : d3, p3 = t3.displayName, f3 = p3 === void 0 ? function(e3) {
    return ke(e3) ? "styled." + e3 : "Styled(" + _2(e3) + ")";
  }(e2) : p3, g4 = t3.displayName && t3.componentId ? Te(t3.displayName) + "-" + t3.componentId : t3.componentId || h4, S4 = o3 && e2.attrs ? Array.prototype.concat(e2.attrs, c3).filter(Boolean) : c3, A3 = t3.shouldForwardProp;
  o3 && e2.shouldForwardProp && (A3 = t3.shouldForwardProp ? function(n4, r3, o4) {
    return e2.shouldForwardProp(n4, r3, o4) && t3.shouldForwardProp(n4, r3, o4);
  } : e2.shouldForwardProp);
  var C2, I4 = new se(n3, g4, o3 ? e2.componentStyle : void 0), P3 = I4.isStatic && c3.length === 0, O4 = function(e3, t4) {
    return function(e4, t5, n4, r3) {
      var o4 = e4.attrs, i4 = e4.componentStyle, a5 = e4.defaultProps, c4 = e4.foldedComponentIds, d4 = e4.shouldForwardProp, h5 = e4.styledComponentId, p4 = e4.target;
      (0, import_react2.useDebugValue)(h5);
      var f4 = function(e5, t6, n5) {
        e5 === void 0 && (e5 = E2);
        var r4 = v2({}, t6, { theme: e5 }), o5 = {};
        return n5.forEach(function(e6) {
          var t7, n6, s3, i5 = e6;
          for (t7 in b2(i5) && (i5 = i5(r4)), i5)
            r4[t7] = o5[t7] = t7 === "className" ? (n6 = o5[t7], s3 = i5[t7], n6 && s3 ? n6 + " " + s3 : n6 || s3) : i5[t7];
        }), [r4, o5];
      }(Re(t5, (0, import_react2.useContext)(Ge), a5) || E2, t5, o4), y3 = f4[0], g5 = f4[1], S5 = function(e5, t6, n5, r4) {
        var o5 = fe(), s3 = me(), i5 = t6 ? e5.generateAndInjectStyles(E2, o5, s3) : e5.generateAndInjectStyles(n5, o5, s3);
        return (0, import_react2.useDebugValue)(i5), !t6 && r4 && r4(i5), i5;
      }(i4, r3, y3, true ? e4.warnTooManyClasses : void 0), w4 = n4, _3 = g5.$as || t5.$as || g5.as || t5.as || p4, N3 = ke(_3), A4 = g5 !== t5 ? v2({}, t5, {}, g5) : t5, C3 = {};
      for (var I5 in A4)
        I5[0] !== "$" && I5 !== "as" && (I5 === "forwardedAs" ? C3.as = A4[I5] : (d4 ? d4(I5, import_is_prop_valid.default, _3) : !N3 || (0, import_is_prop_valid.default)(I5)) && (C3[I5] = A4[I5]));
      return t5.style && g5.style !== t5.style && (C3.style = v2({}, t5.style, {}, g5.style)), C3.className = Array.prototype.concat(c4, h5, S5 !== h5 ? S5 : null, t5.className, g5.className).filter(Boolean).join(" "), C3.ref = w4, (0, import_react2.createElement)(_3, C3);
    }(C2, e3, t4, P3);
  };
  return O4.displayName = f3, (C2 = import_react2.default.forwardRef(O4)).attrs = S4, C2.componentStyle = I4, C2.displayName = f3, C2.shouldForwardProp = A3, C2.foldedComponentIds = o3 ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w2, C2.styledComponentId = g4, C2.target = o3 ? e2.target : e2, C2.withComponent = function(e3) {
    var r3 = t3.componentId, o4 = function(e4, t4) {
      if (e4 == null)
        return {};
      var n4, r4, o5 = {}, s4 = Object.keys(e4);
      for (r4 = 0; r4 < s4.length; r4++)
        n4 = s4[r4], t4.indexOf(n4) >= 0 || (o5[n4] = e4[n4]);
      return o5;
    }(t3, ["componentId"]), s3 = r3 && r3 + "-" + (ke(e3) ? e3 : Te(_2(e3)));
    return qe(e3, v2({}, o4, { attrs: S4, componentId: s3 }), n3);
  }, Object.defineProperty(C2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t4) {
    this._foldedDefaultProps = o3 ? Me({}, e2.defaultProps, t4) : t4;
  } }), Oe(f3, g4), C2.warnTooManyClasses = function(e3, t4) {
    var n4 = {}, r3 = false;
    return function(o4) {
      if (!r3 && (n4[o4] = true, Object.keys(n4).length >= 200)) {
        var s3 = t4 ? ' with the id of "' + t4 + '"' : "";
        console.warn("Over 200 classes were generated for component " + e3 + s3 + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r3 = true, n4 = {};
      }
    };
  }(f3, g4), C2.toString = function() {
    return "." + C2.styledComponentId;
  }, i3 && (0, import_hoist_non_react_statics.default)(C2, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), C2;
}
function We(e2) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), o3 = 1; o3 < t3; o3++)
    n3[o3 - 1] = arguments[o3];
  var i3 = Ce.apply(void 0, [e2].concat(n3)), a4 = "sc-global-" + xe(JSON.stringify(i3)), u3 = new $e(i3, a4);
  function l4(e3) {
    var t4 = fe(), n4 = me(), o4 = (0, import_react2.useContext)(Ge), l5 = (0, import_react2.useRef)(t4.allocateGSInstance(a4)).current;
    return import_react2.default.Children.count(e3.children) && console.warn("The global style component " + a4 + " was given child JSX. createGlobalStyle does not render children."), i3.some(function(e4) {
      return typeof e4 == "string" && e4.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t4.server && h4(l5, e3, t4, o4, n4), (0, import_react2.useLayoutEffect)(function() {
      if (!t4.server)
        return h4(l5, e3, t4, o4, n4), function() {
          return u3.removeStyles(l5, t4);
        };
    }, [l5, e3, t4, o4, n4]), null;
  }
  function h4(e3, t4, n4, r3, o4) {
    if (u3.isStatic)
      u3.renderStyles(e3, O2, n4, o4);
    else {
      var s3 = v2({}, t4, { theme: Re(t4, r3, l4.defaultProps) });
      u3.renderStyles(e3, s3, n4, o4);
    }
  }
  return Oe(a4), import_react2.default.memo(l4);
}
var import_react_is, import_react2, import_shallowequal, import_is_prop_valid, import_hoist_non_react_statics, g2, S2, w2, E2, A2, I2, P2, O2, R2, T, x2, k2, V2, B2, z2, M2, G2, L2, F2, Y2, q2, H2, $, W2, U2, J, X2, Z2, K, Q2, te, ne, oe, se, ie, ae, ue, le, de, he, pe, ve, ge, Se, we, Ee, _e, Ae, Ie, Pe, Oe, Re, De, je, xe, Ve, Be, Ge, Le, Ye, He, $e, Je, styled_components_browser_esm_default;
var init_styled_components_browser_esm = __esm({
  "../node_modules/styled-components/dist/styled-components.browser.esm.js"() {
    import_react_is = __toModule(require_react_is());
    import_react2 = __toModule(require_react());
    import_shallowequal = __toModule(require_shallowequal());
    init_stylis_browser_esm();
    init_unitless_browser_esm();
    import_is_prop_valid = __toModule(require_emotion_is_prop_valid_cjs());
    import_hoist_non_react_statics = __toModule(require_hoist_non_react_statics_cjs());
    g2 = function(e2, t3) {
      for (var n3 = [e2[0]], r3 = 0, o3 = t3.length; r3 < o3; r3 += 1)
        n3.push(t3[r3], e2[r3 + 1]);
      return n3;
    };
    S2 = function(t3) {
      return t3 !== null && typeof t3 == "object" && (t3.toString ? t3.toString() : Object.prototype.toString.call(t3)) === "[object Object]" && !(0, import_react_is.typeOf)(t3);
    };
    w2 = Object.freeze([]);
    E2 = Object.freeze({});
    A2 = typeof process != "undefined" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled";
    I2 = typeof window != "undefined" && "HTMLElement" in window;
    P2 = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : true);
    O2 = {};
    R2 = true ? { 1: "Cannot create styled-component for component: %s.\n\n", 2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n", 3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n", 4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n", 5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n", 6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n", 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: 'ThemeProvider: Please make your "theme" prop an object.\n\n', 9: "Missing document `<head>`\n\n", 10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n", 11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n", 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n", 14: 'ThemeProvider: "theme" prop is required.\n\n', 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n", 17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n" } : {};
    T = function() {
      function e2(e3) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
      }
      var t3 = e2.prototype;
      return t3.indexOfGroup = function(e3) {
        for (var t4 = 0, n3 = 0; n3 < e3; n3++)
          t4 += this.groupSizes[n3];
        return t4;
      }, t3.insertRules = function(e3, t4) {
        if (e3 >= this.groupSizes.length) {
          for (var n3 = this.groupSizes, r3 = n3.length, o3 = r3; e3 >= o3; )
            (o3 <<= 1) < 0 && j2(16, "" + e3);
          this.groupSizes = new Uint32Array(o3), this.groupSizes.set(n3), this.length = o3;
          for (var s3 = r3; s3 < o3; s3++)
            this.groupSizes[s3] = 0;
        }
        for (var i3 = this.indexOfGroup(e3 + 1), a4 = 0, c3 = t4.length; a4 < c3; a4++)
          this.tag.insertRule(i3, t4[a4]) && (this.groupSizes[e3]++, i3++);
      }, t3.clearGroup = function(e3) {
        if (e3 < this.length) {
          var t4 = this.groupSizes[e3], n3 = this.indexOfGroup(e3), r3 = n3 + t4;
          this.groupSizes[e3] = 0;
          for (var o3 = n3; o3 < r3; o3++)
            this.tag.deleteRule(n3);
        }
      }, t3.getGroup = function(e3) {
        var t4 = "";
        if (e3 >= this.length || this.groupSizes[e3] === 0)
          return t4;
        for (var n3 = this.groupSizes[e3], r3 = this.indexOfGroup(e3), o3 = r3 + n3, s3 = r3; s3 < o3; s3++)
          t4 += this.tag.getRule(s3) + "/*!sc*/\n";
        return t4;
      }, e2;
    }();
    x2 = new Map();
    k2 = new Map();
    V2 = 1;
    B2 = function(e2) {
      if (x2.has(e2))
        return x2.get(e2);
      for (; k2.has(V2); )
        V2++;
      var t3 = V2++;
      return ((0 | t3) < 0 || t3 > 1 << 30) && j2(16, "" + t3), x2.set(e2, t3), k2.set(t3, e2), t3;
    };
    z2 = function(e2) {
      return k2.get(e2);
    };
    M2 = function(e2, t3) {
      t3 >= V2 && (V2 = t3 + 1), x2.set(e2, t3), k2.set(t3, e2);
    };
    G2 = "style[" + A2 + '][data-styled-version="5.3.5"]';
    L2 = new RegExp("^" + A2 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)');
    F2 = function(e2, t3, n3) {
      for (var r3, o3 = n3.split(","), s3 = 0, i3 = o3.length; s3 < i3; s3++)
        (r3 = o3[s3]) && e2.registerName(t3, r3);
    };
    Y2 = function(e2, t3) {
      for (var n3 = (t3.textContent || "").split("/*!sc*/\n"), r3 = [], o3 = 0, s3 = n3.length; o3 < s3; o3++) {
        var i3 = n3[o3].trim();
        if (i3) {
          var a4 = i3.match(L2);
          if (a4) {
            var c3 = 0 | parseInt(a4[1], 10), u3 = a4[2];
            c3 !== 0 && (M2(u3, c3), F2(e2, u3, a4[3]), e2.getTag().insertRules(c3, r3)), r3.length = 0;
          } else
            r3.push(i3);
        }
      }
    };
    q2 = function() {
      return typeof window != "undefined" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
    };
    H2 = function(e2) {
      var t3 = document.head, n3 = e2 || t3, r3 = document.createElement("style"), o3 = function(e3) {
        for (var t4 = e3.childNodes, n4 = t4.length; n4 >= 0; n4--) {
          var r4 = t4[n4];
          if (r4 && r4.nodeType === 1 && r4.hasAttribute(A2))
            return r4;
        }
      }(n3), s3 = o3 !== void 0 ? o3.nextSibling : null;
      r3.setAttribute(A2, "active"), r3.setAttribute("data-styled-version", "5.3.5");
      var i3 = q2();
      return i3 && r3.setAttribute("nonce", i3), n3.insertBefore(r3, s3), r3;
    };
    $ = function() {
      function e2(e3) {
        var t4 = this.element = H2(e3);
        t4.appendChild(document.createTextNode("")), this.sheet = function(e4) {
          if (e4.sheet)
            return e4.sheet;
          for (var t5 = document.styleSheets, n3 = 0, r3 = t5.length; n3 < r3; n3++) {
            var o3 = t5[n3];
            if (o3.ownerNode === e4)
              return o3;
          }
          j2(17);
        }(t4), this.length = 0;
      }
      var t3 = e2.prototype;
      return t3.insertRule = function(e3, t4) {
        try {
          return this.sheet.insertRule(t4, e3), this.length++, true;
        } catch (e4) {
          return false;
        }
      }, t3.deleteRule = function(e3) {
        this.sheet.deleteRule(e3), this.length--;
      }, t3.getRule = function(e3) {
        var t4 = this.sheet.cssRules[e3];
        return t4 !== void 0 && typeof t4.cssText == "string" ? t4.cssText : "";
      }, e2;
    }();
    W2 = function() {
      function e2(e3) {
        var t4 = this.element = H2(e3);
        this.nodes = t4.childNodes, this.length = 0;
      }
      var t3 = e2.prototype;
      return t3.insertRule = function(e3, t4) {
        if (e3 <= this.length && e3 >= 0) {
          var n3 = document.createTextNode(t4), r3 = this.nodes[e3];
          return this.element.insertBefore(n3, r3 || null), this.length++, true;
        }
        return false;
      }, t3.deleteRule = function(e3) {
        this.element.removeChild(this.nodes[e3]), this.length--;
      }, t3.getRule = function(e3) {
        return e3 < this.length ? this.nodes[e3].textContent : "";
      }, e2;
    }();
    U2 = function() {
      function e2(e3) {
        this.rules = [], this.length = 0;
      }
      var t3 = e2.prototype;
      return t3.insertRule = function(e3, t4) {
        return e3 <= this.length && (this.rules.splice(e3, 0, t4), this.length++, true);
      }, t3.deleteRule = function(e3) {
        this.rules.splice(e3, 1), this.length--;
      }, t3.getRule = function(e3) {
        return e3 < this.length ? this.rules[e3] : "";
      }, e2;
    }();
    J = I2;
    X2 = { isServer: !I2, useCSSOMInjection: !P2 };
    Z2 = function() {
      function e2(e3, t4, n3) {
        e3 === void 0 && (e3 = E2), t4 === void 0 && (t4 = {}), this.options = v2({}, X2, {}, e3), this.gs = t4, this.names = new Map(n3), this.server = !!e3.isServer, !this.server && I2 && J && (J = false, function(e4) {
          for (var t5 = document.querySelectorAll(G2), n4 = 0, r3 = t5.length; n4 < r3; n4++) {
            var o3 = t5[n4];
            o3 && o3.getAttribute(A2) !== "active" && (Y2(e4, o3), o3.parentNode && o3.parentNode.removeChild(o3));
          }
        }(this));
      }
      e2.registerId = function(e3) {
        return B2(e3);
      };
      var t3 = e2.prototype;
      return t3.reconstructWithOptions = function(t4, n3) {
        return n3 === void 0 && (n3 = true), new e2(v2({}, this.options, {}, t4), this.gs, n3 && this.names || void 0);
      }, t3.allocateGSInstance = function(e3) {
        return this.gs[e3] = (this.gs[e3] || 0) + 1;
      }, t3.getTag = function() {
        return this.tag || (this.tag = (n3 = (t4 = this.options).isServer, r3 = t4.useCSSOMInjection, o3 = t4.target, e3 = n3 ? new U2(o3) : r3 ? new $(o3) : new W2(o3), new T(e3)));
        var e3, t4, n3, r3, o3;
      }, t3.hasNameForId = function(e3, t4) {
        return this.names.has(e3) && this.names.get(e3).has(t4);
      }, t3.registerName = function(e3, t4) {
        if (B2(e3), this.names.has(e3))
          this.names.get(e3).add(t4);
        else {
          var n3 = new Set();
          n3.add(t4), this.names.set(e3, n3);
        }
      }, t3.insertRules = function(e3, t4, n3) {
        this.registerName(e3, t4), this.getTag().insertRules(B2(e3), n3);
      }, t3.clearNames = function(e3) {
        this.names.has(e3) && this.names.get(e3).clear();
      }, t3.clearRules = function(e3) {
        this.getTag().clearGroup(B2(e3)), this.clearNames(e3);
      }, t3.clearTag = function() {
        this.tag = void 0;
      }, t3.toString = function() {
        return function(e3) {
          for (var t4 = e3.getTag(), n3 = t4.length, r3 = "", o3 = 0; o3 < n3; o3++) {
            var s3 = z2(o3);
            if (s3 !== void 0) {
              var i3 = e3.names.get(s3), a4 = t4.getGroup(o3);
              if (i3 && a4 && i3.size) {
                var c3 = A2 + ".g" + o3 + '[id="' + s3 + '"]', u3 = "";
                i3 !== void 0 && i3.forEach(function(e4) {
                  e4.length > 0 && (u3 += e4 + ",");
                }), r3 += "" + a4 + c3 + '{content:"' + u3 + '"}/*!sc*/\n';
              }
            }
          }
          return r3;
        }(this);
      }, e2;
    }();
    K = /(a)(d)/gi;
    Q2 = function(e2) {
      return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
    };
    te = function(e2, t3) {
      for (var n3 = t3.length; n3; )
        e2 = 33 * e2 ^ t3.charCodeAt(--n3);
      return e2;
    };
    ne = function(e2) {
      return te(5381, e2);
    };
    oe = ne("5.3.5");
    se = function() {
      function e2(e3, t3, n3) {
        this.rules = e3, this.staticRulesId = "", this.isStatic = false, this.componentId = t3, this.baseHash = te(oe, t3), this.baseStyle = n3, Z2.registerId(t3);
      }
      return e2.prototype.generateAndInjectStyles = function(e3, t3, n3) {
        var r3 = this.componentId, o3 = [];
        if (this.baseStyle && o3.push(this.baseStyle.generateAndInjectStyles(e3, t3, n3)), this.isStatic && !n3.hash)
          if (this.staticRulesId && t3.hasNameForId(r3, this.staticRulesId))
            o3.push(this.staticRulesId);
          else {
            var s3 = Ne(this.rules, e3, t3, n3).join(""), i3 = ee(te(this.baseHash, s3) >>> 0);
            if (!t3.hasNameForId(r3, i3)) {
              var a4 = n3(s3, "." + i3, void 0, r3);
              t3.insertRules(r3, i3, a4);
            }
            o3.push(i3), this.staticRulesId = i3;
          }
        else {
          for (var c3 = this.rules.length, u3 = te(this.baseHash, n3.hash), l4 = "", d3 = 0; d3 < c3; d3++) {
            var h4 = this.rules[d3];
            if (typeof h4 == "string")
              l4 += h4, u3 = te(u3, h4 + d3);
            else if (h4) {
              var p3 = Ne(h4, e3, t3, n3), f3 = Array.isArray(p3) ? p3.join("") : p3;
              u3 = te(u3, f3 + d3), l4 += f3;
            }
          }
          if (l4) {
            var m3 = ee(u3 >>> 0);
            if (!t3.hasNameForId(r3, m3)) {
              var y3 = n3(l4, "." + m3, void 0, r3);
              t3.insertRules(r3, m3, y3);
            }
            o3.push(m3);
          }
        }
        return o3.join(" ");
      }, e2;
    }();
    ie = /^\s*\/\/.*$/gm;
    ae = [":", "[", ".", "#"];
    ue = import_react2.default.createContext();
    le = ue.Consumer;
    de = import_react2.default.createContext();
    he = (de.Consumer, new Z2());
    pe = ce();
    ve = function() {
      function e2(e3, t3) {
        var n3 = this;
        this.inject = function(e4, t4) {
          t4 === void 0 && (t4 = pe);
          var r3 = n3.name + t4.hash;
          e4.hasNameForId(n3.id, r3) || e4.insertRules(n3.id, r3, t4(n3.rules, r3, "@keyframes"));
        }, this.toString = function() {
          return j2(12, String(n3.name));
        }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t3;
      }
      return e2.prototype.getName = function(e3) {
        return e3 === void 0 && (e3 = pe), this.name + e3.hash;
      }, e2;
    }();
    ge = /([A-Z])/;
    Se = /([A-Z])/g;
    we = /^ms-/;
    Ee = function(e2) {
      return "-" + e2.toLowerCase();
    };
    _e = function(e2) {
      return e2 == null || e2 === false || e2 === "";
    };
    Ae = function(e2) {
      return Array.isArray(e2) && (e2.isCss = true), e2;
    };
    Ie = /invalid hook call/i;
    Pe = new Set();
    Oe = function(e2, t3) {
      if (true) {
        var n3 = "The component " + e2 + (t3 ? ' with the id of "' + t3 + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r3 = console.error;
        try {
          var o3 = true;
          console.error = function(e3) {
            if (Ie.test(e3))
              o3 = false, Pe.delete(n3);
            else {
              for (var t4 = arguments.length, s3 = new Array(t4 > 1 ? t4 - 1 : 0), i3 = 1; i3 < t4; i3++)
                s3[i3 - 1] = arguments[i3];
              r3.apply(void 0, [e3].concat(s3));
            }
          }, (0, import_react2.useRef)(), o3 && !Pe.has(n3) && (console.warn(n3), Pe.add(n3));
        } catch (e3) {
          Ie.test(e3.message) && Pe.delete(n3);
        } finally {
          console.error = r3;
        }
      }
    };
    Re = function(e2, t3, n3) {
      return n3 === void 0 && (n3 = E2), e2.theme !== n3.theme && e2.theme || t3 || n3.theme;
    };
    De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g;
    je = /(^-|-$)/g;
    xe = function(e2) {
      return ee(ne(e2) >>> 0);
    };
    Ve = function(e2) {
      return typeof e2 == "function" || typeof e2 == "object" && e2 !== null && !Array.isArray(e2);
    };
    Be = function(e2) {
      return e2 !== "__proto__" && e2 !== "constructor" && e2 !== "prototype";
    };
    Ge = import_react2.default.createContext();
    Le = Ge.Consumer;
    Ye = {};
    He = function(e2) {
      return function e3(t3, r3, o3) {
        if (o3 === void 0 && (o3 = E2), !(0, import_react_is.isValidElementType)(r3))
          return j2(1, String(r3));
        var s3 = function() {
          return t3(r3, o3, Ce.apply(void 0, arguments));
        };
        return s3.withConfig = function(n3) {
          return e3(t3, r3, v2({}, o3, {}, n3));
        }, s3.attrs = function(n3) {
          return e3(t3, r3, v2({}, o3, { attrs: Array.prototype.concat(o3.attrs, n3).filter(Boolean) }));
        }, s3;
      }(qe, e2);
    };
    ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e2) {
      He[e2] = He(e2);
    });
    $e = function() {
      function e2(e3, t4) {
        this.rules = e3, this.componentId = t4, this.isStatic = re(e3), Z2.registerId(this.componentId + 1);
      }
      var t3 = e2.prototype;
      return t3.createStyles = function(e3, t4, n3, r3) {
        var o3 = r3(Ne(this.rules, t4, n3, r3).join(""), ""), s3 = this.componentId + e3;
        n3.insertRules(s3, s3, o3);
      }, t3.removeStyles = function(e3, t4) {
        t4.clearRules(this.componentId + e3);
      }, t3.renderStyles = function(e3, t4, n3, r3) {
        e3 > 2 && Z2.registerId(this.componentId + e3), this.removeStyles(e3, n3), this.createStyles(e3, t4, n3, r3);
      }, e2;
    }();
    Je = function() {
      function e2() {
        var e3 = this;
        this._emitSheetCSS = function() {
          var t4 = e3.instance.toString();
          if (!t4)
            return "";
          var n3 = q2();
          return "<style " + [n3 && 'nonce="' + n3 + '"', A2 + '="true"', 'data-styled-version="5.3.5"'].filter(Boolean).join(" ") + ">" + t4 + "</style>";
        }, this.getStyleTags = function() {
          return e3.sealed ? j2(2) : e3._emitSheetCSS();
        }, this.getStyleElement = function() {
          var t4;
          if (e3.sealed)
            return j2(2);
          var n3 = ((t4 = {})[A2] = "", t4["data-styled-version"] = "5.3.5", t4.dangerouslySetInnerHTML = { __html: e3.instance.toString() }, t4), o3 = q2();
          return o3 && (n3.nonce = o3), [import_react2.default.createElement("style", v2({}, n3, { key: "sc-0-0" }))];
        }, this.seal = function() {
          e3.sealed = true;
        }, this.instance = new Z2({ isServer: true }), this.sealed = false;
      }
      var t3 = e2.prototype;
      return t3.collectStyles = function(e3) {
        return this.sealed ? j2(2) : import_react2.default.createElement(ye, { sheet: this.instance }, e3);
      }, t3.interleaveWithNodeStream = function(e3) {
        return j2(3);
      }, e2;
    }();
    typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), typeof window != "undefined" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
    styled_components_browser_esm_default = He;
  }
});

// studio/src/uiComponents/PointerEventsHandler.tsx
var import_react3, elementId, lockedCursorCssVarName, Container, CursorOverride, context, PointerEventsHandler, useCssCursorLock, PointerEventsHandler_default;
var init_PointerEventsHandler = __esm({
  "studio/src/uiComponents/PointerEventsHandler.tsx"() {
    import_react3 = __toModule(require_react());
    init_styled_components_browser_esm();
    elementId = "pointer-root";
    lockedCursorCssVarName = "--lockedCursor";
    Container = styled_components_browser_esm_default.div`
  pointer-events: auto;
  &.normal {
    pointer-events: none;
  }
`;
    CursorOverride = styled_components_browser_esm_default.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  #pointer-root:not(.normal) > & {
    pointer-events: auto;
  }
`;
    context = (0, import_react3.createContext)({});
    PointerEventsHandler = (props) => {
      var _a2, _b, _c, _d;
      const [locks, setLocks] = (0, import_react3.useState)([]);
      const contextValue = (0, import_react3.useMemo)(() => {
        const getLock2 = (className, cursor) => {
          const lock = { className, cursor };
          setLocks((s3) => [...s3, lock]);
          const unlock = () => {
            setLocks((s3) => s3.filter((l4) => l4 !== lock));
          };
          return unlock;
        };
        return {
          getLock: getLock2
        };
      }, []);
      const lockedCursor = (_b = (_a2 = locks[0]) == null ? void 0 : _a2.cursor) != null ? _b : "";
      return /* @__PURE__ */ import_react3.default.createElement(context.Provider, {
        value: contextValue
      }, /* @__PURE__ */ import_react3.default.createElement(Container, {
        id: elementId,
        className: ((_d = (_c = locks[0]) == null ? void 0 : _c.className) != null ? _d : "normal") + " " + props.className
      }, /* @__PURE__ */ import_react3.default.createElement(CursorOverride, {
        style: {
          cursor: lockedCursor,
          [lockedCursorCssVarName]: lockedCursor
        }
      }, props.children)));
    };
    useCssCursorLock = (enabled, className, cursor) => {
      const ctx3 = (0, import_react3.useContext)(context);
      (0, import_react3.useLayoutEffect)(() => {
        if (!enabled)
          return;
        return ctx3.getLock(className, cursor);
      }, [enabled, className, cursor]);
    };
    PointerEventsHandler_default = PointerEventsHandler;
  }
});

// studio/src/uiComponents/useLogger.tsx
function ProvideLogger(props) {
  return /* @__PURE__ */ import_react4.default.createElement(loggerContext.Provider, {
    value: props.logger
  }, props.children);
}
function useLogger(name, key) {
  const parentLogger = (0, import_react4.useContext)(loggerContext);
  return (0, import_react4.useMemo)(() => {
    if (name) {
      return parentLogger.named(name, key);
    } else {
      return parentLogger;
    }
  }, [parentLogger, name, key]);
}
var import_react4, loggerContext;
var init_useLogger = __esm({
  "studio/src/uiComponents/useLogger.tsx"() {
    import_react4 = __toModule(require_react());
    loggerContext = import_react4.default.createContext(null);
  }
});

// studio/src/UIRoot/PointerCapturing.tsx
function _usePointerCapturingContext() {
  const logger = useLogger("PointerCapturing");
  let currentCaptureRef = import_react5.default.useRef(null);
  const isPointerBeingCaptured = () => currentCaptureRef.current != null;
  return (forDebugName) => {
    let localCapture;
    const updateCapture = (to) => {
      localCapture = to;
      currentCaptureRef.current = to;
      return to;
    };
    const capturing = {
      capturePointer(reason) {
        logger._debug("Capturing pointer", { forDebugName, reason });
        if (currentCaptureRef.current != null) {
          throw new Error(`"${forDebugName}" attempted capturing pointer for "${reason}" while already captured by "${currentCaptureRef.current.debugOwnerName}" for "${currentCaptureRef.current.debugReason}"`);
        }
        const releaseCapture = updateCapture({
          debugOwnerName: forDebugName,
          debugReason: reason
        });
        return {
          isCapturing() {
            return releaseCapture === currentCaptureRef.current;
          },
          release() {
            if (releaseCapture === currentCaptureRef.current) {
              logger._debug("Releasing pointer", {
                forDebugName,
                reason
              });
              updateCapture(null);
              return true;
            }
            return false;
          }
        };
      },
      isPointerBeingCaptured
    };
    return {
      capturing,
      forceRelease() {
        if (localCapture && currentCaptureRef.current === localCapture) {
          logger._debug("Force releasing pointer", { localCapture });
          updateCapture(null);
        }
      }
    };
  };
}
function ProvidePointerCapturing(props) {
  const ctx3 = _usePointerCapturingContext();
  return /* @__PURE__ */ import_react5.default.createElement(PointerCapturingContext.Provider, {
    value: ctx3
  }, /* @__PURE__ */ import_react5.default.createElement(ProviderChildrenMemo, {
    children: props.children
  }));
}
function usePointerCapturing(forDebugName) {
  const pointerCapturingFn = (0, import_react5.useContext)(PointerCapturingContext);
  const control = (0, import_react5.useMemo)(() => {
    return pointerCapturingFn(forDebugName);
  }, [forDebugName, pointerCapturingFn]);
  (0, import_react5.useEffect)(() => {
    return () => {
      control.forceRelease();
    };
  }, [control]);
  return control.capturing;
}
var import_react5, PointerCapturingContext, ProviderChildrenMemo;
var init_PointerCapturing = __esm({
  "studio/src/UIRoot/PointerCapturing.tsx"() {
    import_react5 = __toModule(require_react());
    init_useLogger();
    PointerCapturingContext = import_react5.default.createContext(null);
    ProviderChildrenMemo = import_react5.default.memo(({ children }) => /* @__PURE__ */ import_react5.default.createElement(import_react5.default.Fragment, null, children));
  }
});

// shared/src/utils/noop.ts
var noop2, noop_default2;
var init_noop2 = __esm({
  "shared/src/utils/noop.ts"() {
    noop2 = () => {
    };
    noop_default2 = noop2;
  }
});

// studio/src/uiComponents/isSafari.ts
var isSafari;
var init_isSafari = __esm({
  "studio/src/uiComponents/isSafari.ts"() {
    isSafari = typeof window !== "undefined" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
});

// studio/src/utils/useRefAndState.ts
function useRefAndState(initialValue) {
  const ref = (0, import_react6.useMemo)(() => {
    let current = initialValue;
    return {
      get current() {
        return current;
      },
      set current(v5) {
        current = v5;
        setState(v5);
      }
    };
  }, []);
  const [state, setState] = (0, import_react6.useState)(() => initialValue);
  return [ref, state];
}
var import_react6;
var init_useRefAndState = __esm({
  "studio/src/utils/useRefAndState.ts"() {
    import_react6 = __toModule(require_react());
  }
});

// studio/src/uiComponents/useDrag.ts
function useDrag(target, opts) {
  const optsRef = (0, import_react7.useRef)(opts);
  optsRef.current = opts;
  const isPointerLockUsed = opts.shouldPointerLock && !isSafari;
  const stateRef = (0, import_react7.useRef)({
    domDragStarted: false
  });
  const { capturePointer } = usePointerCapturing(`useDrag for ${opts.debugName}`);
  const callbacksRef = (0, import_react7.useRef)({ onDrag: noop_default2, onDragEnd: noop_default2, onClick: noop_default2 });
  const capturedPointerRef = (0, import_react7.useRef)();
  const [isDraggingRef, isDragging] = useRefAndState(false);
  (0, import_react7.useLayoutEffect)(() => {
    if (!target)
      return;
    const ensureIsDraggingUpToDateForReactLifecycle = () => {
      const isDragging2 = stateRef.current.domDragStarted && stateRef.current.detection.detected;
      if (isDraggingRef.current !== isDragging2) {
        isDraggingRef.current = isDragging2;
      }
    };
    const dragHandler = (event) => {
      if (!stateRef.current.domDragStarted)
        return;
      const stateStarted = stateRef.current;
      if (didPointerLockCauseMovement(event, stateStarted))
        return;
      if (!stateStarted.detection.detected) {
        stateStarted.detection.totalDistanceMoved += Math.abs(event.movementY) + Math.abs(event.movementX);
        if (stateStarted.detection.totalDistanceMoved > DRAG_DETECTION_DISTANCE_THRESHOLD) {
          if (isPointerLockUsed) {
            target.requestPointerLock();
          }
          stateStarted.detection = {
            detected: true,
            dragMovement: { x: 0, y: 0 },
            dragEventCount: 0
          };
          ensureIsDraggingUpToDateForReactLifecycle();
        }
      }
      if (stateStarted.detection.detected) {
        stateStarted.detection.dragEventCount += 1;
        const { dragMovement } = stateStarted.detection;
        if (isPointerLockUsed) {
          dragMovement.x += event.movementX;
          dragMovement.y += event.movementY;
        } else {
          const { startPos } = stateStarted;
          dragMovement.x = event.screenX - startPos.x;
          dragMovement.y = event.screenY - startPos.y;
        }
        callbacksRef.current.onDrag(dragMovement.x, dragMovement.y, event, event.movementX, event.movementY);
      }
    };
    const dragEndHandler = (e2) => {
      removeDragListeners();
      if (!stateRef.current.domDragStarted)
        return;
      const dragHappened = stateRef.current.detection.detected;
      stateRef.current = { domDragStarted: false };
      if (opts.shouldPointerLock && !isSafari)
        document.exitPointerLock();
      callbacksRef.current.onDragEnd(dragHappened);
      window.focus();
      if (!dragHappened) {
        callbacksRef.current.onClick(e2);
      }
      ensureIsDraggingUpToDateForReactLifecycle();
    };
    const addDragListeners = () => {
      document.addEventListener("mousemove", dragHandler);
      document.addEventListener("mouseup", dragEndHandler);
    };
    const removeDragListeners = () => {
      var _a2;
      (_a2 = capturedPointerRef.current) == null ? void 0 : _a2.release();
      document.removeEventListener("mousemove", dragHandler);
      document.removeEventListener("mouseup", dragEndHandler);
    };
    const preventUnwantedClick = (event) => {
      if (optsRef.current.disabled)
        return;
      if (!stateRef.current.domDragStarted)
        return;
      if (stateRef.current.detection.detected) {
        if (!optsRef.current.dontBlockMouseDown) {
          event.stopPropagation();
          event.preventDefault();
        }
        stateRef.current.detection = {
          detected: false,
          totalDistanceMoved: 0
        };
        ensureIsDraggingUpToDateForReactLifecycle();
      }
    };
    const dragStartHandler = (event) => {
      var _a2, _b, _c, _d;
      (_a2 = capturedPointerRef.current) == null ? void 0 : _a2.release();
      const opts2 = optsRef.current;
      if (opts2.disabled === true)
        return;
      const acceptedButtons = (_b = opts2.buttons) != null ? _b : [0];
      if (!acceptedButtons.includes(event.button))
        return;
      const returnOfOnDragStart = opts2.onDragStart(event);
      if (returnOfOnDragStart === false) {
        return;
      }
      callbacksRef.current.onDrag = returnOfOnDragStart.onDrag;
      callbacksRef.current.onDragEnd = (_c = returnOfOnDragStart.onDragEnd) != null ? _c : noop_default2;
      callbacksRef.current.onClick = (_d = returnOfOnDragStart.onClick) != null ? _d : noop_default2;
      capturedPointerRef.current = capturePointer("Drag start");
      if (!opts2.dontBlockMouseDown) {
        event.stopPropagation();
        event.preventDefault();
      }
      stateRef.current = {
        domDragStarted: true,
        startPos: { x: event.screenX, y: event.screenY },
        detection: {
          detected: false,
          totalDistanceMoved: 0
        }
      };
      ensureIsDraggingUpToDateForReactLifecycle();
      addDragListeners();
    };
    const onMouseDown = (e2) => {
      dragStartHandler(e2);
    };
    target.addEventListener("mousedown", onMouseDown);
    target.addEventListener("click", preventUnwantedClick);
    return () => {
      var _a2, _b;
      removeDragListeners();
      target.removeEventListener("mousedown", onMouseDown);
      target.removeEventListener("click", preventUnwantedClick);
      if (stateRef.current.domDragStarted) {
        (_b = (_a2 = callbacksRef.current).onDragEnd) == null ? void 0 : _b.call(_a2, stateRef.current.detection.detected);
      }
      stateRef.current = { domDragStarted: false };
      ensureIsDraggingUpToDateForReactLifecycle();
    };
  }, [target]);
  useCssCursorLock(isDragging && !!opts.lockCSSCursorTo, "dragging", opts.lockCSSCursorTo);
  return [isDragging];
}
function didPointerLockCauseMovement(event, state) {
  const isEarlyInDragging = !state.detection.detected || state.detection.detected && state.detection.dragEventCount < 3;
  return isEarlyInDragging && (Math.abs(event.movementX) > DRAG_DETECTION_WAS_POINTER_LOCK_MOVEMENT || Math.abs(event.movementY) > DRAG_DETECTION_WAS_POINTER_LOCK_MOVEMENT);
}
var import_react7, MouseButton, DRAG_DETECTION_DISTANCE_THRESHOLD, DRAG_DETECTION_WAS_POINTER_LOCK_MOVEMENT;
var init_useDrag = __esm({
  "studio/src/uiComponents/useDrag.ts"() {
    import_react7 = __toModule(require_react());
    init_PointerEventsHandler();
    init_PointerCapturing();
    init_noop2();
    init_isSafari();
    init_useRefAndState();
    (function(MouseButton2) {
      MouseButton2[MouseButton2["Left"] = 0] = "Left";
      MouseButton2[MouseButton2["Middle"] = 1] = "Middle";
    })(MouseButton || (MouseButton = {}));
    DRAG_DETECTION_DISTANCE_THRESHOLD = 3;
    DRAG_DETECTION_WAS_POINTER_LOCK_MOVEMENT = 100;
  }
});

// studio/src/uiComponents/useKeyDownCallback.tsx
function useKeyDownCallback(combo, listener) {
  const refs = (0, import_react8.useRef)({ combo, listener });
  refs.current = { combo, listener };
  (0, import_react8.useEffect)(() => {
    function onKeyDown(event) {
      if (event.key === refs.current.combo) {
        refs.current.listener({ down: true, event });
      }
    }
    function onKeyUp(event) {
      if (event.key === refs.current.combo) {
        refs.current.listener({ down: false, event });
      }
    }
    function onBlur(event) {
      refs.current.listener({ down: false, event: void 0 });
    }
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);
    window.addEventListener("blur", onBlur);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("keyup", onKeyUp);
      window.removeEventListener("blur", onBlur);
    };
  }, []);
}
var import_react8;
var init_useKeyDownCallback = __esm({
  "studio/src/uiComponents/useKeyDownCallback.tsx"() {
    import_react8 = __toModule(require_react());
  }
});

// studio/src/uiComponents/useKeyDown.ts
function useKeyDown(combo) {
  const [state, setState] = (0, import_react9.useState)(false);
  useKeyDownCallback(combo, ({ down }) => {
    setState(down);
  });
  return state;
}
var import_react9;
var init_useKeyDown = __esm({
  "studio/src/uiComponents/useKeyDown.ts"() {
    import_react9 = __toModule(require_react());
    init_useKeyDownCallback();
  }
});

// studio/src/uiComponents/useValToAtom.ts
function useValToAtom(val59) {
  const atom = (0, import_react10.useMemo)(() => {
    return new import_dataverse4.Atom(val59);
  }, []);
  (0, import_react10.useLayoutEffect)(() => {
    atom.setState(val59);
  }, [val59]);
  return atom;
}
var import_dataverse4, import_react10;
var init_useValToAtom = __esm({
  "studio/src/uiComponents/useValToAtom.ts"() {
    import_dataverse4 = __toModule(require("@theatre/dataverse"));
    import_react10 = __toModule(require_react());
  }
});

// shared/src/utils/mutableSetDeep.ts
function mutableSetDeep(obj, getPointer, val59) {
  const rootPointer = (0, import_dataverse5.pointer)({ root: {}, path: [] });
  const deepPointer = getPointer(rootPointer);
  set_default(obj, (0, import_dataverse5.getPointerParts)(deepPointer).path, val59);
}
var import_dataverse5;
var init_mutableSetDeep = __esm({
  "shared/src/utils/mutableSetDeep.ts"() {
    import_dataverse5 = __toModule(require("@theatre/dataverse"));
    init_set();
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/DopeSnap.tsx
var POSITION_SNAP_ATTR, DopeSnap, DopeSnap_default;
var init_DopeSnap = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/DopeSnap.tsx"() {
    POSITION_SNAP_ATTR = "data-pos";
    DopeSnap = {
      checkIfMouseEventSnapToPos(event, options2) {
        const snapTarget = event.composedPath().find((el) => el instanceof Element && el !== (options2 == null ? void 0 : options2.ignore) && el.hasAttribute(POSITION_SNAP_ATTR));
        if (snapTarget) {
          const snapPos = parseFloat(snapTarget.getAttribute(POSITION_SNAP_ATTR));
          if (isFinite(snapPos)) {
            return snapPos;
          }
        }
        return null;
      },
      includePositionSnapAttrs(position2) {
        return { [POSITION_SNAP_ATTR]: position2 };
      }
    };
    DopeSnap_default = DopeSnap;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/collectAggregateKeyframes.tsx
function collectAggregateKeyframesInPrism(leaf) {
  const tracks = leaf.type === "sheet" ? collectAggregateKeyframesSheet(leaf) : collectAggregateKeyframesCompoundOrObject(leaf);
  return {
    byPosition: keyframesByPositionFromTrackWithIds(tracks),
    tracks
  };
}
function keyframesByPositionFromTrackWithIds(tracks) {
  const byPosition = new Map();
  for (const track of tracks) {
    for (const kf of track.data.keyframes) {
      let existing = byPosition.get(kf.position);
      if (!existing) {
        existing = [];
        byPosition.set(kf.position, existing);
      }
      existing.push({
        kf,
        track,
        itemKey: createStudioSheetItemKey.forTrackKeyframe(track.sheetObject, track.id, kf.id)
      });
    }
  }
  return byPosition;
}
function collectAggregateKeyframesSheet(leaf) {
  return leaf.children.flatMap(collectAggregateKeyframesCompoundOrObject);
}
function collectAggregateKeyframesCompoundOrObject(leaf) {
  return leaf.children.flatMap((childLeaf) => childLeaf.type === "propWithChildren" ? collectAggregateKeyframesCompoundOrObject(childLeaf) : collectAggregateKeyframesPrimitiveProp(childLeaf));
}
function collectAggregateKeyframesPrimitiveProp(leaf) {
  const sheetObject = leaf.sheetObject;
  const projectId = sheetObject.address.projectId;
  const sheetObjectTracksP = getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetObject.address.sheetId].sequence.tracksByObject[sheetObject.address.objectKey];
  const trackId = (0, import_dataverse6.val)(sheetObjectTracksP.trackIdByPropPath[encodePathToProp(leaf.pathToProp)]);
  if (!trackId)
    return [];
  const trackData = (0, import_dataverse6.val)(sheetObjectTracksP.trackData[trackId]);
  if (!trackData)
    return [];
  return [{ id: trackId, data: trackData, sheetObject }];
}
function collectAggregateSnapPositionsSheet(leaf, snapTargetPositions) {
  return uniq_default(leaf.children.flatMap((childLeaf) => collectAggregateSnapPositionsObjectOrCompound(childLeaf, snapTargetPositions)));
}
function collectAggregateSnapPositionsObjectOrCompound(leaf, snapTargetPositions) {
  return uniq_default(leaf.children.flatMap((childLeaf) => childLeaf.type === "propWithChildren" ? collectAggregateSnapPositionsObjectOrCompound(childLeaf, snapTargetPositions) : collectAggregateSnapPositionsPrimitiveProp(childLeaf, snapTargetPositions)));
}
function collectAggregateSnapPositionsPrimitiveProp(leaf, snapTargetPositions) {
  var _a2, _b;
  const sheetObject = leaf.sheetObject;
  const projectId = sheetObject.address.projectId;
  const sheetObjectTracksP = getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetObject.address.sheetId].sequence.tracksByObject[sheetObject.address.objectKey];
  const trackId = (0, import_dataverse6.val)(sheetObjectTracksP.trackIdByPropPath[encodePathToProp(leaf.pathToProp)]);
  if (!trackId)
    return [];
  return (_b = (_a2 = snapTargetPositions[sheetObject.address.objectKey]) == null ? void 0 : _a2[trackId]) != null ? _b : [];
}
var import_dataverse6;
var init_collectAggregateKeyframes = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/collectAggregateKeyframes.tsx"() {
    init_getStudio();
    import_dataverse6 = __toModule(require("@theatre/dataverse"));
    init_ids();
    init_addresses();
    init_lodash();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/DopeSheetSelectionView.tsx
function useCaptureSelection(layoutP, containerNode) {
  const [ref, state] = useRefAndState(null);
  const logger = useLogger("useCaptureSelection");
  useDrag(containerNode, (0, import_react12.useMemo)(() => {
    return {
      debugName: "DopeSheetSelectionView/useCaptureSelection",
      dontBlockMouseDown: true,
      lockCSSCursorTo: "cell",
      onDragStart(event) {
        if (!event.shiftKey || event.target instanceof HTMLInputElement) {
          return false;
        }
        const rect = containerNode.getBoundingClientRect();
        const posInScaledSpace = event.clientX - rect.left - (0, import_dataverse7.val)(layoutP.scaledSpace.leftPadding);
        const posInUnitSpace = (0, import_dataverse7.val)(layoutP.scaledSpace.toUnitSpace)(posInScaledSpace);
        ref.current = {
          h: [posInUnitSpace, posInUnitSpace],
          v: [event.clientY - rect.top, event.clientY - rect.top]
        };
        (0, import_dataverse7.val)(layoutP.selectionAtom).setState({ current: void 0 });
        return {
          onDrag(_dx, _dy, event2) {
            const rect2 = containerNode.getBoundingClientRect();
            const posInScaledSpace2 = event2.clientX - rect2.left - (0, import_dataverse7.val)(layoutP.scaledSpace.leftPadding);
            const posInUnitSpace2 = (0, import_dataverse7.val)(layoutP.scaledSpace.toUnitSpace)(posInScaledSpace2);
            ref.current = {
              h: [ref.current.h[0], posInUnitSpace2],
              v: [ref.current.v[0], event2.clientY - rect2.top]
            };
            const selection = utils.boundsToSelection(logger, (0, import_dataverse7.val)(layoutP), ref.current);
            (0, import_dataverse7.val)(layoutP.selectionAtom).setState({ current: selection });
          },
          onDragEnd(_dragHappened) {
            ref.current = null;
          }
        };
      }
    };
  }, [layoutP, containerNode, ref]));
  return state;
}
var import_dataverse7, import_react12, HITBOX_SIZE_PX, Container2, DopeSheetSelectionView, utils, SelectionRectangleDiv, sortBounds, SelectionRectangle, DopeSheetSelectionView_default;
var init_DopeSheetSelectionView = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/DopeSheetSelectionView.tsx"() {
    init_getStudio();
    init_useDrag();
    init_useKeyDown();
    init_useValToAtom();
    init_mutableSetDeep();
    init_useRefAndState();
    init_src();
    import_dataverse7 = __toModule(require("@theatre/dataverse"));
    import_react12 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_DopeSnap();
    init_collectAggregateKeyframes();
    init_useLogger();
    HITBOX_SIZE_PX = 5;
    Container2 = styled_components_browser_esm_default.div`
  cursor: ${(props) => props.isShiftDown ? "cell" : "default"};
`;
    DopeSheetSelectionView = ({ layoutP, children, height: height2 }) => {
      const [containerRef, containerNode] = useRefAndState(null);
      const isShiftDown = useKeyDown("Shift");
      const selectionBounds = useCaptureSelection(layoutP, containerNode);
      const selectionBoundsRef = (0, import_react12.useRef)(selectionBounds);
      selectionBoundsRef.current = selectionBounds;
      return /* @__PURE__ */ import_react12.default.createElement(Container2, {
        style: { height: height2 + "px" },
        ref: containerRef,
        isShiftDown,
        className: "selectionview"
      }, selectionBounds && /* @__PURE__ */ import_react12.default.createElement(SelectionRectangle, {
        state: selectionBounds,
        layoutP
      }), children);
    };
    (function(utils2) {
      const collectForAggregatedChildren = (logger, layout, leaf, bounds, selectionByObjectKey) => {
        const aggregatedKeyframes = collectAggregateKeyframesInPrism(leaf);
        if (leaf.top + leaf.nodeHeight / 2 + HITBOX_SIZE_PX > bounds.v[0] && leaf.top + leaf.nodeHeight / 2 - HITBOX_SIZE_PX < bounds.v[1]) {
          for (const [position2, keyframes] of aggregatedKeyframes.byPosition) {
            const hitboxWidth = layout.scaledSpace.toUnitSpace(HITBOX_SIZE_PX);
            const isHitboxOutsideSelection = position2 + hitboxWidth <= bounds.h[0] || position2 - hitboxWidth >= bounds.h[1];
            if (isHitboxOutsideSelection)
              continue;
            for (const keyframeWithTrack of keyframes) {
              mutableSetDeep(selectionByObjectKey, (selectionByObjectKeyP) => selectionByObjectKeyP[keyframeWithTrack.track.sheetObject.address.objectKey].byTrackId[keyframeWithTrack.track.id].byKeyframeId[keyframeWithTrack.kf.id], true);
            }
          }
        }
        collectChildren(logger, layout, leaf, bounds, selectionByObjectKey);
      };
      const collectorByLeafType = {
        sheet(logger, layout, leaf, bounds, selectionByObjectKey) {
          collectForAggregatedChildren(logger, layout, leaf, bounds, selectionByObjectKey);
        },
        propWithChildren(logger, layout, leaf, bounds, selectionByObjectKey) {
          collectForAggregatedChildren(logger, layout, leaf, bounds, selectionByObjectKey);
        },
        sheetObject(logger, layout, leaf, bounds, selectionByObjectKey) {
          collectForAggregatedChildren(logger, layout, leaf, bounds, selectionByObjectKey);
        },
        primitiveProp(logger, layout, leaf, bounds, selectionByObjectKey) {
          const { sheetObject, trackId } = leaf;
          const trackData = (0, import_dataverse7.val)(getStudio().atomP.historic.coreByProject[sheetObject.address.projectId].sheetsById[sheetObject.address.sheetId].sequence.tracksByObject[sheetObject.address.objectKey].trackData[trackId]);
          if (bounds.v[0] > leaf.top + leaf.heightIncludingChildren / 2 + HITBOX_SIZE_PX || leaf.top + leaf.heightIncludingChildren / 2 - HITBOX_SIZE_PX > bounds.v[1]) {
            return;
          }
          for (const kf of trackData.keyframes) {
            if (kf.position + layout.scaledSpace.toUnitSpace(HITBOX_SIZE_PX) <= bounds.h[0])
              continue;
            if (kf.position - layout.scaledSpace.toUnitSpace(HITBOX_SIZE_PX) >= bounds.h[1])
              break;
            mutableSetDeep(selectionByObjectKey, (selectionByObjectKeyP) => selectionByObjectKeyP[sheetObject.address.objectKey].byTrackId[trackId].byKeyframeId[kf.id], true);
          }
        }
      };
      const collectChildren = (logger, layout, leaf, bounds, selectionByObjectKey) => {
        if ("children" in leaf) {
          for (const sub of leaf.children) {
            collectFromAnyLeaf(logger, layout, sub, bounds, selectionByObjectKey);
          }
        }
      };
      function collectFromAnyLeaf(logger, layout, leaf, bounds, selectionByObjectKey) {
        if (!leaf.shouldRender)
          return;
        if (bounds.v[0] > leaf.top + leaf.heightIncludingChildren || leaf.top > bounds.v[1]) {
          return;
        }
        const collector = collectorByLeafType[leaf.type];
        if (collector) {
          collector(logger, layout, leaf, bounds, selectionByObjectKey);
        } else {
          collectChildren(logger, layout, leaf, bounds, selectionByObjectKey);
        }
      }
      function boundsToSelection(logger, layout, bounds) {
        const selectionByObjectKey = {};
        bounds = sortBounds(bounds);
        const tree = layout.tree;
        collectFromAnyLeaf(logger.utilFor.internal(), layout, tree, bounds, selectionByObjectKey);
        const sheet = layout.tree.sheet;
        return {
          type: "DopeSheetSelection",
          byObjectKey: selectionByObjectKey,
          getDragHandlers(origin) {
            return {
              debugName: "DopeSheetSelectionView/boundsToSelection",
              onDragStart() {
                let tempTransaction;
                const toUnitSpace = layout.scaledSpace.toUnitSpace;
                return {
                  onDrag(dx, _3, event) {
                    if (tempTransaction) {
                      tempTransaction.discard();
                      tempTransaction = void 0;
                    }
                    const snapPos = DopeSnap_default.checkIfMouseEventSnapToPos(event, {
                      ignore: origin.domNode
                    });
                    const delta = snapPos != null ? snapPos - origin.positionAtStartOfDrag : toUnitSpace(dx);
                    tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                      const transformKeyframes = stateEditors2.coreByProject.historic.sheetsById.sequence.transformKeyframes;
                      for (const objectKey of Object.keys(selectionByObjectKey)) {
                        const { byTrackId } = selectionByObjectKey[objectKey];
                        for (const trackId of Object.keys(byTrackId)) {
                          const { byKeyframeId } = byTrackId[trackId];
                          transformKeyframes({
                            trackId,
                            keyframeIds: Object.keys(byKeyframeId),
                            translate: delta,
                            scale: 1,
                            origin: 0,
                            snappingFunction: sheet.getSequence().closestGridPosition,
                            objectKey,
                            projectId: origin.projectId,
                            sheetId: origin.sheetId
                          });
                        }
                      }
                    });
                  },
                  onDragEnd(dragHappened) {
                    if (dragHappened)
                      tempTransaction == null ? void 0 : tempTransaction.commit();
                    else
                      tempTransaction == null ? void 0 : tempTransaction.discard();
                  }
                };
              }
            };
          },
          delete() {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              const deleteKeyframes = stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes;
              for (const objectKey of Object.keys(selectionByObjectKey)) {
                const { byTrackId } = selectionByObjectKey[objectKey];
                for (const trackId of Object.keys(byTrackId)) {
                  const { byKeyframeId } = byTrackId[trackId];
                  deleteKeyframes(__spreadProps(__spreadValues({}, sheet.address), {
                    objectKey,
                    trackId,
                    keyframeIds: Object.keys(byKeyframeId)
                  }));
                }
              }
            });
          }
        };
      }
      utils2.boundsToSelection = boundsToSelection;
    })(utils || (utils = {}));
    SelectionRectangleDiv = styled_components_browser_esm_default.div`
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border: 1px dashed rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
`;
    sortBounds = (b4) => {
      return {
        h: [...b4.h].sort((a4, b5) => a4 - b5),
        v: [...b4.v].sort((a4, b5) => a4 - b5)
      };
    };
    SelectionRectangle = ({ state, layoutP }) => {
      const atom = useValToAtom(state);
      return usePrism(() => {
        const state2 = (0, import_dataverse7.val)(atom.pointer);
        const sorted = sortBounds(state2);
        const unitSpaceToScaledSpace = (0, import_dataverse7.val)(layoutP.scaledSpace.fromUnitSpace);
        const leftPadding = (0, import_dataverse7.val)(layoutP.scaledSpace.leftPadding);
        const positionsInScaledSpace = sorted.h.map(unitSpaceToScaledSpace).map((coord) => coord + leftPadding);
        const top = sorted.v[0];
        const height2 = sorted.v[1] - sorted.v[0];
        const left = positionsInScaledSpace[0];
        const width = positionsInScaledSpace[1] - positionsInScaledSpace[0];
        return /* @__PURE__ */ import_react12.default.createElement(SelectionRectangleDiv, {
          style: {
            top: top + "px",
            height: height2 + "px",
            left: left + "px",
            width: width + "px"
          }
        });
      }, [layoutP, atom]);
    };
    DopeSheetSelectionView_default = DopeSheetSelectionView;
  }
});

// studio/src/selectors.ts
function keys2(obj) {
  return Object.keys(obj);
}
function getRegisteredSheetIds(project) {
  return Object.keys((0, import_dataverse8.val)(project.sheetTemplatesP));
}
function getSelectedSequence() {
  const selectedSheets = uniq_default(getOutlineSelection().filter((s3) => isSheet(s3) || isSheetObject(s3)).map((s3) => isSheetObject(s3) ? s3.sheet : s3));
  const sheet = selectedSheets[0];
  if (!sheet)
    return;
  return sheet.getSequence();
}
var import_dataverse8, getOutlineSelection, getSelectedInstanceOfSheetId;
var init_selectors = __esm({
  "studio/src/selectors.ts"() {
    import_dataverse8 = __toModule(require("@theatre/dataverse"));
    init_instanceTypes();
    init_lodash();
    init_getStudio();
    getOutlineSelection = () => {
      var _a2;
      const projects = (0, import_dataverse8.val)(getStudio().projectsP);
      const mapped = ((_a2 = (0, import_dataverse8.val)(getStudio().atomP.historic.panels.outlinePanel.selection)) != null ? _a2 : []).map((s3) => {
        const project = projects[s3.projectId];
        if (!project)
          return;
        if (s3.type === "Project")
          return project;
        const sheetTemplate = (0, import_dataverse8.val)(project.sheetTemplatesP[s3.sheetId]);
        if (!sheetTemplate) {
          return;
        }
        const sheetInstance = getSelectedInstanceOfSheetId(project, s3.sheetId);
        if (!sheetInstance)
          return;
        if (s3.type === "Sheet") {
          return sheetInstance;
        }
        const obj = (0, import_dataverse8.val)(sheetInstance.objectsP[s3.objectKey]);
        if (!obj)
          return;
        return obj;
      });
      return uniq_default(mapped.filter((s3) => typeof s3 !== "undefined"));
    };
    getSelectedInstanceOfSheetId = (project, selectedSheetId) => {
      const projectStateP = getStudio().atomP.historic.projects.stateByProjectId[project.address.projectId];
      const instanceId = (0, import_dataverse8.val)(projectStateP.stateBySheetId[selectedSheetId].selectedInstanceId);
      const template = (0, import_dataverse8.val)(project.sheetTemplatesP[selectedSheetId]);
      if (!template)
        return void 0;
      if (instanceId) {
        return (0, import_dataverse8.val)(template.instancesP[instanceId]);
      } else {
        const allInstances = (0, import_dataverse8.val)(template.instancesP);
        return allInstances[keys2(allInstances)[0]];
      }
    };
  }
});

// shared/src/utils/valToAtom.ts
var import_dataverse9, valToAtom;
var init_valToAtom = __esm({
  "shared/src/utils/valToAtom.ts"() {
    import_dataverse9 = __toModule(require("@theatre/dataverse"));
    valToAtom = (key, vals) => {
      const a4 = import_dataverse9.prism.memo(key, () => new import_dataverse9.Atom(vals), []);
      a4.setState(vals);
      return a4;
    };
  }
});

// ../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var init_extends = __esm({
  "../node_modules/@babel/runtime/helpers/esm/extends.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
var init_assertThisInitialized = __esm({
  "../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o3, p3) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o4, p4) {
    o4.__proto__ = p4;
    return o4;
  };
  return _setPrototypeOf(o3, p3);
}
var init_setPrototypeOf = __esm({
  "../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
var init_inheritsLoose = __esm({
  "../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js"() {
    init_setPrototypeOf();
  }
});

// ../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o3) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o4) {
    return o4.__proto__ || Object.getPrototypeOf(o4);
  };
  return _getPrototypeOf(o3);
}
var init_getPrototypeOf = __esm({
  "../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
var init_isNativeFunction = __esm({
  "../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var init_isNativeReflectConstruct = __esm({
  "../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"() {
  }
});

// ../node_modules/@babel/runtime/helpers/esm/construct.js
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a4 = [null];
      a4.push.apply(a4, args2);
      var Constructor = Function.bind.apply(Parent2, a4);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
var init_construct = __esm({
  "../node_modules/@babel/runtime/helpers/esm/construct.js"() {
    init_setPrototypeOf();
    init_isNativeReflectConstruct();
  }
});

// ../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper2,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper2, Class2);
  };
  return _wrapNativeSuper(Class);
}
var init_wrapNativeSuper = __esm({
  "../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js"() {
    init_getPrototypeOf();
    init_setPrototypeOf();
    init_isNativeFunction();
    init_construct();
  }
});

// ../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteralLoose.js
var init_taggedTemplateLiteralLoose = __esm({
  "../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteralLoose.js"() {
  }
});

// ../node_modules/polished/dist/polished.esm.js
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a4 = args[0];
  var b4 = [];
  var c3;
  for (c3 = 1; c3 < args.length; c3 += 1) {
    b4.push(args[c3]);
  }
  b4.forEach(function(d3) {
    a4 = a4.replace(/%[a-z]/, d3);
  });
  return a4;
}
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function generateProperty(property2, position2) {
  if (!property2)
    return position2.toLowerCase();
  var splitProperty = property2.split("-");
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position2);
    return splitProperty.reduce(function(acc, val59) {
      return "" + acc + capitalizeString(val59);
    });
  }
  var joinedProperty = property2.replace(/([a-z])([A-Z])/g, "$1" + position2 + "$2");
  return property2 === joinedProperty ? "" + property2 + position2 : joinedProperty;
}
function generateStyles(property2, valuesWithDefaults) {
  var styles = {};
  for (var i3 = 0; i3 < valuesWithDefaults.length; i3 += 1) {
    if (valuesWithDefaults[i3] || valuesWithDefaults[i3] === 0) {
      styles[generateProperty(property2, positionMap$1[i3])] = valuesWithDefaults[i3];
    }
  }
  return styles;
}
function directionalProperty(property2) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property2, valuesWithDefaults);
}
function colorToInt(color2) {
  return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
function nameToHex(color2) {
  if (typeof color2 !== "string")
    return color2;
  var normalizedColorName = color2.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
function parseToRgb(color2) {
  if (typeof color2 !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color2);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color2) {
  var red = color2.red / 255;
  var green = color2.green / 255;
  var blue = color2.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    if (color2.alpha !== void 0) {
      return {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color2.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color2.alpha !== void 0) {
    return {
      hue,
      saturation,
      lightness,
      alpha: color2.alpha
    };
  }
  return {
    hue,
    saturation,
    lightness
  };
}
function parseToHsl(color2) {
  return rgbToHsl(parseToRgb(color2));
}
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color2) {
  return numberToHex(Math.round(color2 * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha === "number") {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
function toColorString(color2) {
  if (typeof color2 !== "object")
    throw new PolishedError(8);
  if (isRgba(color2))
    return rgba(color2);
  if (isRgb(color2))
    return rgb(color2);
  if (isHsla(color2))
    return hsla(color2);
  if (isHsl(color2))
    return hsl(color2);
  throw new PolishedError(8);
}
function curried(f3, length, acc) {
  return function fn2() {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f3.apply(this, combined) : curried(f3, length, combined);
  };
}
function curry(f3) {
  return curried(f3, f3.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken(amount, color2) {
  if (color2 === "transparent")
    return color2;
  var hslColor = parseToHsl(color2);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}
function lighten(amount, color2) {
  if (color2 === "transparent")
    return color2;
  var hslColor = parseToHsl(color2);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}
function saturate(amount, color2) {
  if (color2 === "transparent")
    return color2;
  var hslColor = parseToHsl(color2);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}
function transparentize(amount, color2) {
  if (color2 === "transparent")
    return color2;
  var parsedColor = parseToRgb(color2);
  var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
}
function position(firstValue) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  if (positionMap.indexOf(firstValue) >= 0 && firstValue) {
    return _extends({}, directionalProperty.apply(void 0, [""].concat(values)), {
      position: firstValue
    });
  } else {
    return directionalProperty.apply(void 0, ["", firstValue].concat(values));
  }
}
var ERRORS, PolishedError, positionMap$1, namedColorMap, hexRegex, hexRgbaRegex, reducedHexRegex, reducedRgbaHexRegex, rgbRegex, rgbaRegex, hslRegex, hslaRegex, reduceHexValue, isRgb, isRgba, isHsl, isHsla, curriedDarken, curriedLighten, curriedSaturate, curriedTransparentize, positionMap;
var init_polished_esm = __esm({
  "../node_modules/polished/dist/polished.esm.js"() {
    init_extends();
    init_assertThisInitialized();
    init_inheritsLoose();
    init_wrapNativeSuper();
    init_taggedTemplateLiteralLoose();
    ERRORS = {
      "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
      "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
      "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
      "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
      "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
      "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
      "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
      "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
      "9": "Please provide a number of steps to the modularScale helper.\n\n",
      "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
      "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
      "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
      "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
      "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
      "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
      "16": "You must provide a template to this method.\n\n",
      "17": "You passed an unsupported selector state to this method.\n\n",
      "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
      "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
      "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
      "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      "23": "fontFace expects a name of a font-family.\n\n",
      "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
      "25": "fontFace expects localFonts to be an array.\n\n",
      "26": "fontFace expects fileFormats to be an array.\n\n",
      "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
      "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
      "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
      "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
      "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
      "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
      "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
      "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
      "36": "Property must be a string value.\n\n",
      "37": "Syntax Error at %s.\n\n",
      "38": "Formula contains a function that needs parentheses at %s.\n\n",
      "39": "Formula is missing closing parenthesis at %s.\n\n",
      "40": "Formula has too many closing parentheses at %s.\n\n",
      "41": "All values in a formula must have the same unit or be unitless.\n\n",
      "42": "Please provide a number of steps to the modularScale helper.\n\n",
      "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
      "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
      "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
      "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
      "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
      "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
      "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
      "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
      "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
      "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
      "53": "fontFace expects localFonts to be an array.\n\n",
      "54": "fontFace expects fileFormats to be an array.\n\n",
      "55": "fontFace expects a name of a font-family.\n\n",
      "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
      "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
      "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
      "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
      "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      "61": "Property must be a string value.\n\n",
      "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
      "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
      "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
      "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
      "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
      "67": "You must provide a template to this method.\n\n",
      "68": "You passed an unsupported selector state to this method.\n\n",
      "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
      "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
      "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
      "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
      "73": "Please provide a valid CSS variable.\n\n",
      "74": "CSS variable not found and no default was provided.\n\n",
      "75": "important requires a valid style object, got a %s instead.\n\n",
      "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
      "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
      "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
    };
    PolishedError = /* @__PURE__ */ function(_Error) {
      _inheritsLoose(PolishedError2, _Error);
      function PolishedError2(code) {
        var _this;
        if (false) {
          _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        } else {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
        }
        return _assertThisInitialized(_this);
      }
      return PolishedError2;
    }(/* @__PURE__ */ _wrapNativeSuper(Error));
    positionMap$1 = ["Top", "Right", "Bottom", "Left"];
    namedColorMap = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "639",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };
    hexRegex = /^#[a-fA-F0-9]{6}$/;
    hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
    reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
    reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
    rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
    rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
    hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    reduceHexValue = function reduceHexValue2(value) {
      if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
        return "#" + value[1] + value[3] + value[5];
      }
      return value;
    };
    isRgb = function isRgb2(color2) {
      return typeof color2.red === "number" && typeof color2.green === "number" && typeof color2.blue === "number" && (typeof color2.alpha !== "number" || typeof color2.alpha === "undefined");
    };
    isRgba = function isRgba2(color2) {
      return typeof color2.red === "number" && typeof color2.green === "number" && typeof color2.blue === "number" && typeof color2.alpha === "number";
    };
    isHsl = function isHsl2(color2) {
      return typeof color2.hue === "number" && typeof color2.saturation === "number" && typeof color2.lightness === "number" && (typeof color2.alpha !== "number" || typeof color2.alpha === "undefined");
    };
    isHsla = function isHsla2(color2) {
      return typeof color2.hue === "number" && typeof color2.saturation === "number" && typeof color2.lightness === "number" && typeof color2.alpha === "number";
    };
    curriedDarken = /* @__PURE__ */ curry(darken);
    curriedLighten = /* @__PURE__ */ curry(lighten);
    curriedSaturate = /* @__PURE__ */ curry(saturate);
    curriedTransparentize = /* @__PURE__ */ curry(transparentize);
    positionMap = ["absolute", "fixed", "relative", "static", "sticky"];
  }
});

// ../node_modules/reakit/es/_rollupPluginBabelHelpers-1f0bf8c2.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys3 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread2(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3] != null ? arguments[i3] : {};
    if (i3 % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var init_rollupPluginBabelHelpers_1f0bf8c2 = __esm({
  "../node_modules/reakit/es/_rollupPluginBabelHelpers-1f0bf8c2.js"() {
  }
});

// ../node_modules/reakit-system/es/SystemContext.js
var import_react13, SystemContext;
var init_SystemContext = __esm({
  "../node_modules/reakit-system/es/SystemContext.js"() {
    import_react13 = __toModule(require_react());
    SystemContext = /* @__PURE__ */ (0, import_react13.createContext)({});
  }
});

// ../node_modules/reakit-system/es/_rollupPluginBabelHelpers-0c84a174.js
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys2(object, enumerableOnly) {
  var keys3 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread22(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3] != null ? arguments[i3] : {};
    if (i3 % 2) {
      ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray(o3, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++)
    arr2[i3] = arr[i3];
  return arr2;
}
function _createForOfIteratorHelperLoose(o3, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o3[Symbol.iterator] == null) {
    if (Array.isArray(o3) || (it = _unsupportedIterableToArray(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
      if (it)
        o3 = it;
      var i3 = 0;
      return function() {
        if (i3 >= o3.length)
          return {
            done: true
          };
        return {
          done: false,
          value: o3[i3++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  it = o3[Symbol.iterator]();
  return it.next.bind(it);
}
var init_rollupPluginBabelHelpers_0c84a174 = __esm({
  "../node_modules/reakit-system/es/_rollupPluginBabelHelpers-0c84a174.js"() {
  }
});

// ../node_modules/reakit-system/es/useCreateElement.js
function isRenderProp(children) {
  return typeof children === "function";
}
var import_react14, useCreateElement;
var init_useCreateElement = __esm({
  "../node_modules/reakit-system/es/useCreateElement.js"() {
    import_react14 = __toModule(require_react());
    init_SystemContext();
    init_rollupPluginBabelHelpers_0c84a174();
    useCreateElement = function useCreateElement2(type, props, children) {
      if (children === void 0) {
        children = props.children;
      }
      var context3 = (0, import_react14.useContext)(SystemContext);
      if (context3.useCreateElement) {
        return context3.useCreateElement(type, props, children);
      }
      if (typeof type === "string" && isRenderProp(children)) {
        var _3 = props.children, rest = _objectWithoutPropertiesLoose2(props, ["children"]);
        return children(rest);
      }
      return /* @__PURE__ */ (0, import_react14.createElement)(type, props, children);
    };
  }
});

// ../node_modules/reakit-utils/es/_rollupPluginBabelHelpers-1f0bf8c2.js
function _defineProperty3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys3(object, enumerableOnly) {
  var keys3 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread23(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3] != null ? arguments[i3] : {};
    if (i3 % 2) {
      ownKeys3(Object(source), true).forEach(function(key) {
        _defineProperty3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray2(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray2(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray2(o3, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++)
    arr2[i3] = arr[i3];
  return arr2;
}
function _createForOfIteratorHelperLoose2(o3, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o3[Symbol.iterator] == null) {
    if (Array.isArray(o3) || (it = _unsupportedIterableToArray2(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
      if (it)
        o3 = it;
      var i3 = 0;
      return function() {
        if (i3 >= o3.length)
          return {
            done: true
          };
        return {
          done: false,
          value: o3[i3++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  it = o3[Symbol.iterator]();
  return it.next.bind(it);
}
var init_rollupPluginBabelHelpers_1f0bf8c22 = __esm({
  "../node_modules/reakit-utils/es/_rollupPluginBabelHelpers-1f0bf8c2.js"() {
  }
});

// ../node_modules/reakit-utils/es/isObject.js
function isObject2(arg) {
  return typeof arg === "object" && arg != null;
}
var init_isObject2 = __esm({
  "../node_modules/reakit-utils/es/isObject.js"() {
  }
});

// ../node_modules/reakit-utils/es/isPlainObject.js
function isPlainObject2(arg) {
  var _proto$constructor;
  if (!isObject2(arg))
    return false;
  var proto = Object.getPrototypeOf(arg);
  if (proto == null)
    return true;
  return ((_proto$constructor = proto.constructor) === null || _proto$constructor === void 0 ? void 0 : _proto$constructor.toString()) === Object.toString();
}
var init_isPlainObject2 = __esm({
  "../node_modules/reakit-utils/es/isPlainObject.js"() {
    init_isObject2();
  }
});

// ../node_modules/reakit-utils/es/splitProps.js
function __deprecatedSplitProps(props, keys3) {
  var propsKeys = Object.keys(props);
  var picked = {};
  var omitted = {};
  for (var _i = 0, _propsKeys = propsKeys; _i < _propsKeys.length; _i++) {
    var key = _propsKeys[_i];
    if (keys3.indexOf(key) >= 0) {
      picked[key] = props[key];
    } else {
      omitted[key] = props[key];
    }
  }
  return [picked, omitted];
}
function splitProps(props, keys3) {
  if (keys3 === void 0) {
    keys3 = [];
  }
  if (!isPlainObject2(props.state)) {
    return __deprecatedSplitProps(props, keys3);
  }
  var _deprecatedSplitProp = __deprecatedSplitProps(props, [].concat(keys3, ["state"])), picked = _deprecatedSplitProp[0], omitted = _deprecatedSplitProp[1];
  var state = picked.state, restPicked = _objectWithoutPropertiesLoose3(picked, ["state"]);
  return [_objectSpread23(_objectSpread23({}, state), restPicked), omitted];
}
var init_splitProps = __esm({
  "../node_modules/reakit-utils/es/splitProps.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c22();
    init_isPlainObject2();
  }
});

// ../node_modules/reakit-utils/es/shallowEqual.js
function shallowEqual(objA, objB) {
  if (objA === objB)
    return true;
  if (!objA)
    return false;
  if (!objB)
    return false;
  if (typeof objA !== "object")
    return false;
  if (typeof objB !== "object")
    return false;
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var length = aKeys.length;
  if (bKeys.length !== length)
    return false;
  for (var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++) {
    var key = _aKeys[_i];
    if (objA[key] !== objB[key]) {
      return false;
    }
  }
  return true;
}
var init_shallowEqual = __esm({
  "../node_modules/reakit-utils/es/shallowEqual.js"() {
  }
});

// ../node_modules/reakit-utils/es/normalizePropsAreEqual.js
function normalizePropsAreEqual(propsAreEqual2) {
  if (propsAreEqual2.name === "normalizePropsAreEqualInner") {
    return propsAreEqual2;
  }
  return function normalizePropsAreEqualInner(prev, next) {
    if (!isPlainObject2(prev.state) || !isPlainObject2(next.state)) {
      return propsAreEqual2(prev, next);
    }
    return propsAreEqual2(_objectSpread23(_objectSpread23({}, prev.state), prev), _objectSpread23(_objectSpread23({}, next.state), next));
  };
}
var init_normalizePropsAreEqual = __esm({
  "../node_modules/reakit-utils/es/normalizePropsAreEqual.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c22();
    init_isPlainObject2();
  }
});

// ../node_modules/reakit-system/es/createComponent.js
function forwardRef(component) {
  return /* @__PURE__ */ (0, import_react15.forwardRef)(component);
}
function memo(component, propsAreEqual2) {
  return /* @__PURE__ */ (0, import_react15.memo)(component, propsAreEqual2);
}
function createComponent(_ref) {
  var type = _ref.as, useHook = _ref.useHook, shouldMemo = _ref.memo, _ref$propsAreEqual = _ref.propsAreEqual, propsAreEqual2 = _ref$propsAreEqual === void 0 ? useHook === null || useHook === void 0 ? void 0 : useHook.unstable_propsAreEqual : _ref$propsAreEqual, _ref$keys = _ref.keys, keys3 = _ref$keys === void 0 ? (useHook === null || useHook === void 0 ? void 0 : useHook.__keys) || [] : _ref$keys, _ref$useCreateElement = _ref.useCreateElement, useCreateElement$1 = _ref$useCreateElement === void 0 ? useCreateElement : _ref$useCreateElement;
  var Comp = function Comp2(_ref2, ref) {
    var _ref2$as = _ref2.as, as = _ref2$as === void 0 ? type : _ref2$as, props = _objectWithoutPropertiesLoose2(_ref2, ["as"]);
    if (useHook) {
      var _as$render;
      var _splitProps = splitProps(props, keys3), _options = _splitProps[0], htmlProps = _splitProps[1];
      var _useHook = useHook(_options, _objectSpread22({
        ref
      }, htmlProps)), wrapElement = _useHook.wrapElement, elementProps = _objectWithoutPropertiesLoose2(_useHook, ["wrapElement"]);
      var asKeys = ((_as$render = as.render) === null || _as$render === void 0 ? void 0 : _as$render.__keys) || as.__keys;
      var asOptions = asKeys && splitProps(props, asKeys)[0];
      var allProps = asOptions ? _objectSpread22(_objectSpread22({}, elementProps), asOptions) : elementProps;
      var _element = useCreateElement$1(as, allProps);
      if (wrapElement) {
        return wrapElement(_element);
      }
      return _element;
    }
    return useCreateElement$1(as, _objectSpread22({
      ref
    }, props));
  };
  if (useHook) {
    Comp.displayName = useHook.name.replace(/^(unstable_)?use/, "");
  }
  Comp = forwardRef(Comp);
  if (shouldMemo) {
    Comp = memo(Comp, propsAreEqual2 && normalizePropsAreEqual(propsAreEqual2));
  }
  Comp.__keys = keys3;
  Comp.unstable_propsAreEqual = normalizePropsAreEqual(propsAreEqual2 || shallowEqual);
  return Comp;
}
var import_react15;
var init_createComponent = __esm({
  "../node_modules/reakit-system/es/createComponent.js"() {
    import_react15 = __toModule(require_react());
    init_rollupPluginBabelHelpers_0c84a174();
    init_useCreateElement();
    init_splitProps();
    init_shallowEqual();
    init_normalizePropsAreEqual();
  }
});

// ../node_modules/reakit-system/es/useToken.js
function useToken(token, defaultValue) {
  (0, import_react16.useDebugValue)(token);
  var context3 = (0, import_react16.useContext)(SystemContext);
  return context3[token] != null ? context3[token] : defaultValue;
}
var import_react16;
var init_useToken = __esm({
  "../node_modules/reakit-system/es/useToken.js"() {
    import_react16 = __toModule(require_react());
    init_SystemContext();
  }
});

// ../node_modules/reakit-system/es/useProps.js
function useProps(name, options2, htmlProps) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (htmlProps === void 0) {
    htmlProps = {};
  }
  var hookName = "use" + name + "Props";
  (0, import_react17.useDebugValue)(hookName);
  var useHook = useToken(hookName);
  if (useHook) {
    return useHook(options2, htmlProps);
  }
  return htmlProps;
}
var import_react17;
var init_useProps = __esm({
  "../node_modules/reakit-system/es/useProps.js"() {
    import_react17 = __toModule(require_react());
    init_useToken();
  }
});

// ../node_modules/reakit-system/es/useOptions.js
function useOptions(name, options2, htmlProps) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (htmlProps === void 0) {
    htmlProps = {};
  }
  var hookName = "use" + name + "Options";
  (0, import_react18.useDebugValue)(hookName);
  var useHook = useToken(hookName);
  if (useHook) {
    return _objectSpread22(_objectSpread22({}, options2), useHook(options2, htmlProps));
  }
  return options2;
}
var import_react18;
var init_useOptions = __esm({
  "../node_modules/reakit-system/es/useOptions.js"() {
    import_react18 = __toModule(require_react());
    init_useToken();
    init_rollupPluginBabelHelpers_0c84a174();
  }
});

// ../node_modules/reakit-utils/es/toArray.js
function toArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }
  return typeof arg !== "undefined" ? [arg] : [];
}
var init_toArray = __esm({
  "../node_modules/reakit-utils/es/toArray.js"() {
  }
});

// ../node_modules/reakit-system/es/createHook.js
function createHook(options2) {
  var _options$useState, _composedHooks$;
  var composedHooks = toArray(options2.compose);
  var __useOptions = function __useOptions2(hookOptions, htmlProps) {
    if (options2.useOptions) {
      hookOptions = options2.useOptions(hookOptions, htmlProps);
    }
    if (options2.name) {
      hookOptions = useOptions(options2.name, hookOptions, htmlProps);
    }
    if (options2.compose) {
      for (var _iterator = _createForOfIteratorHelperLoose(composedHooks), _step; !(_step = _iterator()).done; ) {
        var hook = _step.value;
        hookOptions = hook.__useOptions(hookOptions, htmlProps);
      }
    }
    return hookOptions;
  };
  var useHook = function useHook2(hookOptions, htmlProps, unstable_ignoreUseOptions) {
    if (hookOptions === void 0) {
      hookOptions = {};
    }
    if (htmlProps === void 0) {
      htmlProps = {};
    }
    if (unstable_ignoreUseOptions === void 0) {
      unstable_ignoreUseOptions = false;
    }
    if (!unstable_ignoreUseOptions) {
      hookOptions = __useOptions(hookOptions, htmlProps);
    }
    if (options2.useProps) {
      htmlProps = options2.useProps(hookOptions, htmlProps);
    }
    if (options2.name) {
      htmlProps = useProps(options2.name, hookOptions, htmlProps);
    }
    if (options2.compose) {
      if (options2.useComposeOptions) {
        hookOptions = options2.useComposeOptions(hookOptions, htmlProps);
      }
      if (options2.useComposeProps) {
        htmlProps = options2.useComposeProps(hookOptions, htmlProps);
      } else {
        for (var _iterator2 = _createForOfIteratorHelperLoose(composedHooks), _step2; !(_step2 = _iterator2()).done; ) {
          var hook = _step2.value;
          htmlProps = hook(hookOptions, htmlProps, true);
        }
      }
    }
    var finalHTMLProps = {};
    var definedHTMLProps = htmlProps || {};
    for (var prop in definedHTMLProps) {
      if (definedHTMLProps[prop] !== void 0) {
        finalHTMLProps[prop] = definedHTMLProps[prop];
      }
    }
    return finalHTMLProps;
  };
  useHook.__useOptions = __useOptions;
  var composedKeys = composedHooks.reduce(function(keys3, hook) {
    keys3.push.apply(keys3, hook.__keys || []);
    return keys3;
  }, []);
  useHook.__keys = [].concat(composedKeys, ((_options$useState = options2.useState) === null || _options$useState === void 0 ? void 0 : _options$useState.__keys) || [], options2.keys || []);
  useHook.unstable_propsAreEqual = options2.propsAreEqual || ((_composedHooks$ = composedHooks[0]) === null || _composedHooks$ === void 0 ? void 0 : _composedHooks$.unstable_propsAreEqual) || shallowEqual;
  if (options2.name) {
    Object.defineProperty(useHook, "name", {
      value: "use" + options2.name
    });
  }
  return useHook;
}
var import_react19;
var init_createHook = __esm({
  "../node_modules/reakit-system/es/createHook.js"() {
    import_react19 = __toModule(require_react());
    init_useProps();
    init_rollupPluginBabelHelpers_0c84a174();
    init_useOptions();
    init_shallowEqual();
    init_toArray();
  }
});

// ../node_modules/reakit-utils/es/useForkRef.js
function setRef(ref, value) {
  if (value === void 0) {
    value = null;
  }
  if (!ref)
    return;
  if (typeof ref === "function") {
    ref(value);
  } else {
    ref.current = value;
  }
}
function useForkRef(refA, refB) {
  return (0, import_react20.useMemo)(function() {
    if (refA == null && refB == null) {
      return null;
    }
    return function(value) {
      setRef(refA, value);
      setRef(refB, value);
    };
  }, [refA, refB]);
}
var import_react20;
var init_useForkRef = __esm({
  "../node_modules/reakit-utils/es/useForkRef.js"() {
    import_react20 = __toModule(require_react());
  }
});

// ../node_modules/reakit-utils/es/isButton.js
function isButton(element) {
  if (element.tagName === "BUTTON")
    return true;
  if (element.tagName === "INPUT") {
    var input = element;
    return buttonInputTypes.indexOf(input.type) !== -1;
  }
  return false;
}
var buttonInputTypes;
var init_isButton = __esm({
  "../node_modules/reakit-utils/es/isButton.js"() {
    buttonInputTypes = ["button", "color", "file", "image", "reset", "submit"];
  }
});

// ../node_modules/reakit-utils/es/flatten.js
function flatten(array) {
  var flat = [];
  for (var _iterator = _createForOfIteratorHelperLoose2(array), _step; !(_step = _iterator()).done; ) {
    var maybeArray = _step.value;
    if (Array.isArray(maybeArray)) {
      flat.push.apply(flat, flatten(maybeArray));
    } else {
      flat.push(maybeArray);
    }
  }
  return flat;
}
var init_flatten = __esm({
  "../node_modules/reakit-utils/es/flatten.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c22();
  }
});

// ../node_modules/reakit-warning/es/warning.js
function warning(condition) {
  if (true) {
    var _console;
    if (!condition)
      return;
    for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      messages[_key - 1] = arguments[_key];
    }
    var warns = flatten(messages.map(function(message) {
      return [message, "\n"];
    }));
    (_console = console).warn.apply(_console, warns.slice(0, -1));
    try {
      throw Error(warns.join(""));
    } catch (x4) {
    }
  }
}
var init_warning = __esm({
  "../node_modules/reakit-warning/es/warning.js"() {
    init_flatten();
  }
});

// ../node_modules/reakit-warning/es/useWarning.js
var import_react21;
var init_useWarning = __esm({
  "../node_modules/reakit-warning/es/useWarning.js"() {
    init_warning();
    import_react21 = __toModule(require_react());
  }
});

// ../node_modules/reakit-warning/es/index.js
var import_react22;
var init_es = __esm({
  "../node_modules/reakit-warning/es/index.js"() {
    init_warning();
    import_react22 = __toModule(require_react());
    init_useWarning();
  }
});

// ../node_modules/reakit-utils/es/getDocument.js
function getDocument(element) {
  return element ? element.ownerDocument || element : document;
}
var init_getDocument = __esm({
  "../node_modules/reakit-utils/es/getDocument.js"() {
  }
});

// ../node_modules/reakit-utils/es/getWindow.js
function getWindow(element) {
  if (!element) {
    return _window;
  }
  return getDocument(element).defaultView || _window;
}
var _window;
var init_getWindow = __esm({
  "../node_modules/reakit-utils/es/getWindow.js"() {
    init_getDocument();
    try {
      _window = window;
    } catch (e2) {
    }
  }
});

// ../node_modules/reakit-utils/es/canUseDOM.js
function checkIsBrowser() {
  var _window2 = getWindow();
  return Boolean(typeof _window2 !== "undefined" && _window2.document && _window2.document.createElement);
}
var canUseDOM;
var init_canUseDOM = __esm({
  "../node_modules/reakit-utils/es/canUseDOM.js"() {
    init_getWindow();
    canUseDOM = checkIsBrowser();
  }
});

// ../node_modules/reakit-utils/es/useIsomorphicEffect.js
var import_react23, useIsomorphicEffect;
var init_useIsomorphicEffect = __esm({
  "../node_modules/reakit-utils/es/useIsomorphicEffect.js"() {
    import_react23 = __toModule(require_react());
    init_canUseDOM();
    useIsomorphicEffect = !canUseDOM ? import_react23.useEffect : import_react23.useLayoutEffect;
  }
});

// ../node_modules/reakit-utils/es/useLiveRef.js
function useLiveRef(value) {
  var ref = (0, import_react24.useRef)(value);
  useIsomorphicEffect(function() {
    ref.current = value;
  });
  return ref;
}
var import_react24;
var init_useLiveRef = __esm({
  "../node_modules/reakit-utils/es/useLiveRef.js"() {
    import_react24 = __toModule(require_react());
    init_useIsomorphicEffect();
  }
});

// ../node_modules/reakit-utils/es/isSelfTarget.js
function isSelfTarget(event) {
  return event.target === event.currentTarget;
}
var init_isSelfTarget = __esm({
  "../node_modules/reakit-utils/es/isSelfTarget.js"() {
  }
});

// ../node_modules/reakit-utils/es/getActiveElement.js
function getActiveElement(element) {
  var _getDocument = getDocument(element), activeElement = _getDocument.activeElement;
  if (!(activeElement !== null && activeElement !== void 0 && activeElement.nodeName)) {
    return null;
  }
  return activeElement;
}
var init_getActiveElement = __esm({
  "../node_modules/reakit-utils/es/getActiveElement.js"() {
    init_getDocument();
  }
});

// ../node_modules/reakit-utils/es/contains.js
function contains(parent, child) {
  return parent === child || parent.contains(child);
}
var init_contains = __esm({
  "../node_modules/reakit-utils/es/contains.js"() {
  }
});

// ../node_modules/reakit-utils/es/hasFocusWithin.js
function hasFocusWithin(element) {
  var activeElement = getActiveElement(element);
  if (!activeElement)
    return false;
  if (contains(element, activeElement))
    return true;
  var activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant)
    return false;
  if (activeDescendant === element.id)
    return true;
  return !!element.querySelector("#" + activeDescendant);
}
var init_hasFocusWithin = __esm({
  "../node_modules/reakit-utils/es/hasFocusWithin.js"() {
    init_getActiveElement();
    init_contains();
  }
});

// ../node_modules/reakit-utils/es/isPortalEvent.js
function isPortalEvent(event) {
  return !contains(event.currentTarget, event.target);
}
var init_isPortalEvent = __esm({
  "../node_modules/reakit-utils/es/isPortalEvent.js"() {
    init_contains();
  }
});

// ../node_modules/reakit-utils/es/dom.js
function isUA(string) {
  if (!canUseDOM)
    return false;
  return window.navigator.userAgent.indexOf(string) !== -1;
}
var init_dom = __esm({
  "../node_modules/reakit-utils/es/dom.js"() {
    init_canUseDOM();
  }
});

// ../node_modules/reakit-utils/es/matches.js
function matches(element, selectors) {
  if ("matches" in element) {
    return element.matches(selectors);
  }
  if ("msMatchesSelector" in element) {
    return element.msMatchesSelector(selectors);
  }
  return element.webkitMatchesSelector(selectors);
}
var init_matches = __esm({
  "../node_modules/reakit-utils/es/matches.js"() {
  }
});

// ../node_modules/reakit-utils/es/tabbable.js
function isVisible(element) {
  var htmlElement = element;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}
function isFocusable(element) {
  return matches(element, selector) && isVisible(element);
}
var selector;
var init_tabbable = __esm({
  "../node_modules/reakit-utils/es/tabbable.js"() {
    init_matches();
    selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
  }
});

// ../node_modules/reakit/es/Role/Role.js
var ROLE_KEYS, useRole, Role;
var init_Role = __esm({
  "../node_modules/reakit/es/Role/Role.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c2();
    init_createComponent();
    init_createHook();
    init_shallowEqual();
    ROLE_KEYS = ["unstable_system"];
    useRole = createHook({
      name: "Role",
      keys: ROLE_KEYS,
      propsAreEqual: function propsAreEqual(prev, next) {
        var prevSystem = prev.unstable_system, prevProps = _objectWithoutPropertiesLoose(prev, ["unstable_system"]);
        var nextSystem = next.unstable_system, nextProps = _objectWithoutPropertiesLoose(next, ["unstable_system"]);
        if (prevSystem !== nextSystem && !shallowEqual(prevSystem, nextSystem)) {
          return false;
        }
        return shallowEqual(prevProps, nextProps);
      }
    });
    Role = createComponent({
      as: "div",
      useHook: useRole
    });
  }
});

// ../node_modules/reakit/es/Tabbable/Tabbable.js
function focusIfNeeded(element) {
  if (!hasFocusWithin(element) && isFocusable(element)) {
    element.focus();
  }
}
function isNativeTabbable(element) {
  return element.tagName === "BUTTON" || element.tagName === "INPUT" || element.tagName === "SELECT" || element.tagName === "TEXTAREA" || element.tagName === "A";
}
function supportsDisabledAttribute(element) {
  return element.tagName === "BUTTON" || element.tagName === "INPUT" || element.tagName === "SELECT" || element.tagName === "TEXTAREA";
}
function getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex) {
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) {
      return -1;
    }
    return void 0;
  }
  if (nativeTabbable) {
    return htmlTabIndex;
  }
  return htmlTabIndex || 0;
}
function useDisableEvent(htmlEventRef, disabled) {
  return (0, import_react25.useCallback)(function(event) {
    var _htmlEventRef$current;
    (_htmlEventRef$current = htmlEventRef.current) === null || _htmlEventRef$current === void 0 ? void 0 : _htmlEventRef$current.call(htmlEventRef, event);
    if (event.defaultPrevented)
      return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, [htmlEventRef, disabled]);
}
var import_react25, TABBABLE_KEYS, isSafariOrFirefoxOnMac, useTabbable, Tabbable;
var init_Tabbable = __esm({
  "../node_modules/reakit/es/Tabbable/Tabbable.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c2();
    init_createComponent();
    init_createHook();
    import_react25 = __toModule(require_react());
    init_useForkRef();
    init_isButton();
    init_es();
    init_useLiveRef();
    init_useIsomorphicEffect();
    init_hasFocusWithin();
    init_isPortalEvent();
    init_dom();
    init_tabbable();
    init_Role();
    TABBABLE_KEYS = ["disabled", "focusable"];
    isSafariOrFirefoxOnMac = isUA("Mac") && !isUA("Chrome") && (isUA("Safari") || isUA("Firefox"));
    useTabbable = createHook({
      name: "Tabbable",
      compose: useRole,
      keys: TABBABLE_KEYS,
      useOptions: function useOptions2(options2, _ref) {
        var disabled = _ref.disabled;
        return _objectSpread2({
          disabled
        }, options2);
      },
      useProps: function useProps2(options2, _ref2) {
        var htmlRef = _ref2.ref, htmlTabIndex = _ref2.tabIndex, htmlOnClickCapture = _ref2.onClickCapture, htmlOnMouseDownCapture = _ref2.onMouseDownCapture, htmlOnMouseDown = _ref2.onMouseDown, htmlOnKeyPressCapture = _ref2.onKeyPressCapture, htmlStyle = _ref2.style, htmlProps = _objectWithoutPropertiesLoose(_ref2, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]);
        var ref = (0, import_react25.useRef)(null);
        var onClickCaptureRef = useLiveRef(htmlOnClickCapture);
        var onMouseDownCaptureRef = useLiveRef(htmlOnMouseDownCapture);
        var onMouseDownRef = useLiveRef(htmlOnMouseDown);
        var onKeyPressCaptureRef = useLiveRef(htmlOnKeyPressCapture);
        var trulyDisabled = !!options2.disabled && !options2.focusable;
        var _React$useState = (0, import_react25.useState)(true), nativeTabbable = _React$useState[0], setNativeTabbable = _React$useState[1];
        var _React$useState2 = (0, import_react25.useState)(true), supportsDisabled = _React$useState2[0], setSupportsDisabled = _React$useState2[1];
        var style = options2.disabled ? _objectSpread2({
          pointerEvents: "none"
        }, htmlStyle) : htmlStyle;
        useIsomorphicEffect(function() {
          var tabbable = ref.current;
          if (!tabbable) {
            true ? warning(true, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable") : void 0;
            return;
          }
          if (!isNativeTabbable(tabbable)) {
            setNativeTabbable(false);
          }
          if (!supportsDisabledAttribute(tabbable)) {
            setSupportsDisabled(false);
          }
        }, []);
        var onClickCapture = useDisableEvent(onClickCaptureRef, options2.disabled);
        var onMouseDownCapture = useDisableEvent(onMouseDownCaptureRef, options2.disabled);
        var onKeyPressCapture = useDisableEvent(onKeyPressCaptureRef, options2.disabled);
        var onMouseDown = (0, import_react25.useCallback)(function(event) {
          var _onMouseDownRef$curre;
          (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 ? void 0 : _onMouseDownRef$curre.call(onMouseDownRef, event);
          var element = event.currentTarget;
          if (event.defaultPrevented)
            return;
          if (!isSafariOrFirefoxOnMac)
            return;
          if (isPortalEvent(event))
            return;
          if (!isButton(element))
            return;
          var raf = requestAnimationFrame(function() {
            element.removeEventListener("mouseup", focusImmediately, true);
            focusIfNeeded(element);
          });
          var focusImmediately = function focusImmediately2() {
            cancelAnimationFrame(raf);
            focusIfNeeded(element);
          };
          element.addEventListener("mouseup", focusImmediately, {
            once: true,
            capture: true
          });
        }, []);
        return _objectSpread2({
          ref: useForkRef(ref, htmlRef),
          style,
          tabIndex: getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex),
          disabled: trulyDisabled && supportsDisabled ? true : void 0,
          "aria-disabled": options2.disabled ? true : void 0,
          onClickCapture,
          onMouseDownCapture,
          onMouseDown,
          onKeyPressCapture
        }, htmlProps);
      }
    });
    Tabbable = createComponent({
      as: "div",
      useHook: useTabbable
    });
  }
});

// ../node_modules/reakit/es/Clickable/Clickable.js
function isNativeClick(event) {
  var element = event.currentTarget;
  if (!event.isTrusted)
    return false;
  return isButton(element) || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "A" || element.tagName === "SELECT";
}
var import_react26, CLICKABLE_KEYS, useClickable, Clickable;
var init_Clickable = __esm({
  "../node_modules/reakit/es/Clickable/Clickable.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c2();
    init_createComponent();
    init_createHook();
    import_react26 = __toModule(require_react());
    init_isButton();
    init_es();
    init_useLiveRef();
    init_isSelfTarget();
    init_Tabbable();
    CLICKABLE_KEYS = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
    useClickable = createHook({
      name: "Clickable",
      compose: useTabbable,
      keys: CLICKABLE_KEYS,
      useOptions: function useOptions3(_ref) {
        var _ref$unstable_clickOn = _ref.unstable_clickOnEnter, unstable_clickOnEnter = _ref$unstable_clickOn === void 0 ? true : _ref$unstable_clickOn, _ref$unstable_clickOn2 = _ref.unstable_clickOnSpace, unstable_clickOnSpace = _ref$unstable_clickOn2 === void 0 ? true : _ref$unstable_clickOn2, options2 = _objectWithoutPropertiesLoose(_ref, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
        return _objectSpread2({
          unstable_clickOnEnter,
          unstable_clickOnSpace
        }, options2);
      },
      useProps: function useProps3(options2, _ref2) {
        var htmlOnKeyDown = _ref2.onKeyDown, htmlOnKeyUp = _ref2.onKeyUp, htmlProps = _objectWithoutPropertiesLoose(_ref2, ["onKeyDown", "onKeyUp"]);
        var _React$useState = (0, import_react26.useState)(false), active = _React$useState[0], setActive = _React$useState[1];
        var onKeyDownRef = useLiveRef(htmlOnKeyDown);
        var onKeyUpRef = useLiveRef(htmlOnKeyUp);
        var onKeyDown = (0, import_react26.useCallback)(function(event) {
          var _onKeyDownRef$current;
          (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
          if (event.defaultPrevented)
            return;
          if (options2.disabled)
            return;
          if (event.metaKey)
            return;
          if (!isSelfTarget(event))
            return;
          var isEnter = options2.unstable_clickOnEnter && event.key === "Enter";
          var isSpace = options2.unstable_clickOnSpace && event.key === " ";
          if (isEnter || isSpace) {
            if (isNativeClick(event))
              return;
            event.preventDefault();
            if (isEnter) {
              event.currentTarget.click();
            } else if (isSpace) {
              setActive(true);
            }
          }
        }, [options2.disabled, options2.unstable_clickOnEnter, options2.unstable_clickOnSpace]);
        var onKeyUp = (0, import_react26.useCallback)(function(event) {
          var _onKeyUpRef$current;
          (_onKeyUpRef$current = onKeyUpRef.current) === null || _onKeyUpRef$current === void 0 ? void 0 : _onKeyUpRef$current.call(onKeyUpRef, event);
          if (event.defaultPrevented)
            return;
          if (options2.disabled)
            return;
          if (event.metaKey)
            return;
          var isSpace = options2.unstable_clickOnSpace && event.key === " ";
          if (active && isSpace) {
            setActive(false);
            event.currentTarget.click();
          }
        }, [options2.disabled, options2.unstable_clickOnSpace, active]);
        return _objectSpread2({
          "data-active": active || void 0,
          onKeyDown,
          onKeyUp
        }, htmlProps);
      }
    });
    Clickable = createComponent({
      as: "button",
      memo: true,
      useHook: useClickable
    });
  }
});

// ../node_modules/reakit/es/Button/Button.js
var import_react27, BUTTON_KEYS, useButton, Button;
var init_Button = __esm({
  "../node_modules/reakit/es/Button/Button.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c2();
    init_createComponent();
    init_createHook();
    import_react27 = __toModule(require_react());
    init_useForkRef();
    init_isButton();
    init_es();
    init_Clickable();
    BUTTON_KEYS = [];
    useButton = createHook({
      name: "Button",
      compose: useClickable,
      keys: BUTTON_KEYS,
      useProps: function useProps4(_3, _ref) {
        var htmlRef = _ref.ref, htmlProps = _objectWithoutPropertiesLoose(_ref, ["ref"]);
        var ref = (0, import_react27.useRef)(null);
        var _React$useState = (0, import_react27.useState)(void 0), role = _React$useState[0], setRole = _React$useState[1];
        var _React$useState2 = (0, import_react27.useState)("button"), type = _React$useState2[0], setType = _React$useState2[1];
        (0, import_react27.useEffect)(function() {
          var element = ref.current;
          if (!element) {
            true ? warning(true, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button") : void 0;
            return;
          }
          if (!isButton(element)) {
            if (element.tagName !== "A") {
              setRole("button");
            }
            setType(void 0);
          }
        }, []);
        return _objectSpread2({
          ref: useForkRef(ref, htmlRef),
          role,
          type
        }, htmlProps);
      }
    });
    Button = createComponent({
      as: "button",
      memo: true,
      useHook: useButton
    });
  }
});

// ../node_modules/reakit/es/Group/Group.js
var GROUP_KEYS, useGroup, Group;
var init_Group = __esm({
  "../node_modules/reakit/es/Group/Group.js"() {
    init_rollupPluginBabelHelpers_1f0bf8c2();
    init_createComponent();
    init_createHook();
    init_Role();
    GROUP_KEYS = [];
    useGroup = createHook({
      name: "Group",
      compose: useRole,
      keys: GROUP_KEYS,
      useProps: function useProps5(_3, htmlProps) {
        return _objectSpread2({
          role: "group"
        }, htmlProps);
      }
    });
    Group = createComponent({
      as: "div",
      useHook: useGroup
    });
  }
});

// ../node_modules/reakit/es/Portal/Portal.js
function getBodyElement() {
  return canUseDOM ? document.body : null;
}
function Portal(_ref) {
  var children = _ref.children;
  var context3 = (0, import_react28.useContext)(PortalContext) || getBodyElement();
  var _React$useState = (0, import_react28.useState)(function() {
    if (canUseDOM) {
      var element = document.createElement("div");
      element.className = Portal.__className;
      return element;
    }
    return null;
  }), hostNode = _React$useState[0];
  useIsomorphicEffect(function() {
    if (!hostNode || !context3)
      return void 0;
    context3.appendChild(hostNode);
    return function() {
      context3.removeChild(hostNode);
    };
  }, [hostNode, context3]);
  if (hostNode) {
    return /* @__PURE__ */ (0, import_react_dom2.createPortal)(/* @__PURE__ */ (0, import_react28.createElement)(PortalContext.Provider, {
      value: hostNode
    }, children), hostNode);
  }
  return null;
}
var import_react28, import_react_dom2, PortalContext;
var init_Portal = __esm({
  "../node_modules/reakit/es/Portal/Portal.js"() {
    import_react28 = __toModule(require_react());
    init_useIsomorphicEffect();
    init_canUseDOM();
    import_react_dom2 = __toModule(require_react_dom());
    PortalContext = /* @__PURE__ */ (0, import_react28.createContext)(getBodyElement());
    Portal.__className = "__reakit-portal";
    Portal.__selector = "." + Portal.__className;
  }
});

// ../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var hasPassiveEvents, passiveTestOptions, isIosDevice;
var init_bodyScrollLock_esm = __esm({
  "../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js"() {
    hasPassiveEvents = false;
    if (typeof window !== "undefined") {
      passiveTestOptions = {
        get passive() {
          hasPassiveEvents = true;
          return void 0;
        }
      };
      window.addEventListener("testPassive", null, passiveTestOptions);
      window.removeEventListener("testPassive", null, passiveTestOptions);
    }
    isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
  }
});

// ../node_modules/reakit/es/index.js
var import_react29, import_react_dom3;
var init_es2 = __esm({
  "../node_modules/reakit/es/index.js"() {
    import_react29 = __toModule(require_react());
    init_es();
    init_Button();
    init_Group();
    import_react_dom3 = __toModule(require_react_dom());
    init_Portal();
    init_bodyScrollLock_esm();
    init_warning();
  }
});

// studio/src/css.tsx
function withStyledShadow(Comp) {
  return (props) => /* @__PURE__ */ import_react30.default.createElement(ProvideStyledShadow, null, /* @__PURE__ */ import_react30.default.createElement(Comp, __spreadValues({}, props)));
}
var import_react30, import_react_dom4, pointerEventsAutoInNormalMode, theme, GlobalStyle, PortalLayer, ProvideStyles, ProvideStyledShadow;
var init_css = __esm({
  "studio/src/css.tsx"() {
    init_polished_esm();
    init_styled_components_browser_esm();
    init_styled_components_browser_esm();
    import_react30 = __toModule(require_react());
    import_react_dom4 = __toModule(require_react_dom());
    init_es2();
    init_useRefAndState();
    pointerEventsAutoInNormalMode = Ce`
  #pointer-root & {
    pointer-events: none;
  }
  #pointer-root.normal & {
    pointer-events: auto;
  }
`;
    theme = {
      panel: {
        bg: `#282b2f`,
        head: {
          title: {
            color: `#bbb`
          },
          punctuation: {
            color: `#808080`
          }
        },
        body: {
          compoudThing: {
            label: {
              get color() {
                return curriedLighten(0.6, theme.panel.bg);
              }
            }
          }
        }
      }
    };
    GlobalStyle = typeof window !== "undefined" ? We`
  :host {
    all: initial;
    color: white;
    font: 11px -apple-system, BlinkMacSystemFont, Segoe WPC, Segoe Editor,
      HelveticaNeue-Light, Ubuntu, Droid Sans, sans-serif;
  }

  * {
    padding: 0;
    margin: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    list-style: none;
  }
` : {};
    PortalLayer = styled_components_browser_esm_default.div`
  z-index: 51;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  pointer-events: none;
`;
    ProvideStyles = (props) => {
      return /* @__PURE__ */ import_react30.default.createElement(ye, {
        disableVendorPrefixes: true,
        target: props.target
      }, /* @__PURE__ */ import_react30.default.createElement(import_react30.default.Fragment, null, /* @__PURE__ */ import_react30.default.createElement(GlobalStyle, null), props.children));
    };
    ProvideStyledShadow = (props) => {
      const [template, ref] = (0, import_react30.useState)(null);
      const [shadowRoot, setShadowRoot] = (0, import_react30.useState)(null);
      (0, import_react30.useLayoutEffect)(() => {
        if (!template)
          return;
        const shadowRoot2 = template.parentNode.attachShadow({
          mode: "open"
        });
        setShadowRoot(shadowRoot2);
        return () => {
          var _a2;
          (_a2 = template.parentNode) == null ? void 0 : _a2.removeChild(shadowRoot2);
        };
      }, [template]);
      const [portalLayerRef, portalLayer] = useRefAndState(void 0);
      if (!shadowRoot) {
        return /* @__PURE__ */ import_react30.default.createElement("template", {
          ref,
          "shadow-root": "open"
        }, props.children);
      }
      return import_react_dom4.default.createPortal(/* @__PURE__ */ import_react30.default.createElement(ProvideStyles, {
        target: shadowRoot
      }, /* @__PURE__ */ import_react30.default.createElement(import_react30.default.Fragment, null, /* @__PURE__ */ import_react30.default.createElement(PortalLayer, {
        ref: portalLayerRef
      }), /* @__PURE__ */ import_react30.default.createElement(PortalContext.Provider, {
        value: portalLayer
      }, props.children))), shadowRoot);
    };
  }
});

// ../node_modules/react-icons/lib/esm/iconsManifest.js
var init_iconsManifest = __esm({
  "../node_modules/react-icons/lib/esm/iconsManifest.js"() {
  }
});

// ../node_modules/react-icons/lib/esm/iconContext.js
var import_react31, DefaultContext, IconContext;
var init_iconContext = __esm({
  "../node_modules/react-icons/lib/esm/iconContext.js"() {
    import_react31 = __toModule(require_react());
    DefaultContext = {
      color: void 0,
      size: void 0,
      className: void 0,
      style: void 0,
      attr: void 0
    };
    IconContext = import_react31.default.createContext && import_react31.default.createContext(DefaultContext);
  }
});

// ../node_modules/react-icons/lib/esm/iconBase.js
function Tree2Element(tree) {
  return tree && tree.map(function(node, i3) {
    return import_react32.default.createElement(node.tag, __assign({
      key: i3
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return import_react32.default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return import_react32.default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && import_react32.default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? import_react32.default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
var import_react32, __assign, __rest;
var init_iconBase = __esm({
  "../node_modules/react-icons/lib/esm/iconBase.js"() {
    import_react32 = __toModule(require_react());
    init_iconContext();
    __assign = function() {
      __assign = Object.assign || function(t3) {
        for (var s3, i3 = 1, n3 = arguments.length; i3 < n3; i3++) {
          s3 = arguments[i3];
          for (var p3 in s3)
            if (Object.prototype.hasOwnProperty.call(s3, p3))
              t3[p3] = s3[p3];
        }
        return t3;
      };
      return __assign.apply(this, arguments);
    };
    __rest = function(s3, e2) {
      var t3 = {};
      for (var p3 in s3)
        if (Object.prototype.hasOwnProperty.call(s3, p3) && e2.indexOf(p3) < 0)
          t3[p3] = s3[p3];
      if (s3 != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i3 = 0, p3 = Object.getOwnPropertySymbols(s3); i3 < p3.length; i3++) {
          if (e2.indexOf(p3[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s3, p3[i3]))
            t3[p3[i3]] = s3[p3[i3]];
        }
      return t3;
    };
  }
});

// ../node_modules/react-icons/lib/esm/index.js
var init_esm = __esm({
  "../node_modules/react-icons/lib/esm/index.js"() {
    init_iconsManifest();
    init_iconBase();
    init_iconContext();
  }
});

// ../node_modules/react-icons/fa/index.esm.js
var init_index_esm = __esm({
  "../node_modules/react-icons/fa/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/io/index.esm.js
var init_index_esm2 = __esm({
  "../node_modules/react-icons/io/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/io5/index.esm.js
function IoClose(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" } }] })(props);
}
var init_index_esm3 = __esm({
  "../node_modules/react-icons/io5/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/md/index.esm.js
var init_index_esm4 = __esm({
  "../node_modules/react-icons/md/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/ti/index.esm.js
var init_index_esm5 = __esm({
  "../node_modules/react-icons/ti/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/go/index.esm.js
function GoChevronLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 8 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M5.5 3L7 4.5 3.25 8 7 11.5 5.5 13l-5-5 5-5z" } }] })(props);
}
function GoChevronRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 8 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M7.5 8l-5 5L1 11.5 4.75 8 1 4.5 2.5 3l5 5z" } }] })(props);
}
var init_index_esm6 = __esm({
  "../node_modules/react-icons/go/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/fi/index.esm.js
var init_index_esm7 = __esm({
  "../node_modules/react-icons/fi/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/gi/index.esm.js
var init_index_esm8 = __esm({
  "../node_modules/react-icons/gi/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/wi/index.esm.js
var init_index_esm9 = __esm({
  "../node_modules/react-icons/wi/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/di/index.esm.js
var init_index_esm10 = __esm({
  "../node_modules/react-icons/di/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/ai/index.esm.js
var init_index_esm11 = __esm({
  "../node_modules/react-icons/ai/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/bs/index.esm.js
var init_index_esm12 = __esm({
  "../node_modules/react-icons/bs/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/ri/index.esm.js
var init_index_esm13 = __esm({
  "../node_modules/react-icons/ri/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/fc/index.esm.js
var init_index_esm14 = __esm({
  "../node_modules/react-icons/fc/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/gr/index.esm.js
var init_index_esm15 = __esm({
  "../node_modules/react-icons/gr/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/hi/index.esm.js
function HiOutlineChevronRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "none", "viewBox": "0 0 24 24", "stroke": "currentColor" }, "child": [{ "tag": "path", "attr": { "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "2", "d": "M9 5l7 7-7 7" } }] })(props);
}
var init_index_esm16 = __esm({
  "../node_modules/react-icons/hi/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/si/index.esm.js
var init_index_esm17 = __esm({
  "../node_modules/react-icons/si/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/im/index.esm.js
var init_index_esm18 = __esm({
  "../node_modules/react-icons/im/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/bi/index.esm.js
var init_index_esm19 = __esm({
  "../node_modules/react-icons/bi/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/cg/index.esm.js
function CgSelect(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none" }, "child": [{ "tag": "path", "attr": { "d": "M6 9.65685L7.41421 11.0711L11.6569 6.82843L15.8995 11.0711L17.3137 9.65685L11.6569 4L6 9.65685Z", "fill": "currentColor" } }, { "tag": "path", "attr": { "d": "M6 14.4433L7.41421 13.0291L11.6569 17.2717L15.8995 13.0291L17.3137 14.4433L11.6569 20.1001L6 14.4433Z", "fill": "currentColor" } }] })(props);
}
var init_index_esm20 = __esm({
  "../node_modules/react-icons/cg/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/vsc/index.esm.js
function VscTriangleUp(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 16 16", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M14 10.44l-.413.56H2.393L2 10.46 7.627 5h.827L14 10.44z" } }] })(props);
}
var init_index_esm21 = __esm({
  "../node_modules/react-icons/vsc/index.esm.js"() {
    init_esm();
  }
});

// ../node_modules/react-icons/all.js
var init_all = __esm({
  "../node_modules/react-icons/all.js"() {
    init_index_esm();
    init_index_esm2();
    init_index_esm3();
    init_index_esm4();
    init_index_esm5();
    init_index_esm6();
    init_index_esm7();
    init_index_esm8();
    init_index_esm9();
    init_index_esm10();
    init_index_esm11();
    init_index_esm12();
    init_index_esm13();
    init_index_esm14();
    init_index_esm15();
    init_index_esm16();
    init_index_esm17();
    init_index_esm18();
    init_index_esm19();
    init_index_esm20();
    init_index_esm21();
  }
});

// studio/src/propEditors/utils/propNameTextCSS.tsx
var propNameTextCSS;
var init_propNameTextCSS = __esm({
  "studio/src/propEditors/utils/propNameTextCSS.tsx"() {
    init_styled_components_browser_esm();
    propNameTextCSS = Ce`
  font-weight: 300;
  font-size: 11px;
  color: ${(props) => props.isHighlighted === "self" ? "#CCC" : "#919191"};
  text-shadow: 0.5px 0.5px 2px rgba(0, 0, 0, 0.3);
`;
  }
});

// shared/src/utils/pointerDeep.ts
function pointerDeep(base, toAppend) {
  let p3 = base;
  for (const k4 of toAppend) {
    p3 = p3[k4];
  }
  return p3;
}
var init_pointerDeep = __esm({
  "shared/src/utils/pointerDeep.ts"() {
  }
});

// studio/src/panels/SequenceEditorPanel/whatPropIsHighlighted.ts
function createWhatPropIsHighlightedState() {
  let lastLockId2 = 0;
  const whatIsHighlighted = new import_dataverse11.Atom({ hasLock: false });
  return {
    replaceLock(address, cleanup) {
      const lockId = lastLockId2++;
      const existingState = whatIsHighlighted.getState();
      if (existingState.hasLock)
        existingState.cleanup();
      whatIsHighlighted.setState({
        hasLock: true,
        lockId,
        cleanup,
        deepPath: arrayToDeepObject(addressToArray(address))
      });
      return function unlock() {
        const curr = whatIsHighlighted.getState();
        if (curr.hasLock && curr.lockId === lockId) {
          curr.cleanup();
          whatIsHighlighted.setState({ hasLock: false });
        }
      };
    },
    getIsPropHighlightedD(address) {
      const highlightedP = pointerDeep(whatIsHighlighted.pointer.deepPath, addressToArray(address));
      return (0, import_dataverse12.prism)(() => {
        const value = (0, import_dataverse10.val)(highlightedP);
        return value === true ? "self" : value ? "descendent" : null;
      });
    }
  };
}
function addressToArray(address) {
  return [
    address.projectId,
    address.sheetId,
    address.objectKey,
    ...address.pathToProp
  ];
}
function arrayToDeepObject(arr) {
  const obj = {};
  set_default(obj, arr, true);
  return obj;
}
var import_dataverse10, import_dataverse11, import_dataverse12, whatPropIsHighlighted;
var init_whatPropIsHighlighted = __esm({
  "studio/src/panels/SequenceEditorPanel/whatPropIsHighlighted.ts"() {
    import_dataverse10 = __toModule(require("@theatre/dataverse"));
    import_dataverse11 = __toModule(require("@theatre/dataverse"));
    import_dataverse12 = __toModule(require("@theatre/dataverse"));
    init_pointerDeep();
    init_set();
    whatPropIsHighlighted = createWhatPropIsHighlightedState();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/usePropHighlightMouseEnter.tsx
function usePropHighlightMouseEnter(node, leaf) {
  (0, import_react33.useLayoutEffect)(() => {
    if (!node)
      return;
    if (leaf.type !== "propWithChildren" && leaf.type !== "primitiveProp" && leaf.type !== "sheetObject")
      return;
    let unlock = null;
    const propAddress = __spreadProps(__spreadValues({}, leaf.sheetObject.address), {
      pathToProp: leaf.type === "sheetObject" ? [] : leaf.pathToProp
    });
    function onMouseEnter() {
      unlock = whatPropIsHighlighted.replaceLock(propAddress, () => {
      });
    }
    function onMouseLeave() {
      unlock == null ? void 0 : unlock();
    }
    node.addEventListener("mouseenter", onMouseEnter);
    node.addEventListener("mouseleave", onMouseLeave);
    return () => {
      unlock == null ? void 0 : unlock();
      node.removeEventListener("mouseenter", onMouseEnter);
      node.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [node]);
}
var import_react33;
var init_usePropHighlightMouseEnter = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/usePropHighlightMouseEnter.tsx"() {
    import_react33 = __toModule(require_react());
    init_whatPropIsHighlighted();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/AnyCompositeRow.tsx
var import_react34, LeftRowContainer, BaseHeader, LeftRowHeader, LeftRowHead_Label, LeftRowHead_Icon, LeftRowChildren, AnyCompositeRow, AnyCompositeRow_default;
var init_AnyCompositeRow = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/AnyCompositeRow.tsx"() {
    init_css();
    import_react34 = __toModule(require_react());
    init_all();
    init_styled_components_browser_esm();
    init_propNameTextCSS();
    init_usePropHighlightMouseEnter();
    LeftRowContainer = styled_components_browser_esm_default.li`
  --depth: ${(props) => props.depth};
  margin: 0;
  padding: 0;
  list-style: none;
`;
    BaseHeader = styled_components_browser_esm_default.div`
  border-bottom: 1px solid #7695b705;
`;
    LeftRowHeader = styled_components_browser_esm_default(BaseHeader)`
  padding-left: calc(8px + var(--depth) * 20px);

  display: flex;
  align-items: stretch;
  color: ${theme.panel.body.compoudThing.label.color};

  box-sizing: border-box;

  ${(props) => props.isSelected && `background: blue`};
`;
    LeftRowHead_Label = styled_components_browser_esm_default.span`
  ${propNameTextCSS};
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 4px;
  line-height: 26px;
  flex-wrap: nowrap;

  ${LeftRowHeader}:hover & {
    color: #ccc;
  }
`;
    LeftRowHead_Icon = styled_components_browser_esm_default.span`
  width: 12px;
  padding: 8px;
  font-size: 9px;
  display: flex;
  align-items: center;

  transition: transform 0.05s ease-out, color 0.1s ease-out;
  transform: rotateZ(${(props) => props.isCollapsed ? 0 : 90}deg);
  color: #66686a;

  &:hover {
    transform: rotateZ(${(props) => props.isCollapsed ? 15 : 75}deg);
    color: #c0c4c9;
  }
`;
    LeftRowChildren = styled_components_browser_esm_default.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
    AnyCompositeRow = ({
      leaf,
      label,
      children,
      isSelectable,
      isSelected,
      toggleSelect,
      toggleCollapsed,
      isCollapsed
    }) => {
      const hasChildren = Array.isArray(children) && children.length > 0;
      const rowHeaderRef = (0, import_react34.useRef)(null);
      usePropHighlightMouseEnter(rowHeaderRef.current, leaf);
      return leaf.shouldRender ? /* @__PURE__ */ import_react34.default.createElement(LeftRowContainer, {
        depth: leaf.depth
      }, /* @__PURE__ */ import_react34.default.createElement(LeftRowHeader, {
        ref: rowHeaderRef,
        style: {
          height: leaf.nodeHeight + "px"
        },
        isSelectable: isSelectable === true,
        isSelected: isSelected === true,
        onClick: toggleSelect,
        isEven: leaf.n % 2 === 0
      }, /* @__PURE__ */ import_react34.default.createElement(LeftRowHead_Icon, {
        isCollapsed,
        onClick: toggleCollapsed
      }, /* @__PURE__ */ import_react34.default.createElement(HiOutlineChevronRight, null)), /* @__PURE__ */ import_react34.default.createElement(LeftRowHead_Label, null, label)), hasChildren && /* @__PURE__ */ import_react34.default.createElement(LeftRowChildren, null, children)) : null;
    };
    AnyCompositeRow_default = AnyCompositeRow;
  }
});

// shared/src/propTypes/utils.ts
function isPropConfigComposite(c3) {
  return c3.type === "compound" || c3.type === "enum";
}
function getPropConfigByPath(parentConf, path) {
  if (!parentConf)
    return void 0;
  const [key, ...rest] = path;
  if (key === void 0)
    return parentConf;
  if (!isPropConfigComposite(parentConf))
    return void 0;
  const sub = parentConf.type === "enum" ? parentConf.cases[key] : parentConf.props[key];
  return getPropConfigByPath(sub, rest);
}
function valueInProp(value, propConfig) {
  const sanitizedVal = propConfig.deserializeAndSanitize(value);
  if (sanitizedVal === void 0) {
    return propConfig.default;
  } else {
    return sanitizedVal;
  }
}
function isPropConfSequencable(conf) {
  return !isPropConfigComposite(conf);
}
function compoundHasSimpleDescendants(conf) {
  if (!compoundPropSequenceabilityCache.has(conf)) {
    compoundPropSequenceabilityCache.set(conf, compoundHasSimpleDescendantsImpl(conf));
  }
  return compoundPropSequenceabilityCache.get(conf);
}
function compoundHasSimpleDescendantsImpl(conf) {
  if (conf.type === "enum") {
    throw new Error(`Not implemented yet for enums`);
  }
  for (const key in conf.props) {
    const subConf = conf.props[key];
    if (isPropConfigComposite(subConf)) {
      if (compoundHasSimpleDescendants(subConf)) {
        return true;
      }
    } else {
      return true;
    }
  }
  return false;
}
function* iteratePropType(conf, pathPrefix) {
  if (conf.type === "compound") {
    for (const key in conf.props) {
      yield* iteratePropType(conf.props[key], [
        ...pathPrefix,
        key
      ]);
    }
  } else if (conf.type === "enum") {
    throw new Error(`Not implemented yet`);
  } else {
    return yield { path: pathPrefix, conf };
  }
}
var compoundPropSequenceabilityCache;
var init_utils = __esm({
  "shared/src/propTypes/utils.ts"() {
    compoundPropSequenceabilityCache = new WeakMap();
  }
});

// studio/src/propEditors/DefaultValueIndicator.tsx
var import_react35, theme2, Container3, Rect, Icon, DefaultOrStaticValueIndicator, DefaultValueIndicator_default;
var init_DefaultValueIndicator = __esm({
  "studio/src/propEditors/DefaultValueIndicator.tsx"() {
    init_polished_esm();
    import_react35 = __toModule(require_react());
    init_styled_components_browser_esm();
    theme2 = {
      defaultState: {
        color: curriedTransparentize(0.85, `#C4C4C4`)
      },
      withStaticOverride: {
        color: curriedTransparentize(0.85, `#C4C4C4`)
      }
    };
    Container3 = styled_components_browser_esm_default.div`
  width: 16px;
  margin: 0 0px 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${(props) => props.hasStaticOverride ? theme2.withStaticOverride.color : theme2.defaultState.color};
`;
    Rect = styled_components_browser_esm_default.rect`
  fill: currentColor;
`;
    Icon = () => /* @__PURE__ */ import_react35.default.createElement("svg", {
      width: "5",
      height: "5",
      viewBox: "0 0 5 5",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react35.default.createElement(Rect, {
      width: "5",
      height: "5"
    }));
    DefaultOrStaticValueIndicator = (props) => {
      return /* @__PURE__ */ import_react35.default.createElement(Container3, {
        hasStaticOverride: props.hasStaticOverride
      }, /* @__PURE__ */ import_react35.default.createElement(Icon, null));
    };
    DefaultValueIndicator_default = DefaultOrStaticValueIndicator;
  }
});

// studio/src/propEditors/getNearbyKeyframesOfTrack.tsx
function getNearbyKeyframesOfTrack(obj, track, sequencePosition) {
  if (!track || track.data.keyframes.length === 0)
    return noKeyframes;
  const cachedItem = cache.get(track.data);
  if (cachedItem && cachedItem[0] === sequencePosition) {
    return cachedItem[1];
  }
  function getKeyframeWithTrackId(idx) {
    if (!track)
      return;
    const found = track.data.keyframes[idx];
    return found && {
      kf: found,
      track,
      itemKey: createStudioSheetItemKey.forTrackKeyframe(obj, track.id, found.id)
    };
  }
  const calculate = () => {
    const nextOrCurIdx = track.data.keyframes.findIndex((kf) => kf.position >= sequencePosition);
    if (nextOrCurIdx === -1) {
      return {
        prev: getKeyframeWithTrackId(track.data.keyframes.length - 1)
      };
    }
    const nextOrCur = getKeyframeWithTrackId(nextOrCurIdx);
    if (nextOrCur.kf.position === sequencePosition) {
      return {
        prev: getKeyframeWithTrackId(nextOrCurIdx - 1),
        cur: nextOrCur,
        next: getKeyframeWithTrackId(nextOrCurIdx + 1)
      };
    } else {
      return {
        next: nextOrCur,
        prev: getKeyframeWithTrackId(nextOrCurIdx - 1)
      };
    }
  };
  const result2 = calculate();
  cache.set(track.data, [sequencePosition, result2]);
  return result2;
}
var cache, noKeyframes;
var init_getNearbyKeyframesOfTrack = __esm({
  "studio/src/propEditors/getNearbyKeyframesOfTrack.tsx"() {
    init_ids();
    cache = new WeakMap();
    noKeyframes = {};
  }
});

// studio/src/utils/selectClosestHTMLAncestor.ts
function selectClosestHTMLAncestor(start, selector2) {
  if (start == null)
    return null;
  if (start instanceof Element && start.matches(selector2)) {
    return start;
  } else {
    return selectClosestHTMLAncestor(start.parentElement, selector2);
  }
}
var init_selectClosestHTMLAncestor = __esm({
  "studio/src/utils/selectClosestHTMLAncestor.ts"() {
  }
});

// studio/src/uiComponents/usePresence.tsx
function createPresenceContext(options2) {
  const currentUserHoverItemB = new import_dataverse13.Box(void 0);
  const currentUserHoverFlagItemsAtom = new import_dataverse14.Atom({});
  const relationsAtom = new import_dataverse14.Atom({});
  let lastRelationId = 0;
  return {
    addRelatedFlags(itemKey, relationships) {
      const relationId = String(++lastRelationId);
      const undoAtPaths = relationships.map((rel) => {
        const presence = {
          flag: rel.flag
        };
        const path = [rel.affects, itemKey, relationId];
        relationsAtom.setIn(path, presence);
        return path;
      });
      return () => {
        for (const pathToUndo of undoAtPaths) {
          relationsAtom.setIn(pathToUndo, void 0);
        }
      };
    },
    usePresenceFlag(itemKey) {
      if (!options2.enabled)
        return void 0;
      const focusD = (0, import_react36.useMemo)(() => {
        if (!itemKey)
          return undefinedD;
        const currentD = currentUserHoverItemB.derivation;
        const primaryFocusDer = (0, import_dataverse13.valueDerivation)(currentUserHoverFlagItemsAtom.pointer[itemKey]);
        const relationsDer = (0, import_dataverse13.valueDerivation)(relationsAtom.pointer[itemKey]);
        return (0, import_dataverse13.prism)(() => {
          const primary = primaryFocusDer.getValue();
          if (primary) {
            return 2;
          } else {
            const related = relationsDer.getValue();
            const current = currentD.getValue();
            const rels = related && current && related[current];
            if (rels) {
              let best;
              for (const rel of Object.values(rels)) {
                if (!rel)
                  continue;
                if (best && best >= rel.flag)
                  continue;
                best = rel.flag;
              }
              return best;
            }
            return void 0;
          }
        });
      }, [itemKey]);
      return useDerivation(focusD);
    },
    setUserHover(itemKeyOpt) {
      const prev = currentUserHoverItemB.get();
      if (prev === itemKeyOpt) {
        return;
      }
      if (prev) {
        currentUserHoverFlagItemsAtom.setIn([prev], false);
      }
      currentUserHoverItemB.set(itemKeyOpt);
      if (itemKeyOpt) {
        currentUserHoverFlagItemsAtom.setIn([itemKeyOpt], true);
      }
    }
  };
}
function usePresence(key) {
  const presenceInternal = import_react36.default.useContext(presenceInternalCtx);
  const flag = presenceInternal.usePresenceFlag(key);
  return {
    attrs: {
      [PRESENCE_ITEM_DATA_ATTR]: key
    },
    flag,
    useRelations(getRelations, deps) {
      (0, import_react37.useEffect)(() => {
        return key && presenceInternal.addRelatedFlags(key, getRelations());
      }, [key, ...deps]);
    }
  };
}
function usePresenceListenersOnRootElement(target) {
  const presence = import_react36.default.useContext(presenceInternalCtx);
  const logger = useLogger("PresenceListeners");
  (0, import_react37.useEffect)(() => {
    let currentItemKeyUserHover;
    if (!target)
      return;
    const onMouseOver = (event) => {
      if (event.target instanceof Node) {
        const found = selectClosestHTMLAncestor(event.target, `[${PRESENCE_ITEM_DATA_ATTR}]`);
        if (found) {
          const itemKey = found.getAttribute(PRESENCE_ITEM_DATA_ATTR);
          if (currentItemKeyUserHover !== itemKey) {
            currentItemKeyUserHover = itemKey;
            presence.setUserHover(itemKey || void 0);
            logger._debug("Updated current hover", { itemKey });
          }
          return;
        }
        if (currentItemKeyUserHover != null) {
          currentItemKeyUserHover = null;
          presence.setUserHover(void 0);
          logger._debug("Cleared current hover");
        }
      }
    };
    target.addEventListener("mouseover", onMouseOver);
    return () => {
      target.removeEventListener("mouseover", onMouseOver);
      if (currentItemKeyUserHover != null) {
        currentItemKeyUserHover = null;
        logger._debug("Cleared current hover as part of cleanup");
      }
    };
  }, [target, presence]);
}
var import_react36, import_react37, import_dataverse13, import_dataverse14, PresenceFlag, undefinedD, presenceInternalCtx, PRESENCE_ITEM_DATA_ATTR;
var init_usePresence = __esm({
  "studio/src/uiComponents/usePresence.tsx"() {
    import_react36 = __toModule(require_react());
    import_react37 = __toModule(require_react());
    init_useLogger();
    import_dataverse13 = __toModule(require("@theatre/dataverse"));
    import_dataverse14 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_selectClosestHTMLAncestor();
    (function(PresenceFlag2) {
      PresenceFlag2[PresenceFlag2["Primary"] = 2] = "Primary";
      PresenceFlag2[PresenceFlag2["Secondary"] = 1] = "Secondary";
    })(PresenceFlag || (PresenceFlag = {}));
    undefinedD = (0, import_dataverse13.prism)(() => void 0);
    undefinedD.keepHot();
    presenceInternalCtx = import_react36.default.createContext(createPresenceContext({ enabled: false }));
    PRESENCE_ITEM_DATA_ATTR = "data-pi-key";
  }
});

// studio/src/propEditors/NextPrevKeyframeCursors.tsx
var import_react39, Container4, Button2, nextPrevCursorsTheme, CurButton, pointerEventsNone, PrevOrNextButton, Prev, Next, Icons, NextPrevKeyframeCursors, NextPrevKeyframeCursors_default;
var init_NextPrevKeyframeCursors = __esm({
  "studio/src/propEditors/NextPrevKeyframeCursors.tsx"() {
    init_css();
    init_polished_esm();
    import_react39 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_usePresence();
    init_usePresence();
    Container4 = styled_components_browser_esm_default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  margin: 0 0px 0 2px;
  position: relative;
  z-index: 0;
  opacity: 0.7;

  &:after {
    position: absolute;
    left: -14px;
    right: -14px;
    top: -2px;
    bottom: -2px;
    content: ' ';
    display: none;
    z-index: -1;
    background: ${curriedTransparentize(0.2, "black")};
  }

  &:hover {
    opacity: 1;
    &:after {
      display: block;
    }
  }
`;
    Button2 = styled_components_browser_esm_default.div`
  background: none;
  position: relative;
  border: 0;
  transition: transform 0.1s ease-out;
  z-index: 0;
  outline: none;
  cursor: pointer;

  &:after {
    display: none;
    ${Container4}:hover & {
      display: block;
    }
    position: absolute;
    left: -4px;
    right: -4px;
    top: -4px;
    bottom: -4px;
    content: ' ';
    z-index: -1;
  }
`;
    nextPrevCursorsTheme = {
      offColor: "#555",
      onColor: "#e0c917"
    };
    CurButton = styled_components_browser_esm_default(Button2)`
  &:hover {
    color: #e0c917;
  }

  color: ${(props) => props.presence === PresenceFlag.Primary ? "white" : props.isOn ? nextPrevCursorsTheme.onColor : nextPrevCursorsTheme.offColor};
`;
    pointerEventsNone = Ce`
  pointer-events: none !important;
`;
    PrevOrNextButton = styled_components_browser_esm_default(Button2)`
  color: ${(props) => props.flag === PresenceFlag.Primary ? "white" : props.available ? nextPrevCursorsTheme.onColor : nextPrevCursorsTheme.offColor};

  ${(props) => props.available ? pointerEventsAutoInNormalMode : pointerEventsNone};
`;
    Prev = styled_components_browser_esm_default(PrevOrNextButton)`
  transform: translateX(2px);
  ${Container4}:hover & {
    transform: translateX(-7px);
  }
`;
    Next = styled_components_browser_esm_default(PrevOrNextButton)`
  transform: translateX(-2px);
  ${Container4}:hover & {
    transform: translateX(7px);
  }
`;
    (function(Icons2) {
      const Chevron_Group = styled_components_browser_esm_default.g`
    stroke-width: 1;
    ${PrevOrNextButton}:hover & path {
      stroke-width: 3;
    }
  `;
      Icons2.Prev = () => /* @__PURE__ */ import_react39.default.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react39.default.createElement(Chevron_Group, {
        transform: `translate(6 3)`
      }, /* @__PURE__ */ import_react39.default.createElement("path", {
        d: "M4 1L1 4L4 7",
        stroke: "currentColor"
      })));
      Icons2.Next = () => /* @__PURE__ */ import_react39.default.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react39.default.createElement(Chevron_Group, {
        transform: `translate(1 3)`
      }, /* @__PURE__ */ import_react39.default.createElement("path", {
        d: "M1 1L4 4L1 7",
        stroke: "currentColor"
      })));
      const Cur_Group = styled_components_browser_esm_default.g`
    stroke-width: 0;
    ${CurButton}:hover & path {
      stroke: currentColor;
      stroke-width: 2;
    }
  `;
      Icons2.Cur = () => /* @__PURE__ */ import_react39.default.createElement("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react39.default.createElement(Cur_Group, {
        transform: "translate(1 4)"
      }, /* @__PURE__ */ import_react39.default.createElement("path", {
        d: "M3 0L6 3L3 6L0 3L3 0Z",
        fill: "currentColor"
      })));
    })(Icons || (Icons = {}));
    NextPrevKeyframeCursors = (props) => {
      var _a2, _b, _c, _d, _e2;
      const prevPresence = usePresence((_a2 = props.prev) == null ? void 0 : _a2.itemKey);
      const curPresence = usePresence(((_b = props.cur) == null ? void 0 : _b.type) === "on" ? props.cur.itemKey : void 0);
      const nextPresence = usePresence((_c = props.next) == null ? void 0 : _c.itemKey);
      return /* @__PURE__ */ import_react39.default.createElement(Container4, null, /* @__PURE__ */ import_react39.default.createElement(Prev, __spreadValues({
        available: !!props.prev,
        onClick: (_d = props.prev) == null ? void 0 : _d.jump,
        flag: prevPresence.flag
      }, prevPresence.attrs), /* @__PURE__ */ import_react39.default.createElement(Icons.Prev, null)), /* @__PURE__ */ import_react39.default.createElement(CurButton, __spreadValues({
        isOn: props.cur.type === "on",
        onClick: props.cur.toggle,
        presence: curPresence.flag
      }, curPresence.attrs), /* @__PURE__ */ import_react39.default.createElement(Icons.Cur, null)), /* @__PURE__ */ import_react39.default.createElement(Next, __spreadValues({
        available: !!props.next,
        onClick: (_e2 = props.next) == null ? void 0 : _e2.jump,
        flag: nextPresence.flag
      }, nextPresence.attrs), /* @__PURE__ */ import_react39.default.createElement(Icons.Next, null)));
    };
    NextPrevKeyframeCursors_default = NextPrevKeyframeCursors;
  }
});

// studio/src/propEditors/useEditingToolsForSimpleProp.tsx
function createDerivation(pointerToProp, obj, propConfig) {
  return (0, import_dataverse15.prism)(() => {
    var _a2;
    const pathToProp = (0, import_dataverse15.getPointerParts)(pointerToProp).path;
    const final = obj.getValueByPointer(pointerToProp);
    const editPropValue = import_dataverse15.prism.memo("editPropValue", () => {
      let currentScrub = null;
      return {
        temporarilySetValue(v5) {
          if (!currentScrub) {
            currentScrub = getStudio().scrub();
          }
          currentScrub.capture((api) => {
            api.set(pointerToProp, v5);
          });
        },
        discardTemporaryValue() {
          if (currentScrub) {
            currentScrub.discard();
            currentScrub = null;
          }
        },
        permanentlySetValue(v5) {
          if (currentScrub) {
            currentScrub.capture((api) => {
              api.set(pointerToProp, v5);
            });
            currentScrub.commit();
            currentScrub = null;
          } else {
            getStudio().transaction((api) => {
              api.set(pointerToProp, v5);
            });
          }
        }
      };
    }, []);
    const beingScrubbed = (0, import_dataverse15.val)(get_default(getStudio().atomP.ephemeral.projects.stateByProjectId[obj.address.projectId].stateBySheetId[obj.address.sheetId].stateByObjectKey[obj.address.objectKey].valuesBeingScrubbed, (0, import_dataverse15.getPointerParts)(pointerToProp).path)) === true;
    const contextMenuItems = [];
    const common = __spreadProps(__spreadValues({}, editPropValue), {
      value: final,
      beingScrubbed,
      contextMenuItems,
      controlIndicators: /* @__PURE__ */ import_react40.default.createElement(import_react40.default.Fragment, null)
    });
    const isSequencable = isPropConfSequencable(propConfig);
    if (isSequencable) {
      const validSequencedTracks = (0, import_dataverse15.val)(obj.template.getMapOfValidSequenceTracks_forStudio());
      const possibleSequenceTrackId = getDeep(validSequencedTracks, pathToProp);
      const isSequenced = typeof possibleSequenceTrackId === "string";
      if (isSequenced) {
        contextMenuItems.push({
          label: "Make static",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              const propAddress = __spreadProps(__spreadValues({}, obj.address), { pathToProp });
              stateEditors2.coreByProject.historic.sheetsById.sequence.setPrimitivePropAsStatic(__spreadProps(__spreadValues({}, propAddress), {
                value: obj.getValueByPointer(pointerToProp)
              }));
            });
          }
        });
        const sequenceTrackId = possibleSequenceTrackId;
        const nearbyKeyframes = import_dataverse15.prism.sub("lcr", () => {
          const track = (0, import_dataverse15.val)(obj.template.project.pointers.historic.sheetsById[obj.address.sheetId].sequence.tracksByObject[obj.address.objectKey].trackData[sequenceTrackId]);
          const sequencePosition = (0, import_dataverse15.val)(obj.sheet.getSequence().positionDerivation);
          return getNearbyKeyframesOfTrack(obj, track && {
            data: track,
            id: sequenceTrackId,
            sheetObject: obj
          }, sequencePosition);
        }, [sequenceTrackId]);
        let shade;
        if (common.beingScrubbed) {
          shade = "Sequenced_OnKeyframe_BeingScrubbed";
        } else {
          if (nearbyKeyframes.cur) {
            shade = "Sequenced_OnKeyframe";
          } else if (((_a2 = nearbyKeyframes.prev) == null ? void 0 : _a2.kf.connectedRight) === true) {
            shade = "Sequenced_BeingInterpolated";
          } else {
            shade = "Sequened_NotBeingInterpolated";
          }
        }
        const toggle = () => {
          if (nearbyKeyframes.cur) {
            getStudio().transaction((api) => {
              api.unset(pointerToProp);
            });
          } else {
            getStudio().transaction((api) => {
              api.set(pointerToProp, common.value);
            });
          }
        };
        const controls = {
          cur: nearbyKeyframes.cur ? {
            type: "on",
            itemKey: nearbyKeyframes.cur.itemKey,
            toggle
          } : {
            type: "off",
            toggle
          },
          prev: nearbyKeyframes.prev !== void 0 ? {
            itemKey: nearbyKeyframes.prev.itemKey,
            position: nearbyKeyframes.prev.kf.position,
            jump: () => {
              obj.sheet.getSequence().position = nearbyKeyframes.prev.kf.position;
            }
          } : void 0,
          next: nearbyKeyframes.next !== void 0 ? {
            itemKey: nearbyKeyframes.next.itemKey,
            position: nearbyKeyframes.next.kf.position,
            jump: () => {
              obj.sheet.getSequence().position = nearbyKeyframes.next.kf.position;
            }
          } : void 0
        };
        const nextPrevKeyframeCursors = /* @__PURE__ */ import_react40.default.createElement(NextPrevKeyframeCursors_default, __spreadValues({}, controls));
        const ret2 = __spreadProps(__spreadValues({}, common), {
          type: "Sequenced",
          shade,
          nearbyKeyframes,
          controlIndicators: nextPrevKeyframeCursors
        });
        return ret2;
      }
    }
    contextMenuItems.push({
      label: "Reset to default",
      callback: () => {
        getStudio().transaction(({ unset }) => {
          unset(pointerToProp);
        });
      }
    });
    if (isSequencable) {
      contextMenuItems.push({
        label: "Sequence",
        callback: () => {
          getStudio().transaction(({ stateEditors: stateEditors2 }) => {
            const propAddress = __spreadProps(__spreadValues({}, obj.address), { pathToProp });
            stateEditors2.coreByProject.historic.sheetsById.sequence.setPrimitivePropAsSequenced(propAddress, propConfig);
          });
        }
      });
    }
    const statics = (0, import_dataverse15.val)(obj.template.getStaticValues());
    if (typeof getDeep(statics, pathToProp) !== "undefined") {
      const ret2 = __spreadProps(__spreadValues({}, common), {
        type: "Static",
        shade: common.beingScrubbed ? "Static_BeingScrubbed" : "Static",
        controlIndicators: /* @__PURE__ */ import_react40.default.createElement(DefaultValueIndicator_default, {
          hasStaticOverride: true
        })
      });
      return ret2;
    }
    const ret = __spreadProps(__spreadValues({}, common), {
      type: "Default",
      shade: "Default",
      controlIndicators: /* @__PURE__ */ import_react40.default.createElement(DefaultValueIndicator_default, {
        hasStaticOverride: false
      })
    });
    return ret;
  });
}
function getDerivation(pointerToProp, obj, propConfig) {
  if (cache2.has(pointerToProp)) {
    return cache2.get(pointerToProp);
  } else {
    const d3 = createDerivation(pointerToProp, obj, propConfig);
    cache2.set(pointerToProp, d3);
    return d3;
  }
}
function useEditingToolsForSimplePropInDetailsPanel(pointerToProp, obj, propConfig) {
  const der = getDerivation(pointerToProp, obj, propConfig);
  return useDerivation(der);
}
var import_react40, import_dataverse15, cache2;
var init_useEditingToolsForSimpleProp = __esm({
  "studio/src/propEditors/useEditingToolsForSimpleProp.tsx"() {
    init_get();
    import_react40 = __toModule(require_react());
    import_dataverse15 = __toModule(require("@theatre/dataverse"));
    init_getStudio();
    init_getDeep();
    init_src();
    init_utils();
    init_DefaultValueIndicator();
    init_getNearbyKeyframesOfTrack();
    init_NextPrevKeyframeCursors();
    cache2 = new WeakMap();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/PrimitivePropRow.tsx
var import_dataverse16, import_react43, theme3, PrimitivePropRowContainer, PrimitivePropRowHead, PrimitivePropRowIconContainer, GraphIcon, PrimitivePropRowHead_Label, PrimitivePropRow, PrimitivePropRow_default;
var init_PrimitivePropRow = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/PrimitivePropRow.tsx"() {
    init_getStudio();
    init_addresses();
    init_pointerDeep();
    init_src();
    import_dataverse16 = __toModule(require("@theatre/dataverse"));
    import_react43 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_useEditingToolsForSimpleProp();
    init_NextPrevKeyframeCursors();
    init_GraphEditor();
    init_AnyCompositeRow();
    init_propNameTextCSS();
    init_usePropHighlightMouseEnter();
    theme3 = {
      label: {
        color: `#9a9a9a`
      }
    };
    PrimitivePropRowContainer = styled_components_browser_esm_default(LeftRowContainer)``;
    PrimitivePropRowHead = styled_components_browser_esm_default(BaseHeader)`
  display: flex;
  color: ${theme3.label.color};
  padding-right: 12px;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
`;
    PrimitivePropRowIconContainer = styled_components_browser_esm_default.button`
  background: none;
  border: none;
  outline: none;
  display: flex;
  box-sizing: border-box;
  font-size: 14px;
  align-items: center;
  height: 100%;
  margin-left: 12px;
  color: ${(props) => props.isSelected ? graphEditorColors[props.graphEditorColor].iconColor : nextPrevCursorsTheme.offColor};

  &:not([disabled]):hover {
    color: white;
  }
`;
    GraphIcon = () => /* @__PURE__ */ import_react43.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "10",
      height: "12",
      viewBox: "0 0 640 512"
    }, /* @__PURE__ */ import_react43.default.createElement("g", {
      transform: "translate(0 100)"
    }, /* @__PURE__ */ import_react43.default.createElement("path", {
      fill: "currentColor",
      d: "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    })));
    PrimitivePropRowHead_Label = styled_components_browser_esm_default.span`
  margin-right: 4px;
  ${propNameTextCSS};

  ${PrimitivePropRowHead}:hover & {
    color: #ccc;
  }
`;
    PrimitivePropRow = ({ leaf }) => {
      var _a2;
      const pointerToProp = pointerDeep(leaf.sheetObject.propsP, leaf.pathToProp);
      const obj = leaf.sheetObject;
      const { controlIndicators } = useEditingToolsForSimplePropInDetailsPanel(pointerToProp, obj, leaf.propConf);
      const possibleColor = usePrism(() => {
        const c3 = leaf.sheetObject.address;
        const encodedPathToProp = encodePathToProp(leaf.pathToProp);
        return (0, import_dataverse16.val)(getStudio().atomP.historic.projects.stateByProjectId[c3.projectId].stateBySheetId[c3.sheetId].sequenceEditor.selectedPropsByObject[c3.objectKey][encodedPathToProp]);
      }, [leaf]);
      const isSelectedRef = (0, import_react43.useRef)(false);
      const isSelected = typeof possibleColor === "string";
      isSelectedRef.current = isSelected;
      const toggleSelect = (0, import_react43.useCallback)(() => {
        const c3 = leaf.sheetObject.address;
        getStudio().transaction(({ stateEditors: stateEditors2 }) => {
          if (isSelectedRef.current) {
            stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.sequenceEditor.removePropFromGraphEditor(__spreadProps(__spreadValues({}, c3), { pathToProp: leaf.pathToProp }));
          } else {
            stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.sequenceEditor.addPropToGraphEditor(__spreadProps(__spreadValues({}, c3), { pathToProp: leaf.pathToProp }));
            stateEditors2.studio.historic.panels.sequenceEditor.graphEditor.setIsOpen({
              isOpen: true
            });
          }
        });
      }, [leaf]);
      const label = (_a2 = leaf.propConf.label) != null ? _a2 : leaf.pathToProp[leaf.pathToProp.length - 1];
      const isSelectable = true;
      const headRef = (0, import_react43.useRef)(null);
      usePropHighlightMouseEnter(headRef.current, leaf);
      return /* @__PURE__ */ import_react43.default.createElement(PrimitivePropRowContainer, {
        depth: leaf.depth
      }, /* @__PURE__ */ import_react43.default.createElement(PrimitivePropRowHead, {
        ref: headRef,
        isEven: leaf.n % 2 === 0,
        style: {
          height: leaf.nodeHeight + "px"
        },
        isSelected: isSelected === true
      }, /* @__PURE__ */ import_react43.default.createElement(PrimitivePropRowHead_Label, null, label), controlIndicators, /* @__PURE__ */ import_react43.default.createElement(PrimitivePropRowIconContainer, {
        onClick: toggleSelect,
        isSelected: isSelected === true,
        graphEditorColor: possibleColor != null ? possibleColor : "1",
        style: { opacity: isSelectable ? 1 : 0.25 },
        disabled: !isSelectable
      }, /* @__PURE__ */ import_react43.default.createElement(GraphIcon, null))));
    };
    PrimitivePropRow_default = PrimitivePropRow;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/setCollapsedSheetObjectOrCompoundProp.tsx
function setCollapsedSheetItem(isCollapsed, toCollapse) {
  getStudio().transaction(({ stateEditors: stateEditors2 }) => {
    stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.sequenceEditorCollapsableItems.set(__spreadProps(__spreadValues({}, toCollapse.sheetAddress), {
      studioSheetItemKey: toCollapse.sheetItemKey,
      isCollapsed
    }));
  });
}
var init_setCollapsedSheetObjectOrCompoundProp = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/setCollapsedSheetObjectOrCompoundProp.tsx"() {
    init_getStudio();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/PropWithChildrenRow.tsx
var import_react44, decideRowByPropType, PropWithChildrenRow;
var init_PropWithChildrenRow = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/PropWithChildrenRow.tsx"() {
    import_react44 = __toModule(require_react());
    init_AnyCompositeRow();
    init_PrimitivePropRow();
    init_setCollapsedSheetObjectOrCompoundProp();
    decideRowByPropType = (leaf) => {
      const key = "prop" + leaf.pathToProp[leaf.pathToProp.length - 1];
      return leaf.shouldRender ? leaf.type === "propWithChildren" ? /* @__PURE__ */ import_react44.default.createElement(PropWithChildrenRow, {
        leaf,
        key
      }) : /* @__PURE__ */ import_react44.default.createElement(PrimitivePropRow_default, {
        leaf,
        key
      }) : /* @__PURE__ */ import_react44.default.createElement(import_react44.default.Fragment, {
        key
      });
    };
    PropWithChildrenRow = ({ leaf }) => {
      return /* @__PURE__ */ import_react44.default.createElement(AnyCompositeRow_default, {
        leaf,
        label: leaf.pathToProp[leaf.pathToProp.length - 1],
        isCollapsed: leaf.isCollapsed,
        toggleCollapsed: () => setCollapsedSheetItem(!leaf.isCollapsed, {
          sheetAddress: leaf.sheetObject.address,
          sheetItemKey: leaf.sheetItemKey
        })
      }, leaf.children.map((propLeaf) => decideRowByPropType(propLeaf)));
    };
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/SheetObjectRow.tsx
var import_react45, LeftSheetObjectRow, SheetObjectRow_default;
var init_SheetObjectRow = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/SheetObjectRow.tsx"() {
    import_react45 = __toModule(require_react());
    init_AnyCompositeRow();
    init_PropWithChildrenRow();
    init_setCollapsedSheetObjectOrCompoundProp();
    init_getStudio();
    LeftSheetObjectRow = ({ leaf }) => {
      return /* @__PURE__ */ import_react45.default.createElement(AnyCompositeRow_default, {
        leaf,
        label: leaf.sheetObject.address.objectKey,
        isCollapsed: leaf.isCollapsed,
        toggleSelect: () => {
          getStudio().transaction(({ stateEditors: stateEditors2 }) => {
            stateEditors2.studio.historic.panels.outline.selection.set([
              leaf.sheetObject
            ]);
          });
        },
        toggleCollapsed: () => setCollapsedSheetItem(!leaf.isCollapsed, {
          sheetAddress: leaf.sheetObject.address,
          sheetItemKey: leaf.sheetItemKey
        })
      }, leaf.children.map((leaf2) => decideRowByPropType(leaf2)));
    };
    SheetObjectRow_default = LeftSheetObjectRow;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/SheetRow.tsx
var import_react47, SheetRow, SheetRow_default;
var init_SheetRow = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/SheetRow.tsx"() {
    init_src();
    import_react47 = __toModule(require_react());
    init_SheetObjectRow();
    init_AnyCompositeRow();
    init_setCollapsedSheetObjectOrCompoundProp();
    SheetRow = ({ leaf }) => {
      return usePrism(() => {
        return /* @__PURE__ */ import_react47.default.createElement(AnyCompositeRow_default, {
          leaf,
          label: leaf.sheet.address.sheetId,
          isCollapsed: leaf.isCollapsed,
          toggleCollapsed: () => {
            setCollapsedSheetItem(!leaf.isCollapsed, {
              sheetAddress: leaf.sheet.address,
              sheetItemKey: leaf.sheetItemKey
            });
          }
        }, leaf.children.map((sheetObjectLeaf) => /* @__PURE__ */ import_react47.default.createElement(SheetObjectRow_default, {
          key: "sheetObject-" + sheetObjectLeaf.sheetObject.address.objectKey,
          leaf: sheetObjectLeaf
        })));
      }, [leaf]);
    };
    SheetRow_default = SheetRow;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Left/Left.tsx
var import_dataverse17, import_react49, Container5, ListContainer, Left, Left_default;
var init_Left = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Left/Left.tsx"() {
    init_src();
    import_dataverse17 = __toModule(require("@theatre/dataverse"));
    import_react49 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SheetRow();
    Container5 = styled_components_browser_esm_default.div`
  position: absolute;
  left: 0;
  overflow-x: visible;
`;
    ListContainer = styled_components_browser_esm_default.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
    Left = ({ layoutP }) => {
      return usePrism(() => {
        const tree = (0, import_dataverse17.val)(layoutP.tree);
        const width = (0, import_dataverse17.val)(layoutP.leftDims.width);
        return /* @__PURE__ */ import_react49.default.createElement(Container5, {
          style: { width: width + "px", top: tree.top + "px" }
        }, /* @__PURE__ */ import_react49.default.createElement(ListContainer, null, /* @__PURE__ */ import_react49.default.createElement(SheetRow_default, {
          leaf: tree
        })));
      }, [layoutP]);
    };
    Left_default = Left;
  }
});

// studio/src/panels/SequenceEditorPanel/FrameGrid/createGrid.ts
function createGrid({
  clippedSpaceRange,
  clippedSpaceWidth,
  fps,
  gapWidth = 120
}, cb) {
  const frameLengthInSeconeds = 1 / fps;
  const clippedSpaceLengthInSeconds = clippedSpaceRange.end - clippedSpaceRange.start;
  const frameWidthInScreenSpace = clippedSpaceWidth / (fps * clippedSpaceLengthInSeconds);
  const numberOfFramesFittingInMinimumCellWidth = Math.floor(gapWidth / frameWidthInScreenSpace);
  const numberOfFramesPerCell = numberOfFramesFittingInMinimumCellWidth < fps ? getFactorsOfNumber(fps).find((factor) => factor >= numberOfFramesFittingInMinimumCellWidth) : fps * Math.floor(numberOfFramesFittingInMinimumCellWidth / fps);
  const cellLengthInSeconds = numberOfFramesPerCell * frameLengthInSeconeds;
  const startCell = Math.floor(clippedSpaceRange.start / cellLengthInSeconds);
  const endCell = Math.ceil(clippedSpaceRange.end / cellLengthInSeconds);
  for (let cell = startCell; cell <= endCell; cell++) {
    const posInUnitSpace = cell * cellLengthInSeconds;
    const isFullSecond = posInUnitSpace % 1 === 0;
    cb(posInUnitSpace, isFullSecond);
  }
}
var getFactorsOfNumber;
var init_createGrid = __esm({
  "studio/src/panels/SequenceEditorPanel/FrameGrid/createGrid.ts"() {
    init_lodash();
    getFactorsOfNumber = memoize_default((divisionsPerUnit) => {
      const factors = [];
      for (let i3 = 1; i3 <= divisionsPerUnit; i3++) {
        if (divisionsPerUnit % i3 === 0) {
          factors.push(i3);
        }
      }
      return factors;
    });
  }
});

// studio/src/studioTicker.ts
var import_dataverse18, studioTicker, studioTicker_default;
var init_studioTicker = __esm({
  "studio/src/studioTicker.ts"() {
    import_dataverse18 = __toModule(require("@theatre/dataverse"));
    studioTicker = import_dataverse18.Ticker.raf;
    studioTicker_default = studioTicker;
  }
});

// studio/src/panels/SequenceEditorPanel/FrameGrid/FrameGrid.tsx
function drawGrid(opts) {
  const { clippedSpaceWidth, height: height2, ctx: ctx3, unitSpaceToClippedSpace, snapToGrid } = opts;
  ctx3.clearRect(0, 0, clippedSpaceWidth, height2);
  createGrid(opts, (_posInUnitSpace, isFullSecond) => {
    const posInUnitSpace = snapToGrid(_posInUnitSpace);
    const posInClippedSpace = Math.floor(unitSpaceToClippedSpace(posInUnitSpace));
    ctx3.strokeStyle = isFullSecond ? "rgba(225, 225, 225, 0.04)" : "rgba(255, 255, 255, 0.01)";
    ctx3.beginPath();
    ctx3.moveTo(posInClippedSpace, 0);
    ctx3.lineTo(posInClippedSpace, height2);
    ctx3.stroke();
    ctx3.closePath();
  });
}
var import_dataverse19, import_react50, Container6, TheCanvas, getBackingStoreRatio, getDevicePixelRatio, getRatio, FrameGrid, FrameGrid_default;
var init_FrameGrid = __esm({
  "studio/src/panels/SequenceEditorPanel/FrameGrid/FrameGrid.tsx"() {
    import_dataverse19 = __toModule(require("@theatre/dataverse"));
    import_react50 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_createGrid();
    init_studioTicker();
    Container6 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
`;
    TheCanvas = styled_components_browser_esm_default.canvas`
  position: relative;
  left: 0;
`;
    getBackingStoreRatio = (ctx3) => {
      const _ctx = ctx3;
      return _ctx.webkitBackingStorePixelRatio || _ctx.mozBackingStorePixelRatio || _ctx.msBackingStorePixelRatio || _ctx.oBackingStorePixelRatio || _ctx.backingStorePixelRatio || 1;
    };
    getDevicePixelRatio = () => window.devicePixelRatio || 1;
    getRatio = (ctx3) => {
      return getDevicePixelRatio() / getBackingStoreRatio(ctx3);
    };
    FrameGrid = ({ layoutP, width, height: height2 }) => {
      const containerRef = (0, import_react50.useRef)(null);
      const [canvas, canvasRef] = (0, import_react50.useState)(null);
      const { ctx: ctx3, ratio } = (0, import_react50.useMemo)(() => {
        if (!canvas)
          return {};
        const ctx4 = canvas.getContext("2d");
        const ratio2 = getRatio(ctx4);
        return { ctx: ctx4, ratio: ratio2 };
      }, [canvas]);
      (0, import_react50.useLayoutEffect)(() => {
        if (!ctx3)
          return;
        canvas.width = width * ratio;
        canvas.height = height2 * ratio;
        const untap = (0, import_dataverse19.prism)(() => {
          const sequence = (0, import_dataverse19.val)(layoutP.sheet).getSequence();
          return {
            ctx: ctx3,
            clippedSpaceRange: (0, import_dataverse19.val)(layoutP.clippedSpace.range),
            clippedSpaceWidth: (0, import_dataverse19.val)(layoutP.clippedSpace.width),
            unitSpaceToClippedSpace: (0, import_dataverse19.val)(layoutP.clippedSpace.fromUnitSpace),
            height: height2,
            leftPadding: (0, import_dataverse19.val)(layoutP.scaledSpace.leftPadding),
            fps: sequence.subUnitsPerUnit,
            snapToGrid: (n3) => sequence.closestGridPosition(n3)
          };
        }).tapImmediate(studioTicker_default, (p3) => {
          ctx3.save();
          ctx3.scale(ratio, ratio);
          drawGrid(p3);
          ctx3.restore();
        });
        return () => {
          untap();
        };
      }, [ctx3, width, height2, layoutP]);
      return /* @__PURE__ */ import_react50.default.createElement(Container6, {
        ref: containerRef,
        style: { width: width + "px" }
      }, /* @__PURE__ */ import_react50.default.createElement(TheCanvas, {
        ref: canvasRef,
        style: {
          width: width + "px",
          height: height2 + "px"
        }
      }));
    };
    FrameGrid_default = FrameGrid;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/DopeSheetBackground.tsx
var import_react52, Container7, DopeSheetBackground, DopeSheetBackground_default;
var init_DopeSheetBackground = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/DopeSheetBackground.tsx"() {
    init_css();
    init_SequenceEditorPanel();
    init_src();
    init_polished_esm();
    import_react52 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameGrid();
    Container7 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${() => zIndexes.rightBackground};
  overflow: hidden;
  background: ${curriedTransparentize(0.01, curriedDarken(1 * 0.03, theme.panel.bg))};
  pointer-events: none;
`;
    DopeSheetBackground = ({ layoutP }) => {
      const width = useVal(layoutP.rightDims.width);
      const height2 = useVal(layoutP.panelDims.height);
      return /* @__PURE__ */ import_react52.default.createElement(Container7, {
        style: { width: width + "px" }
      }, /* @__PURE__ */ import_react52.default.createElement(FrameGrid_default, {
        width,
        height: height2,
        layoutP
      }));
    };
    DopeSheetBackground_default = DopeSheetBackground;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/DopeSheet.tsx
var import_react54, Container8, DopeSheet, DopeSheet_default;
var init_DopeSheet = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/DopeSheet.tsx"() {
    init_src();
    import_react54 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Left();
    init_DopeSheetBackground();
    init_Right();
    init_VerticalScrollContainer();
    Container8 = styled_components_browser_esm_default.div`
  position: absolute;
  left: 0;
  right: 0;
`;
    DopeSheet = ({
      layoutP
    }) => {
      const height2 = useVal(layoutP.dopeSheetDims.height);
      return /* @__PURE__ */ import_react54.default.createElement(Container8, {
        style: { height: height2 + "px" }
      }, /* @__PURE__ */ import_react54.default.createElement(DopeSheetBackground_default, {
        layoutP
      }), /* @__PURE__ */ import_react54.default.createElement(VerticalScrollContainer_default, null, /* @__PURE__ */ import_react54.default.createElement(Left_default, {
        layoutP
      }), /* @__PURE__ */ import_react54.default.createElement(Right_default, {
        layoutP
      })));
    };
    DopeSheet_default = DopeSheet;
  }
});

// shared/src/utils/subPrism.ts
function subPrism(key, fn2, deps) {
  const m3 = import_dataverse20.prism.memo(key, () => (0, import_dataverse20.prism)(fn2), deps);
  return m3.getValue();
}
var import_dataverse20;
var init_subPrism = __esm({
  "shared/src/utils/subPrism.ts"() {
    import_dataverse20 = __toModule(require("@theatre/dataverse"));
  }
});

// studio/src/panels/BasePanel/common.tsx
var panelZIndexes, propsEditorBackground, TitleBar_Piece, TitleBar_Punctuation, F22, titleBarHeight, TitleBar, visibleSize;
var init_common = __esm({
  "studio/src/panels/BasePanel/common.tsx"() {
    init_css();
    init_styled_components_browser_esm();
    panelZIndexes = {
      get outlinePanel() {
        return 1;
      },
      get propsPanel() {
        return panelZIndexes.outlinePanel;
      },
      get sequenceEditorPanel() {
        return this.outlinePanel - 1;
      },
      get toolbar() {
        return this.outlinePanel + 1;
      },
      get pluginPanes() {
        return this.sequenceEditorPanel - 1;
      }
    };
    propsEditorBackground = theme.panel.bg;
    TitleBar_Piece = styled_components_browser_esm_default.span`
  white-space: nowrap;
`;
    TitleBar_Punctuation = styled_components_browser_esm_default.span`
  white-space: nowrap;
  color: ${theme.panel.head.punctuation.color};
`;
    F22 = styled_components_browser_esm_default.div`
  background: ${propsEditorBackground};
  flex-grow: 1;
  overflow-y: scroll;
  padding: 0;
`;
    titleBarHeight = 18;
    TitleBar = styled_components_browser_esm_default.div`
  height: ${titleBarHeight}px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  color: #adadadb3;
  border-bottom: 1px solid rgb(0 0 0 / 13%);
  background-color: #25272b;
  font-size: 10px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
    visibleSize = 100;
  }
});

// studio/src/panels/SequenceEditorPanel/layout/tree.ts
var import_dataverse21, HEIGHT_OF_ANY_TITLE, calculateSequenceEditorTree;
var init_tree = __esm({
  "studio/src/panels/SequenceEditorPanel/layout/tree.ts"() {
    init_ids();
    import_dataverse21 = __toModule(require("@theatre/dataverse"));
    init_logger2();
    init_common();
    HEIGHT_OF_ANY_TITLE = 28;
    calculateSequenceEditorTree = (sheet, studio3) => {
      var _a2;
      import_dataverse21.prism.ensurePrism();
      const rootShouldRender = true;
      let topSoFar = titleBarHeight + (rootShouldRender ? HEIGHT_OF_ANY_TITLE : 0);
      let nSoFar = 0;
      const collapsableItemSetP = studio3.atomP.ahistoric.projects.stateByProjectId[sheet.address.projectId].stateBySheetId[sheet.address.sheetId].sequence.collapsableItems;
      const isCollapsedP = collapsableItemSetP.byId[createStudioSheetItemKey.forSheet()].isCollapsed;
      const isCollapsed = (_a2 = (0, import_dataverse21.valueDerivation)(isCollapsedP).getValue()) != null ? _a2 : false;
      const tree = {
        type: "sheet",
        isCollapsed,
        sheet,
        children: [],
        sheetItemKey: createStudioSheetItemKey.forSheet(),
        shouldRender: rootShouldRender,
        top: titleBarHeight,
        depth: 0,
        n: nSoFar,
        nodeHeight: rootShouldRender ? HEIGHT_OF_ANY_TITLE : 0,
        heightIncludingChildren: -1
      };
      if (rootShouldRender) {
        nSoFar += 1;
      }
      for (const sheetObject of Object.values((0, import_dataverse21.val)(sheet.objectsP))) {
        if (sheetObject) {
          addObject(sheetObject, tree.children, tree.depth + 1, rootShouldRender && !isCollapsed);
        }
      }
      tree.heightIncludingChildren = topSoFar - tree.top;
      function addObject(sheetObject, arrayOfChildren, level, shouldRender) {
        var _a3;
        const trackSetups = (0, import_dataverse21.val)(sheetObject.template.getMapOfValidSequenceTracks_forStudio());
        const objectConfig = (0, import_dataverse21.val)(sheetObject.template.configPointer);
        if (Object.keys(trackSetups).length === 0)
          return;
        const isCollapsedP2 = collapsableItemSetP.byId[createStudioSheetItemKey.forSheetObject(sheetObject)].isCollapsed;
        const isCollapsed2 = (_a3 = (0, import_dataverse21.valueDerivation)(isCollapsedP2).getValue()) != null ? _a3 : false;
        const row = {
          type: "sheetObject",
          isCollapsed: isCollapsed2,
          sheetItemKey: createStudioSheetItemKey.forSheetObject(sheetObject),
          shouldRender,
          top: topSoFar,
          children: [],
          depth: level,
          n: nSoFar,
          sheetObject,
          nodeHeight: shouldRender ? HEIGHT_OF_ANY_TITLE : 0,
          heightIncludingChildren: -1
        };
        arrayOfChildren.push(row);
        if (shouldRender) {
          nSoFar += 1;
          topSoFar += row.nodeHeight;
        }
        addProps(sheetObject, trackSetups, [], objectConfig, row.children, level + 1, shouldRender && !isCollapsed2);
        row.heightIncludingChildren = topSoFar - row.top;
      }
      function addProps(sheetObject, trackSetups, pathSoFar, parentPropConfig, arrayOfChildren, level, shouldRender) {
        for (const [propKey, setupOrSetups] of Object.entries(trackSetups)) {
          const propConfig = parentPropConfig.props[propKey];
          addProp(sheetObject, setupOrSetups, [...pathSoFar, propKey], propConfig, arrayOfChildren, level, shouldRender);
        }
      }
      function addProp(sheetObject, trackIdOrMapping, pathToProp, conf, arrayOfChildren, level, shouldRender) {
        if (conf.type === "compound") {
          const trackMapping = trackIdOrMapping;
          addProp_compound(sheetObject, trackMapping, conf, pathToProp, conf, arrayOfChildren, level, shouldRender);
        } else if (conf.type === "enum") {
          logger_default.warn("Prop type enum is not yet supported in the sequence editor");
        } else {
          const trackId = trackIdOrMapping;
          addProp_primitive(sheetObject, trackId, pathToProp, conf, arrayOfChildren, level, shouldRender);
        }
      }
      function addProp_compound(sheetObject, trackMapping, propConf, pathToProp, conf, arrayOfChildren, level, shouldRender) {
        var _a3;
        const isCollapsedP2 = collapsableItemSetP.byId[createStudioSheetItemKey.forSheetObjectProp(sheetObject, pathToProp)].isCollapsed;
        const isCollapsed2 = (_a3 = (0, import_dataverse21.valueDerivation)(isCollapsedP2).getValue()) != null ? _a3 : false;
        const row = {
          type: "propWithChildren",
          isCollapsed: isCollapsed2,
          propConf,
          pathToProp,
          sheetItemKey: createStudioSheetItemKey.forSheetObjectProp(sheetObject, pathToProp),
          sheetObject,
          shouldRender,
          top: topSoFar,
          children: [],
          nodeHeight: shouldRender ? HEIGHT_OF_ANY_TITLE : 0,
          heightIncludingChildren: -1,
          depth: level,
          trackMapping,
          n: nSoFar
        };
        arrayOfChildren.push(row);
        if (shouldRender) {
          topSoFar += row.nodeHeight;
          nSoFar += 1;
        }
        addProps(sheetObject, trackMapping, pathToProp, conf, row.children, level + 1, shouldRender && !isCollapsed2);
        row.heightIncludingChildren = topSoFar - row.top;
      }
      function addProp_primitive(sheetObject, trackId, pathToProp, propConf, arrayOfChildren, level, shouldRender) {
        const row = {
          type: "primitiveProp",
          propConf,
          depth: level,
          sheetItemKey: createStudioSheetItemKey.forSheetObjectProp(sheetObject, pathToProp),
          sheetObject,
          pathToProp,
          shouldRender,
          top: topSoFar,
          nodeHeight: shouldRender ? HEIGHT_OF_ANY_TITLE : 0,
          heightIncludingChildren: shouldRender ? HEIGHT_OF_ANY_TITLE : 0,
          trackId,
          n: nSoFar
        };
        arrayOfChildren.push(row);
        nSoFar += 1;
        topSoFar += row.nodeHeight;
      }
      return tree;
    };
  }
});

// studio/src/panels/SequenceEditorPanel/layout/layout.ts
function sequenceEditorPanelLayout(sheet, panelDimsP) {
  const studio3 = getStudio();
  const ahistoricStateP = studio3.atomP.ahistoric.projects.stateByProjectId[sheet.address.projectId].stateBySheetId[sheet.address.sheetId];
  const historicStateP = studio3.atomP.historic.projects.stateByProjectId[sheet.address.projectId].stateBySheetId[sheet.address.sheetId];
  return (0, import_dataverse22.prism)(() => {
    var _a2;
    const tree = subPrism("tree", () => calculateSequenceEditorTree(sheet, studio3), []);
    const panelDims = (0, import_dataverse22.val)(panelDimsP);
    const graphEditorState = (0, import_dataverse22.val)(studio3.atomP.historic.panels.sequenceEditor.graphEditor);
    const selectedPropsByObject = (0, import_dataverse22.val)(historicStateP.sequenceEditor.selectedPropsByObject);
    const graphEditorAvailable = !!selectedPropsByObject && Object.keys(selectedPropsByObject).length > 0;
    const {
      leftDims,
      rightDims,
      graphEditorDims,
      dopeSheetDims,
      horizontalScrollbarDims
    } = import_dataverse22.prism.memo("leftDims", () => {
      var _a3;
      const leftDims2 = {
        width: Math.floor(panelDims.width * panelSplitRatio),
        height: panelDims.height,
        screenX: panelDims.screenX,
        screenY: panelDims.screenY
      };
      const rightDims2 = {
        width: panelDims.width - leftDims2.width,
        height: panelDims.height,
        screenX: panelDims.screenX + leftDims2.width,
        screenY: panelDims.screenY
      };
      const graphEditorOpen = graphEditorAvailable && (graphEditorState == null ? void 0 : graphEditorState.isOpen) === true;
      const graphEditorHeight = Math.floor((graphEditorOpen ? clamp_default((_a3 = graphEditorState == null ? void 0 : graphEditorState.height) != null ? _a3 : 0.5, 0.1, 0.7) : 0) * panelDims.heightWithoutBorder);
      const bottomHeight = 0 + graphEditorHeight;
      const dopeSheetHeight = panelDims.height - bottomHeight;
      const dopeSheetDims2 = {
        width: panelDims.width,
        height: dopeSheetHeight,
        screenX: panelDims.screenX,
        screenY: panelDims.screenY
      };
      const graphEditorDims2 = {
        isAvailable: graphEditorAvailable,
        isOpen: graphEditorOpen,
        width: rightDims2.width,
        height: graphEditorHeight,
        screenX: panelDims.screenX,
        screenY: panelDims.screenY + dopeSheetHeight,
        padding: {
          top: 20,
          bottom: 20
        }
      };
      const horizontalScrollbarDims2 = {
        bottom: graphEditorOpen ? 0 : 0
      };
      return {
        leftDims: leftDims2,
        rightDims: rightDims2,
        graphEditorDims: graphEditorDims2,
        dopeSheetDims: dopeSheetDims2,
        horizontalScrollbarDims: horizontalScrollbarDims2
      };
    }, [panelDims, graphEditorState, graphEditorAvailable]);
    const graphEditorVerticalSpace = import_dataverse22.prism.memo("graphEditorVerticalSpace", () => {
      const space = graphEditorDims.height - graphEditorDims.padding.top - graphEditorDims.padding.bottom;
      return {
        space,
        fromExtremumSpace(ex) {
          return ex * space;
        },
        toExtremumSpace(s3) {
          return s3 / space;
        }
      };
    }, [graphEditorDims]);
    const [isSeeking, setIsSeeking] = import_dataverse22.prism.state("isSeeking", false);
    const seeker = {
      isSeeking,
      setIsSeeking
    };
    const unitSpace = {};
    const clippedSpaceRange = (_a2 = (0, import_dataverse22.val)(ahistoricStateP.sequence.clippedSpaceRange)) != null ? _a2 : initialClippedSpaceRange;
    const scaledSpace = import_dataverse22.prism.memo("scaledSpace", () => {
      const unitsShownInClippedSpace = clippedSpaceRange.end - clippedSpaceRange.start;
      const pixelsShownInClippedSpace = rightDims.width;
      const unitToPixelRatio = unitsShownInClippedSpace / pixelsShownInClippedSpace;
      const pixelToUnitRatio = pixelsShownInClippedSpace / unitsShownInClippedSpace;
      return {
        fromUnitSpace(u3) {
          return u3 * pixelToUnitRatio;
        },
        toUnitSpace(s3) {
          return s3 * unitToPixelRatio;
        },
        leftPadding: 10
      };
    }, [clippedSpaceRange, rightDims.width]);
    const setClippedSpaceRange = import_dataverse22.prism.memo("setClippedSpaceRange", () => {
      return function setClippedSpaceRange2(_range) {
        studio3.transaction(({ stateEditors: stateEditors2 }) => {
          const range = __spreadValues({}, _range);
          if (range.end <= range.start) {
            range.end = range.start + 1;
          }
          if (range.start < 0) {
            const length = range.end - range.start;
            range.start = 0;
            range.end = length;
          }
          stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.clippedSpaceRange.set(__spreadProps(__spreadValues({}, sheet.address), { range }));
        });
      };
    }, []);
    const clippedSpace = import_dataverse22.prism.memo("clippedSpace", () => {
      return {
        range: clippedSpaceRange,
        width: rightDims.width,
        fromUnitSpace(u3) {
          return scaledSpace.fromUnitSpace(u3 - clippedSpaceRange.start) + scaledSpace.leftPadding;
        },
        toUnitSpace(c3) {
          return scaledSpace.toUnitSpace(c3 - scaledSpace.leftPadding) + clippedSpaceRange.start;
        },
        setRange: setClippedSpaceRange
      };
    }, [clippedSpaceRange, rightDims.width, scaledSpace, setClippedSpaceRange]);
    const selectionAtom = import_dataverse22.prism.memo("selection.current", () => {
      return new import_dataverse22.Atom({});
    }, []);
    const finalAtom = valToAtom("finalAtom", {
      sheet,
      tree,
      panelDims,
      leftDims,
      rightDims,
      dopeSheetDims,
      horizontalScrollbarDims,
      seeker,
      unitSpace,
      scaledSpace,
      clippedSpace,
      graphEditorDims,
      graphEditorVerticalSpace,
      selectionAtom
    });
    return finalAtom.pointer;
  });
}
var import_dataverse22, panelSplitRatio, initialClippedSpaceRange;
var init_layout = __esm({
  "studio/src/panels/SequenceEditorPanel/layout/layout.ts"() {
    init_getStudio();
    init_subPrism();
    init_valToAtom();
    import_dataverse22 = __toModule(require("@theatre/dataverse"));
    init_tree();
    init_lodash();
    panelSplitRatio = 0.2;
    initialClippedSpaceRange = { start: 0, end: 10 };
  }
});

// studio/src/panels/SequenceEditorPanel/FrameGrid/StampsGrid.tsx
function drawStamps(opts) {
  const {
    fullSecondStampsContainer,
    sequencePositionFormatter,
    snapToGrid,
    unitSpaceToClippedSpace
  } = opts;
  let innerHTML = "";
  createGrid(opts, (_posInUnitSpace, isFullUnit) => {
    const posInUnitSpace = snapToGrid(_posInUnitSpace);
    const posInClippedSpace = unitSpaceToClippedSpace(posInUnitSpace);
    if (isFullUnit) {
      innerHTML += createStampClass(sequencePositionFormatter.formatFullUnitForGrid(posInUnitSpace), posInClippedSpace, "full-unit");
    } else {
      innerHTML += createStampClass(sequencePositionFormatter.formatSubUnitForGrid(posInUnitSpace), posInClippedSpace, "sub-unit");
    }
  });
  fullSecondStampsContainer.innerHTML = innerHTML;
}
function createStampClass(pos, x4, type) {
  return `<span class="${type}" style="transform: translate3d(${x4.toFixed(1)}px, -50%, 0);">${pos}</span>`;
}
var import_dataverse23, import_react55, Container9, stampsGridTheme, TheStamps, FullSecondStampsContainer, StampsGrid, StampsGrid_default;
var init_StampsGrid = __esm({
  "studio/src/panels/SequenceEditorPanel/FrameGrid/StampsGrid.tsx"() {
    import_dataverse23 = __toModule(require("@theatre/dataverse"));
    init_polished_esm();
    import_react55 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_createGrid();
    init_studioTicker();
    Container9 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
`;
    stampsGridTheme = {
      fullUnitStampColor: `#6a6a6a`,
      stampFontSize: "10px",
      get subUnitStampColor() {
        return curriedDarken(0.2, stampsGridTheme.fullUnitStampColor);
      }
    };
    TheStamps = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  height: 100%;
  left: 0;
  overflow: hidden;
  z-index: 2;
  will-change: transform;
  pointer-events: none;
`;
    FullSecondStampsContainer = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;

  & > span {
    position: absolute;
    display: block;
    top: 9px;
    left: -10px;
    color: ${stampsGridTheme.fullUnitStampColor};
    text-align: center;
    font-size: ${stampsGridTheme.stampFontSize};
    width: 20px;

    &.full-unit {
      color: ${stampsGridTheme.fullUnitStampColor};
    }

    &.sub-unit {
      color: ${stampsGridTheme.subUnitStampColor};
    }
  }

  pointer-events: none;
`;
    StampsGrid = ({ layoutP, width }) => {
      const containerRef = (0, import_react55.useRef)(null);
      const [fullSecondStampsContainer, fullSecondStampsContainerRef] = (0, import_react55.useState)(null);
      (0, import_react55.useLayoutEffect)(() => {
        if (!fullSecondStampsContainer)
          return;
        return (0, import_dataverse23.prism)(() => {
          const sequence = (0, import_dataverse23.val)(layoutP.sheet).getSequence();
          return {
            fullSecondStampsContainer,
            clippedSpaceRange: (0, import_dataverse23.val)(layoutP.clippedSpace.range),
            clippedSpaceWidth: (0, import_dataverse23.val)(layoutP.clippedSpace.width),
            unitSpaceToClippedSpace: (0, import_dataverse23.val)(layoutP.clippedSpace.fromUnitSpace),
            leftPadding: (0, import_dataverse23.val)(layoutP.scaledSpace.leftPadding),
            fps: sequence.subUnitsPerUnit,
            sequencePositionFormatter: sequence.positionFormatter,
            snapToGrid: (n3) => sequence.closestGridPosition(n3)
          };
        }).tapImmediate(studioTicker_default, drawStamps);
      }, [fullSecondStampsContainer, width, layoutP]);
      return /* @__PURE__ */ import_react55.default.createElement(Container9, {
        ref: containerRef,
        style: { width: width + "px" }
      }, /* @__PURE__ */ import_react55.default.createElement(TheStamps, {
        style: { width: width + "px" }
      }, /* @__PURE__ */ import_react55.default.createElement(FullSecondStampsContainer, {
        ref: fullSecondStampsContainerRef
      })));
    };
    StampsGrid_default = StampsGrid;
  }
});

// studio/src/utils/mousePositionD.ts
var import_dataverse24, mousePositionD, mousePositionD_default;
var init_mousePositionD = __esm({
  "studio/src/utils/mousePositionD.ts"() {
    import_dataverse24 = __toModule(require("@theatre/dataverse"));
    mousePositionD = (0, import_dataverse24.prism)(() => {
      const [pos, setPos] = import_dataverse24.prism.state("pos", null);
      import_dataverse24.prism.effect("setupListeners", () => {
        const handleMouseMove = (e2) => {
          setPos(e2);
        };
        document.addEventListener("mousemove", handleMouseMove);
        return () => {
          document.removeEventListener("mousemove", handleMouseMove);
        };
      }, []);
      return pos;
    });
    mousePositionD_default = mousePositionD;
  }
});

// studio/src/panels/SequenceEditorPanel/FrameStampPositionProvider.tsx
var import_dataverse25, import_react56, FrameStampPositionType, context2, lastLockId, FrameStampPositionProvider, useFrameStampPositionD, useLockFrameStampPositionRef, useLockFrameStampPosition, includeLockFrameStampAttrs, ATTR_LOCK_FRAMESTAMP, pointerPositionInUnitSpace, FrameStampPositionProvider_default;
var init_FrameStampPositionProvider = __esm({
  "studio/src/panels/SequenceEditorPanel/FrameStampPositionProvider.tsx"() {
    import_dataverse25 = __toModule(require("@theatre/dataverse"));
    init_mousePositionD();
    init_lodash();
    import_react56 = __toModule(require_react());
    (function(FrameStampPositionType2) {
      FrameStampPositionType2[FrameStampPositionType2["hidden"] = 0] = "hidden";
      FrameStampPositionType2[FrameStampPositionType2["locked"] = 1] = "locked";
      FrameStampPositionType2[FrameStampPositionType2["snapped"] = 2] = "snapped";
      FrameStampPositionType2[FrameStampPositionType2["free"] = 3] = "free";
    })(FrameStampPositionType || (FrameStampPositionType = {}));
    context2 = (0, import_react56.createContext)(null);
    lastLockId = 0;
    FrameStampPositionProvider = ({ children, layoutP }) => {
      const locksAtom = (0, import_react56.useMemo)(() => new import_dataverse25.Atom({ list: [] }), []);
      const currentD = (0, import_react56.useMemo)(() => (0, import_dataverse25.prism)(() => {
        const pointerPos = import_dataverse25.prism.memo("p", () => pointerPositionInUnitSpace(layoutP), [layoutP]).getValue();
        const locks = (0, import_dataverse25.val)(locksAtom.pointer.list);
        if (locks.length > 0) {
          return last_default(locks).position;
        } else {
          return pointerPos;
        }
      }), [layoutP]);
      const getLock2 = (0, import_react56.useCallback)(() => {
        const id = lastLockId++;
        locksAtom.reduceState(["list"], (list) => [
          ...list,
          {
            id,
            position: [-1, 0]
          }
        ]);
        const unlock = () => {
          locksAtom.reduceState(["list"], (list) => list.filter((lock) => lock.id !== id));
        };
        const set2 = (posInUnitSpace) => {
          locksAtom.reduceState(["list"], (list) => {
            const index = list.findIndex((lock) => lock.id === id);
            if (index === -1) {
              console.warn(`Lock is already freed. This is a bug.`);
              return list;
            }
            const newList = [...list];
            newList.splice(index, 1, {
              id,
              position: [
                posInUnitSpace,
                posInUnitSpace === -1 ? 0 : 1
              ]
            });
            return newList;
          });
        };
        return {
          set: set2,
          unlock
        };
      }, []);
      const value = {
        currentD,
        getLock: getLock2
      };
      return /* @__PURE__ */ import_react56.default.createElement(context2.Provider, {
        value
      }, children);
    };
    useFrameStampPositionD = () => (0, import_react56.useContext)(context2).currentD;
    useLockFrameStampPositionRef = () => {
      const { getLock: getLock2 } = (0, import_react56.useContext)(context2);
      const lockRef = (0, import_react56.useRef)();
      (0, import_react56.useLayoutEffect)(() => {
        return () => {
          var _a2;
          (_a2 = lockRef.current) == null ? void 0 : _a2.unlock();
        };
      }, []);
      return (0, import_react56.useMemo)(() => {
        let prevLock = void 0;
        return (shouldLock, posValue) => {
          var _a2, _b;
          if ((prevLock == null ? void 0 : prevLock.shouldLock) !== shouldLock) {
            if (shouldLock) {
              lockRef.current = getLock2();
            } else {
              (_a2 = lockRef.current) == null ? void 0 : _a2.unlock();
            }
          }
          if ((prevLock == null ? void 0 : prevLock.pos) !== posValue) {
            if (shouldLock) {
              (_b = lockRef.current) == null ? void 0 : _b.set(posValue);
            }
          }
          prevLock = { shouldLock, pos: posValue };
        };
      }, [getLock2]);
    };
    useLockFrameStampPosition = (shouldLock, val59) => {
      const { getLock: getLock2 } = (0, import_react56.useContext)(context2);
      const lockRef = (0, import_react56.useRef)();
      (0, import_react56.useLayoutEffect)(() => {
        if (!shouldLock)
          return;
        lockRef.current = getLock2();
        return () => {
          lockRef.current.unlock();
        };
      }, [shouldLock, getLock2]);
      (0, import_react56.useLayoutEffect)(() => {
        if (shouldLock) {
          lockRef.current.set(val59);
        }
      }, [val59, shouldLock]);
    };
    includeLockFrameStampAttrs = (value) => ({
      [ATTR_LOCK_FRAMESTAMP]: value === "hide" ? value : value.toFixed(3)
    });
    ATTR_LOCK_FRAMESTAMP = "data-theatre-lock-framestamp-to";
    pointerPositionInUnitSpace = (layoutP) => {
      return (0, import_dataverse25.prism)(() => {
        const rightDims = (0, import_dataverse25.val)(layoutP.rightDims);
        const clippedSpaceToUnitSpace = (0, import_dataverse25.val)(layoutP.clippedSpace.toUnitSpace);
        const mousePos = (0, import_dataverse25.val)(mousePositionD_default);
        if (!mousePos)
          return [-1, 0];
        for (const el of mousePos.composedPath()) {
          if (!(el instanceof HTMLElement || el instanceof SVGElement))
            break;
          if (el.hasAttribute(ATTR_LOCK_FRAMESTAMP)) {
            const val59 = el.getAttribute(ATTR_LOCK_FRAMESTAMP);
            if (typeof val59 !== "string")
              continue;
            if (val59 === "hide")
              return [-1, 0];
            const double = parseFloat(val59);
            if (isFinite(double) && double >= 0)
              return [double, 2];
          }
        }
        const { clientX, clientY } = mousePos;
        const { screenX: x4, screenY: y3, width: rightWidth, height: height2 } = rightDims;
        if (inRange_default(clientX, x4, x4 + rightWidth) && inRange_default(clientY, y3 + 16, y3 + height2)) {
          const posInRightDims = clientX - x4;
          const posInUnitSpace = clippedSpaceToUnitSpace(posInRightDims);
          return [posInUnitSpace, 3];
        } else {
          return [-1, 0];
        }
      });
    };
    FrameStampPositionProvider_default = FrameStampPositionProvider;
  }
});

// studio/src/uiComponents/useLockSet.ts
function useLockSet() {
  const [isLocked, _setIsLocked] = (0, import_react57.useState)(false);
  const addLock = (0, import_react57.useMemo)(() => {
    const locks = new Set();
    return () => {
      const unlock = () => {
        locks.delete(unlock);
        _setIsLocked(locks.size > 0);
      };
      locks.add(unlock);
      _setIsLocked(true);
      return unlock;
    };
  }, []);
  return [isLocked, addLock];
}
var import_react57;
var init_useLockSet = __esm({
  "studio/src/uiComponents/useLockSet.ts"() {
    import_react57 = __toModule(require_react());
  }
});

// ../node_modules/react-use/esm/useEffectOnce.js
var import_react58, useEffectOnce, useEffectOnce_default;
var init_useEffectOnce = __esm({
  "../node_modules/react-use/esm/useEffectOnce.js"() {
    import_react58 = __toModule(require_react());
    useEffectOnce = function(effect) {
      (0, import_react58.useEffect)(effect, []);
    };
    useEffectOnce_default = useEffectOnce;
  }
});

// ../node_modules/react-use/esm/useUnmount.js
var import_react59, useUnmount, useUnmount_default;
var init_useUnmount = __esm({
  "../node_modules/react-use/esm/useUnmount.js"() {
    import_react59 = __toModule(require_react());
    init_useEffectOnce();
    useUnmount = function(fn2) {
      var fnRef = (0, import_react59.useRef)(fn2);
      fnRef.current = fn2;
      useEffectOnce_default(function() {
        return function() {
          return fnRef.current();
        };
      });
    };
    useUnmount_default = useUnmount;
  }
});

// ../node_modules/react-use/esm/useRafState.js
var import_react60, useRafState, useRafState_default;
var init_useRafState = __esm({
  "../node_modules/react-use/esm/useRafState.js"() {
    import_react60 = __toModule(require_react());
    init_useUnmount();
    useRafState = function(initialState2) {
      var frame = (0, import_react60.useRef)(0);
      var _a2 = (0, import_react60.useState)(initialState2), state = _a2[0], setState = _a2[1];
      var setRafState = (0, import_react60.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
          setState(value);
        });
      }, []);
      useUnmount_default(function() {
        cancelAnimationFrame(frame.current);
      });
      return [state, setRafState];
    };
    useRafState_default = useRafState;
  }
});

// ../node_modules/react-use/esm/misc/util.js
function on2(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser;
var init_util = __esm({
  "../node_modules/react-use/esm/misc/util.js"() {
    isBrowser = typeof window !== "undefined";
  }
});

// ../node_modules/react-use/esm/useWindowSize.js
var import_react61, useWindowSize, useWindowSize_default;
var init_useWindowSize = __esm({
  "../node_modules/react-use/esm/useWindowSize.js"() {
    import_react61 = __toModule(require_react());
    init_useRafState();
    init_util();
    useWindowSize = function(initialWidth, initialHeight) {
      if (initialWidth === void 0) {
        initialWidth = Infinity;
      }
      if (initialHeight === void 0) {
        initialHeight = Infinity;
      }
      var _a2 = useRafState_default({
        width: isBrowser ? window.innerWidth : initialWidth,
        height: isBrowser ? window.innerHeight : initialHeight
      }), state = _a2[0], setState = _a2[1];
      (0, import_react61.useEffect)(function() {
        if (isBrowser) {
          var handler_1 = function() {
            setState({
              width: window.innerWidth,
              height: window.innerHeight
            });
          };
          on2(window, "resize", handler_1);
          return function() {
            off(window, "resize", handler_1);
          };
        }
      }, []);
      return state;
    };
    useWindowSize_default = useWindowSize;
  }
});

// studio/src/panels/BasePanel/BasePanel.tsx
var import_dataverse26, import_react63, panelDimsToPanelPosition, PanelContext, usePanel, BasePanel, BasePanel_default;
var init_BasePanel = __esm({
  "studio/src/panels/BasePanel/BasePanel.tsx"() {
    import_dataverse26 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    init_useLockSet();
    import_react63 = __toModule(require_react());
    init_useWindowSize();
    panelDimsToPanelPosition = (dims, windowDims) => {
      const left = dims.left / windowDims.width;
      const right = (dims.left + dims.width) / windowDims.width;
      const top = dims.top / windowDims.height;
      const bottom = (dims.height + dims.top) / windowDims.height;
      const position2 = {
        edges: {
          left: left <= 0.5 ? { from: "screenLeft", distance: left } : { from: "screenRight", distance: 1 - left },
          right: right <= 0.5 ? { from: "screenLeft", distance: right } : { from: "screenRight", distance: 1 - right },
          top: top <= 0.5 ? { from: "screenTop", distance: top } : { from: "screenBottom", distance: 1 - top },
          bottom: bottom <= 0.5 ? { from: "screenTop", distance: bottom } : { from: "screenBottom", distance: 1 - bottom }
        }
      };
      return position2;
    };
    PanelContext = import_react63.default.createContext(null);
    usePanel = () => (0, import_react63.useContext)(PanelContext);
    BasePanel = ({ panelId, children, defaultPosition: defaultPosition3, minDims: minDims3 }) => {
      const windowSize = useWindowSize_default(800, 200);
      const [boundsHighlighted, addBoundsHighlightLock] = useLockSet();
      const { stuff } = usePrism(() => {
        var _a2;
        const { edges } = (_a2 = (0, import_dataverse26.val)(getStudio().atomP.historic.panelPositions[panelId])) != null ? _a2 : defaultPosition3;
        const left = Math.floor(windowSize.width * (edges.left.from === "screenLeft" ? edges.left.distance : 1 - edges.left.distance));
        const right = Math.floor(windowSize.width * (edges.right.from === "screenLeft" ? edges.right.distance : 1 - edges.right.distance));
        const top = Math.floor(windowSize.height * (edges.top.from === "screenTop" ? edges.top.distance : 1 - edges.top.distance));
        const bottom = Math.floor(windowSize.height * (edges.bottom.from === "screenTop" ? edges.bottom.distance : 1 - edges.bottom.distance));
        const width = Math.max(right - left, minDims3.width);
        const height2 = Math.max(bottom - top, minDims3.height);
        const dims = import_dataverse26.prism.memo("dims", () => ({
          width,
          left,
          top,
          height: height2
        }), [width, left, top, height2]);
        const stuff2 = {
          dims,
          panelId,
          minDims: minDims3,
          boundsHighlighted,
          addBoundsHighlightLock
        };
        return { stuff: stuff2 };
      }, [panelId, windowSize, boundsHighlighted, addBoundsHighlightLock]);
      return /* @__PURE__ */ import_react63.default.createElement(PanelContext.Provider, {
        value: stuff
      }, children);
    };
    BasePanel_default = BasePanel;
  }
});

// studio/src/uiComponents/useHoverWithoutDescendants.ts
function useHoverWithoutDescendants(target) {
  const [isHovered, setIsHovered] = (0, import_react64.useState)(false);
  (0, import_react64.useEffect)(() => {
    setIsHovered(false);
    if (!target)
      return;
    const onMouseEnterOrMove = (e2) => {
      if (e2.target === target) {
        setIsHovered(true);
      } else {
        setIsHovered(false);
      }
    };
    const onMouseLeave = () => {
      setIsHovered(false);
    };
    target.addEventListener("mouseenter", onMouseEnterOrMove);
    target.addEventListener("mousemove", onMouseEnterOrMove);
    target.addEventListener("mouseleave", onMouseLeave);
    return () => {
      setIsHovered(false);
      target.removeEventListener("mouseenter", onMouseEnterOrMove);
      target.removeEventListener("mousemove", onMouseEnterOrMove);
      target.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [target]);
  return isHovered;
}
var import_react64;
var init_useHoverWithoutDescendants = __esm({
  "studio/src/uiComponents/useHoverWithoutDescendants.ts"() {
    import_react64 = __toModule(require_react());
  }
});

// studio/src/uiComponents/useBoundingClientRect.ts
function useBoundingClientRect(node) {
  const [bounds, set2] = (0, import_react65.useState)(null);
  (0, import_react65.useLayoutEffect)(() => {
    if (node) {
      set2(node.getBoundingClientRect());
    }
    return () => {
      set2(null);
    };
  }, [node]);
  return bounds;
}
var import_react65;
var init_useBoundingClientRect = __esm({
  "studio/src/uiComponents/useBoundingClientRect.ts"() {
    import_react65 = __toModule(require_react());
  }
});

// ../node_modules/polished/lib/internalHelpers/_curry.js
var require_curry = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_curry.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = curry2;
    function curried2(f3, length, acc) {
      return function fn2() {
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f3.apply(this, combined) : curried2(f3, length, combined);
      };
    }
    function curry2(f3) {
      return curried2(f3, f3.length, []);
    }
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_guard.js
var require_guard = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_guard.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    function guard2(lowerBoundary, upperBoundary, value) {
      return Math.max(lowerBoundary, Math.min(upperBoundary, value));
    }
    var _default = guard2;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_hslToRgb.js
var require_hslToRgb = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_hslToRgb.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    function colorToInt2(color2) {
      return Math.round(color2 * 255);
    }
    function convertToInt2(red, green, blue) {
      return colorToInt2(red) + "," + colorToInt2(green) + "," + colorToInt2(blue);
    }
    function hslToRgb2(hue, saturation, lightness, convert) {
      if (convert === void 0) {
        convert = convertToInt2;
      }
      if (saturation === 0) {
        return convert(lightness, lightness, lightness);
      }
      var huePrime = (hue % 360 + 360) % 360 / 60;
      var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
      var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
      var red = 0;
      var green = 0;
      var blue = 0;
      if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
      } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
      } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
      } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
      } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
      } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
      }
      var lightnessModification = lightness - chroma / 2;
      var finalRed = red + lightnessModification;
      var finalGreen = green + lightnessModification;
      var finalBlue = blue + lightnessModification;
      return convert(finalRed, finalGreen, finalBlue);
    }
    var _default = hslToRgb2;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_nameToHex.js
var require_nameToHex = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_nameToHex.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    var namedColorMap2 = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "639",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };
    function nameToHex2(color2) {
      if (typeof color2 !== "string")
        return color2;
      var normalizedColorName = color2.toLowerCase();
      return namedColorMap2[normalizedColorName] ? "#" + namedColorMap2[normalizedColorName] : color2;
    }
    var _default = nameToHex2;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_errors.js
var require_errors = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_errors.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    function _assertThisInitialized2(self2) {
      if (self2 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return self2;
    }
    function _inheritsLoose2(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf2(subClass, superClass);
    }
    function _wrapNativeSuper2(Class) {
      var _cache = typeof Map === "function" ? new Map() : void 0;
      _wrapNativeSuper2 = function _wrapNativeSuper3(Class2) {
        if (Class2 === null || !_isNativeFunction2(Class2))
          return Class2;
        if (typeof Class2 !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
          if (_cache.has(Class2))
            return _cache.get(Class2);
          _cache.set(Class2, Wrapper2);
        }
        function Wrapper2() {
          return _construct2(Class2, arguments, _getPrototypeOf2(this).constructor);
        }
        Wrapper2.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper2, enumerable: false, writable: true, configurable: true } });
        return _setPrototypeOf2(Wrapper2, Class2);
      };
      return _wrapNativeSuper2(Class);
    }
    function _construct2(Parent, args, Class) {
      if (_isNativeReflectConstruct2()) {
        _construct2 = Reflect.construct;
      } else {
        _construct2 = function _construct3(Parent2, args2, Class2) {
          var a4 = [null];
          a4.push.apply(a4, args2);
          var Constructor = Function.bind.apply(Parent2, a4);
          var instance = new Constructor();
          if (Class2)
            _setPrototypeOf2(instance, Class2.prototype);
          return instance;
        };
      }
      return _construct2.apply(null, arguments);
    }
    function _isNativeReflectConstruct2() {
      if (typeof Reflect === "undefined" || !Reflect.construct)
        return false;
      if (Reflect.construct.sham)
        return false;
      if (typeof Proxy === "function")
        return true;
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
        return true;
      } catch (e2) {
        return false;
      }
    }
    function _isNativeFunction2(fn2) {
      return Function.toString.call(fn2).indexOf("[native code]") !== -1;
    }
    function _setPrototypeOf2(o3, p3) {
      _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o4, p4) {
        o4.__proto__ = p4;
        return o4;
      };
      return _setPrototypeOf2(o3, p3);
    }
    function _getPrototypeOf2(o3) {
      _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o4) {
        return o4.__proto__ || Object.getPrototypeOf(o4);
      };
      return _getPrototypeOf2(o3);
    }
    var ERRORS2 = {
      "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
      "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
      "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
      "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
      "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
      "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
      "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
      "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
      "9": "Please provide a number of steps to the modularScale helper.\n\n",
      "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
      "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
      "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
      "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
      "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
      "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
      "16": "You must provide a template to this method.\n\n",
      "17": "You passed an unsupported selector state to this method.\n\n",
      "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
      "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
      "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
      "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      "23": "fontFace expects a name of a font-family.\n\n",
      "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
      "25": "fontFace expects localFonts to be an array.\n\n",
      "26": "fontFace expects fileFormats to be an array.\n\n",
      "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
      "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
      "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
      "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
      "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
      "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
      "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
      "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
      "36": "Property must be a string value.\n\n",
      "37": "Syntax Error at %s.\n\n",
      "38": "Formula contains a function that needs parentheses at %s.\n\n",
      "39": "Formula is missing closing parenthesis at %s.\n\n",
      "40": "Formula has too many closing parentheses at %s.\n\n",
      "41": "All values in a formula must have the same unit or be unitless.\n\n",
      "42": "Please provide a number of steps to the modularScale helper.\n\n",
      "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
      "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
      "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
      "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
      "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
      "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
      "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
      "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
      "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
      "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
      "53": "fontFace expects localFonts to be an array.\n\n",
      "54": "fontFace expects fileFormats to be an array.\n\n",
      "55": "fontFace expects a name of a font-family.\n\n",
      "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
      "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
      "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
      "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
      "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      "61": "Property must be a string value.\n\n",
      "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
      "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
      "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
      "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
      "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
      "67": "You must provide a template to this method.\n\n",
      "68": "You passed an unsupported selector state to this method.\n\n",
      "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
      "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
      "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
      "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
      "73": "Please provide a valid CSS variable.\n\n",
      "74": "CSS variable not found and no default was provided.\n\n",
      "75": "important requires a valid style object, got a %s instead.\n\n",
      "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
      "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
      "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
    };
    function format4() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var a4 = args[0];
      var b4 = [];
      var c3;
      for (c3 = 1; c3 < args.length; c3 += 1) {
        b4.push(args[c3]);
      }
      b4.forEach(function(d3) {
        a4 = a4.replace(/%[a-z]/, d3);
      });
      return a4;
    }
    var PolishedError2 = /* @__PURE__ */ function(_Error) {
      _inheritsLoose2(PolishedError3, _Error);
      function PolishedError3(code) {
        var _this;
        if (false) {
          _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        } else {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this = _Error.call(this, format4.apply(void 0, [ERRORS2[code]].concat(args))) || this;
        }
        return _assertThisInitialized2(_this);
      }
      return PolishedError3;
    }(/* @__PURE__ */ _wrapNativeSuper2(Error));
    exports2["default"] = PolishedError2;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/color/parseToRgb.js
var require_parseToRgb = __commonJS({
  "../node_modules/polished/lib/color/parseToRgb.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = parseToRgb2;
    var _hslToRgb = /* @__PURE__ */ _interopRequireDefault(require_hslToRgb());
    var _nameToHex = /* @__PURE__ */ _interopRequireDefault(require_nameToHex());
    var _errors = /* @__PURE__ */ _interopRequireDefault(require_errors());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var hexRegex2 = /^#[a-fA-F0-9]{6}$/;
    var hexRgbaRegex2 = /^#[a-fA-F0-9]{8}$/;
    var reducedHexRegex2 = /^#[a-fA-F0-9]{3}$/;
    var reducedRgbaHexRegex2 = /^#[a-fA-F0-9]{4}$/;
    var rgbRegex2 = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
    var rgbaRegex2 = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    var hslRegex2 = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
    var hslaRegex2 = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    function parseToRgb2(color2) {
      if (typeof color2 !== "string") {
        throw new _errors["default"](3);
      }
      var normalizedColor = (0, _nameToHex["default"])(color2);
      if (normalizedColor.match(hexRegex2)) {
        return {
          red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
          green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
          blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
        };
      }
      if (normalizedColor.match(hexRgbaRegex2)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
          green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
          blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
          alpha
        };
      }
      if (normalizedColor.match(reducedHexRegex2)) {
        return {
          red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
          green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
          blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
        };
      }
      if (normalizedColor.match(reducedRgbaHexRegex2)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
          green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
          blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
          alpha: _alpha
        };
      }
      var rgbMatched = rgbRegex2.exec(normalizedColor);
      if (rgbMatched) {
        return {
          red: parseInt("" + rgbMatched[1], 10),
          green: parseInt("" + rgbMatched[2], 10),
          blue: parseInt("" + rgbMatched[3], 10)
        };
      }
      var rgbaMatched = rgbaRegex2.exec(normalizedColor.substring(0, 50));
      if (rgbaMatched) {
        return {
          red: parseInt("" + rgbaMatched[1], 10),
          green: parseInt("" + rgbaMatched[2], 10),
          blue: parseInt("" + rgbaMatched[3], 10),
          alpha: parseFloat("" + rgbaMatched[4])
        };
      }
      var hslMatched = hslRegex2.exec(normalizedColor);
      if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + (0, _hslToRgb["default"])(hue, saturation, lightness) + ")";
        var hslRgbMatched = rgbRegex2.exec(rgbColorString);
        if (!hslRgbMatched) {
          throw new _errors["default"](4, normalizedColor, rgbColorString);
        }
        return {
          red: parseInt("" + hslRgbMatched[1], 10),
          green: parseInt("" + hslRgbMatched[2], 10),
          blue: parseInt("" + hslRgbMatched[3], 10)
        };
      }
      var hslaMatched = hslaRegex2.exec(normalizedColor.substring(0, 50));
      if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + (0, _hslToRgb["default"])(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = rgbRegex2.exec(_rgbColorString);
        if (!_hslRgbMatched) {
          throw new _errors["default"](4, normalizedColor, _rgbColorString);
        }
        return {
          red: parseInt("" + _hslRgbMatched[1], 10),
          green: parseInt("" + _hslRgbMatched[2], 10),
          blue: parseInt("" + _hslRgbMatched[3], 10),
          alpha: parseFloat("" + hslaMatched[4])
        };
      }
      throw new _errors["default"](5);
    }
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_reduceHexValue.js
var require_reduceHexValue = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_reduceHexValue.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    var reduceHexValue3 = function reduceHexValue4(value) {
      if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
        return "#" + value[1] + value[3] + value[5];
      }
      return value;
    };
    var _default = reduceHexValue3;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/internalHelpers/_numberToHex.js
var require_numberToHex = __commonJS({
  "../node_modules/polished/lib/internalHelpers/_numberToHex.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    function numberToHex2(value) {
      var hex = value.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    }
    var _default = numberToHex2;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/color/rgb.js
var require_rgb = __commonJS({
  "../node_modules/polished/lib/color/rgb.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = rgb2;
    var _reduceHexValue = /* @__PURE__ */ _interopRequireDefault(require_reduceHexValue());
    var _numberToHex = /* @__PURE__ */ _interopRequireDefault(require_numberToHex());
    var _errors = /* @__PURE__ */ _interopRequireDefault(require_errors());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function rgb2(value, green, blue) {
      if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
        return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value) + (0, _numberToHex["default"])(green) + (0, _numberToHex["default"])(blue));
      } else if (typeof value === "object" && green === void 0 && blue === void 0) {
        return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value.red) + (0, _numberToHex["default"])(value.green) + (0, _numberToHex["default"])(value.blue));
      }
      throw new _errors["default"](6);
    }
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/color/rgba.js
var require_rgba = __commonJS({
  "../node_modules/polished/lib/color/rgba.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = rgba2;
    var _parseToRgb = /* @__PURE__ */ _interopRequireDefault(require_parseToRgb());
    var _rgb = /* @__PURE__ */ _interopRequireDefault(require_rgb());
    var _errors = /* @__PURE__ */ _interopRequireDefault(require_errors());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function rgba2(firstValue, secondValue, thirdValue, fourthValue) {
      if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = (0, _parseToRgb["default"])(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
      } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
        return fourthValue >= 1 ? (0, _rgb["default"])(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
      } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
        return firstValue.alpha >= 1 ? (0, _rgb["default"])(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
      }
      throw new _errors["default"](7);
    }
    module2.exports = exports2.default;
  }
});

// ../node_modules/polished/lib/color/transparentize.js
var require_transparentize = __commonJS({
  "../node_modules/polished/lib/color/transparentize.js"(exports2, module2) {
    "use strict";
    exports2.__esModule = true;
    exports2["default"] = void 0;
    var _curry = /* @__PURE__ */ _interopRequireDefault(require_curry());
    var _guard = /* @__PURE__ */ _interopRequireDefault(require_guard());
    var _rgba = /* @__PURE__ */ _interopRequireDefault(require_rgba());
    var _parseToRgb = /* @__PURE__ */ _interopRequireDefault(require_parseToRgb());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _extends2() {
      _extends2 = Object.assign || function(target) {
        for (var i3 = 1; i3 < arguments.length; i3++) {
          var source = arguments[i3];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends2.apply(this, arguments);
    }
    function transparentize3(amount, color2) {
      if (color2 === "transparent")
        return color2;
      var parsedColor = (0, _parseToRgb["default"])(color2);
      var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
      var colorWithAlpha = _extends2({}, parsedColor, {
        alpha: (0, _guard["default"])(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
      });
      return (0, _rgba["default"])(colorWithAlpha);
    }
    var curriedTransparentize2 = /* @__PURE__ */ (0, _curry["default"])(transparentize3);
    var _default = curriedTransparentize2;
    exports2["default"] = _default;
    module2.exports = exports2.default;
  }
});

// studio/src/uiComponents/simpleContextMenu/ContextMenu/Item.tsx
var import_react66, height, ItemContainer, ItemLabel, Item, Item_default;
var init_Item = __esm({
  "studio/src/uiComponents/simpleContextMenu/ContextMenu/Item.tsx"() {
    init_noop2();
    import_react66 = __toModule(require_react());
    init_styled_components_browser_esm();
    height = 26;
    ItemContainer = styled_components_browser_esm_default.li`
  height: ${height}px;
  padding: 0 12px;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 400;
  position: relative;
  color: ${(props) => props.enabled ? "white" : "#8f8f8f"};
  cursor: ${(props) => props.enabled ? "normal" : "not-allowed"};

  &:after {
    position: absolute;
    inset: 2px 1px;
    display: block;
    content: ' ';
    pointer-events: none;
    z-index: -1;
    border-radius: 3px;
  }

  &:hover:after {
    background-color: ${(props) => props.enabled ? "rgba(63, 174, 191, 0.75)" : "initial"};
  }
`;
    ItemLabel = styled_components_browser_esm_default.span``;
    Item = (props) => {
      return /* @__PURE__ */ import_react66.default.createElement(ItemContainer, {
        onClick: props.enabled ? props.onClick : noop_default2,
        enabled: props.enabled,
        title: props.enabled ? void 0 : "Disabled"
      }, /* @__PURE__ */ import_react66.default.createElement(ItemLabel, null, props.label));
    };
    Item_default = Item;
  }
});

// studio/src/uiComponents/useOnKeyDown.ts
function useOnKeyDown(callback) {
  const ref = (0, import_react67.useRef)(callback);
  ref.current = callback;
  (0, import_react67.useEffect)(() => {
    const onKeyDown = (ev) => ref.current(ev);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, []);
}
var import_react67;
var init_useOnKeyDown = __esm({
  "studio/src/uiComponents/useOnKeyDown.ts"() {
    import_react67 = __toModule(require_react());
  }
});

// studio/src/uiComponents/simpleContextMenu/ContextMenu/ContextMenu.tsx
var import_transparentize, import_react68, import_react69, import_react70, import_react_dom5, minWidth, pointerDistanceThreshold, SHOW_OPTIONAL_MENU_TITLE, MenuContainer, MenuTitle, ContextMenu, ContextMenu_default;
var init_ContextMenu = __esm({
  "studio/src/uiComponents/simpleContextMenu/ContextMenu/ContextMenu.tsx"() {
    init_css();
    init_useBoundingClientRect();
    import_transparentize = __toModule(require_transparentize());
    import_react68 = __toModule(require_react());
    import_react69 = __toModule(require_react());
    import_react70 = __toModule(require_react());
    import_react_dom5 = __toModule(require_react_dom());
    init_useWindowSize();
    init_styled_components_browser_esm();
    init_Item();
    init_es2();
    init_useOnKeyDown();
    minWidth = 190;
    pointerDistanceThreshold = 20;
    SHOW_OPTIONAL_MENU_TITLE = true;
    MenuContainer = styled_components_browser_esm_default.ul`
  position: absolute;
  min-width: ${minWidth}px;
  z-index: 10000;
  background: ${(0, import_transparentize.default)(0.2, "#111")};
  backdrop-filter: blur(2px);
  color: white;
  list-style-type: none;
  padding: 2px 0;
  margin: 0;
  border-radius: 1px;
  cursor: default;
  ${pointerEventsAutoInNormalMode};
  border-radius: 3px;
`;
    MenuTitle = styled_components_browser_esm_default.div`
  padding: 4px 10px;
  border-bottom: 1px solid #6262626d;
  color: #adadadb3;
  font-size: 11px;
  font-weight: 500;
`;
    ContextMenu = (props) => {
      const [container, setContainer] = (0, import_react70.useState)(null);
      const rect = useBoundingClientRect(container);
      const windowSize = useWindowSize_default();
      (0, import_react70.useLayoutEffect)(() => {
        if (!rect || !container)
          return;
        const preferredAnchorPoint = {
          left: rect.width / 2,
          top: height / 2 + (props.displayName ? height : 0)
        };
        const pos = {
          left: props.clickPoint.clientX - preferredAnchorPoint.left,
          top: props.clickPoint.clientY - preferredAnchorPoint.top
        };
        if (pos.left < 0) {
          pos.left = 0;
        } else if (pos.left + rect.width > windowSize.width) {
          pos.left = windowSize.width - rect.width;
        }
        if (pos.top < 0) {
          pos.top = 0;
        } else if (pos.top + rect.height > windowSize.height) {
          pos.top = windowSize.height - rect.height;
        }
        container.style.left = pos.left + "px";
        container.style.top = pos.top + "px";
        const onMouseMove = (e2) => {
          if (e2.clientX < pos.left - pointerDistanceThreshold || e2.clientX > pos.left + rect.width + pointerDistanceThreshold || e2.clientY < pos.top - pointerDistanceThreshold || e2.clientY > pos.top + rect.height + pointerDistanceThreshold) {
            props.onRequestClose();
          }
        };
        window.addEventListener("mousemove", onMouseMove);
        return () => {
          window.removeEventListener("mousemove", onMouseMove);
        };
      }, [rect, container, props.clickPoint, windowSize, props.onRequestClose]);
      const portalLayer = (0, import_react69.useContext)(PortalContext);
      useOnKeyDown((ev) => {
        if (ev.key === "Escape")
          props.onRequestClose();
      });
      const items = (0, import_react68.useMemo)(() => {
        const itemsArr = Array.isArray(props.items) ? props.items : props.items();
        if (itemsArr.length > 0)
          return itemsArr;
        else
          return [
            {
              label: props.displayName ? `No actions for ${props.displayName}` : `No actions found`,
              enabled: false
            }
          ];
      }, [props.items]);
      return (0, import_react_dom5.createPortal)(/* @__PURE__ */ import_react70.default.createElement(MenuContainer, {
        ref: setContainer
      }, SHOW_OPTIONAL_MENU_TITLE && props.displayName ? /* @__PURE__ */ import_react70.default.createElement(MenuTitle, null, props.displayName) : null, items.map((item, i3) => /* @__PURE__ */ import_react70.default.createElement(Item_default, {
        key: `item-${i3}`,
        label: item.label,
        enabled: item.enabled === false ? false : true,
        onClick: (e2) => {
          if (item.callback) {
            item.callback(e2);
          }
          props.onRequestClose();
        }
      }))), portalLayer);
    };
    ContextMenu_default = ContextMenu;
  }
});

// studio/src/uiComponents/simpleContextMenu/useRequestContextMenu.ts
var import_react71, useRequestContextMenu, useRequestContextMenu_default;
var init_useRequestContextMenu = __esm({
  "studio/src/uiComponents/simpleContextMenu/useRequestContextMenu.ts"() {
    import_react71 = __toModule(require_react());
    useRequestContextMenu = (target, opts) => {
      const [state, setState] = (0, import_react71.useState)({ isOpen: false });
      const close = (0, import_react71.useCallback)(() => setState({ isOpen: false }), []);
      (0, import_react71.useEffect)(() => {
        if (!target || opts.disabled === true) {
          setState({ isOpen: false });
          return;
        }
        const onTrigger = (event) => {
          setState({ isOpen: true, event });
          event.preventDefault();
          event.stopPropagation();
        };
        target.addEventListener("contextmenu", onTrigger);
        return () => {
          target.removeEventListener("contextmenu", onTrigger);
        };
      }, [target, opts.disabled]);
      return [state, close];
    };
    useRequestContextMenu_default = useRequestContextMenu;
  }
});

// studio/src/uiComponents/form/BasicCheckbox.tsx
var BasicCheckbox, BasicCheckbox_default;
var init_BasicCheckbox = __esm({
  "studio/src/uiComponents/form/BasicCheckbox.tsx"() {
    init_styled_components_browser_esm();
    BasicCheckbox = styled_components_browser_esm_default.input.attrs({ type: "checkbox" })`
  outline: none;
`;
    BasicCheckbox_default = BasicCheckbox;
  }
});

// studio/src/propEditors/simpleEditors/BooleanPropEditor.tsx
function BooleanPropEditor({
  propConfig,
  editingTools,
  value,
  autoFocus
}) {
  const onChange = (0, import_react72.useCallback)((el) => {
    editingTools.permanentlySetValue(Boolean(el.target.checked));
  }, [propConfig, editingTools]);
  return /* @__PURE__ */ import_react72.default.createElement(Input, {
    checked: value,
    onChange,
    autoFocus
  });
}
var import_react72, Input, BooleanPropEditor_default;
var init_BooleanPropEditor = __esm({
  "studio/src/propEditors/simpleEditors/BooleanPropEditor.tsx"() {
    import_react72 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_BasicCheckbox();
    Input = styled_components_browser_esm_default(BasicCheckbox_default)`
  margin-left: 6px;

  :focus {
    outline: 1px solid #555;
  }
`;
    BooleanPropEditor_default = BooleanPropEditor;
  }
});

// ../node_modules/react-merge-refs/dist/react-merge-refs.esm.js
function mergeRefs(refs) {
  return function(value) {
    refs.forEach(function(ref) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}
var react_merge_refs_esm_default;
var init_react_merge_refs_esm = __esm({
  "../node_modules/react-merge-refs/dist/react-merge-refs.esm.js"() {
    react_merge_refs_esm_default = mergeRefs;
  }
});

// studio/src/uiComponents/useOnClickOutside.ts
function useOnClickOutside(container, onOutside, enabled) {
  (0, import_react73.useEffect)(() => {
    if (!container || enabled === false)
      return;
    const containers = Array.isArray(container) ? container.filter((container2) => container2) : [container];
    const onMouseDown = (e2) => {
      if (containers.every((container2) => !e2.composedPath().includes(container2))) {
        onOutside(e2);
      }
    };
    window.addEventListener("mousedown", onMouseDown, {
      capture: true,
      passive: false
    });
    return () => {
      window.removeEventListener("mousedown", onMouseDown, {
        capture: true,
        passive: false
      });
    };
  }, [container, enabled]);
}
var import_react73;
var init_useOnClickOutside = __esm({
  "studio/src/uiComponents/useOnClickOutside.ts"() {
    import_react73 = __toModule(require_react());
  }
});

// studio/src/uiComponents/form/BasicNumberInput.tsx
function format2(v5) {
  return isNaN(v5) ? "NaN" : isInteger_default(v5) ? v5.toFixed(0) : round_default(v5, 3).toString();
}
var import_react74, import_react75, import_react76, Container10, Input2, FillIndicator, DragWrap, alwaysValid, BasicNumberInput, BasicNumberInput_default;
var init_BasicNumberInput = __esm({
  "studio/src/uiComponents/form/BasicNumberInput.tsx"() {
    init_lodash();
    import_react74 = __toModule(require_react());
    import_react75 = __toModule(require_react());
    import_react76 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_react_merge_refs_esm();
    init_useRefAndState();
    init_useOnClickOutside();
    init_useDrag();
    Container10 = styled_components_browser_esm_default.div`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  &:after {
    position: absolute;
    inset: 1px 0 2px;
    display: block;
    content: ' ';
    background-color: transparent;
    border: 1px solid transparent;
    z-index: -2;
    box-sizing: border-box;
    border-radius: 1px;
  }

  &:hover,
  &.dragging,
  &.editingViaKeyboard {
    &:after {
      background-color: #10101042;
      border-color: #00000059;
    }
  }
`;
    Input2 = styled_components_browser_esm_default.input`
  background: transparent;
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.9);
  padding: 1px 6px;
  font: inherit;
  outline: none;
  cursor: ew-resize;
  text-align: left;
  width: 100%;
  height: calc(100% - 4px);
  border-radius: 2px;

  &:focus {
    cursor: text;
  }
`;
    FillIndicator = styled_components_browser_esm_default.div`
  position: absolute;
  inset: 3px 2px 4px;
  transform: scale(var(--percentage), 1);
  transform-origin: top left;
  background-color: #2d5561;
  z-index: -1;
  border-radius: 2px;
  pointer-events: none;

  ${Container10}.dragging &, ${Container10}.noFocus:hover & {
    background-color: #338198;
  }
`;
    DragWrap = styled_components_browser_esm_default.div`
  display: contents;
`;
    alwaysValid = (v5) => true;
    BasicNumberInput = (propsA) => {
      var _a2;
      const [stateRef] = useRefAndState({ mode: "noFocus" });
      const isValid = (_a2 = propsA.isValid) != null ? _a2 : alwaysValid;
      const propsRef = (0, import_react76.useRef)(propsA);
      propsRef.current = propsA;
      const inputRef = (0, import_react76.useRef)(null);
      useOnClickOutside(inputRef.current, () => {
        inputRef.current.blur();
      }, stateRef.current.mode === "editingViaKeyboard");
      const bodyCursorBeforeDrag = (0, import_react76.useRef)(null);
      const callbacks = (0, import_react76.useMemo)(() => {
        const inputChange = (e2) => {
          const target = e2.target;
          const { value: value2 } = target;
          const curState = stateRef.current;
          stateRef.current = __spreadProps(__spreadValues({}, curState), { currentEditedValueInString: value2 });
          const valInFloat = parseFloat(value2);
          if (!isFinite(valInFloat) || !isValid(valInFloat))
            return;
          propsRef.current.temporarilySetValue(valInFloat);
        };
        const onBlur = () => {
          if (stateRef.current.mode === "editingViaKeyboard") {
            commitKeyboardInput();
            stateRef.current = { mode: "noFocus" };
          }
          if (propsA.onBlur)
            propsA.onBlur();
        };
        const commitKeyboardInput = () => {
          const curState = stateRef.current;
          const value2 = parseFloat(curState.currentEditedValueInString);
          if (!isFinite(value2) || !isValid(value2)) {
            propsRef.current.discardTemporaryValue();
          } else {
            if (curState.valueBeforeEditing === value2) {
              propsRef.current.discardTemporaryValue();
            } else {
              propsRef.current.permanentlySetValue(value2);
            }
          }
        };
        const onInputKeyDown = (e2) => {
          if (e2.key === "Escape") {
            propsRef.current.discardTemporaryValue();
            stateRef.current = { mode: "noFocus" };
            inputRef.current.blur();
          } else if (e2.key === "Enter" || e2.key === "Tab") {
            commitKeyboardInput();
            inputRef.current.blur();
          }
        };
        const onClick = (e2) => {
          if (stateRef.current.mode === "noFocus") {
            const c3 = inputRef.current;
            c3.focus();
            e2.preventDefault();
            e2.stopPropagation();
          } else {
            e2.stopPropagation();
          }
        };
        const onFocus = () => {
          if (stateRef.current.mode === "noFocus") {
            transitionToEditingViaKeyboardMode();
          } else if (stateRef.current.mode === "editingViaKeyboard") {
          }
        };
        const transitionToEditingViaKeyboardMode = () => {
          const curValue = propsRef.current.value;
          stateRef.current = {
            mode: "editingViaKeyboard",
            currentEditedValueInString: String(curValue),
            valueBeforeEditing: curValue
          };
          setTimeout(() => {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(0, 100);
          });
        };
        let inputWidth;
        const transitionToDraggingMode = () => {
          var _a3;
          const curValue = propsRef.current.value;
          inputWidth = (_a3 = inputRef.current) == null ? void 0 : _a3.getBoundingClientRect().width;
          stateRef.current = {
            mode: "dragging"
          };
          let valueBeforeDragging = curValue;
          let valueDuringDragging = curValue;
          bodyCursorBeforeDrag.current = document.body.style.cursor;
          return {
            onDrag(_dx, _dy, e2, mx) {
              const deltaX = e2.altKey ? mx / 10 : mx;
              const newValue = valueDuringDragging + propsA.nudge({
                deltaX,
                deltaFraction: deltaX / inputWidth,
                magnitude: 1
              });
              valueDuringDragging = propsA.range ? clamp_default(newValue, propsA.range[0], propsA.range[1]) : newValue;
              propsRef.current.temporarilySetValue(valueDuringDragging);
            },
            onDragEnd(happened) {
              if (!happened) {
                propsRef.current.discardTemporaryValue();
                stateRef.current = { mode: "noFocus" };
              } else {
                if (valueBeforeDragging === valueDuringDragging) {
                  propsRef.current.discardTemporaryValue();
                } else {
                  propsRef.current.permanentlySetValue(valueDuringDragging);
                }
                stateRef.current = { mode: "noFocus" };
              }
            },
            onClick() {
              inputRef.current.focus();
              inputRef.current.setSelectionRange(0, 100);
            }
          };
        };
        return {
          inputChange,
          onBlur,
          transitionToDraggingMode,
          onInputKeyDown,
          onClick,
          onFocus
        };
      }, []);
      (0, import_react74.useEffect)(() => {
        return () => {
          callbacks.onBlur();
        };
      }, []);
      let value = stateRef.current.mode !== "editingViaKeyboard" ? format2(propsA.value) : stateRef.current.currentEditedValueInString;
      if (typeof value === "number" && isNaN(value)) {
        value = "NaN";
      }
      const _refs = [inputRef];
      if (propsA.inputRef)
        _refs.push(propsA.inputRef);
      const theInput = /* @__PURE__ */ import_react76.default.createElement(Input2, {
        key: "input",
        type: "text",
        onChange: callbacks.inputChange,
        value,
        onBlur: callbacks.onBlur,
        onKeyDown: callbacks.onInputKeyDown,
        onClick: callbacks.onClick,
        onFocus: callbacks.onFocus,
        ref: react_merge_refs_esm_default(_refs),
        onMouseDown: (e2) => {
          e2.stopPropagation();
        },
        onDoubleClick: (e2) => {
          e2.preventDefault();
          e2.stopPropagation();
        },
        autoFocus: propsA.autoFocus
      });
      const { range } = propsA;
      const num = parseFloat(value);
      const fillIndicator = range ? /* @__PURE__ */ import_react76.default.createElement(FillIndicator, {
        style: {
          "--percentage": clamp_default((num - range[0]) / (range[1] - range[0]), 0, 1)
        }
      }) : null;
      const [dragNode, setDragNode] = (0, import_react75.useState)(null);
      useDrag(dragNode, {
        debugName: "form/BasicNumberInput",
        onDragStart: callbacks.transitionToDraggingMode,
        lockCSSCursorTo: "ew-resize",
        shouldPointerLock: true,
        disabled: stateRef.current.mode === "editingViaKeyboard"
      });
      return /* @__PURE__ */ import_react76.default.createElement(Container10, {
        className: propsA.className + " " + stateRef.current.mode
      }, /* @__PURE__ */ import_react76.default.createElement(DragWrap, {
        ref: setDragNode
      }, theInput), fillIndicator);
    };
    BasicNumberInput_default = BasicNumberInput;
  }
});

// studio/src/propEditors/simpleEditors/NumberPropEditor.tsx
function NumberPropEditor({
  propConfig,
  editingTools,
  value,
  autoFocus
}) {
  const nudge3 = (0, import_react77.useCallback)((params) => {
    return propConfig.nudgeFn(__spreadProps(__spreadValues({}, params), { config: propConfig }));
  }, [propConfig]);
  return /* @__PURE__ */ import_react77.default.createElement(BasicNumberInput_default, {
    value,
    temporarilySetValue: editingTools.temporarilySetValue,
    discardTemporaryValue: editingTools.discardTemporaryValue,
    permanentlySetValue: editingTools.permanentlySetValue,
    range: propConfig.range,
    nudge: nudge3,
    autoFocus
  });
}
var import_react77, NumberPropEditor_default;
var init_NumberPropEditor = __esm({
  "studio/src/propEditors/simpleEditors/NumberPropEditor.tsx"() {
    init_BasicNumberInput();
    import_react77 = __toModule(require_react());
    NumberPropEditor_default = NumberPropEditor;
  }
});

// studio/src/uiComponents/form/BasicSwitch.tsx
function BasicSwitch({
  value,
  onChange,
  options: options2,
  autoFocus
}) {
  const _onChange = (0, import_react78.useCallback)((el) => {
    onChange(String(el.target.value));
  }, [onChange]);
  return /* @__PURE__ */ import_react78.default.createElement(Container11, {
    role: "radiogroup"
  }, Object.keys(options2).map((key, i3) => /* @__PURE__ */ import_react78.default.createElement(Label, {
    key: "label-" + i3,
    "data-checked": value === key
  }, options2[key], /* @__PURE__ */ import_react78.default.createElement(Input3, {
    type: "radio",
    checked: value === key,
    value: key,
    onChange: _onChange,
    name: "switchbox",
    autoFocus
  }))));
}
var import_react78, Container11, Label, Input3, BasicSwitch_default;
var init_BasicSwitch = __esm({
  "studio/src/uiComponents/form/BasicSwitch.tsx"() {
    init_polished_esm();
    import_react78 = __toModule(require_react());
    init_styled_components_browser_esm();
    Container11 = styled_components_browser_esm_default.form`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  vertical-align: middle;
  justify-content: stretch;
  height: 24px;
  width: 100%;
`;
    Label = styled_components_browser_esm_default.label`
  padding: 0 0.5em;
  background: transparent;
  /* background: #373748; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  color: #a7a7a7;
  border: 1px solid transparent;
  box-sizing: border-box;
  border-right-width: 0px;

  & + &:last-child {
    border-right-width: 1px;
  }

  ${Container11}:hover > & {
    border-color: #1c2123;
    /* background-color: #373748; */
    /* color: ${curriedDarken(0.1, "white")}; */
  }

  &&:hover {
    background-color: #464654;
  }

  &&[data-checked='true'] {
    color: white;
    background: #3f3f4c;
  }
`;
    Input3 = styled_components_browser_esm_default.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;
    BasicSwitch_default = BasicSwitch;
  }
});

// studio/src/uiComponents/form/BasicSelect.tsx
function BasicSelect({
  value,
  onChange,
  options: options2,
  className,
  autoFocus
}) {
  const _onChange = (0, import_react79.useCallback)((el) => {
    onChange(String(el.target.value));
  }, [onChange]);
  return /* @__PURE__ */ import_react79.default.createElement(Container12, null, /* @__PURE__ */ import_react79.default.createElement(Select, {
    className,
    value,
    onChange: _onChange,
    autoFocus
  }, Object.keys(options2).map((key, i3) => /* @__PURE__ */ import_react79.default.createElement("option", {
    key: "option-" + i3,
    value: key
  }, options2[key]))), /* @__PURE__ */ import_react79.default.createElement(IconContainer, null, /* @__PURE__ */ import_react79.default.createElement(CgSelect, null)));
}
var import_react79, Container12, IconContainer, Select, BasicSelect_default;
var init_BasicSelect = __esm({
  "studio/src/uiComponents/form/BasicSelect.tsx"() {
    import_react79 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_all();
    Container12 = styled_components_browser_esm_default.div`
  width: 100%;
  position: relative;
`;
    IconContainer = styled_components_browser_esm_default.div`
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 0;
  width: 1.5em;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #6b7280;
  pointer-events: none;
`;
    Select = styled_components_browser_esm_default.select`
  appearance: none;
  background-color: transparent;
  box-sizing: border-box;
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.85);
  padding: 1px 6px;
  font: inherit;
  outline: none;
  text-align: left;
  width: 100%;
  border-radius: 2px;
  /*
  looks like putting percentages in the height of a select box doesn't work in Firefox. Not sure why.
  So we're hard-coding the height to 26px, unlike all other inputs that use a relative height.
  */
  height: 26px /* calc(100% - 4px); */;

  @supports (-moz-appearance: none) {
    /* Ugly hack to remove the extra left padding that shows up only in Firefox */
    text-indent: -2px;
  }

  &:hover,
  &:focus {
    background-color: #10101042;
    border-color: #00000059;
  }
`;
    BasicSelect_default = BasicSelect;
  }
});

// studio/src/propEditors/simpleEditors/StringLiteralPropEditor.tsx
function StringLiteralPropEditor({
  propConfig,
  editingTools,
  value,
  autoFocus
}) {
  const onChange = (0, import_react80.useCallback)((val59) => {
    editingTools.permanentlySetValue(val59);
  }, [propConfig, editingTools]);
  return propConfig.as === "menu" ? /* @__PURE__ */ import_react80.default.createElement(BasicSelect_default, {
    value,
    onChange,
    options: propConfig.valuesAndLabels,
    autoFocus
  }) : /* @__PURE__ */ import_react80.default.createElement(BasicSwitch_default, {
    value,
    onChange,
    options: propConfig.valuesAndLabels,
    autoFocus
  });
}
var import_react80, StringLiteralPropEditor_default;
var init_StringLiteralPropEditor = __esm({
  "studio/src/propEditors/simpleEditors/StringLiteralPropEditor.tsx"() {
    import_react80 = __toModule(require_react());
    init_BasicSwitch();
    init_BasicSelect();
    StringLiteralPropEditor_default = StringLiteralPropEditor;
  }
});

// studio/src/uiComponents/form/BasicStringInput.tsx
function format3(v5) {
  return v5;
}
var import_react81, import_react82, Input4, alwaysValid2, BasicStringInput, BasicStringInput_default;
var init_BasicStringInput = __esm({
  "studio/src/uiComponents/form/BasicStringInput.tsx"() {
    init_styled_components_browser_esm();
    import_react81 = __toModule(require_react());
    import_react82 = __toModule(require_react());
    init_react_merge_refs_esm();
    init_useRefAndState();
    init_useOnClickOutside();
    Input4 = styled_components_browser_esm_default.input.attrs({ type: "text" })`
  background: transparent;
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.9);
  padding: 1px 6px;
  font: inherit;
  outline: none;
  cursor: text;
  text-align: left;
  width: 100%;
  height: calc(100% - 4px);
  border-radius: 2px;
  border: 1px solid transparent;
  box-sizing: border-box;

  &:hover {
    background-color: #10101042;
    border-color: #00000059;
  }

  &:hover,
  &:focus {
    cursor: text;
    background-color: #10101042;
    border-color: #00000059;
  }

  &.invalid {
    border-color: red;
  }
`;
    alwaysValid2 = (v5) => true;
    BasicStringInput = (props) => {
      var _a2, _b;
      const [stateRef] = useRefAndState({ mode: "noFocus" });
      const isValid = (_a2 = props.isValid) != null ? _a2 : alwaysValid2;
      const propsRef = (0, import_react82.useRef)(props);
      propsRef.current = props;
      const inputRef = (0, import_react82.useRef)(null);
      useOnClickOutside(inputRef.current, () => {
        inputRef.current.blur();
      }, stateRef.current.mode === "editingViaKeyboard");
      const callbacks = (0, import_react82.useMemo)(() => {
        const inputChange = (e2) => {
          const target = e2.target;
          const { value: value2 } = target;
          const curState = stateRef.current;
          stateRef.current = __spreadProps(__spreadValues({}, curState), { currentEditedValueInString: value2 });
          if (!isValid(value2))
            return;
          propsRef.current.temporarilySetValue(value2);
        };
        const onBlur = () => {
          var _a3, _b2;
          if (stateRef.current.mode === "editingViaKeyboard") {
            commitKeyboardInput();
            stateRef.current = { mode: "noFocus" };
          }
          (_b2 = (_a3 = propsRef.current).onBlur) == null ? void 0 : _b2.call(_a3);
        };
        const commitKeyboardInput = () => {
          const curState = stateRef.current;
          const value2 = curState.currentEditedValueInString;
          if (!isValid(value2)) {
            propsRef.current.discardTemporaryValue();
          } else {
            if (curState.valueBeforeEditing === value2) {
              propsRef.current.discardTemporaryValue();
            } else {
              propsRef.current.permanentlySetValue(value2);
            }
          }
        };
        const onInputKeyDown = (e2) => {
          if (e2.key === "Escape") {
            propsRef.current.discardTemporaryValue();
            stateRef.current = { mode: "noFocus" };
            inputRef.current.blur();
          } else if (e2.key === "Enter" || e2.key === "Tab") {
            commitKeyboardInput();
            inputRef.current.blur();
          }
        };
        const onClick = (e2) => {
          if (stateRef.current.mode === "noFocus") {
            const c3 = inputRef.current;
            c3.focus();
            e2.preventDefault();
            e2.stopPropagation();
          } else {
            e2.stopPropagation();
          }
        };
        const onFocus = () => {
          if (stateRef.current.mode === "noFocus") {
            transitionToEditingViaKeyboardMode();
          } else if (stateRef.current.mode === "editingViaKeyboard") {
          }
        };
        const transitionToEditingViaKeyboardMode = () => {
          const curValue = propsRef.current.value;
          stateRef.current = {
            mode: "editingViaKeyboard",
            currentEditedValueInString: String(curValue),
            valueBeforeEditing: curValue
          };
          setTimeout(() => {
            inputRef.current.focus();
          });
        };
        return {
          inputChange,
          onBlur,
          onInputKeyDown,
          onClick,
          onFocus
        };
      }, []);
      (0, import_react81.useEffect)(() => {
        return () => {
          callbacks.onBlur();
        };
      }, []);
      let value = stateRef.current.mode !== "editingViaKeyboard" ? format3(props.value) : stateRef.current.currentEditedValueInString;
      const _refs = [inputRef];
      if (props.inputRef)
        _refs.push(props.inputRef);
      const theInput = /* @__PURE__ */ import_react82.default.createElement(Input4, {
        key: "input",
        type: "text",
        className: `${(_b = props.className) != null ? _b : ""} ${!isValid(value) ? "invalid" : ""}`,
        onChange: callbacks.inputChange,
        value,
        onBlur: callbacks.onBlur,
        onKeyDown: callbacks.onInputKeyDown,
        onClick: callbacks.onClick,
        onFocus: callbacks.onFocus,
        ref: react_merge_refs_esm_default(_refs),
        onMouseDown: (e2) => {
          e2.stopPropagation();
        },
        onDoubleClick: (e2) => {
          e2.preventDefault();
          e2.stopPropagation();
        },
        autoFocus: props.autoFocus
      });
      return theInput;
    };
    BasicStringInput_default = BasicStringInput;
  }
});

// studio/src/propEditors/simpleEditors/StringPropEditor.tsx
function StringPropEditor({
  editingTools,
  value,
  autoFocus
}) {
  return /* @__PURE__ */ import_react83.default.createElement(BasicStringInput_default, {
    value,
    temporarilySetValue: editingTools.temporarilySetValue,
    discardTemporaryValue: editingTools.discardTemporaryValue,
    permanentlySetValue: editingTools.permanentlySetValue,
    autoFocus
  });
}
var import_react83, StringPropEditor_default;
var init_StringPropEditor = __esm({
  "studio/src/propEditors/simpleEditors/StringPropEditor.tsx"() {
    import_react83 = __toModule(require_react());
    init_BasicStringInput();
    StringPropEditor_default = StringPropEditor;
  }
});

// shared/src/utils/color.ts
function parseRgbaFromHex(rgba2) {
  rgba2 = rgba2.trim().toLowerCase();
  const match = rgba2.match(validHexRegExp);
  if (!match) {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  }
  const hex = _hexInEightValueSyntax(match[1]);
  return {
    r: parseInt(hex.substr(0, 2), 16) / 255,
    g: parseInt(hex.substr(2, 2), 16) / 255,
    b: parseInt(hex.substr(4, 2), 16) / 255,
    a: parseInt(hex.substr(6, 2), 16) / 255
  };
}
function rgba2hex(rgba2, {
  removeAlphaIfOpaque = false
} = {}) {
  const alpha = (rgba2.a * 255 | 1 << 8).toString(16).slice(1);
  const hex = (rgba2.r * 255 | 1 << 8).toString(16).slice(1) + (rgba2.g * 255 | 1 << 8).toString(16).slice(1) + (rgba2.b * 255 | 1 << 8).toString(16).slice(1) + (removeAlphaIfOpaque && alpha === "ff" ? "" : alpha);
  return `#${hex}`;
}
function decorateRgba(rgba2) {
  return __spreadProps(__spreadValues({}, rgba2), {
    toString() {
      return rgba2hex(this, { removeAlphaIfOpaque: true });
    }
  });
}
function _hexInEightValueSyntax(hex) {
  switch (hex.length) {
    case 3:
      return `${hex.repeat(2)}ff`;
    case 4:
      const rgb2 = hex.substr(0, 3);
      const alpha = hex[3];
      return `${rgb2.repeat(2)}${alpha.repeat(2)}`;
    case 6:
      return `${hex}ff`;
  }
  return hex;
}
var validHexRegExp;
var init_color = __esm({
  "shared/src/utils/color.ts"() {
    validHexRegExp = /^#*([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
  }
});

// studio/src/uiComponents/colorPicker/hooks/useEventCallback.ts
function useEventCallback(handler) {
  const callbackRef = (0, import_react84.useRef)(handler);
  const fn2 = (0, import_react84.useRef)((value) => {
    callbackRef.current && callbackRef.current(value);
  });
  callbackRef.current = handler;
  return fn2.current;
}
var import_react84;
var init_useEventCallback = __esm({
  "studio/src/uiComponents/colorPicker/hooks/useEventCallback.ts"() {
    import_react84 = __toModule(require_react());
  }
});

// studio/src/uiComponents/colorPicker/utils/clamp.ts
var clamp2;
var init_clamp2 = __esm({
  "studio/src/uiComponents/colorPicker/utils/clamp.ts"() {
    clamp2 = (number, min = 0, max = 1) => {
      return number > max ? max : number < min ? min : number;
    };
  }
});

// studio/src/uiComponents/colorPicker/components/EditingProvider.tsx
var import_react85, editingContext, EditingProvider, useEditing;
var init_EditingProvider = __esm({
  "studio/src/uiComponents/colorPicker/components/EditingProvider.tsx"() {
    import_react85 = __toModule(require_react());
    editingContext = (0, import_react85.createContext)(void 0);
    EditingProvider = ({ children }) => {
      const [editing, setEditing] = (0, import_react85.useState)(false);
      return /* @__PURE__ */ import_react85.default.createElement(editingContext.Provider, {
        value: {
          editing,
          setEditing
        }
      }, children);
    };
    useEditing = () => (0, import_react85.useContext)(editingContext);
  }
});

// studio/src/uiComponents/colorPicker/components/common/Interactive.tsx
var import_react86, isTouch, getTouchPoint, getParentWindow, getRelativePosition, preventDefaultMove, isInvalid, Container13, InteractiveBase, Interactive;
var init_Interactive = __esm({
  "studio/src/uiComponents/colorPicker/components/common/Interactive.tsx"() {
    import_react86 = __toModule(require_react());
    init_useEventCallback();
    init_clamp2();
    init_styled_components_browser_esm();
    init_EditingProvider();
    isTouch = (event) => "touches" in event;
    getTouchPoint = (touches, touchId) => {
      for (let i3 = 0; i3 < touches.length; i3++) {
        if (touches[i3].identifier === touchId)
          return touches[i3];
      }
      return touches[0];
    };
    getParentWindow = (node) => {
      return node && node.ownerDocument.defaultView || self;
    };
    getRelativePosition = (node, event, touchId) => {
      const rect = node.getBoundingClientRect();
      const pointer2 = isTouch(event) ? getTouchPoint(event.touches, touchId) : event;
      return {
        left: clamp2((pointer2.pageX - (rect.left + getParentWindow(node).pageXOffset)) / rect.width),
        top: clamp2((pointer2.pageY - (rect.top + getParentWindow(node).pageYOffset)) / rect.height)
      };
    };
    preventDefaultMove = (event) => {
      !isTouch(event) && event.preventDefault();
    };
    isInvalid = (event, hasTouch) => {
      return hasTouch && !isTouch(event);
    };
    Container13 = styled_components_browser_esm_default.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  outline: none;
  /* Don't trigger the default scrolling behavior when the event is originating from this element */
  touch-action: none;
`;
    InteractiveBase = (_a2) => {
      var _b = _a2, { onMove, onKey } = _b, rest = __objRest(_b, ["onMove", "onKey"]);
      const container = (0, import_react86.useRef)(null);
      const onMoveCallback = useEventCallback(onMove);
      const onKeyCallback = useEventCallback(onKey);
      const touchId = (0, import_react86.useRef)(null);
      const hasTouch = (0, import_react86.useRef)(false);
      const { setEditing } = useEditing();
      const [handleMoveStart, handleKeyDown, toggleDocumentEvents] = (0, import_react86.useMemo)(() => {
        const handleMoveStart2 = ({
          nativeEvent
        }) => {
          const el = container.current;
          if (!el)
            return;
          preventDefaultMove(nativeEvent);
          if (isInvalid(nativeEvent, hasTouch.current) || !el)
            return;
          if (isTouch(nativeEvent)) {
            hasTouch.current = true;
            const changedTouches = nativeEvent.changedTouches || [];
            if (changedTouches.length)
              touchId.current = changedTouches[0].identifier;
          }
          el.focus();
          setEditing(true);
          onMoveCallback(getRelativePosition(el, nativeEvent, touchId.current));
          toggleDocumentEvents2(true);
        };
        const handleMove = (event) => {
          preventDefaultMove(event);
          const isDown = isTouch(event) ? event.touches.length > 0 : event.buttons > 0;
          if (isDown && container.current) {
            onMoveCallback(getRelativePosition(container.current, event, touchId.current));
          } else {
            setEditing(false);
            toggleDocumentEvents2(false);
          }
        };
        const handleMoveEnd = (event) => {
          setEditing(false);
          toggleDocumentEvents2(false);
        };
        const handleKeyDown2 = (event) => {
          const keyCode = event.which || event.keyCode;
          if (keyCode < 37 || keyCode > 40)
            return;
          event.preventDefault();
          onKeyCallback({
            left: keyCode === 39 ? 0.05 : keyCode === 37 ? -0.05 : 0,
            top: keyCode === 40 ? 0.05 : keyCode === 38 ? -0.05 : 0
          });
        };
        function toggleDocumentEvents2(state) {
          const touch = hasTouch.current;
          const el = container.current;
          const parentWindow = getParentWindow(el);
          const toggleEvent = state ? parentWindow.addEventListener : parentWindow.removeEventListener;
          toggleEvent(touch ? "touchmove" : "mousemove", handleMove);
          toggleEvent(touch ? "touchend" : "mouseup", handleMoveEnd);
        }
        return [handleMoveStart2, handleKeyDown2, toggleDocumentEvents2];
      }, [onKeyCallback, onMoveCallback]);
      (0, import_react86.useEffect)(() => toggleDocumentEvents, [toggleDocumentEvents]);
      return /* @__PURE__ */ import_react86.default.createElement(Container13, __spreadProps(__spreadValues({}, rest), {
        onTouchStart: handleMoveStart,
        onMouseDown: handleMoveStart,
        ref: container,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "slider"
      }));
    };
    Interactive = import_react86.default.memo(InteractiveBase);
  }
});

// studio/src/uiComponents/colorPicker/components/common/Pointer.tsx
var import_react87, StyledInteractive, Container14, Fill, Pointer;
var init_Pointer = __esm({
  "studio/src/uiComponents/colorPicker/components/common/Pointer.tsx"() {
    import_react87 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Interactive();
    StyledInteractive = styled_components_browser_esm_default(Interactive)``;
    Container14 = styled_components_browser_esm_default.div`
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 1px solid #ffffff00;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  ${StyledInteractive}:focus & {
    transform: translate(-50%, -50%) scale(1.1);
  }
`;
    Fill = styled_components_browser_esm_default.div`
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  border-radius: inherit;
`;
    Pointer = ({
      className,
      color: color2,
      left,
      top = 0.5
    }) => {
      const style = {
        top: `${top * 100}%`,
        left: `${left * 100}%`
      };
      return /* @__PURE__ */ import_react87.default.createElement(Container14, {
        style,
        className
      }, /* @__PURE__ */ import_react87.default.createElement(Fill, {
        style: { backgroundColor: color2 }
      }));
    };
  }
});

// studio/src/uiComponents/colorPicker/utils/round.ts
var round2;
var init_round2 = __esm({
  "studio/src/uiComponents/colorPicker/utils/round.ts"() {
    round2 = (number, digits = 0, base = Math.pow(10, digits)) => {
      return Math.round(base * number) / base;
    };
  }
});

// studio/src/uiComponents/colorPicker/utils/convert.ts
var angleUnits, hsvaToHsla, hsvaToHslString, hsvaToHslaString, hsvaToRgba, rgbaToHsva;
var init_convert = __esm({
  "studio/src/uiComponents/colorPicker/utils/convert.ts"() {
    init_round2();
    angleUnits = {
      grad: 360 / 400,
      turn: 360,
      rad: 360 / (Math.PI * 2)
    };
    hsvaToHsla = ({ h: h4, s: s3, v: v5, a: a4 }) => {
      const hh = (200 - s3) * v5 / 100;
      return {
        h: round2(h4),
        s: round2(hh > 0 && hh < 200 ? s3 * v5 / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
        l: round2(hh / 2),
        a: round2(a4, 2)
      };
    };
    hsvaToHslString = (hsva) => {
      const { h: h4, s: s3, l: l4 } = hsvaToHsla(hsva);
      return `hsl(${h4}, ${s3}%, ${l4}%)`;
    };
    hsvaToHslaString = (hsva) => {
      const { h: h4, s: s3, l: l4, a: a4 } = hsvaToHsla(hsva);
      return `hsla(${h4}, ${s3}%, ${l4}%, ${a4})`;
    };
    hsvaToRgba = ({ h: h4, s: s3, v: v5, a: a4 }) => {
      h4 = h4 / 360 * 6;
      s3 = s3 / 100;
      v5 = v5 / 100;
      const hh = Math.floor(h4), b4 = v5 * (1 - s3), c3 = v5 * (1 - (h4 - hh) * s3), d3 = v5 * (1 - (1 - h4 + hh) * s3), module2 = hh % 6;
      return {
        r: round2([v5, c3, b4, b4, d3, v5][module2] * 255),
        g: round2([d3, v5, v5, c3, b4, b4][module2] * 255),
        b: round2([b4, b4, d3, v5, v5, c3][module2] * 255),
        a: round2(a4, 2)
      };
    };
    rgbaToHsva = ({ r: r3, g: g4, b: b4, a: a4 }) => {
      const max = Math.max(r3, g4, b4);
      const delta = max - Math.min(r3, g4, b4);
      const hh = delta ? max === r3 ? (g4 - b4) / delta : max === g4 ? 2 + (b4 - r3) / delta : 4 + (r3 - g4) / delta : 0;
      return {
        h: round2(60 * (hh < 0 ? hh + 6 : hh)),
        s: round2(max ? delta / max * 100 : 0),
        v: round2(max / 255 * 100),
        a: a4
      };
    };
  }
});

// studio/src/uiComponents/colorPicker/components/common/Hue.tsx
var import_react88, Container15, StyledPointer, HueBase, Hue;
var init_Hue = __esm({
  "studio/src/uiComponents/colorPicker/components/common/Hue.tsx"() {
    import_react88 = __toModule(require_react());
    init_Interactive();
    init_Pointer();
    init_convert();
    init_clamp2();
    init_round2();
    init_styled_components_browser_esm();
    Container15 = styled_components_browser_esm_default.div`
  position: relative;
  height: 16px;
  border-radius: 2px;

  background: linear-gradient(
    to right,
    #f00 0%,
    #ff0 17%,
    #0f0 33%,
    #0ff 50%,
    #00f 67%,
    #f0f 83%,
    #f00 100%
  );
`;
    StyledPointer = styled_components_browser_esm_default(Pointer)`
  z-index: 2;
`;
    HueBase = ({ className, hue, onChange }) => {
      const handleMove = (interaction) => {
        onChange({ h: 360 * interaction.left });
      };
      const handleKey = (offset) => {
        onChange({
          h: clamp2(hue + offset.left * 360, 0, 360)
        });
      };
      return /* @__PURE__ */ import_react88.default.createElement(Container15, {
        className
      }, /* @__PURE__ */ import_react88.default.createElement(Interactive, {
        onMove: handleMove,
        onKey: handleKey,
        "aria-label": "Hue",
        "aria-valuetext": round2(hue)
      }, /* @__PURE__ */ import_react88.default.createElement(StyledPointer, {
        left: hue / 360,
        color: hsvaToHslString({ h: hue, s: 100, v: 100, a: 1 })
      })));
    };
    Hue = import_react88.default.memo(HueBase);
  }
});

// studio/src/uiComponents/colorPicker/components/common/Saturation.tsx
var import_react89, Container16, StyledPointer2, SaturationBase, Saturation;
var init_Saturation = __esm({
  "studio/src/uiComponents/colorPicker/components/common/Saturation.tsx"() {
    import_react89 = __toModule(require_react());
    init_Interactive();
    init_Pointer();
    init_convert();
    init_clamp2();
    init_round2();
    init_styled_components_browser_esm();
    Container16 = styled_components_browser_esm_default.div`
  position: relative;
  flex-grow: 1;
  border-color: transparent; /* Fixes https://github.com/omgovich/react-colorful/issues/139 */
  border-bottom: 12px solid #000;
  border-radius: 2px;
  background-image: linear-gradient(to top, #000, rgba(0, 0, 0, 0)),
    linear-gradient(to right, #fff, rgba(255, 255, 255, 0));

  // Improve elements rendering on light backgrounds
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
`;
    StyledPointer2 = styled_components_browser_esm_default(Pointer)`
  z-index: 3;
`;
    SaturationBase = ({ hsva, onChange }) => {
      const handleMove = (interaction) => {
        onChange({
          s: interaction.left * 100,
          v: 100 - interaction.top * 100
        });
      };
      const handleKey = (offset) => {
        onChange({
          s: clamp2(hsva.s + offset.left * 100, 0, 100),
          v: clamp2(hsva.v - offset.top * 100, 0, 100)
        });
      };
      const containerStyle = {
        backgroundColor: hsvaToHslString({ h: hsva.h, s: 100, v: 100, a: 1 })
      };
      return /* @__PURE__ */ import_react89.default.createElement(Container16, {
        style: containerStyle
      }, /* @__PURE__ */ import_react89.default.createElement(Interactive, {
        onMove: handleMove,
        onKey: handleKey,
        "aria-label": "Color",
        "aria-valuetext": `Saturation ${round2(hsva.s)}%, Brightness ${round2(hsva.v)}%`
      }, /* @__PURE__ */ import_react89.default.createElement(StyledPointer2, {
        top: 1 - hsva.v / 100,
        left: hsva.s / 100,
        color: hsvaToHslString(hsva)
      })));
    };
    Saturation = import_react89.default.memo(SaturationBase);
  }
});

// studio/src/uiComponents/colorPicker/components/common/Alpha.tsx
var import_react90, Container17, Gradient, StyledPointer3, Alpha;
var init_Alpha = __esm({
  "studio/src/uiComponents/colorPicker/components/common/Alpha.tsx"() {
    import_react90 = __toModule(require_react());
    init_Interactive();
    init_Pointer();
    init_convert();
    init_clamp2();
    init_round2();
    init_styled_components_browser_esm();
    Container17 = styled_components_browser_esm_default.div`
  position: relative;
  height: 16px;
  border-radius: 2px;
  // Checkerboard
  background-color: #fff;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><rect x="8" width="8" height="8"/><rect y="8" width="8" height="8"/></svg>');
`;
    Gradient = styled_components_browser_esm_default.div.attrs(({ colorFrom, colorTo }) => ({
      style: {
        backgroundImage: `linear-gradient(90deg, ${colorFrom}, ${colorTo})`
      }
    }))`
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  border-radius: inherit;

  // Improve rendering on light backgrounds
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
`;
    StyledPointer3 = styled_components_browser_esm_default(Pointer)`
  // Checkerboard
  background-color: #fff;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><rect x="8" width="8" height="8"/><rect y="8" width="8" height="8"/></svg>');
`;
    Alpha = ({ className, hsva, onChange }) => {
      const handleMove = (interaction) => {
        onChange({ a: interaction.left });
      };
      const handleKey = (offset) => {
        onChange({ a: clamp2(hsva.a + offset.left) });
      };
      const colorFrom = hsvaToHslaString(Object.assign({}, hsva, { a: 0 }));
      const colorTo = hsvaToHslaString(Object.assign({}, hsva, { a: 1 }));
      return /* @__PURE__ */ import_react90.default.createElement(Container17, {
        className
      }, /* @__PURE__ */ import_react90.default.createElement(Gradient, {
        colorFrom,
        colorTo
      }), /* @__PURE__ */ import_react90.default.createElement(Interactive, {
        onMove: handleMove,
        onKey: handleKey,
        "aria-label": "Alpha",
        "aria-valuetext": `${round2(hsva.a * 100)}%`
      }, /* @__PURE__ */ import_react90.default.createElement(StyledPointer3, {
        left: hsva.a,
        color: hsvaToHslaString(hsva)
      })));
    };
  }
});

// studio/src/uiComponents/colorPicker/utils/compare.ts
var equalColorObjects;
var init_compare = __esm({
  "studio/src/uiComponents/colorPicker/utils/compare.ts"() {
    equalColorObjects = (first, second) => {
      if (first === second)
        return true;
      for (const prop in first) {
        if (first[prop] !== second[prop])
          return false;
      }
      return true;
    };
  }
});

// studio/src/uiComponents/colorPicker/hooks/useColorManipulation.ts
function useColorManipulation(colorModel2, color2, onTemporarilyChange, onPermanentlyChange) {
  const { editing } = useEditing();
  const [editingValue, setEditingValue] = (0, import_react91.useState)(color2);
  const onTemporarilyChangeCallback = useEventCallback(onTemporarilyChange);
  const onPermanentlyChangeCallback = useEventCallback(onPermanentlyChange);
  let value = editing ? editingValue : color2;
  const [hsva, updateHsva] = (0, import_react91.useState)(() => colorModel2.toHsva(value));
  const tempCache = (0, import_react91.useRef)({ color: value, hsva });
  const permCache = (0, import_react91.useRef)({ color: value, hsva });
  (0, import_react91.useEffect)(() => {
    if (editing) {
      setEditingValue(tempCache.current.color);
    }
  }, [editing]);
  (0, import_react91.useEffect)(() => {
    let newColor = colorModel2.fromHsva(hsva);
    if (editing) {
      if (!equalColorObjects(hsva, tempCache.current.hsva) && !colorModel2.equal(newColor, tempCache.current.color)) {
        tempCache.current = { hsva, color: newColor };
        setEditingValue(newColor);
        onTemporarilyChangeCallback(newColor);
      }
    } else {
      if (!equalColorObjects(hsva, permCache.current.hsva) && !colorModel2.equal(newColor, permCache.current.color)) {
        permCache.current = { hsva, color: newColor };
        tempCache.current = { hsva, color: newColor };
        onPermanentlyChangeCallback(newColor);
      }
    }
  }, [
    editing,
    hsva,
    colorModel2,
    onTemporarilyChangeCallback,
    onPermanentlyChangeCallback
  ]);
  (0, import_react91.useEffect)(() => {
    if (!editing) {
      if (!colorModel2.equal(value, permCache.current.color)) {
        const newHsva = colorModel2.toHsva(value);
        permCache.current = { hsva: newHsva, color: value };
        updateHsva(newHsva);
      }
    }
  }, [editing, value, colorModel2]);
  const handleChange = (0, import_react91.useCallback)((params) => {
    updateHsva((current) => Object.assign({}, current, params));
  }, []);
  return [hsva, handleChange];
}
var import_react91;
var init_useColorManipulation = __esm({
  "studio/src/uiComponents/colorPicker/hooks/useColorManipulation.ts"() {
    import_react91 = __toModule(require_react());
    init_compare();
    init_useEventCallback();
    init_EditingProvider();
  }
});

// studio/src/uiComponents/colorPicker/components/common/AlphaColorPicker.tsx
var import_react92, Container18, AlphaColorPicker;
var init_AlphaColorPicker = __esm({
  "studio/src/uiComponents/colorPicker/components/common/AlphaColorPicker.tsx"() {
    import_react92 = __toModule(require_react());
    init_Hue();
    init_Saturation();
    init_Alpha();
    init_useColorManipulation();
    init_styled_components_browser_esm();
    Container18 = styled_components_browser_esm_default.div`
  position: relative;
  display: flex;
  gap: 4px;
  flex-direction: column;
  width: 200px;
  height: 200px;
  user-select: none;
  cursor: default;
`;
    AlphaColorPicker = (_a2) => {
      var _b = _a2, {
        className,
        colorModel: colorModel2,
        color: color2 = colorModel2.defaultColor,
        temporarilySetValue,
        permanentlySetValue,
        discardTemporaryValue
      } = _b, rest = __objRest(_b, [
        "className",
        "colorModel",
        "color",
        "temporarilySetValue",
        "permanentlySetValue",
        "discardTemporaryValue"
      ]);
      const [tempHsva, updateHsva] = useColorManipulation(colorModel2, color2, temporarilySetValue, permanentlySetValue);
      (0, import_react92.useEffect)(() => {
        return () => {
          discardTemporaryValue();
        };
      }, []);
      return /* @__PURE__ */ import_react92.default.createElement(Container18, __spreadValues({}, rest), /* @__PURE__ */ import_react92.default.createElement(Saturation, {
        hsva: tempHsva,
        onChange: updateHsva
      }), /* @__PURE__ */ import_react92.default.createElement(Hue, {
        hue: tempHsva.h,
        onChange: updateHsva
      }), /* @__PURE__ */ import_react92.default.createElement(Alpha, {
        hsva: tempHsva,
        onChange: updateHsva
      }));
    };
  }
});

// studio/src/uiComponents/colorPicker/components/RgbaColorPicker.tsx
var import_react93, normalizeRgba, denormalizeRgba, colorModel, RgbaColorPicker;
var init_RgbaColorPicker = __esm({
  "studio/src/uiComponents/colorPicker/components/RgbaColorPicker.tsx"() {
    import_react93 = __toModule(require_react());
    init_AlphaColorPicker();
    init_compare();
    init_convert();
    init_EditingProvider();
    normalizeRgba = (rgba2) => {
      return {
        r: rgba2.r / 255,
        g: rgba2.g / 255,
        b: rgba2.b / 255,
        a: rgba2.a
      };
    };
    denormalizeRgba = (rgba2) => {
      return {
        r: rgba2.r * 255,
        g: rgba2.g * 255,
        b: rgba2.b * 255,
        a: rgba2.a
      };
    };
    colorModel = {
      defaultColor: { r: 0, g: 0, b: 0, a: 1 },
      toHsva: (rgba2) => rgbaToHsva(denormalizeRgba(rgba2)),
      fromHsva: (hsva) => normalizeRgba(hsvaToRgba(hsva)),
      equal: equalColorObjects
    };
    RgbaColorPicker = (props) => /* @__PURE__ */ import_react93.default.createElement(EditingProvider, null, /* @__PURE__ */ import_react93.default.createElement(AlphaColorPicker, __spreadProps(__spreadValues({}, props), {
      permanentlySetValue: (newColor) => {
        props.permanentlySetValue(newColor);
      },
      colorModel
    })));
  }
});

// studio/src/uiComponents/colorPicker/index.ts
var init_colorPicker = __esm({
  "studio/src/uiComponents/colorPicker/index.ts"() {
    init_RgbaColorPicker();
  }
});

// studio/src/uiComponents/Popover/ArrowContext.tsx
var import_react94, ArrowContext, ArrowContext_default;
var init_ArrowContext = __esm({
  "studio/src/uiComponents/Popover/ArrowContext.tsx"() {
    import_react94 = __toModule(require_react());
    ArrowContext = (0, import_react94.createContext)({});
    ArrowContext_default = ArrowContext;
  }
});

// studio/src/uiComponents/onPointerOutside.ts
function onPointerOutside(node, threshold, onPointerOutside2) {
  const containerRect = node.getBoundingClientRect();
  const onMouseMove = (e2) => {
    if (e2.clientX < containerRect.left - threshold || e2.clientX > containerRect.left + containerRect.width + threshold || e2.clientY < containerRect.top - threshold || e2.clientY > containerRect.top + containerRect.height + threshold) {
      onPointerOutside2(e2);
    }
  };
  window.addEventListener("mousemove", onMouseMove);
  return () => {
    window.removeEventListener("mousemove", onMouseMove);
  };
}
var init_onPointerOutside = __esm({
  "studio/src/uiComponents/onPointerOutside.ts"() {
  }
});

// studio/src/uiComponents/Popover/TooltipWrapper.tsx
var import_react95, import_react96, minimumDistanceOfArrowToEdgeOfPopover, TooltipWrapper, TooltipWrapper_default;
var init_TooltipWrapper = __esm({
  "studio/src/uiComponents/Popover/TooltipWrapper.tsx"() {
    import_react95 = __toModule(require_react());
    import_react96 = __toModule(require_react());
    init_useWindowSize();
    init_useBoundingClientRect();
    init_ArrowContext();
    init_useRefAndState();
    init_useOnClickOutside();
    init_onPointerOutside();
    init_noop2();
    init_lodash();
    minimumDistanceOfArrowToEdgeOfPopover = 8;
    TooltipWrapper = (props) => {
      var _a2, _b;
      const originalElement = props.children();
      const [ref, container] = useRefAndState(null);
      const style = originalElement.props.style ? __spreadValues({}, originalElement.props.style) : {};
      style.position = "absolute";
      const containerRect = useBoundingClientRect(container);
      const targetRect = useBoundingClientRect(props.target);
      const windowSize = useWindowSize_default();
      const [arrowContextValue, setArrowContextValue] = (0, import_react96.useState)({});
      (0, import_react96.useLayoutEffect)(() => {
        var _a3, _b2, _c;
        if (!containerRect || !container || !targetRect)
          return;
        const gap = (_a3 = props.verticalGap) != null ? _a3 : 8;
        const arrowStyle = {};
        let verticalPlacement = (_b2 = props.verticalPlacement) != null ? _b2 : "bottom";
        let top = 0;
        let left = 0;
        if (verticalPlacement === "bottom") {
          if (targetRect.bottom + containerRect.height + gap < windowSize.height) {
            verticalPlacement = "bottom";
            top = targetRect.bottom + gap;
            arrowStyle.top = "0px";
          } else if (targetRect.top > containerRect.height + gap) {
            verticalPlacement = "top";
            top = targetRect.top - (containerRect.height + gap);
            arrowStyle.bottom = "0px";
            arrowStyle.transform = "rotateZ(180deg)";
          } else {
            verticalPlacement = "overlay";
          }
        } else if (verticalPlacement === "top") {
          if (targetRect.top > containerRect.height + gap) {
            verticalPlacement = "top";
            top = targetRect.top - (containerRect.height + gap);
            arrowStyle.bottom = "0px";
            arrowStyle.transform = "rotateZ(180deg)";
          } else if (targetRect.bottom + containerRect.height + gap < windowSize.height) {
            verticalPlacement = "bottom";
            top = targetRect.bottom + gap;
            arrowStyle.top = "0px";
          } else {
            verticalPlacement = "overlay";
          }
        }
        let arrowLeft = 0;
        if (verticalPlacement !== "overlay") {
          const anchorLeft = targetRect.left + targetRect.width / 2;
          if (anchorLeft < containerRect.width / 2) {
            left = gap;
            arrowLeft = Math.max(anchorLeft - gap, minimumDistanceOfArrowToEdgeOfPopover);
          } else if (anchorLeft + containerRect.width / 2 > windowSize.width) {
            left = windowSize.width - (gap + containerRect.width);
            arrowLeft = Math.min(anchorLeft - left, containerRect.width - minimumDistanceOfArrowToEdgeOfPopover);
          } else {
            left = anchorLeft - containerRect.width / 2;
            arrowLeft = containerRect.width / 2;
          }
          arrowStyle.left = arrowLeft + "px";
        }
        const {
          minX = -Infinity,
          maxX = Infinity,
          minY = -Infinity,
          maxY = Infinity
        } = (_c = props.constraints) != null ? _c : {};
        const pos = {
          left: clamp_default(left, minX, maxX - containerRect.width),
          top: clamp_default(top, minY, maxY + containerRect.height)
        };
        container.style.left = pos.left + "px";
        container.style.top = pos.top + "px";
        setArrowContextValue(arrowStyle);
        if (props.onPointerOutside) {
          return onPointerOutside(container, props.onPointerOutside.threshold, props.onPointerOutside.callback);
        }
      }, [
        containerRect,
        container,
        props.target,
        targetRect,
        windowSize,
        props.onPointerOutside
      ]);
      useOnClickOutside([container, (_a2 = props.target) != null ? _a2 : null], (_b = props.onClickOutside) != null ? _b : noop_default2);
      return /* @__PURE__ */ import_react95.default.createElement(ArrowContext_default.Provider, {
        value: arrowContextValue
      }, (0, import_react96.cloneElement)(originalElement, { ref, style }));
    };
    TooltipWrapper_default = TooltipWrapper;
  }
});

// studio/src/uiComponents/Popover/usePopover.tsx
function usePopover(opts, render) {
  const _debug = (...args) => {
  };
  const { isPointerBeingCaptured } = usePointerCapturing(`usePopover`);
  const [stateRef, state] = useRefAndState({
    isOpen: false
  });
  const optsRef = (0, import_react97.useRef)(opts);
  const close = (0, import_react97.useCallback)((reason) => {
    _debug(`closing due to "${reason}"`);
    stateRef.current = { isOpen: false };
  }, []);
  const open = (0, import_react97.useCallback)((e2, target) => {
    var _a2;
    const opts2 = typeof optsRef.current === "function" ? optsRef.current() : optsRef.current;
    function onClickOutside() {
      if (lock.childHasFocusRef.current)
        return;
      if (opts2.closeOnClickOutside !== false) {
        close("clicked outside popover");
      }
    }
    stateRef.current = {
      isOpen: true,
      clickPoint: { clientX: e2.clientX, clientY: e2.clientY },
      target,
      opts: opts2,
      onClickOutside,
      onPointerOutside: opts2.closeWhenPointerIsDistant === false ? void 0 : {
        threshold: (_a2 = opts2.pointerDistanceThreshold) != null ? _a2 : 100,
        callback: () => {
          if (lock.childHasFocusRef.current)
            return;
          if (isPointerBeingCaptured())
            return;
          close("pointer outside");
        }
      }
    };
  }, []);
  const toggle = (0, import_react97.useCallback)((...args) => {
    if (stateRef.current.isOpen) {
      close("toggled");
    } else {
      open(...args);
    }
  }, []);
  const lock = useAutoCloseLockState({
    _debug,
    state
  });
  const [, addContextMenu] = (0, import_react97.useContext)(contextMenuShownContext);
  (0, import_react97.useEffect)(() => {
    let removeContextMenu;
    if (state.isOpen) {
      removeContextMenu = addContextMenu();
    }
    return () => removeContextMenu == null ? void 0 : removeContextMenu();
  }, [state.isOpen]);
  const portalLayer = (0, import_react97.useContext)(PortalContext);
  const node = state.isOpen ? (0, import_react_dom6.createPortal)(/* @__PURE__ */ import_react97.default.createElement(PopoverAutoCloseLock.Provider, {
    value: lock.childPopoverLock
  }, /* @__PURE__ */ import_react97.default.createElement(TooltipWrapper_default, {
    children: render,
    target: state.target,
    onClickOutside: state.onClickOutside,
    onPointerOutside: state.onPointerOutside,
    constraints: state.opts.constraints,
    verticalGap: state.opts.verticalGap
  })), portalLayer) : /* @__PURE__ */ import_react97.default.createElement(import_react97.default.Fragment, null);
  return { node, open, close, toggle, isOpen: state.isOpen };
}
function useAutoCloseLockState(options2) {
  const parentLock = (0, import_react97.useContext)(PopoverAutoCloseLock);
  (0, import_react97.useEffect)(() => {
    if (options2.state.isOpen) {
      const focused = parentLock.takeFocus();
      options2._debug("take focus");
      return () => {
        options2._debug("release focus");
        focused.releaseFocus();
      };
    }
  }, [options2.state.isOpen]);
  const childHasFocusRef = (0, import_react97.useRef)(false);
  return {
    childHasFocusRef,
    childPopoverLock: {
      takeFocus() {
        childHasFocusRef.current = true;
        return {
          releaseFocus() {
            childHasFocusRef.current = false;
          }
        };
      }
    }
  };
}
var import_react97, import_react_dom6, PopoverAutoCloseLock;
var init_usePopover = __esm({
  "studio/src/uiComponents/Popover/usePopover.tsx"() {
    init_PointerCapturing();
    init_useRefAndState();
    import_react97 = __toModule(require_react());
    import_react_dom6 = __toModule(require_react_dom());
    init_es2();
    init_TooltipWrapper();
    init_DetailPanel();
    PopoverAutoCloseLock = import_react97.default.createContext({
      takeFocus() {
        return {
          releaseFocus() {
          }
        };
      }
    });
  }
});

// studio/src/uiComponents/Popover/PopoverArrow.tsx
var import_react98, Container19, Adjust, InnerTriangle, InnerStroke, OuterStroke, PopoverArrow, PopoverArrow_default;
var init_PopoverArrow = __esm({
  "studio/src/uiComponents/Popover/PopoverArrow.tsx"() {
    import_react98 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_ArrowContext();
    Container19 = styled_components_browser_esm_default.div`
  position: absolute;
  width: 0;
  height: 0;
  color: var(--popover-arrow-color);
  pointer-events: none;
`;
    Adjust = styled_components_browser_esm_default.div`
  width: 12px;
  height: 8px;
  position: absolute;
  left: -7px;
  top: -8px;
  text-align: center;
  line-height: 0;
`;
    InnerTriangle = styled_components_browser_esm_default.path`
  fill: var(--popover-bg);
`;
    InnerStroke = styled_components_browser_esm_default.path`
  fill: var(--popover-inner-stroke);
`;
    OuterStroke = styled_components_browser_esm_default.path`
  fill: var(--popover-outer-stroke);
`;
    PopoverArrow = (0, import_react98.forwardRef)(({ className }, ref) => {
      const arrowStyle = (0, import_react98.useContext)(ArrowContext_default);
      return /* @__PURE__ */ import_react98.default.createElement(Container19, {
        className,
        ref,
        style: __spreadValues({}, arrowStyle)
      }, /* @__PURE__ */ import_react98.default.createElement(Adjust, null, /* @__PURE__ */ import_react98.default.createElement("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react98.default.createElement(OuterStroke, {
        d: "M6 0L0 6H12L6 0Z"
      }), /* @__PURE__ */ import_react98.default.createElement(InnerStroke, {
        d: "M6 1.5L0 7.5H12L6 1.5Z"
      }), /* @__PURE__ */ import_react98.default.createElement(InnerTriangle, {
        d: "M6 3L0 9H12L6 3Z"
      }))));
    });
    PopoverArrow_default = PopoverArrow;
  }
});

// studio/src/uiComponents/Popover/BasicPopover.tsx
var import_react99, popoverBackgroundColor, Container20, BasicPopover, BasicPopover_default;
var init_BasicPopover = __esm({
  "studio/src/uiComponents/Popover/BasicPopover.tsx"() {
    init_css();
    init_polished_esm();
    import_react99 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_PopoverArrow();
    popoverBackgroundColor = curriedTransparentize(0.05, `#2a2a31`);
    Container20 = styled_components_browser_esm_default.div`
  position: absolute;
  --popover-bg: ${popoverBackgroundColor};
  --popover-inner-stroke: #505159;
  --popover-outer-stroke: #111;

  background: var(--popover-bg);

  color: white;
  padding: 0;
  margin: 0;
  cursor: default;
  ${pointerEventsAutoInNormalMode};
  border-radius: 3px;
  z-index: 10000;
  border: 1px solid var(--popover-inner-stroke);
  box-shadow: 0 0 0 1px var(--popover-outer-stroke), 0 6px 8px -4px black;
  backdrop-filter: blur(8px);

  & a {
    color: inherit;
  }
`;
    BasicPopover = import_react99.default.forwardRef(({
      children,
      className,
      showPopoverEdgeTriangle = true
    }, ref) => {
      return /* @__PURE__ */ import_react99.default.createElement(Container20, {
        className,
        ref
      }, showPopoverEdgeTriangle ? /* @__PURE__ */ import_react99.default.createElement(PopoverArrow_default, null) : void 0, children);
    });
    BasicPopover_default = BasicPopover;
  }
});

// studio/src/propEditors/simpleEditors/RgbaPropEditor.tsx
function RgbaPropEditor({
  editingTools,
  value,
  autoFocus
}) {
  const containerRef = (0, import_react100.useRef)(null);
  const onChange = (0, import_react100.useCallback)((color2) => {
    const rgba2 = decorateRgba(parseRgbaFromHex(color2));
    editingTools.permanentlySetValue(rgba2);
  }, [editingTools]);
  const popover = usePopover({ debugName: "RgbaPropEditor" }, () => /* @__PURE__ */ import_react100.default.createElement(RgbaPopover, null, /* @__PURE__ */ import_react100.default.createElement(RgbaColorPicker, {
    color: {
      r: value.r,
      g: value.g,
      b: value.b,
      a: value.a
    },
    temporarilySetValue: (color2) => {
      const rgba2 = decorateRgba(color2);
      editingTools.temporarilySetValue(rgba2);
    },
    permanentlySetValue: (color2) => {
      const rgba2 = decorateRgba(color2);
      editingTools.permanentlySetValue(rgba2);
    },
    discardTemporaryValue: editingTools.discardTemporaryValue
  })));
  return /* @__PURE__ */ import_react100.default.createElement(import_react100.default.Fragment, null, /* @__PURE__ */ import_react100.default.createElement(RowContainer, null, /* @__PURE__ */ import_react100.default.createElement(ColorPreviewPuck, {
    rgbaColor: value,
    ref: containerRef,
    onClick: (e2) => {
      popover.toggle(e2, containerRef.current);
    }
  }), /* @__PURE__ */ import_react100.default.createElement(HexInput, {
    value: rgba2hex(value, { removeAlphaIfOpaque: true }),
    temporarilySetValue: noop3,
    discardTemporaryValue: noop3,
    permanentlySetValue: onChange,
    isValid: (v5) => !!v5.match(validHexRegExp),
    autoFocus
  })), popover.node);
}
var import_react100, RowContainer, ColorPreviewPuck, HexInput, noop3, RgbaPopover, RgbaPropEditor_default;
var init_RgbaPropEditor = __esm({
  "studio/src/propEditors/simpleEditors/RgbaPropEditor.tsx"() {
    init_color();
    init_color();
    import_react100 = __toModule(require_react());
    init_colorPicker();
    init_styled_components_browser_esm();
    init_usePopover();
    init_BasicStringInput();
    init_BasicPopover();
    RowContainer = styled_components_browser_esm_default.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 4px;
`;
    ColorPreviewPuck = styled_components_browser_esm_default.div.attrs((props) => ({
      style: {
        background: rgba2hex(props.rgbaColor)
      }
    }))`
  height: 18px;
  aspect-ratio: 1;
  border-radius: 99999px;
`;
    HexInput = styled_components_browser_esm_default(BasicStringInput_default)`
  flex: 1;
`;
    noop3 = () => {
    };
    RgbaPopover = styled_components_browser_esm_default.div`
  position: absolute;
  background-color: ${popoverBackgroundColor};
  color: white;
  margin: 0;
  cursor: default;
  border-radius: 3px;
  z-index: 10000;
  backdrop-filter: blur(8px);

  padding: 4px;
  pointer-events: all;

  border: none;
  box-shadow: none;
`;
    RgbaPropEditor_default = RgbaPropEditor;
  }
});

// studio/src/propEditors/simpleEditors/simplePropEditorByPropType.ts
var simplePropEditorByPropType;
var init_simplePropEditorByPropType = __esm({
  "studio/src/propEditors/simpleEditors/simplePropEditorByPropType.ts"() {
    init_BooleanPropEditor();
    init_NumberPropEditor();
    init_StringLiteralPropEditor();
    init_StringPropEditor();
    init_RgbaPropEditor();
    simplePropEditorByPropType = {
      number: NumberPropEditor_default,
      string: StringPropEditor_default,
      boolean: BooleanPropEditor_default,
      stringLiteral: StringLiteralPropEditor_default,
      rgba: RgbaPropEditor_default
    };
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail/rowIndentationFormulaCSS.tsx
var rowIndentationFormulaCSS;
var init_rowIndentationFormulaCSS = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail/rowIndentationFormulaCSS.tsx"() {
    rowIndentationFormulaCSS = `calc(var(--left-pad) + var(--depth) * var(--step))`;
  }
});

// studio/src/propEditors/useEditingToolsForCompoundProp.tsx
function useEditingToolsForCompoundProp(pointerToProp, obj, propConfig) {
  return usePrism(() => {
    if (!compoundHasSimpleDescendants(propConfig)) {
      return {
        type: "AllStatic",
        beingScrubbed: false,
        contextMenuItems: [],
        controlIndicators: /* @__PURE__ */ import_react102.default.createElement(DefaultValueIndicator_default, {
          hasStaticOverride: false
        })
      };
    }
    const pathToProp = (0, import_dataverse27.getPointerParts)(pointerToProp).path;
    const someDescendantsBeingScrubbed = !!(0, import_dataverse27.val)(get_default(getStudio().atomP.ephemeral.projects.stateByProjectId[obj.address.projectId].stateBySheetId[obj.address.sheetId].stateByObjectKey[obj.address.objectKey].valuesBeingScrubbed, (0, import_dataverse27.getPointerParts)(pointerToProp).path));
    const contextMenuItems = [];
    const common = {
      beingScrubbed: someDescendantsBeingScrubbed,
      contextMenuItems,
      controlIndicators: /* @__PURE__ */ import_react102.default.createElement(import_react102.default.Fragment, null)
    };
    const validSequencedTracks = (0, import_dataverse27.val)(obj.template.getMapOfValidSequenceTracks_forStudio());
    const possibleSequenceTrackIds = getDeep(validSequencedTracks, pathToProp);
    const hasOneOrMoreSequencedTracks = possibleSequenceTrackIds !== void 0 && Object.keys(possibleSequenceTrackIds).length !== 0;
    const listOfDescendantTrackIds = [];
    let hasOneOrMoreStatics = true;
    if (hasOneOrMoreSequencedTracks) {
      hasOneOrMoreStatics = false;
      for (const descendant of iteratePropType(propConfig, [])) {
        if (isPropConfigComposite(descendant.conf))
          continue;
        const sequencedTrackIdBelongingToDescendant = getDeep(possibleSequenceTrackIds, descendant.path);
        if (typeof sequencedTrackIdBelongingToDescendant !== "string") {
          hasOneOrMoreStatics = true;
        } else {
          listOfDescendantTrackIds.push(sequencedTrackIdBelongingToDescendant);
        }
      }
    }
    if (hasOneOrMoreStatics) {
      contextMenuItems.push({
        label: "Reset all to default",
        callback: () => {
          getStudio().transaction(({ unset }) => {
            unset(pointerToProp);
          });
        }
      }, {
        label: "Sequence all",
        callback: () => {
          getStudio().transaction(({ stateEditors: stateEditors2 }) => {
            for (const { path, conf } of iteratePropType(propConfig, pathToProp)) {
              if (isPropConfigComposite(conf))
                continue;
              const propAddress = __spreadProps(__spreadValues({}, obj.address), { pathToProp: path });
              stateEditors2.coreByProject.historic.sheetsById.sequence.setPrimitivePropAsSequenced(propAddress, propConfig);
            }
          });
        }
      });
    }
    if (hasOneOrMoreSequencedTracks) {
      contextMenuItems.push({
        label: "Make all static",
        callback: () => {
          getStudio().transaction(({ stateEditors: stateEditors2 }) => {
            for (const { path: subPath, conf } of iteratePropType(propConfig, [])) {
              if (isPropConfigComposite(conf))
                continue;
              const propAddress = __spreadProps(__spreadValues({}, obj.address), {
                pathToProp: [...pathToProp, ...subPath]
              });
              const pointerToSub = pointerDeep(pointerToProp, subPath);
              stateEditors2.coreByProject.historic.sheetsById.sequence.setPrimitivePropAsStatic(__spreadProps(__spreadValues({}, propAddress), {
                value: obj.getValueByPointer(pointerToSub)
              }));
            }
          });
        }
      });
    }
    if (hasOneOrMoreSequencedTracks) {
      const controlIndicators = import_dataverse27.prism.memo(`controlIndicators`, () => /* @__PURE__ */ import_react102.default.createElement(ControlIndicators, __spreadValues({}, {
        pointerToProp,
        obj,
        possibleSequenceTrackIds,
        listOfDescendantTrackIds
      })), [possibleSequenceTrackIds, listOfDescendantTrackIds]);
      const ret = __spreadProps(__spreadValues({}, common), {
        type: "HasSequences",
        controlIndicators
      });
      return ret;
    } else {
      return __spreadProps(__spreadValues({}, common), {
        type: "AllStatic",
        controlIndicators: /* @__PURE__ */ import_react102.default.createElement(DefaultValueIndicator_default, {
          hasStaticOverride: false
        })
      });
    }
  }, []);
}
function ControlIndicators({
  pointerToProp,
  obj,
  possibleSequenceTrackIds,
  listOfDescendantTrackIds
}) {
  return usePrism(() => {
    const pathToProp = (0, import_dataverse27.getPointerParts)(pointerToProp).path;
    const sequencePosition = (0, import_dataverse27.val)(obj.sheet.getSequence().positionDerivation);
    const nearbyKeyframesInEachTrack = listOfDescendantTrackIds.map((trackId) => ({
      trackId,
      track: (0, import_dataverse27.val)(obj.template.project.pointers.historic.sheetsById[obj.address.sheetId].sequence.tracksByObject[obj.address.objectKey].trackData[trackId])
    })).filter(({ track }) => !!track).map((s3) => __spreadProps(__spreadValues({}, s3), {
      nearbies: getNearbyKeyframesOfTrack(obj, { id: s3.trackId, data: s3.track, sheetObject: obj }, sequencePosition)
    }));
    const hasCur = nearbyKeyframesInEachTrack.find(({ nearbies }) => !!nearbies.cur);
    const allCur = nearbyKeyframesInEachTrack.every(({ nearbies }) => !!nearbies.cur);
    const closestPrev = nearbyKeyframesInEachTrack.reduce((acc, s3) => {
      if (s3.nearbies.prev) {
        if (acc === void 0 || s3.nearbies.prev.kf.position > acc.kf.position) {
          return s3.nearbies.prev;
        } else {
          return acc;
        }
      } else {
        return acc;
      }
    }, void 0);
    const closestNext = nearbyKeyframesInEachTrack.reduce((acc, s3) => {
      if (s3.nearbies.next) {
        if (acc === void 0 || s3.nearbies.next.kf.position < acc.kf.position) {
          return s3.nearbies.next;
        } else {
          return acc;
        }
      } else {
        return acc;
      }
    }, void 0);
    const toggle = () => {
      if (allCur) {
        getStudio().transaction((api) => {
          api.unset(pointerToProp);
        });
      } else if (hasCur) {
        getStudio().transaction((api) => {
          api.set(pointerToProp, (0, import_dataverse27.val)(pointerToProp));
        });
      } else {
        getStudio().transaction((api) => {
          api.set(pointerToProp, (0, import_dataverse27.val)(pointerToProp));
        });
      }
    };
    const pr = {
      cur: hasCur ? {
        type: "on",
        itemKey: createStudioSheetItemKey.forCompoundPropAggregateKeyframe(obj, pathToProp, sequencePosition),
        toggle
      } : {
        toggle,
        type: "off"
      },
      prev: closestPrev !== void 0 ? {
        position: closestPrev.kf.position,
        itemKey: createStudioSheetItemKey.forCompoundPropAggregateKeyframe(obj, pathToProp, closestPrev.kf.position),
        jump: () => {
          obj.sheet.getSequence().position = closestPrev.kf.position;
        }
      } : void 0,
      next: closestNext !== void 0 ? {
        position: closestNext.kf.position,
        itemKey: createStudioSheetItemKey.forCompoundPropAggregateKeyframe(obj, pathToProp, closestNext.kf.position),
        jump: () => {
          obj.sheet.getSequence().position = closestNext.kf.position;
        }
      } : void 0
    };
    return /* @__PURE__ */ import_react102.default.createElement(NextPrevKeyframeCursors_default, __spreadValues({}, pr));
  }, [pointerToProp, obj, possibleSequenceTrackIds, listOfDescendantTrackIds]);
}
var import_dataverse27, import_react102;
var init_useEditingToolsForCompoundProp = __esm({
  "studio/src/propEditors/useEditingToolsForCompoundProp.tsx"() {
    init_getStudio();
    init_getDeep();
    init_src();
    import_dataverse27 = __toModule(require("@theatre/dataverse"));
    init_get();
    import_react102 = __toModule(require_react());
    init_DefaultValueIndicator();
    init_utils();
    init_ids();
    init_pointerDeep();
    init_NextPrevKeyframeCursors();
    init_getNearbyKeyframesOfTrack();
  }
});

// studio/src/utils/tightJsonStringify.ts
function tightJsonStringify(obj, replacer) {
  return JSON.stringify(obj, replacer, 2).replace(/^([\{\[])\n (\s+)/, "$1$2").replace(/(\n[ ]+[\{\[])\n\s+/g, "$1 ").replace(/\n\s*([\]\}])/g, " $1");
}
var init_tightJsonStringify = __esm({
  "studio/src/utils/tightJsonStringify.ts"() {
  }
});

// studio/src/utils/devStringify.ts
function devStringify(input, indentJSON = true) {
  try {
    return typeof input === "string" ? input : typeof input === "function" || input instanceof Error ? input.toString() : indentJSON ? tightJsonStringify(input) : JSON.stringify(input);
  } catch (err) {
    return (input == null ? void 0 : input.name) || String(input);
  }
}
var init_devStringify = __esm({
  "studio/src/utils/devStringify.ts"() {
    init_tightJsonStringify();
  }
});

// studio/src/utils/invariant.ts
function invariant(shouldBeTruthy, message, butFoundInstead) {
  if (!shouldBeTruthy) {
    const isFoundArgGiven = arguments.length > 2;
    if (isFoundArgGiven) {
      invariantThrow(message, butFoundInstead);
    } else {
      invariantThrow(message);
    }
  }
}
function invariantThrow(message, butFoundInstead) {
  const isFoundArgGiven = arguments.length > 1;
  const prefix = devStringify(typeof message === "function" ? message() : message);
  const suffix = isFoundArgGiven ? `
Instead found: ${devStringify(butFoundInstead)}` : "";
  throw new InvariantError(`Invariant: ${prefix}${suffix}`, butFoundInstead);
}
var AT_NODE_INTERNAL_RE, AT_INVARIANT_RE, AT_TEST_HELPERS_RE, AT_ASSORTED_HELPERS_RE, InvariantError;
var init_invariant = __esm({
  "studio/src/utils/invariant.ts"() {
    init_devStringify();
    AT_NODE_INTERNAL_RE = /^\s*at.+node:internal.+/gm;
    AT_INVARIANT_RE = /^\s*(at|[^@]+@) (?:Object\.)?invariant.+/gm;
    AT_TEST_HELPERS_RE = /^\s*(at|[^@]+@).+test\-helpers.+/gm;
    AT_ASSORTED_HELPERS_RE = /^\s*(at|[^@]+@).+(debounce|invariant|iif)\.[tj]s.*/gm;
    InvariantError = class extends Error {
      constructor(message, found) {
        super(message);
        __publicField(this, "found");
        var _a2;
        if (found !== void 0) {
          this.found = found;
        }
        this.stack = (_a2 = this.stack) == null ? void 0 : _a2.replace(AT_INVARIANT_RE, "").replace(AT_ASSORTED_HELPERS_RE, "").replace(AT_TEST_HELPERS_RE, "").replace(AT_NODE_INTERNAL_RE, "");
      }
    };
  }
});

// studio/src/utils/derive-utils.tsx
function deriveAllD(obj) {
  return (0, import_dataverse28.prism)(() => {
    if (Array.isArray(obj)) {
      const values = new Array(obj.length);
      for (let i3 = 0; i3 < obj.length; i3++) {
        values[i3] = obj[i3].getValue();
      }
      return values;
    } else {
      const values = {};
      for (const k4 in obj) {
        values[k4] = (0, import_dataverse28.val)(obj[k4]);
      }
      return values;
    }
  });
}
function deriver(Component) {
  const finalComp = import_react104.default.memo(import_react104.default.forwardRef(function deriverRender(props, ref) {
    let observableArr = [];
    const observables = {};
    const normalProps = {
      ref
    };
    for (const key in props) {
      const value = props[key];
      if ((0, import_dataverse28.isDerivation)(value)) {
        observableArr.push(value);
        observables[key] = value;
      } else {
        normalProps[key] = value;
      }
    }
    const initialCount = (0, import_react104.useRef)(observableArr.length);
    invariant(initialCount.current === observableArr.length, `expect same number of observable props on every invocation of deriver wrapped component.`, { initial: initialCount.current, count: observableArr.length });
    const allD = (0, import_react104.useMemo)(() => deriveAllD(observables), observableArr);
    const observedPropState = useDerivation(allD);
    return observedPropState && import_react104.default.createElement(Component, __spreadValues(__spreadValues({}, normalProps), observedPropState));
  }));
  finalComp.displayName = `deriver(${Component.displayName})`;
  return finalComp;
}
var import_dataverse28, import_react104;
var init_derive_utils = __esm({
  "studio/src/utils/derive-utils.tsx"() {
    import_dataverse28 = __toModule(require("@theatre/dataverse"));
    init_src();
    import_react104 = __toModule(require_react());
    init_invariant();
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail/getDetailRowHighlightBackground.tsx
function getDetailRowHighlightBackground({
  isHighlighted
}) {
  return isHighlighted === "self" ? "#1857a4" : isHighlighted === "descendent" ? "#0a2f5c" : "initial";
}
var init_getDetailRowHighlightBackground = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail/getDetailRowHighlightBackground.tsx"() {
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail/DetailCompoundPropEditor.tsx
function DetailCompoundPropEditor({
  pointerToProp,
  obj,
  propConfig,
  visualIndentation
}) {
  var _a2;
  const propName = (_a2 = propConfig.label) != null ? _a2 : last_default((0, import_dataverse29.getPointerParts)(pointerToProp).path);
  const allSubs = Object.entries(propConfig.props);
  const compositeSubs = allSubs.filter(([_3, conf]) => isPropConfigComposite(conf));
  const nonCompositeSubs = allSubs.filter(([_3, conf]) => !isPropConfigComposite(conf));
  const [propNameContainerRef, propNameContainer] = useRefAndState(null);
  const tools = useEditingToolsForCompoundProp(pointerToProp, obj, propConfig);
  const [contextMenu] = useContextMenu(propNameContainer, {
    menuItems: tools.contextMenuItems
  });
  const lastSubPropIsComposite = compositeSubs.length > 0;
  const isPropHighlightedD = (0, import_react105.useMemo)(() => whatPropIsHighlighted.getIsPropHighlightedD(__spreadProps(__spreadValues({}, obj.address), {
    pathToProp: (0, import_dataverse29.getPointerParts)(pointerToProp).path
  })), [pointerToProp]);
  return /* @__PURE__ */ import_react105.default.createElement(Container21, null, contextMenu, /* @__PURE__ */ import_react105.default.createElement(Header, {
    isHighlighted: isPropHighlightedD,
    style: { "--depth": visualIndentation - 1 }
  }, /* @__PURE__ */ import_react105.default.createElement(Padding, null, tools.controlIndicators, /* @__PURE__ */ import_react105.default.createElement(PropName, {
    isHighlighted: isPropHighlightedD,
    ref: propNameContainerRef
  }, propName || "Props"))), /* @__PURE__ */ import_react105.default.createElement(SubProps, {
    style: { "--depth": visualIndentation },
    depth: visualIndentation,
    lastSubIsComposite: lastSubPropIsComposite
  }, [...nonCompositeSubs, ...compositeSubs].map(([subPropKey, subPropConfig]) => {
    return /* @__PURE__ */ import_react105.default.createElement(DeterminePropEditorForDetail_default, {
      key: "prop-" + subPropKey,
      propConfig: subPropConfig,
      pointerToProp: pointerToProp[subPropKey],
      obj,
      visualIndentation: visualIndentation + 1
    });
  })));
}
var import_dataverse29, import_react105, Container21, Header, Padding, PropName, color, SubProps, DetailCompoundPropEditor_default;
var init_DetailCompoundPropEditor = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail/DetailCompoundPropEditor.tsx"() {
    init_utils();
    import_dataverse29 = __toModule(require("@theatre/dataverse"));
    init_last();
    init_polished_esm();
    import_react105 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_rowIndentationFormulaCSS();
    init_propNameTextCSS();
    init_css();
    init_useRefAndState();
    init_DeterminePropEditorForDetail();
    init_useContextMenu();
    init_useEditingToolsForCompoundProp();
    init_whatPropIsHighlighted();
    init_derive_utils();
    init_getDetailRowHighlightBackground();
    Container21 = styled_components_browser_esm_default.div`
  --step: 15px;
  --left-pad: 15px;
  ${pointerEventsAutoInNormalMode};
`;
    Header = deriver(styled_components_browser_esm_default.div`
  height: 30px;
  display: flex;
  align-items: stretch;
  position: relative;

  /* background-color: ${getDetailRowHighlightBackground}; */
`);
    Padding = styled_components_browser_esm_default.div`
  padding-left: ${rowIndentationFormulaCSS};
  display: flex;
  align-items: center;
`;
    PropName = deriver(styled_components_browser_esm_default.div`
  margin-left: 4px;
  cursor: default;
  height: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  &:hover {
    color: white;
  }

  ${() => propNameTextCSS};
`);
    color = curriedTransparentize(0.05, `#282b2f`);
    SubProps = styled_components_browser_esm_default.div`
  /* background: ${({ depth }) => curriedDarken(depth * 0.03, color)}; */
  /* padding: ${(props) => props.lastSubIsComposite ? 0 : "4px"} 0; */
`;
    DetailCompoundPropEditor_default = import_react105.default.memo(DetailCompoundPropEditor);
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail/SingleRowPropEditor.tsx
function SingleRowPropEditor({
  propConfig,
  pointerToProp,
  editingTools,
  children,
  isPropHighlightedD
}) {
  var _a2;
  const label = (_a2 = propConfig.label) != null ? _a2 : last_default((0, import_dataverse30.getPointerParts)(pointerToProp).path);
  const [propNameContainerRef, propNameContainer] = useRefAndState(null);
  const [contextMenu] = useContextMenu(propNameContainer, {
    menuItems: editingTools.contextMenuItems
  });
  return /* @__PURE__ */ import_react106.default.createElement(Container22, {
    isHighlighted: isPropHighlightedD
  }, contextMenu, /* @__PURE__ */ import_react106.default.createElement(Left2, null, /* @__PURE__ */ import_react106.default.createElement(ControlsContainer, null, editingTools.controlIndicators), /* @__PURE__ */ import_react106.default.createElement(PropNameContainer, {
    isHighlighted: isPropHighlightedD,
    ref: propNameContainerRef,
    title: ["obj", "props", ...(0, import_dataverse30.getPointerParts)(pointerToProp).path].join(".")
  }, label)), /* @__PURE__ */ import_react106.default.createElement(InputContainer, null, children));
}
var import_dataverse30, import_react106, Container22, Left2, PropNameContainer, ControlsContainer, InputContainer;
var init_SingleRowPropEditor = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail/SingleRowPropEditor.tsx"() {
    import_dataverse30 = __toModule(require("@theatre/dataverse"));
    init_useContextMenu();
    init_useRefAndState();
    init_lodash();
    import_react106 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_css();
    init_propNameTextCSS();
    init_derive_utils();
    init_rowIndentationFormulaCSS();
    init_getDetailRowHighlightBackground();
    Container22 = deriver(styled_components_browser_esm_default.div`
  display: flex;
  height: 30px;
  justify-content: flex-start;
  align-items: stretch;
  // We cannot calculate both the container (details panel) width and the descendant
  // (this) width dynamically. This leads to the container width being calculated
  // without this percentage being taken into consideration leads to horizontal
  // clipping/scrolling--the same way as if we explicitly fixed either the container
  // width, or the descendant width.
  // The correct solution for tabulated UIs with dynamic container widths is to use
  // CSS grid. For now I fixed this issue by just giving a great enough width
  // to the details panel so most things don't break.
  --right-width: 60%;
  position: relative;
  ${pointerEventsAutoInNormalMode};

  /* background-color: ${getDetailRowHighlightBackground}; */
`);
    Left2 = styled_components_browser_esm_default.div`
  box-sizing: border-box;
  padding-left: ${rowIndentationFormulaCSS};
  padding-right: 4px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  gap: 4px;
  flex-grow: 0;
  flex-shrink: 0;
  width: calc(100% - var(--right-width));
`;
    PropNameContainer = deriver(styled_components_browser_esm_default.div`
  text-align: left;
  flex: 1 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  user-select: none;
  cursor: default;

  ${propNameTextCSS};
  &:hover {
    color: white;
  }
`);
    ControlsContainer = styled_components_browser_esm_default.div`
  flex-basis: 8px;
  flex: 0 0;
  display: flex;
  align-items: center;
`;
    InputContainer = styled_components_browser_esm_default.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  padding: 0 8px 0 2px;
  box-sizing: border-box;
  height: 100%;
  width: var(--right-width);
  flex-shrink: 0;
  flex-grow: 0;
`;
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail/DetailSimplePropEditor.tsx
function DetailSimplePropEditor({
  propConfig,
  pointerToProp,
  obj,
  SimpleEditorComponent: EditorComponent
}) {
  const editingTools = useEditingToolsForSimplePropInDetailsPanel(pointerToProp, obj, propConfig);
  const isPropHighlightedD = (0, import_react107.useMemo)(() => whatPropIsHighlighted.getIsPropHighlightedD(__spreadProps(__spreadValues({}, obj.address), {
    pathToProp: (0, import_dataverse31.getPointerParts)(pointerToProp).path
  })), [pointerToProp]);
  return /* @__PURE__ */ import_react107.default.createElement(SingleRowPropEditor, __spreadValues({}, {
    editingTools,
    propConfig,
    pointerToProp,
    isPropHighlightedD
  }), /* @__PURE__ */ import_react107.default.createElement(EditorComponent, {
    editingTools,
    propConfig,
    value: editingTools.value
  }));
}
var import_react107, import_dataverse31, DetailSimplePropEditor_default;
var init_DetailSimplePropEditor = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail/DetailSimplePropEditor.tsx"() {
    import_react107 = __toModule(require_react());
    init_useEditingToolsForSimpleProp();
    init_SingleRowPropEditor();
    import_dataverse31 = __toModule(require("@theatre/dataverse"));
    init_whatPropIsHighlighted();
    DetailSimplePropEditor_default = import_react107.default.memo(DetailSimplePropEditor);
  }
});

// studio/src/panels/DetailPanel/DeterminePropEditorForDetail.tsx
var import_react108, DeterminePropEditorForDetail, DeterminePropEditorForDetail_default;
var init_DeterminePropEditorForDetail = __esm({
  "studio/src/panels/DetailPanel/DeterminePropEditorForDetail.tsx"() {
    import_react108 = __toModule(require_react());
    init_simplePropEditorByPropType();
    init_DetailCompoundPropEditor();
    init_DetailSimplePropEditor();
    DeterminePropEditorForDetail = ({ propConfig, visualIndentation, pointerToProp, obj }) => {
      if (propConfig.type === "compound") {
        return /* @__PURE__ */ import_react108.default.createElement(DetailCompoundPropEditor_default, {
          obj,
          visualIndentation,
          pointerToProp,
          propConfig
        });
      } else if (propConfig.type === "enum") {
        return /* @__PURE__ */ import_react108.default.createElement(import_react108.default.Fragment, null);
      } else {
        const PropEditor = simplePropEditorByPropType[propConfig.type];
        return /* @__PURE__ */ import_react108.default.createElement(DetailSimplePropEditor_default, {
          SimpleEditorComponent: PropEditor,
          obj,
          visualIndentation,
          pointerToProp,
          propConfig
        });
      }
    };
    DeterminePropEditorForDetail_default = DeterminePropEditorForDetail;
  }
});

// studio/src/panels/DetailPanel/ObjectDetails.tsx
var import_react109, ObjectDetails, ObjectDetails_default;
var init_ObjectDetails = __esm({
  "studio/src/panels/DetailPanel/ObjectDetails.tsx"() {
    import_react109 = __toModule(require_react());
    init_DeterminePropEditorForDetail();
    init_src();
    ObjectDetails = ({ objects }) => {
      const obj = objects[0];
      const key = (0, import_react109.useMemo)(() => JSON.stringify(obj.address), [obj]);
      const config = useVal(obj.template.configPointer);
      return /* @__PURE__ */ import_react109.default.createElement(DeterminePropEditorForDetail_default, {
        key,
        obj,
        pointerToProp: obj.propsP,
        propConfig: config,
        visualIndentation: 1
      });
    };
    ObjectDetails_default = ObjectDetails;
  }
});

// studio/src/uiComponents/DetailPanelButton.tsx
var DetailPanelButton, DetailPanelButton_default;
var init_DetailPanelButton = __esm({
  "studio/src/uiComponents/DetailPanelButton.tsx"() {
    init_styled_components_browser_esm();
    DetailPanelButton = styled_components_browser_esm_default.button`
  text-align: center;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid #627b7b87;
  background-color: #4b787d3d;
  color: #eaeaea;
  font-weight: 400;
  display: block;
  appearance: none;
  flex-grow: 1;
  cursor: ${(props) => props.disabled ? "none" : "pointer"};
  opacity: ${(props) => props.disabled ? 0.4 : 1};

  &:hover {
    background-color: #7dc1c878;
    border-color: #9ebcbf;
  }
`;
    DetailPanelButton_default = DetailPanelButton;
  }
});

// ../node_modules/nanoid/url-alphabet/index.js
var init_url_alphabet = __esm({
  "../node_modules/nanoid/url-alphabet/index.js"() {
  }
});

// ../node_modules/nanoid/index.browser.js
var nanoid2;
var init_index_browser = __esm({
  "../node_modules/nanoid/index.browser.js"() {
    init_url_alphabet();
    nanoid2 = (size = 21) => {
      let id = "";
      let bytes = crypto.getRandomValues(new Uint8Array(size));
      while (size--) {
        let byte = bytes[size] & 63;
        if (byte < 36) {
          id += byte.toString(36);
        } else if (byte < 62) {
          id += (byte - 26).toString(36).toUpperCase();
        } else if (byte < 63) {
          id += "_";
        } else {
          id += "-";
        }
      }
      return id;
    };
  }
});

// studio/src/StudioStore/generateDiskStateRevision.ts
function generateDiskStateRevision() {
  return nanoid2(16);
}
var init_generateDiskStateRevision = __esm({
  "studio/src/StudioStore/generateDiskStateRevision.ts"() {
    init_index_browser();
  }
});

// studio/src/uiComponents/Popover/TooltipContext.tsx
var import_dataverse32, import_react111, ctx, lastTooltipId, useTooltipOpenState, TooltipContext, TooltipContext_default;
var init_TooltipContext = __esm({
  "studio/src/uiComponents/Popover/TooltipContext.tsx"() {
    import_dataverse32 = __toModule(require("@theatre/dataverse"));
    init_useRefAndState();
    import_react111 = __toModule(require_react());
    ctx = (0, import_react111.createContext)(null);
    lastTooltipId = 0;
    useTooltipOpenState = () => {
      const id = (0, import_react111.useMemo)(() => lastTooltipId++, []);
      const { cur, set: set2 } = (0, import_react111.useContext)(ctx);
      const [isOpenRef, isOpen] = useRefAndState(false);
      const setIsOpen = (0, import_react111.useCallback)((shouldOpen, delay) => {
        set2(shouldOpen ? id : -1, delay);
      }, []);
      (0, import_react111.useEffect)(() => {
        return cur.changesWithoutValues().tap(() => {
          const flag = cur.getValue() === id;
          if (isOpenRef.current !== flag)
            isOpenRef.current = flag;
        });
      }, [cur, id]);
      return [isOpen, setIsOpen];
    };
    TooltipContext = ({ children }) => {
      const currentTooltipId = (0, import_react111.useMemo)(() => new import_dataverse32.Box(-1), []);
      const cur = currentTooltipId.derivation;
      const set2 = (0, import_react111.useMemo)(() => {
        let lastTimeout = void 0;
        return (id, delay) => {
          const overridingPreviousTimeout = lastTimeout !== void 0;
          if (lastTimeout !== void 0) {
            clearTimeout(lastTimeout);
            lastTimeout = void 0;
          }
          if (delay === 0 || overridingPreviousTimeout) {
            currentTooltipId.set(id);
          } else {
            lastTimeout = setTimeout(() => {
              currentTooltipId.set(id);
              lastTimeout = void 0;
            }, delay);
          }
        };
      }, []);
      return /* @__PURE__ */ import_react111.default.createElement(ctx.Provider, {
        value: { cur, set: set2 }
      }, children);
    };
    TooltipContext_default = TooltipContext;
  }
});

// studio/src/uiComponents/Popover/useTooltip.tsx
function useTooltip(opts, render) {
  const enabled = opts.enabled !== false;
  const [isOpen, setIsOpen] = useTooltipOpenState();
  const [targetRef, targetNode] = useRefAndState(null);
  (0, import_react113.useEffect)(() => {
    if (!enabled) {
      return;
    }
    const target = targetRef.current;
    if (!target)
      return;
    const onMouseEnter = () => {
      var _a2;
      return setIsOpen(true, (_a2 = opts.enterDelay) != null ? _a2 : 400);
    };
    const onMouseLeave = () => {
      var _a2;
      return setIsOpen(false, (_a2 = opts.exitDelay) != null ? _a2 : 200);
    };
    target.addEventListener("mouseenter", onMouseEnter);
    target.addEventListener("mouseleave", onMouseLeave);
    return () => {
      target.removeEventListener("mouseenter", onMouseEnter);
      target.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [targetRef, enabled, opts.enterDelay, opts.exitDelay]);
  const portalLayer = (0, import_react112.useContext)(PortalContext);
  const node = enabled && isOpen && targetNode ? (0, import_react_dom7.createPortal)(/* @__PURE__ */ import_react114.default.createElement(TooltipWrapper_default, {
    children: render,
    target: targetNode,
    onClickOutside: noop_default2,
    verticalPlacement: opts.verticalPlacement,
    verticalGap: opts.verticalGap
  }), portalLayer) : /* @__PURE__ */ import_react114.default.createElement(import_react114.default.Fragment, null);
  return [node, targetRef, isOpen];
}
var import_react112, import_react113, import_react114, import_react_dom7;
var init_useTooltip = __esm({
  "studio/src/uiComponents/Popover/useTooltip.tsx"() {
    init_useRefAndState();
    import_react112 = __toModule(require_react());
    import_react113 = __toModule(require_react());
    import_react114 = __toModule(require_react());
    init_TooltipWrapper();
    import_react_dom7 = __toModule(require_react_dom());
    init_TooltipContext();
    init_es2();
    init_noop2();
  }
});

// studio/src/uiComponents/Popover/BasicTooltip.tsx
var BasicTooltip, BasicTooltip_default;
var init_BasicTooltip = __esm({
  "studio/src/uiComponents/Popover/BasicTooltip.tsx"() {
    init_styled_components_browser_esm();
    init_BasicPopover();
    BasicTooltip = styled_components_browser_esm_default(BasicPopover_default)`
  padding: 1em;
  max-width: 240px;
  pointer-events: none !important;
  --popover-outer-stroke: transparent;
  --popover-inner-stroke: #45464d;
`;
    BasicTooltip_default = BasicTooltip;
  }
});

// studio/src/panels/DetailPanel/ProjectDetails/StateConflictRow.tsx
var import_react116, Container23, Message, ChooseStateRow, StateConflictRow, InConflict, StateConflictRow_default;
var init_StateConflictRow = __esm({
  "studio/src/panels/DetailPanel/ProjectDetails/StateConflictRow.tsx"() {
    init_src();
    init_getStudio();
    import_react116 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_generateDiskStateRevision();
    init_useTooltip();
    init_BasicTooltip();
    init_DetailPanelButton();
    Container23 = styled_components_browser_esm_default.div`
  padding: 8px 10px;
  position: relative;
  background-color: #6d232352;
  &:before {
    position: absolute;
    content: ' ';
    display: block;
    left: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #ff000070;
  }
`;
    Message = styled_components_browser_esm_default.div`
  margin-bottom: 1em;
  & a {
    color: inherit;
  }
`;
    ChooseStateRow = styled_components_browser_esm_default.div`
  display: flex;
  gap: 8px;
`;
    StateConflictRow = ({ projectId }) => {
      const loadingState = useVal(getStudio().atomP.ephemeral.coreByProject[projectId].loadingState);
      if (!loadingState)
        return null;
      if (loadingState.type === "browserStateIsNotBasedOnDiskState") {
        return /* @__PURE__ */ import_react116.default.createElement(InConflict, {
          loadingState,
          projectId
        });
      } else {
        return null;
      }
    };
    InConflict = ({ projectId, loadingState }) => {
      const useBrowserState = () => {
        getStudio().transaction(({ drafts: drafts2, stateEditors: stateEditors2 }) => {
          stateEditors2.coreByProject.historic.revisionHistory.add({
            projectId,
            revision: loadingState.onDiskState.revisionHistory[0]
          });
          stateEditors2.coreByProject.historic.revisionHistory.add({
            projectId,
            revision: generateDiskStateRevision()
          });
          drafts2.ephemeral.coreByProject[projectId].loadingState = {
            type: "loaded"
          };
        });
      };
      const useOnDiskState = () => {
        getStudio().transaction(({ drafts: drafts2 }) => {
          drafts2.historic.coreByProject[projectId] = loadingState.onDiskState;
          drafts2.ephemeral.coreByProject[projectId].loadingState = {
            type: "loaded"
          };
        });
      };
      const [browserStateNode, browserStateRef] = useTooltip({}, () => /* @__PURE__ */ import_react116.default.createElement(BasicTooltip_default, null, "The browser's state will override the disk state."));
      const [diskStateNode, diskStateRef] = useTooltip({}, () => /* @__PURE__ */ import_react116.default.createElement(BasicTooltip_default, null, "The disk's state will override the browser's state."));
      return /* @__PURE__ */ import_react116.default.createElement(Container23, null, /* @__PURE__ */ import_react116.default.createElement(Message, null, "Browser state is not based on disk state.", " ", /* @__PURE__ */ import_react116.default.createElement("a", {
        href: "https://www.theatrejs.com/docs/latest/manual/projects#state",
        target: "_blank"
      }, "Learn more.")), /* @__PURE__ */ import_react116.default.createElement(ChooseStateRow, null, browserStateNode, /* @__PURE__ */ import_react116.default.createElement(DetailPanelButton_default, {
        onClick: useBrowserState,
        ref: browserStateRef
      }, "Use browser's state"), diskStateNode, /* @__PURE__ */ import_react116.default.createElement(DetailPanelButton_default, {
        onClick: useOnDiskState,
        ref: diskStateRef
      }, "Use disk state")));
    };
    StateConflictRow_default = StateConflictRow;
  }
});

// studio/src/panels/DetailPanel/ProjectDetails.tsx
var import_react117, Container24, TheExportRow, ExportTooltip, ProjectDetails, ProjectDetails_default;
var init_ProjectDetails = __esm({
  "studio/src/panels/DetailPanel/ProjectDetails.tsx"() {
    init_getStudio();
    init_BasicPopover();
    init_usePopover();
    import_react117 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_DetailPanelButton();
    init_StateConflictRow();
    Container24 = styled_components_browser_esm_default.div``;
    TheExportRow = styled_components_browser_esm_default.div`
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
    ExportTooltip = styled_components_browser_esm_default(BasicPopover_default)`
  width: 280px;
  padding: 1em;
`;
    ProjectDetails = ({ projects }) => {
      const project = projects[0];
      const projectId = project.address.projectId;
      const slugifiedProjectId = projectId.replace(/[^\w\d'_\-]+/g, " ").trim();
      const suggestedFileName = `${slugifiedProjectId}.theatre-project-state.json`;
      const [downloaded, setDownloaded] = (0, import_react117.useState)(false);
      const exportProject = (0, import_react117.useCallback)(() => {
        const str = JSON.stringify(getStudio().createContentOfSaveFile(project.address.projectId), null, 2);
        const file = new File([str], suggestedFileName, {
          type: "application/json"
        });
        const objUrl = URL.createObjectURL(file);
        const a4 = Object.assign(document.createElement("a"), {
          href: objUrl,
          target: "_blank",
          rel: "noopener"
        });
        a4.setAttribute("download", suggestedFileName);
        a4.click();
        setDownloaded(true);
        setTimeout(() => {
          setDownloaded(false);
        }, 2e3);
        setTimeout(() => {
          URL.revokeObjectURL(objUrl);
        }, 4e4);
      }, [project, suggestedFileName]);
      const exportTooltip = usePopover({ debugName: "ProjectDetails", pointerDistanceThreshold: 50 }, () => /* @__PURE__ */ import_react117.default.createElement(ExportTooltip, null, "This will create a JSON file with the state of your project. You can commit this file to your git repo and include it in your production bundle.", /* @__PURE__ */ import_react117.default.createElement("a", {
        href: "https://www.theatrejs.com/docs/latest/manual/projects#state",
        target: "_blank"
      }, "Here is a quick guide on how to export to production.")));
      return /* @__PURE__ */ import_react117.default.createElement(import_react117.default.Fragment, null, exportTooltip.node, /* @__PURE__ */ import_react117.default.createElement(Container24, null, /* @__PURE__ */ import_react117.default.createElement(StateConflictRow_default, {
        projectId
      }), /* @__PURE__ */ import_react117.default.createElement(TheExportRow, null, /* @__PURE__ */ import_react117.default.createElement(DetailPanelButton_default, {
        onMouseEnter: (e2) => exportTooltip.open(e2, e2.target),
        onClick: !downloaded ? exportProject : void 0,
        disabled: downloaded
      }, downloaded ? "(Exported)" : `Export ${projectId} to JSON`))));
    };
    ProjectDetails_default = ProjectDetails;
  }
});

// studio/src/uiComponents/useHotspot.ts
function useHotspot(spot) {
  const [active, setActive] = (0, import_react118.useState)(false);
  (0, import_react118.useEffect)(() => {
    const hoverListener = (e2) => {
      const threshold = active ? 200 : 50;
      const topBuffer = 56;
      let mouseInside = spot === "left" ? e2.x < threshold : e2.x > window.innerWidth - threshold;
      mouseInside && (mouseInside = e2.y > topBuffer);
      if (mouseInside) {
        setActive(true);
      } else {
        setActive(false);
      }
    };
    document.addEventListener("mousemove", hoverListener);
    const leaveListener = () => {
      setActive(false);
    };
    document.addEventListener("mouseleave", leaveListener);
    return () => {
      document.removeEventListener("mousemove", hoverListener);
      document.removeEventListener("mouseleave", leaveListener);
    };
  }, [active]);
  return active;
}
var import_react118;
var init_useHotspot = __esm({
  "studio/src/uiComponents/useHotspot.ts"() {
    import_react118 = __toModule(require_react());
  }
});

// studio/src/uiComponents/icons/Outline.tsx
function Outline(props) {
  return /* @__PURE__ */ React58.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React58.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.775 2.781a.5.5 0 01.5.5v1.7H4.67c.108-.957.92-1.7 1.905-1.7h6.608a1.917 1.917 0 110 3.834H6.574c-.78 0-1.452-.466-1.751-1.135H2.275v5.03h2.39a2.032 2.032 0 012.023-1.854h6.38a2.031 2.031 0 110 4.063h-6.38c-.83 0-1.543-.497-1.858-1.21H1.775a.5.5 0 01-.5-.5V3.281a.5.5 0 01.5-.5zm4.799 1.5h6.608a.917.917 0 110 1.834H6.574a.917.917 0 110-1.834zm.114 5.875h6.38a1.031 1.031 0 110 2.063h-6.38a1.032 1.032 0 110-2.063z",
    fill: "currentColor"
  }));
}
var React58, Outline_default;
var init_Outline = __esm({
  "studio/src/uiComponents/icons/Outline.tsx"() {
    React58 = __toModule(require_react());
    Outline_default = Outline;
  }
});

// studio/src/uiComponents/icons/ChevronDown.tsx
function ChevronDown(props) {
  return /* @__PURE__ */ React59.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React59.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5L4 6.654 5.2 5.5 8 8.385 10.8 5.5 12 6.654 8 10.5z",
    fill: "currentColor"
  }));
}
var React59, ChevronDown_default;
var init_ChevronDown = __esm({
  "studio/src/uiComponents/icons/ChevronDown.tsx"() {
    React59 = __toModule(require_react());
    ChevronDown_default = ChevronDown;
  }
});

// studio/src/uiComponents/icons/Details.tsx
function Details(props) {
  return /* @__PURE__ */ React60.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React60.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3c-1.072 0-1.969.904-1.969 1.969 0 1 .929 1.968 1.969 1.968h9A1.969 1.969 0 1012.5 3h-9zm9 1H5.531v1.938H12.5A.969.969 0 0012.5 4zM3.5 9.14a1.969 1.969 0 000 3.938h9a1.969 1.969 0 100-3.937h-9zm9 1H8.406v1.938H12.5a.969.969 0 100-1.937z",
    fill: "currentColor"
  }));
}
var React60, Details_default;
var init_Details = __esm({
  "studio/src/uiComponents/icons/Details.tsx"() {
    React60 = __toModule(require_react());
    Details_default = Details;
  }
});

// studio/src/uiComponents/icons/Ellipsis.tsx
function Ellipsis(props) {
  return /* @__PURE__ */ React61.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React61.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.166 7.994a2.26 2.26 0 114.518 0 2.26 2.26 0 01-4.518 0zM2.425 6.91a1.085 1.085 0 100 2.17 1.085 1.085 0 000-2.17zM5.74 7.994a2.26 2.26 0 114.519 0 2.26 2.26 0 01-4.519 0zM8 6.91a1.085 1.085 0 100 2.17 1.085 1.085 0 000-2.17zM13.575 5.735a2.26 2.26 0 100 4.519 2.26 2.26 0 000-4.52zm-1.086 2.26a1.085 1.085 0 112.171 0 1.085 1.085 0 01-2.17 0z",
    fill: "currentColor"
  }));
}
var React61, Ellipsis_default;
var init_Ellipsis = __esm({
  "studio/src/uiComponents/icons/Ellipsis.tsx"() {
    React61 = __toModule(require_react());
    Ellipsis_default = Ellipsis;
  }
});

// studio/src/uiComponents/icons/Package.tsx
function Package(props) {
  return /* @__PURE__ */ React62.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React62.createElement("path", {
    d: "M8.339 4.5l-2.055.644 4.451 1.393v2.748l-2.966.928-2.504-.783V6.738l2.42.758 2.055-.644-4.458-1.395L4 5.858v4.463L7.768 11.5 12 10.175V5.646L8.339 4.5z",
    fill: "currentColor"
  }));
}
var React62, Package_default;
var init_Package = __esm({
  "studio/src/uiComponents/icons/Package.tsx"() {
    React62 = __toModule(require_react());
    Package_default = Package;
  }
});

// studio/src/uiComponents/icons/Bell.tsx
function Bell(props) {
  return /* @__PURE__ */ React63.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React63.createElement("path", {
    d: "M8 1.57c-.416 0-.752.36-.752.804v.482c-1.715.372-3.006 1.994-3.006 3.938v.473c0 1.18-.407 2.32-1.14 3.205l-.173.208a.85.85 0 00-.125.864.75.75 0 00.686.475h9.019a.752.752 0 00.686-.475.845.845 0 00-.125-.864l-.174-.208a5.026 5.026 0 01-1.139-3.205v-.473c0-1.944-1.291-3.566-3.006-3.938v-.482c0-.445-.336-.804-.752-.804zm1.063 12.39c.282-.301.44-.71.44-1.138H6.496c0 .428.158.837.44 1.138.281.302.664.47 1.063.47.4 0 .783-.168 1.064-.47z",
    fill: "currentColor"
  }));
}
var React63, Bell_default;
var init_Bell = __esm({
  "studio/src/uiComponents/icons/Bell.tsx"() {
    React63 = __toModule(require_react());
    Bell_default = Bell;
  }
});

// studio/src/uiComponents/icons/index.ts
var init_icons = __esm({
  "studio/src/uiComponents/icons/index.ts"() {
    init_Outline();
    init_ChevronDown();
    init_Details();
    init_Ellipsis();
    init_Package();
    init_Bell();
  }
});

// studio/src/panels/DetailPanel/EmptyState.tsx
var import_react119, Container25, Message2, Icon2, LinkToDoc, EmptyState, EmptyState_default;
var init_EmptyState = __esm({
  "studio/src/panels/DetailPanel/EmptyState.tsx"() {
    import_react119 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_icons();
    Container25 = styled_components_browser_esm_default.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
    Message2 = styled_components_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  color: rgba(255, 255, 255, 0.9);
`;
    Icon2 = styled_components_browser_esm_default.div`
  color: rgba(145, 145, 145, 0.8);
`;
    LinkToDoc = styled_components_browser_esm_default.a`
  color: #919191;
  font-size: 10px;
  text-decoration-color: #40434a;
  text-underline-offset: 3px;
`;
    EmptyState = () => {
      return /* @__PURE__ */ import_react119.default.createElement(Container25, null, /* @__PURE__ */ import_react119.default.createElement(Message2, null, /* @__PURE__ */ import_react119.default.createElement(Icon2, null, /* @__PURE__ */ import_react119.default.createElement(Outline_default, null)), /* @__PURE__ */ import_react119.default.createElement("div", null, "Please select an object from the ", /* @__PURE__ */ import_react119.default.createElement("u", null, "Outline Menu"), " to see its properties.")), /* @__PURE__ */ import_react119.default.createElement(LinkToDoc, {
        href: "https://www.theatrejs.com/docs/latest/manual/objects",
        target: "_blank"
      }, "Learn more about Objects"));
    };
    EmptyState_default = EmptyState;
  }
});

// studio/src/panels/DetailPanel/DetailPanel.tsx
var import_react121, import_dataverse33, headerHeight, Container26, Title, Header2, Body, contextMenuShownContext, DetailPanel, DetailPanel_default, isDetailPanelHotspotActiveB, isDetailPanelHoveredB, shouldShowDetailD;
var init_DetailPanel = __esm({
  "studio/src/panels/DetailPanel/DetailPanel.tsx"() {
    init_selectors();
    init_src();
    import_react121 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_instanceTypes();
    init_common();
    init_css();
    init_ObjectDetails();
    init_ProjectDetails();
    init_getStudio();
    init_useHotspot();
    import_dataverse33 = __toModule(require("@theatre/dataverse"));
    init_EmptyState();
    init_useLockSet();
    init_usePresence();
    headerHeight = `32px`;
    Container26 = styled_components_browser_esm_default.div`
  ${pointerEventsAutoInNormalMode};
  background-color: rgba(40, 43, 47, 0.8);
  position: fixed;
  right: 8px;
  top: 50px;
  // Temporary, see comment about CSS grid in SingleRowPropEditor.
  width: 280px;
  height: fit-content;
  z-index: ${panelZIndexes.propsPanel};

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(14px);
  border-radius: 2px;

  display: ${({ pin }) => pin ? "block" : "none"};

  &:hover {
    display: block;
  }

  @supports not (backdrop-filter: blur()) {
    background: rgba(40, 43, 47, 0.95);
  }
`;
    Title = styled_components_browser_esm_default.div`
  margin: 0 10px;
  color: #919191;
  font-weight: 500;
  font-size: 10px;
  user-select: none;
  ${pointerEventsAutoInNormalMode};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
    Header2 = styled_components_browser_esm_default.div`
  height: ${headerHeight};
  display: flex;
  align-items: center;
`;
    Body = styled_components_browser_esm_default.div`
  ${pointerEventsAutoInNormalMode};
  max-height: calc(100vh - 100px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  padding: 0;
  user-select: none;

  /* Set the font-size for input values in the detail panel */
  font-size: 12px;
`;
    contextMenuShownContext = (0, import_react121.createContext)([false, () => () => {
    }]);
    DetailPanel = (props) => {
      const pin = useVal(getStudio().atomP.ahistoric.pinDetails) !== false;
      const hotspotActive = useHotspot("right");
      (0, import_react121.useLayoutEffect)(() => {
        isDetailPanelHotspotActiveB.set(hotspotActive);
      }, [hotspotActive]);
      (0, import_react121.useEffect)(() => {
        return () => {
          isDetailPanelHoveredB.set(false);
          isDetailPanelHotspotActiveB.set(false);
        };
      }, []);
      const [isContextMenuShown] = (0, import_react121.useContext)(contextMenuShownContext);
      const showDetailsPanel = pin || hotspotActive || isContextMenuShown;
      const [containerElt, setContainerElt] = (0, import_react121.useState)(null);
      usePresenceListenersOnRootElement(containerElt);
      return usePrism(() => {
        const selection = getOutlineSelection();
        const obj = selection.find(isSheetObject);
        if (obj) {
          return /* @__PURE__ */ import_react121.default.createElement(Container26, {
            "data-testid": "DetailPanel-Object",
            pin: showDetailsPanel,
            ref: setContainerElt,
            onMouseEnter: () => {
              isDetailPanelHoveredB.set(true);
            },
            onMouseLeave: () => {
              isDetailPanelHoveredB.set(false);
            }
          }, /* @__PURE__ */ import_react121.default.createElement(Header2, null, /* @__PURE__ */ import_react121.default.createElement(Title, {
            title: `${obj.sheet.address.sheetId}: ${obj.sheet.address.sheetInstanceId} > ${obj.address.objectKey}`
          }, /* @__PURE__ */ import_react121.default.createElement(TitleBar_Piece, null, obj.sheet.address.sheetId, " "), /* @__PURE__ */ import_react121.default.createElement(TitleBar_Punctuation, null, ":", "\xA0"), /* @__PURE__ */ import_react121.default.createElement(TitleBar_Piece, null, obj.sheet.address.sheetInstanceId, " "), /* @__PURE__ */ import_react121.default.createElement(TitleBar_Punctuation, null, "\xA0\u2192\xA0"), /* @__PURE__ */ import_react121.default.createElement(TitleBar_Piece, null, obj.address.objectKey))), /* @__PURE__ */ import_react121.default.createElement(Body, null, /* @__PURE__ */ import_react121.default.createElement(ObjectDetails_default, {
            objects: [obj]
          })));
        }
        const project = selection.find(isProject);
        if (project) {
          return /* @__PURE__ */ import_react121.default.createElement(Container26, {
            pin: showDetailsPanel
          }, /* @__PURE__ */ import_react121.default.createElement(Header2, null, /* @__PURE__ */ import_react121.default.createElement(Title, {
            title: `${project.address.projectId}`
          }, /* @__PURE__ */ import_react121.default.createElement(TitleBar_Piece, null, project.address.projectId, " "))), /* @__PURE__ */ import_react121.default.createElement(Body, null, /* @__PURE__ */ import_react121.default.createElement(ProjectDetails_default, {
            projects: [project]
          })));
        }
        return /* @__PURE__ */ import_react121.default.createElement(Container26, {
          pin: showDetailsPanel,
          onMouseEnter: () => {
            isDetailPanelHoveredB.set(true);
          },
          onMouseLeave: () => {
            isDetailPanelHoveredB.set(false);
          }
        }, /* @__PURE__ */ import_react121.default.createElement(EmptyState_default, null));
      }, [showDetailsPanel]);
    };
    DetailPanel_default = () => {
      const lockSet = useLockSet();
      return /* @__PURE__ */ import_react121.default.createElement(contextMenuShownContext.Provider, {
        value: lockSet
      }, /* @__PURE__ */ import_react121.default.createElement(DetailPanel, null));
    };
    isDetailPanelHotspotActiveB = new import_dataverse33.Box(false);
    isDetailPanelHoveredB = new import_dataverse33.Box(false);
    shouldShowDetailD = (0, import_dataverse33.prism)(() => {
      const isHovered = (0, import_dataverse33.val)(isDetailPanelHoveredB.derivation);
      const isHotspotActive = (0, import_dataverse33.val)(isDetailPanelHotspotActiveB.derivation);
      return isHovered || isHotspotActive;
    });
  }
});

// studio/src/uiComponents/simpleContextMenu/useContextMenu.tsx
function useContextMenu(target, opts) {
  const [status, close] = useRequestContextMenu_default(target, opts);
  const [, addContextMenu] = (0, import_react122.useContext)(contextMenuShownContext);
  (0, import_react122.useEffect)(() => {
    var _a2;
    let removeContextMenu;
    if (status.isOpen) {
      (_a2 = opts.onOpen) == null ? void 0 : _a2.call(opts);
      removeContextMenu = addContextMenu();
    }
    return () => removeContextMenu == null ? void 0 : removeContextMenu();
  }, [status.isOpen, opts.onOpen]);
  const node = !status.isOpen ? emptyNode : /* @__PURE__ */ import_react122.default.createElement(ContextMenu_default, {
    items: opts.menuItems,
    displayName: opts.displayName,
    clickPoint: status.event,
    onRequestClose: close
  });
  return [node, close, status.isOpen];
}
var import_react122, emptyNode;
var init_useContextMenu = __esm({
  "studio/src/uiComponents/simpleContextMenu/useContextMenu.tsx"() {
    import_react122 = __toModule(require_react());
    init_ContextMenu();
    init_useRequestContextMenu();
    init_DetailPanel();
    emptyNode = /* @__PURE__ */ import_react122.default.createElement(import_react122.default.Fragment, null);
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeStrip.tsx
function clampRange(range, referenceRange) {
  let overflow = 0;
  const [start, end] = range;
  const [lower, upper] = referenceRange;
  if (end - start > upper - lower)
    return [lower, upper];
  if (start < lower) {
    overflow = 0 - start;
  }
  if (end > upper) {
    overflow = upper - end;
  }
  return [start + overflow, end + overflow];
}
var import_dataverse34, import_react124, focusRangeStripTheme, stripWidth, RangeStrip, FocusRangeStrip, FocusRangeStrip_default;
var init_FocusRangeStrip = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeStrip.tsx"() {
    import_dataverse34 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_css();
    init_getStudio();
    init_TopStrip();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_react124 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameStampPositionProvider();
    focusRangeStripTheme = {
      enabled: {
        backgroundColor: "#2C2F34",
        stroke: "#646568"
      },
      disabled: {
        backgroundColor: "#282a2cc5",
        stroke: "#595a5d"
      },
      hover: {
        backgroundColor: "#34373D",
        stroke: "#C8CAC0"
      },
      dragging: {
        backgroundColor: "#3F444A",
        stroke: "#C8CAC0"
      },
      thumbWidth: 9,
      hitZoneWidth: 26,
      rangeStripMinWidth: 30
    };
    stripWidth = 1e3;
    RangeStrip = styled_components_browser_esm_default.div`
  position: absolute;
  height: ${() => topStripHeight - 1}px;
  background-color: ${(props) => props.enabled ? focusRangeStripTheme.enabled.backgroundColor : focusRangeStripTheme.disabled.backgroundColor};
  cursor: grab;
  top: 0;
  left: 0;
  width: ${stripWidth}px;
  transform-origin: left top;
  &:hover {
    background-color: ${focusRangeStripTheme.hover.backgroundColor};
  }
  &.dragging {
    background-color: ${focusRangeStripTheme.dragging.backgroundColor};
    cursor: grabbing !important;
  }
  ${pointerEventsAutoInNormalMode};

  /* covers the one pixel space between the focus range strip and the top strip
  of the sequence editor panel, which would have caused that one pixel to act
  like a panel drag zone */
  &:after {
    display: block;
    content: ' ';
    position: absolute;
    bottom: -1px;
    height: 1px;
    left: 0;
    right: 0;
    background: transparent;
    pointer-events: normal;
    z-index: -1;
  }
`;
    FocusRangeStrip = ({ layoutP }) => {
      const existingRangeD = (0, import_react124.useMemo)(() => (0, import_dataverse34.prism)(() => {
        const { projectId, sheetId } = (0, import_dataverse34.val)(layoutP.sheet).address;
        const existingRange = (0, import_dataverse34.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
        return existingRange;
      }), [layoutP]);
      const [rangeStripRef, rangeStripNode] = useRefAndState(null);
      const [contextMenu] = useContextMenu(rangeStripNode, {
        menuItems: () => {
          const sheet2 = (0, import_dataverse34.val)(layoutP.sheet);
          const existingRange = existingRangeD.getValue();
          return [
            {
              label: "Delete focus range",
              callback: () => {
                getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                  stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.focusRange.unset(__spreadValues({}, sheet2.address));
                }).commit();
              }
            },
            {
              label: (existingRange == null ? void 0 : existingRange.enabled) ? "Disable focus range" : "Enable focus range",
              callback: () => {
                if (existingRange !== void 0) {
                  getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                    stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.focusRange.set(__spreadProps(__spreadValues({}, sheet2.address), {
                      range: existingRange.range,
                      enabled: !existingRange.enabled
                    }));
                  }).commit();
                }
              }
            }
          ];
        }
      });
      const scaledSpaceToUnitSpace = useVal(layoutP.scaledSpace.toUnitSpace);
      const sheet = useVal(layoutP.sheet);
      const gestureHandlers = (0, import_react124.useMemo)(() => {
        let newStartPosition, newEndPosition;
        return {
          debugName: "FocusRangeStrip",
          onDragStart(event) {
            let tempTransaction;
            let existingRange = existingRangeD.getValue();
            if (!existingRange)
              return false;
            const startPosBeforeDrag = existingRange.range.start;
            const endPosBeforeDrag = existingRange.range.end;
            let dragHappened = false;
            const sequence = (0, import_dataverse34.val)(layoutP.sheet).getSequence();
            return {
              onDrag(dx) {
                existingRange = existingRangeD.getValue();
                if (existingRange) {
                  dragHappened = true;
                  const deltaPos = scaledSpaceToUnitSpace(dx);
                  const start = startPosBeforeDrag + deltaPos;
                  let end = endPosBeforeDrag + deltaPos;
                  if (end < start) {
                    end = start;
                  }
                  ;
                  [newStartPosition, newEndPosition] = clampRange([start, end], [0, sequence.length]).map((pos) => sequence.closestGridPosition(pos));
                  if (tempTransaction) {
                    tempTransaction.discard();
                  }
                  tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                    var _a2;
                    stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.focusRange.set(__spreadProps(__spreadValues({}, sheet.address), {
                      range: {
                        start: newStartPosition,
                        end: newEndPosition
                      },
                      enabled: (_a2 = existingRange == null ? void 0 : existingRange.enabled) != null ? _a2 : true
                    }));
                  });
                }
              },
              onDragEnd() {
                if (existingRange) {
                  if (dragHappened && tempTransaction !== void 0) {
                    tempTransaction.commit();
                  } else if (tempTransaction) {
                    tempTransaction.discard();
                  }
                }
              }
            };
          },
          lockCSSCursorTo: "grabbing"
        };
      }, [sheet, scaledSpaceToUnitSpace]);
      const [isDragging] = useDrag(rangeStripNode, gestureHandlers);
      useLockFrameStampPosition(isDragging, -1);
      return usePrism(() => {
        const existingRange = existingRangeD.getValue();
        const range = (existingRange == null ? void 0 : existingRange.range) || { start: 0, end: 0 };
        let startX = (0, import_dataverse34.val)(layoutP.clippedSpace.fromUnitSpace)(range.start);
        let endX = (0, import_dataverse34.val)(layoutP.clippedSpace.fromUnitSpace)(range.end);
        let scaleX, translateX;
        if (startX < 0) {
          startX = 0;
        }
        if (endX > (0, import_dataverse34.val)(layoutP.clippedSpace.width)) {
          endX = (0, import_dataverse34.val)(layoutP.clippedSpace.width);
        }
        if (startX > endX) {
          translateX = 0;
          scaleX = 0;
        } else {
          translateX = startX;
          scaleX = (endX - startX) / stripWidth;
        }
        if (!existingRange)
          return /* @__PURE__ */ import_react124.default.createElement(import_react124.default.Fragment, null);
        return /* @__PURE__ */ import_react124.default.createElement(import_react124.default.Fragment, null, contextMenu, /* @__PURE__ */ import_react124.default.createElement(RangeStrip, {
          id: "range-strip",
          enabled: existingRange.enabled,
          className: `${isDragging ? "dragging" : ""} ${existingRange.enabled ? "enabled" : ""}`,
          ref: rangeStripRef,
          style: {
            transform: `translateX(${translateX}px) scale(${scaleX}, 1)`
          }
        }));
      }, [layoutP, rangeStripRef, existingRangeD, contextMenu, isDragging]);
    };
    FocusRangeStrip_default = FocusRangeStrip;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeThumb.tsx
var import_dataverse35, import_react126, TheDiv, ColoredMargin, OuterColoredMargin, FocusRangeThumb, FocusRangeThumb_default;
var init_FocusRangeThumb = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeThumb.tsx"() {
    import_dataverse35 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    init_TopStrip();
    init_PointerEventsHandler();
    init_useDrag();
    init_useRefAndState();
    import_react126 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameStampPositionProvider();
    init_FocusRangeStrip();
    init_DopeSnap();
    TheDiv = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  // the right handle has to be pulled back by its width since its right side indicates its position, not its left side
  left: ${(props) => props.type === "start" ? 0 : -focusRangeStripTheme.thumbWidth}px;
  transform-origin: left top;
  width: ${focusRangeStripTheme.thumbWidth}px;
  height: ${() => topStripHeight - 1}px;
  z-index: 3;

  --bg: ${({ enabled }) => enabled ? focusRangeStripTheme.enabled.backgroundColor : focusRangeStripTheme.disabled.backgroundColor};

  stroke: ${focusRangeStripTheme.enabled.stroke};
  user-select: none;

  cursor: ${(props) => props.type === "start" ? "w-resize" : "e-resize"};

  // no pointer events unless pointer-root is in normal mode _and_ the
  // focus range is enabled
  #pointer-root & {
    pointer-events: none;
  }

  #pointer-root.normal & {
    pointer-events: auto;
  }

  #pointer-root.draggingPositionInSequenceEditor & {
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});
  }

  &.dragging {
    pointer-events: none !important;
  }

  // highlight the handle if it's hovered, or the whole strip is hovverd
  ${() => RangeStrip}:hover ~ &, &:hover {
    --bg: ${focusRangeStripTheme.hover.backgroundColor};
    stroke: ${focusRangeStripTheme.hover.stroke};
  }

  // highlight the handle when it's being dragged or the whole strip is being dragged.
  // using dragging.dragging to give this selector priority, as it seems to be overridden
  // by the hover selector above
  &.dragging,
  ${() => RangeStrip}.dragging.dragging ~ & {
    --bg: ${focusRangeStripTheme.dragging.backgroundColor};
    stroke: ${focusRangeStripTheme.dragging.stroke};
  }

  #pointer-root.draggingPositionInSequenceEditor &:hover {
    --bg: ${focusRangeStripTheme.dragging.backgroundColor};
    stroke: #40aaa4;
  }

  background-color: var(--bg);

  // a larger hit zone
  &:before {
    display: block;
    content: ' ';
    position: absolute;
    inset: -8px;
  }
`;
    ColoredMargin = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;

  background: linear-gradient(
    ${(props) => props.type === "start" ? 90 : -90}deg,
    var(--bg) 0%,
    #ffffff00 100%
  );

  width: 12px;
  left: ${(props) => props.type === "start" ? focusRangeStripTheme.thumbWidth : -focusRangeStripTheme.thumbWidth + 1}px;
`;
    OuterColoredMargin = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;

  background: linear-gradient(
    ${(props) => props.type === "start" ? -90 : 90}deg,
    ${() => topStripTheme.backgroundColor} 0%,
    #ffffff00 100%
  );

  width: 12px;
  left: ${(props) => props.type === "start" ? -12 : focusRangeStripTheme.thumbWidth}px;
`;
    FocusRangeThumb = ({ layoutP, thumbType }) => {
      var _a2;
      const [hitZoneRef, hitZoneNode] = useRefAndState(null);
      const existingRangeD = (0, import_react126.useMemo)(() => (0, import_dataverse35.prism)(() => {
        const { projectId, sheetId } = (0, import_dataverse35.val)(layoutP.sheet).address;
        const existingRange2 = (0, import_dataverse35.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
        return existingRange2;
      }), [layoutP]);
      const gestureHandlers = (0, import_react126.useMemo)(() => {
        return {
          debugName: "FocusRangeThumb",
          onDragStart() {
            let tempTransaction;
            let range;
            const sheet = (0, import_dataverse35.val)(layoutP.sheet);
            const sequence = sheet.getSequence();
            const defaultRange = { start: 0, end: sequence.length };
            let existingRange2 = existingRangeD.getValue() || {
              range: defaultRange,
              enabled: false
            };
            const focusRangeEnabled = existingRange2.enabled;
            const posBeforeDrag = existingRange2.range[thumbType];
            const scaledSpaceToUnitSpace = (0, import_dataverse35.val)(layoutP.scaledSpace.toUnitSpace);
            const minFocusRangeStripWidth = scaledSpaceToUnitSpace(focusRangeStripTheme.rangeStripMinWidth);
            return {
              onDrag(dx, _3, event) {
                var _a3;
                let newPosition;
                const snapPos = DopeSnap_default.checkIfMouseEventSnapToPos(event, {
                  ignore: hitZoneNode
                });
                if (snapPos == null) {
                  const deltaPos = scaledSpaceToUnitSpace(dx);
                  const oldPosPlusDeltaPos = posBeforeDrag + deltaPos;
                  newPosition = oldPosPlusDeltaPos;
                } else {
                  newPosition = snapPos;
                }
                range = ((_a3 = existingRangeD.getValue()) == null ? void 0 : _a3.range) || defaultRange;
                if (thumbType === "start") {
                  newPosition = Math.max(Math.min(newPosition, range["end"] - minFocusRangeStripWidth), 0);
                } else {
                  newPosition = Math.min(Math.max(newPosition, range["start"] + minFocusRangeStripWidth), sheet.getSequence().length);
                }
                const newPositionInFrame = sheet.getSequence().closestGridPosition(newPosition);
                if (tempTransaction !== void 0) {
                  tempTransaction.discard();
                }
                tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                  stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.focusRange.set(__spreadProps(__spreadValues({}, sheet.address), {
                    range: __spreadProps(__spreadValues({}, range), { [thumbType]: newPositionInFrame }),
                    enabled: focusRangeEnabled
                  }));
                });
              },
              onDragEnd(dragHappened) {
                if (dragHappened)
                  tempTransaction == null ? void 0 : tempTransaction.commit();
                else
                  tempTransaction == null ? void 0 : tempTransaction.discard();
              }
            };
          }
        };
      }, [layoutP]);
      const [isDragging] = useDrag(hitZoneNode, gestureHandlers);
      useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", thumbType === "start" ? "w-resize" : "e-resize");
      const existingRange = useVal(existingRangeD);
      useLockFrameStampPosition(isDragging, (_a2 = existingRange == null ? void 0 : existingRange.range[thumbType]) != null ? _a2 : 0);
      return usePrism(() => {
        const existingRange2 = existingRangeD.getValue();
        if (!existingRange2)
          return null;
        const { enabled } = existingRange2;
        const position2 = existingRange2.range[thumbType];
        let posInClippedSpace = (0, import_dataverse35.val)(layoutP.clippedSpace.fromUnitSpace)(position2);
        if (posInClippedSpace < 0 || (0, import_dataverse35.val)(layoutP.clippedSpace.width) < posInClippedSpace) {
          posInClippedSpace = -1e4;
        }
        return /* @__PURE__ */ import_react126.default.createElement(TheDiv, __spreadProps(__spreadValues(__spreadValues({
          ref: hitZoneRef
        }, DopeSnap_default.includePositionSnapAttrs(position2)), includeLockFrameStampAttrs(position2)), {
          className: `${isDragging && "dragging"} ${enabled && "enabled"}`,
          enabled,
          type: thumbType,
          style: {
            transform: `translate3d(${posInClippedSpace}px, 0, 0)`
          }
        }), /* @__PURE__ */ import_react126.default.createElement(ColoredMargin, {
          type: thumbType,
          enabled
        }), /* @__PURE__ */ import_react126.default.createElement(OuterColoredMargin, {
          type: thumbType
        }), /* @__PURE__ */ import_react126.default.createElement("svg", {
          viewBox: "0 0 9 18",
          xmlns: "http://www.w3.org/2000/svg"
        }, /* @__PURE__ */ import_react126.default.createElement("line", {
          x1: "4",
          y1: "6",
          x2: "4",
          y2: "12"
        }), /* @__PURE__ */ import_react126.default.createElement("line", {
          x1: "6",
          y1: "6",
          x2: "6",
          y2: "12"
        })));
      }, [layoutP, hitZoneRef, existingRangeD, isDragging]);
    };
    FocusRangeThumb_default = FocusRangeThumb;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeZone.tsx
function usePanelDragZoneGestureHandlers(layoutP, panelStuffRef) {
  const [mode, setMode] = (0, import_react128.useState)("none");
  useCssCursorLock(mode !== "none", "dragging", mode === "creating" ? "ew-resize" : "move");
  return (0, import_react128.useMemo)(() => {
    const focusRangeCreationGestureHandlers = () => {
      return {
        debugName: "FocusRangeZone/focusRangeCreationGestureHandlers",
        onDragStart(event) {
          let tempTransaction;
          const clippedSpaceToUnitSpace = (0, import_dataverse36.val)(layoutP.clippedSpace.toUnitSpace);
          const scaledSpaceToUnitSpace = (0, import_dataverse36.val)(layoutP.scaledSpace.toUnitSpace);
          const sheet = (0, import_dataverse36.val)(layoutP.sheet);
          const sequence = sheet.getSequence();
          const targetElement = event.target;
          const rect = targetElement.getBoundingClientRect();
          const startPosInUnitSpace = clippedSpaceToUnitSpace(event.clientX - rect.left);
          const minFocusRangeStripWidth = scaledSpaceToUnitSpace(focusRangeStripTheme.rangeStripMinWidth);
          return {
            onDrag(dx) {
              const deltaPos = scaledSpaceToUnitSpace(dx);
              let start = startPosInUnitSpace;
              let end = startPosInUnitSpace + deltaPos;
              [start, end] = [
                clamp_default(start, 0, sequence.length),
                clamp_default(end, 0, sequence.length)
              ].map((pos) => sequence.closestGridPosition(pos));
              if (end < start) {
                ;
                [start, end] = [
                  Math.max(Math.min(end, start - minFocusRangeStripWidth), 0),
                  start
                ];
              } else if (dx > 0) {
                end = Math.min(Math.max(end, start + minFocusRangeStripWidth), sequence.length);
              }
              if (tempTransaction) {
                tempTransaction.discard();
              }
              tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence.focusRange.set(__spreadProps(__spreadValues({}, sheet.address), {
                  range: { start, end },
                  enabled: true
                }));
              });
            },
            onDragEnd(dragHappened) {
              if (dragHappened && tempTransaction !== void 0) {
                tempTransaction.commit();
              } else if (tempTransaction) {
                tempTransaction.discard();
              }
            }
          };
        },
        lockCSSCursorTo: "ew-resize"
      };
    };
    const panelMoveGestureHandlers = () => {
      return {
        debugName: "FocusRangeZone/panelMoveGestureHandlers",
        onDragStart() {
          let tempTransaction;
          const stuffBeforeDrag = panelStuffRef.current;
          const unlock = panelStuffRef.current.addBoundsHighlightLock();
          return {
            onDrag(dx, dy) {
              const newDims = __spreadProps(__spreadValues({}, stuffBeforeDrag.dims), {
                top: clamp_default(stuffBeforeDrag.dims.top + dy, 0, window.innerHeight - visibleSize),
                left: clamp_default(stuffBeforeDrag.dims.left + dx, -stuffBeforeDrag.dims.width + visibleSize, window.innerWidth - visibleSize)
              });
              const position2 = panelDimsToPanelPosition(newDims, {
                width: window.innerWidth,
                height: window.innerHeight
              });
              tempTransaction == null ? void 0 : tempTransaction.discard();
              tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.studio.historic.panelPositions.setPanelPosition({
                  position: position2,
                  panelId: stuffBeforeDrag.panelId
                });
              });
            },
            onDragEnd(dragHappened) {
              unlock();
              if (dragHappened) {
                tempTransaction == null ? void 0 : tempTransaction.commit();
              } else {
                tempTransaction == null ? void 0 : tempTransaction.discard();
              }
            }
          };
        },
        lockCSSCursorTo: "move"
      };
    };
    return {
      debugName: "FocusRangeZone",
      onDragStart(event) {
        const [_mode, currentGestureHandlers] = event.shiftKey ? [
          "creating",
          focusRangeCreationGestureHandlers().onDragStart(event)
        ] : [
          "moving-panel",
          panelMoveGestureHandlers().onDragStart(event)
        ];
        setMode(_mode);
        if (currentGestureHandlers === false)
          return false;
        return {
          onDrag(dx, dy, event2, ddx, ddy) {
            currentGestureHandlers.onDrag(dx, dy, event2, ddx, ddy);
          },
          onDragEnd(dragHappened) {
            var _a2;
            setMode("none");
            (_a2 = currentGestureHandlers.onDragEnd) == null ? void 0 : _a2.call(currentGestureHandlers, dragHappened);
          }
        };
      }
    };
  }, [layoutP, panelStuffRef]);
}
var import_dataverse36, import_react128, Container27, FocusRangeZone, FocusRangeZone_default;
var init_FocusRangeZone = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/FocusRangeZone/FocusRangeZone.tsx"() {
    import_dataverse36 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    init_BasePanel();
    init_TopStrip();
    init_PointerEventsHandler();
    init_useDrag();
    init_useHoverWithoutDescendants();
    init_useKeyDown();
    init_useRefAndState();
    init_lodash();
    import_react128 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FocusRangeStrip();
    init_FocusRangeThumb();
    init_common();
    Container27 = styled_components_browser_esm_default.div`
  position: absolute;
  height: ${() => topStripHeight}px;
  left: 0;
  right: 0;
  box-sizing: border-box;
  /* Use the "grab" cursor if the shift key is up, which is the one used on the top strip of the sequence editor */
  cursor: ${(props) => props.isShiftDown ? "ew-resize" : "move"};
`;
    FocusRangeZone = ({ layoutP }) => {
      const [containerRef, containerNode] = useRefAndState(null);
      const panelStuff = usePanel();
      const panelStuffRef = (0, import_react128.useRef)(panelStuff);
      panelStuffRef.current = panelStuff;
      const existingRangeD = (0, import_react128.useMemo)(() => (0, import_dataverse36.prism)(() => {
        const { projectId, sheetId } = (0, import_dataverse36.val)(layoutP.sheet).address;
        const existingRange = (0, import_dataverse36.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
        return existingRange;
      }), [layoutP]);
      useDrag(containerNode, usePanelDragZoneGestureHandlers(layoutP, panelStuffRef));
      const isShiftDown = useKeyDown("Shift");
      const isPointerHovering = useHoverWithoutDescendants(containerNode);
      (0, import_react128.useEffect)(() => {
        if (!isShiftDown && isPointerHovering) {
          const unlock = panelStuffRef.current.addBoundsHighlightLock();
          return unlock;
        }
      }, [!isShiftDown && isPointerHovering]);
      return usePrism(() => {
        return /* @__PURE__ */ import_react128.default.createElement(Container27, {
          ref: containerRef,
          isShiftDown
        }, /* @__PURE__ */ import_react128.default.createElement(FocusRangeStrip_default, {
          layoutP
        }), /* @__PURE__ */ import_react128.default.createElement(FocusRangeThumb_default, {
          thumbType: "start",
          layoutP
        }), /* @__PURE__ */ import_react128.default.createElement(FocusRangeThumb_default, {
          thumbType: "end",
          layoutP
        }));
      }, [layoutP, existingRangeD, isShiftDown]);
    };
    FocusRangeZone_default = FocusRangeZone;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/TopStrip.tsx
var import_react130, topStripHeight, topStripTheme, Container28, TopStrip, TopStrip_default;
var init_TopStrip = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/TopStrip.tsx"() {
    init_src();
    import_react130 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_StampsGrid();
    init_FrameStampPositionProvider();
    init_css();
    init_FocusRangeZone();
    topStripHeight = 18;
    topStripTheme = {
      backgroundColor: `#1f2120eb`,
      borderColor: `#1c1e21`
    };
    Container28 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${topStripHeight}px;
  box-sizing: border-box;
  background: ${topStripTheme.backgroundColor};
  border-bottom: 1px solid ${topStripTheme.borderColor};
  ${pointerEventsAutoInNormalMode};
`;
    TopStrip = ({
      layoutP
    }) => {
      const width = useVal(layoutP.rightDims.width);
      return /* @__PURE__ */ import_react130.default.createElement(import_react130.default.Fragment, null, /* @__PURE__ */ import_react130.default.createElement(Container28, __spreadValues({}, includeLockFrameStampAttrs("hide")), /* @__PURE__ */ import_react130.default.createElement(StampsGrid_default, {
        layoutP,
        width,
        height: topStripHeight
      }), /* @__PURE__ */ import_react130.default.createElement(FocusRangeZone_default, {
        layoutP
      })));
    };
    TopStrip_default = TopStrip;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/LengthIndicator/LengthEditorPopover.tsx
var import_react131, greaterThanZero, Container29, Label2, nudge, LengthEditorPopover, LengthEditorPopover_default;
var init_LengthEditorPopover = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/LengthIndicator/LengthEditorPopover.tsx"() {
    import_react131 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_src();
    init_getStudio();
    init_BasicNumberInput();
    init_propNameTextCSS();
    greaterThanZero = (v5) => isFinite(v5) && v5 > 0;
    Container29 = styled_components_browser_esm_default.div`
  display: flex;
  gap: 8px;
  padding: 4px 8px;
  height: 28px;
  align-items: center;
`;
    Label2 = styled_components_browser_esm_default.div`
  ${propNameTextCSS};
  white-space: nowrap;
`;
    nudge = ({ deltaX }) => deltaX * 0.25;
    LengthEditorPopover = ({ layoutP }) => {
      const sheet = useVal(layoutP.sheet);
      const fns = (0, import_react131.useMemo)(() => {
        let tempTransaction;
        return {
          temporarilySetValue(newLength) {
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.setLength(__spreadProps(__spreadValues({}, sheet.address), {
                length: newLength
              }));
            });
          },
          discardTemporaryValue() {
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
          },
          permanentlySetValue(newLength) {
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.setLength(__spreadProps(__spreadValues({}, sheet.address), {
                length: newLength
              }));
            });
          }
        };
      }, [layoutP, sheet]);
      const inputRef = (0, import_react131.useRef)(null);
      (0, import_react131.useLayoutEffect)(() => {
        inputRef.current.focus();
      }, []);
      return usePrism(() => {
        const sequence = sheet.getSequence();
        const sequenceLength = sequence.length;
        return /* @__PURE__ */ import_react131.default.createElement(Container29, null, /* @__PURE__ */ import_react131.default.createElement(Label2, null, "Sequence length"), /* @__PURE__ */ import_react131.default.createElement(BasicNumberInput_default, __spreadProps(__spreadValues({
          value: sequenceLength
        }, fns), {
          isValid: greaterThanZero,
          inputRef,
          nudge
        })));
      }, [sheet, fns, inputRef]);
    };
    LengthEditorPopover_default = LengthEditorPopover;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/LengthIndicator/LengthIndicator.tsx
function useDragBulge(node, props) {
  const propsRef = (0, import_react134.useRef)(props);
  propsRef.current = props;
  const gestureHandlers = (0, import_react134.useMemo)(() => {
    return {
      debugName: "LengthIndicator/useDragBulge",
      lockCSSCursorTo: "ew-resize",
      onDragStart(event) {
        let tempTransaction;
        const propsAtStartOfDrag = propsRef.current;
        const sheet = (0, import_dataverse37.val)(propsRef.current.layoutP.sheet);
        const initialLength = sheet.getSequence().length;
        const toUnitSpace = (0, import_dataverse37.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        return {
          onDrag(dx, dy, event2) {
            const delta = toUnitSpace(dx);
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.setLength(__spreadProps(__spreadValues({}, sheet.address), {
                length: initialLength + delta
              }));
            });
          },
          onDragEnd(dragHappened) {
            if (dragHappened) {
              if (tempTransaction) {
                tempTransaction.commit();
              }
            } else {
              if (tempTransaction) {
                tempTransaction.discard();
              }
            }
          }
        };
      }
    };
  }, []);
  const [isDragging] = useDrag(node, gestureHandlers);
  useLockFrameStampPosition(isDragging, -1);
  return [isDragging];
}
var import_dataverse37, import_react134, coverWidth, colors, Strip, ThumbContainer, Tooltip, Tumb, Cover, RENDER_OUT_OF_VIEW_X, LengthIndicator, LengthIndicator_default;
var init_LengthIndicator = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/LengthIndicator/LengthIndicator.tsx"() {
    init_src();
    import_dataverse37 = __toModule(require("@theatre/dataverse"));
    import_react134 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SequenceEditorPanel();
    init_TopStrip();
    init_useRefAndState();
    init_useDrag();
    init_getStudio();
    init_usePopover();
    init_FrameStampPositionProvider();
    init_all();
    init_LengthEditorPopover();
    init_css();
    init_BasicPopover();
    coverWidth = 1e3;
    colors = {
      stripNormal: `#0000006c`,
      stripActive: `#000000`
    };
    Strip = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  z-index: ${() => zIndexes.lengthIndicatorStrip};
  pointer-events: none;

  &:after {
    display: block;
    content: ' ';
    position: absolute;
    /* top: ${topStripHeight}px; */
    top: 0;
    bottom: 0;
    left: -1px;
    width: 1px;
    background-color: ${colors.stripNormal};
  }

  &:hover:after,
  &.dragging:after {
    background-color: ${colors.stripActive};
  }
`;
    ThumbContainer = styled_components_browser_esm_default.div`
  position: absolute;
  top: ${topStripHeight - 15}px;
  width: 100px;
  left: -50px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
    Tooltip = styled_components_browser_esm_default.div`
  margin-top: 8px;
  font-size: 10px;
  white-space: nowrap;
  padding: 2px 8px;
  border-radius: 2px;
  ${pointerEventsAutoInNormalMode};
  cursor: ew-resize;
  color: #464646;
  background-color: #0000004d;
  display: none;

  ${Strip}:hover &, ${Strip}.dragging & {
    display: block;
    color: white;
    background-color: ${colors.stripActive};
  }
`;
    Tumb = styled_components_browser_esm_default.div`
  font-size: 10px;
  white-space: nowrap;
  padding: 1px 2px;
  border-radius: 2px;
  ${pointerEventsAutoInNormalMode};
  justify-content: center;
  align-items: center;
  cursor: ew-resize;
  color: #5d5d5d;
  background-color: #191919;

  ${Strip}:hover &, ${Strip}.dragging & {
    color: white;
    background-color: ${colors.stripActive};

    & > svg:first-child {
      margin-right: -1px;
    }
  }

  & > svg:first-child {
    margin-right: -4px;
  }
`;
    Cover = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgb(23 23 23 / 43%);
  width: ${coverWidth}px;
  z-index: ${() => zIndexes.lengthIndicatorCover};
  transform-origin: left top;

  ${Strip}.dragging ~ &, ${Strip}:hover ~ & {
    background-color: rgb(23 23 23 / 60%);
  }
`;
    RENDER_OUT_OF_VIEW_X = -1e4;
    LengthIndicator = ({ layoutP }) => {
      const [nodeRef, node] = useRefAndState(null);
      const [isDragging] = useDragBulge(node, { layoutP });
      const {
        node: popoverNode,
        toggle: togglePopover,
        close: closePopover
      } = usePopover({ debugName: "LengthIndicator" }, () => {
        return /* @__PURE__ */ import_react134.default.createElement(BasicPopover_default, null, /* @__PURE__ */ import_react134.default.createElement(LengthEditorPopover_default, {
          layoutP,
          onRequestClose: closePopover
        }));
      });
      return usePrism(() => {
        const sheet = (0, import_dataverse37.val)(layoutP.sheet);
        const height2 = (0, import_dataverse37.val)(layoutP.rightDims.height);
        const sequence = sheet.getSequence();
        const sequenceLength = sequence.length;
        const startInUnitSpace = sequenceLength;
        let startX = (0, import_dataverse37.val)(layoutP.clippedSpace.fromUnitSpace)(startInUnitSpace);
        let endX = (0, import_dataverse37.val)(layoutP.clippedSpace.width);
        let scaleX, translateX;
        if (startX > endX) {
          translateX = 0;
          scaleX = 0;
        } else {
          if (startX < 0) {
            startX = 0;
          }
          translateX = startX;
          scaleX = (endX - startX) / coverWidth;
        }
        return /* @__PURE__ */ import_react134.default.createElement(import_react134.default.Fragment, null, popoverNode, /* @__PURE__ */ import_react134.default.createElement(Strip, {
          style: {
            height: height2 + "px",
            transform: `translateX(${translateX === 0 ? RENDER_OUT_OF_VIEW_X : translateX}px)`
          },
          className: isDragging ? "dragging" : ""
        }, /* @__PURE__ */ import_react134.default.createElement(ThumbContainer, null, /* @__PURE__ */ import_react134.default.createElement(Tumb, __spreadValues({
          ref: nodeRef,
          onClick: (e2) => {
            togglePopover(e2, node);
          }
        }, includeLockFrameStampAttrs("hide")), /* @__PURE__ */ import_react134.default.createElement(GoChevronLeft, null), /* @__PURE__ */ import_react134.default.createElement(GoChevronRight, null)), /* @__PURE__ */ import_react134.default.createElement(Tooltip, null, "Sequence length:", " ", sequence.positionFormatter.formatBasic(sequenceLength)))), /* @__PURE__ */ import_react134.default.createElement(Cover, {
          title: "Length",
          style: {
            height: height2 + "px",
            transform: `translateX(${translateX}px) scale(${scaleX}, 1)`
          }
        }));
      }, [layoutP, nodeRef, isDragging, popoverNode]);
    };
    LengthIndicator_default = LengthIndicator;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/FrameStamp.tsx
var import_dataverse38, import_react136, Container30, Label3, Line, FrameStamp, FrameStamp_default;
var init_FrameStamp = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/FrameStamp.tsx"() {
    init_src();
    import_dataverse38 = __toModule(require("@theatre/dataverse"));
    import_react136 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_StampsGrid();
    init_SequenceEditorPanel();
    init_TopStrip();
    init_FrameStampPositionProvider();
    Container30 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0px;
`;
    Label3 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 16px;
  font-size: ${stampsGridTheme.stampFontSize};
  color: ${stampsGridTheme.fullUnitStampColor};
  text-align: center;
  transform: translateX(-50%);
  background: ${topStripTheme.backgroundColor};
  padding: 1px 8px;
  font-variant-numeric: tabular-nums;
  pointer-events: none;
  z-index: ${() => zIndexes.currentFrameStamp};
`;
    Line = styled_components_browser_esm_default.div`
  position: absolute;
  top: 5px;
  left: -0px;
  bottom: 0;
  width: 0.5px;
  background: rgba(100, 100, 100, 0.2);
  pointer-events: none;
`;
    FrameStamp = import_react136.default.memo(({ layoutP }) => {
      const [posInUnitSpace, posType] = useVal(useFrameStampPositionD());
      const unitSpaceToClippedSpace = useVal(layoutP.clippedSpace.fromUnitSpace);
      const { sequence, formatter, clippedSpaceWidth } = usePrism(() => {
        const sequence2 = (0, import_dataverse38.val)(layoutP.sheet).getSequence();
        const clippedSpaceWidth2 = (0, import_dataverse38.val)(layoutP.clippedSpace.width);
        return { sequence: sequence2, formatter: sequence2.positionFormatter, clippedSpaceWidth: clippedSpaceWidth2 };
      }, [layoutP]);
      if (posInUnitSpace == -1) {
        return /* @__PURE__ */ import_react136.default.createElement(import_react136.default.Fragment, null);
      }
      const snappedPosInUnitSpace = posType === FrameStampPositionType.free ? sequence.closestGridPosition(posInUnitSpace) : posInUnitSpace;
      const posInClippedSpace = unitSpaceToClippedSpace(snappedPosInUnitSpace);
      const isVisible2 = posInClippedSpace >= 0 && posInClippedSpace <= clippedSpaceWidth;
      return /* @__PURE__ */ import_react136.default.createElement(import_react136.default.Fragment, null, /* @__PURE__ */ import_react136.default.createElement(Container30, null, /* @__PURE__ */ import_react136.default.createElement(Label3, {
        style: {
          opacity: isVisible2 ? 1 : 0,
          transform: `translate3d(calc(${posInClippedSpace}px - 50%), 0, 0)`
        }
      }, formatter.formatForPlayhead(snappedPosInUnitSpace)), /* @__PURE__ */ import_react136.default.createElement(Line, {
        posType,
        style: {
          opacity: isVisible2 ? 1 : 0,
          transform: `translate3d(${posInClippedSpace}px, 0, 0)`
        }
      })), " ");
    });
    FrameStamp_default = FrameStamp;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/HorizontalScrollbar.tsx
var import_dataverse39, import_react138, Container31, TimeThread, RangeBar, RangeHandle, RangeStartHandle, RangeEndHandle, Tooltip2, HorizontalScrollbar, HorizontalScrollbar_default;
var init_HorizontalScrollbar = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/HorizontalScrollbar.tsx"() {
    init_src();
    import_dataverse39 = __toModule(require("@theatre/dataverse"));
    init_mapValues();
    init_polished_esm();
    import_react138 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SequenceEditorPanel();
    init_FrameStampPositionProvider();
    init_css();
    init_useDrag();
    Container31 = styled_components_browser_esm_default.div`
  --threadHeight: 6px;
  --bg-inactive: #32353b;
  --bg-active: #5b5c5d;
  position: absolute;
  height: 0;
  width: 100%;
  left: 12px;
  /* bottom: 8px; */
  z-index: ${() => zIndexes.horizontalScrollbar};
  ${pointerEventsAutoInNormalMode}
`;
    TimeThread = styled_components_browser_esm_default.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--threadHeight);
`;
    RangeBar = styled_components_browser_esm_default.div`
  position: absolute;
  height: 5px;
  background: var(--bg-inactive);
  cursor: ew-resize;
  z-index: 2;

  &:hover,
  &:active {
    background: var(--bg-active);
  }

  &:after {
    ${position("absolute", "-4px")};
    display: block;
    content: ' ';
  }
`;
    RangeHandle = styled_components_browser_esm_default.div`
  position: absolute;
  height: 5px;
  width: 7px;
  left: 0;
  z-index: 2;
  top: 0;
  bottom: 0;
  display: block;

  &:hover:before {
    background: var(--bg-active);
  }

  &:before {
    ${position("absolute", "0")};
    display: block;
    content: ' ';
    background: var(--bg-inactive);
    border-radius: 0 2px 2px 0;
  }

  &:after {
    ${position("absolute", "-4px")};
    display: block;
    content: ' ';
  }
`;
    RangeStartHandle = styled_components_browser_esm_default(RangeHandle)`
  left: calc(-1 * 7px);
  cursor: w-resize;
  &:before {
    transform: scaleX(-1);
  }
`;
    RangeEndHandle = styled_components_browser_esm_default(RangeHandle)`
  cursor: e-resize;
  left: 0px;
`;
    Tooltip2 = styled_components_browser_esm_default.div`
  display: ${(props) => props.active ? "block" : "none"};
  position: absolute;
  top: -20px;
  left: 4px;
  padding: 0 4px;
  transform: translateX(-50%);
  background: #131d1f;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;

  ${RangeStartHandle}:hover &,
  ${RangeEndHandle}:hover &,
  ${RangeBar}:hover ~ ${RangeStartHandle} &,
  ${RangeBar}:hover ~ ${RangeEndHandle} & {
    display: block;
  }
`;
    HorizontalScrollbar = ({ layoutP }) => {
      const unitPosToHumanReadablePos = (0, import_react138.useCallback)((n3) => n3.toFixed(2), []);
      const relevantValuesD = (0, import_react138.useMemo)(() => (0, import_dataverse39.prism)(() => {
        const rightWidth = (0, import_dataverse39.val)(layoutP.rightDims.width) - 25;
        const clippedSpaceRange2 = (0, import_dataverse39.val)(layoutP.clippedSpace.range);
        const sequenceLength = (0, import_dataverse39.val)(layoutP.sheet).getSequence().length;
        const assumedLengthOfSequence = Math.max(clippedSpaceRange2.end, sequenceLength);
        const rangeStartX2 = clippedSpaceRange2.start / assumedLengthOfSequence * rightWidth;
        const rangeEndX2 = clippedSpaceRange2.end / assumedLengthOfSequence * rightWidth;
        return {
          rightWidth,
          clippedSpaceRange: clippedSpaceRange2,
          sequenceLength,
          assumedLengthOfSequence,
          rangeStartX: rangeStartX2,
          rangeEndX: rangeEndX2,
          bottom: (0, import_dataverse39.val)(layoutP.horizontalScrollbarDims.bottom)
        };
      }), [layoutP]);
      const { rangeStartX, rangeEndX, clippedSpaceRange, bottom } = useVal(relevantValuesD);
      const [beingDragged, setBeingDragged] = (0, import_react138.useState)("nothing");
      const handles = (0, import_react138.useMemo)(() => {
        let valuesBeforeDrag = (0, import_dataverse39.val)(relevantValuesD);
        let noteValuesBeforeDrag = () => {
          valuesBeforeDrag = (0, import_dataverse39.val)(relevantValuesD);
        };
        const deltaXToDeltaPos = (dx) => {
          const asAFractionOfRightWidth = dx / valuesBeforeDrag.rightWidth;
          return asAFractionOfRightWidth * valuesBeforeDrag.assumedLengthOfSequence;
        };
        const self2 = {
          onRangeDragStart() {
            noteValuesBeforeDrag();
            return {
              onDrag(dx) {
                setBeingDragged("both");
                const deltaPosInUnitSpace = deltaXToDeltaPos(dx);
                const newRange = mapValues_default(valuesBeforeDrag.clippedSpaceRange, (p3) => p3 + deltaPosInUnitSpace);
                (0, import_dataverse39.val)(layoutP.clippedSpace.setRange)(newRange);
              },
              onDragEnd() {
                setBeingDragged("nothing");
              }
            };
          },
          onRangeStartDragStart() {
            noteValuesBeforeDrag();
            return {
              onDrag(dx) {
                setBeingDragged("start");
                const deltaPosInUnitSpace = deltaXToDeltaPos(dx);
                const newRange = {
                  start: valuesBeforeDrag.clippedSpaceRange.start + deltaPosInUnitSpace,
                  end: valuesBeforeDrag.clippedSpaceRange.end
                };
                if (newRange.start > newRange.end - 1) {
                  newRange.start = newRange.end - 1;
                }
                if (newRange.start <= 0) {
                  newRange.start = 0;
                }
                (0, import_dataverse39.val)(layoutP.clippedSpace.setRange)(newRange);
              },
              onDragEnd() {
                setBeingDragged("nothing");
              }
            };
          },
          onRangeEndDragStart() {
            noteValuesBeforeDrag();
            return {
              onDrag(dx) {
                setBeingDragged("end");
                const deltaPosInUnitSpace = deltaXToDeltaPos(dx);
                const newRange = {
                  start: valuesBeforeDrag.clippedSpaceRange.start,
                  end: valuesBeforeDrag.clippedSpaceRange.end + deltaPosInUnitSpace
                };
                if (newRange.end < newRange.start + 1) {
                  newRange.end = newRange.start + 1;
                }
                if (newRange.end >= valuesBeforeDrag.assumedLengthOfSequence) {
                  newRange.end = valuesBeforeDrag.assumedLengthOfSequence;
                }
                (0, import_dataverse39.val)(layoutP.clippedSpace.setRange)(newRange);
              },
              onDragEnd() {
                setBeingDragged("nothing");
              }
            };
          }
        };
        return self2;
      }, [layoutP, relevantValuesD]);
      const [rangeDragNode, setRangeDragNode] = (0, import_react138.useState)(null);
      useDrag(rangeDragNode, {
        debugName: "HorizontalScrollbar/onRangeDrag",
        onDragStart: handles.onRangeDragStart,
        lockCSSCursorTo: "ew-resize"
      });
      const [rangeStartDragNode, setRangeStartDragNode] = (0, import_react138.useState)(null);
      useDrag(rangeStartDragNode, {
        debugName: "HorizontalScrollbar/onRangeStartDrag",
        onDragStart: handles.onRangeStartDragStart,
        lockCSSCursorTo: "w-resize"
      });
      const [rangeEndDragNode, setRangeEndDragNode] = (0, import_react138.useState)(null);
      useDrag(rangeEndDragNode, {
        debugName: "HorizontalScrollbar/onRangeEndDrag",
        onDragStart: handles.onRangeEndDragStart,
        lockCSSCursorTo: "e-resize"
      });
      return /* @__PURE__ */ import_react138.default.createElement(Container31, __spreadValues({
        style: { bottom: bottom + 8 + "px" }
      }, includeLockFrameStampAttrs("hide")), /* @__PURE__ */ import_react138.default.createElement(TimeThread, null, /* @__PURE__ */ import_react138.default.createElement(RangeBar, {
        ref: setRangeDragNode,
        style: {
          width: `${rangeEndX - rangeStartX}px`,
          transform: `translate3d(${rangeStartX}px, 0, 0)`
        }
      }), /* @__PURE__ */ import_react138.default.createElement(RangeStartHandle, {
        ref: setRangeStartDragNode,
        style: { transform: `translate3d(${rangeStartX}px, 0, 0)` }
      }, /* @__PURE__ */ import_react138.default.createElement(Tooltip2, {
        active: beingDragged === "both" || beingDragged === "start"
      }, unitPosToHumanReadablePos(clippedSpaceRange.start))), /* @__PURE__ */ import_react138.default.createElement(RangeEndHandle, {
        ref: setRangeEndDragNode,
        style: { transform: `translate3d(${rangeEndX}px, 0, 0)` }
      }, /* @__PURE__ */ import_react138.default.createElement(Tooltip2, {
        active: beingDragged === "both" || beingDragged === "end"
      }, unitPosToHumanReadablePos(clippedSpaceRange.end)))));
    };
    HorizontalScrollbar_default = HorizontalScrollbar;
  }
});

// studio/src/uiComponents/RoomToClick.tsx
var import_react139, Container32, RoomToClick, RoomToClick_default;
var init_RoomToClick = __esm({
  "studio/src/uiComponents/RoomToClick.tsx"() {
    import_react139 = __toModule(require_react());
    init_styled_components_browser_esm();
    Container32 = styled_components_browser_esm_default.div`
  position: absolute;
  inset: ${(props) => props.room * -1}px;
`;
    RoomToClick = (props) => {
      return /* @__PURE__ */ import_react139.default.createElement(Container32, {
        room: props.room
      });
    };
    RoomToClick_default = RoomToClick;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/PlayheadPositionPopover.tsx
var import_react141, import_react142, import_dataverse40, greaterThanOrEqualToZero, Container33, Label4, nudge2, PlayheadPositionPopover, PlayheadPositionPopover_default;
var init_PlayheadPositionPopover = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/PlayheadPositionPopover.tsx"() {
    init_styled_components_browser_esm();
    init_src();
    init_BasicNumberInput();
    init_propNameTextCSS();
    import_react141 = __toModule(require_react());
    import_react142 = __toModule(require_react());
    import_dataverse40 = __toModule(require("@theatre/dataverse"));
    init_clamp();
    greaterThanOrEqualToZero = (v5) => isFinite(v5) && v5 >= 0;
    Container33 = styled_components_browser_esm_default.div`
  display: flex;
  gap: 8px;
  padding: 4px 8px;
  height: 28px;
  align-items: center;
`;
    Label4 = styled_components_browser_esm_default.div`
  ${propNameTextCSS};
  white-space: nowrap;
`;
    nudge2 = ({ deltaX }) => deltaX * 0.25;
    PlayheadPositionPopover = ({ layoutP }) => {
      const sheet = (0, import_dataverse40.val)(layoutP.sheet);
      const sequence = sheet.getSequence();
      const fns = (0, import_react141.useMemo)(() => {
        let tempPosition;
        const originalPosition = sequence.position;
        return {
          temporarilySetValue(newPosition) {
            if (tempPosition) {
              tempPosition = void 0;
            }
            tempPosition = clamp_default(newPosition, 0, sequence.length);
            sequence.position = tempPosition;
          },
          discardTemporaryValue() {
            if (tempPosition) {
              tempPosition = void 0;
              sequence.position = originalPosition;
            }
          },
          permanentlySetValue(newPosition) {
            if (tempPosition) {
              tempPosition = void 0;
            }
            sequence.position = clamp_default(newPosition, 0, sequence.length);
          }
        };
      }, [layoutP, sequence]);
      const inputRef = (0, import_react141.useRef)(null);
      (0, import_react141.useLayoutEffect)(() => {
        inputRef.current.focus();
      }, []);
      return usePrism(() => {
        const sequence2 = sheet.getSequence();
        return /* @__PURE__ */ import_react142.default.createElement(Container33, null, /* @__PURE__ */ import_react142.default.createElement(Label4, null, "Sequence position"), /* @__PURE__ */ import_react142.default.createElement(BasicNumberInput_default, __spreadProps(__spreadValues({
          value: Number(sequence2.position.toFixed(3))
        }, fns), {
          isValid: greaterThanOrEqualToZero,
          inputRef,
          nudge: nudge2
        })));
      }, [sheet, fns, inputRef]);
    };
    PlayheadPositionPopover_default = PlayheadPositionPopover;
  }
});

// studio/src/utils/isMac.ts
var isMac;
var init_isMac = __esm({
  "studio/src/utils/isMac.ts"() {
    isMac = typeof navigator !== "undefined" && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  }
});

// studio/src/utils/keyboardUtils.ts
var cmdIsDown;
var init_keyboardUtils = __esm({
  "studio/src/utils/keyboardUtils.ts"() {
    init_isMac();
    cmdIsDown = (e2) => {
      if (isMac) {
        return e2.metaKey === true;
      } else {
        return e2.ctrlKey === true;
      }
    };
  }
});

// studio/src/UIRoot/useKeyboardShortcuts.ts
function useKeyboardShortcuts() {
  const studio3 = getStudio();
  (0, import_react143.useEffect)(() => {
    const handleKeyDown = (e2) => {
      const target = e2.composedPath()[0];
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
        return;
      }
      if (e2.key === "z" || e2.key === "Z" || e2.code === "KeyZ") {
        if (cmdIsDown(e2)) {
          if (e2.shiftKey === true) {
            studio3.redo();
          } else {
            studio3.undo();
          }
        } else {
          return;
        }
      } else if (e2.code === "Space" && !e2.shiftKey && !e2.metaKey && !e2.altKey && !e2.ctrlKey) {
        const seq = getSelectedSequence();
        if (seq) {
          if (seq.playing) {
            seq.pause();
          } else {
            const { projectId, sheetId } = seq.address;
            const controlledPlaybackStateD = (0, import_dataverse41.prism)(() => {
              const focusRange = (0, import_dataverse41.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
              const shouldFollowFocusRange = import_dataverse41.prism.memo("shouldFollowFocusRange", () => {
                const posBeforePlay = seq.position;
                if (focusRange) {
                  const withinRange = posBeforePlay >= focusRange.range.start && posBeforePlay <= focusRange.range.end;
                  if (focusRange.enabled) {
                    if (withinRange) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              }, []);
              if (shouldFollowFocusRange && focusRange && focusRange.enabled) {
                return {
                  range: [focusRange.range.start, focusRange.range.end],
                  isFollowingARange: true
                };
              } else {
                const sequenceLength = (0, import_dataverse41.val)(seq.pointer.length);
                return { range: [0, sequenceLength], isFollowingARange: false };
              }
            });
            const playbackPromise = seq.playDynamicRange(controlledPlaybackStateD.map(({ range }) => range));
            const playbackStateBox = getPlaybackStateBox(seq);
            playbackPromise.finally(() => {
              playbackStateBox.set(void 0);
            });
            playbackStateBox.set(controlledPlaybackStateD);
          }
        } else {
          return;
        }
      } else if (e2.altKey && (e2.key === "\\" || e2.code === "Backslash" || e2.code === "IntlBackslash")) {
        studio3.transaction(({ stateEditors: stateEditors2, drafts: drafts2 }) => {
          stateEditors2.studio.ahistoric.setVisibilityState(drafts2.ahistoric.visibilityState === "everythingIsHidden" ? "everythingIsVisible" : "everythingIsHidden");
        });
      } else {
        return;
      }
      e2.preventDefault();
      e2.stopPropagation();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
}
var import_react143, import_dataverse41, getPlaybackStateBox, getIsPlayheadAttachedToFocusRange;
var init_useKeyboardShortcuts = __esm({
  "studio/src/UIRoot/useKeyboardShortcuts.ts"() {
    import_react143 = __toModule(require_react());
    init_getStudio();
    init_keyboardUtils();
    init_selectors();
    import_dataverse41 = __toModule(require("@theatre/dataverse"));
    init_memoizeFn();
    getPlaybackStateBox = memoizeFn((sequence) => {
      const box = new import_dataverse41.Box(void 0);
      return box;
    });
    getIsPlayheadAttachedToFocusRange = memoizeFn((sequence) => (0, import_dataverse41.prism)(() => {
      const controlledPlaybackState = getPlaybackStateBox(sequence).derivation.getValue();
      if (controlledPlaybackState) {
        return controlledPlaybackState.getValue().isFollowingARange;
      } else {
        const { projectId, sheetId } = sequence.address;
        const focusRange = (0, import_dataverse41.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
        if (!focusRange || !focusRange.enabled)
          return false;
        const pos = (0, import_dataverse41.val)(sequence.pointer.position);
        const withinRange = pos >= focusRange.range.start && pos <= focusRange.range.end;
        return withinRange;
      }
    }));
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/SnapCursor.svg
var SnapCursor_default;
var init_SnapCursor = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/SnapCursor.svg"() {
    SnapCursor_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMSA3VjFINyIgc3Ryb2tlPSIjNzRGRkRFIiBzdHJva2Utd2lkdGg9IjAuMjUiIC8+CiAgPHBhdGggZD0iTTcgMzNIMUwxIDI3IiBzdHJva2U9IiM3NEZGREUiIHN0cm9rZS13aWR0aD0iMC4yNSIgLz4KICA8cGF0aCBkPSJNMzMgMjdWMzNIMjciIHN0cm9rZT0iIzc0RkZERSIgc3Ryb2tlLXdpZHRoPSIwLjI1IiAvPgogIDxwYXRoIGQ9Ik0yNyAxTDMzIDFWNyIgc3Ryb2tlPSIjNzRGRkRFIiBzdHJva2Utd2lkdGg9IjAuMjUiIC8+Cjwvc3ZnPg==";
  }
});

// studio/src/utils/absoluteDims.tsx
var absoluteDims;
var init_absoluteDims = __esm({
  "studio/src/utils/absoluteDims.tsx"() {
    absoluteDims = (w4, h4 = w4) => `
  left: ${w4 * -0.5}px;
  top: ${h4 * -0.5}px;
  width: ${w4}px;
  height: ${h4}px;
`;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/DopeSnapHitZoneUI.tsx
var HIT_ZONE_SIZE_PX, SNAP_CURSOR_SIZE_PX, BEING_DRAGGED_CLASS, DopeSnapHitZoneUI;
var init_DopeSnapHitZoneUI = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/DopeSnapHitZoneUI.tsx"() {
    init_css();
    init_PointerEventsHandler();
    init_styled_components_browser_esm();
    init_SnapCursor();
    init_absoluteDims();
    init_DopeSnap();
    init_FrameStampPositionProvider();
    HIT_ZONE_SIZE_PX = 12;
    SNAP_CURSOR_SIZE_PX = 34;
    BEING_DRAGGED_CLASS = "beingDragged";
    DopeSnapHitZoneUI = {
      BEING_DRAGGED_CLASS,
      CSS: Ce`
    position: absolute;
    ${absoluteDims(HIT_ZONE_SIZE_PX)};
    ${pointerEventsAutoInNormalMode};

    &.${BEING_DRAGGED_CLASS} {
      pointer-events: none !important;
    }
  `,
      CSS_WHEN_SOMETHING_DRAGGING: Ce`
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});

    // ⸢⸤⸣⸥ thing
    // This box extends the hitzone so the user does not
    // accidentally leave the hitzone
    &:hover:after {
      position: absolute;
      top: calc(50% - ${SNAP_CURSOR_SIZE_PX / 2}px);
      left: calc(50% - ${SNAP_CURSOR_SIZE_PX / 2}px);
      width: ${SNAP_CURSOR_SIZE_PX}px;
      height: ${SNAP_CURSOR_SIZE_PX}px;
      display: block;
      content: ' ';
      background: url(${SnapCursor_default}) no-repeat 100% 100%;
      // This icon might also fit: GiConvergenceTarget
    }
  `,
      reactProps(config) {
        return __spreadProps(__spreadValues(__spreadValues({}, includeLockFrameStampAttrs(config.position)), DopeSnap_default.includePositionSnapAttrs(config.position)), {
          className: config.isDragging ? DopeSnapHitZoneUI.BEING_DRAGGED_CLASS : ""
        });
      }
    };
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/KeyframeSnapTarget.tsx
function snapToAll() {
  stateB.set({ mode: "snapToAll" });
}
function snapToNone() {
  stateB.set({ mode: "snapToNone" });
}
function snapToSome(positions) {
  stateB.set({ mode: "snapToSome", positions });
}
function collectKeyframeSnapPositions(tracksByObject, shouldIncludeKeyframe) {
  return Object.fromEntries(Object.entries(tracksByObject).map(([objectKey, trackDataAndTrackIdByPropPath]) => [
    objectKey,
    Object.fromEntries(Object.entries(trackDataAndTrackIdByPropPath.trackData).map(([trackId, track]) => [
      trackId,
      track.keyframes.filter((kf) => shouldIncludeKeyframe(kf, {
        trackId,
        trackData: track,
        objectKey
      })).map((keyframe) => keyframe.position)
    ]))
  ]));
}
var import_dataverse42, import_react144, HitZone, Container34, KeyframeSnapTarget, KeyframeSnapTarget_default, stateB, snapPositionsStateD;
var init_KeyframeSnapTarget = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/KeyframeSnapTarget.tsx"() {
    import_dataverse42 = __toModule(require("@theatre/dataverse"));
    import_react144 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_DopeSnapHitZoneUI();
    HitZone = styled_components_browser_esm_default.div`
  z-index: 1;
  cursor: ew-resize;

  ${DopeSnapHitZoneUI.CSS}

  #pointer-root.draggingPositionInSequenceEditor & {
    ${DopeSnapHitZoneUI.CSS_WHEN_SOMETHING_DRAGGING}
  }
`;
    Container34 = styled_components_browser_esm_default.div`
  position: absolute;
`;
    KeyframeSnapTarget = (props) => {
      return /* @__PURE__ */ import_react144.default.createElement(Container34, {
        style: {
          top: `${props.leaf.nodeHeight / 2}px`,
          left: `calc(${(0, import_dataverse42.val)(props.layoutP.scaledSpace.leftPadding)}px + calc(var(--unitSpaceToScaledSpaceMultiplier) * ${props.position}px))`
        }
      }, /* @__PURE__ */ import_react144.default.createElement(HitZone, __spreadValues({}, DopeSnapHitZoneUI.reactProps({
        isDragging: false,
        position: props.position
      }))));
    };
    KeyframeSnapTarget_default = KeyframeSnapTarget;
    stateB = new import_dataverse42.Box({ mode: "snapToNone" });
    snapPositionsStateD = stateB.derivation;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/Playhead.tsx
function usePlayheadContextMenu(node, options2) {
  return useContextMenu(node, {
    menuItems() {
      return [
        {
          label: "Place marker",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              const sheet = (0, import_dataverse43.val)(options2.layoutP.sheet);
              const sheetSequence = sheet.getSequence();
              stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.sequenceEditor.replaceMarkers({
                sheetAddress: sheet.address,
                markers: [
                  {
                    id: generateSequenceMarkerId(),
                    position: sheetSequence.position
                  }
                ],
                snappingFunction: sheetSequence.closestGridPosition
              });
            });
          }
        }
      ];
    }
  });
}
var import_dataverse43, import_react146, Container35, Rod, Thumb, Squinch, Tooltip3, Playhead, Playhead_default;
var init_Playhead = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/Playhead.tsx"() {
    init_RoomToClick();
    init_useDrag();
    init_useRefAndState();
    init_src();
    import_dataverse43 = __toModule(require("@theatre/dataverse"));
    init_clamp();
    import_react146 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SequenceEditorPanel();
    init_FrameStampPositionProvider();
    init_css();
    init_usePopover();
    init_BasicPopover();
    init_PlayheadPositionPopover();
    init_useKeyboardShortcuts();
    init_PointerEventsHandler();
    init_useContextMenu();
    init_getStudio();
    init_ids();
    init_DopeSnap();
    init_KeyframeSnapTarget();
    Container35 = styled_components_browser_esm_default.div`
  --thumbColor: #00e0ff;
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  z-index: ${() => zIndexes.playhead};
  pointer-events: none;

  display: ${(props) => props.isVisible ? "block" : "none"};
`;
    Rod = styled_components_browser_esm_default.div`
  position: absolute;
  top: 8px;
  width: 0;
  height: calc(100% - 8px);
  border-left: 1px solid #27e0fd;
  z-index: 10;
  pointer-events: none;

  #pointer-root.draggingPositionInSequenceEditor &:not(.seeking) {
    /* pointer-events: auto; */
    /* cursor: var(${lockedCursorCssVarName}); */

    &:after {
      position: absolute;
      inset: -8px;
      display: block;
      content: ' ';
    }
  }
`;
    Thumb = styled_components_browser_esm_default.div`
  background-color: var(--thumbColor);
  position: absolute;
  width: 5px;
  height: 13px;
  top: -4px;
  left: -2px;
  z-index: 11;
  cursor: ew-resize;
  --sunblock-color: #1f2b2b;

  ${pointerEventsAutoInNormalMode};

  ${Container35}.seeking > & {
    pointer-events: none !important;
  }

  #pointer-root.draggingPositionInSequenceEditor
    ${Container35}:not(.seeking)
    > & {
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});
  }

  ${Container35}.playheadattachedtofocusrange > & {
    top: -8px;
    --sunblock-color: #005662;
    &:before,
    &:after {
      border-bottom-width: 8px;
    }
  }

  &:before {
    position: absolute;
    display: block;
    content: ' ';
    left: -2px;
    width: 0;
    height: 0;
    border-bottom: 4px solid var(--sunblock-color);
    border-left: 2px solid transparent;
  }

  &:after {
    position: absolute;
    display: block;
    content: ' ';
    right: -2px;
    width: 0;
    height: 0;
    border-bottom: 4px solid var(--sunblock-color);
    border-right: 2px solid transparent;
  }
`;
    Squinch = styled_components_browser_esm_default.div`
  position: absolute;
  left: 1px;
  right: 1px;
  top: 13px;
  border-top: 3px solid var(--thumbColor);
  border-right: 1px solid transparent;
  border-left: 1px solid transparent;
  pointer-events: none;

  /* ${Container35}.playheadattachedtofocusrange & {
    top: 10px;
    &:before,
    &:after {
      height: 15px;
    }
  } */

  &:before {
    position: absolute;
    display: block;
    content: ' ';
    top: -4px;
    left: -2px;
    height: 8px;
    width: 2px;
    background: none;
    border-radius: 0 100% 0 0;
    border-top: 1px solid var(--thumbColor);
    border-right: 1px solid var(--thumbColor);
  }

  &:after {
    position: absolute;
    display: block;
    content: ' ';
    top: -4px;
    right: -2px;
    height: 8px;
    width: 2px;
    background: none;
    border-radius: 100% 0 0 0;
    border-top: 1px solid var(--thumbColor);
    border-left: 1px solid var(--thumbColor);
  }
`;
    Tooltip3 = styled_components_browser_esm_default.div`
  display: none;
  position: absolute;
  top: -20px;
  left: 4px;
  padding: 0 2px;
  transform: translateX(-50%);
  background: #1a1a1a;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  ${Thumb}:hover &, ${Container35}.seeking & {
    display: block;
  }
`;
    Playhead = ({
      layoutP
    }) => {
      const [thumbRef, thumbNode] = useRefAndState(null);
      const {
        node: popoverNode,
        toggle: togglePopover,
        close: closePopover
      } = usePopover({ debugName: "Playhead" }, () => {
        return /* @__PURE__ */ import_react146.default.createElement(BasicPopover_default, null, /* @__PURE__ */ import_react146.default.createElement(PlayheadPositionPopover_default, {
          layoutP,
          onRequestClose: closePopover
        }));
      });
      const gestureHandlers = (0, import_react146.useMemo)(() => {
        return {
          debugName: "RightOverlay/Playhead",
          onDragStart() {
            const sequence = (0, import_dataverse43.val)(layoutP.sheet).getSequence();
            const posBeforeSeek = sequence.position;
            const scaledSpaceToUnitSpace = (0, import_dataverse43.val)(layoutP.scaledSpace.toUnitSpace);
            const setIsSeeking = (0, import_dataverse43.val)(layoutP.seeker.setIsSeeking);
            setIsSeeking(true);
            snapToAll();
            return {
              onDrag(dx, _3, event) {
                var _a2;
                const deltaPos = scaledSpaceToUnitSpace(dx);
                sequence.position = (_a2 = DopeSnap_default.checkIfMouseEventSnapToPos(event, {
                  ignore: thumbNode
                })) != null ? _a2 : clamp_default(posBeforeSeek + deltaPos, 0, sequence.length);
              },
              onDragEnd(dragHappened) {
                setIsSeeking(false);
                snapToNone();
              },
              onClick(e2) {
                togglePopover(e2, thumbRef.current);
              }
            };
          }
        };
      }, [layoutP, thumbNode]);
      const [isDragging] = useDrag(thumbNode, gestureHandlers);
      useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "ew-resize");
      useLockFrameStampPosition(useVal(layoutP.seeker.isSeeking) || isDragging, -1);
      const [contextMenu] = usePlayheadContextMenu(thumbNode, {
        layoutP
      });
      return usePrism(() => {
        const isSeeking = (0, import_dataverse43.val)(layoutP.seeker.isSeeking);
        const sequence = (0, import_dataverse43.val)(layoutP.sheet).getSequence();
        const isPlayheadAttachedToFocusRange = (0, import_dataverse43.val)(getIsPlayheadAttachedToFocusRange(sequence));
        const posInUnitSpace = sequence.positionDerivation.getValue();
        const posInClippedSpace = (0, import_dataverse43.val)(layoutP.clippedSpace.fromUnitSpace)(posInUnitSpace);
        const isVisible2 = posInClippedSpace >= 0 && posInClippedSpace <= (0, import_dataverse43.val)(layoutP.clippedSpace.width);
        return /* @__PURE__ */ import_react146.default.createElement(import_react146.default.Fragment, null, contextMenu, popoverNode, /* @__PURE__ */ import_react146.default.createElement(Container35, __spreadValues({
          isVisible: isVisible2,
          style: { transform: `translate3d(${posInClippedSpace}px, 0, 0)` },
          className: `${isSeeking && "seeking"} ${isPlayheadAttachedToFocusRange && "playheadattachedtofocusrange"}`
        }, includeLockFrameStampAttrs("hide")), /* @__PURE__ */ import_react146.default.createElement(Thumb, __spreadValues({
          ref: thumbRef
        }, DopeSnap_default.includePositionSnapAttrs(posInUnitSpace)), /* @__PURE__ */ import_react146.default.createElement(RoomToClick_default, {
          room: 8
        }), /* @__PURE__ */ import_react146.default.createElement(Squinch, null), /* @__PURE__ */ import_react146.default.createElement(Tooltip3, null, sequence.positionFormatter.formatForPlayhead(sequence.closestGridPosition(posInUnitSpace)))), /* @__PURE__ */ import_react146.default.createElement(Rod, __spreadProps(__spreadValues({}, DopeSnap_default.includePositionSnapAttrs(posInUnitSpace)), {
          className: isSeeking ? "seeking" : ""
        }))));
      }, [layoutP, thumbRef, popoverNode]);
    };
    Playhead_default = Playhead;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/FocusRangeCurtains.tsx
var import_dataverse44, import_react148, divWidth, Curtain, FocusRangeCurtains, FocusRangeCurtains_default;
var init_FocusRangeCurtains = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/FocusRangeCurtains.tsx"() {
    import_dataverse44 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    init_TopStrip();
    import_react148 = __toModule(require_react());
    init_styled_components_browser_esm();
    divWidth = 1e3;
    Curtain = styled_components_browser_esm_default.div`
  position: absolute;
  top: ${topStripHeight}px;
  left: 0;
  opacity: 0.15;
  width: ${divWidth}px;
  transform-origin: top left;
  pointer-events: none;
  background-color: ${(props) => props.enabled ? "#000000" : "transparent"};
`;
    FocusRangeCurtains = ({ layoutP }) => {
      const existingRangeD = (0, import_react148.useMemo)(() => (0, import_dataverse44.prism)(() => {
        const { projectId, sheetId } = (0, import_dataverse44.val)(layoutP.sheet).address;
        const existingRange = (0, import_dataverse44.val)(getStudio().atomP.ahistoric.projects.stateByProjectId[projectId].stateBySheetId[sheetId].sequence.focusRange);
        return existingRange;
      }), [layoutP]);
      return usePrism(() => {
        const existingRange = existingRangeD.getValue();
        if (!existingRange || !existingRange.enabled)
          return null;
        const { range } = existingRange;
        const height2 = (0, import_dataverse44.val)(layoutP.rightDims.height) - topStripHeight;
        const unitSpaceToClippedSpace = (0, import_dataverse44.val)(layoutP.clippedSpace.fromUnitSpace);
        const clippedSpaceWidth = (0, import_dataverse44.val)(layoutP.clippedSpace.width);
        const els2 = [];
        {
          let startX = 0;
          let endX = unitSpaceToClippedSpace(existingRange.range.start);
          let scaleX, translateX;
          if (startX > endX) {
            translateX = 0;
            scaleX = 0;
          } else {
            if (endX > clippedSpaceWidth) {
              endX = clippedSpaceWidth;
            }
            translateX = startX;
            scaleX = (endX - startX) / divWidth;
          }
          els2.push({ translateX, scaleX });
        }
        {
          let startX = unitSpaceToClippedSpace(existingRange.range.end);
          let endX = clippedSpaceWidth;
          let scaleX, translateX;
          if (startX > endX) {
            translateX = 0;
            scaleX = 0;
          } else {
            if (startX < 0) {
              startX = 0;
            }
            translateX = startX;
            scaleX = (endX - startX) / divWidth;
          }
          els2.push({ translateX, scaleX });
        }
        return /* @__PURE__ */ import_react148.default.createElement(import_react148.default.Fragment, null, els2.map(({ translateX, scaleX }, i3) => /* @__PURE__ */ import_react148.default.createElement(Curtain, {
          key: `curtain-${i3}`,
          enabled: true,
          style: {
            height: `${height2}px`,
            transform: `translateX(${translateX}px) scaleX(${scaleX})`
          }
        })));
      }, [layoutP, existingRangeD]);
    };
    FocusRangeCurtains_default = FocusRangeCurtains;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/MarkerDot.tsx
function useMarkerContextMenu(node, options2) {
  return useContextMenu(node, {
    menuItems() {
      return [
        {
          label: "Remove marker",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.sequenceEditor.removeMarker({
                sheetAddress: options2.sheetAddress,
                markerId: options2.markerId
              });
            });
          }
        }
      ];
    }
  });
}
function useDragMarker(node, props) {
  const propsRef = (0, import_react150.useRef)(props);
  propsRef.current = props;
  const useDragOpts = (0, import_react150.useMemo)(() => {
    return {
      debugName: `MarkerDot/useDragMarker (${props.marker.id})`,
      onDragStart(_event) {
        const markerAtStartOfDrag = propsRef.current.marker;
        const toUnitSpace = (0, import_dataverse45.val)(props.layoutP.scaledSpace.toUnitSpace);
        let tempTransaction;
        snapToAll();
        return {
          onDrag(dx, _dy, event) {
            var _a2;
            const original = markerAtStartOfDrag;
            const newPosition = Math.max((_a2 = DopeSnap_default.checkIfMouseEventSnapToPos(event, {
              ignore: node
            })) != null ? _a2 : original.position + toUnitSpace(dx), 0);
            tempTransaction == null ? void 0 : tempTransaction.discard();
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.sequenceEditor.replaceMarkers({
                sheetAddress: (0, import_dataverse45.val)(props.layoutP.sheet.address),
                markers: [__spreadProps(__spreadValues({}, original), { position: newPosition })],
                snappingFunction: (0, import_dataverse45.val)(props.layoutP.sheet).getSequence().closestGridPosition
              });
            });
          },
          onDragEnd(dragHappened) {
            if (dragHappened)
              tempTransaction == null ? void 0 : tempTransaction.commit();
            else
              tempTransaction == null ? void 0 : tempTransaction.discard();
            snapToNone();
          }
        };
      }
    };
  }, []);
  const [isDragging] = useDrag(node, useDragOpts);
  useLockFrameStampPosition(isDragging, props.marker.position);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor draggingMarker", "ew-resize");
  return [isDragging];
}
var import_dataverse45, import_react150, MARKER_SIZE_W_PX, MARKER_SIZE_H_PX, MARKER_HOVER_SIZE_W_PX, MARKER_HOVER_SIZE_H_PX, MarkerDotContainer, MarkerVisualDotSVGContainer, MarkerVisualDot, HitZone2, MarkerDot, MarkerDot_default, MarkerDotVisible;
var init_MarkerDot = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/MarkerDot.tsx"() {
    import_dataverse45 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    init_PointerEventsHandler();
    init_useContextMenu();
    init_useRefAndState();
    import_react150 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameStampPositionProvider();
    init_useDrag();
    init_SequenceEditorPanel();
    init_DopeSnap();
    init_absoluteDims();
    init_DopeSnapHitZoneUI();
    init_KeyframeSnapTarget();
    MARKER_SIZE_W_PX = 12;
    MARKER_SIZE_H_PX = 12;
    MARKER_HOVER_SIZE_W_PX = MARKER_SIZE_W_PX * 2;
    MARKER_HOVER_SIZE_H_PX = MARKER_SIZE_H_PX * 2;
    MarkerDotContainer = styled_components_browser_esm_default.div`
  position: absolute;
  // below the sequence ruler "top bar"
  top: 18px;
  z-index: ${() => zIndexes.marker};
`;
    MarkerVisualDotSVGContainer = styled_components_browser_esm_default.div`
  position: absolute;
  ${absoluteDims(MARKER_SIZE_W_PX, MARKER_SIZE_H_PX)}
  pointer-events: none;
`;
    MarkerVisualDot = import_react150.default.memo(() => /* @__PURE__ */ import_react150.default.createElement(MarkerVisualDotSVGContainer, {
      children: /* @__PURE__ */ import_react150.default.createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react150.default.createElement("path", {
        d: "M12 5H0V7H2.71973L5.96237 10.2426L9.20501 7H12V5Z",
        fill: "#40AAA4"
      }))
    }));
    HitZone2 = styled_components_browser_esm_default.div`
  z-index: 1;
  cursor: ew-resize;

  ${DopeSnapHitZoneUI.CSS}

  // :not dragging marker to ensure that markers don't snap to other markers
  // this works because only one marker track (so this technique is not used by keyframes...)
  #pointer-root.draggingPositionInSequenceEditor:not(.draggingMarker) & {
    ${DopeSnapHitZoneUI.CSS_WHEN_SOMETHING_DRAGGING}
  }

  // "All instances of this component <Mark/> inside #pointer-root when it has the .draggingPositionInSequenceEditor class"
  // ref: https://styled-components.com/docs/basics#pseudoelements-pseudoselectors-and-nesting
  #pointer-root.draggingPositionInSequenceEditor:not(.draggingMarker) &,
  #pointer-root.draggingPositionInSequenceEditor
    &.${DopeSnapHitZoneUI.BEING_DRAGGED_CLASS} {
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});
  }

  &:hover
    + ${MarkerVisualDotSVGContainer},
    // notice , "or" in CSS
    &.${DopeSnapHitZoneUI.BEING_DRAGGED_CLASS}
    + ${MarkerVisualDotSVGContainer} {
    ${absoluteDims(MARKER_HOVER_SIZE_W_PX, MARKER_HOVER_SIZE_H_PX)}
  }
`;
    MarkerDot = ({ layoutP, markerId }) => {
      const sheetAddress = useVal(layoutP.sheet.address);
      const marker = useVal(getStudio().atomP.historic.projects.stateByProjectId[sheetAddress.projectId].stateBySheetId[sheetAddress.sheetId].sequenceEditor.markerSet.byId[markerId]);
      if (!marker) {
        return null;
      }
      const clippedSpaceWidth = useVal(layoutP.clippedSpace.width);
      const clippedSpaceFromUnitSpace = useVal(layoutP.clippedSpace.fromUnitSpace);
      const clippedSpaceMarkerX = clippedSpaceFromUnitSpace(marker.position);
      const outsideClipDims = clippedSpaceMarkerX <= 0 || clippedSpaceMarkerX > clippedSpaceWidth;
      const translateX = outsideClipDims ? -1e4 : clippedSpaceMarkerX;
      const scale = outsideClipDims ? 0 : 1;
      return /* @__PURE__ */ import_react150.default.createElement(MarkerDotContainer, {
        style: {
          transform: `translateX(${translateX}px) scale(${scale})`
        }
      }, /* @__PURE__ */ import_react150.default.createElement(MarkerDotVisible, {
        marker,
        layoutP
      }));
    };
    MarkerDot_default = MarkerDot;
    MarkerDotVisible = ({
      layoutP,
      marker
    }) => {
      const sheetAddress = useVal(layoutP.sheet.address);
      const [markRef, markNode] = useRefAndState(null);
      const [contextMenu] = useMarkerContextMenu(markNode, {
        sheetAddress,
        markerId: marker.id
      });
      const [isDragging] = useDragMarker(markNode, {
        layoutP,
        marker
      });
      return /* @__PURE__ */ import_react150.default.createElement(import_react150.default.Fragment, null, contextMenu, /* @__PURE__ */ import_react150.default.createElement(HitZone2, __spreadValues({
        ref: markRef
      }, DopeSnapHitZoneUI.reactProps({
        isDragging,
        position: marker.position
      }))), /* @__PURE__ */ import_react150.default.createElement(MarkerVisualDot, null));
    };
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/Markers.tsx
var import_react152, Markers, Markers_default;
var init_Markers = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/Markers.tsx"() {
    init_src();
    init_getStudio();
    import_react152 = __toModule(require_react());
    init_MarkerDot();
    Markers = ({
      layoutP
    }) => {
      const sheetAddress = useVal(layoutP.sheet.address);
      const markerSetP = getStudio().atomP.historic.projects.stateByProjectId[sheetAddress.projectId].stateBySheetId[sheetAddress.sheetId].sequenceEditor.markerSet;
      const markerAllIds = useVal(markerSetP.allIds);
      return /* @__PURE__ */ import_react152.default.createElement(import_react152.default.Fragment, null, markerAllIds && Object.keys(markerAllIds).map((markerId) => /* @__PURE__ */ import_react152.default.createElement(MarkerDot_default, {
        key: markerId,
        layoutP,
        markerId
      })));
    };
    Markers_default = Markers;
  }
});

// studio/src/panels/SequenceEditorPanel/RightOverlay/RightOverlay.tsx
var import_dataverse46, import_react154, Container36, RightOverlay, RightOverlay_default;
var init_RightOverlay = __esm({
  "studio/src/panels/SequenceEditorPanel/RightOverlay/RightOverlay.tsx"() {
    init_SequenceEditorPanel();
    init_src();
    import_dataverse46 = __toModule(require("@theatre/dataverse"));
    import_react154 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_LengthIndicator();
    init_FrameStamp();
    init_HorizontalScrollbar();
    init_Playhead();
    init_TopStrip();
    init_FocusRangeCurtains();
    init_Markers();
    Container36 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${() => zIndexes.rightOverlay};
  overflow: visible;
  pointer-events: none;
`;
    RightOverlay = ({ layoutP }) => {
      return usePrism(() => {
        const width = (0, import_dataverse46.val)(layoutP.rightDims.width);
        return /* @__PURE__ */ import_react154.default.createElement(Container36, {
          style: { width: width + "px" }
        }, /* @__PURE__ */ import_react154.default.createElement(Playhead_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(HorizontalScrollbar_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(FrameStamp_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(TopStrip_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(Markers_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(LengthIndicator_default, {
          layoutP
        }), /* @__PURE__ */ import_react154.default.createElement(FocusRangeCurtains_default, {
          layoutP
        }));
      }, [layoutP]);
    };
    RightOverlay_default = RightOverlay;
  }
});

// studio/src/panels/BasePanel/PanelDragZone.tsx
var import_react155, Container37, PanelDragZone, PanelDragZone_default;
var init_PanelDragZone = __esm({
  "studio/src/panels/BasePanel/PanelDragZone.tsx"() {
    init_useRefAndState();
    init_getStudio();
    init_useDrag();
    import_react155 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_BasePanel();
    init_PointerEventsHandler();
    init_lodash();
    init_common();
    Container37 = styled_components_browser_esm_default.div`
  cursor: move;
`;
    PanelDragZone = (props) => {
      const panelStuff = usePanel();
      const panelStuffRef = (0, import_react155.useRef)(panelStuff);
      panelStuffRef.current = panelStuff;
      const [ref, node] = useRefAndState(null);
      const dragOpts = (0, import_react155.useMemo)(() => {
        return {
          debugName: "PanelDragZone",
          lockCursorTo: "move",
          onDragStart() {
            const stuffBeforeDrag = panelStuffRef.current;
            let tempTransaction;
            const unlock = panelStuff.addBoundsHighlightLock();
            return {
              onDrag(dx, dy) {
                const newDims = __spreadProps(__spreadValues({}, stuffBeforeDrag.dims), {
                  top: clamp_default(stuffBeforeDrag.dims.top + dy, 0, window.innerHeight - visibleSize),
                  left: clamp_default(stuffBeforeDrag.dims.left + dx, -stuffBeforeDrag.dims.width + visibleSize, window.innerWidth - visibleSize)
                });
                const position2 = panelDimsToPanelPosition(newDims, {
                  width: window.innerWidth,
                  height: window.innerHeight
                });
                tempTransaction == null ? void 0 : tempTransaction.discard();
                tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                  stateEditors2.studio.historic.panelPositions.setPanelPosition({
                    position: position2,
                    panelId: stuffBeforeDrag.panelId
                  });
                });
              },
              onDragEnd(dragHappened) {
                unlock();
                if (dragHappened) {
                  tempTransaction == null ? void 0 : tempTransaction.commit();
                } else {
                  tempTransaction == null ? void 0 : tempTransaction.discard();
                }
              }
            };
          }
        };
      }, []);
      const [isDragging] = useDrag(node, dragOpts);
      useCssCursorLock(isDragging, "dragging", "move");
      const [onMouseEnter, onMouseLeave] = (0, import_react155.useMemo)(() => {
        let unlock;
        return [
          function onMouseEnter2() {
            if (unlock) {
              const u3 = unlock;
              unlock = void 0;
              u3();
            }
            unlock = panelStuff.addBoundsHighlightLock();
          },
          function onMouseLeave2() {
            if (unlock) {
              const u3 = unlock;
              unlock = void 0;
              u3();
            }
          }
        ];
      }, []);
      return /* @__PURE__ */ import_react155.default.createElement(Container37, __spreadProps(__spreadValues({}, props), {
        ref,
        onMouseEnter,
        onMouseLeave
      }));
    };
    PanelDragZone_default = PanelDragZone;
  }
});

// studio/src/panels/BasePanel/PanelResizeHandle.tsx
var import_react156, Base, Side, Horizontal, Top, Bottom, Vertical, Left3, Right, Angle, TopLeft, TopRight, BottomLeft, BottomRight, els, cursors, PanelResizeHandle, PanelResizeHandle_default;
var init_PanelResizeHandle = __esm({
  "studio/src/panels/BasePanel/PanelResizeHandle.tsx"() {
    init_useRefAndState();
    init_getStudio();
    init_useDrag();
    init_polished_esm();
    import_react156 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_BasePanel();
    init_css();
    init_lodash();
    init_common();
    Base = styled_components_browser_esm_default.div`
  position: absolute;
  ${pointerEventsAutoInNormalMode};
  &:after {
    position: absolute;
    inset: -5px;
    display: block;
    content: ' ';
  }

  opacity: 0;
  background-color: #478698;

  &.isHighlighted {
    opacity: 0.7;
  }

  &.isDragging {
    opacity: 1;
    /* background-color: ${curriedLighten(0.2, "#478698")}; */
  }

  &:hover {
    opacity: 1;
  }
`;
    Side = styled_components_browser_esm_default(Base)`
  /**
  The horizintal/vertical resize handles have z-index:-1 and are offset 1px outside of the panel
  to make sure they don't occlude any element that pops out of the panel (like the Playhead in SequenceEditorPanel).

  This means that panels will always need an extra 1px margin for their resize handles to be visible, but that's not a problem
  that we have to deal with right now (if it is at all a problem).
  
   */
  z-index: -1;
`;
    Horizontal = styled_components_browser_esm_default(Side)`
  left: 0px;
  right: 0px;
  height: 1px;
`;
    Top = styled_components_browser_esm_default(Horizontal)`
  top: -1px;
`;
    Bottom = styled_components_browser_esm_default(Horizontal)`
  bottom: -1px;
`;
    Vertical = styled_components_browser_esm_default(Side)`
  z-index: -1;
  top: -1px;
  bottom: -1px;
  width: 1px;
`;
    Left3 = styled_components_browser_esm_default(Vertical)`
  left: -1px;
`;
    Right = styled_components_browser_esm_default(Vertical)`
  right: -1px;
`;
    Angle = styled_components_browser_esm_default(Base)`
  // The angles have z-index: 10 to make sure they _do_ occlude other elements in the panel.
  z-index: 10;
  width: 8px;
  height: 8px;
`;
    TopLeft = styled_components_browser_esm_default(Angle)`
  top: 0;
  left: 0;
`;
    TopRight = styled_components_browser_esm_default(Angle)`
  top: 0;
  right: 0;
`;
    BottomLeft = styled_components_browser_esm_default(Angle)`
  bottom: 0;
  left: 0;
`;
    BottomRight = styled_components_browser_esm_default(Angle)`
  bottom: 0;
  right: 0;
`;
    els = {
      Top,
      TopLeft,
      TopRight,
      Bottom,
      BottomLeft,
      BottomRight,
      Left: Left3,
      Right
    };
    cursors = {
      Top: "ns-resize",
      Bottom: "ns-resize",
      Left: "ew-resize",
      Right: "ew-resize",
      TopLeft: "nw-resize",
      TopRight: "ne-resize",
      BottomLeft: "sw-resize",
      BottomRight: "se-resize"
    };
    PanelResizeHandle = ({ which }) => {
      const panelStuff = usePanel();
      const panelStuffRef = (0, import_react156.useRef)(panelStuff);
      panelStuffRef.current = panelStuff;
      const [ref, node] = useRefAndState(null);
      const dragOpts = (0, import_react156.useMemo)(() => {
        return {
          debugName: "PanelResizeHandle",
          lockCursorTo: cursors[which],
          onDragStart() {
            let tempTransaction;
            const stuffBeforeDrag = panelStuffRef.current;
            const unlock = panelStuff.addBoundsHighlightLock();
            return {
              onDrag(dx, dy) {
                const newDims = __spreadValues({}, stuffBeforeDrag.dims);
                if (which.startsWith("Bottom")) {
                  newDims.height = Math.max(newDims.height + dy, stuffBeforeDrag.minDims.height);
                } else if (which.startsWith("Top")) {
                  const bottom = newDims.top + newDims.height;
                  const top = clamp_default(newDims.top + dy, 0, Math.min(bottom - stuffBeforeDrag.minDims.height, window.innerHeight - visibleSize));
                  const height2 = bottom - top;
                  newDims.height = height2;
                  newDims.top = top;
                }
                if (which.endsWith("Left")) {
                  const right = newDims.left + newDims.width;
                  const left = Math.min(newDims.left + dx, Math.min(right - stuffBeforeDrag.minDims.width, window.innerWidth - visibleSize));
                  const width = right - left;
                  newDims.width = width;
                  newDims.left = left;
                } else if (which.endsWith("Right")) {
                  newDims.width = Math.max(newDims.width + dx, Math.max(stuffBeforeDrag.minDims.width, visibleSize - stuffBeforeDrag.dims.left));
                }
                const position2 = panelDimsToPanelPosition(newDims, {
                  width: window.innerWidth,
                  height: window.innerHeight
                });
                tempTransaction == null ? void 0 : tempTransaction.discard();
                tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                  stateEditors2.studio.historic.panelPositions.setPanelPosition({
                    position: position2,
                    panelId: stuffBeforeDrag.panelId
                  });
                });
              },
              onDragEnd(dragHappened) {
                unlock();
                if (dragHappened) {
                  tempTransaction == null ? void 0 : tempTransaction.commit();
                } else {
                  tempTransaction == null ? void 0 : tempTransaction.discard();
                }
              }
            };
          }
        };
      }, [which]);
      const [isDragging] = useDrag(node, dragOpts);
      const Comp = els[which];
      const isOnCorner = which.length <= 6;
      return /* @__PURE__ */ import_react156.default.createElement(Comp, {
        ref,
        className: [
          isDragging ? "isDragging" : "",
          panelStuff.boundsHighlighted && isOnCorner ? "isHighlighted" : ""
        ].join(" "),
        style: { cursor: cursors[which] }
      });
    };
    PanelResizeHandle_default = PanelResizeHandle;
  }
});

// studio/src/panels/BasePanel/PanelResizers.tsx
var import_react157, PanelResizers, PanelResizers_default;
var init_PanelResizers = __esm({
  "studio/src/panels/BasePanel/PanelResizers.tsx"() {
    import_react157 = __toModule(require_react());
    init_PanelResizeHandle();
    PanelResizers = (props) => {
      return /* @__PURE__ */ import_react157.default.createElement(import_react157.default.Fragment, null, /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "Bottom"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "Top"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "Left"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "Right"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "TopLeft"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "TopRight"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "BottomLeft"
      }), /* @__PURE__ */ import_react157.default.createElement(PanelResizeHandle_default, {
        which: "BottomRight"
      }));
    };
    PanelResizers_default = PanelResizers;
  }
});

// studio/src/panels/BasePanel/PanelWrapper.tsx
var import_react158, Container38, PanelWrapper, PanelWrapper_default;
var init_PanelWrapper = __esm({
  "studio/src/panels/BasePanel/PanelWrapper.tsx"() {
    init_css();
    import_react158 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_BasePanel();
    init_PanelResizers();
    Container38 = styled_components_browser_esm_default.div`
  position: absolute;
  user-select: none;
  box-sizing: border-box;
  ${pointerEventsAutoInNormalMode};
  /* box-shadow: 1px 2px 10px -5px black; */

  z-index: 1000;
`;
    PanelWrapper = import_react158.default.forwardRef((props, ref) => {
      const stuff = usePanel();
      const _a2 = props, { style, children } = _a2, otherProps = __objRest(_a2, ["style", "children"]);
      return /* @__PURE__ */ import_react158.default.createElement(Container38, __spreadProps(__spreadValues({
        ref
      }, otherProps), {
        style: __spreadValues({
          width: stuff.dims.width + "px",
          height: stuff.dims.height + "px",
          top: stuff.dims.top + "px",
          left: stuff.dims.left + "px"
        }, style != null ? style : {})
      }), /* @__PURE__ */ import_react158.default.createElement(PanelResizers_default, null), children);
    });
    PanelWrapper_default = PanelWrapper;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditorToggle.tsx
var import_dataverse47, import_react160, Container39, GraphEditorToggle, GraphEditorToggle_default;
var init_GraphEditorToggle = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditorToggle.tsx"() {
    import_dataverse47 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    import_react160 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_all();
    init_FrameStampPositionProvider();
    Container39 = styled_components_browser_esm_default.button`
  outline: none;
  background-color: #1c1d21;
  border: 1px solid #191919;
  border-radius: 2px;
  display: flex;
  bottom: 14px;
  right: 8px;
  z-index: 1;
  position: absolute;

  padding: 4px 8px;
  display: flex;
  color: #656d77;
  line-height: 20px;
  font-size: 10px;

  &:hover {
    color: white;
  }

  & > svg {
    transition: transform 0.3s;
    transform: rotateZ(0deg);
  }

  &:hover > svg {
    transform: rotateZ(-20deg);
  }

  &.open > svg {
    transform: rotateZ(-180deg);
  }

  &.open:hover > svg {
    transform: rotateZ(-160deg);
  }
`;
    GraphEditorToggle = ({ layoutP }) => {
      const isOpen = useVal(layoutP.graphEditorDims.isOpen);
      const toggle = (0, import_react160.useCallback)(() => {
        const isOpen2 = (0, import_dataverse47.val)(layoutP.graphEditorDims.isOpen);
        getStudio().transaction(({ stateEditors: stateEditors2 }) => {
          stateEditors2.studio.historic.panels.sequenceEditor.graphEditor.setIsOpen({
            isOpen: !isOpen2
          });
        });
      }, [layoutP]);
      return /* @__PURE__ */ import_react160.default.createElement(Container39, __spreadValues({
        onClick: toggle,
        title: "Toggle graph editor",
        className: isOpen ? "open" : ""
      }, includeLockFrameStampAttrs("hide")), /* @__PURE__ */ import_react160.default.createElement(VscTriangleUp, null));
    };
    GraphEditorToggle_default = GraphEditorToggle;
  }
});

// studio/src/panels/SequenceEditorPanel/SequenceEditorPanel.tsx
var import_dataverse48, import_react162, Container40, LeftBackground, zIndexes, Header_Container, defaultPosition, minDims, SequenceEditorPanel, Content, Header3, SequenceEditorPanel_default, preventHorizontalWheelEvents;
var init_SequenceEditorPanel = __esm({
  "studio/src/panels/SequenceEditorPanel/SequenceEditorPanel.tsx"() {
    init_selectors();
    init_src();
    init_valToAtom();
    import_dataverse48 = __toModule(require("@theatre/dataverse"));
    import_react162 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_DopeSheet();
    init_GraphEditor();
    init_layout();
    init_RightOverlay();
    init_BasePanel();
    init_PanelDragZone();
    init_PanelWrapper();
    init_FrameStampPositionProvider();
    init_instanceTypes();
    init_lodash();
    init_GraphEditorToggle();
    init_common();
    init_usePresence();
    Container40 = styled_components_browser_esm_default(PanelWrapper_default)`
  z-index: ${panelZIndexes.sequenceEditorPanel};
  box-shadow: 2px 2px 0 rgb(0 0 0 / 11%);
`;
    LeftBackground = styled_components_browser_esm_default.div`
  background-color: rgba(40, 43, 47, 0.99);
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  pointer-events: none;
`;
    zIndexes = (() => {
      const s3 = {
        rightBackground: 0,
        scrollableArea: 0,
        rightOverlay: 0,
        lengthIndicatorCover: 0,
        lengthIndicatorStrip: 0,
        playhead: 0,
        currentFrameStamp: 0,
        marker: 0,
        horizontalScrollbar: 0
      };
      let i3 = -1;
      for (const key of Object.keys(s3)) {
        s3[key] = i3;
        i3++;
      }
      return s3;
    })();
    Header_Container = styled_components_browser_esm_default(PanelDragZone_default)`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`;
    defaultPosition = {
      edges: {
        left: { from: "screenLeft", distance: 0.1 },
        right: { from: "screenRight", distance: 0.2 },
        top: { from: "screenBottom", distance: 0.4 },
        bottom: { from: "screenBottom", distance: 0.01 }
      }
    };
    minDims = { width: 800, height: 200 };
    SequenceEditorPanel = (props) => {
      return /* @__PURE__ */ import_react162.default.createElement(BasePanel_default, {
        panelId: "sequenceEditor",
        defaultPosition,
        minDims
      }, /* @__PURE__ */ import_react162.default.createElement(Content, null));
    };
    Content = () => {
      const { dims } = usePanel();
      const [containerNode, setContainerNode] = (0, import_react162.useState)(null);
      usePresenceListenersOnRootElement(containerNode);
      return usePrism(() => {
        const panelSize = import_dataverse48.prism.memo("panelSize", () => {
          const width = dims.width;
          const height2 = dims.height;
          return {
            width,
            height: height2,
            widthWithoutBorder: width - 2,
            heightWithoutBorder: height2 - 4,
            screenX: dims.left,
            screenY: dims.top
          };
        }, [dims]);
        const selectedSheets = uniq_default(getOutlineSelection().filter((s3) => isSheet(s3) || isSheetObject(s3)).map((s3) => isSheetObject(s3) ? s3.sheet : s3));
        const selectedTemplates = uniq_default(selectedSheets.map((s3) => s3.template));
        if (selectedTemplates.length !== 1)
          return /* @__PURE__ */ import_react162.default.createElement(import_react162.default.Fragment, null);
        const sheet = selectedSheets[0];
        if (!sheet)
          return /* @__PURE__ */ import_react162.default.createElement(import_react162.default.Fragment, null);
        const panelSizeP = valToAtom("panelSizeP", panelSize).pointer;
        const key = import_dataverse48.prism.memo("key", () => JSON.stringify(sheet.address), [sheet]);
        const layoutP = import_dataverse48.prism.memo("layout", () => {
          return sequenceEditorPanelLayout(sheet, panelSizeP);
        }, [sheet, panelSizeP]).getValue();
        if ((0, import_dataverse48.val)(layoutP.tree.children).length === 0)
          return /* @__PURE__ */ import_react162.default.createElement(import_react162.default.Fragment, null);
        const containerRef = import_dataverse48.prism.memo("containerRef", preventHorizontalWheelEvents, []);
        const graphEditorAvailable = (0, import_dataverse48.val)(layoutP.graphEditorDims.isAvailable);
        const graphEditorOpen = (0, import_dataverse48.val)(layoutP.graphEditorDims.isOpen);
        return /* @__PURE__ */ import_react162.default.createElement(Container40, {
          ref: (elt) => {
            containerRef(elt);
            if (elt !== containerNode) {
              setContainerNode(elt);
            }
          }
        }, /* @__PURE__ */ import_react162.default.createElement(LeftBackground, {
          style: { width: `${(0, import_dataverse48.val)(layoutP.leftDims.width)}px` }
        }), /* @__PURE__ */ import_react162.default.createElement(FrameStampPositionProvider_default, {
          layoutP
        }, /* @__PURE__ */ import_react162.default.createElement(Header3, {
          layoutP
        }), /* @__PURE__ */ import_react162.default.createElement(DopeSheet_default, {
          key: key + "-dopeSheet",
          layoutP
        }), graphEditorOpen && /* @__PURE__ */ import_react162.default.createElement(GraphEditor_default, {
          key: key + "-graphEditor",
          layoutP
        }), graphEditorAvailable && /* @__PURE__ */ import_react162.default.createElement(GraphEditorToggle_default, {
          layoutP
        }), /* @__PURE__ */ import_react162.default.createElement(RightOverlay_default, {
          layoutP
        })));
      }, [dims, containerNode]);
    };
    Header3 = ({
      layoutP
    }) => {
      return usePrism(() => {
        const sheet = (0, import_dataverse48.val)(layoutP.sheet);
        return /* @__PURE__ */ import_react162.default.createElement(Header_Container, {
          style: {
            width: (0, import_dataverse48.val)(layoutP.leftDims.width)
          }
        }, /* @__PURE__ */ import_react162.default.createElement(TitleBar, null, /* @__PURE__ */ import_react162.default.createElement(TitleBar_Piece, null, sheet.address.sheetId, " "), /* @__PURE__ */ import_react162.default.createElement(TitleBar_Punctuation, null, ":", "\xA0"), /* @__PURE__ */ import_react162.default.createElement(TitleBar_Piece, null, sheet.address.sheetInstanceId, " "), /* @__PURE__ */ import_react162.default.createElement(TitleBar_Punctuation, null, "\xA0", ">", "\xA0"), /* @__PURE__ */ import_react162.default.createElement(TitleBar_Piece, null, "Sequence")));
      }, [layoutP]);
    };
    SequenceEditorPanel_default = SequenceEditorPanel;
    preventHorizontalWheelEvents = () => {
      let lastNode = null;
      const listenerOptions = {
        passive: false,
        capture: false
      };
      const receiveWheelEvent = (event) => {
        if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
          event.preventDefault();
          event.stopPropagation();
        }
      };
      return (node) => {
        if (lastNode !== node && lastNode) {
          lastNode.removeEventListener("wheel", receiveWheelEvent, listenerOptions);
        }
        lastNode = node;
        if (node) {
          node.addEventListener("wheel", receiveWheelEvent, listenerOptions);
        }
      };
    };
  }
});

// studio/src/panels/SequenceEditorPanel/VerticalScrollContainer.tsx
var import_react163, Container41, ctx2, useReceiveVerticalWheelEvent, VerticalScrollContainer, VerticalScrollContainer_default;
var init_VerticalScrollContainer = __esm({
  "studio/src/panels/SequenceEditorPanel/VerticalScrollContainer.tsx"() {
    init_noop2();
    import_react163 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SequenceEditorPanel();
    Container41 = styled_components_browser_esm_default.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  z-index: ${() => zIndexes.scrollableArea};

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`;
    ctx2 = (0, import_react163.createContext)(noop_default2);
    useReceiveVerticalWheelEvent = () => (0, import_react163.useContext)(ctx2);
    VerticalScrollContainer = (props) => {
      const ref = (0, import_react163.useRef)(null);
      const receiveVerticalWheelEvent = (0, import_react163.useCallback)((event) => {
        ref.current.scrollBy(0, event.deltaY);
      }, []);
      return /* @__PURE__ */ import_react163.default.createElement(ctx2.Provider, {
        value: receiveVerticalWheelEvent
      }, /* @__PURE__ */ import_react163.default.createElement(Container41, {
        ref
      }, props.children));
    };
    VerticalScrollContainer_default = VerticalScrollContainer;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/HorizontallyScrollableArea.tsx
function useDragPlayheadHandlers(layoutP, containerEl) {
  const handlers = (0, import_react165.useMemo)(() => {
    return {
      debugName: "HorizontallyScrollableArea",
      onDragStart(event) {
        if (event.target instanceof HTMLInputElement) {
          return false;
        }
        if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
          return false;
        }
        if (event.composedPath().some((el) => el instanceof HTMLElement && el.draggable === true)) {
          return false;
        }
        const initialPositionInClippedSpace = event.clientX - containerEl.getBoundingClientRect().left;
        const initialPositionInUnitSpace = clamp_default((0, import_dataverse49.val)(layoutP.clippedSpace.toUnitSpace)(initialPositionInClippedSpace), 0, Infinity);
        const setIsSeeking = (0, import_dataverse49.val)(layoutP.seeker.setIsSeeking);
        const sequence = (0, import_dataverse49.val)(layoutP.sheet).getSequence();
        sequence.position = initialPositionInUnitSpace;
        const posBeforeSeek = initialPositionInUnitSpace;
        const scaledSpaceToUnitSpace = (0, import_dataverse49.val)(layoutP.scaledSpace.toUnitSpace);
        setIsSeeking(true);
        snapToAll();
        return {
          onDrag(dx, _3, event2) {
            const deltaPos = scaledSpaceToUnitSpace(dx);
            const unsnappedPos = clamp_default(posBeforeSeek + deltaPos, 0, sequence.length);
            let newPosition = unsnappedPos;
            const snapPos = DopeSnap_default.checkIfMouseEventSnapToPos(event2, {});
            if (snapPos != null) {
              newPosition = snapPos;
            }
            sequence.position = newPosition;
          },
          onDragEnd() {
            setIsSeeking(false);
            snapToNone();
          }
        };
      }
    };
  }, [layoutP, containerEl]);
  const [isDragging] = useDrag(containerEl, handlers);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "ew-resize");
}
function useHandlePanAndZoom(layoutP, node) {
  const receiveVerticalWheelEvent = useReceiveVerticalWheelEvent();
  (0, import_react165.useLayoutEffect)(() => {
    if (!node)
      return;
    const receiveWheelEvent = (event) => {
      if (event.ctrlKey) {
        event.preventDefault();
        event.stopPropagation();
        const pivotPointInClippedSpace = event.clientX - node.getBoundingClientRect().left;
        const pivotPointInUnitSpace = (0, import_dataverse49.val)(layoutP.clippedSpace.toUnitSpace)(pivotPointInClippedSpace);
        const oldRange = (0, import_dataverse49.val)(layoutP.clippedSpace.range);
        const delta = normalize(event.deltaY, [-50, 50]);
        const scaleFactor = 1 + delta * 0.03;
        const newRange = mapValues_default(oldRange, (originalPos) => {
          return (originalPos - pivotPointInUnitSpace) * scaleFactor + pivotPointInUnitSpace;
        });
        const sequenceLength = (0, import_dataverse49.val)(layoutP.sheet).getSequence().length;
        const maxEnd = sequenceLength + sequenceLength * 0.25;
        (0, import_dataverse49.val)(layoutP.clippedSpace.setRange)(normalizeRange(newRange, [0, maxEnd]));
        return;
      } else if (event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        const sequenceLength = (0, import_dataverse49.val)(layoutP.sheet).getSequence().length;
        const oldRange = (0, import_dataverse49.val)(layoutP.clippedSpace.range);
        const windowSize = oldRange.end - oldRange.start;
        const speed = windowSize / sequenceLength;
        const delta = normalize(event.deltaY || event.deltaX, [-50, 50]);
        const scaleFactor = delta * 0.05 * speed;
        const newRange = mapValues_default(oldRange, (originalPos) => originalPos + scaleFactor);
        (0, import_dataverse49.val)(layoutP.clippedSpace.setRange)(newRange);
        return;
      } else {
        receiveVerticalWheelEvent(event);
        event.preventDefault();
        event.stopPropagation();
        const scaledSpaceToUnitSpace = (0, import_dataverse49.val)(layoutP.scaledSpace.toUnitSpace);
        const deltaPos = scaledSpaceToUnitSpace(event.deltaX * 1);
        const oldRange = (0, import_dataverse49.val)(layoutP.clippedSpace.range);
        const newRange = mapValues_default(oldRange, (p3) => p3 + deltaPos);
        const setRange = (0, import_dataverse49.val)(layoutP.clippedSpace.setRange);
        setRange(newRange);
        return;
      }
    };
    const listenerOptions = {
      capture: true,
      passive: false
    };
    node.addEventListener("wheel", receiveWheelEvent, listenerOptions);
    return () => {
      node.removeEventListener("wheel", receiveWheelEvent, listenerOptions);
    };
  }, [node, layoutP]);
  useDrag(node, (0, import_react165.useMemo)(() => {
    return {
      onDragStart(e2) {
        const oldRange = (0, import_dataverse49.val)(layoutP.clippedSpace.range);
        const setRange = (0, import_dataverse49.val)(layoutP.clippedSpace.setRange);
        const scaledSpaceToUnitSpace = (0, import_dataverse49.val)(layoutP.scaledSpace.toUnitSpace);
        e2.preventDefault();
        e2.stopPropagation();
        return {
          onDrag(dx, dy, _3, __, deltaYFromLastEvent) {
            receiveVerticalWheelEvent({ deltaY: -deltaYFromLastEvent });
            const delta = -scaledSpaceToUnitSpace(dx);
            const newRange = mapValues_default(oldRange, (originalPos) => originalPos + delta);
            setRange(newRange);
          }
        };
      },
      debugName: "HorizontallyScrollableArea Middle Button Drag",
      buttons: [1],
      lockCSSCursorTo: "grabbing"
    };
  }, [layoutP]));
}
function normalize(value, [min, max]) {
  return Math.max(Math.min(value, max), min);
}
function normalizeRange(range, minMax) {
  return mapValues_default(range, (pos) => normalize(pos, minMax));
}
function useUpdateScrollFromClippedSpaceRange(layoutP, node) {
  (0, import_react165.useLayoutEffect)(() => {
    if (!node)
      return;
    const d3 = (0, import_dataverse49.prism)(() => {
      const range = (0, import_dataverse49.val)(layoutP.clippedSpace.range);
      const rangeStartInScaledSpace = (0, import_dataverse49.val)(layoutP.scaledSpace.fromUnitSpace)(range.start);
      return rangeStartInScaledSpace;
    });
    const update = () => {
      const rangeStartInScaledSpace = d3.getValue();
      node.scrollLeft = rangeStartInScaledSpace;
    };
    const untap = d3.changesWithoutValues().tap(update);
    update();
    const timeout = setTimeout(update, 100);
    return () => {
      clearTimeout(timeout);
      untap();
    };
  }, [layoutP, node]);
}
var import_dataverse49, import_react165, Container42, HorizontallyScrollableArea, HorizontallyScrollableArea_default;
var init_HorizontallyScrollableArea = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/HorizontallyScrollableArea.tsx"() {
    init_useDrag();
    init_useRefAndState();
    init_src();
    import_dataverse49 = __toModule(require("@theatre/dataverse"));
    init_lodash();
    import_react165 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_VerticalScrollContainer();
    init_css();
    init_PointerEventsHandler();
    init_DopeSnap();
    init_KeyframeSnapTarget();
    Container42 = styled_components_browser_esm_default.div`
  position: absolute;

  right: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  ${pointerEventsAutoInNormalMode};

  // hide the scrollbar on Gecko
  scrollbar-width: none;

  // hide the scrollbar on Webkit/Blink
  &::-webkit-scrollbar {
    display: none;
  }
`;
    HorizontallyScrollableArea = import_react165.default.memo(({ layoutP, children, height: height2 }) => {
      const { width, unitSpaceToScaledSpaceMultiplier } = usePrism(() => ({
        width: (0, import_dataverse49.val)(layoutP.rightDims.width),
        unitSpaceToScaledSpaceMultiplier: (0, import_dataverse49.val)(layoutP.scaledSpace.fromUnitSpace)(1)
      }), [layoutP]);
      const [containerRef, containerNode] = useRefAndState(null);
      useHandlePanAndZoom(layoutP, containerNode);
      useDragPlayheadHandlers(layoutP, containerNode);
      useUpdateScrollFromClippedSpaceRange(layoutP, containerNode);
      return /* @__PURE__ */ import_react165.default.createElement(Container42, {
        ref: containerRef,
        style: {
          width: width + "px",
          height: height2 + "px",
          "--unitSpaceToScaledSpaceMultiplier": unitSpaceToScaledSpaceMultiplier
        }
      }, children);
    });
    HorizontallyScrollableArea_default = HorizontallyScrollableArea;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/Row.tsx
var import_react166, RightRowContainer, RightRowNodeWrapper, RightRowChildren, RightRow, Row_default;
var init_Row = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/Row.tsx"() {
    import_react166 = __toModule(require_react());
    init_styled_components_browser_esm();
    RightRowContainer = styled_components_browser_esm_default.li`
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
  position: relative;
`;
    RightRowNodeWrapper = styled_components_browser_esm_default.div`
  box-sizing: border-box;
  width: 100%;
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: ' ';
    left: -40px;
    top: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    border-bottom: 1px solid #252b3869;
    background: ${(props) => props.isEven ? "transparent" : "#6b8fb505"};
  }
`;
    RightRowChildren = styled_components_browser_esm_default.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
    RightRow = ({ leaf, children, node, isCollapsed }) => {
      const hasChildren = Array.isArray(children) && children.length > 0;
      return leaf.shouldRender ? /* @__PURE__ */ import_react166.default.createElement(RightRowContainer, null, /* @__PURE__ */ import_react166.default.createElement(RightRowNodeWrapper, {
        style: { height: leaf.nodeHeight + "px" },
        isEven: leaf.n % 2 === 0
      }, node), hasChildren && /* @__PURE__ */ import_react166.default.createElement(RightRowChildren, null, children)) : null;
    };
    Row_default = RightRow;
  }
});

// ../node_modules/fuzzy/lib/fuzzy.js
var require_fuzzy = __commonJS({
  "../node_modules/fuzzy/lib/fuzzy.js"(exports2, module2) {
    (function() {
      var root3 = this;
      var fuzzy2 = {};
      if (typeof exports2 !== "undefined") {
        module2.exports = fuzzy2;
      } else {
        root3.fuzzy = fuzzy2;
      }
      fuzzy2.simpleFilter = function(pattern, array) {
        return array.filter(function(str) {
          return fuzzy2.test(pattern, str);
        });
      };
      fuzzy2.test = function(pattern, str) {
        return fuzzy2.match(pattern, str) !== null;
      };
      fuzzy2.match = function(pattern, str, opts) {
        opts = opts || {};
        var patternIdx = 0, result2 = [], len = str.length, totalScore = 0, currScore = 0, pre = opts.pre || "", post = opts.post || "", compareString = opts.caseSensitive && str || str.toLowerCase(), ch;
        pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
        for (var idx = 0; idx < len; idx++) {
          ch = str[idx];
          if (compareString[idx] === pattern[patternIdx]) {
            ch = pre + ch + post;
            patternIdx += 1;
            currScore += 1 + currScore;
          } else {
            currScore = 0;
          }
          totalScore += currScore;
          result2[result2.length] = ch;
        }
        if (patternIdx === pattern.length) {
          totalScore = compareString === pattern ? Infinity : totalScore;
          return { rendered: result2.join(""), score: totalScore };
        }
        return null;
      };
      fuzzy2.filter = function(pattern, arr, opts) {
        if (!arr || arr.length === 0) {
          return [];
        }
        if (typeof pattern !== "string") {
          return arr;
        }
        opts = opts || {};
        return arr.reduce(function(prev, element, idx, arr2) {
          var str = element;
          if (opts.extract) {
            str = opts.extract(element);
          }
          var rendered = fuzzy2.match(pattern, str, opts);
          if (rendered != null) {
            prev[prev.length] = {
              string: rendered.rendered,
              score: rendered.score,
              index: idx,
              original: element
            };
          }
          return prev;
        }, []).sort(function(a4, b4) {
          var compare = b4.score - a4.score;
          if (compare)
            return compare;
          return a4.index - b4.index;
        });
      };
    })();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/useFreezableMemo.ts
function useFreezableMemo(fn2, deps) {
  const [isFrozen, setFreeze] = (0, import_react167.useState)(false);
  const freezableDeps = (0, import_react167.useRef)(deps);
  if (!isFrozen)
    freezableDeps.current = deps;
  return (0, import_react167.useMemo)(() => fn2(setFreeze), freezableDeps.current);
}
var import_react167;
var init_useFreezableMemo = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/useFreezableMemo.ts"() {
    import_react167 = __toModule(require_react());
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/colors.ts
var COLOR_POPOVER_BACK, COLOR_BASE;
var init_colors = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/colors.ts"() {
    COLOR_POPOVER_BACK = "rgba(26, 28, 30, 0.97);";
    COLOR_BASE = "#272B2F";
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/CurveSegmentEditor.tsx
function useKeyframeDrag(svgNode, node, props, setHandles) {
  const handlers = useFreezableMemo((setFrozen) => ({
    debugName: "CurveSegmentEditor/useKeyframeDrag",
    lockCSSCursorTo: "move",
    onDragStart() {
      setFrozen(true);
      return {
        onDrag(dx, dy) {
          if (!svgNode)
            return;
          props.onCurveChange(setHandles(dx, dy));
        },
        onDragEnd(dragHappened) {
          setFrozen(false);
          props.onCancelCurveChange();
        }
      };
    }
  }), [svgNode, props.onCurveChange, props.onCancelCurveChange]);
  useDrag(node, handlers);
}
var import_react168, VIEWBOX_PADDING, VIEWBOX_SIZE, PATTERN_DOT_SIZE, PATTERN_DOT_COUNT, PATTERN_GRID_SIZE, CURVE_START_OVERSHOOT_COLOR, CURVE_START_COLOR, CURVE_MID_START_COLOR, CURVE_MID_COLOR, CURVE_MID_END_COLOR, CURVE_END_COLOR, CURVE_END_OVERSHOOT_COLOR, CONTROL_COLOR, HANDLE_COLOR, HANDLE_HOVER_COLOR, BACKGROUND_CURVE_COLORS, Circle, HitZone3, CurveSegmentEditor, CurveSegmentEditor_default;
var init_CurveSegmentEditor = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/CurveSegmentEditor.tsx"() {
    import_react168 = __toModule(require_react());
    init_useDrag();
    init_useRefAndState();
    init_clamp();
    init_styled_components_browser_esm();
    init_css();
    init_useFreezableMemo();
    init_colors();
    VIEWBOX_PADDING = 0.12;
    VIEWBOX_SIZE = 1 + VIEWBOX_PADDING * 2;
    PATTERN_DOT_SIZE = 0.01;
    PATTERN_DOT_COUNT = 8;
    PATTERN_GRID_SIZE = (1 - PATTERN_DOT_SIZE) / (PATTERN_DOT_COUNT - 1);
    CURVE_START_OVERSHOOT_COLOR = "#3EAAA4";
    CURVE_START_COLOR = "#3EAAA4";
    CURVE_MID_START_COLOR = "#3EAAA4";
    CURVE_MID_COLOR = "#3EAAA4";
    CURVE_MID_END_COLOR = "#3EAAA4";
    CURVE_END_COLOR = "#3EAAA4";
    CURVE_END_OVERSHOOT_COLOR = "#3EAAA4";
    CONTROL_COLOR = "#B3B3B3";
    HANDLE_COLOR = "#3eaaa4";
    HANDLE_HOVER_COLOR = "#67dfd8";
    BACKGROUND_CURVE_COLORS = [
      "goldenrod",
      "cornflowerblue",
      "dodgerblue",
      "lawngreen"
    ];
    Circle = styled_components_browser_esm_default.circle`
  stroke-width: 0.1px;
  vector-effect: non-scaling-stroke;
  r: 0.04px;
  pointer-events: none;
  transition: r 0.15s;
  fill: ${HANDLE_COLOR};
`;
    HitZone3 = styled_components_browser_esm_default.circle`
  stroke-width: 0.1px;
  vector-effect: non-scaling-stroke;
  r: 0.09px;
  cursor: move;
  ${pointerEventsAutoInNormalMode};
  &:hover {
    opacity: 0.4;
  }
  &:hover + ${Circle} {
    fill: ${HANDLE_HOVER_COLOR};
  }
`;
    CurveSegmentEditor = (props) => {
      const {
        curveConnection: { left, right },
        backgroundConnections
      } = props;
      const minY = Math.min(0, 1 - right.handles[1], 1 - left.handles[3]);
      const maxY = Math.max(1, 1 - right.handles[1], 1 - left.handles[3]);
      const h4 = Math.max(1, maxY - minY);
      const toExtremumSpace = (y3) => (y3 - minY) / h4;
      const [refSVG, nodeSVG] = useRefAndState(null);
      const viewboxToElWidthRatio = VIEWBOX_SIZE / ((nodeSVG == null ? void 0 : nodeSVG.clientWidth) || 1);
      const viewboxToElHeightRatio = VIEWBOX_SIZE / ((nodeSVG == null ? void 0 : nodeSVG.clientHeight) || 1);
      const [refLeft, nodeLeft] = useRefAndState(null);
      useKeyframeDrag(nodeSVG, nodeLeft, props, (dx, dy) => {
        const handleX = clamp_default(left.handles[2] + dx * viewboxToElWidthRatio, 0, 1);
        const handleY = left.handles[3] - dy * viewboxToElHeightRatio;
        return [handleX, handleY, right.handles[0], right.handles[1]];
      });
      const [refRight, nodeRight] = useRefAndState(null);
      useKeyframeDrag(nodeSVG, nodeRight, props, (dx, dy) => {
        const handleX = clamp_default(right.handles[0] + dx * viewboxToElWidthRatio, 0, 1);
        const handleY = right.handles[1] - dy * viewboxToElHeightRatio;
        return [left.handles[2], left.handles[3], handleX, handleY];
      });
      const curvePathDAttrValue = (connection) => `M0 ${toExtremumSpace(1)} C${connection.left.handles[2]} ${toExtremumSpace(1 - connection.left.handles[3])} ${connection.right.handles[0]} ${toExtremumSpace(1 - connection.right.handles[1])} 1 ${toExtremumSpace(0)}`;
      return /* @__PURE__ */ import_react168.default.createElement("svg", {
        height: "100%",
        width: "100%",
        ref: refSVG,
        viewBox: `${-VIEWBOX_PADDING} ${-VIEWBOX_PADDING} ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`,
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        fill: "none"
      }, /* @__PURE__ */ import_react168.default.createElement("linearGradient", {
        id: "myGradient",
        gradientTransform: "rotate(90)"
      }, /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(-1),
        stopColor: CURVE_END_OVERSHOOT_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(0),
        stopColor: CURVE_END_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(0.3),
        stopColor: CURVE_MID_END_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(0.5),
        stopColor: CURVE_MID_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(0.7),
        stopColor: CURVE_MID_START_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(1),
        stopColor: CURVE_START_COLOR
      }), /* @__PURE__ */ import_react168.default.createElement("stop", {
        offset: toExtremumSpace(2),
        stopColor: CURVE_START_OVERSHOOT_COLOR
      })), /* @__PURE__ */ import_react168.default.createElement("pattern", {
        id: "dot-background-pattern-1",
        width: PATTERN_GRID_SIZE,
        height: PATTERN_GRID_SIZE / h4,
        y: -minY / h4
      }, /* @__PURE__ */ import_react168.default.createElement("rect", {
        width: PATTERN_DOT_SIZE,
        height: PATTERN_DOT_SIZE,
        fill: CONTROL_COLOR,
        opacity: 0.3
      })), /* @__PURE__ */ import_react168.default.createElement("rect", {
        x: 0,
        y: 0,
        width: "1",
        height: 1,
        fill: "url(#dot-background-pattern-1)"
      }), /* @__PURE__ */ import_react168.default.createElement("pattern", {
        id: "dot-background-pattern-2",
        width: PATTERN_GRID_SIZE,
        height: PATTERN_GRID_SIZE
      }, /* @__PURE__ */ import_react168.default.createElement("rect", {
        width: PATTERN_DOT_SIZE,
        height: PATTERN_DOT_SIZE,
        fill: CONTROL_COLOR
      })), /* @__PURE__ */ import_react168.default.createElement("rect", {
        x: 0,
        y: toExtremumSpace(0),
        width: "1",
        height: toExtremumSpace(1) - toExtremumSpace(0),
        fill: "url(#dot-background-pattern-2)"
      }), /* @__PURE__ */ import_react168.default.createElement("line", {
        x1: 0,
        y1: toExtremumSpace(1),
        x2: left.handles[2],
        y2: toExtremumSpace(1 - left.handles[3]),
        stroke: CONTROL_COLOR,
        strokeWidth: "0.01"
      }), /* @__PURE__ */ import_react168.default.createElement("line", {
        x1: 1,
        y1: toExtremumSpace(0),
        x2: right.handles[0],
        y2: toExtremumSpace(1 - right.handles[1]),
        stroke: CONTROL_COLOR,
        strokeWidth: "0.01"
      }), /* @__PURE__ */ import_react168.default.createElement("path", {
        d: curvePathDAttrValue(props.curveConnection),
        stroke: "none",
        fill: "url('#myGradient')",
        opacity: "0.1"
      }), backgroundConnections.map((connection, i3) => /* @__PURE__ */ import_react168.default.createElement("path", {
        key: connection.objectKey + "/" + connection.left.id,
        d: curvePathDAttrValue(connection),
        stroke: BACKGROUND_CURVE_COLORS[i3 % BACKGROUND_CURVE_COLORS.length],
        opacity: 0.6,
        strokeWidth: "0.01"
      })), /* @__PURE__ */ import_react168.default.createElement("path", {
        d: curvePathDAttrValue(props.curveConnection),
        stroke: "url('#myGradient')",
        strokeWidth: "0.02"
      }), /* @__PURE__ */ import_react168.default.createElement("circle", {
        cx: 0,
        cy: toExtremumSpace(1),
        r: "0.025",
        stroke: CURVE_START_COLOR,
        strokeWidth: "0.02",
        fill: COLOR_BASE
      }), /* @__PURE__ */ import_react168.default.createElement("circle", {
        cx: 1,
        cy: toExtremumSpace(0),
        r: "0.025",
        stroke: CURVE_END_COLOR,
        strokeWidth: "0.02",
        fill: COLOR_BASE
      }), /* @__PURE__ */ import_react168.default.createElement(HitZone3, {
        ref: refLeft,
        cx: left.handles[2],
        cy: toExtremumSpace(1 - left.handles[3]),
        fill: CURVE_START_COLOR,
        opacity: 0.2
      }), /* @__PURE__ */ import_react168.default.createElement(Circle, {
        cx: left.handles[2],
        cy: toExtremumSpace(1 - left.handles[3])
      }), /* @__PURE__ */ import_react168.default.createElement(HitZone3, {
        ref: refRight,
        cx: right.handles[0],
        cy: toExtremumSpace(1 - right.handles[1]),
        fill: CURVE_END_COLOR,
        opacity: 0.2
      }), /* @__PURE__ */ import_react168.default.createElement(Circle, {
        cx: right.handles[0],
        cy: toExtremumSpace(1 - right.handles[1])
      }));
    };
    CurveSegmentEditor_default = CurveSegmentEditor;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/shared.ts
function cssCubicBezierArgsFromHandles(points) {
  return points.map((p3) => p3.toFixed(CSS_BEZIER_ARGS_DECIMAL_POINTS)).join(", ");
}
function handlesFromCssCubicBezierArgs(str) {
  if (!str || (str == null ? void 0 : str.length) > MAX_REASONABLE_BEZIER_STRING)
    return null;
  const args = str.split(",");
  if (args.length !== 4)
    return null;
  const nums = args.map((arg) => {
    return Number(arg.trim());
  });
  if (!nums.every((v5) => isFinite(v5)))
    return null;
  if (nums[0] < 0 || nums[0] > 1 || nums[2] < 0 || nums[2] > 1)
    return null;
  return nums;
}
function areEasingsSimilar(easing1, easing2, options2 = { threshold: 0.02 }) {
  if (!easing1 || !easing2)
    return false;
  let totalDiff = 0;
  for (let i3 = 0; i3 < 4; i3++) {
    totalDiff += Math.abs(easing1[i3] - easing2[i3]);
  }
  return totalDiff < options2.threshold;
}
var CSS_BEZIER_ARGS_DECIMAL_POINTS, MAX_REASONABLE_BEZIER_STRING, EASING_PRESETS;
var init_shared = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/shared.ts"() {
    CSS_BEZIER_ARGS_DECIMAL_POINTS = 3;
    MAX_REASONABLE_BEZIER_STRING = 128;
    EASING_PRESETS = [
      { label: "Quad Out", value: "0.250, 0.460, 0.450, 0.940" },
      { label: "Quad In Out", value: "0.455, 0.030, 0.515, 0.955" },
      { label: "Quad In", value: "0.550, 0.085, 0.680, 0.530" },
      { label: "Cubic Out", value: "0.215, 0.610, 0.355, 1.000" },
      { label: "Cubic In Out", value: "0.645, 0.045, 0.355, 1.000" },
      { label: "Cubic In", value: "0.550, 0.055, 0.675, 0.190" },
      { label: "Quart Out", value: "0.165, 0.840, 0.440, 1.000" },
      { label: "Quart In Out", value: "0.770, 0.000, 0.175, 1.000" },
      { label: "Quart In", value: "0.895, 0.030, 0.685, 0.220" },
      { label: "Quint Out", value: "0.230, 1.000, 0.320, 1.000" },
      { label: "Quint In Out", value: "0.860, 0.000, 0.070, 1.000" },
      { label: "Quint In", value: "0.755, 0.050, 0.855, 0.060" },
      { label: "Sine Out", value: "0.390, 0.575, 0.565, 1.000" },
      { label: "Sine In Out", value: "0.445, 0.050, 0.550, 0.950" },
      { label: "Sine In", value: "0.470, 0.000, 0.745, 0.715" },
      { label: "Expo Out", value: "0.190, 1.000, 0.220, 1.000" },
      { label: "Expo In Out", value: "1.000, 0.000, 0.000, 1.000" },
      { label: "Expo In", value: "0.780, 0.000, 0.810, 0.00" },
      { label: "Circ Out", value: "0.075, 0.820, 0.165, 1.000" },
      { label: "Circ In Out", value: "0.785, 0.135, 0.150, 0.860" },
      { label: "Circ In", value: "0.600, 0.040, 0.980, 0.335" },
      { label: "Back Out", value: "0.175, 0.885, 0.320, 1.275" },
      { label: "Back In Out", value: "0.680, -0.550, 0.265, 1.550" },
      { label: "Back In", value: "0.600, -0.280, 0.735, 0.045" },
      { label: "linear", value: "0.5, 0.5, 0.5, 0.5" },
      { label: "In Out", value: "0.42,0,0.58,1" }
    ];
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/SVGCurveSegment.tsx
var import_react169, VIEWBOX_PADDING2, SVG_CIRCLE_RADIUS, VIEWBOX_SIZE2, SELECTED_CURVE_COLOR, CURVE_COLOR, CONTROL_COLOR2, CONTROL_HITZONE_COLOR, toVerticalSVGSpace, SVGCurveSegment, SVGCurveSegment_default;
var init_SVGCurveSegment = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/SVGCurveSegment.tsx"() {
    import_react169 = __toModule(require_react());
    VIEWBOX_PADDING2 = 0.75;
    SVG_CIRCLE_RADIUS = 0.1;
    VIEWBOX_SIZE2 = 1 + VIEWBOX_PADDING2 * 2;
    SELECTED_CURVE_COLOR = "#F5F5F5";
    CURVE_COLOR = "#888888";
    CONTROL_COLOR2 = "#4f4f4f";
    CONTROL_HITZONE_COLOR = "rgba(255, 255, 255, 0.1)";
    toVerticalSVGSpace = (y3) => 1 - y3;
    SVGCurveSegment = (props) => {
      const { easing, isSelected } = props;
      if (!easing)
        return /* @__PURE__ */ import_react169.default.createElement(import_react169.default.Fragment, null);
      const curveColor = isSelected ? SELECTED_CURVE_COLOR : CURVE_COLOR;
      const leftControlPoint = [easing[0], toVerticalSVGSpace(easing[1])];
      const rightControlPoint = [easing[2], toVerticalSVGSpace(easing[3])];
      const SVG_VIEWBOX_ATTR = `${-VIEWBOX_PADDING2} ${-VIEWBOX_PADDING2} ${VIEWBOX_SIZE2} ${VIEWBOX_SIZE2}`;
      return /* @__PURE__ */ import_react169.default.createElement("svg", {
        height: "100%",
        width: "100%",
        viewBox: SVG_VIEWBOX_ATTR,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ import_react169.default.createElement("line", {
        x1: "0",
        y1: "1",
        x2: leftControlPoint[0],
        y2: leftControlPoint[1],
        stroke: CONTROL_COLOR2,
        strokeWidth: "0.1"
      }), /* @__PURE__ */ import_react169.default.createElement("line", {
        x1: "1",
        y1: "0",
        x2: rightControlPoint[0],
        y2: rightControlPoint[1],
        stroke: CONTROL_COLOR2,
        strokeWidth: "0.1"
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: leftControlPoint[0],
        cy: leftControlPoint[1],
        r: 0.1,
        fill: CONTROL_HITZONE_COLOR
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: rightControlPoint[0],
        cy: rightControlPoint[1],
        r: 0.1,
        fill: CONTROL_HITZONE_COLOR
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: leftControlPoint[0],
        cy: leftControlPoint[1],
        r: SVG_CIRCLE_RADIUS,
        fill: CONTROL_COLOR2
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: rightControlPoint[0],
        cy: rightControlPoint[1],
        r: SVG_CIRCLE_RADIUS,
        fill: CONTROL_COLOR2
      }), /* @__PURE__ */ import_react169.default.createElement("path", {
        d: `M0 1 C${leftControlPoint[0]} ${leftControlPoint[1]} ${rightControlPoint[0]} 
      ${rightControlPoint[1]} 1 0`,
        stroke: curveColor,
        strokeWidth: "0.08"
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: 0,
        cy: 1,
        r: SVG_CIRCLE_RADIUS,
        fill: curveColor
      }), /* @__PURE__ */ import_react169.default.createElement("circle", {
        cx: 1,
        cy: 0,
        r: SVG_CIRCLE_RADIUS,
        fill: curveColor
      }));
    };
    SVGCurveSegment_default = SVGCurveSegment;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/EasingOption.tsx
var import_react170, Wrapper, EasingTooltip, EasingOption, EasingOption_default;
var init_EasingOption = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/EasingOption.tsx"() {
    init_useTooltip();
    import_react170 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_shared();
    init_SVGCurveSegment();
    init_react_merge_refs_esm();
    init_colors();
    init_BasicPopover();
    Wrapper = styled_components_browser_esm_default.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  aspect-ratio: 1;

  transition: background-color 0.15s;
  background-color: ${COLOR_BASE};
  border-radius: 2px;
  cursor: pointer;
  outline: none;

  ${({ isSelected }) => isSelected && Ce`
      background-color: #383d42;
    `}

  &:hover {
    background-color: #31353a;
  }

  &:focus {
    background-color: #383d42;
  }
`;
    EasingTooltip = styled_components_browser_esm_default(BasicPopover_default)`
  padding: 0.5em;
  color: white;
  max-width: 240px;
  pointer-events: none !important;
  --popover-bg: black;
  --popover-outer-stroke: transparent;
  --popover-inner-stroke: transparent;
  box-shadow: none;
`;
    EasingOption = import_react170.default.forwardRef((props, ref) => {
      const [tooltip, tooltipHostRef] = useTooltip({ enabled: true, verticalPlacement: props.tooltipPlacement, verticalGap: 0 }, () => /* @__PURE__ */ import_react170.default.createElement(EasingTooltip, {
        showPopoverEdgeTriangle: false
      }, props.easing.label));
      return /* @__PURE__ */ import_react170.default.createElement(Wrapper, __spreadValues({
        ref: react_merge_refs_esm_default([tooltipHostRef, ref])
      }, props), tooltip, /* @__PURE__ */ import_react170.default.createElement(SVGCurveSegment_default, {
        easing: handlesFromCssCubicBezierArgs(props.easing.value),
        isSelected: props.isSelected
      }));
    });
    EasingOption_default = EasingOption;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/useUIOptionGrid.tsx
function useUIOptionGrid(options2) {
  var _a2;
  const [selectionIndex, setSelectionIndex] = (0, import_react171.useState)(null);
  const moveCursorVertical = (vdir) => {
    if (selectionIndex === null) {
      if (options2.items.length > 0) {
        setSelectionIndex(0);
      } else {
      }
      return;
    }
    const nextSelectionIndex = selectionIndex + vdir * options2.uiColumns;
    const exitsTop = nextSelectionIndex < 0;
    const exitsBottom = nextSelectionIndex > options2.items.length - 1;
    if (exitsTop || exitsBottom) {
      if (options2.canVerticleExit) {
        if (options2.canVerticleExit(exitsTop ? "top" : "bottom")) {
          setSelectionIndex(null);
          return;
        }
      }
      return;
    }
    setSelectionIndex(nextSelectionIndex);
  };
  const moveCursorHorizontal = (hdir) => {
    if (selectionIndex === null)
      setSelectionIndex(mod(hdir, options2.items.length));
    else if (selectionIndex + hdir < 0) {
      setSelectionIndex(null);
    } else
      setSelectionIndex(Math.min(selectionIndex + hdir, options2.items.length - 1));
  };
  const onParentKeydown = (e2) => {
    if (e2.key === "ArrowRight")
      moveCursorHorizontal(1);
    else if (e2.key === "ArrowLeft")
      moveCursorHorizontal(-1);
    else if (e2.key === "ArrowUp")
      moveCursorVertical(-1);
    else if (e2.key === "ArrowDown")
      moveCursorVertical(1);
    else
      return 0;
    return 1;
  };
  return {
    focusFirstItem() {
      setSelectionIndex(0);
    },
    onParentEltKeyDown: onParentKeydown,
    gridItems: options2.items.map((item, idx) => options2.renderItem({
      isSelected: idx === selectionIndex,
      item,
      select(e2) {
        setSelectionIndex(idx);
        if (options2.onSelectItem(item) === 1) {
          e2 == null ? void 0 : e2.preventDefault();
          e2 == null ? void 0 : e2.stopPropagation();
        }
      }
    })),
    currentSelection: (_a2 = options2.items[selectionIndex != null ? selectionIndex : -1]) != null ? _a2 : null
  };
}
var import_react171, Outcome;
var init_useUIOptionGrid = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/useUIOptionGrid.tsx"() {
    import_react171 = __toModule(require_react());
    init_CurveEditorPopover();
    (function(Outcome2) {
      Outcome2[Outcome2["Handled"] = 1] = "Handled";
      Outcome2[Outcome2["Passthrough"] = 0] = "Passthrough";
    })(Outcome || (Outcome = {}));
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/CurveEditorPopover.tsx
function setTempValue(tempTransaction, keyframeConnections2, newCurveCssCubicBezier) {
  var _a2;
  (_a2 = tempTransaction.current) == null ? void 0 : _a2.discard();
  tempTransaction.current = null;
  const handles = handlesFromCssCubicBezierArgs(newCurveCssCubicBezier);
  if (handles === null)
    return;
  tempTransaction.current = transactionSetCubicBezier(keyframeConnections2, handles);
}
function discardTempValue(tempTransaction) {
  var _a2;
  (_a2 = tempTransaction.current) == null ? void 0 : _a2.discard();
  tempTransaction.current = null;
}
function transactionSetCubicBezier(keyframeConnections2, handles) {
  return getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
    const { setHandlesForKeyframe } = stateEditors2.coreByProject.historic.sheetsById.sequence;
    for (const {
      projectId,
      sheetId,
      objectKey,
      trackId,
      left,
      right
    } of keyframeConnections2) {
      setHandlesForKeyframe({
        projectId,
        sheetId,
        objectKey,
        trackId,
        keyframeId: left.id,
        start: [handles[0], handles[1]]
      });
      setHandlesForKeyframe({
        projectId,
        sheetId,
        objectKey,
        trackId,
        keyframeId: right.id,
        end: [handles[2], handles[3]]
      });
    }
  });
}
function mod(n3, m3) {
  return (n3 % m3 + m3) % m3;
}
function setTimeoutFunction(f3, timeout) {
  return () => setTimeout(f3, timeout);
}
function areConnectedKeyframesTheSameAs({
  left: left1,
  right: right1
}) {
  return ({ left: left2, right: right2 }) => left1.handles[2] !== left2.handles[2] || left1.handles[3] !== left2.handles[3] || right1.handles[0] !== right2.handles[0] || right1.handles[1] !== right2.handles[1];
}
var import_dataverse50, import_react172, import_fuzzy, PRESET_COLUMNS, PRESET_SIZE, APPROX_TOOLTIP_HEIGHT, Grid, OptionsContainer, SearchBox, CurveEditorContainer, NoResultsFoundContainer, TextInputMode, CurveEditorPopover, CurveEditorPopover_default, isCurveEditorOpenD, isConnectionEditingInCurvePopover, getLock;
var init_CurveEditorPopover = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/CurveEditorPopover/CurveEditorPopover.tsx"() {
    import_dataverse50 = __toModule(require("@theatre/dataverse"));
    import_react172 = __toModule(require_react());
    init_styled_components_browser_esm();
    import_fuzzy = __toModule(require_fuzzy());
    init_getStudio();
    init_CurveSegmentEditor();
    init_EasingOption();
    init_shared();
    init_colors();
    init_useRefAndState();
    init_useUIOptionGrid();
    PRESET_COLUMNS = 3;
    PRESET_SIZE = 53;
    APPROX_TOOLTIP_HEIGHT = 25;
    Grid = styled_components_browser_esm_default.div`
  background: ${COLOR_POPOVER_BACK};
  display: grid;
  grid-template-areas:
    'search  tween'
    'presets tween';
  grid-template-rows: 32px 1fr;
  grid-template-columns: ${PRESET_COLUMNS * PRESET_SIZE}px 120px;
  gap: 1px;
  height: 120px;
`;
    OptionsContainer = styled_components_browser_esm_default.div`
  overflow: auto;
  grid-area: presets;

  display: grid;
  grid-template-columns: repeat(${PRESET_COLUMNS}, 1fr);
  grid-auto-rows: min-content;
  gap: 1px;

  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
`;
    SearchBox = styled_components_browser_esm_default.input.attrs({ type: "text" })`
  background-color: ${COLOR_BASE};
  border: none;
  border-radius: 2px;
  color: rgba(255, 255, 255, 0.8);
  padding: 6px;
  font-size: 12px;
  outline: none;
  cursor: text;
  text-align: left;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  grid-area: search;

  &:hover {
    background-color: #212121;
  }

  &:focus {
    background-color: rgba(16, 16, 16, 0.26);
    outline: 1px solid rgba(0, 0, 0, 0.35);
  }
`;
    CurveEditorContainer = styled_components_browser_esm_default.div`
  grid-area: tween;
  background: ${COLOR_BASE};
`;
    NoResultsFoundContainer = styled_components_browser_esm_default.div`
  grid-column: 1 / 4;
  padding: 6px;
  color: #888888;
`;
    (function(TextInputMode2) {
      TextInputMode2[TextInputMode2["init"] = 0] = "init";
      TextInputMode2[TextInputMode2["user"] = 1] = "user";
      TextInputMode2[TextInputMode2["auto"] = 2] = "auto";
      TextInputMode2[TextInputMode2["multipleValues"] = 3] = "multipleValues";
    })(TextInputMode || (TextInputMode = {}));
    CurveEditorPopover = (props) => {
      const allConnections = (0, import_react172.useMemo)(() => [props.curveConnection, ...props.additionalConnections], [props.curveConnection, ...props.additionalConnections]);
      const tempTransaction = (0, import_react172.useRef)(null);
      (0, import_react172.useEffect)(() => {
        const unlock = getLock(allConnections);
        return () => {
          var _a2;
          unlock();
          (_a2 = tempTransaction.current) == null ? void 0 : _a2.commit();
        };
      }, [tempTransaction]);
      const easing = [
        props.curveConnection.left.handles[2],
        props.curveConnection.left.handles[3],
        props.curveConnection.right.handles[0],
        props.curveConnection.right.handles[1]
      ];
      const inputRef = (0, import_react172.useRef)(null);
      (0, import_react172.useLayoutEffect)(() => {
        var _a2, _b;
        (_a2 = inputRef.current) == null ? void 0 : _a2.select();
        (_b = inputRef.current) == null ? void 0 : _b.focus();
      }, [inputRef.current]);
      const [inputValue, setInputValue] = (0, import_react172.useState)(cssCubicBezierArgsFromHandles(easing));
      const onInputChange = (e2) => {
        setTextInputMode(1);
        setInputValue(e2.target.value);
        const maybeHandles = handlesFromCssCubicBezierArgs(e2.target.value);
        if (maybeHandles)
          setEdit(e2.target.value);
      };
      const onSearchKeyDown = (e2) => {
        var _a2, _b;
        setTextInputMode(1);
        if (e2.key === "ArrowDown" || e2.key === "ArrowUp")
          e2.preventDefault();
        if (e2.key === "ArrowDown") {
          grid.focusFirstItem();
          (_b = (_a2 = optionsRef.current[displayedPresets[0].label]) == null ? void 0 : _a2.current) == null ? void 0 : _b.focus();
        } else if (e2.key === "Escape") {
          discardTempValue(tempTransaction);
          props.onRequestClose("key Escape");
        } else if (e2.key === "Enter") {
          props.onRequestClose("key Enter");
        }
      };
      const [textInputMode, setTextInputMode] = (0, import_react172.useState)(0);
      (0, import_react172.useEffect)(() => {
        if (textInputMode === 2) {
          setInputValue(cssCubicBezierArgsFromHandles(easing));
        } else if (textInputMode === 3) {
          if (inputValue !== "")
            setInputValue("");
        }
      }, allConnections);
      const [edit2, setEdit] = (0, import_react172.useState)(cssCubicBezierArgsFromHandles(easing));
      const [preview, setPreview] = (0, import_react172.useState)(null);
      (0, import_react172.useEffect)(() => {
        var _a2;
        if (textInputMode !== 0 && textInputMode !== 3)
          setTempValue(tempTransaction, allConnections, (_a2 = preview != null ? preview : edit2) != null ? _a2 : "");
      }, [preview, edit2, textInputMode]);
      if (allConnections.some(areConnectedKeyframesTheSameAs(props.curveConnection)) && textInputMode === 0) {
        setTextInputMode(3);
      }
      const onCurveChange = (newHandles) => {
        var _a2, _b;
        setTextInputMode(2);
        const value = cssCubicBezierArgsFromHandles(newHandles);
        setInputValue(value);
        setEdit(value);
        (_a2 = inputRef.current) == null ? void 0 : _a2.select();
        (_b = inputRef.current) == null ? void 0 : _b.focus();
      };
      const onCancelCurveChange = () => {
      };
      const displayedPresets = (0, import_react172.useMemo)(() => {
        const isInputValueAQuery = /^[A-Za-z]/.test(inputValue);
        if (isInputValueAQuery) {
          return import_fuzzy.default.filter(inputValue, EASING_PRESETS, {
            extract: (el) => el.label
          }).map((result2) => result2.original);
        } else {
          return EASING_PRESETS;
        }
      }, [inputValue]);
      (0, import_react172.useEffect)(() => {
        if (textInputMode === 1 && displayedPresets[0])
          setEdit(displayedPresets[0].value);
      }, [displayedPresets]);
      const onEasingOptionKeydown = (e2) => {
        if (e2.key === "Escape") {
          discardTempValue(tempTransaction);
          props.onRequestClose("key Escape");
          e2.stopPropagation();
        } else if (e2.key === "Enter") {
          props.onRequestClose("key Enter");
          e2.stopPropagation();
        }
      };
      const onEasingOptionMouseOver = (item) => {
        if (textInputMode === 0)
          setTextInputMode(2);
        setPreview(item.value);
      };
      const onEasingOptionMouseOut = () => setPreview(null);
      const onSelectEasingOption = (item) => {
        setTempValue(tempTransaction, allConnections, item.value);
        props.onRequestClose("selected easing option");
        return Outcome.Handled;
      };
      const optionsRef = (0, import_react172.useRef)(EASING_PRESETS.reduce((acc, curr) => {
        acc[curr.label] = { current: null };
        return acc;
      }, {}));
      const [optionsContainerRef, optionsContainer] = useRefAndState(null);
      const [optionsScrollPosition, setOptionsScrollPosition] = (0, import_react172.useState)(0);
      (0, import_react172.useEffect)(() => {
        const listener = () => {
          var _a2;
          setOptionsScrollPosition((_a2 = optionsContainer == null ? void 0 : optionsContainer.scrollTop) != null ? _a2 : 0);
        };
        optionsContainer == null ? void 0 : optionsContainer.addEventListener("scroll", listener);
        return () => optionsContainer == null ? void 0 : optionsContainer.removeEventListener("scroll", listener);
      }, [optionsContainer]);
      const grid = useUIOptionGrid({
        items: displayedPresets,
        uiColumns: 3,
        onSelectItem: onSelectEasingOption,
        canVerticleExit(exitSide) {
          var _a2, _b;
          if (exitSide === "top") {
            (_a2 = inputRef.current) == null ? void 0 : _a2.select();
            (_b = inputRef.current) == null ? void 0 : _b.focus();
            return Outcome.Handled;
          }
          return Outcome.Passthrough;
        },
        renderItem: ({ item: preset, select }) => {
          var _a2, _b;
          return /* @__PURE__ */ import_react172.default.createElement(EasingOption_default, {
            key: preset.label,
            easing: preset,
            tabIndex: 0,
            onKeyDown: onEasingOptionKeydown,
            ref: optionsRef.current[preset.label],
            onMouseOver: () => onEasingOptionMouseOver(preset),
            onMouseOut: onEasingOptionMouseOut,
            onClick: select,
            tooltipPlacement: ((_b = (_a2 = optionsRef.current[preset.label].current) == null ? void 0 : _a2.offsetTop) != null ? _b : 0) - (optionsScrollPosition != null ? optionsScrollPosition : 0) < PRESET_SIZE + APPROX_TOOLTIP_HEIGHT ? "bottom" : "top",
            isSelected: areEasingsSimilar(easing, handlesFromCssCubicBezierArgs(preset.value))
          });
        }
      });
      (0, import_react172.useLayoutEffect)(() => {
        var _a2, _b;
        if (grid.currentSelection !== null && document.activeElement !== inputRef.current) {
          const maybePresetEl = (_b = (_a2 = optionsRef.current) == null ? void 0 : _a2[grid.currentSelection.label]) == null ? void 0 : _b.current;
          maybePresetEl == null ? void 0 : maybePresetEl.focus();
          setEdit(grid.currentSelection.value);
          const isInputValueAQuery = /^[A-Za-z]/.test(inputValue);
          if (!isInputValueAQuery) {
            setInputValue(grid.currentSelection.value);
          }
        }
      }, [grid.currentSelection]);
      return /* @__PURE__ */ import_react172.default.createElement(Grid, null, /* @__PURE__ */ import_react172.default.createElement(SearchBox, {
        value: inputValue,
        placeholder: textInputMode === 3 ? "Multiple easings selected" : "Search presets...",
        onPaste: setTimeoutFunction(onInputChange),
        onChange: onInputChange,
        ref: inputRef,
        onKeyDown: onSearchKeyDown
      }), /* @__PURE__ */ import_react172.default.createElement(OptionsContainer, {
        ref: optionsContainerRef,
        onKeyDown: (evt) => grid.onParentEltKeyDown(evt)
      }, grid.gridItems, grid.gridItems.length === 0 ? /* @__PURE__ */ import_react172.default.createElement(NoResultsFoundContainer, null, "No results found") : void 0), /* @__PURE__ */ import_react172.default.createElement(CurveEditorContainer, {
        onClick: () => {
          var _a2;
          return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
        }
      }, /* @__PURE__ */ import_react172.default.createElement(CurveSegmentEditor_default, {
        curveConnection: props.curveConnection,
        backgroundConnections: props.additionalConnections,
        onCurveChange,
        onCancelCurveChange
      })));
    };
    CurveEditorPopover_default = CurveEditorPopover;
    ({ isCurveEditorOpenD, isConnectionEditingInCurvePopover, getLock } = (() => {
      const connectionsInCurvePopoverEdit = new import_dataverse50.Box([]);
      return {
        getLock(connections) {
          connectionsInCurvePopoverEdit.set(connections);
          return function unlock() {
            connectionsInCurvePopoverEdit.set([]);
          };
        },
        isCurveEditorOpenD: (0, import_dataverse50.prism)(() => {
          return connectionsInCurvePopoverEdit.derivation.getValue().length > 0;
        }),
        isConnectionEditingInCurvePopover(con) {
          import_dataverse50.prism.ensurePrism();
          return connectionsInCurvePopoverEdit.derivation.getValue().some(({ left, right }) => con.left.id === left.id && con.right.id === right.id);
        }
      };
    })());
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/selections.ts
function isKeyframeConnectionInSelection(keyframeConnection, selection) {
  for (const { keyframeId } of flatSelectionKeyframeIds(selection)) {
    if (keyframeConnection.left.id === keyframeId)
      return true;
  }
  return false;
}
function selectedKeyframeConnections(projectId, sheetId, selection) {
  return (0, import_dataverse51.prism)(() => {
    if (selection === void 0)
      return [];
    let ckfs = [];
    for (const { objectKey, trackId } of flatSelectionTrackIds(selection)) {
      const track = (0, import_dataverse51.val)(getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetId].sequence.tracksByObject[objectKey].trackData[trackId]);
      if (track) {
        ckfs = ckfs.concat(keyframeConnections(track.keyframes).filter((kfc) => isKeyframeConnectionInSelection(kfc, selection)).map(({ left, right }) => ({
          left,
          right,
          trackId,
          objectKey,
          sheetId,
          projectId
        })));
      }
    }
    return ckfs;
  });
}
function copyableKeyframesFromSelection(projectId, sheetId, selection) {
  var _a2;
  if (selection === void 0)
    return [];
  let kfs = [];
  for (const { objectKey, trackId, keyframeIds } of flatSelectionTrackIds(selection)) {
    kfs = kfs.concat((_a2 = keyframesWithPaths({
      projectId,
      sheetId,
      objectKey,
      trackId,
      keyframeIds
    })) != null ? _a2 : []);
  }
  const commonPath = commonRootOfPathsToProps(kfs.map((kf) => kf.pathToProp));
  const keyframesWithCommonRootPath = kfs.map(({ keyframe, pathToProp }) => ({
    keyframe,
    pathToProp: pathToProp.slice(commonPath.length)
  }));
  return keyframesWithCommonRootPath;
}
function keyframesWithPaths({
  projectId,
  sheetId,
  objectKey,
  trackId,
  keyframeIds
}) {
  const tracksByObject = (0, import_dataverse51.val)(getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetId].sequence.tracksByObject[objectKey]);
  const track = tracksByObject == null ? void 0 : tracksByObject.trackData[trackId];
  if (!track)
    return null;
  const propPathByTrackId = swapKeyAndValue((tracksByObject == null ? void 0 : tracksByObject.trackIdByPropPath) || {});
  const encodedPropPath = propPathByTrackId[trackId];
  if (!encodedPropPath)
    return null;
  const pathToProp = [objectKey, ...decodePathToProp(encodedPropPath)];
  return keyframeIds.map((keyframeId) => ({
    keyframe: track.keyframes.find((keyframe) => keyframe.id === keyframeId),
    pathToProp
  })).filter(({ keyframe }) => keyframe !== void 0);
}
function swapKeyAndValue(obj) {
  const result2 = {};
  for (const [key, value] of Object.entries(obj)) {
    result2[value] = key;
  }
  return result2;
}
function keyframeConnections(keyframes) {
  return keyframes.map((kf, i3) => ({ left: kf, right: keyframes[i3 + 1] })).slice(0, -1);
}
function flatSelectionKeyframeIds(selection) {
  var _a2, _b, _c;
  const result2 = [];
  for (const [objectKey, maybeObjectRecord] of Object.entries((_a2 = selection == null ? void 0 : selection.byObjectKey) != null ? _a2 : {})) {
    for (const [trackId, maybeTrackRecord] of Object.entries((_b = maybeObjectRecord == null ? void 0 : maybeObjectRecord.byTrackId) != null ? _b : {})) {
      for (const keyframeId of Object.keys((_c = maybeTrackRecord == null ? void 0 : maybeTrackRecord.byKeyframeId) != null ? _c : {})) {
        result2.push({ objectKey, trackId, keyframeId });
      }
    }
  }
  return result2;
}
function flatSelectionTrackIds(selection) {
  var _a2, _b, _c;
  const result2 = [];
  for (const [objectKey, maybeObjectRecord] of Object.entries((_a2 = selection == null ? void 0 : selection.byObjectKey) != null ? _a2 : {})) {
    for (const [trackId, maybeTrackRecord] of Object.entries((_b = maybeObjectRecord == null ? void 0 : maybeObjectRecord.byTrackId) != null ? _b : {})) {
      result2.push({
        objectKey,
        trackId,
        keyframeIds: Object.keys((_c = maybeTrackRecord == null ? void 0 : maybeTrackRecord.byKeyframeId) != null ? _c : {})
      });
    }
  }
  return result2;
}
var import_dataverse51;
var init_selections = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/selections.ts"() {
    import_dataverse51 = __toModule(require("@theatre/dataverse"));
    init_getStudio();
    init_addresses();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/useTempTransactionEditingTools.tsx
function useTempTransactionEditingTools(writeTx) {
  return (0, import_react173.useMemo)(() => createTempTransactionEditingTools(writeTx), []);
}
function createTempTransactionEditingTools(writeTx) {
  let currentTransaction = null;
  const createTempTx = (value) => getStudio().tempTransaction((api) => writeTx(api, value));
  function discardTemporaryValue() {
    currentTransaction == null ? void 0 : currentTransaction.discard();
    currentTransaction = null;
  }
  return {
    temporarilySetValue(value) {
      discardTemporaryValue();
      currentTransaction = createTempTx(value);
    },
    discardTemporaryValue,
    permanentlySetValue(value) {
      discardTemporaryValue();
      createTempTx(value).commit();
    }
  };
}
var import_react173;
var init_useTempTransactionEditingTools = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/useTempTransactionEditingTools.tsx"() {
    init_getStudio();
    import_react173 = __toModule(require_react());
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/DeterminePropEditorForSingleKeyframe.tsx
function DeterminePropEditorForKeyframeTree(p3) {
  var _a2;
  if (p3.type === "sheetObject") {
    return /* @__PURE__ */ import_react174.default.createElement(import_react174.default.Fragment, null, /* @__PURE__ */ import_react174.default.createElement(SingleKeyframePropLabel, {
      style: { paddingLeft: `${p3.indent * INDENT_PX}px` }
    }, p3.sheetObject.address.objectKey), p3.children.map((c3, i3) => /* @__PURE__ */ import_react174.default.createElement(DeterminePropEditorForKeyframeTree, __spreadProps(__spreadValues({
      key: i3
    }, c3), {
      autoFocusInput: p3.autoFocusInput && i3 === 0,
      indent: p3.indent + 1
    }))));
  } else if (p3.type === "propWithChildren") {
    const label = (_a2 = p3.propConfig.label) != null ? _a2 : last_default(p3.pathToProp);
    return /* @__PURE__ */ import_react174.default.createElement(import_react174.default.Fragment, null, /* @__PURE__ */ import_react174.default.createElement(SingleKeyframePropLabel, {
      style: { paddingLeft: `${p3.indent * INDENT_PX}px` }
    }, label), p3.children.map((c3, i3) => /* @__PURE__ */ import_react174.default.createElement(DeterminePropEditorForKeyframeTree, __spreadProps(__spreadValues({
      key: i3
    }, c3), {
      autoFocusInput: p3.autoFocusInput && i3 === 0,
      indent: p3.indent + 1
    }))));
  } else {
    return /* @__PURE__ */ import_react174.default.createElement(PrimitivePropEditor, __spreadProps(__spreadValues({}, p3), {
      autoFocusInput: p3.autoFocusInput,
      indent: p3.indent
    }));
  }
}
function PrimitivePropEditor(p3) {
  var _a2;
  const label = (_a2 = p3.propConfig.label) != null ? _a2 : last_default(p3.pathToProp);
  const editingTools = useEditingToolsForKeyframeEditorPopover(p3);
  if (p3.propConfig.type === "enum") {
    return /* @__PURE__ */ import_react174.default.createElement(import_react174.default.Fragment, null);
  } else {
    const PropEditor = simplePropEditorByPropType[p3.propConfig.type];
    return /* @__PURE__ */ import_react174.default.createElement(SingleKeyframePropEditorContainer, null, /* @__PURE__ */ import_react174.default.createElement(SingleKeyframePropLabel, null, /* @__PURE__ */ import_react174.default.createElement("span", {
      style: { paddingLeft: `${p3.indent * INDENT_PX}px` }
    }, label)), /* @__PURE__ */ import_react174.default.createElement(SingleKeyframeSimplePropEditorContainer, null, /* @__PURE__ */ import_react174.default.createElement(PropEditor, {
      editingTools,
      propConfig: p3.propConfig,
      value: valueInProp(p3.keyframe.value, p3.propConfig),
      autoFocus: p3.autoFocusInput
    })));
  }
}
function useEditingToolsForKeyframeEditorPopover(props) {
  const obj = props.sheetObject;
  return useTempTransactionEditingTools(({ stateEditors: stateEditors2 }, value) => {
    const newKeyframe = __spreadProps(__spreadValues({}, props.keyframe), { value });
    stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, obj.address), {
      trackId: props.trackId,
      keyframes: [newKeyframe],
      snappingFunction: obj.sheet.getSequence().closestGridPosition
    }));
  });
}
var import_react174, SingleKeyframePropEditorContainer, SingleKeyframePropLabel, INDENT_PX, SingleKeyframeSimplePropEditorContainer;
var init_DeterminePropEditorForSingleKeyframe = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/DeterminePropEditorForSingleKeyframe.tsx"() {
    import_react174 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_simplePropEditorByPropType();
    init_last();
    init_useTempTransactionEditingTools();
    init_utils();
    SingleKeyframePropEditorContainer = styled_components_browser_esm_default.div`
  display: flex;
  align-items: stretch;

  select {
    min-width: 100px;
  }
`;
    SingleKeyframePropLabel = styled_components_browser_esm_default.div`
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.01em;
  padding: 6px 6px 6px 0;

  width: 40%;

  color: #919191;

  overflow: hidden;
`;
    INDENT_PX = 10;
    SingleKeyframeSimplePropEditorContainer = styled_components_browser_esm_default.div`
  display: flex;
  align-items: center;
  width: 60%;
`;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/useSingleKeyframeInlineEditorPopover.tsx
function useKeyframeInlineEditorPopover(props) {
  return usePopover({ debugName: "useKeyframeInlineEditorPopover" }, () => /* @__PURE__ */ import_react175.default.createElement(BasicPopover_default, {
    showPopoverEdgeTriangle: true
  }, /* @__PURE__ */ import_react175.default.createElement("div", {
    style: { margin: "1px 2px 1px 10px" }
  }, !Array.isArray(props) ? void 0 : props.map((prop, i3) => /* @__PURE__ */ import_react175.default.createElement(DeterminePropEditorForKeyframeTree, __spreadProps(__spreadValues({
    key: i3
  }, prop), {
    autoFocusInput: i3 === 0,
    indent: 0
  }))))));
}
var import_react175;
var init_useSingleKeyframeInlineEditorPopover = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/useSingleKeyframeInlineEditorPopover.tsx"() {
    import_react175 = __toModule(require_react());
    init_usePopover();
    init_BasicPopover();
    init_DeterminePropEditorForSingleKeyframe();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/SingleKeyframeDot.tsx
function useSingleKeyframeContextMenu(target, logger, props) {
  return useContextMenu(target, {
    displayName: "Keyframe",
    menuItems: () => {
      const copyableKeyframes = copyableKeyframesFromSelection(props.leaf.sheetObject.address.projectId, props.leaf.sheetObject.address.sheetId, props.selection);
      return [
        {
          label: copyableKeyframes.length > 0 ? "Copy (selection)" : "Copy",
          callback: () => {
            if (copyableKeyframes.length > 0) {
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(copyableKeyframes);
              });
            } else {
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes([
                  { keyframe: props.keyframe, pathToProp: props.leaf.pathToProp }
                ]);
              });
            }
          }
        },
        {
          label: props.selection !== void 0 ? "Delete (selection)" : "Delete",
          callback: () => {
            if (props.selection) {
              props.selection.delete();
            } else {
              getStudio().transaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, props.leaf.sheetObject.address), {
                  keyframeIds: [props.keyframe.id],
                  trackId: props.leaf.trackId
                }));
              });
            }
          }
        }
      ];
    },
    onOpen() {
      logger._debug("Show keyframe", props);
    }
  });
}
function useDragForSingleKeyframeDot(node, props, options2) {
  const propsRef = (0, import_react176.useRef)(props);
  propsRef.current = props;
  const { onClickFromDrag } = options2;
  const useDragOpts = (0, import_react176.useMemo)(() => {
    return {
      debugName: "KeyframeDot/useDragKeyframe",
      onDragStart(event) {
        const props2 = propsRef.current;
        const tracksByObject = (0, import_dataverse52.val)(getStudio().atomP.historic.coreByProject[props2.leaf.sheetObject.address.projectId].sheetsById[props2.leaf.sheetObject.address.sheetId].sequence.tracksByObject);
        const snapPositions = collectKeyframeSnapPositions(tracksByObject, function shouldIncludeKeyfram(keyframe, { trackId, objectKey }) {
          var _a2, _b;
          return keyframe.id !== props2.keyframe.id && !(props2.selection && ((_b = (_a2 = props2.selection.byObjectKey[objectKey]) == null ? void 0 : _a2.byTrackId[trackId]) == null ? void 0 : _b.byKeyframeId[keyframe.id]));
        });
        snapToSome(snapPositions);
        if (props2.selection) {
          const { selection, leaf } = props2;
          const { sheetObject } = leaf;
          const handlers = selection.getDragHandlers(__spreadProps(__spreadValues({}, sheetObject.address), {
            domNode: node,
            positionAtStartOfDrag: props2.track.data.keyframes[props2.index].position
          })).onDragStart(event);
          return handlers && __spreadProps(__spreadValues({}, handlers), {
            onClick: onClickFromDrag,
            onDragEnd: (...args) => {
              var _a2;
              (_a2 = handlers.onDragEnd) == null ? void 0 : _a2.call(handlers, ...args);
              snapToNone();
            }
          });
        }
        const propsAtStartOfDrag = props2;
        const toUnitSpace = (0, import_dataverse52.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        let tempTransaction;
        return {
          onDrag(dx, dy, event2) {
            var _a2;
            const original = propsAtStartOfDrag.track.data.keyframes[propsAtStartOfDrag.index];
            const newPosition = Math.max((_a2 = DopeSnap_default.checkIfMouseEventSnapToPos(event2, {
              ignore: node
            })) != null ? _a2 : original.position + toUnitSpace(dx), 0);
            tempTransaction == null ? void 0 : tempTransaction.discard();
            tempTransaction = void 0;
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.leaf.sheetObject.address), {
                trackId: propsAtStartOfDrag.leaf.trackId,
                keyframes: [__spreadProps(__spreadValues({}, original), { position: newPosition })],
                snappingFunction: (0, import_dataverse52.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition
              }));
            });
          },
          onDragEnd(dragHappened) {
            if (dragHappened) {
              tempTransaction == null ? void 0 : tempTransaction.commit();
            } else {
              tempTransaction == null ? void 0 : tempTransaction.discard();
            }
            snapToNone();
          },
          onClick(ev) {
            onClickFromDrag(ev);
          }
        };
      }
    };
  }, [onClickFromDrag]);
  const [isDragging] = useDrag(node, useDragOpts);
  useLockFrameStampPosition(isDragging, props.keyframe.position);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "ew-resize");
  return [isDragging];
}
var import_react176, import_dataverse52, DOT_SIZE_PX, DOT_HOVER_SIZE_PX, dotTheme, selectBacgroundForDiamond, Diamond, HitZone4, SingleKeyframeDot, SingleKeyframeDot_default;
var init_SingleKeyframeDot = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/SingleKeyframeDot.tsx"() {
    import_react176 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_getStudio();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_dataverse52 = __toModule(require("@theatre/dataverse"));
    init_FrameStampPositionProvider();
    init_PointerEventsHandler();
    init_DopeSnap();
    init_absoluteDims();
    init_useLogger();
    init_selections();
    init_css();
    init_KeyframeSnapTarget();
    init_useSingleKeyframeInlineEditorPopover();
    init_usePresence();
    DOT_SIZE_PX = 6;
    DOT_HOVER_SIZE_PX = DOT_SIZE_PX + 2;
    dotTheme = {
      normalColor: "#40AAA4",
      selectedColor: "#F2C95C",
      inlineEditorOpenColor: "#FCF3DC",
      selectedAndInlineEditorOpenColor: "#CBEBEA"
    };
    selectBacgroundForDiamond = ({
      isSelected,
      isInlineEditorPopoverOpen
    }) => {
      if (isSelected && isInlineEditorPopoverOpen) {
        return dotTheme.inlineEditorOpenColor;
      } else if (isSelected) {
        return dotTheme.selectedColor;
      } else if (isInlineEditorPopoverOpen) {
        return dotTheme.selectedAndInlineEditorOpenColor;
      } else {
        return dotTheme.normalColor;
      }
    };
    Diamond = styled_components_browser_esm_default.div`
  position: absolute;
  ${absoluteDims(DOT_SIZE_PX)}

  background: ${(props) => selectBacgroundForDiamond(props)};
  transform: rotateZ(45deg);

  ${(props) => props.flag === PresenceFlag.Primary ? "outline: 2px solid white;" : ""};

  z-index: 1;
  pointer-events: none;
`;
    HitZone4 = styled_components_browser_esm_default.div`
  z-index: 1;
  cursor: ew-resize;

  position: absolute;
  ${absoluteDims(12)};
  ${pointerEventsAutoInNormalMode};

  & + ${Diamond} {
    ${(props) => props.isInlineEditorPopoverOpen ? absoluteDims(DOT_HOVER_SIZE_PX) : ""}
  }

  &:hover + ${Diamond} {
    ${absoluteDims(DOT_HOVER_SIZE_PX)}
  }
`;
    SingleKeyframeDot = (props) => {
      const logger = useLogger("SingleKeyframeDot", props.keyframe.id);
      const presence = usePresence(props.itemKey);
      const [ref, node] = useRefAndState(null);
      const [contextMenu] = useSingleKeyframeContextMenu(node, logger, props);
      const {
        node: inlineEditorPopover,
        toggle: toggleEditor,
        isOpen: isInlineEditorPopoverOpen
      } = useKeyframeInlineEditorPopover([
        {
          type: "primitiveProp",
          keyframe: props.keyframe,
          pathToProp: props.leaf.pathToProp,
          propConfig: props.leaf.propConf,
          sheetObject: props.leaf.sheetObject,
          trackId: props.leaf.trackId
        }
      ]);
      const [isDragging] = useDragForSingleKeyframeDot(node, props, {
        onClickFromDrag(dragStartEvent) {
          toggleEditor(dragStartEvent, ref.current);
        }
      });
      return /* @__PURE__ */ import_react176.default.createElement(import_react176.default.Fragment, null, /* @__PURE__ */ import_react176.default.createElement(HitZone4, __spreadValues({
        ref,
        isInlineEditorPopoverOpen
      }, presence.attrs)), /* @__PURE__ */ import_react176.default.createElement(Diamond, {
        isSelected: !!props.selection,
        isInlineEditorPopoverOpen,
        flag: presence.flag
      }), inlineEditorPopover, contextMenu);
    };
    SingleKeyframeDot_default = SingleKeyframeDot;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/keyframeRowUI/ConnectorLine.tsx
var import_react177, CONNECTOR_HEIGHT, CONNECTOR_WIDTH_UNSCALED, CONNECTOR_THEME, Container43, ConnectorLine;
var init_ConnectorLine = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/keyframeRowUI/ConnectorLine.tsx"() {
    init_polished_esm();
    import_react177 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SingleKeyframeDot();
    CONNECTOR_HEIGHT = DOT_SIZE_PX / 2 + 1;
    CONNECTOR_WIDTH_UNSCALED = 1e3;
    CONNECTOR_THEME = {
      normalColor: `#365b59`,
      selectedColor: `#8A7842`,
      barColor: (values) => {
        const base = values.isSelected ? CONNECTOR_THEME.selectedColor : CONNECTOR_THEME.normalColor;
        return values.isPopoverOpen ? curriedSaturate(0.2, curriedLighten(0.2, base)) : base;
      },
      hoverColor: (values) => {
        const base = values.isSelected ? CONNECTOR_THEME.selectedColor : CONNECTOR_THEME.normalColor;
        return values.isPopoverOpen ? curriedSaturate(0.2, curriedLighten(0.2, base)) : curriedSaturate(0.1, curriedLighten(0.1, base));
      }
    };
    Container43 = styled_components_browser_esm_default.div`
  position: absolute;
  background: ${CONNECTOR_THEME.barColor};
  height: ${CONNECTOR_HEIGHT}px;
  width: ${CONNECTOR_WIDTH_UNSCALED}px;

  left: 0;
  top: -${CONNECTOR_HEIGHT / 2}px;
  transform-origin: top left;
  z-index: 0;
  cursor: ew-resize;

  &:after {
    display: block;
    position: absolute;
    content: ' ';
    top: -4px;
    bottom: -4px;
    left: 0;
    right: 0;
  }

  &:hover {
    background: ${CONNECTOR_THEME.hoverColor};
  }
`;
    ConnectorLine = import_react177.default.forwardRef((props, ref) => {
      const themeValues = {
        isPopoverOpen: props.isPopoverOpen,
        isSelected: props.isSelected
      };
      return /* @__PURE__ */ import_react177.default.createElement(Container43, __spreadProps(__spreadValues({}, themeValues), {
        ref,
        style: {
          transform: `scaleX(calc(var(--unitSpaceToScaledSpaceMultiplier) * ${props.connectorLengthInUnitSpace / CONNECTOR_WIDTH_UNSCALED}))`
        },
        onClick: (e2) => {
          var _a2;
          (_a2 = props.openPopover) == null ? void 0 : _a2.call(props, e2);
        }
      }), props.children);
    });
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/BasicKeyframeConnector.tsx
function useDragKeyframe(node, props) {
  const propsRef = (0, import_react179.useRef)(props);
  propsRef.current = props;
  const gestureHandlers = (0, import_react179.useMemo)(() => {
    return {
      debugName: "useDragKeyframe",
      lockCSSCursorTo: "ew-resize",
      onDragStart(event) {
        const props2 = propsRef.current;
        let tempTransaction;
        if (props2.selection) {
          const { selection, leaf } = props2;
          const { sheetObject } = leaf;
          return selection.getDragHandlers(__spreadProps(__spreadValues({}, sheetObject.address), {
            domNode: node,
            positionAtStartOfDrag: props2.track.data.keyframes[props2.index].position
          })).onDragStart(event);
        }
        const propsAtStartOfDrag = props2;
        const sequence = (0, import_dataverse53.val)(propsAtStartOfDrag.layoutP.sheet).getSequence();
        const toUnitSpace = (0, import_dataverse53.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        return {
          onDrag(dx, dy, event2) {
            const delta = toUnitSpace(dx);
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.transformKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.leaf.sheetObject.address), {
                trackId: propsAtStartOfDrag.leaf.trackId,
                keyframeIds: [
                  propsAtStartOfDrag.keyframe.id,
                  propsAtStartOfDrag.track.data.keyframes[propsAtStartOfDrag.index + 1].id
                ],
                translate: delta,
                scale: 1,
                origin: 0,
                snappingFunction: sequence.closestGridPosition
              }));
            });
          },
          onDragEnd(dragHappened) {
            if (dragHappened) {
              if (tempTransaction) {
                tempTransaction.commit();
              }
            } else {
              if (tempTransaction) {
                tempTransaction.discard();
              }
            }
          }
        };
      }
    };
  }, []);
  useDrag(node, gestureHandlers);
}
function useConnectorContextMenu(props, node, cur, next) {
  return useContextMenu(node, {
    displayName: "Tween",
    menuItems: () => {
      const copyableKeyframes = copyableKeyframesFromSelection(props.leaf.sheetObject.address.projectId, props.leaf.sheetObject.address.sheetId, props.selection);
      return [
        {
          label: copyableKeyframes.length > 0 ? "Copy (selection)" : "Copy",
          callback: () => {
            if (copyableKeyframes.length > 0) {
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(copyableKeyframes);
              });
            } else {
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes([
                  { keyframe: cur, pathToProp: props.leaf.pathToProp },
                  { keyframe: next, pathToProp: props.leaf.pathToProp }
                ]);
              });
            }
          }
        },
        {
          label: props.selection ? "Delete (selection)" : "Delete",
          callback: () => {
            if (props.selection) {
              props.selection.delete();
            } else {
              getStudio().transaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, props.leaf.sheetObject.address), {
                  keyframeIds: [cur.id, next.id],
                  trackId: props.leaf.trackId
                }));
              });
            }
          }
        }
      ];
    }
  });
}
var import_dataverse53, import_react178, import_react179, POPOVER_MARGIN, EasingPopover, BasicKeyframeConnector, BasicKeyframeConnector_default, SingleCurveEditorPopover;
var init_BasicKeyframeConnector = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/BasicKeyframeConnector.tsx"() {
    init_getStudio();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_dataverse53 = __toModule(require("@theatre/dataverse"));
    import_react178 = __toModule(require_react());
    import_react179 = __toModule(require_react());
    init_usePopover();
    init_BasicPopover();
    init_CurveEditorPopover();
    init_ConnectorLine();
    init_colors();
    init_src();
    init_selections();
    init_selections();
    init_styled_components_browser_esm();
    POPOVER_MARGIN = 5;
    EasingPopover = styled_components_browser_esm_default(BasicPopover_default)`
  --popover-outer-stroke: transparent;
  --popover-inner-stroke: ${COLOR_POPOVER_BACK};
`;
    BasicKeyframeConnector = (props) => {
      const { index, track } = props;
      const cur = track.data.keyframes[index];
      const next = track.data.keyframes[index + 1];
      const [nodeRef, node] = useRefAndState(null);
      const {
        node: popoverNode,
        toggle: togglePopover,
        close: closePopover
      } = usePopover(() => {
        const rightDims = (0, import_dataverse53.val)(props.layoutP.rightDims);
        return {
          debugName: "Connector",
          constraints: {
            minX: rightDims.screenX + POPOVER_MARGIN,
            maxX: rightDims.screenX + rightDims.width - POPOVER_MARGIN
          }
        };
      }, () => /* @__PURE__ */ import_react178.default.createElement(SingleCurveEditorPopover, __spreadProps(__spreadValues({}, props), {
        closePopover
      })));
      const [contextMenu] = useConnectorContextMenu(props, node, cur, next);
      useDragKeyframe(node, props);
      const connectorLengthInUnitSpace = next.position - cur.position;
      const isInCurveEditorPopoverSelection = usePrism(() => isConnectionEditingInCurvePopover(__spreadProps(__spreadValues({}, props.leaf.sheetObject.address), {
        trackId: props.leaf.trackId,
        left: cur,
        right: next
      })), [props.leaf.sheetObject.address, props.leaf.trackId, cur, next]);
      const themeValues = {
        isPopoverOpen: isInCurveEditorPopoverSelection,
        isSelected: props.selection !== void 0
      };
      return /* @__PURE__ */ import_react178.default.createElement(import_react178.default.Fragment, null, /* @__PURE__ */ import_react178.default.createElement(ConnectorLine, __spreadProps(__spreadValues({
        ref: nodeRef,
        connectorLengthInUnitSpace
      }, themeValues), {
        openPopover: (e2) => {
          if (node)
            togglePopover(e2, node);
        }
      }), popoverNode), contextMenu);
    };
    BasicKeyframeConnector_default = BasicKeyframeConnector;
    SingleCurveEditorPopover = import_react178.default.forwardRef((props, ref) => {
      const {
        index,
        track: { data: trackData },
        selection
      } = props;
      const cur = trackData.keyframes[index];
      const next = trackData.keyframes[index + 1];
      const trackId = props.leaf.trackId;
      const address = props.leaf.sheetObject.address;
      const selectedConnections = usePrism(() => selectedKeyframeConnections(address.projectId, address.sheetId, selection).getValue(), [address, selection]);
      const curveConnection = __spreadValues({
        left: cur,
        right: next,
        trackId
      }, address);
      return /* @__PURE__ */ import_react178.default.createElement(EasingPopover, {
        showPopoverEdgeTriangle: false,
        ref
      }, /* @__PURE__ */ import_react178.default.createElement(CurveEditorPopover_default, {
        curveConnection,
        additionalConnections: selectedConnections,
        onRequestClose: props.closePopover
      }));
    });
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/SingleKeyframeEditor.tsx
var import_dataverse54, import_react181, SingleKeyframeEditorContainer, noConnector, SingleKeyframeEditor, SingleKeyframeEditor_default;
var init_SingleKeyframeEditor = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/KeyframeEditor/SingleKeyframeEditor.tsx"() {
    import_dataverse54 = __toModule(require("@theatre/dataverse"));
    import_react181 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_BasicKeyframeConnector();
    init_SingleKeyframeDot();
    SingleKeyframeEditorContainer = styled_components_browser_esm_default.div`
  position: absolute;
`;
    noConnector = /* @__PURE__ */ import_react181.default.createElement(import_react181.default.Fragment, null);
    SingleKeyframeEditor = import_react181.default.memo((props) => {
      const {
        index,
        track: { data: trackData }
      } = props;
      const cur = trackData.keyframes[index];
      const next = trackData.keyframes[index + 1];
      const connected = cur.connectedRight && !!next;
      return /* @__PURE__ */ import_react181.default.createElement(SingleKeyframeEditorContainer, {
        style: {
          top: `${props.leaf.nodeHeight / 2}px`,
          left: `calc(${(0, import_dataverse54.val)(props.layoutP.scaledSpace.leftPadding)}px + calc(var(--unitSpaceToScaledSpaceMultiplier) * ${cur.position}px))`
        }
      }, /* @__PURE__ */ import_react181.default.createElement(SingleKeyframeDot_default, __spreadProps(__spreadValues({}, props), {
        itemKey: props.itemKey
      })), connected ? /* @__PURE__ */ import_react181.default.createElement(BasicKeyframeConnector_default, __spreadValues({}, props)) : noConnector);
    });
    SingleKeyframeEditor_default = SingleKeyframeEditor;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/BasicKeyframedTrack.tsx
function useBasicKeyframedTrackContextMenu(node, props) {
  return useContextMenu(node, {
    displayName: "Keyframe Track",
    menuItems: () => {
      var _a2;
      const selectionKeyframes = (_a2 = (0, import_dataverse55.val)(getStudio().atomP.ahistoric.clipboard.keyframesWithRelativePaths)) != null ? _a2 : [];
      return [pasteKeyframesContextMenuItem(props, selectionKeyframes)];
    }
  });
}
function pasteKeyframesContextMenuItem(props, keyframes) {
  return {
    label: "Paste Keyframes",
    enabled: keyframes.length > 0,
    callback: () => {
      var _a2;
      const sheet = (0, import_dataverse55.val)(props.layoutP.sheet);
      const sequence = sheet.getSequence();
      const firstPath = (_a2 = keyframes[0]) == null ? void 0 : _a2.pathToProp;
      const singleTrackKeyframes = keyframes.filter(({ keyframe, pathToProp }) => arePathsEqual(firstPath, pathToProp)).map(({ keyframe, pathToProp }) => keyframe);
      getStudio().transaction(({ stateEditors: stateEditors2 }) => {
        var _a3;
        sequence.position = sequence.closestGridPosition(sequence.position);
        const keyframeOffset = (_a3 = earliestKeyframe(singleTrackKeyframes)) == null ? void 0 : _a3.position;
        for (const keyframe of singleTrackKeyframes) {
          stateEditors2.coreByProject.historic.sheetsById.sequence.setKeyframeAtPosition(__spreadProps(__spreadValues({}, props.leaf.sheetObject.address), {
            trackId: props.leaf.trackId,
            position: sequence.position + keyframe.position - keyframeOffset,
            handles: keyframe.handles,
            value: keyframe.value,
            snappingFunction: sequence.closestGridPosition
          }));
        }
      });
    }
  };
}
function earliestKeyframe(keyframes) {
  let curEarliest = null;
  for (const keyframe of keyframes) {
    if (curEarliest === null || keyframe.position < curEarliest.position) {
      curEarliest = keyframe;
    }
  }
  return curEarliest;
}
var import_dataverse55, import_react183, Container44, BasicKeyframedTrack, BasicKeyframedTrack_default;
var init_BasicKeyframedTrack = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/BasicKeyframedTrack/BasicKeyframedTrack.tsx"() {
    init_src();
    import_dataverse55 = __toModule(require("@theatre/dataverse"));
    import_react183 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SingleKeyframeEditor();
    init_useContextMenu();
    init_useRefAndState();
    init_getStudio();
    init_addresses();
    init_KeyframeSnapTarget();
    init_ids();
    Container44 = styled_components_browser_esm_default.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
    BasicKeyframedTrack = import_react183.default.memo((props) => {
      var _a2;
      const { layoutP, trackData, leaf } = props;
      const [containerRef, containerNode] = useRefAndState(null);
      const { selectedKeyframeIds, selection } = usePrism(() => {
        const selectionAtom = (0, import_dataverse55.val)(layoutP.selectionAtom);
        const selectedKeyframeIds2 = (0, import_dataverse55.val)(selectionAtom.pointer.current.byObjectKey[leaf.sheetObject.address.objectKey].byTrackId[leaf.trackId].byKeyframeId);
        if (selectedKeyframeIds2) {
          return {
            selectedKeyframeIds: selectedKeyframeIds2,
            selection: (0, import_dataverse55.val)(selectionAtom.pointer.current)
          };
        } else {
          return {
            selectedKeyframeIds: {},
            selection: void 0
          };
        }
      }, [layoutP, leaf.trackId]);
      const [contextMenu, _3, isOpen] = useBasicKeyframedTrackContextMenu(containerNode, props);
      const snapPositionsState = useVal(snapPositionsStateD);
      const snapPositions = snapPositionsState.mode === "snapToSome" ? (_a2 = snapPositionsState.positions[leaf.sheetObject.address.objectKey]) == null ? void 0 : _a2[leaf.trackId] : [];
      const snapToAllKeyframes = snapPositionsState.mode === "snapToAll";
      const track = (0, import_react183.useMemo)(() => ({
        data: trackData,
        id: leaf.trackId,
        sheetObject: props.leaf.sheetObject
      }), [trackData, leaf.trackId]);
      const keyframeEditors = trackData.keyframes.map((kf, index) => /* @__PURE__ */ import_react183.default.createElement(SingleKeyframeEditor_default, {
        key: "keyframe-" + kf.id,
        itemKey: createStudioSheetItemKey.forTrackKeyframe(leaf.sheetObject, leaf.trackId, kf.id),
        keyframe: kf,
        index,
        track,
        layoutP,
        leaf,
        selection: selectedKeyframeIds[kf.id] === true ? selection : void 0
      }));
      const snapTargets = snapPositions.map((position2) => /* @__PURE__ */ import_react183.default.createElement(KeyframeSnapTarget_default, {
        key: "snap-target-" + position2,
        layoutP,
        leaf,
        position: position2
      }));
      const additionalSnapTargets = !snapToAllKeyframes ? null : trackData.keyframes.map((kf) => /* @__PURE__ */ import_react183.default.createElement(KeyframeSnapTarget_default, {
        key: `additionalSnapTarget-${kf.id}`,
        layoutP,
        leaf,
        position: kf.position
      }));
      return /* @__PURE__ */ import_react183.default.createElement(Container44, {
        ref: containerRef,
        style: {
          background: isOpen ? "#444850 " : "unset"
        }
      }, keyframeEditors, snapTargets, /* @__PURE__ */ import_react183.default.createElement(import_react183.default.Fragment, null, additionalSnapTargets), contextMenu);
    });
    BasicKeyframedTrack.displayName = `BasicKeyframedTrack`;
    BasicKeyframedTrack_default = BasicKeyframedTrack;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/PrimitivePropRow.tsx
var import_dataverse56, import_react185, PrimitivePropRow2, PrimitivePropRow_default2;
var init_PrimitivePropRow2 = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/PrimitivePropRow.tsx"() {
    init_getStudio();
    init_src();
    import_dataverse56 = __toModule(require("@theatre/dataverse"));
    import_react185 = __toModule(require_react());
    init_Row();
    init_BasicKeyframedTrack();
    init_useLogger();
    PrimitivePropRow2 = ({ leaf, layoutP }) => {
      const logger = useLogger("PrimitivePropRow", leaf.pathToProp.join());
      return usePrism(() => {
        const { sheetObject } = leaf;
        const { trackId } = leaf;
        const trackData = (0, import_dataverse56.val)(getStudio().atomP.historic.coreByProject[sheetObject.address.projectId].sheetsById[sheetObject.address.sheetId].sequence.tracksByObject[sheetObject.address.objectKey].trackData[trackId]);
        if ((trackData == null ? void 0 : trackData.type) !== "BasicKeyframedTrack") {
          logger.errorDev(`trackData type ${trackData == null ? void 0 : trackData.type} is not yet supported on the sequence editor`);
          return /* @__PURE__ */ import_react185.default.createElement(Row_default, {
            leaf,
            isCollapsed: false,
            node: /* @__PURE__ */ import_react185.default.createElement("div", null)
          });
        } else {
          const node = /* @__PURE__ */ import_react185.default.createElement(BasicKeyframedTrack_default, {
            layoutP,
            trackData,
            leaf
          });
          return /* @__PURE__ */ import_react185.default.createElement(Row_default, {
            leaf,
            isCollapsed: false,
            node
          });
        }
      }, [leaf, layoutP]);
    };
    PrimitivePropRow_default2 = PrimitivePropRow2;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/iif.tsx
function iif(fn2) {
  return fn2();
}
var init_iif = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/iif.tsx"() {
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/useAggregateKeyframeEditorUtils.tsx
function useAggregateKeyframeEditorUtils(props) {
  const { index, aggregateKeyframes, selection } = props;
  return usePrism(getAggregateKeyframeEditorUtilsPrismFn(props), [
    index,
    aggregateKeyframes,
    selection,
    props.viewModel
  ]);
}
function getAggregateKeyframeEditorUtilsPrismFn(props) {
  const { index, aggregateKeyframes, selection } = props;
  const { projectId, sheetId } = props.viewModel.type === "sheet" ? props.viewModel.sheet.address : props.viewModel.sheetObject.address;
  return () => {
    const cur = aggregateKeyframes[index];
    const next = aggregateKeyframes[index + 1];
    const curAndNextAggregateKeyframesMatch = next && cur.keyframes.length === next.keyframes.length && cur.keyframes.every(({ track }, ind) => next.keyframes[ind].track === track);
    const connected = curAndNextAggregateKeyframesMatch ? {
      length: next.position - cur.position,
      selected: cur.selected === AggregateKeyframePositionIsSelected.AllSelected && next.selected === AggregateKeyframePositionIsSelected.AllSelected
    } : null;
    const aggregatedConnections = !connected ? [] : cur.keyframes.map(({ kf, track }, i3) => __spreadProps(__spreadValues({}, track.sheetObject.address), {
      trackId: track.id,
      left: kf,
      right: next.keyframes[i3].kf
    }));
    const allConnections = iif(() => {
      const selectedConnections = import_dataverse57.prism.memo("selectedConnections", () => selectedKeyframeConnections(projectId, sheetId, selection), [projectId, sheetId, selection]).getValue();
      return [...aggregatedConnections, ...selectedConnections];
    });
    const isAggregateEditingInCurvePopover = aggregatedConnections.every((con) => isConnectionEditingInCurvePopover(con));
    const itemKey = import_dataverse57.prism.memo("itemKey", () => {
      if (props.viewModel.type === "sheet") {
        return createStudioSheetItemKey.forSheetAggregateKeyframe(props.viewModel.sheet, cur.position);
      } else if (props.viewModel.type === "sheetObject") {
        return createStudioSheetItemKey.forSheetObjectAggregateKeyframe(props.viewModel.sheetObject, cur.position);
      } else {
        return createStudioSheetItemKey.forCompoundPropAggregateKeyframe(props.viewModel.sheetObject, props.viewModel.pathToProp, cur.position);
      }
    }, [props.viewModel, cur.position]);
    return {
      itemKey,
      cur,
      connected,
      isAggregateEditingInCurvePopover,
      allConnections
    };
  };
}
var import_dataverse57;
var init_useAggregateKeyframeEditorUtils = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/useAggregateKeyframeEditorUtils.tsx"() {
    import_dataverse57 = __toModule(require("@theatre/dataverse"));
    init_ids();
    init_AggregatedKeyframeTrack();
    init_CurveEditorPopover();
    init_src();
    init_selections();
    init_iif();
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeConnector.tsx
function useDragKeyframe2(node, editorProps) {
  const propsRef = (0, import_react187.useRef)(editorProps);
  propsRef.current = editorProps;
  const gestureHandlers = (0, import_react187.useMemo)(() => {
    return {
      debugName: "useDragKeyframe",
      lockCSSCursorTo: "ew-resize",
      onDragStart(event) {
        const props = propsRef.current;
        let tempTransaction;
        const keyframes = props.aggregateKeyframes[props.index].keyframes;
        const { selection, viewModel } = props;
        const address = viewModel.type === "sheet" ? viewModel.sheet.address : viewModel.sheetObject.address;
        if (selection && props.aggregateKeyframes[props.index].selected === AggregateKeyframePositionIsSelected.AllSelected) {
          return selection.getDragHandlers(__spreadProps(__spreadValues({}, address), {
            domNode: node,
            positionAtStartOfDrag: props.aggregateKeyframes[props.index].position
          })).onDragStart(event);
        }
        const propsAtStartOfDrag = props;
        const sequence = (0, import_dataverse58.val)(propsAtStartOfDrag.layoutP.sheet).getSequence();
        const toUnitSpace = (0, import_dataverse58.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        return {
          onDrag(dx, dy, event2) {
            const delta = toUnitSpace(dx);
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              for (const keyframe of keyframes) {
                stateEditors2.coreByProject.historic.sheetsById.sequence.transformKeyframes(__spreadProps(__spreadValues({}, keyframe.track.sheetObject.address), {
                  trackId: keyframe.track.id,
                  keyframeIds: [
                    keyframe.kf.id,
                    keyframe.track.data.keyframes[keyframe.track.data.keyframes.indexOf(keyframe.kf) + 1].id
                  ],
                  translate: delta,
                  scale: 1,
                  origin: 0,
                  snappingFunction: sequence.closestGridPosition
                }));
              }
            });
          },
          onDragEnd(dragHappened) {
            if (dragHappened) {
              if (tempTransaction) {
                tempTransaction.commit();
              }
            } else {
              if (tempTransaction) {
                tempTransaction.discard();
              }
            }
          }
        };
      }
    };
  }, []);
  return useDrag(node, gestureHandlers);
}
function useConnectorContextMenu2(props, node) {
  return useContextMenu(node, {
    displayName: "Aggregate Tween",
    menuItems: () => {
      const kfs = props.utils.allConnections.reduce((acc, con) => {
        var _a2;
        return acc.concat((_a2 = keyframesWithPaths(__spreadProps(__spreadValues({}, con), {
          keyframeIds: [con.left.id, con.right.id]
        }))) != null ? _a2 : []);
      }, []);
      const commonPath = commonRootOfPathsToProps(kfs.map((kf) => kf.pathToProp));
      const keyframesWithCommonRootPath = kfs.map(({ keyframe, pathToProp }) => ({
        keyframe,
        pathToProp: pathToProp.slice(commonPath.length)
      }));
      const viewModel = props.editorProps.viewModel;
      const address = viewModel.type === "sheet" ? viewModel.sheet.address : viewModel.sheetObject.address;
      return [
        {
          label: "Copy",
          callback: () => {
            if (props.editorProps.selection) {
              const copyableKeyframes = copyableKeyframesFromSelection(address.projectId, address.sheetId, props.editorProps.selection);
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(copyableKeyframes);
              });
            } else {
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(keyframesWithCommonRootPath);
              });
            }
          }
        },
        {
          label: "Delete",
          callback: () => {
            if (props.editorProps.selection) {
              props.editorProps.selection.delete();
            } else {
              getStudio().transaction(({ stateEditors: stateEditors2 }) => {
                for (const con of props.utils.allConnections) {
                  stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, address), {
                    objectKey: con.objectKey,
                    keyframeIds: [con.left.id, con.right.id],
                    trackId: con.trackId
                  }));
                }
              });
            }
          }
        }
      ];
    }
  });
}
var import_dataverse58, import_react187, POPOVER_MARGIN_PX, EasingPopoverWrapper, AggregateCurveEditorPopover, AggregateKeyframeConnector;
var init_AggregateKeyframeConnector = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeConnector.tsx"() {
    import_dataverse58 = __toModule(require("@theatre/dataverse"));
    import_react187 = __toModule(require_react());
    init_ConnectorLine();
    init_AggregatedKeyframeTrack();
    init_usePopover();
    init_useRefAndState();
    init_getStudio();
    init_useDrag();
    init_CurveEditorPopover();
    init_useAggregateKeyframeEditorUtils();
    init_styled_components_browser_esm();
    init_BasicPopover();
    init_selections();
    init_useContextMenu();
    init_addresses();
    POPOVER_MARGIN_PX = 5;
    EasingPopoverWrapper = styled_components_browser_esm_default(BasicPopover_default)`
  --popover-outer-stroke: transparent;
  --popover-inner-stroke: rgba(26, 28, 30, 0.97);
`;
    AggregateCurveEditorPopover = import_react187.default.forwardRef((props, ref) => {
      const { allConnections } = useAggregateKeyframeEditorUtils(props);
      return /* @__PURE__ */ import_react187.default.createElement(EasingPopoverWrapper, {
        showPopoverEdgeTriangle: false,
        ref
      }, /* @__PURE__ */ import_react187.default.createElement(CurveEditorPopover_default, {
        curveConnection: allConnections[0],
        additionalConnections: allConnections,
        onRequestClose: props.closePopover
      }));
    });
    AggregateKeyframeConnector = (props) => {
      const [nodeRef, node] = useRefAndState(null);
      const { editorProps } = props;
      const [contextMenu] = useConnectorContextMenu2(props, node);
      const [isDragging] = useDragKeyframe2(node, props.editorProps);
      const {
        node: popoverNode,
        toggle: togglePopover,
        close: closePopover
      } = usePopover(() => {
        const rightDims = (0, import_dataverse58.val)(editorProps.layoutP.rightDims);
        return {
          debugName: "Connector",
          constraints: {
            minX: rightDims.screenX + POPOVER_MARGIN_PX,
            maxX: rightDims.screenX + rightDims.width - POPOVER_MARGIN_PX
          }
        };
      }, () => {
        return /* @__PURE__ */ import_react187.default.createElement(AggregateCurveEditorPopover, __spreadProps(__spreadValues({}, editorProps), {
          closePopover
        }));
      });
      const { connected, isAggregateEditingInCurvePopover } = props.utils;
      return connected || isDragging ? /* @__PURE__ */ import_react187.default.createElement(import_react187.default.Fragment, null, /* @__PURE__ */ import_react187.default.createElement(ConnectorLine, {
        ref: nodeRef,
        connectorLengthInUnitSpace: connected ? connected.length : 0,
        isSelected: connected ? connected.selected : false,
        isPopoverOpen: isAggregateEditingInCurvePopover,
        openPopover: (e2) => {
          if (node)
            togglePopover(e2, node);
        }
      }), popoverNode, contextMenu) : /* @__PURE__ */ import_react187.default.createElement(import_react187.default.Fragment, null);
    };
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeVisualDot.tsx
function AggregateKeyframeVisualDot(props) {
  const theme4 = {
    isSelected: props.isSelected,
    flag: props.flag
  };
  return /* @__PURE__ */ import_react188.default.createElement(DotContainer, null, props.isAllHere ? /* @__PURE__ */ import_react188.default.createElement(AggregateDotAllHereSvg, __spreadValues({}, theme4)) : /* @__PURE__ */ import_react188.default.createElement(AggregateDotSomeHereSvg, __spreadValues({}, theme4)));
}
var import_react188, DOT_SIZE_PX2, DOT_HOVER_SIZE_PX2, DotContainer, HitZone5, SELECTED_COLOR, DEFAULT_PRIMARY_COLOR, DEFAULT_SECONDARY_COLOR, selectionColorAll, selectionColorSome, AggregateDotAllHereSvg, AggregateDotSomeHereSvg;
var init_AggregateKeyframeVisualDot = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeVisualDot.tsx"() {
    import_react188 = __toModule(require_react());
    init_AggregatedKeyframeTrack();
    init_usePresence();
    init_styled_components_browser_esm();
    init_absoluteDims();
    init_css();
    DOT_SIZE_PX2 = 16;
    DOT_HOVER_SIZE_PX2 = DOT_SIZE_PX2 + 2;
    DotContainer = styled_components_browser_esm_default.div`
  position: absolute;
  ${absoluteDims(DOT_SIZE_PX2)}
  z-index: 1;
`;
    HitZone5 = styled_components_browser_esm_default.div`
  z-index: 2;
  cursor: ew-resize;

  position: absolute;
  ${absoluteDims(12)};
  ${pointerEventsAutoInNormalMode};

  &:hover
    + ${DotContainer},
    #pointer-root.draggingPositionInSequenceEditor
    &:hover
    + ${DotContainer} {
    ${absoluteDims(DOT_HOVER_SIZE_PX2)}
  }
`;
    SELECTED_COLOR = "#F2C95C";
    DEFAULT_PRIMARY_COLOR = "#40AAA4";
    DEFAULT_SECONDARY_COLOR = "#45747C";
    selectionColorAll = (theme4) => theme4.isSelected === AggregateKeyframePositionIsSelected.AllSelected ? SELECTED_COLOR : theme4.isSelected === AggregateKeyframePositionIsSelected.AtLeastOneUnselected ? DEFAULT_PRIMARY_COLOR : DEFAULT_SECONDARY_COLOR;
    selectionColorSome = (theme4) => theme4.isSelected === AggregateKeyframePositionIsSelected.AllSelected ? SELECTED_COLOR : theme4.isSelected === AggregateKeyframePositionIsSelected.AtLeastOneUnselected ? DEFAULT_PRIMARY_COLOR : DEFAULT_SECONDARY_COLOR;
    AggregateDotAllHereSvg = (theme4) => /* @__PURE__ */ import_react188.default.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react188.default.createElement("rect", {
      x: "4.46443",
      y: "10.0078",
      width: "5",
      height: "5",
      transform: "rotate(-45 4.46443 10.0078)",
      fill: "#212327",
      stroke: selectionColorSome(theme4)
    }), /* @__PURE__ */ import_react188.default.createElement("rect", {
      x: "3.75732",
      y: "6.01953",
      width: "6",
      height: "6",
      transform: "rotate(-45 3.75732 6.01953)",
      fill: selectionColorAll(theme4),
      stroke: theme4.flag === PresenceFlag.Primary ? "white" : void 0,
      strokeWidth: theme4.flag === PresenceFlag.Primary ? "2px" : void 0
    }));
    AggregateDotSomeHereSvg = (theme4) => /* @__PURE__ */ import_react188.default.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react188.default.createElement("rect", {
      x: "4.46443",
      y: "8",
      width: "5",
      height: "5",
      transform: "rotate(-45 4.46443 8)",
      fill: "#23262B",
      stroke: theme4.flag === PresenceFlag.Primary ? "white" : selectionColorAll(theme4),
      strokeWidth: theme4.flag === PresenceFlag.Primary ? "2px" : void 0
    }));
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeDot.tsx
function sheetObjectBuild(viewModel, keyframes) {
  const children = viewModel.children.map((a4) => a4.type === "propWithChildren" ? propWithChildrenBuild(a4, keyframes) : primitivePropBuild(a4, keyframes)).filter(isOptionsTreeNodeNotNull);
  if (children.length === 0)
    return null;
  return {
    type: "sheetObject",
    sheetObject: viewModel.sheetObject,
    children
  };
}
function propWithChildrenBuild(viewModel, keyframes) {
  const children = viewModel.children.map((a4) => a4.type === "propWithChildren" ? propWithChildrenBuild(a4, keyframes) : primitivePropBuild(a4, keyframes)).filter(isOptionsTreeNodeNotNull);
  if (children.length === 0)
    return null;
  return {
    type: "propWithChildren",
    pathToProp: viewModel.pathToProp,
    propConfig: viewModel.propConf,
    children
  };
}
function primitivePropBuild(viewModelLeaf, keyframes) {
  const keyframe = keyframes.find((kf) => kf.track.id === viewModelLeaf.trackId);
  if (!keyframe)
    return null;
  return {
    type: "primitiveProp",
    keyframe: keyframe.kf,
    pathToProp: viewModelLeaf.pathToProp,
    propConfig: viewModelLeaf.propConf,
    sheetObject: viewModelLeaf.sheetObject,
    trackId: viewModelLeaf.trackId
  };
}
function AggregateKeyframeDot(props) {
  var _a2, _b, _c, _d;
  const { cur } = props.utils;
  const inlineEditorPopover = useKeyframeInlineEditorPopover(props.editorProps.viewModel.type === "sheet" ? null : props.editorProps.viewModel.type === "sheetObject" ? (_b = (_a2 = sheetObjectBuild(props.editorProps.viewModel, cur.keyframes)) == null ? void 0 : _a2.children) != null ? _b : null : (_d = (_c = propWithChildrenBuild(props.editorProps.viewModel, cur.keyframes)) == null ? void 0 : _c.children) != null ? _d : null);
  const presence = usePresence(props.utils.itemKey);
  presence.useRelations(() => cur.keyframes.map((kf) => ({
    affects: kf.itemKey,
    flag: PresenceFlag.Primary
  })), [
    cur.keyframes.map((keyframeWithTrack) => keyframeWithTrack.track.id).join("-")
  ]);
  const [ref, node] = useRefAndState(null);
  const [contextMenu] = useAggregateKeyframeContextMenu(props, node);
  return /* @__PURE__ */ import_react189.default.createElement(import_react189.default.Fragment, null, /* @__PURE__ */ import_react189.default.createElement(HitZone5, __spreadProps(__spreadValues(__spreadValues({
    ref
  }, presence.attrs), DopeSnap_default.includePositionSnapAttrs(cur.position)), {
    onClick: (e2) => props.editorProps.viewModel.type !== "sheet" ? inlineEditorPopover.open(e2, ref.current) : null
  })), /* @__PURE__ */ import_react189.default.createElement(AggregateKeyframeVisualDot, {
    flag: presence.flag,
    isAllHere: cur.allHere,
    isSelected: cur.selected
  }), contextMenu, inlineEditorPopover.node);
}
function useAggregateKeyframeContextMenu(props, target) {
  return useContextMenu(target, {
    displayName: "Aggregate Keyframe",
    menuItems: () => {
      const viewModel = props.editorProps.viewModel;
      const selection = props.editorProps.selection;
      return [
        {
          label: selection ? "Copy (selection)" : "Copy",
          callback: () => {
            if (selection) {
              const { projectId, sheetId } = viewModel.type === "sheet" ? viewModel.sheet.address : viewModel.sheetObject.address;
              const copyableKeyframes = copyableKeyframesFromSelection(projectId, sheetId, selection);
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(copyableKeyframes);
              });
            } else {
              const kfs = props.utils.cur.keyframes.flatMap((kfWithTrack) => {
                var _a2;
                return (_a2 = keyframesWithPaths(__spreadProps(__spreadValues({}, kfWithTrack.track.sheetObject.address), {
                  trackId: kfWithTrack.track.id,
                  keyframeIds: [kfWithTrack.kf.id]
                }))) != null ? _a2 : [];
              });
              const basePathRelativeToSheet = viewModel.type === "sheet" ? [] : viewModel.type === "sheetObject" ? [viewModel.sheetObject.address.objectKey] : viewModel.type === "propWithChildren" ? [
                viewModel.sheetObject.address.objectKey,
                ...viewModel.pathToProp
              ] : [];
              const commonPath = commonRootOfPathsToProps([
                basePathRelativeToSheet,
                ...kfs.map((kf) => kf.pathToProp)
              ]);
              const keyframesWithCommonRootPath = kfs.map(({ keyframe, pathToProp }) => ({
                keyframe,
                pathToProp: pathToProp.slice(commonPath.length)
              }));
              getStudio().transaction((api) => {
                api.stateEditors.studio.ahistoric.setClipboardKeyframes(keyframesWithCommonRootPath);
              });
            }
          }
        },
        {
          label: selection ? "Delete (selection)" : "Delete",
          callback: () => {
            if (selection) {
              selection.delete();
            } else {
              getStudio().transaction(({ stateEditors: stateEditors2 }) => {
                for (const kfWithTrack of props.utils.cur.keyframes) {
                  stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, kfWithTrack.track.sheetObject.address), {
                    keyframeIds: [kfWithTrack.kf.id],
                    trackId: kfWithTrack.track.id
                  }));
                }
              });
            }
          }
        }
      ];
    }
  });
}
var import_react189, isOptionsTreeNodeNotNull;
var init_AggregateKeyframeDot = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeDot.tsx"() {
    import_react189 = __toModule(require_react());
    init_useRefAndState();
    init_usePresence();
    init_useContextMenu();
    init_AggregateKeyframeVisualDot();
    init_getStudio();
    init_selections();
    init_addresses();
    init_DopeSnap();
    init_useSingleKeyframeInlineEditorPopover();
    isOptionsTreeNodeNotNull = (a4) => a4 !== null;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeEditor.tsx
var import_dataverse59, import_react190, AggregateKeyframeEditorContainer, AggregateKeyframeEditor, AggregateKeyframeEditor_default;
var init_AggregateKeyframeEditor = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregateKeyframeEditor/AggregateKeyframeEditor.tsx"() {
    import_dataverse59 = __toModule(require("@theatre/dataverse"));
    import_react190 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_AggregateKeyframeConnector();
    init_useAggregateKeyframeEditorUtils();
    init_AggregateKeyframeDot();
    AggregateKeyframeEditorContainer = styled_components_browser_esm_default.div`
  position: absolute;
`;
    AggregateKeyframeEditor = import_react190.default.memo((props) => {
      const utils2 = useAggregateKeyframeEditorUtils(props);
      return /* @__PURE__ */ import_react190.default.createElement(AggregateKeyframeEditorContainer, {
        style: {
          top: `${props.viewModel.nodeHeight / 2}px`,
          left: `calc(${(0, import_dataverse59.val)(props.layoutP.scaledSpace.leftPadding)}px + calc(var(--unitSpaceToScaledSpaceMultiplier) * ${utils2.cur.position}px))`
        }
      }, /* @__PURE__ */ import_react190.default.createElement(AggregateKeyframeDot, {
        editorProps: props,
        utils: utils2
      }), /* @__PURE__ */ import_react190.default.createElement(AggregateKeyframeConnector, {
        editorProps: props,
        utils: utils2
      }));
    });
    AggregateKeyframeEditor_default = AggregateKeyframeEditor;
  }
});

// shared/src/utils/index.ts
var emptyObject, emptyArray;
var init_utils2 = __esm({
  "shared/src/utils/index.ts"() {
    emptyObject = {};
    emptyArray = [];
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregatedKeyframeTrack.tsx
function AggregatedKeyframeTrack_memo(props) {
  const { layoutP, aggregatedKeyframes, viewModel } = props;
  const logger = useLogger("AggregatedKeyframeTrack");
  const [containerRef, containerNode] = useRefAndState(null);
  const { selectedPositions, selection } = useCollectedSelectedPositions(layoutP, aggregatedKeyframes);
  const [contextMenu, _3, isOpen] = useAggregatedKeyframeTrackContextMenu(containerNode, props, () => logger._debug("see aggregatedKeyframes", props.aggregatedKeyframes));
  const posKfs = (0, import_react192.useMemo)(() => [...aggregatedKeyframes.byPosition.entries()].sort((a4, b4) => a4[0] - b4[0]).map(([position2, keyframes]) => ({
    position: position2,
    keyframes,
    selected: selectedPositions.get(position2),
    allHere: keyframes.length === aggregatedKeyframes.tracks.length
  })), [aggregatedKeyframes, selectedPositions]);
  const snapPositionsState = useVal(snapPositionsStateD);
  const snapToAllKeyframes = snapPositionsState.mode === "snapToAll";
  const snapPositions = snapPositionsState.mode === "snapToSome" ? snapPositionsState.positions : emptyObject;
  const aggregateSnapPositions = (0, import_react192.useMemo)(() => viewModel.type === "sheet" ? collectAggregateSnapPositionsSheet(viewModel, snapPositions) : collectAggregateSnapPositionsObjectOrCompound(viewModel, snapPositions), [snapPositions]);
  const snapTargets = aggregateSnapPositions.map((position2) => /* @__PURE__ */ import_react192.default.createElement(KeyframeSnapTarget_default, {
    key: "snap-target-" + position2,
    layoutP,
    leaf: viewModel,
    position: position2
  }));
  const keyframeEditorProps = (0, import_react192.useMemo)(() => posKfs.map(({ position: position2, keyframes }, index) => ({
    position: position2,
    editorProps: {
      index,
      layoutP,
      viewModel,
      aggregateKeyframes: posKfs,
      selection: selectedPositions.has(position2) ? selection : void 0
    }
  })), [posKfs, viewModel, selectedPositions]);
  const [isDragging] = useDragForAggregateKeyframeDot(containerNode, (position2) => {
    var _a2;
    return (_a2 = keyframeEditorProps.find((editorProp) => editorProp.position === position2)) == null ? void 0 : _a2.editorProps;
  }, {
    onClickFromDrag(dragStartEvent) {
    }
  });
  const keyframeEditors = keyframeEditorProps.map((props2, i3) => /* @__PURE__ */ import_react192.default.createElement(import_react192.Fragment, {
    key: "agg-" + posKfs[i3].keyframes[0].kf.id
  }, snapToAllKeyframes && /* @__PURE__ */ import_react192.default.createElement(KeyframeSnapTarget_default, {
    layoutP,
    leaf: viewModel,
    position: props2.position
  }), /* @__PURE__ */ import_react192.default.createElement(AggregateKeyframeEditor_default, __spreadValues({}, props2.editorProps))));
  return /* @__PURE__ */ import_react192.default.createElement(AggregatedKeyframeTrackContainer, {
    ref: containerRef,
    style: {
      background: isOpen ? "#444850 " : "unset"
    }
  }, keyframeEditors, snapTargets, contextMenu);
}
function useCollectedSelectedPositions(layoutP, aggregatedKeyframes) {
  return usePrism(() => (0, import_dataverse60.val)(collectedSelectedPositions(layoutP, aggregatedKeyframes)), [layoutP, aggregatedKeyframes]);
}
function collectedSelectedPositions(layoutP, aggregatedKeyframes) {
  return (0, import_dataverse60.prism)(() => {
    const selectionAtom = (0, import_dataverse60.val)(layoutP.selectionAtom);
    const selection = (0, import_dataverse60.val)(selectionAtom.pointer.current);
    if (!selection)
      return EMPTY_SELECTION;
    const selectedAtPositions = new Map();
    for (const [position2, kfsWithTrack] of aggregatedKeyframes.byPosition) {
      const positionIsSelected = allOrSomeOrNoneSelected(kfsWithTrack, selection);
      if (positionIsSelected !== void 0 && positionIsSelected !== NoneSelected) {
        selectedAtPositions.set(position2, positionIsSelected);
      }
    }
    return {
      selectedPositions: selectedAtPositions,
      selection: (0, import_dataverse60.val)(selectionAtom.pointer.current)
    };
  });
}
function allOrSomeOrNoneSelected(keyframeWithTracks, selection) {
  var _a2, _b, _c;
  let positionIsSelected = void 0;
  for (const { track, kf } of keyframeWithTracks) {
    const kfIsSelected = ((_c = (_b = (_a2 = selection.byObjectKey[track.sheetObject.address.objectKey]) == null ? void 0 : _a2.byTrackId[track.id]) == null ? void 0 : _b.byKeyframeId) == null ? void 0 : _c[kf.id]) === true;
    if (positionIsSelected === void 0) {
      if (kfIsSelected) {
        positionIsSelected = AllSelected;
      } else {
        positionIsSelected = NoneSelected;
      }
    } else if (kfIsSelected) {
      if (positionIsSelected === NoneSelected) {
        positionIsSelected = AtLeastOneUnselected;
      }
    } else {
      if (positionIsSelected === AllSelected) {
        positionIsSelected = AtLeastOneUnselected;
      }
    }
  }
  return positionIsSelected;
}
function useAggregatedKeyframeTrackContextMenu(node, props, debugOnOpen) {
  return useContextMenu(node, {
    onOpen: debugOnOpen,
    displayName: "Aggregate Keyframe Track",
    menuItems: () => {
      var _a2;
      const selectionKeyframes = (_a2 = (0, import_dataverse60.valueDerivation)(getStudio().atomP.ahistoric.clipboard.keyframesWithRelativePaths).getValue()) != null ? _a2 : [];
      return [pasteKeyframesContextMenuItem2(props, selectionKeyframes)];
    }
  });
}
function pasteKeyframesContextMenuItem2(props, keyframes) {
  return {
    label: "Paste Keyframes",
    enabled: keyframes.length > 0,
    callback: () => {
      const sheet = (0, import_dataverse60.val)(props.layoutP.sheet);
      const sequence = sheet.getSequence();
      if (props.viewModel.type === "sheet") {
        pasteKeyframesSheet(props.viewModel, keyframes, sequence);
      } else {
        pasteKeyframesObjectOrCompound(props.viewModel, keyframes, sequence);
      }
    }
  };
}
function pasteKeyframesSheet(viewModel, keyframes, sequence) {
  var _a2;
  const { projectId, sheetId, sheetInstanceId } = viewModel.sheet.address;
  const areKeyframesAllOnSingleTrack = keyframes.every(({ pathToProp }) => pathToProp.length === 0);
  if (areKeyframesAllOnSingleTrack) {
    for (const object of viewModel.children.map((child) => child.sheetObject)) {
      const tracksByObject = (0, import_dataverse60.valueDerivation)(getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetId].sequence.tracksByObject[object.address.objectKey]).getValue();
      const trackIdsOnObject = Object.keys((_a2 = tracksByObject == null ? void 0 : tracksByObject.trackData) != null ? _a2 : {});
      pasteKeyframesToMultipleTracks(object.address, trackIdsOnObject, keyframes, sequence);
    }
  } else {
    const tracksByObject = (0, import_dataverse60.valueDerivation)(getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetId].sequence.tracksByObject).getValue();
    const placeableKeyframes = keyframes.map(({ keyframe, pathToProp }) => {
      var _a3, _b;
      const objectKey = pathToProp[0];
      const relativePathToProp = pathToProp.slice(1);
      const pathToPropEncoded = encodePathToProp([...relativePathToProp]);
      const trackIdByPropPath = (_b = (_a3 = tracksByObject == null ? void 0 : tracksByObject[objectKey]) == null ? void 0 : _a3.trackIdByPropPath) != null ? _b : {};
      const maybeTrackId = trackIdByPropPath[pathToPropEncoded];
      return maybeTrackId ? {
        keyframe,
        trackId: maybeTrackId,
        address: {
          objectKey,
          projectId,
          sheetId,
          sheetInstanceId
        }
      } : null;
    }).filter((result2) => result2 !== null);
    pasteKeyframesToSpecificTracks(placeableKeyframes, sequence);
  }
}
function pasteKeyframesObjectOrCompound(viewModel, keyframes, sequence) {
  var _a2;
  const { projectId, sheetId, objectKey } = viewModel.sheetObject.address;
  const trackRecords = (0, import_dataverse60.valueDerivation)(getStudio().atomP.historic.coreByProject[projectId].sheetsById[sheetId].sequence.tracksByObject[objectKey]).getValue();
  const areKeyframesAllOnSingleTrack = keyframes.every(({ pathToProp }) => pathToProp.length === 0);
  if (areKeyframesAllOnSingleTrack) {
    const trackIdsOnObject = Object.keys((_a2 = trackRecords == null ? void 0 : trackRecords.trackData) != null ? _a2 : {});
    if (viewModel.type === "sheetObject") {
      pasteKeyframesToMultipleTracks(viewModel.sheetObject.address, trackIdsOnObject, keyframes, sequence);
    } else {
      const trackIdByPropPath = (trackRecords == null ? void 0 : trackRecords.trackIdByPropPath) || {};
      const trackIdsOnCompoundProp = Object.entries(trackIdByPropPath).filter(([encodedPath, trackId]) => trackId !== void 0 && doesPathStartWith(decodePathToProp(encodedPath), viewModel.pathToProp)).map(([encodedPath, trackId]) => trackId);
      pasteKeyframesToMultipleTracks(viewModel.sheetObject.address, trackIdsOnCompoundProp, keyframes, sequence);
    }
  } else {
    const trackIdByPropPath = (trackRecords == null ? void 0 : trackRecords.trackIdByPropPath) || {};
    const rootPath = viewModel.type === "propWithChildren" ? viewModel.pathToProp : [];
    const placeableKeyframes = keyframes.map(({ keyframe, pathToProp: relativePathToProp }) => {
      const pathToPropEncoded = encodePathToProp([
        ...rootPath,
        ...relativePathToProp
      ]);
      const maybeTrackId = trackIdByPropPath[pathToPropEncoded];
      return maybeTrackId ? {
        keyframe,
        trackId: maybeTrackId,
        address: viewModel.sheetObject.address
      } : null;
    }).filter((result2) => result2 !== null);
    pasteKeyframesToSpecificTracks(placeableKeyframes, sequence);
  }
}
function pasteKeyframesToMultipleTracks(address, trackIds, keyframes, sequence) {
  var _a2;
  sequence.position = sequence.closestGridPosition(sequence.position);
  const keyframeOffset = (_a2 = earliestKeyframe2(keyframes.map(({ keyframe }) => keyframe))) == null ? void 0 : _a2.position;
  getStudio().transaction(({ stateEditors: stateEditors2 }) => {
    for (const trackId of trackIds) {
      for (const { keyframe } of keyframes) {
        stateEditors2.coreByProject.historic.sheetsById.sequence.setKeyframeAtPosition(__spreadProps(__spreadValues({}, address), {
          trackId,
          position: sequence.position + keyframe.position - keyframeOffset,
          handles: keyframe.handles,
          value: keyframe.value,
          snappingFunction: sequence.closestGridPosition
        }));
      }
    }
  });
}
function pasteKeyframesToSpecificTracks(keyframesWithTracksToPlaceThemIn, sequence) {
  var _a2;
  sequence.position = sequence.closestGridPosition(sequence.position);
  const keyframeOffset = (_a2 = earliestKeyframe2(keyframesWithTracksToPlaceThemIn.map(({ keyframe }) => keyframe))) == null ? void 0 : _a2.position;
  getStudio().transaction(({ stateEditors: stateEditors2 }) => {
    for (const {
      keyframe,
      trackId,
      address
    } of keyframesWithTracksToPlaceThemIn) {
      stateEditors2.coreByProject.historic.sheetsById.sequence.setKeyframeAtPosition(__spreadProps(__spreadValues({}, address), {
        trackId,
        position: sequence.position + keyframe.position - keyframeOffset,
        handles: keyframe.handles,
        value: keyframe.value,
        snappingFunction: sequence.closestGridPosition
      }));
    }
  });
}
function earliestKeyframe2(keyframes) {
  let curEarliest = null;
  for (const keyframe of keyframes) {
    if (curEarliest === null || keyframe.position < curEarliest.position) {
      curEarliest = keyframe;
    }
  }
  return curEarliest;
}
function useDragForAggregateKeyframeDot(containerNode, getPropsForPosition, options2) {
  const logger = useLogger("useDragForAggregateKeyframeDot");
  const frameStampLock = useLockFrameStampPositionRef();
  const useDragOpts = (0, import_react192.useMemo)(() => {
    return {
      debugName: "AggregateKeyframeDot/useDragKeyframe",
      onDragStart(event) {
        logger._debug("onDragStart", { target: event.target });
        const positionToFind = Number(event.target.dataset.pos);
        const props = getPropsForPosition(positionToFind);
        if (!props) {
          logger._debug("no props found for ", { positionToFind });
          return false;
        }
        frameStampLock(true, positionToFind);
        const keyframes = (0, import_dataverse60.prism)(getAggregateKeyframeEditorUtilsPrismFn(props)).getValue().cur.keyframes;
        const address = props.viewModel.type === "sheet" ? props.viewModel.sheet.address : props.viewModel.sheetObject.address;
        const tracksByObject = (0, import_dataverse60.val)(getStudio().atomP.historic.coreByProject[address.projectId].sheetsById[address.sheetId].sequence.tracksByObject);
        const snapPositions = collectKeyframeSnapPositions(tracksByObject, function shouldIncludeKeyfram(keyframe, { trackId, objectKey }) {
          var _a2, _b;
          return keyframes.every((kfWithTrack) => keyframe.id !== kfWithTrack.kf.id) && !(props.selection && ((_b = (_a2 = props.selection.byObjectKey[objectKey]) == null ? void 0 : _a2.byTrackId[trackId]) == null ? void 0 : _b.byKeyframeId[keyframe.id]));
        });
        snapToSome(snapPositions);
        if (props.selection && props.aggregateKeyframes[props.index].selected === 0) {
          const { selection, viewModel } = props;
          const handlers = selection.getDragHandlers(__spreadProps(__spreadValues({}, address), {
            domNode: containerNode,
            positionAtStartOfDrag: keyframes[0].kf.position
          })).onDragStart(event);
          return handlers && __spreadProps(__spreadValues({}, handlers), {
            onClick: options2.onClickFromDrag,
            onDragEnd: (...args) => {
              var _a2;
              (_a2 = handlers.onDragEnd) == null ? void 0 : _a2.call(handlers, ...args);
              snapToNone();
            }
          });
        }
        const propsAtStartOfDrag = props;
        const toUnitSpace = (0, import_dataverse60.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        let tempTransaction;
        return {
          onDrag(dx, dy, event2) {
            var _a2;
            const newPosition = Math.max((_a2 = DopeSnap_default.checkIfMouseEventSnapToPos(event2, {})) != null ? _a2 : keyframes[0].kf.position + toUnitSpace(dx), 0);
            frameStampLock(true, newPosition);
            tempTransaction == null ? void 0 : tempTransaction.discard();
            tempTransaction = void 0;
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              for (const keyframe of keyframes) {
                const original = keyframe.kf;
                stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, keyframe.track.sheetObject.address), {
                  trackId: keyframe.track.id,
                  keyframes: [__spreadProps(__spreadValues({}, original), { position: newPosition })],
                  snappingFunction: (0, import_dataverse60.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition
                }));
              }
            });
          },
          onDragEnd(dragHappened) {
            frameStampLock(false, -1);
            if (dragHappened) {
              tempTransaction == null ? void 0 : tempTransaction.commit();
            } else {
              tempTransaction == null ? void 0 : tempTransaction.discard();
              options2.onClickFromDrag(event);
            }
            snapToNone();
          },
          onClick(ev) {
            options2.onClickFromDrag(ev);
          }
        };
      }
    };
  }, [getPropsForPosition, options2.onClickFromDrag]);
  const [isDragging] = useDrag(containerNode, useDragOpts);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "ew-resize");
  return [isDragging];
}
var import_dataverse60, import_react192, AggregatedKeyframeTrackContainer, EMPTY_SELECTION, AggregatedKeyframeTrack, AggregatedKeyframeTrack_default, AggregateKeyframePositionIsSelected, AllSelected, AtLeastOneUnselected, NoneSelected;
var init_AggregatedKeyframeTrack = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/AggregatedKeyframeTrack/AggregatedKeyframeTrack.tsx"() {
    init_src();
    import_dataverse60 = __toModule(require("@theatre/dataverse"));
    import_react192 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_useContextMenu();
    init_useRefAndState();
    init_AggregateKeyframeEditor();
    init_collectAggregateKeyframes();
    init_useLogger();
    init_useAggregateKeyframeEditorUtils();
    init_DopeSnap();
    init_useDrag();
    init_FrameStampPositionProvider();
    init_PointerEventsHandler();
    init_getStudio();
    init_addresses();
    init_KeyframeSnapTarget();
    init_utils2();
    init_KeyframeSnapTarget();
    init_collectAggregateKeyframes();
    AggregatedKeyframeTrackContainer = styled_components_browser_esm_default.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
    EMPTY_SELECTION = Object.freeze({
      selectedPositions: new Map(),
      selection: void 0
    });
    AggregatedKeyframeTrack = import_react192.default.memo(AggregatedKeyframeTrack_memo);
    AggregatedKeyframeTrack_default = AggregatedKeyframeTrack;
    (function(AggregateKeyframePositionIsSelected2) {
      AggregateKeyframePositionIsSelected2[AggregateKeyframePositionIsSelected2["AllSelected"] = 0] = "AllSelected";
      AggregateKeyframePositionIsSelected2[AggregateKeyframePositionIsSelected2["AtLeastOneUnselected"] = 1] = "AtLeastOneUnselected";
      AggregateKeyframePositionIsSelected2[AggregateKeyframePositionIsSelected2["NoneSelected"] = 2] = "NoneSelected";
    })(AggregateKeyframePositionIsSelected || (AggregateKeyframePositionIsSelected = {}));
    ({ AllSelected, AtLeastOneUnselected, NoneSelected } = AggregateKeyframePositionIsSelected);
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/PropWithChildrenRow.tsx
var import_react194, decideRowByPropType2, RightPropWithChildrenRow;
var init_PropWithChildrenRow2 = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/PropWithChildrenRow.tsx"() {
    init_src();
    import_react194 = __toModule(require_react());
    init_PrimitivePropRow2();
    init_Row();
    init_AggregatedKeyframeTrack();
    init_collectAggregateKeyframes();
    init_useLogger();
    decideRowByPropType2 = (leaf, layoutP) => leaf.type === "propWithChildren" ? /* @__PURE__ */ import_react194.default.createElement(RightPropWithChildrenRow, {
      layoutP,
      viewModel: leaf,
      key: "prop" + leaf.pathToProp[leaf.pathToProp.length - 1]
    }) : /* @__PURE__ */ import_react194.default.createElement(PrimitivePropRow_default2, {
      layoutP,
      leaf,
      key: "prop" + leaf.pathToProp[leaf.pathToProp.length - 1]
    });
    RightPropWithChildrenRow = ({ viewModel, layoutP }) => {
      const logger = useLogger("RightPropWithChildrenRow", viewModel.pathToProp.join());
      return usePrism(() => {
        const aggregatedKeyframes = collectAggregateKeyframesInPrism(viewModel);
        const node = /* @__PURE__ */ import_react194.default.createElement(AggregatedKeyframeTrack_default, {
          layoutP,
          aggregatedKeyframes,
          viewModel
        });
        return /* @__PURE__ */ import_react194.default.createElement(ProvideLogger, {
          logger
        }, /* @__PURE__ */ import_react194.default.createElement(Row_default, {
          leaf: viewModel,
          node,
          isCollapsed: viewModel.isCollapsed
        }, viewModel.children.map((propLeaf) => decideRowByPropType2(propLeaf, layoutP))));
      }, [viewModel, layoutP]);
    };
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/SheetObjectRow.tsx
var import_react196, RightSheetObjectRow, SheetObjectRow_default2;
var init_SheetObjectRow2 = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/SheetObjectRow.tsx"() {
    init_src();
    import_react196 = __toModule(require_react());
    init_PropWithChildrenRow2();
    init_Row();
    init_collectAggregateKeyframes();
    init_AggregatedKeyframeTrack();
    RightSheetObjectRow = ({ leaf, layoutP }) => {
      return usePrism(() => {
        const aggregatedKeyframes = collectAggregateKeyframesInPrism(leaf);
        const node = /* @__PURE__ */ import_react196.default.createElement(AggregatedKeyframeTrack_default, {
          layoutP,
          aggregatedKeyframes,
          viewModel: leaf
        });
        return /* @__PURE__ */ import_react196.default.createElement(Row_default, {
          leaf,
          node,
          isCollapsed: leaf.isCollapsed
        }, leaf.children.map((leaf2) => decideRowByPropType2(leaf2, layoutP)));
      }, [leaf, layoutP]);
    };
    SheetObjectRow_default2 = RightSheetObjectRow;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/SheetRow.tsx
var import_react198, SheetRow2, SheetRow_default2;
var init_SheetRow2 = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/SheetRow.tsx"() {
    init_src();
    import_react198 = __toModule(require_react());
    init_SheetObjectRow2();
    init_Row();
    init_collectAggregateKeyframes();
    init_AggregatedKeyframeTrack();
    SheetRow2 = ({ leaf, layoutP }) => {
      return usePrism(() => {
        const aggregatedKeyframes = collectAggregateKeyframesInPrism(leaf);
        const node = /* @__PURE__ */ import_react198.default.createElement(AggregatedKeyframeTrack_default, {
          layoutP,
          aggregatedKeyframes,
          viewModel: leaf
        });
        return /* @__PURE__ */ import_react198.default.createElement(Row_default, {
          leaf,
          node,
          isCollapsed: leaf.isCollapsed
        }, leaf.children.map((sheetObjectLeaf) => /* @__PURE__ */ import_react198.default.createElement(SheetObjectRow_default2, {
          layoutP,
          key: "sheetObject-" + sheetObjectLeaf.sheetObject.address.objectKey,
          leaf: sheetObjectLeaf
        })));
      }, [leaf, layoutP]);
    };
    SheetRow_default2 = SheetRow2;
  }
});

// studio/src/panels/SequenceEditorPanel/DopeSheet/Right/Right.tsx
var import_dataverse61, import_react200, contentWidth, ListContainer2, Right2, Right_default;
var init_Right = __esm({
  "studio/src/panels/SequenceEditorPanel/DopeSheet/Right/Right.tsx"() {
    init_src();
    import_dataverse61 = __toModule(require("@theatre/dataverse"));
    import_react200 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_DopeSheetSelectionView();
    init_HorizontallyScrollableArea();
    init_SheetRow2();
    contentWidth = 1e6;
    ListContainer2 = styled_components_browser_esm_default.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  left: 0;
  width: ${contentWidth}px;
`;
    Right2 = ({ layoutP }) => {
      return usePrism(() => {
        const tree = (0, import_dataverse61.val)(layoutP.tree);
        const height2 = (0, import_dataverse61.val)(layoutP.tree.top) + Math.max((0, import_dataverse61.val)(layoutP.tree.heightIncludingChildren), (0, import_dataverse61.val)(layoutP.dopeSheetDims.height));
        return /* @__PURE__ */ import_react200.default.createElement(import_react200.default.Fragment, null, /* @__PURE__ */ import_react200.default.createElement(HorizontallyScrollableArea_default, {
          layoutP,
          height: height2
        }, /* @__PURE__ */ import_react200.default.createElement(DopeSheetSelectionView_default, {
          layoutP,
          height: height2
        }, /* @__PURE__ */ import_react200.default.createElement(ListContainer2, {
          style: { top: tree.top + "px" }
        }, /* @__PURE__ */ import_react200.default.createElement(SheetRow_default2, {
          leaf: tree,
          layoutP
        })))));
      }, [layoutP]);
    };
    Right_default = Right2;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/Curve.tsx
function transformBox(xInUnitSpace, yInExtremumSpace, widthInUnitSpace, heightInExtremumSpace) {
  const translateX = `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${xInUnitSpace}px)`;
  const translateY = `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${yInExtremumSpace}) * 1px)`;
  if (widthInUnitSpace === 0) {
    widthInUnitSpace = 1e-4;
  }
  const scaleX = `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${widthInUnitSpace})`;
  if (heightInExtremumSpace === 0) {
    heightInExtremumSpace = 1e-3;
  }
  const scaleY = `calc(var(--graphEditorVerticalSpace) * ${heightInExtremumSpace * -1})`;
  return `translate(${translateX}, ${translateY}) scale(${scaleX}, ${scaleY})`;
}
function useConnectorContextMenu3(node, props) {
  const { index, trackData } = props;
  const cur = trackData.keyframes[index];
  const next = trackData.keyframes[index + 1];
  return useContextMenu(node, {
    menuItems: () => {
      return [
        {
          label: "Delete",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              const { deleteKeyframes } = stateEditors2.coreByProject.historic.sheetsById.sequence;
              deleteKeyframes(__spreadProps(__spreadValues({}, props.sheetObject.address), {
                trackId: props.trackId,
                keyframeIds: [cur.id, next.id]
              }));
            });
          }
        }
      ];
    }
  });
}
var import_react201, SVGPath, Curve, Curve_default;
var init_Curve = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/Curve.tsx"() {
    init_utils();
    init_getStudio();
    init_useContextMenu();
    init_useRefAndState();
    import_react201 = __toModule(require_react());
    init_styled_components_browser_esm();
    SVGPath = styled_components_browser_esm_default.path`
  stroke-width: 2;
  stroke: var(--main-color);
  fill: none;
  vector-effect: non-scaling-stroke;
`;
    Curve = (props) => {
      const { index, trackData } = props;
      const cur = trackData.keyframes[index];
      const next = trackData.keyframes[index + 1];
      const connectorLengthInUnitSpace = next.position - cur.position;
      const [nodeRef, node] = useRefAndState(null);
      const [contextMenu] = useConnectorContextMenu3(node, props);
      const curValue = props.isScalar ? valueInProp(cur.value, props.propConfig) : 0;
      const nextValue = props.isScalar ? valueInProp(next.value, props.propConfig) : 1;
      const leftYInExtremumSpace = props.extremumSpace.fromValueSpace(curValue);
      const rightYInExtremumSpace = props.extremumSpace.fromValueSpace(nextValue);
      const heightInExtremumSpace = rightYInExtremumSpace - leftYInExtremumSpace;
      const transform = transformBox(cur.position, leftYInExtremumSpace, connectorLengthInUnitSpace, heightInExtremumSpace);
      const x1 = cur.handles[2];
      const y1 = cur.handles[3];
      const x22 = next.handles[0];
      const y22 = next.handles[1];
      const pathD = `M 0 0 C ${x1} ${y1} ${x22} ${y22} 1 1`;
      return /* @__PURE__ */ import_react201.default.createElement(import_react201.default.Fragment, null, /* @__PURE__ */ import_react201.default.createElement(SVGPath, {
        ref: nodeRef,
        d: pathD,
        style: {
          transform
        }
      }), contextMenu);
    };
    Curve_default = Curve;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/CurveHandle.tsx
function useOurDrags(node, props) {
  const propsRef = (0, import_react202.useRef)(props);
  propsRef.current = props;
  const handlers = (0, import_react202.useMemo)(() => {
    return {
      debugName: "CurveHandler/useOurDrags",
      lockCSSCursorTo: "move",
      onDragStart() {
        let tempTransaction;
        const propsAtStartOfDrag = propsRef.current;
        const scaledToUnitSpace = (0, import_dataverse62.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        const verticalToExtremumSpace = (0, import_dataverse62.val)(propsAtStartOfDrag.layoutP.graphEditorVerticalSpace.toExtremumSpace);
        const unlockExtremums = propsAtStartOfDrag.extremumSpace.lock();
        return {
          onDrag(dxInScaledSpace, dy) {
            if (tempTransaction) {
              tempTransaction.discard();
              tempTransaction = void 0;
            }
            const { index, trackData } = propsAtStartOfDrag;
            const cur = trackData.keyframes[index];
            const next = trackData.keyframes[index + 1];
            const dPosInUnitSpace = scaledToUnitSpace(dxInScaledSpace);
            let dPosInKeyframeDiffSpace = dPosInUnitSpace / (next.position - cur.position);
            const dyInVerticalSpace = -dy;
            const dYInExtremumSpace = verticalToExtremumSpace(dyInVerticalSpace);
            const dYInValueSpace = propsAtStartOfDrag.extremumSpace.deltaToValueSpace(dYInExtremumSpace);
            const curValue = props.isScalar ? cur.value : 0;
            const nextValue = props.isScalar ? next.value : 1;
            const dyInKeyframeDiffSpace = dYInValueSpace / (nextValue - curValue);
            if (propsAtStartOfDrag.which === "left") {
              const handleX = clamp_default(cur.handles[2] + dPosInKeyframeDiffSpace, 0, 1);
              const handleY = cur.handles[3] + dyInKeyframeDiffSpace;
              tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.sheetObject.address), {
                  snappingFunction: (0, import_dataverse62.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition,
                  trackId: propsAtStartOfDrag.trackId,
                  keyframes: [
                    __spreadProps(__spreadValues({}, cur), {
                      handles: [
                        cur.handles[0],
                        cur.handles[1],
                        handleX,
                        handleY
                      ]
                    })
                  ]
                }));
              });
            } else {
              const handleX = clamp_default(next.handles[0] + dPosInKeyframeDiffSpace, 0, 1);
              const handleY = next.handles[1] + dyInKeyframeDiffSpace;
              tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
                stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.sheetObject.address), {
                  trackId: propsAtStartOfDrag.trackId,
                  snappingFunction: (0, import_dataverse62.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition,
                  keyframes: [
                    __spreadProps(__spreadValues({}, next), {
                      handles: [
                        handleX,
                        handleY,
                        next.handles[2],
                        next.handles[3]
                      ]
                    })
                  ]
                }));
              });
            }
          },
          onDragEnd(dragHappened) {
            unlockExtremums();
            if (dragHappened) {
              if (tempTransaction) {
                tempTransaction.commit();
              }
            } else {
              if (tempTransaction) {
                tempTransaction.discard();
              }
            }
          }
        };
      }
    };
  }, []);
  useDrag(node, handlers);
}
function useOurContextMenu(node, props) {
  return useContextMenu(node, {
    menuItems: () => {
      return [
        {
          label: "Delete",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, props.sheetObject.address), {
                keyframeIds: [props.keyframe.id],
                trackId: props.trackId
              }));
            });
          }
        }
      ];
    }
  });
}
var import_dataverse62, import_react202, Circle2, HitZone6, Line2, CurveHandle, CurveHandle_default;
var init_CurveHandle = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/CurveHandle.tsx"() {
    init_getStudio();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_dataverse62 = __toModule(require("@theatre/dataverse"));
    init_lodash();
    import_react202 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Curve();
    init_css();
    Circle2 = styled_components_browser_esm_default.circle`
  stroke-width: 1px;
  vector-effect: non-scaling-stroke;
  fill: var(--main-color);
  r: 2px;
  pointer-events: none;
`;
    HitZone6 = styled_components_browser_esm_default.circle`
  stroke-width: 6px;
  vector-effect: non-scaling-stroke;
  r: 6px;
  fill: transparent;
  cursor: move;
  ${pointerEventsAutoInNormalMode};
  &:hover {
  }
  &:hover + ${Circle2} {
    r: 6px;
  }
`;
    Line2 = styled_components_browser_esm_default.path`
  stroke-width: 1;
  stroke: var(--main-color);
  /* stroke: gray; */
  fill: none;
  vector-effect: non-scaling-stroke;
`;
    CurveHandle = (props) => {
      const [ref, node] = useRefAndState(null);
      const { index, trackData } = props;
      const cur = trackData.keyframes[index];
      const next = trackData.keyframes[index + 1];
      const [contextMenu] = useOurContextMenu(node, props);
      useOurDrags(node, props);
      const posInDiffSpace = props.which === "left" ? cur.handles[2] : next.handles[0];
      const posInUnitSpace = cur.position + (next.position - cur.position) * posInDiffSpace;
      const valInDiffSpace = props.which === "left" ? cur.handles[3] : next.handles[1];
      const curValue = props.isScalar ? cur.value : 0;
      const nextValue = props.isScalar ? next.value : 1;
      const value = curValue + (nextValue - curValue) * valInDiffSpace;
      const valInExtremumSpace = props.extremumSpace.fromValueSpace(value);
      const heightInExtremumSpace = valInExtremumSpace - props.extremumSpace.fromValueSpace(props.which === "left" ? curValue : nextValue);
      const lineTransform = transformBox(props.which === "left" ? cur.position : next.position, props.extremumSpace.fromValueSpace(props.which === "left" ? curValue : nextValue), posInUnitSpace - (props.which === "left" ? cur.position : next.position), heightInExtremumSpace);
      return /* @__PURE__ */ import_react202.default.createElement("g", null, /* @__PURE__ */ import_react202.default.createElement(HitZone6, {
        ref,
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${posInUnitSpace} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${valInExtremumSpace}) * 1px)`
        }
      }), /* @__PURE__ */ import_react202.default.createElement(Circle2, {
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${posInUnitSpace} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${valInExtremumSpace}) * 1px)`
        }
      }), /* @__PURE__ */ import_react202.default.createElement(Line2, {
        d: "M 0 0 L 1 1",
        style: {
          transform: lineTransform
        }
      }), contextMenu);
    };
    CurveHandle_default = CurveHandle;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorDotScalar.tsx
function useDragKeyframe3(options2) {
  const [isDragging, setIsDragging] = (0, import_react203.useState)(false);
  useLockFrameStampPosition(isDragging, options2.props.keyframe.position);
  const propsRef = (0, import_react203.useRef)(options2.props);
  propsRef.current = options2.props;
  const gestureHandlers = (0, import_react203.useMemo)(() => {
    return {
      debugName: "GraphEditorDotScalar/useDragKeyframe",
      lockCSSCursorTo: "move",
      onDragStart(event) {
        setIsDragging(true);
        const keepSpeeds = !!event.altKey;
        const propsAtStartOfDrag = propsRef.current;
        const toUnitSpace = (0, import_dataverse63.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        const verticalToExtremumSpace = (0, import_dataverse63.val)(propsAtStartOfDrag.layoutP.graphEditorVerticalSpace.toExtremumSpace);
        const unlockExtremums = propsAtStartOfDrag.extremumSpace.lock();
        let tempTransaction;
        return {
          onDrag(dx, dy) {
            const original = propsAtStartOfDrag.trackData.keyframes[propsAtStartOfDrag.index];
            const deltaPos = toUnitSpace(dx);
            const dyInVerticalSpace = -dy;
            const dYInExtremumSpace = verticalToExtremumSpace(dyInVerticalSpace);
            const dYInValueSpace = propsAtStartOfDrag.extremumSpace.deltaToValueSpace(dYInExtremumSpace);
            const updatedKeyframes = [];
            const cur = __spreadProps(__spreadValues({}, original), {
              position: original.position + deltaPos,
              value: original.value + dYInValueSpace,
              handles: [...original.handles]
            });
            updatedKeyframes.push(cur);
            if (keepSpeeds) {
              const prev = propsAtStartOfDrag.trackData.keyframes[propsAtStartOfDrag.index - 1];
              if (prev && Math.abs(original.value - prev.value) > 0) {
                const newPrev = __spreadProps(__spreadValues({}, prev), {
                  handles: [...prev.handles]
                });
                updatedKeyframes.push(newPrev);
                newPrev.handles[3] = preserveRightHandle(prev.handles[3], prev.value, prev.value, original.value, cur.value);
              }
              const next = propsAtStartOfDrag.trackData.keyframes[propsAtStartOfDrag.index + 1];
              if (next && Math.abs(original.value - next.value) > 0) {
                const newNext = __spreadProps(__spreadValues({}, next), {
                  handles: [...next.handles]
                });
                updatedKeyframes.push(newNext);
                newNext.handles[1] = preserveLeftHandle(newNext.handles[1], newNext.value, newNext.value, original.value, cur.value);
              }
            }
            tempTransaction == null ? void 0 : tempTransaction.discard();
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.sheetObject.address), {
                trackId: propsAtStartOfDrag.trackId,
                keyframes: updatedKeyframes,
                snappingFunction: (0, import_dataverse63.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition
              }));
            });
          },
          onDragEnd(dragHappened) {
            setIsDragging(false);
            unlockExtremums();
            if (dragHappened) {
              tempTransaction == null ? void 0 : tempTransaction.commit();
            } else {
              tempTransaction == null ? void 0 : tempTransaction.discard();
              options2.onDetectedClick(event);
            }
          }
        };
      }
    };
  }, []);
  useDrag(options2.node, gestureHandlers);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "move");
  return isDragging;
}
function useKeyframeContextMenu(node, props) {
  return useContextMenu(node, {
    menuItems: () => {
      return [
        {
          label: "Delete",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, props.sheetObject.address), {
                keyframeIds: [props.keyframe.id],
                trackId: props.trackId
              }));
            });
          }
        }
      ];
    }
  });
}
function preserveRightHandle(rightHandleInKeyframeDeltaSpace, originalValueOfMovedKeyframe, newValueOfMovedKeyframe, originalValueOfNeighbouringKeyframe, newValueOfNeighbouringKeyframe) {
  const diffOfHandleYToMovingKeyframeInValueSpace = (originalValueOfNeighbouringKeyframe - originalValueOfMovedKeyframe) * rightHandleInKeyframeDeltaSpace;
  const newHandleYInKeyframeDeltaSpace = diffOfHandleYToMovingKeyframeInValueSpace / (newValueOfNeighbouringKeyframe - newValueOfMovedKeyframe);
  return newHandleYInKeyframeDeltaSpace;
}
function preserveLeftHandle(leftHandleInKeyframeDeltaSpace, originalValueOfMovedKeyframe, newValueOfMovedKeyframe, originalValueOfNeighbouringKeyframe, newValueOfNeighbouringKeyframe) {
  const handleYInValueSpace = (originalValueOfMovedKeyframe - originalValueOfNeighbouringKeyframe) * leftHandleInKeyframeDeltaSpace + originalValueOfNeighbouringKeyframe;
  const diffOfHandleYToMovingKeyframeInValueSpace = handleYInValueSpace - originalValueOfMovedKeyframe;
  const newHandleYInValueSpace = diffOfHandleYToMovingKeyframeInValueSpace + newValueOfMovedKeyframe;
  const diffOfNewHandleYToNeighbouringKeyframe = newHandleYInValueSpace - newValueOfNeighbouringKeyframe;
  const newHandleYInKeyframeDeltaSpace = diffOfNewHandleYToNeighbouringKeyframe / (newValueOfMovedKeyframe - newValueOfNeighbouringKeyframe);
  return newHandleYInKeyframeDeltaSpace;
}
var import_dataverse63, import_react203, Circle3, HitZone7, GraphEditorDotScalar, GraphEditorDotScalar_default;
var init_GraphEditorDotScalar = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorDotScalar.tsx"() {
    init_getStudio();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_dataverse63 = __toModule(require("@theatre/dataverse"));
    import_react203 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameStampPositionProvider();
    init_FrameStampPositionProvider();
    init_css();
    init_PointerEventsHandler();
    init_DopeSnap();
    init_useSingleKeyframeInlineEditorPopover();
    init_usePresence();
    Circle3 = styled_components_browser_esm_default.circle`
  fill: var(--main-color);
  stroke-width: 1px;
  vector-effect: non-scaling-stroke;

  r: 2px;
`;
    HitZone7 = styled_components_browser_esm_default.circle`
  stroke-width: 6px;
  vector-effect: non-scaling-stroke;
  r: 6px;
  fill: transparent;
  ${pointerEventsAutoInNormalMode};

  &:hover + ${Circle3} {
    r: 6px;
  }

  #pointer-root.normal & {
    cursor: move;
  }

  #pointer-root.draggingPositionInSequenceEditor & {
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});
  }

  &.beingDragged {
    pointer-events: none !important;
  }
`;
    GraphEditorDotScalar = (props) => {
      const [ref, node] = useRefAndState(null);
      const { index, trackData } = props;
      const cur = trackData.keyframes[index];
      const [contextMenu] = useKeyframeContextMenu(node, props);
      const presence = usePresence(props.itemKey);
      const curValue = cur.value;
      const cyInExtremumSpace = props.extremumSpace.fromValueSpace(curValue);
      const inlineEditorPopover = useKeyframeInlineEditorPopover([
        {
          type: "primitiveProp",
          keyframe: props.keyframe,
          pathToProp: props.pathToProp,
          propConfig: props.propConfig,
          sheetObject: props.sheetObject,
          trackId: props.trackId
        }
      ]);
      const isDragging = useDragKeyframe3({
        node,
        props,
        onDetectedClick: (event) => inlineEditorPopover.toggle(event, event.target instanceof Element ? event.target : node)
      });
      return /* @__PURE__ */ import_react203.default.createElement(import_react203.default.Fragment, null, /* @__PURE__ */ import_react203.default.createElement(HitZone7, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
        ref,
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${cur.position} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${cyInExtremumSpace}) * 1px)`
        }
      }, includeLockFrameStampAttrs(cur.position)), DopeSnap_default.includePositionSnapAttrs(cur.position)), presence.attrs), {
        className: isDragging ? "beingDragged" : ""
      })), /* @__PURE__ */ import_react203.default.createElement(Circle3, {
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${cur.position} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${cyInExtremumSpace}) * 1px)`,
          fill: presence.flag === PresenceFlag.Primary ? "white" : void 0
        }
      }), inlineEditorPopover.node, contextMenu);
    };
    GraphEditorDotScalar_default = GraphEditorDotScalar;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorDotNonScalar.tsx
function useDragKeyframe4(options2) {
  const [isDragging, setIsDragging] = (0, import_react204.useState)(false);
  useLockFrameStampPosition(isDragging, options2.props.keyframe.position);
  const propsRef = (0, import_react204.useRef)(options2.props);
  propsRef.current = options2.props;
  const gestureHandlers = (0, import_react204.useMemo)(() => {
    return {
      debugName: "GraphEditorDotNonScalar/useDragKeyframe",
      lockCSSCursorTo: "ew-resize",
      onDragStart(event) {
        setIsDragging(true);
        const propsAtStartOfDrag = propsRef.current;
        const toUnitSpace = (0, import_dataverse64.val)(propsAtStartOfDrag.layoutP.scaledSpace.toUnitSpace);
        const unlockExtremums = propsAtStartOfDrag.extremumSpace.lock();
        let tempTransaction;
        return {
          onDrag(dx, dy) {
            const original = propsAtStartOfDrag.trackData.keyframes[propsAtStartOfDrag.index];
            const deltaPos = toUnitSpace(dx);
            const updatedKeyframes = [];
            const cur = __spreadProps(__spreadValues({}, original), {
              position: original.position + deltaPos,
              value: original.value,
              handles: [...original.handles]
            });
            updatedKeyframes.push(cur);
            tempTransaction == null ? void 0 : tempTransaction.discard();
            tempTransaction = getStudio().tempTransaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.replaceKeyframes(__spreadProps(__spreadValues({}, propsAtStartOfDrag.sheetObject.address), {
                trackId: propsAtStartOfDrag.trackId,
                keyframes: updatedKeyframes,
                snappingFunction: (0, import_dataverse64.val)(propsAtStartOfDrag.layoutP.sheet).getSequence().closestGridPosition
              }));
            });
          },
          onDragEnd(dragHappened) {
            setIsDragging(false);
            unlockExtremums();
            if (dragHappened) {
              tempTransaction == null ? void 0 : tempTransaction.commit();
            } else {
              tempTransaction == null ? void 0 : tempTransaction.discard();
              options2.onDetectedClick(event);
            }
          }
        };
      }
    };
  }, []);
  useDrag(options2.node, gestureHandlers);
  useCssCursorLock(isDragging, "draggingPositionInSequenceEditor", "ew-resize");
  return isDragging;
}
function useKeyframeContextMenu2(node, props) {
  return useContextMenu(node, {
    menuItems: () => {
      return [
        {
          label: "Delete",
          callback: () => {
            getStudio().transaction(({ stateEditors: stateEditors2 }) => {
              stateEditors2.coreByProject.historic.sheetsById.sequence.deleteKeyframes(__spreadProps(__spreadValues({}, props.sheetObject.address), {
                keyframeIds: [props.keyframe.id],
                trackId: props.trackId
              }));
            });
          }
        }
      ];
    }
  });
}
var import_dataverse64, import_react204, Circle4, HitZone8, GraphEditorDotNonScalar, GraphEditorDotNonScalar_default;
var init_GraphEditorDotNonScalar = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorDotNonScalar.tsx"() {
    init_getStudio();
    init_useContextMenu();
    init_useDrag();
    init_useRefAndState();
    import_dataverse64 = __toModule(require("@theatre/dataverse"));
    import_react204 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_FrameStampPositionProvider();
    init_FrameStampPositionProvider();
    init_css();
    init_PointerEventsHandler();
    init_DopeSnap();
    init_useSingleKeyframeInlineEditorPopover();
    init_usePresence();
    Circle4 = styled_components_browser_esm_default.circle`
  fill: var(--main-color);
  stroke-width: 1px;
  vector-effect: non-scaling-stroke;

  r: 2px;
`;
    HitZone8 = styled_components_browser_esm_default.circle`
  stroke-width: 6px;
  vector-effect: non-scaling-stroke;
  r: 6px;
  fill: transparent;
  ${pointerEventsAutoInNormalMode};

  &:hover + ${Circle4} {
    r: 6px;
  }

  #pointer-root.normal & {
    cursor: ew-resize;
  }

  #pointer-root.draggingPositionInSequenceEditor & {
    pointer-events: auto;
    cursor: var(${lockedCursorCssVarName});
  }

  &.beingDragged {
    pointer-events: none !important;
  }
`;
    GraphEditorDotNonScalar = (props) => {
      const [ref, node] = useRefAndState(null);
      const { index, trackData, itemKey } = props;
      const cur = trackData.keyframes[index];
      const [contextMenu] = useKeyframeContextMenu2(node, props);
      const presence = usePresence(itemKey);
      const curValue = props.which === "left" ? 0 : 1;
      const inlineEditorPopover = useKeyframeInlineEditorPopover([
        {
          type: "primitiveProp",
          keyframe: props.keyframe,
          pathToProp: props.pathToProp,
          propConfig: props.propConfig,
          sheetObject: props.sheetObject,
          trackId: props.trackId
        }
      ]);
      const isDragging = useDragKeyframe4({
        node,
        props,
        onDetectedClick: (event) => inlineEditorPopover.toggle(event, event.target instanceof Element ? event.target : node)
      });
      const cyInExtremumSpace = props.extremumSpace.fromValueSpace(curValue);
      return /* @__PURE__ */ import_react204.default.createElement(import_react204.default.Fragment, null, /* @__PURE__ */ import_react204.default.createElement(HitZone8, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
        ref,
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${cur.position} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${cyInExtremumSpace}) * 1px)`
        }
      }, presence.attrs), includeLockFrameStampAttrs(cur.position)), DopeSnap_default.includePositionSnapAttrs(cur.position)), {
        className: isDragging ? "beingDragged" : ""
      })), /* @__PURE__ */ import_react204.default.createElement(Circle4, {
        style: {
          cx: `calc(var(--unitSpaceToScaledSpaceMultiplier) * ${cur.position} * 1px)`,
          cy: `calc((var(--graphEditorVerticalSpace) - var(--graphEditorVerticalSpace) * ${cyInExtremumSpace}) * 1px)`,
          fill: presence.flag === PresenceFlag.Primary ? "white" : void 0
        }
      }), inlineEditorPopover.node, contextMenu);
    };
    GraphEditorDotNonScalar_default = GraphEditorDotNonScalar;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorNonScalarDash.tsx
var import_react205, SVGPath2, GraphEditorNonScalarDash, GraphEditorNonScalarDash_default;
var init_GraphEditorNonScalarDash = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/GraphEditorNonScalarDash.tsx"() {
    import_react205 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Curve();
    SVGPath2 = styled_components_browser_esm_default.path`
  stroke-width: 2;
  stroke: var(--main-color);
  stroke-dasharray: 3 2;
  fill: none;
  vector-effect: non-scaling-stroke;
  opacity: 0.3;
`;
    GraphEditorNonScalarDash = (props) => {
      const { index, trackData } = props;
      const pathD = `M 0 0 L 1 1`;
      const transform = transformBox(trackData.keyframes[index].position, props.extremumSpace.fromValueSpace(0), 0, props.extremumSpace.fromValueSpace(1) - props.extremumSpace.fromValueSpace(0));
      return /* @__PURE__ */ import_react205.default.createElement(import_react205.default.Fragment, null, /* @__PURE__ */ import_react205.default.createElement(SVGPath2, {
        d: pathD,
        style: {
          transform
        }
      }));
    };
    GraphEditorNonScalarDash_default = GraphEditorNonScalarDash;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/KeyframeEditor.tsx
var import_react206, Container45, noConnector2, KeyframeEditor, KeyframeEditor_default;
var init_KeyframeEditor = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/KeyframeEditor/KeyframeEditor.tsx"() {
    import_react206 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Curve();
    init_CurveHandle();
    init_GraphEditorDotScalar();
    init_GraphEditorDotNonScalar();
    init_GraphEditorNonScalarDash();
    Container45 = styled_components_browser_esm_default.g`
  /* position: absolute; */
`;
    noConnector2 = /* @__PURE__ */ import_react206.default.createElement(import_react206.default.Fragment, null);
    KeyframeEditor = (props) => {
      const { index, trackData, isScalar } = props;
      const cur = trackData.keyframes[index];
      const next = trackData.keyframes[index + 1];
      const connected = cur.connectedRight && !!next;
      const shouldShowCurve = connected && next.value !== cur.value;
      return /* @__PURE__ */ import_react206.default.createElement(Container45, null, shouldShowCurve ? /* @__PURE__ */ import_react206.default.createElement(import_react206.default.Fragment, null, /* @__PURE__ */ import_react206.default.createElement(Curve_default, __spreadValues({}, props)), /* @__PURE__ */ import_react206.default.createElement(CurveHandle_default, __spreadProps(__spreadValues({}, props), {
        which: "left"
      })), /* @__PURE__ */ import_react206.default.createElement(CurveHandle_default, __spreadProps(__spreadValues({}, props), {
        which: "right"
      }))) : noConnector2, isScalar ? /* @__PURE__ */ import_react206.default.createElement(GraphEditorDotScalar_default, __spreadValues({}, props)) : /* @__PURE__ */ import_react206.default.createElement(import_react206.default.Fragment, null, /* @__PURE__ */ import_react206.default.createElement(GraphEditorDotNonScalar_default, __spreadProps(__spreadValues({}, props), {
        which: "left"
      })), /* @__PURE__ */ import_react206.default.createElement(GraphEditorDotNonScalar_default, __spreadProps(__spreadValues({}, props), {
        which: "right"
      })), /* @__PURE__ */ import_react206.default.createElement(GraphEditorNonScalarDash_default, __spreadValues({}, props))));
    };
    KeyframeEditor_default = KeyframeEditor;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/BasicKeyframedTrack.tsx
function calculateScalarExtremums(keyframes, propConfig) {
  let min = Infinity, max = -Infinity;
  function check(n3) {
    min = Math.min(n3, min);
    max = Math.max(n3, max);
  }
  keyframes.forEach((cur, i3) => {
    const curVal = valueInProp(cur.value, propConfig);
    check(curVal);
    if (!cur.connectedRight)
      return;
    const next = keyframes[i3 + 1];
    if (!next)
      return;
    const diff = (typeof next.value === "number" ? next.value : 1) - curVal;
    check(curVal + cur.handles[3] * diff);
    check(curVal + next.handles[1] * diff);
  });
  return [min, max];
}
function calculateNonScalarExtremums(keyframes) {
  let min = 0, max = 1;
  function check(n3) {
    min = Math.min(n3, min);
    max = Math.max(n3, max);
  }
  keyframes.forEach((cur, i3) => {
    if (!cur.connectedRight)
      return;
    const next = keyframes[i3 + 1];
    if (!next)
      return;
    check(cur.handles[3]);
    check(next.handles[1]);
  });
  return [min, max];
}
var import_react207, BasicKeyframedTrack2, BasicKeyframedTrack_default2;
var init_BasicKeyframedTrack2 = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/BasicKeyframedTrack/BasicKeyframedTrack.tsx"() {
    init_ids();
    import_react207 = __toModule(require_react());
    init_GraphEditor();
    init_KeyframeEditor();
    init_utils();
    init_src();
    BasicKeyframedTrack2 = import_react207.default.memo(({ layoutP, trackData, sheetObject, trackId, color: color2, pathToProp }) => {
      const propConfig = getPropConfigByPath(useVal(sheetObject.template.configPointer), pathToProp);
      if (isPropConfigComposite(propConfig)) {
        console.error(`Composite prop types cannot be keyframed`);
        return /* @__PURE__ */ import_react207.default.createElement(import_react207.default.Fragment, null);
      }
      const [areExtremumsLocked, setAreExtremumsLocked] = (0, import_react207.useState)(false);
      const lockExtremums = (0, import_react207.useMemo)(() => {
        const locks = new Set();
        return function lockExtremums2() {
          const shouldLock = locks.size === 0;
          locks.add(unlock);
          if (shouldLock)
            setAreExtremumsLocked(true);
          function unlock() {
            const wasLocked = locks.size > 0;
            locks.delete(unlock);
            if (wasLocked && locks.size === 0)
              setAreExtremumsLocked(false);
          }
          return unlock;
        };
      }, []);
      const extremumSpace = (0, import_react207.useMemo)(() => {
        const extremums = propConfig.type === "number" ? calculateScalarExtremums(trackData.keyframes, propConfig) : calculateNonScalarExtremums(trackData.keyframes);
        const fromValueSpace = (val59) => (val59 - extremums[0]) / (extremums[1] - extremums[0]);
        const toValueSpace = (ex) => extremums[0] + deltaToValueSpace(ex);
        const deltaToValueSpace = (ex) => ex * (extremums[1] - extremums[0]);
        return {
          fromValueSpace,
          toValueSpace,
          deltaToValueSpace,
          lock: lockExtremums
        };
      }, [trackData.keyframes]);
      const cachedExtremumSpace = (0, import_react207.useRef)(void 0);
      if (!areExtremumsLocked) {
        cachedExtremumSpace.current = extremumSpace;
      }
      const keyframeEditors = trackData.keyframes.map((kf, index) => /* @__PURE__ */ import_react207.default.createElement(KeyframeEditor_default, {
        pathToProp,
        propConfig,
        itemKey: createStudioSheetItemKey.forTrackKeyframe(sheetObject, trackId, kf.id),
        keyframe: kf,
        index,
        trackData,
        layoutP,
        sheetObject,
        trackId,
        isScalar: propConfig.type === "number",
        key: kf.id,
        extremumSpace: cachedExtremumSpace.current,
        color: color2
      }));
      return /* @__PURE__ */ import_react207.default.createElement("g", {
        style: {
          "--main-color": graphEditorColors[color2].iconColor
        }
      }, keyframeEditors);
    });
    BasicKeyframedTrack_default2 = BasicKeyframedTrack2;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/PrimitivePropGraph.tsx
var import_dataverse65, import_react210, PrimitivePropGraph, PrimitivePropGraph_default;
var init_PrimitivePropGraph = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/PrimitivePropGraph.tsx"() {
    init_getStudio();
    init_src();
    import_dataverse65 = __toModule(require("@theatre/dataverse"));
    import_react210 = __toModule(require_react());
    init_BasicKeyframedTrack2();
    PrimitivePropGraph = (props) => {
      return usePrism(() => {
        const { sheetObject, trackId } = props;
        const trackData = (0, import_dataverse65.val)(getStudio().atomP.historic.coreByProject[sheetObject.address.projectId].sheetsById[sheetObject.address.sheetId].sequence.tracksByObject[sheetObject.address.objectKey].trackData[trackId]);
        if ((trackData == null ? void 0 : trackData.type) !== "BasicKeyframedTrack") {
          console.error(`trackData type ${trackData == null ? void 0 : trackData.type} is not yet supported on the graph editor`);
          return /* @__PURE__ */ import_react210.default.createElement(import_react210.default.Fragment, null);
        } else {
          return /* @__PURE__ */ import_react210.default.createElement(BasicKeyframedTrack_default2, __spreadProps(__spreadValues({}, props), {
            trackData
          }));
        }
      }, [props.trackId, props.layoutP]);
    };
    PrimitivePropGraph_default = PrimitivePropGraph;
  }
});

// studio/src/panels/SequenceEditorPanel/GraphEditor/GraphEditor.tsx
var import_dataverse66, import_react212, graphEditorColors, Container46, SVGContainer, GraphEditor, GraphEditor_default;
var init_GraphEditor = __esm({
  "studio/src/panels/SequenceEditorPanel/GraphEditor/GraphEditor.tsx"() {
    init_getStudio();
    init_addresses();
    init_getDeep();
    init_src();
    import_dataverse66 = __toModule(require("@theatre/dataverse"));
    import_react212 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Right();
    init_HorizontallyScrollableArea();
    init_PrimitivePropGraph();
    init_FrameGrid();
    init_polished_esm();
    graphEditorColors = {
      "1": { iconColor: "#b98b08" },
      "2": { iconColor: "#70a904" },
      "3": { iconColor: "#2e928a" },
      "4": { iconColor: "#a943bb" },
      "5": { iconColor: "#b90808" },
      "6": { iconColor: "#b4bf0e" }
    };
    Container46 = styled_components_browser_esm_default.div`
  position: absolute;
  right: 0;
  bottom: 0;
  background: ${curriedTransparentize(0.03, "#1a1c1e")};
`;
    SVGContainer = styled_components_browser_esm_default.svg`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  pointer-events: none;
`;
    GraphEditor = ({ layoutP }) => {
      return usePrism(() => {
        const sheet = (0, import_dataverse66.val)(layoutP.sheet);
        const selectedPropsByObject = (0, import_dataverse66.val)(getStudio().atomP.historic.projects.stateByProjectId[sheet.address.projectId].stateBySheetId[sheet.address.sheetId].sequenceEditor.selectedPropsByObject);
        const height2 = (0, import_dataverse66.val)(layoutP.graphEditorDims.height);
        const unitSpaceToScaledSpaceMultiplier = (0, import_dataverse66.val)(layoutP.scaledSpace.fromUnitSpace)(1);
        const graphs = [];
        if (selectedPropsByObject) {
          for (const [objectKey, props] of Object.entries(selectedPropsByObject)) {
            const sheetObject = sheet.getObject(objectKey);
            if (!sheetObject)
              continue;
            const validSequenceTracks = (0, import_dataverse66.val)(sheetObject.template.getMapOfValidSequenceTracks_forStudio());
            for (const [encodedPathToProp, graphEditorColor] of Object.entries(props)) {
              const pathToProp = decodePathToProp(encodedPathToProp);
              const possibleSequenceTrackId = getDeep(validSequenceTracks, pathToProp);
              if (!possibleSequenceTrackId)
                continue;
              graphs.push(/* @__PURE__ */ import_react212.default.createElement(PrimitivePropGraph_default, {
                key: `graph-${objectKey}-${encodedPathToProp}`,
                sheetObject,
                pathToProp,
                layoutP,
                trackId: possibleSequenceTrackId,
                color: graphEditorColor
              }));
            }
          }
        }
        const width = (0, import_dataverse66.val)(layoutP.rightDims.width);
        return /* @__PURE__ */ import_react212.default.createElement(Container46, {
          style: {
            width: width + "px",
            height: height2 + "px",
            "--unitSpaceToScaledSpaceMultiplier": unitSpaceToScaledSpaceMultiplier,
            "--graphEditorVerticalSpace": `${(0, import_dataverse66.val)(layoutP.graphEditorVerticalSpace.space)}`
          }
        }, /* @__PURE__ */ import_react212.default.createElement(FrameGrid_default, {
          layoutP,
          width,
          height: height2
        }), /* @__PURE__ */ import_react212.default.createElement(HorizontallyScrollableArea_default, {
          layoutP,
          height: height2
        }, /* @__PURE__ */ import_react212.default.createElement(SVGContainer, {
          width: contentWidth,
          height: height2,
          viewBox: `0 0 ${contentWidth} ${height2}`
        }, /* @__PURE__ */ import_react212.default.createElement("g", {
          style: {
            transform: `translate(${(0, import_dataverse66.val)(layoutP.scaledSpace.leftPadding)}px, ${(0, import_dataverse66.val)(layoutP.graphEditorDims.padding.top)}px)`
          }
        }, graphs))));
      }, [layoutP]);
    };
    GraphEditor_default = GraphEditor;
  }
});

// shared/src/utils/ellipsify.ts
function ellipsify(str, maxLength) {
  if (str.length <= maxLength)
    return str;
  return str.substr(0, maxLength - 3) + "...";
}
var init_ellipsify = __esm({
  "shared/src/utils/ellipsify.ts"() {
  }
});

// shared/src/utils/userReadableTypeOfValue.ts
var userReadableTypeOfValue, userReadableTypeOfValue_default;
var init_userReadableTypeOfValue = __esm({
  "shared/src/utils/userReadableTypeOfValue.ts"() {
    init_ellipsify();
    userReadableTypeOfValue = (v5) => {
      if (typeof v5 === "string") {
        return `string("${ellipsify(v5, 10)}")`;
      } else if (typeof v5 === "number") {
        return `number(${ellipsify(String(v5), 10)})`;
      } else if (v5 === null) {
        return "null";
      } else if (v5 === void 0) {
        return "undefined";
      } else if (typeof v5 === "boolean") {
        return String(v5);
      } else if (Array.isArray(v5)) {
        return "array";
      } else if (typeof v5 === "object") {
        return "object";
      } else {
        return "unknown";
      }
    };
    userReadableTypeOfValue_default = userReadableTypeOfValue;
  }
});

// studio/src/panels/OutlinePanel/BaseItem.tsx
var import_react213, Container47, BaseHeader2, Header4, outlineItemFont, Head_Label, Head_IconContainer, Head_Icon_WithDescendants, ChildrenContainer, BaseItem, BaseItem_default;
var init_BaseItem = __esm({
  "studio/src/panels/OutlinePanel/BaseItem.tsx"() {
    import_react213 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_css();
    init_icons();
    Container47 = styled_components_browser_esm_default.li`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
`;
    BaseHeader2 = styled_components_browser_esm_default.div``;
    Header4 = styled_components_browser_esm_default(BaseHeader2)`
  position: relative;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: calc(4px + var(--depth) * 16px);
  padding-left: 4px;
  padding-right: 8px;
  gap: 4px;
  height: 21px;
  line-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  pointer-events: none;
  white-space: nowrap;

  border-radius: 2px;
  box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.48);

  color: rgba(255, 255, 255, 0.9);
  background: rgba(40, 43, 47, 0.65);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  &.descendant-is-selected {
    background: rgba(29, 53, 59, 0.7);
  }

  ${pointerEventsAutoInNormalMode};
  &:not(.not-selectable):not(.selected):hover {
    background: rgba(59, 63, 69, 0.9);

    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  }

  &:not(.not-selectable):not(.selected):active {
    background: rgba(82, 88, 96, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  }

  &.selected {
    background: rgba(30, 88, 102, 0.7);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  // Hit zone
  &:before {
    position: absolute;
    inset: -1px 0;
    display: block;
    content: ' ';
    z-index: 5;
  }

  @supports not (backdrop-filter: blur()) {
    background: rgba(40, 43, 47, 0.95);
  }
`;
    outlineItemFont = Ce`
  font-weight: 500;
  font-size: 11px;
  & {
  }
`;
    Head_Label = styled_components_browser_esm_default.span`
  ${outlineItemFont};

  ${pointerEventsAutoInNormalMode};
  position: relative;
  // Compensate for border bottom
  top: 0.5px;
  display: flex;
  height: 20px;
  align-items: center;
  box-sizing: border-box;
`;
    Head_IconContainer = styled_components_browser_esm_default.div`
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  opacity: 0.99;
`;
    Head_Icon_WithDescendants = styled_components_browser_esm_default.span`
  font-size: 9px;
  position: relative;
  display: block;
`;
    ChildrenContainer = styled_components_browser_esm_default.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
    BaseItem = ({ label, children, depth, select, selectionStatus, labelDecoration }) => {
      const canContainChildren = children !== void 0;
      return /* @__PURE__ */ import_react213.default.createElement(Container47, {
        style: { "--depth": depth }
      }, /* @__PURE__ */ import_react213.default.createElement(Header4, {
        className: selectionStatus,
        onClick: select
      }, /* @__PURE__ */ import_react213.default.createElement(Head_IconContainer, null, canContainChildren ? /* @__PURE__ */ import_react213.default.createElement(Head_Icon_WithDescendants, {
        isOpen: true
      }, /* @__PURE__ */ import_react213.default.createElement(ChevronDown_default, null)) : /* @__PURE__ */ import_react213.default.createElement(Package_default, null)), /* @__PURE__ */ import_react213.default.createElement(Head_Label, null, /* @__PURE__ */ import_react213.default.createElement("span", null, label)), labelDecoration), canContainChildren && /* @__PURE__ */ import_react213.default.createElement(ChildrenContainer, null, children));
    };
    BaseItem_default = BaseItem;
  }
});

// studio/src/panels/OutlinePanel/ObjectsList/ObjectItem.tsx
var import_react214, ObjectItem;
var init_ObjectItem = __esm({
  "studio/src/panels/OutlinePanel/ObjectsList/ObjectItem.tsx"() {
    init_getStudio();
    import_react214 = __toModule(require_react());
    init_BaseItem();
    init_src();
    init_selectors();
    ObjectItem = ({ sheetObject, depth, overrideLabel }) => {
      const select = () => {
        getStudio().transaction(({ stateEditors: stateEditors2 }) => {
          stateEditors2.studio.historic.panels.outline.selection.set([sheetObject]);
        });
      };
      const selection = usePrism(() => getOutlineSelection(), []);
      return /* @__PURE__ */ import_react214.default.createElement(BaseItem_default, {
        select,
        label: overrideLabel != null ? overrideLabel : sheetObject.address.objectKey,
        depth,
        selectionStatus: selection.includes(sheetObject) ? "selected" : "not-selected"
      });
    };
  }
});

// studio/src/panels/OutlinePanel/ObjectsList/getObjectNamespacePath.tsx
function getObjectNamespacePath(object) {
  let existing = OBJECT_SPLITS_MEMO.get(object);
  if (!existing) {
    existing = object.address.objectKey.split(RE_SPLIT_BY_SLASH_WITHOUT_WHITESPACE);
    console.assert(existing.length > 0, "expected not empty");
    OBJECT_SPLITS_MEMO.set(object, existing);
  }
  return existing;
}
var RE_SPLIT_BY_SLASH_WITHOUT_WHITESPACE, OBJECT_SPLITS_MEMO;
var init_getObjectNamespacePath = __esm({
  "studio/src/panels/OutlinePanel/ObjectsList/getObjectNamespacePath.tsx"() {
    RE_SPLIT_BY_SLASH_WITHOUT_WHITESPACE = /\s*\/\s*/g;
    OBJECT_SPLITS_MEMO = new WeakMap();
  }
});

// studio/src/panels/OutlinePanel/ObjectsList/NamespacedObjects.tsx
function addToNamespace(mutObjects, object) {
  _addToNamespace(mutObjects, getObjectNamespacePath(object), object);
}
function _addToNamespace(mutObjects, path, object) {
  console.assert(path.length > 0, "expecting path to not be empty");
  const [next, ...rest] = path;
  let existing = mutObjects.get(next);
  if (!existing) {
    existing = {
      nested: void 0,
      object: void 0
    };
    mutObjects.set(next, existing);
  }
  if (rest.length === 0) {
    console.assert(!existing.object, "expect not to have existing object with same name", { existing, object });
    existing.object = object;
  } else {
    if (!existing.nested) {
      existing.nested = new Map();
    }
    _addToNamespace(existing.nested, rest, object);
  }
}
var init_NamespacedObjects = __esm({
  "studio/src/panels/OutlinePanel/ObjectsList/NamespacedObjects.tsx"() {
    init_getObjectNamespacePath();
  }
});

// studio/src/panels/OutlinePanel/ObjectsList/ObjectsList.tsx
function NamespaceTree(props) {
  return /* @__PURE__ */ import_react217.default.createElement(import_react217.default.Fragment, null, [...props.namespace.entries()].map(([label, { object, nested }]) => {
    const nestedChildrenElt = nested && /* @__PURE__ */ import_react217.default.createElement(NamespaceTree, {
      namespace: nested,
      key: "namespaceTree(" + label + ")",
      visualIndentation: props.visualIndentation + 1
    });
    const sameNameElt = object && /* @__PURE__ */ import_react217.default.createElement(ObjectItem, {
      depth: props.visualIndentation,
      key: "objectPath(" + object.address.objectKey + ")",
      sheetObject: object,
      overrideLabel: label
    });
    return /* @__PURE__ */ import_react217.default.createElement(import_react217.default.Fragment, {
      key: `${label} - ${props.visualIndentation}`
    }, sameNameElt, nestedChildrenElt && /* @__PURE__ */ import_react217.default.createElement(BaseItem_default, {
      selectionStatus: "not-selectable",
      label,
      key: `baseItem(${label})`,
      depth: props.visualIndentation,
      children: nestedChildrenElt
    }));
  }));
}
var import_dataverse72, import_react217, Li, ObjectsList, ObjectsList_default;
var init_ObjectsList = __esm({
  "studio/src/panels/OutlinePanel/ObjectsList/ObjectsList.tsx"() {
    init_src();
    import_dataverse72 = __toModule(require("@theatre/dataverse"));
    import_react217 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_ObjectItem();
    init_BaseItem();
    init_NamespacedObjects();
    Li = styled_components_browser_esm_default.li`
  color: ${(props) => props.isSelected ? "white" : "hsl(1, 1%, 80%)"};
`;
    ObjectsList = ({ sheet, depth }) => {
      return usePrism(() => {
        const objectsMap = (0, import_dataverse72.val)(sheet.objectsP);
        const objects = Object.values(objectsMap).filter((a4) => a4 != null);
        const rootObject = new Map();
        objects.forEach((object) => {
          addToNamespace(rootObject, object);
        });
        return /* @__PURE__ */ import_react217.default.createElement(NamespaceTree, {
          namespace: rootObject,
          visualIndentation: depth
        });
      }, [sheet, depth]);
    };
    ObjectsList_default = ObjectsList;
  }
});

// studio/src/panels/OutlinePanel/SheetsList/SheetInstanceItem.tsx
var import_react219, Head, Container48, Body2, SheetInstanceItem;
var init_SheetInstanceItem = __esm({
  "studio/src/panels/OutlinePanel/SheetsList/SheetInstanceItem.tsx"() {
    init_getStudio();
    init_selectors();
    init_src();
    import_react219 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_ObjectsList();
    init_BaseItem();
    Head = styled_components_browser_esm_default.div`
  display: flex;
`;
    Container48 = styled_components_browser_esm_default.li`
  color: ${(props) => props.isSelected ? "white" : "hsl(1, 1%, 80%)"};
`;
    Body2 = styled_components_browser_esm_default.div``;
    SheetInstanceItem = ({ sheet, depth }) => {
      const setSelectedSheet = (0, import_react219.useCallback)(() => {
        getStudio().transaction(({ stateEditors: stateEditors2 }) => {
          stateEditors2.studio.historic.panels.outline.selection.set([sheet]);
        });
      }, [sheet]);
      return usePrism(() => {
        const selection = getOutlineSelection();
        return /* @__PURE__ */ import_react219.default.createElement(BaseItem_default, {
          depth,
          select: setSelectedSheet,
          selectionStatus: selection.some((s3) => s3 === sheet) ? "selected" : selection.some((s3) => s3.type === "Theatre_SheetObject" && s3.sheet === sheet) ? "descendant-is-selected" : "not-selected",
          label: /* @__PURE__ */ import_react219.default.createElement(Head, null, sheet.address.sheetId, ": ", sheet.address.sheetInstanceId)
        }, /* @__PURE__ */ import_react219.default.createElement(Body2, null, /* @__PURE__ */ import_react219.default.createElement(ObjectsList_default, {
          depth: depth + 1,
          sheet,
          key: "objectList" + sheet.address.sheetInstanceId
        })));
      }, [depth]);
    };
  }
});

// studio/src/panels/OutlinePanel/SheetsList/SheetItem.tsx
var import_dataverse73, import_react221, Head2, Container49, Body3, SheetItem;
var init_SheetItem = __esm({
  "studio/src/panels/OutlinePanel/SheetsList/SheetItem.tsx"() {
    init_src();
    import_dataverse73 = __toModule(require("@theatre/dataverse"));
    import_react221 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_SheetInstanceItem();
    Head2 = styled_components_browser_esm_default.div`
  display: flex;
`;
    Container49 = styled_components_browser_esm_default.li`
  color: ${(props) => props.isSelected ? "white" : "hsl(1, 1%, 80%)"};
`;
    Body3 = styled_components_browser_esm_default.div``;
    SheetItem = ({ sheetId, depth, project }) => {
      return usePrism(() => {
        const template = (0, import_dataverse73.val)(project.sheetTemplatesP[sheetId]);
        if (!template)
          return /* @__PURE__ */ import_react221.default.createElement(import_react221.default.Fragment, null);
        const allInstances = (0, import_dataverse73.val)(template.instancesP);
        return /* @__PURE__ */ import_react221.default.createElement(import_react221.default.Fragment, null, Object.entries(allInstances).map(([_3, inst]) => {
          return /* @__PURE__ */ import_react221.default.createElement(SheetInstanceItem, {
            key: inst.address.sheetInstanceId,
            sheet: inst,
            depth
          });
        }));
      }, [depth, sheetId, project]);
    };
  }
});

// studio/src/panels/OutlinePanel/SheetsList/SheetsList.tsx
var import_react223, SheetsList, SheetsList_default;
var init_SheetsList = __esm({
  "studio/src/panels/OutlinePanel/SheetsList/SheetsList.tsx"() {
    init_selectors();
    init_src();
    import_react223 = __toModule(require_react());
    init_SheetItem();
    SheetsList = ({ project, depth }) => {
      return usePrism(() => {
        if (!project)
          return null;
        const registeredSheetIds = getRegisteredSheetIds(project);
        return /* @__PURE__ */ import_react223.default.createElement(import_react223.default.Fragment, null, registeredSheetIds.map((sheetId) => {
          return /* @__PURE__ */ import_react223.default.createElement(SheetItem, {
            depth,
            sheetId,
            key: `sheet-${sheetId}`,
            project
          });
        }));
      }, [project, depth]);
    };
    SheetsList_default = SheetsList;
  }
});

// studio/src/panels/OutlinePanel/ProjectsList/ProjectListItem.tsx
var import_react224, import_dataverse74, ConflictNotice, ProjectListItem, ProjectListItem_default;
var init_ProjectListItem = __esm({
  "studio/src/panels/OutlinePanel/ProjectsList/ProjectListItem.tsx"() {
    import_react224 = __toModule(require_react());
    init_BaseItem();
    init_SheetsList();
    init_getStudio();
    init_src();
    init_selectors();
    import_dataverse74 = __toModule(require("@theatre/dataverse"));
    init_styled_components_browser_esm();
    ConflictNotice = styled_components_browser_esm_default.div`
  color: #ff6363;
  margin-left: 11px;
  background: #4c282d;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 10px;
  box-shadow: 0 2px 8px -4px black;
`;
    ProjectListItem = ({ depth, project }) => {
      const selection = usePrism(() => getOutlineSelection(), []);
      const hasConflict = usePrism(() => {
        const projectId = project.address.projectId;
        const loadingState = (0, import_dataverse74.val)(getStudio().atomP.ephemeral.coreByProject[projectId].loadingState);
        return (loadingState == null ? void 0 : loadingState.type) === "browserStateIsNotBasedOnDiskState";
      }, [project]);
      const select = (0, import_react224.useCallback)(() => {
        getStudio().transaction(({ stateEditors: stateEditors2 }) => {
          stateEditors2.studio.historic.panels.outline.selection.set([project]);
        });
      }, [project]);
      return /* @__PURE__ */ import_react224.default.createElement(BaseItem_default, {
        depth,
        label: project.address.projectId,
        labelDecoration: hasConflict ? /* @__PURE__ */ import_react224.default.createElement(ConflictNotice, null, "Has Conflicts") : null,
        children: /* @__PURE__ */ import_react224.default.createElement(SheetsList_default, {
          project,
          depth: depth + 1
        }),
        selectionStatus: selection.includes(project) ? "selected" : selection.some((s3) => s3.address.projectId === project.address.projectId) ? "descendant-is-selected" : "not-selected",
        select
      });
    };
    ProjectListItem_default = ProjectListItem;
  }
});

// studio/src/panels/OutlinePanel/ProjectsList/ProjectsList.tsx
var import_dataverse75, import_react227, Container50, ProjectsList, ProjectsList_default;
var init_ProjectsList = __esm({
  "studio/src/panels/OutlinePanel/ProjectsList/ProjectsList.tsx"() {
    import_dataverse75 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    import_react227 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_ProjectListItem();
    Container50 = styled_components_browser_esm_default.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-right: 4px;
`;
    ProjectsList = (props) => {
      return usePrism(() => {
        const projects = (0, import_dataverse75.val)(getStudio().projectsP);
        return /* @__PURE__ */ import_react227.default.createElement(Container50, null, Object.keys(projects).map((projectId) => {
          const project = projects[projectId];
          return /* @__PURE__ */ import_react227.default.createElement(ProjectListItem_default, {
            depth: 0,
            project,
            key: `projectListItem-${projectId}`
          });
        }));
      }, []);
    };
    ProjectsList_default = ProjectsList;
  }
});

// studio/src/panels/OutlinePanel/OutlinePanel.tsx
var import_react228, import_dataverse76, headerHeight2, Container51, OutlinePanel, OutlinePanel_default, isOutlinePanelHotspotActiveB, isOutlinePanelHoveredB, shouldShowOutlineD;
var init_OutlinePanel = __esm({
  "studio/src/panels/OutlinePanel/OutlinePanel.tsx"() {
    import_react228 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_common();
    init_ProjectsList();
    init_src();
    init_getStudio();
    init_useHotspot();
    import_dataverse76 = __toModule(require("@theatre/dataverse"));
    init_css();
    headerHeight2 = `44px`;
    Container51 = styled_components_browser_esm_default.div`
  ${pointerEventsAutoInNormalMode};
  background-color: transparent;
  position: absolute;
  left: 8px;
  z-index: ${panelZIndexes.outlinePanel};

  top: calc(${headerHeight2} + 8px);
  height: fit-content;
  max-height: calc(100% - ${headerHeight2});
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  display: ${({ pin }) => pin ? "block" : "none"};

  &:hover {
    display: block;
  }

  // Create a small buffer on the bottom to aid selecting the bottom item in a long, scrolling list
  &::after {
    content: '';
    display: block;
    height: 20px;
  }
`;
    OutlinePanel = () => {
      var _a2;
      const pin = (_a2 = useVal(getStudio().atomP.ahistoric.pinOutline)) != null ? _a2 : true;
      const show = useVal(shouldShowOutlineD);
      const active = useHotspot("left");
      (0, import_react228.useLayoutEffect)(() => {
        isOutlinePanelHotspotActiveB.set(active);
      }, [active]);
      (0, import_react228.useEffect)(() => {
        return () => {
          isOutlinePanelHoveredB.set(false);
          isOutlinePanelHotspotActiveB.set(false);
        };
      }, []);
      return /* @__PURE__ */ import_react228.default.createElement(Container51, {
        pin: pin || show,
        onMouseEnter: () => {
          isOutlinePanelHoveredB.set(true);
        },
        onMouseLeave: () => {
          isOutlinePanelHoveredB.set(false);
        }
      }, /* @__PURE__ */ import_react228.default.createElement(ProjectsList_default, null));
    };
    OutlinePanel_default = OutlinePanel;
    isOutlinePanelHotspotActiveB = new import_dataverse76.Box(false);
    isOutlinePanelHoveredB = new import_dataverse76.Box(false);
    shouldShowOutlineD = (0, import_dataverse76.prism)(() => {
      const isHovered = (0, import_dataverse76.val)(isOutlinePanelHoveredB.derivation);
      const isHotspotActive = (0, import_dataverse76.val)(isOutlinePanelHotspotActiveB.derivation);
      return isHovered || isHotspotActive;
    });
  }
});

// ../node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var require_react_error_boundary_umd = __commonJS({
  "../node_modules/react-error-boundary/dist/react-error-boundary.umd.js"(exports2, module2) {
    (function(global2, factory) {
      typeof exports2 === "object" && typeof module2 !== "undefined" ? factory(exports2, require_react()) : typeof define === "function" && define.amd ? define(["exports", "react"], factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory(global2.ReactErrorBoundary = {}, global2.React));
    })(exports2, function(exports3, React149) {
      "use strict";
      function _interopNamespace(e2) {
        if (e2 && e2.__esModule)
          return e2;
        var n3 = Object.create(null);
        if (e2) {
          Object.keys(e2).forEach(function(k4) {
            if (k4 !== "default") {
              var d3 = Object.getOwnPropertyDescriptor(e2, k4);
              Object.defineProperty(n3, k4, d3.get ? d3 : {
                enumerable: true,
                get: function() {
                  return e2[k4];
                }
              });
            }
          });
        }
        n3["default"] = e2;
        return Object.freeze(n3);
      }
      var React__namespace = /* @__PURE__ */ _interopNamespace(React149);
      function _setPrototypeOf2(o3, p3) {
        _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o4, p4) {
          o4.__proto__ = p4;
          return o4;
        };
        return _setPrototypeOf2(o3, p3);
      }
      function _inheritsLoose2(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf2(subClass, superClass);
      }
      var changedArray = function changedArray2(a4, b4) {
        if (a4 === void 0) {
          a4 = [];
        }
        if (b4 === void 0) {
          b4 = [];
        }
        return a4.length !== b4.length || a4.some(function(item, index) {
          return !Object.is(item, b4[index]);
        });
      };
      var initialState2 = {
        error: null
      };
      var ErrorBoundary2 = /* @__PURE__ */ function(_React$Component) {
        _inheritsLoose2(ErrorBoundary3, _React$Component);
        function ErrorBoundary3() {
          var _this;
          for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
            _args[_key] = arguments[_key];
          }
          _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
          _this.state = initialState2;
          _this.updatedWithError = false;
          _this.resetErrorBoundary = function() {
            var _this$props;
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);
            _this.reset();
          };
          return _this;
        }
        ErrorBoundary3.getDerivedStateFromError = function getDerivedStateFromError(error) {
          return {
            error
          };
        };
        var _proto = ErrorBoundary3.prototype;
        _proto.reset = function reset() {
          this.updatedWithError = false;
          this.setState(initialState2);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
          var _this$props$onError, _this$props2;
          (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidMount = function componentDidMount() {
          var error = this.state.error;
          if (error !== null) {
            this.updatedWithError = true;
          }
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
          var error = this.state.error;
          var resetKeys = this.props.resetKeys;
          if (error !== null && !this.updatedWithError) {
            this.updatedWithError = true;
            return;
          }
          if (error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
            var _this$props$onResetKe, _this$props3;
            (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
            this.reset();
          }
        };
        _proto.render = function render() {
          var error = this.state.error;
          var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
          if (error !== null) {
            var _props = {
              error,
              resetErrorBoundary: this.resetErrorBoundary
            };
            if (/* @__PURE__ */ React__namespace.isValidElement(fallback)) {
              return fallback;
            } else if (typeof fallbackRender === "function") {
              return fallbackRender(_props);
            } else if (FallbackComponent) {
              return /* @__PURE__ */ React__namespace.createElement(FallbackComponent, _props);
            } else {
              throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
          }
          return this.props.children;
        };
        return ErrorBoundary3;
      }(React__namespace.Component);
      function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped2(props) {
          return /* @__PURE__ */ React__namespace.createElement(ErrorBoundary2, errorBoundaryProps, /* @__PURE__ */ React__namespace.createElement(Component, props));
        };
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
      }
      function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null)
          throw givenError;
        if (error != null)
          throw error;
        return setError;
      }
      exports3.ErrorBoundary = ErrorBoundary2;
      exports3.useErrorHandler = useErrorHandler;
      exports3.withErrorBoundary = withErrorBoundary;
      Object.defineProperty(exports3, "__esModule", { value: true });
    });
  }
});

// studio/src/panels/BasePanel/ExtensionPaneWrapper.tsx
var import_react230, import_react_error_boundary, defaultPosition2, minDims2, ExtensionPaneWrapper, Container52, Title2, PaneTools, ClosePanelButton, F23, ErrorContainer, ErrorFallback, Content2, ExtensionPaneWrapper_default;
var init_ExtensionPaneWrapper = __esm({
  "studio/src/panels/BasePanel/ExtensionPaneWrapper.tsx"() {
    import_react230 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_common();
    init_BasePanel();
    init_PanelDragZone();
    init_PanelWrapper();
    import_react_error_boundary = __toModule(require_react_error_boundary_umd());
    init_all();
    init_getStudio();
    init_common();
    defaultPosition2 = {
      edges: {
        left: { from: "screenLeft", distance: 0.3 },
        right: { from: "screenRight", distance: 0.3 },
        top: { from: "screenTop", distance: 0.3 },
        bottom: { from: "screenBottom", distance: 0.3 }
      }
    };
    minDims2 = { width: 300, height: 300 };
    ExtensionPaneWrapper = ({ paneInstance }) => {
      return /* @__PURE__ */ import_react230.default.createElement(BasePanel_default, {
        panelId: `pane-${paneInstance.instanceId}`,
        defaultPosition: defaultPosition2,
        minDims: minDims2
      }, /* @__PURE__ */ import_react230.default.createElement(Content2, {
        paneInstance
      }));
    };
    Container52 = styled_components_browser_esm_default(PanelWrapper_default)`
  display: flex;
  flex-direction: column;

  box-shadow: 0px 5px 12px -4px rgb(0 0 0 / 22%);
  z-index: ${panelZIndexes.pluginPanes};
`;
    Title2 = styled_components_browser_esm_default.div`
  width: 100%;
`;
    PaneTools = styled_components_browser_esm_default.div`
  display: flex;
  align-items: center;
  opacity: 1;
  position: absolute;
  right: 4px;
  top: 0;
  bottom: 0;
`;
    ClosePanelButton = styled_components_browser_esm_default.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 11px;
  height: 10px;
  width: 18px;
  color: #adadadb3;
  background: transparent;
  border: none;
  cursor: pointer;
  &:hover {
    color: white;
  }
`;
    F23 = styled_components_browser_esm_default(F22)`
  position: relative;
  overflow: hidden;

  &:after {
    z-index: 10;
    position: absolute;
    inset: 0;
    display: block;
    content: ' ';
    pointer-events: none;

    #pointer-root:not(.normal) & {
      pointer-events: auto;
    }
  }
`;
    ErrorContainer = styled_components_browser_esm_default.div`
  padding: 12px;

  & > pre {
    border: 1px solid #ff62624f;
    background-color: rgb(255 0 0 / 5%);
    margin: 8px 0;
    padding: 8px;
    font-family: monospace;
    overflow: scroll;
    color: #ff9896;
  }
`;
    ErrorFallback = (props) => {
      return /* @__PURE__ */ import_react230.default.createElement(ErrorContainer, null, "An Error occured rendering this pane. Open the console for more info.", /* @__PURE__ */ import_react230.default.createElement("pre", null, JSON.stringify({ message: props.error.message, stack: props.error.stack }, null, 2)));
    };
    Content2 = ({
      paneInstance
    }) => {
      const [mountingPoint, setMountingPoint] = (0, import_react230.useState)(null);
      const mount = paneInstance.definition.mount;
      (0, import_react230.useLayoutEffect)(() => {
        if (!mountingPoint)
          return;
        const unmount = mount({
          paneId: paneInstance.instanceId,
          node: mountingPoint
        });
        if (typeof unmount === "function") {
          return unmount;
        }
      }, [mountingPoint, mount, paneInstance.instanceId]);
      const closePane = (0, import_react230.useCallback)(() => {
        getStudio().paneManager.destroyPane(paneInstance.instanceId);
      }, [paneInstance]);
      return /* @__PURE__ */ import_react230.default.createElement(Container52, null, /* @__PURE__ */ import_react230.default.createElement(PanelDragZone_default, null, /* @__PURE__ */ import_react230.default.createElement(TitleBar, null, /* @__PURE__ */ import_react230.default.createElement(PaneTools, null, /* @__PURE__ */ import_react230.default.createElement(ClosePanelButton, {
        onClick: closePane,
        title: "Close Pane"
      }, /* @__PURE__ */ import_react230.default.createElement(IoClose, null))), /* @__PURE__ */ import_react230.default.createElement(Title2, null, paneInstance.instanceId))), /* @__PURE__ */ import_react230.default.createElement(import_react_error_boundary.ErrorBoundary, {
        FallbackComponent: ErrorFallback
      }, /* @__PURE__ */ import_react230.default.createElement(F23, {
        ref: setMountingPoint
      })));
    };
    ExtensionPaneWrapper_default = ExtensionPaneWrapper;
  }
});

// studio/src/UIRoot/PanelsRoot.tsx
var import_react231, PanelsRoot, PanelsRoot_default;
var init_PanelsRoot = __esm({
  "studio/src/UIRoot/PanelsRoot.tsx"() {
    init_OutlinePanel();
    init_DetailPanel();
    import_react231 = __toModule(require_react());
    init_getStudio();
    init_src();
    init_ExtensionPaneWrapper();
    init_SequenceEditorPanel();
    PanelsRoot = () => {
      const panes = useVal(getStudio().paneManager.allPanesD);
      const paneEls = Object.entries(panes).map(([instanceId, paneInstance]) => {
        return /* @__PURE__ */ import_react231.default.createElement(ExtensionPaneWrapper_default, {
          key: `pane-${instanceId}`,
          paneInstance
        });
      });
      return /* @__PURE__ */ import_react231.default.createElement(import_react231.default.Fragment, null, paneEls, /* @__PURE__ */ import_react231.default.createElement(OutlinePanel_default, null), /* @__PURE__ */ import_react231.default.createElement(DetailPanel_default, null), /* @__PURE__ */ import_react231.default.createElement(SequenceEditorPanel_default, null));
    };
    PanelsRoot_default = PanelsRoot;
  }
});

// studio/src/uiComponents/Popover/ErrorTooltip.tsx
var ErrorTooltip, ErrorTooltip_default;
var init_ErrorTooltip = __esm({
  "studio/src/uiComponents/Popover/ErrorTooltip.tsx"() {
    init_styled_components_browser_esm();
    init_BasicTooltip();
    ErrorTooltip = styled_components_browser_esm_default(BasicTooltip_default)`
  --popover-outer-stroke: #e11c1c;
  --popover-inner-stroke: #2c1c1c;
  --popover-bg: #2c1c1c;
  pointer-events: none !important;
`;
    ErrorTooltip_default = ErrorTooltip;
  }
});

// ../node_modules/levenshtein-edit-distance/index.js
var require_levenshtein_edit_distance = __commonJS({
  "../node_modules/levenshtein-edit-distance/index.js"(exports2, module2) {
    var cache3;
    var codes;
    cache3 = [];
    codes = [];
    function levenshtein(value, other, insensitive) {
      var length, lengthOther, code, result2, distance, distanceOther, index, indexOther;
      if (value === other) {
        return 0;
      }
      length = value.length;
      lengthOther = other.length;
      if (length === 0) {
        return lengthOther;
      }
      if (lengthOther === 0) {
        return length;
      }
      if (insensitive) {
        value = value.toLowerCase();
        other = other.toLowerCase();
      }
      index = 0;
      while (index < length) {
        codes[index] = value.charCodeAt(index);
        cache3[index] = ++index;
      }
      indexOther = 0;
      while (indexOther < lengthOther) {
        code = other.charCodeAt(indexOther);
        result2 = distance = indexOther++;
        index = -1;
        while (++index < length) {
          distanceOther = code === codes[index] ? distance : distance + 1;
          distance = cache3[index];
          cache3[index] = result2 = distance > result2 ? distanceOther > result2 ? result2 + 1 : distanceOther : distanceOther > distance ? distance + 1 : distanceOther;
        }
      }
      return result2;
    }
    module2.exports = levenshtein;
  }
});

// ../node_modules/propose/propose.js
var require_propose = __commonJS({
  "../node_modules/propose/propose.js"(exports2, module2) {
    var levenshtein = require_levenshtein_edit_distance();
    function propose2() {
      var ratio;
      var distance;
      var proposed;
      var threshold;
      var ignoreCase;
      var max_ratio = 0;
      var word = arguments[0];
      var dictionary = arguments[1];
      var len = dictionary.length;
      var options2 = arguments[2];
      if (options2) {
        threshold = options2.threshold;
        ignoreCase = options2.ignoreCase;
      }
      if (threshold === void 0)
        threshold = 0;
      for (var i3 = 0; i3 < len; ++i3) {
        if (ignoreCase)
          distance = levenshtein(word, dictionary[i3], true);
        else
          distance = levenshtein(word, dictionary[i3]);
        if (distance > word.length)
          ratio = 1 - distance / dictionary[i3].length;
        else
          ratio = 1 - distance / word.length;
        if (ratio > max_ratio) {
          max_ratio = ratio;
          proposed = dictionary[i3];
        }
      }
      if (max_ratio >= threshold)
        return proposed;
      return null;
    }
    module2.exports = propose2;
  }
});

// shared/src/utils/didYouMean.ts
function didYouMean(str, dictionary, prepend = "Did you mean ", append = "?") {
  const p3 = (0, import_propose.default)(str, dictionary, {
    threshold: 0.7
  });
  if (p3) {
    return prepend + JSON.stringify(p3) + append;
  } else {
    return "";
  }
}
var import_propose;
var init_didYouMean = __esm({
  "shared/src/utils/didYouMean.ts"() {
    import_propose = __toModule(require_propose());
  }
});

// studio/src/uiComponents/Popover/MinimalTooltip.tsx
var MinimalTooltip, MinimalTooltip_default;
var init_MinimalTooltip = __esm({
  "studio/src/uiComponents/Popover/MinimalTooltip.tsx"() {
    init_styled_components_browser_esm();
    init_BasicTooltip();
    MinimalTooltip = styled_components_browser_esm_default(BasicTooltip_default)`
  padding: 6px;
`;
    MinimalTooltip_default = MinimalTooltip;
  }
});

// studio/src/uiComponents/toolbar/ToolbarSwitchSelectContainer.ts
var Container53, ToolbarSwitchSelectContainer_default;
var init_ToolbarSwitchSelectContainer = __esm({
  "studio/src/uiComponents/toolbar/ToolbarSwitchSelectContainer.ts"() {
    init_styled_components_browser_esm();
    init_es2();
    Container53 = styled_components_browser_esm_default(Group)`
  display: flex;
  height: fit-content;
  backdrop-filter: blur(14px);
  border-radius: 2px;
`;
    ToolbarSwitchSelectContainer_default = Container53;
  }
});

// studio/src/uiComponents/toolbar/ToolbarIconButton.tsx
var import_react233, Container54, ToolbarIconButton, ToolbarIconButton_default;
var init_ToolbarIconButton = __esm({
  "studio/src/uiComponents/toolbar/ToolbarIconButton.tsx"() {
    init_styled_components_browser_esm();
    init_css();
    import_react233 = __toModule(require_react());
    init_useTooltip();
    init_react_merge_refs_esm();
    init_MinimalTooltip();
    init_ToolbarSwitchSelectContainer();
    Container54 = styled_components_browser_esm_default.button`
  ${pointerEventsAutoInNormalMode};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  width: 32px;
  height: 32px;
  outline: none;

  color: #a8a8a9;

  background: rgba(40, 43, 47, 0.8);
  backdrop-filter: blur(14px);
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 2px;

  svg {
    display: block;
  }

  &:hover {
    background: rgba(59, 63, 69, 0.8);
  }

  &:active {
    background: rgba(82, 88, 96, 0.8);
  }

  &.selected {
    color: rgba(255, 255, 255, 0.8);
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  }

  // Don't blur if in a button group, because it already blurs. We need to blur
  // on the group-level, otherwise we get seams.
  ${ToolbarSwitchSelectContainer_default} > & {
    backdrop-filter: none;
    filter: none;
    border-radius: 0;

    &:first-child {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }

    &:last-child {
      border-bottom-right-radius: 2px;
      border-top-right-radius: 2px;
    }
  }

  @supports not (backdrop-filter: blur()) {
    background: rgba(40, 43, 47, 0.95);
  }
`;
    ToolbarIconButton = import_react233.default.forwardRef((_a2, ref) => {
      var _b = _a2, { title } = _b, props = __objRest(_b, ["title"]);
      const [tooltip, localRef] = useTooltip({ enabled: typeof title === "string" }, () => /* @__PURE__ */ import_react233.default.createElement(MinimalTooltip_default, null, title));
      return /* @__PURE__ */ import_react233.default.createElement(import_react233.default.Fragment, null, tooltip, /* @__PURE__ */ import_react233.default.createElement(Container54, __spreadValues({
        ref: react_merge_refs_esm_default([localRef, ref])
      }, props)), " ");
    });
    ToolbarIconButton_default = ToolbarIconButton;
  }
});

// studio/src/toolbars/ExtensionToolbar/tools/IconButton.tsx
var import_react234, Container55, IconButton, IconButton_default;
var init_IconButton = __esm({
  "studio/src/toolbars/ExtensionToolbar/tools/IconButton.tsx"() {
    import_react234 = __toModule(require_react());
    init_ToolbarIconButton();
    init_styled_components_browser_esm();
    init_css();
    Container55 = styled_components_browser_esm_default(ToolbarIconButton_default)`
  ${pointerEventsAutoInNormalMode};
  & > svg {
    width: 1em;
    height: 1em;
    pointer-events: none;
  }
`;
    IconButton = ({ config }) => {
      var _a2;
      return /* @__PURE__ */ import_react234.default.createElement(Container55, {
        onClick: config.onClick,
        title: config.title,
        dangerouslySetInnerHTML: { __html: (_a2 = config["svgSource"]) != null ? _a2 : "" }
      });
    };
    IconButton_default = IconButton;
  }
});

// studio/src/uiComponents/toolbar/ToolbarSwitchSelect.tsx
function OptionButton({
  value,
  label,
  icon,
  onClick,
  isSelected
}) {
  return /* @__PURE__ */ import_react235.default.createElement(import_react235.default.Fragment, null, /* @__PURE__ */ import_react235.default.createElement(ToolbarIconButton_default, {
    forwardedAs: Button,
    className: isSelected ? "selected" : void 0,
    "aria-label": label,
    onClick,
    title: label
  }, icon));
}
var import_react235, ToolbarSwitchSelect, ToolbarSwitchSelect_default;
var init_ToolbarSwitchSelect = __esm({
  "studio/src/uiComponents/toolbar/ToolbarSwitchSelect.tsx"() {
    import_react235 = __toModule(require_react());
    init_es2();
    init_ToolbarIconButton();
    init_ToolbarSwitchSelectContainer();
    ToolbarSwitchSelect = ({
      value: valueOfSwitch,
      onChange,
      options: options2
    }) => {
      return /* @__PURE__ */ import_react235.default.createElement(ToolbarSwitchSelectContainer_default, null, options2.map(({ label, icon, value: optionValue }) => /* @__PURE__ */ import_react235.default.createElement(OptionButton, {
        key: optionValue,
        value: optionValue,
        isSelected: valueOfSwitch === optionValue,
        label,
        icon,
        onClick: () => onChange(optionValue)
      })));
    };
    ToolbarSwitchSelect_default = ToolbarSwitchSelect;
  }
});

// studio/src/toolbars/ExtensionToolbar/tools/Switch.tsx
var import_react236, IconContainer2, IconButton2, Switch_default;
var init_Switch = __esm({
  "studio/src/toolbars/ExtensionToolbar/tools/Switch.tsx"() {
    import_react236 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_css();
    init_ToolbarSwitchSelect();
    IconContainer2 = styled_components_browser_esm_default.div`
  ${pointerEventsAutoInNormalMode};
  & > svg {
    width: 1em;
    height: 1em;
    pointer-events: none;
  }
`;
    IconButton2 = ({ config }) => {
      return /* @__PURE__ */ import_react236.default.createElement(ToolbarSwitchSelect_default, {
        onChange: config.onChange,
        options: config.options.map(({ label, value, svgSource }) => ({
          label,
          value,
          icon: /* @__PURE__ */ import_react236.default.createElement(IconContainer2, {
            dangerouslySetInnerHTML: { __html: svgSource }
          })
        })),
        value: config.value
      });
    };
    Switch_default = IconButton2;
  }
});

// studio/src/toolbars/ExtensionToolbar/Toolset.tsx
function getToolByType(type) {
  return toolByType[type];
}
var import_react237, Toolset, toolByType, Tool, Toolset_default;
var init_Toolset = __esm({
  "studio/src/toolbars/ExtensionToolbar/Toolset.tsx"() {
    init_didYouMean();
    init_userReadableTypeOfValue();
    import_react237 = __toModule(require_react());
    init_IconButton();
    init_Switch();
    Toolset = (props) => {
      return /* @__PURE__ */ import_react237.default.createElement(import_react237.default.Fragment, null, props.config.map((toolConfig, i3) => {
        return /* @__PURE__ */ import_react237.default.createElement(Tool, {
          config: toolConfig,
          key: i3
        });
      }));
    };
    toolByType = {
      Icon: IconButton_default,
      Switch: Switch_default
    };
    Tool = ({ config }) => {
      const Comp = getToolByType(config.type);
      if (!Comp) {
        throw new Error(`No tool with tool.type ${userReadableTypeOfValue_default(config.type)} exists. Did you mean ${didYouMean(config.type, Object.keys(toolByType))}`);
      }
      return /* @__PURE__ */ import_react237.default.createElement(Comp, {
        config
      });
    };
    Toolset_default = Toolset;
  }
});

// studio/src/toolbars/ExtensionToolbar/ExtensionToolbar.tsx
var import_dataverse77, import_react239, Container56, GroupDivider, ExtensionToolsetRender, ExtensionToolbar, ExtensionToolbar_default;
var init_ExtensionToolbar = __esm({
  "studio/src/toolbars/ExtensionToolbar/ExtensionToolbar.tsx"() {
    import_dataverse77 = __toModule(require("@theatre/dataverse"));
    init_src();
    init_getStudio();
    import_react239 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_Toolset();
    Container56 = styled_components_browser_esm_default.div`
  height: 36px;
  /* pointer-events: none; */

  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;
    GroupDivider = styled_components_browser_esm_default.div`
  position: abolute;
  height: 32px;
  width: 1px;
  background: #373b40;
  opacity: 0.4;
`;
    ExtensionToolsetRender = ({ extension, toolbarId }) => {
      const toolsetConfigBox = (0, import_react239.useMemo)(() => new import_dataverse77.Box([]), []);
      (0, import_react239.useLayoutEffect)(() => {
        var _a2, _b;
        const detach = (_b = (_a2 = extension.toolbars) == null ? void 0 : _a2[toolbarId]) == null ? void 0 : _b.call(_a2, toolsetConfigBox.set.bind(toolsetConfigBox), getStudio().publicApi);
        if (typeof detach === "function")
          return detach;
      }, [extension, toolbarId]);
      const config = useVal(toolsetConfigBox.derivation);
      return /* @__PURE__ */ import_react239.default.createElement(Toolset_default, {
        config
      });
    };
    ExtensionToolbar = ({ toolbarId, showLeftDivider }) => {
      var _a2;
      const groups = [];
      const extensionsById = useVal(getStudio().atomP.ephemeral.extensions.byId);
      let isAfterFirstGroup = false;
      for (const [, extension] of Object.entries(extensionsById)) {
        if (!extension || !((_a2 = extension.toolbars) == null ? void 0 : _a2[toolbarId]))
          continue;
        groups.push(/* @__PURE__ */ import_react239.default.createElement(import_react239.default.Fragment, {
          key: "extensionToolbar-" + extension.id
        }, isAfterFirstGroup ? /* @__PURE__ */ import_react239.default.createElement(GroupDivider, null) : void 0, /* @__PURE__ */ import_react239.default.createElement(ExtensionToolsetRender, {
          extension,
          toolbarId
        })));
        isAfterFirstGroup = true;
      }
      if (groups.length === 0)
        return null;
      return /* @__PURE__ */ import_react239.default.createElement(Container56, null, showLeftDivider ? /* @__PURE__ */ import_react239.default.createElement(GroupDivider, null) : void 0, groups);
    };
    ExtensionToolbar_default = ExtensionToolbar;
  }
});

// studio/src/toolbars/PinButton.tsx
var import_react240, Container57, PinButton, PinButton_default;
var init_PinButton = __esm({
  "studio/src/toolbars/PinButton.tsx"() {
    init_styled_components_browser_esm();
    import_react240 = __toModule(require_react());
    init_ToolbarIconButton();
    Container57 = styled_components_browser_esm_default(ToolbarIconButton_default)`
  color: ${({ pinned }) => pinned ? "rgba(255, 255, 255, 0.8)" : "#A8A8A9"};

  border-bottom: 1px solid
    ${({ pinned }) => pinned ? "rgba(255, 255, 255, 0.7)" : "rgba(255, 255, 255, 0.08)"};
`;
    PinButton = (0, import_react240.forwardRef)((_a2, ref) => {
      var _b = _a2, { children, hint, pinned, icon, pinHintIcon, unpinHintIcon } = _b, props = __objRest(_b, ["children", "hint", "pinned", "icon", "pinHintIcon", "unpinHintIcon"]);
      const [hovered, setHovered] = (0, import_react240.useState)(false);
      const showHint = hovered || hint;
      return /* @__PURE__ */ import_react240.default.createElement(Container57, __spreadProps(__spreadValues({}, props), {
        pinned,
        ref,
        onMouseOver: () => setHovered(true),
        onMouseOut: () => setHovered(false)
      }), /* @__PURE__ */ import_react240.default.createElement("div", {
        style: {
          pointerEvents: "none",
          width: "fit-content",
          height: "fit-content",
          inset: 0
        }
      }, showHint && !pinned ? pinHintIcon : showHint && pinned ? unpinHintIcon : icon), children);
    });
    PinButton_default = PinButton;
  }
});

// studio/src/uiComponents/icons/DoubleChevronLeft.tsx
function DoubleChevronLeft(props) {
  return /* @__PURE__ */ React140.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React140.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.732 4.048l-.792-.792L7.2 8l4.74 4.744.792-.792L8.781 8l3.951-3.952zm-3.932 0l-.792-.792L3.268 8l4.74 4.744.792-.792L4.848 8 8.8 4.048z",
    fill: "currentColor"
  }));
}
var React140, DoubleChevronLeft_default;
var init_DoubleChevronLeft = __esm({
  "studio/src/uiComponents/icons/DoubleChevronLeft.tsx"() {
    React140 = __toModule(require_react());
    DoubleChevronLeft_default = DoubleChevronLeft;
  }
});

// studio/src/uiComponents/icons/DoubleChevronRight.tsx
function DoubleChevronRight(props) {
  return /* @__PURE__ */ React141.createElement("svg", __spreadValues({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React141.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.694 3.765l.792-.792 4.74 4.744-4.74 4.744-.792-.793 3.951-3.951-3.951-3.952zm3.932 0l.792-.792 4.74 4.744-4.74 4.744-.792-.793 3.952-3.951-3.952-3.952z",
    fill: "currentColor"
  }));
}
var React141, DoubleChevronRight_default;
var init_DoubleChevronRight = __esm({
  "studio/src/uiComponents/icons/DoubleChevronRight.tsx"() {
    React141 = __toModule(require_react());
    DoubleChevronRight_default = DoubleChevronRight;
  }
});

// studio/src/toolbars/MoreMenu/MoreMenu.tsx
var import_react242, Container58, Item2, Link, VersionContainer, VersionLabel, VersionValueRow, VersionValue, Divider, UpdateDot, version, untaggedVersion, MoreMenu, MoreMenu_default;
var init_MoreMenu = __esm({
  "studio/src/toolbars/MoreMenu/MoreMenu.tsx"() {
    init_src();
    init_getStudio();
    import_react242 = __toModule(require_react());
    init_styled_components_browser_esm();
    Container58 = styled_components_browser_esm_default.div`
  width: 138px;
  border-radius: 2px;
  background-color: rgba(42, 45, 50, 0.9);
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25), 0px 2px 6px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(14px);
  pointer-events: auto;
  // makes the edges of the item highlights match the rounded corners
  overflow: hidden;

  @supports not (backdrop-filter: blur()) {
    background-color: rgba(42, 45, 50, 0.98);
  }

  color: rgba(255, 255, 255, 0.9);

  & a {
    // Fix colors of links to not be default
    color: inherit;
  }
`;
    Item2 = styled_components_browser_esm_default.div`
  position: relative;
  padding: 0px 12px;
  font-weight: 400;
  font-size: 11px;
  height: 32px;
  text-decoration: none;
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: default;
`;
    Link = styled_components_browser_esm_default(Item2)`
  &:before {
    position: absolute;
    display: block;
    content: ' ';
    inset: 3px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.1);
    opacity: 0;
  }

  &.secondary {
    color: rgba(255, 255, 255, 0.5);
  }

  &:hover {
    /* background-color: #398995; */
    color: white !important;
    &:before {
      opacity: 1;
    }
  }
`;
    VersionContainer = styled_components_browser_esm_default(Item2)`
  height: auto;
  min-height: 32px;
  padding-top: 12px;
  padding-bottom: 10px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 8px;
  color: rgba(255, 255, 255, 0.5);
`;
    VersionLabel = styled_components_browser_esm_default.div`
  font-weight: 600;
`;
    VersionValueRow = styled_components_browser_esm_default.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
    VersionValue = styled_components_browser_esm_default.div`
  margin-left: 2px;
`;
    Divider = styled_components_browser_esm_default.div`
  height: 1px;
  margin: 0 2px;
  background: rgba(255, 255, 255, 0.02);
`;
    UpdateDot = styled_components_browser_esm_default.div`
  position: absolute;
  width: 8px;
  height: 8px;
  background: #40aaa4;
  right: 14px;
  top: 12px;
  border-radius: 50%;
`;
    version = "0.5.1";
    untaggedVersion = version.match(/^[^\-]+/)[0];
    MoreMenu = import_react242.default.forwardRef((props, ref) => {
      const hasUpdates = useVal(getStudio().atomP.ahistoric.updateChecker.result.hasUpdates);
      return /* @__PURE__ */ import_react242.default.createElement(Container58, {
        ref
      }, /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: "https://www.theatrejs.com/docs/latest",
        className: "",
        target: "_blank"
      }, "Docs"), /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: `https://www.theatrejs.com/docs/latest/releases`,
        className: "",
        target: "_blank"
      }, "Changelog"), /* @__PURE__ */ import_react242.default.createElement(Divider, null), /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: "https://github.com/theatre-js/theatre",
        className: "",
        target: "_blank"
      }, "Github"), /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: "https://twitter.com/theatre_js",
        className: "",
        target: "_blank"
      }, "Twitter"), /* @__PURE__ */ import_react242.default.createElement(Link, {
        className: "",
        as: "a",
        href: "https://discord.gg/bm9f8F9Y9N",
        target: "_blank"
      }, "Discord"), /* @__PURE__ */ import_react242.default.createElement(Divider, null), /* @__PURE__ */ import_react242.default.createElement(VersionContainer, null, /* @__PURE__ */ import_react242.default.createElement(VersionLabel, null, "Version"), /* @__PURE__ */ import_react242.default.createElement(VersionValueRow, null, /* @__PURE__ */ import_react242.default.createElement(VersionValue, null, version, " ", hasUpdates === true ? "(outdated)" : hasUpdates === false ? "(latest)" : ""))), hasUpdates === true && /* @__PURE__ */ import_react242.default.createElement(import_react242.default.Fragment, null, /* @__PURE__ */ import_react242.default.createElement(Divider, null), /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: `https://www.theatrejs.com/docs/latest/releases${encodeURIComponent(untaggedVersion)}`,
        className: "",
        target: "_blank"
      }, "Update", /* @__PURE__ */ import_react242.default.createElement(UpdateDot, null)), /* @__PURE__ */ import_react242.default.createElement(Link, {
        as: "a",
        href: `https://www.theatrejs.com/docs/latest/releases#${encodeURIComponent(untaggedVersion)}`,
        className: "",
        target: "_blank"
      }, "What's new?")));
    });
    MoreMenu_default = MoreMenu;
  }
});

// ../node_modules/react-hot-toast/headless/index.mjs
var import_react243, import_react244, x3, p2, E3, X3, I3, m2, v3, b3, M3, g3, f2, S3, T2, U3, O3, w3, l3, a3, k3, C, H3, ie2;
var init_headless = __esm({
  "../node_modules/react-hot-toast/headless/index.mjs"() {
    import_react243 = __toModule(require_react());
    import_react244 = __toModule(require_react());
    x3 = (e2) => typeof e2 == "function";
    p2 = (e2, t3) => x3(e2) ? e2(t3) : e2;
    E3 = (() => {
      let e2 = 0;
      return () => (++e2).toString();
    })();
    X3 = (() => {
      let e2;
      return () => {
        if (e2 === void 0 && typeof window < "u") {
          let t3 = matchMedia("(prefers-reduced-motion: reduce)");
          e2 = !t3 || t3.matches;
        }
        return e2;
      };
    })();
    I3 = 20;
    m2 = new Map();
    v3 = 1e3;
    b3 = (e2) => {
      if (m2.has(e2))
        return;
      let t3 = setTimeout(() => {
        m2.delete(e2), T2({ type: 4, toastId: e2 });
      }, v3);
      m2.set(e2, t3);
    };
    M3 = (e2) => {
      let t3 = m2.get(e2);
      t3 && clearTimeout(t3);
    };
    g3 = (e2, t3) => {
      switch (t3.type) {
        case 0:
          return __spreadProps(__spreadValues({}, e2), { toasts: [t3.toast, ...e2.toasts].slice(0, I3) });
        case 1:
          return t3.toast.id && M3(t3.toast.id), __spreadProps(__spreadValues({}, e2), { toasts: e2.toasts.map((r3) => r3.id === t3.toast.id ? __spreadValues(__spreadValues({}, r3), t3.toast) : r3) });
        case 2:
          let { toast: o3 } = t3;
          return e2.toasts.find((r3) => r3.id === o3.id) ? g3(e2, { type: 1, toast: o3 }) : g3(e2, { type: 0, toast: o3 });
        case 3:
          let { toastId: n3 } = t3;
          return n3 ? b3(n3) : e2.toasts.forEach((r3) => {
            b3(r3.id);
          }), __spreadProps(__spreadValues({}, e2), { toasts: e2.toasts.map((r3) => r3.id === n3 || n3 === void 0 ? __spreadProps(__spreadValues({}, r3), { visible: false }) : r3) });
        case 4:
          return t3.toastId === void 0 ? __spreadProps(__spreadValues({}, e2), { toasts: [] }) : __spreadProps(__spreadValues({}, e2), { toasts: e2.toasts.filter((r3) => r3.id !== t3.toastId) });
        case 5:
          return __spreadProps(__spreadValues({}, e2), { pausedAt: t3.time });
        case 6:
          let s3 = t3.time - (e2.pausedAt || 0);
          return __spreadProps(__spreadValues({}, e2), { pausedAt: void 0, toasts: e2.toasts.map((r3) => __spreadProps(__spreadValues({}, r3), { pauseDuration: r3.pauseDuration + s3 })) });
      }
    };
    f2 = [];
    S3 = { toasts: [], pausedAt: void 0 };
    T2 = (e2) => {
      S3 = g3(S3, e2), f2.forEach((t3) => {
        t3(S3);
      });
    };
    U3 = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 };
    O3 = (e2 = {}) => {
      let [t3, o3] = (0, import_react243.useState)(S3);
      (0, import_react243.useEffect)(() => (f2.push(o3), () => {
        let s3 = f2.indexOf(o3);
        s3 > -1 && f2.splice(s3, 1);
      }), [t3]);
      let n3 = t3.toasts.map((s3) => {
        var r3, c3;
        return __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, e2), e2[s3.type]), s3), { duration: s3.duration || ((r3 = e2[s3.type]) == null ? void 0 : r3.duration) || (e2 == null ? void 0 : e2.duration) || U3[s3.type], style: __spreadValues(__spreadValues(__spreadValues({}, e2.style), (c3 = e2[s3.type]) == null ? void 0 : c3.style), s3.style) });
      });
      return __spreadProps(__spreadValues({}, t3), { toasts: n3 });
    };
    w3 = (e2, t3 = "blank", o3) => __spreadProps(__spreadValues({ createdAt: Date.now(), visible: true, type: t3, ariaProps: { role: "status", "aria-live": "polite" }, message: e2, pauseDuration: 0 }, o3), { id: (o3 == null ? void 0 : o3.id) || E3() });
    l3 = (e2) => (t3, o3) => {
      let n3 = w3(t3, e2, o3);
      return T2({ type: 2, toast: n3 }), n3.id;
    };
    a3 = (e2, t3) => l3("blank")(e2, t3);
    a3.error = l3("error");
    a3.success = l3("success");
    a3.loading = l3("loading");
    a3.custom = l3("custom");
    a3.dismiss = (e2) => {
      T2({ type: 3, toastId: e2 });
    };
    a3.remove = (e2) => T2({ type: 4, toastId: e2 });
    a3.promise = (e2, t3, o3) => {
      let n3 = a3.loading(t3.loading, __spreadValues(__spreadValues({}, o3), o3 == null ? void 0 : o3.loading));
      return e2.then((s3) => (a3.success(p2(t3.success, s3), __spreadValues(__spreadValues({ id: n3 }, o3), o3 == null ? void 0 : o3.success)), s3)).catch((s3) => {
        a3.error(p2(t3.error, s3), __spreadValues(__spreadValues({ id: n3 }, o3), o3 == null ? void 0 : o3.error));
      }), e2;
    };
    k3 = (e2, t3) => {
      T2({ type: 1, toast: { id: e2, height: t3 } });
    };
    C = () => {
      T2({ type: 5, time: Date.now() });
    };
    H3 = (e2) => {
      let { toasts: t3, pausedAt: o3 } = O3(e2);
      (0, import_react244.useEffect)(() => {
        if (o3)
          return;
        let r3 = Date.now(), c3 = t3.map((i3) => {
          if (i3.duration === 1 / 0)
            return;
          let d3 = (i3.duration || 0) + i3.pauseDuration - (r3 - i3.createdAt);
          if (d3 < 0) {
            i3.visible && a3.dismiss(i3.id);
            return;
          }
          return setTimeout(() => a3.dismiss(i3.id), d3);
        });
        return () => {
          c3.forEach((i3) => i3 && clearTimeout(i3));
        };
      }, [t3, o3]);
      let n3 = (0, import_react244.useCallback)(() => {
        o3 && T2({ type: 6, time: Date.now() });
      }, [o3]), s3 = (0, import_react244.useCallback)((r3, c3) => {
        let { reverseOrder: i3 = false, gutter: d3 = 8, defaultPosition: P3 } = c3 || {}, A3 = t3.filter((u3) => (u3.position || P3) === (r3.position || P3) && u3.height), _3 = A3.findIndex((u3) => u3.id === r3.id), D3 = A3.filter((u3, y3) => y3 < _3 && u3.visible).length;
        return A3.filter((u3) => u3.visible).slice(...i3 ? [D3 + 1] : [0, D3]).reduce((u3, y3) => u3 + (y3.height || 0) + d3, 0);
      }, [t3]);
      return { toasts: t3, handlers: { updateHeight: k3, startPause: C, endPause: n3, calculateOffset: s3 } };
    };
    ie2 = a3;
  }
});

// ../node_modules/marked/lib/marked.esm.js
function getDefaults() {
  return {
    async: false,
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}
function changeDefaults(newDefaults) {
  defaults = newDefaults;
}
function escape(html, encode) {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }
  return html;
}
function unescape(html) {
  return html.replace(unescapeTest, (_3, n3) => {
    n3 = n3.toLowerCase();
    if (n3 === "colon")
      return ":";
    if (n3.charAt(0) === "#") {
      return n3.charAt(1) === "x" ? String.fromCharCode(parseInt(n3.substring(2), 16)) : String.fromCharCode(+n3.substring(1));
    }
    return "";
  });
}
function edit(regex, opt) {
  regex = typeof regex === "string" ? regex : regex.source;
  opt = opt || "";
  const obj = {
    replace: (name, val59) => {
      val59 = val59.source || val59;
      val59 = val59.replace(caret, "$1");
      regex = regex.replace(name, val59);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex, opt);
    }
  };
  return obj;
}
function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, "").toLowerCase();
    } catch (e2) {
      return null;
    }
    if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, "%");
  } catch (e2) {
    return null;
  }
  return href;
}
function resolveUrl(base, href) {
  if (!baseUrls[" " + base]) {
    if (justDomain.test(base)) {
      baseUrls[" " + base] = base + "/";
    } else {
      baseUrls[" " + base] = rtrim(base, "/", true);
    }
  }
  base = baseUrls[" " + base];
  const relativeBase = base.indexOf(":") === -1;
  if (href.substring(0, 2) === "//") {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, "$1") + href;
  } else if (href.charAt(0) === "/") {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, "$1") + href;
  } else {
    return base + href;
  }
}
function merge(obj) {
  let i3 = 1, target, key;
  for (; i3 < arguments.length; i3++) {
    target = arguments[i3];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }
  return obj;
}
function splitCells(tableRow, count) {
  const row = tableRow.replace(/\|/g, (match, offset, str) => {
    let escaped = false, curr = offset;
    while (--curr >= 0 && str[curr] === "\\")
      escaped = !escaped;
    if (escaped) {
      return "|";
    } else {
      return " |";
    }
  }), cells = row.split(/ \|/);
  let i3 = 0;
  if (!cells[0].trim()) {
    cells.shift();
  }
  if (cells.length > 0 && !cells[cells.length - 1].trim()) {
    cells.pop();
  }
  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count)
      cells.push("");
  }
  for (; i3 < cells.length; i3++) {
    cells[i3] = cells[i3].trim().replace(/\\\|/g, "|");
  }
  return cells;
}
function rtrim(str, c3, invert) {
  const l4 = str.length;
  if (l4 === 0) {
    return "";
  }
  let suffLen = 0;
  while (suffLen < l4) {
    const currChar = str.charAt(l4 - suffLen - 1);
    if (currChar === c3 && !invert) {
      suffLen++;
    } else if (currChar !== c3 && invert) {
      suffLen++;
    } else {
      break;
    }
  }
  return str.slice(0, l4 - suffLen);
}
function findClosingBracket(str, b4) {
  if (str.indexOf(b4[1]) === -1) {
    return -1;
  }
  const l4 = str.length;
  let level = 0, i3 = 0;
  for (; i3 < l4; i3++) {
    if (str[i3] === "\\") {
      i3++;
    } else if (str[i3] === b4[0]) {
      level++;
    } else if (str[i3] === b4[1]) {
      level--;
      if (level < 0) {
        return i3;
      }
    }
  }
  return -1;
}
function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
  }
}
function repeatString(pattern, count) {
  if (count < 1) {
    return "";
  }
  let result2 = "";
  while (count > 1) {
    if (count & 1) {
      result2 += pattern;
    }
    count >>= 1;
    pattern += pattern;
  }
  return result2 + pattern;
}
function outputLink(cap, link, raw, lexer2) {
  const href = link.href;
  const title = link.title ? escape(link.title) : null;
  const text = cap[1].replace(/\\([\[\]])/g, "$1");
  if (cap[0].charAt(0) !== "!") {
    lexer2.state.inLink = true;
    const token = {
      type: "link",
      raw,
      href,
      title,
      text,
      tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
  }
  return {
    type: "image",
    raw,
    href,
    title,
    text: escape(text)
  };
}
function indentCodeCompensation(raw, text) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
  if (matchIndentToCode === null) {
    return text;
  }
  const indentToCode = matchIndentToCode[1];
  return text.split("\n").map((node) => {
    const matchIndentInNode = node.match(/^\s+/);
    if (matchIndentInNode === null) {
      return node;
    }
    const [indentInNode] = matchIndentInNode;
    if (indentInNode.length >= indentToCode.length) {
      return node.slice(indentToCode.length);
    }
    return node;
  }).join("\n");
}
function smartypants(text) {
  return text.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026");
}
function mangle(text) {
  let out = "", i3, ch;
  const l4 = text.length;
  for (i3 = 0; i3 < l4; i3++) {
    ch = text.charCodeAt(i3);
    if (Math.random() > 0.5) {
      ch = "x" + ch.toString(16);
    }
    out += "&#" + ch + ";";
  }
  return out;
}
function marked(src, opt, callback) {
  if (typeof src === "undefined" || src === null) {
    throw new Error("marked(): input parameter is undefined or null");
  }
  if (typeof src !== "string") {
    throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
  }
  if (typeof opt === "function") {
    callback = opt;
    opt = null;
  }
  opt = merge({}, marked.defaults, opt || {});
  checkSanitizeDeprecation(opt);
  if (callback) {
    const highlight = opt.highlight;
    let tokens;
    try {
      tokens = Lexer.lex(src, opt);
    } catch (e2) {
      return callback(e2);
    }
    const done = function(err) {
      let out;
      if (!err) {
        try {
          if (opt.walkTokens) {
            marked.walkTokens(tokens, opt.walkTokens);
          }
          out = Parser.parse(tokens, opt);
        } catch (e2) {
          err = e2;
        }
      }
      opt.highlight = highlight;
      return err ? callback(err) : callback(null, out);
    };
    if (!highlight || highlight.length < 3) {
      return done();
    }
    delete opt.highlight;
    if (!tokens.length)
      return done();
    let pending = 0;
    marked.walkTokens(tokens, function(token) {
      if (token.type === "code") {
        pending++;
        setTimeout(() => {
          highlight(token.text, token.lang, function(err, code) {
            if (err) {
              return done(err);
            }
            if (code != null && code !== token.text) {
              token.text = code;
              token.escaped = true;
            }
            pending--;
            if (pending === 0) {
              done();
            }
          });
        }, 0);
      }
    });
    if (pending === 0) {
      done();
    }
    return;
  }
  function onError(e2) {
    e2.message += "\nPlease report this to https://github.com/markedjs/marked.";
    if (opt.silent) {
      return "<p>An error occurred:</p><pre>" + escape(e2.message + "", true) + "</pre>";
    }
    throw e2;
  }
  try {
    const tokens = Lexer.lex(src, opt);
    if (opt.walkTokens) {
      if (opt.async) {
        return Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(() => {
          return Parser.parse(tokens, opt);
        }).catch(onError);
      }
      marked.walkTokens(tokens, opt.walkTokens);
    }
    return Parser.parse(tokens, opt);
  } catch (e2) {
    onError(e2);
  }
}
var defaults, escapeTest, escapeReplace, escapeTestNoEncode, escapeReplaceNoEncode, escapeReplacements, getEscapeReplacement, unescapeTest, caret, nonWordAndColonTest, originIndependentUrl, baseUrls, justDomain, protocol, domain, noopTest, Tokenizer, block, inline, Lexer, Renderer, TextRenderer, Slugger, Parser, options, setOptions, use, walkTokens, parseInline, parser, lexer;
var init_marked_esm = __esm({
  "../node_modules/marked/lib/marked.esm.js"() {
    defaults = getDefaults();
    escapeTest = /[&<>"']/;
    escapeReplace = /[&<>"']/g;
    escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
    escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
    escapeReplacements = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    getEscapeReplacement = (ch) => escapeReplacements[ch];
    unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    caret = /(^|[^\[])\^/g;
    nonWordAndColonTest = /[^\w:]/g;
    originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    baseUrls = {};
    justDomain = /^[^:]+:\/*[^/]*$/;
    protocol = /^([^:]+:)[\s\S]*$/;
    domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    noopTest = { exec: function noopTest2() {
    } };
    Tokenizer = class {
      constructor(options2) {
        this.options = options2 || defaults;
      }
      space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) {
          return {
            type: "space",
            raw: cap[0]
          };
        }
      }
      code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
          const text = cap[0].replace(/^ {1,4}/gm, "");
          return {
            type: "code",
            raw: cap[0],
            codeBlockStyle: "indented",
            text: !this.options.pedantic ? rtrim(text, "\n") : text
          };
        }
      }
      fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
          const raw = cap[0];
          const text = indentCodeCompensation(raw, cap[3] || "");
          return {
            type: "code",
            raw,
            lang: cap[2] ? cap[2].trim() : cap[2],
            text
          };
        }
      }
      heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
          let text = cap[2].trim();
          if (/#$/.test(text)) {
            const trimmed = rtrim(text, "#");
            if (this.options.pedantic) {
              text = trimmed.trim();
            } else if (!trimmed || / $/.test(trimmed)) {
              text = trimmed.trim();
            }
          }
          return {
            type: "heading",
            raw: cap[0],
            depth: cap[1].length,
            text,
            tokens: this.lexer.inline(text)
          };
        }
      }
      hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) {
          return {
            type: "hr",
            raw: cap[0]
          };
        }
      }
      blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
          const text = cap[0].replace(/^ *>[ \t]?/gm, "");
          return {
            type: "blockquote",
            raw: cap[0],
            tokens: this.lexer.blockTokens(text, []),
            text
          };
        }
      }
      list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
          let raw, istask, ischecked, indent, i3, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
          let bull = cap[1].trim();
          const isordered = bull.length > 1;
          const list = {
            type: "list",
            raw: "",
            ordered: isordered,
            start: isordered ? +bull.slice(0, -1) : "",
            loose: false,
            items: []
          };
          bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
          if (this.options.pedantic) {
            bull = isordered ? bull : "[*+-]";
          }
          const itemRegex = new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`);
          while (src) {
            endEarly = false;
            if (!(cap = itemRegex.exec(src))) {
              break;
            }
            if (this.rules.block.hr.test(src)) {
              break;
            }
            raw = cap[0];
            src = src.substring(raw.length);
            line = cap[2].split("\n", 1)[0];
            nextLine = src.split("\n", 1)[0];
            if (this.options.pedantic) {
              indent = 2;
              itemContents = line.trimLeft();
            } else {
              indent = cap[2].search(/[^ ]/);
              indent = indent > 4 ? 1 : indent;
              itemContents = line.slice(indent);
              indent += cap[1].length;
            }
            blankLine = false;
            if (!line && /^ *$/.test(nextLine)) {
              raw += nextLine + "\n";
              src = src.substring(nextLine.length + 1);
              endEarly = true;
            }
            if (!endEarly) {
              const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))`);
              const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
              const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
              const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
              while (src) {
                rawLine = src.split("\n", 1)[0];
                line = rawLine;
                if (this.options.pedantic) {
                  line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (nextBulletRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(src)) {
                  break;
                }
                if (line.search(/[^ ]/) >= indent || !line.trim()) {
                  itemContents += "\n" + line.slice(indent);
                } else if (!blankLine) {
                  itemContents += "\n" + line;
                } else {
                  break;
                }
                if (!blankLine && !line.trim()) {
                  blankLine = true;
                }
                raw += rawLine + "\n";
                src = src.substring(rawLine.length + 1);
              }
            }
            if (!list.loose) {
              if (endsWithBlankLine) {
                list.loose = true;
              } else if (/\n *\n *$/.test(raw)) {
                endsWithBlankLine = true;
              }
            }
            if (this.options.gfm) {
              istask = /^\[[ xX]\] /.exec(itemContents);
              if (istask) {
                ischecked = istask[0] !== "[ ] ";
                itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
              }
            }
            list.items.push({
              type: "list_item",
              raw,
              task: !!istask,
              checked: ischecked,
              loose: false,
              text: itemContents
            });
            list.raw += raw;
          }
          list.items[list.items.length - 1].raw = raw.trimRight();
          list.items[list.items.length - 1].text = itemContents.trimRight();
          list.raw = list.raw.trimRight();
          const l4 = list.items.length;
          for (i3 = 0; i3 < l4; i3++) {
            this.lexer.state.top = false;
            list.items[i3].tokens = this.lexer.blockTokens(list.items[i3].text, []);
            const spacers = list.items[i3].tokens.filter((t3) => t3.type === "space");
            const hasMultipleLineBreaks = spacers.every((t3) => {
              const chars = t3.raw.split("");
              let lineBreaks = 0;
              for (const char of chars) {
                if (char === "\n") {
                  lineBreaks += 1;
                }
                if (lineBreaks > 1) {
                  return true;
                }
              }
              return false;
            });
            if (!list.loose && spacers.length && hasMultipleLineBreaks) {
              list.loose = true;
              list.items[i3].loose = true;
            }
          }
          return list;
        }
      }
      html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
          const token = {
            type: "html",
            raw: cap[0],
            pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
            text: cap[0]
          };
          if (this.options.sanitize) {
            const text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
            token.type = "paragraph";
            token.text = text;
            token.tokens = this.lexer.inline(text);
          }
          return token;
        }
      }
      def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
          if (cap[3])
            cap[3] = cap[3].substring(1, cap[3].length - 1);
          const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
          return {
            type: "def",
            tag,
            raw: cap[0],
            href: cap[2],
            title: cap[3]
          };
        }
      }
      table(src) {
        const cap = this.rules.block.table.exec(src);
        if (cap) {
          const item = {
            type: "table",
            header: splitCells(cap[1]).map((c3) => {
              return { text: c3 };
            }),
            align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
            rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
          };
          if (item.header.length === item.align.length) {
            item.raw = cap[0];
            let l4 = item.align.length;
            let i3, j3, k4, row;
            for (i3 = 0; i3 < l4; i3++) {
              if (/^ *-+: *$/.test(item.align[i3])) {
                item.align[i3] = "right";
              } else if (/^ *:-+: *$/.test(item.align[i3])) {
                item.align[i3] = "center";
              } else if (/^ *:-+ *$/.test(item.align[i3])) {
                item.align[i3] = "left";
              } else {
                item.align[i3] = null;
              }
            }
            l4 = item.rows.length;
            for (i3 = 0; i3 < l4; i3++) {
              item.rows[i3] = splitCells(item.rows[i3], item.header.length).map((c3) => {
                return { text: c3 };
              });
            }
            l4 = item.header.length;
            for (j3 = 0; j3 < l4; j3++) {
              item.header[j3].tokens = this.lexer.inline(item.header[j3].text);
            }
            l4 = item.rows.length;
            for (j3 = 0; j3 < l4; j3++) {
              row = item.rows[j3];
              for (k4 = 0; k4 < row.length; k4++) {
                row[k4].tokens = this.lexer.inline(row[k4].text);
              }
            }
            return item;
          }
        }
      }
      lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) {
          return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
          };
        }
      }
      paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
          const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
          return {
            type: "paragraph",
            raw: cap[0],
            text,
            tokens: this.lexer.inline(text)
          };
        }
      }
      text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) {
          return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
          };
        }
      }
      escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) {
          return {
            type: "escape",
            raw: cap[0],
            text: escape(cap[1])
          };
        }
      }
      tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
          if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
            this.lexer.state.inLink = true;
          } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
            this.lexer.state.inLink = false;
          }
          if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
            this.lexer.state.inRawBlock = true;
          } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
            this.lexer.state.inRawBlock = false;
          }
          return {
            type: this.options.sanitize ? "text" : "html",
            raw: cap[0],
            inLink: this.lexer.state.inLink,
            inRawBlock: this.lexer.state.inRawBlock,
            text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
          };
        }
      }
      link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
          const trimmedUrl = cap[2].trim();
          if (!this.options.pedantic && /^</.test(trimmedUrl)) {
            if (!/>$/.test(trimmedUrl)) {
              return;
            }
            const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
            if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
              return;
            }
          } else {
            const lastParenIndex = findClosingBracket(cap[2], "()");
            if (lastParenIndex > -1) {
              const start = cap[0].indexOf("!") === 0 ? 5 : 4;
              const linkLen = start + cap[1].length + lastParenIndex;
              cap[2] = cap[2].substring(0, lastParenIndex);
              cap[0] = cap[0].substring(0, linkLen).trim();
              cap[3] = "";
            }
          }
          let href = cap[2];
          let title = "";
          if (this.options.pedantic) {
            const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
            if (link) {
              href = link[1];
              title = link[3];
            }
          } else {
            title = cap[3] ? cap[3].slice(1, -1) : "";
          }
          href = href.trim();
          if (/^</.test(href)) {
            if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
              href = href.slice(1);
            } else {
              href = href.slice(1, -1);
            }
          }
          return outputLink(cap, {
            href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
            title: title ? title.replace(this.rules.inline._escapes, "$1") : title
          }, cap[0], this.lexer);
        }
      }
      reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
          let link = (cap[2] || cap[1]).replace(/\s+/g, " ");
          link = links[link.toLowerCase()];
          if (!link || !link.href) {
            const text = cap[0].charAt(0);
            return {
              type: "text",
              raw: text,
              text
            };
          }
          return outputLink(cap, link, cap[0], this.lexer);
        }
      }
      emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrong.lDelim.exec(src);
        if (!match)
          return;
        if (match[3] && prevChar.match(/[\p{L}\p{N}]/u))
          return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
          const lLength = match[0].length - 1;
          let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
          const endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
          endReg.lastIndex = 0;
          maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
          while ((match = endReg.exec(maskedSrc)) != null) {
            rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
            if (!rDelim)
              continue;
            rLength = rDelim.length;
            if (match[3] || match[4]) {
              delimTotal += rLength;
              continue;
            } else if (match[5] || match[6]) {
              if (lLength % 3 && !((lLength + rLength) % 3)) {
                midDelimTotal += rLength;
                continue;
              }
            }
            delimTotal -= rLength;
            if (delimTotal > 0)
              continue;
            rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
            if (Math.min(lLength, rLength) % 2) {
              const text2 = src.slice(1, lLength + match.index + rLength);
              return {
                type: "em",
                raw: src.slice(0, lLength + match.index + rLength + 1),
                text: text2,
                tokens: this.lexer.inlineTokens(text2)
              };
            }
            const text = src.slice(2, lLength + match.index + rLength - 1);
            return {
              type: "strong",
              raw: src.slice(0, lLength + match.index + rLength + 1),
              text,
              tokens: this.lexer.inlineTokens(text)
            };
          }
        }
      }
      codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
          let text = cap[2].replace(/\n/g, " ");
          const hasNonSpaceChars = /[^ ]/.test(text);
          const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
          if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
            text = text.substring(1, text.length - 1);
          }
          text = escape(text, true);
          return {
            type: "codespan",
            raw: cap[0],
            text
          };
        }
      }
      br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) {
          return {
            type: "br",
            raw: cap[0]
          };
        }
      }
      del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) {
          return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
          };
        }
      }
      autolink(src, mangle2) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
          let text, href;
          if (cap[2] === "@") {
            text = escape(this.options.mangle ? mangle2(cap[1]) : cap[1]);
            href = "mailto:" + text;
          } else {
            text = escape(cap[1]);
            href = text;
          }
          return {
            type: "link",
            raw: cap[0],
            text,
            href,
            tokens: [
              {
                type: "text",
                raw: text,
                text
              }
            ]
          };
        }
      }
      url(src, mangle2) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
          let text, href;
          if (cap[2] === "@") {
            text = escape(this.options.mangle ? mangle2(cap[0]) : cap[0]);
            href = "mailto:" + text;
          } else {
            let prevCapZero;
            do {
              prevCapZero = cap[0];
              cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
            } while (prevCapZero !== cap[0]);
            text = escape(cap[0]);
            if (cap[1] === "www.") {
              href = "http://" + text;
            } else {
              href = text;
            }
          }
          return {
            type: "link",
            raw: cap[0],
            text,
            href,
            tokens: [
              {
                type: "text",
                raw: text,
                text
              }
            ]
          };
        }
      }
      inlineText(src, smartypants2) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
          let text;
          if (this.lexer.state.inRawBlock) {
            text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
          } else {
            text = escape(this.options.smartypants ? smartypants2(cap[0]) : cap[0]);
          }
          return {
            type: "text",
            raw: cap[0],
            text
          };
        }
      }
    };
    block = {
      newline: /^(?: *(?:\n|$))+/,
      code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
      fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
      hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
      heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
      blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
      list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
      html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
      def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
      table: noopTest,
      lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
      _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
      text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
    block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
    block.normal = merge({}, block);
    block.gfm = merge({}, block.normal, {
      table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
    });
    block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", block.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
    block.pedantic = merge({}, block.normal, {
      html: edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
      def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
      heading: /^(#{1,6})(.*)(?:\n+|$)/,
      fences: noopTest,
      paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    inline = {
      escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
      autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
      url: noopTest,
      tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
      link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
      reflink: /^!?\[(label)\]\[(ref)\]/,
      nolink: /^!?\[(ref)\](?:\[\])?/,
      reflinkSearch: "reflink|nolink(?!\\()",
      emStrong: {
        lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
        rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
        rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
      },
      code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
      br: /^( {2,}|\\)\n(?!\s*$)/,
      del: noopTest,
      text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
      punctuation: /^([\spunctuation])/
    };
    inline._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    inline.escapedEmSt = /\\\*|\\_/g;
    inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
    inline.normal = merge({}, inline);
    inline.pedantic = merge({}, inline.normal, {
      strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
      },
      em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
      },
      link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
      reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
    });
    inline.gfm = merge({}, inline.normal, {
      escape: edit(inline.escape).replace("])", "~|])").getRegex(),
      _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
      url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
      _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
      del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
      text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
    inline.breaks = merge({}, inline.gfm, {
      br: edit(inline.br).replace("{2,}", "*").getRegex(),
      text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    Lexer = class {
      constructor(options2) {
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options2 || defaults;
        this.options.tokenizer = this.options.tokenizer || new Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
          inLink: false,
          inRawBlock: false,
          top: true
        };
        const rules = {
          block: block.normal,
          inline: inline.normal
        };
        if (this.options.pedantic) {
          rules.block = block.pedantic;
          rules.inline = inline.pedantic;
        } else if (this.options.gfm) {
          rules.block = block.gfm;
          if (this.options.breaks) {
            rules.inline = inline.breaks;
          } else {
            rules.inline = inline.gfm;
          }
        }
        this.tokenizer.rules = rules;
      }
      static get rules() {
        return {
          block,
          inline
        };
      }
      static lex(src, options2) {
        const lexer2 = new Lexer(options2);
        return lexer2.lex(src);
      }
      static lexInline(src, options2) {
        const lexer2 = new Lexer(options2);
        return lexer2.inlineTokens(src);
      }
      lex(src) {
        src = src.replace(/\r\n|\r/g, "\n");
        this.blockTokens(src, this.tokens);
        let next;
        while (next = this.inlineQueue.shift()) {
          this.inlineTokens(next.src, next.tokens);
        }
        return this.tokens;
      }
      blockTokens(src, tokens = []) {
        if (this.options.pedantic) {
          src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
        } else {
          src = src.replace(/^( *)(\t+)/gm, (_3, leading, tabs) => {
            return leading + "    ".repeat(tabs.length);
          });
        }
        let token, lastToken, cutSrc, lastParagraphClipped;
        while (src) {
          if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer) => {
            if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
              src = src.substring(token.raw.length);
              tokens.push(token);
              return true;
            }
            return false;
          })) {
            continue;
          }
          if (token = this.tokenizer.space(src)) {
            src = src.substring(token.raw.length);
            if (token.raw.length === 1 && tokens.length > 0) {
              tokens[tokens.length - 1].raw += "\n";
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (token = this.tokenizer.code(src)) {
            src = src.substring(token.raw.length);
            lastToken = tokens[tokens.length - 1];
            if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
              lastToken.raw += "\n" + token.raw;
              lastToken.text += "\n" + token.text;
              this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (token = this.tokenizer.fences(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.heading(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.hr(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.blockquote(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.list(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.html(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.def(src)) {
            src = src.substring(token.raw.length);
            lastToken = tokens[tokens.length - 1];
            if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
              lastToken.raw += "\n" + token.raw;
              lastToken.text += "\n" + token.raw;
              this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
            } else if (!this.tokens.links[token.tag]) {
              this.tokens.links[token.tag] = {
                href: token.href,
                title: token.title
              };
            }
            continue;
          }
          if (token = this.tokenizer.table(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.lheading(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          cutSrc = src;
          if (this.options.extensions && this.options.extensions.startBlock) {
            let startIndex = Infinity;
            const tempSrc = src.slice(1);
            let tempStart;
            this.options.extensions.startBlock.forEach(function(getStartIndex) {
              tempStart = getStartIndex.call({ lexer: this }, tempSrc);
              if (typeof tempStart === "number" && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          }
          if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
            lastToken = tokens[tokens.length - 1];
            if (lastParagraphClipped && lastToken.type === "paragraph") {
              lastToken.raw += "\n" + token.raw;
              lastToken.text += "\n" + token.text;
              this.inlineQueue.pop();
              this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
            } else {
              tokens.push(token);
            }
            lastParagraphClipped = cutSrc.length !== src.length;
            src = src.substring(token.raw.length);
            continue;
          }
          if (token = this.tokenizer.text(src)) {
            src = src.substring(token.raw.length);
            lastToken = tokens[tokens.length - 1];
            if (lastToken && lastToken.type === "text") {
              lastToken.raw += "\n" + token.raw;
              lastToken.text += "\n" + token.text;
              this.inlineQueue.pop();
              this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (src) {
            const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
            if (this.options.silent) {
              console.error(errMsg);
              break;
            } else {
              throw new Error(errMsg);
            }
          }
        }
        this.state.top = true;
        return tokens;
      }
      inline(src, tokens = []) {
        this.inlineQueue.push({ src, tokens });
        return tokens;
      }
      inlineTokens(src, tokens = []) {
        let token, lastToken, cutSrc;
        let maskedSrc = src;
        let match;
        let keepPrevChar, prevChar;
        if (this.tokens.links) {
          const links = Object.keys(this.tokens.links);
          if (links.length > 0) {
            while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
              if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) {
                maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
              }
            }
          }
        }
        while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
          maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        }
        while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
          maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        }
        while (src) {
          if (!keepPrevChar) {
            prevChar = "";
          }
          keepPrevChar = false;
          if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer) => {
            if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
              src = src.substring(token.raw.length);
              tokens.push(token);
              return true;
            }
            return false;
          })) {
            continue;
          }
          if (token = this.tokenizer.escape(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.tag(src)) {
            src = src.substring(token.raw.length);
            lastToken = tokens[tokens.length - 1];
            if (lastToken && token.type === "text" && lastToken.type === "text") {
              lastToken.raw += token.raw;
              lastToken.text += token.text;
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (token = this.tokenizer.link(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.reflink(src, this.tokens.links)) {
            src = src.substring(token.raw.length);
            lastToken = tokens[tokens.length - 1];
            if (lastToken && token.type === "text" && lastToken.type === "text") {
              lastToken.raw += token.raw;
              lastToken.text += token.text;
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.codespan(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.br(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.del(src)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (token = this.tokenizer.autolink(src, mangle)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            continue;
          }
          cutSrc = src;
          if (this.options.extensions && this.options.extensions.startInline) {
            let startIndex = Infinity;
            const tempSrc = src.slice(1);
            let tempStart;
            this.options.extensions.startInline.forEach(function(getStartIndex) {
              tempStart = getStartIndex.call({ lexer: this }, tempSrc);
              if (typeof tempStart === "number" && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          }
          if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
            src = src.substring(token.raw.length);
            if (token.raw.slice(-1) !== "_") {
              prevChar = token.raw.slice(-1);
            }
            keepPrevChar = true;
            lastToken = tokens[tokens.length - 1];
            if (lastToken && lastToken.type === "text") {
              lastToken.raw += token.raw;
              lastToken.text += token.text;
            } else {
              tokens.push(token);
            }
            continue;
          }
          if (src) {
            const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
            if (this.options.silent) {
              console.error(errMsg);
              break;
            } else {
              throw new Error(errMsg);
            }
          }
        }
        return tokens;
      }
    };
    Renderer = class {
      constructor(options2) {
        this.options = options2 || defaults;
      }
      code(code, infostring, escaped) {
        const lang = (infostring || "").match(/\S*/)[0];
        if (this.options.highlight) {
          const out = this.options.highlight(code, lang);
          if (out != null && out !== code) {
            escaped = true;
            code = out;
          }
        }
        code = code.replace(/\n$/, "") + "\n";
        if (!lang) {
          return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
        }
        return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
      }
      blockquote(quote) {
        return `<blockquote>
${quote}</blockquote>
`;
      }
      html(html) {
        return html;
      }
      heading(text, level, raw, slugger) {
        if (this.options.headerIds) {
          const id = this.options.headerPrefix + slugger.slug(raw);
          return `<h${level} id="${id}">${text}</h${level}>
`;
        }
        return `<h${level}>${text}</h${level}>
`;
      }
      hr() {
        return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
      }
      list(body, ordered, start) {
        const type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
      }
      listitem(text) {
        return `<li>${text}</li>
`;
      }
      checkbox(checked) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }
      paragraph(text) {
        return `<p>${text}</p>
`;
      }
      table(header, body) {
        if (body)
          body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
      }
      tablerow(content) {
        return `<tr>
${content}</tr>
`;
      }
      tablecell(content, flags) {
        const type = flags.header ? "th" : "td";
        const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
        return tag + content + `</${type}>
`;
      }
      strong(text) {
        return `<strong>${text}</strong>`;
      }
      em(text) {
        return `<em>${text}</em>`;
      }
      codespan(text) {
        return `<code>${text}</code>`;
      }
      br() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }
      del(text) {
        return `<del>${text}</del>`;
      }
      link(href, title, text) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
        if (href === null) {
          return text;
        }
        let out = '<a href="' + escape(href) + '"';
        if (title) {
          out += ' title="' + title + '"';
        }
        out += ">" + text + "</a>";
        return out;
      }
      image(href, title, text) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
        if (href === null) {
          return text;
        }
        let out = `<img src="${href}" alt="${text}"`;
        if (title) {
          out += ` title="${title}"`;
        }
        out += this.options.xhtml ? "/>" : ">";
        return out;
      }
      text(text) {
        return text;
      }
    };
    TextRenderer = class {
      strong(text) {
        return text;
      }
      em(text) {
        return text;
      }
      codespan(text) {
        return text;
      }
      del(text) {
        return text;
      }
      html(text) {
        return text;
      }
      text(text) {
        return text;
      }
      link(href, title, text) {
        return "" + text;
      }
      image(href, title, text) {
        return "" + text;
      }
      br() {
        return "";
      }
    };
    Slugger = class {
      constructor() {
        this.seen = {};
      }
      serialize(value) {
        return value.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }
      getNextSafeSlug(originalSlug, isDryRun) {
        let slug = originalSlug;
        let occurenceAccumulator = 0;
        if (this.seen.hasOwnProperty(slug)) {
          occurenceAccumulator = this.seen[originalSlug];
          do {
            occurenceAccumulator++;
            slug = originalSlug + "-" + occurenceAccumulator;
          } while (this.seen.hasOwnProperty(slug));
        }
        if (!isDryRun) {
          this.seen[originalSlug] = occurenceAccumulator;
          this.seen[slug] = 0;
        }
        return slug;
      }
      slug(value, options2 = {}) {
        const slug = this.serialize(value);
        return this.getNextSafeSlug(slug, options2.dryrun);
      }
    };
    Parser = class {
      constructor(options2) {
        this.options = options2 || defaults;
        this.options.renderer = this.options.renderer || new Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.textRenderer = new TextRenderer();
        this.slugger = new Slugger();
      }
      static parse(tokens, options2) {
        const parser2 = new Parser(options2);
        return parser2.parse(tokens);
      }
      static parseInline(tokens, options2) {
        const parser2 = new Parser(options2);
        return parser2.parseInline(tokens);
      }
      parse(tokens, top = true) {
        let out = "", i3, j3, k4, l22, l32, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
        const l4 = tokens.length;
        for (i3 = 0; i3 < l4; i3++) {
          token = tokens[i3];
          if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
            ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
            if (ret !== false || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(token.type)) {
              out += ret || "";
              continue;
            }
          }
          switch (token.type) {
            case "space": {
              continue;
            }
            case "hr": {
              out += this.renderer.hr();
              continue;
            }
            case "heading": {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
            case "code": {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
            case "table": {
              header = "";
              cell = "";
              l22 = token.header.length;
              for (j3 = 0; j3 < l22; j3++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j3].tokens), { header: true, align: token.align[j3] });
              }
              header += this.renderer.tablerow(cell);
              body = "";
              l22 = token.rows.length;
              for (j3 = 0; j3 < l22; j3++) {
                row = token.rows[j3];
                cell = "";
                l32 = row.length;
                for (k4 = 0; k4 < l32; k4++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k4].tokens), { header: false, align: token.align[k4] });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
            case "blockquote": {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
            case "list": {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l22 = token.items.length;
              body = "";
              for (j3 = 0; j3 < l22; j3++) {
                item = token.items[j3];
                checked = item.checked;
                task = item.task;
                itemBody = "";
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                      item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                        item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: "text",
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
            case "html": {
              out += this.renderer.html(token.text);
              continue;
            }
            case "paragraph": {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
            case "text": {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i3 + 1 < l4 && tokens[i3 + 1].type === "text") {
                token = tokens[++i3];
                body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
            default: {
              const errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
          }
        }
        return out;
      }
      parseInline(tokens, renderer) {
        renderer = renderer || this.renderer;
        let out = "", i3, token, ret;
        const l4 = tokens.length;
        for (i3 = 0; i3 < l4; i3++) {
          token = tokens[i3];
          if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
            ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
            if (ret !== false || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(token.type)) {
              out += ret || "";
              continue;
            }
          }
          switch (token.type) {
            case "escape": {
              out += renderer.text(token.text);
              break;
            }
            case "html": {
              out += renderer.html(token.text);
              break;
            }
            case "link": {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
            case "image": {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
            case "strong": {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
            case "em": {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
            case "codespan": {
              out += renderer.codespan(token.text);
              break;
            }
            case "br": {
              out += renderer.br();
              break;
            }
            case "del": {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
            case "text": {
              out += renderer.text(token.text);
              break;
            }
            default: {
              const errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
          }
        }
        return out;
      }
    };
    marked.options = marked.setOptions = function(opt) {
      merge(marked.defaults, opt);
      changeDefaults(marked.defaults);
      return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = defaults;
    marked.use = function(...args) {
      const opts = merge({}, ...args);
      const extensions = marked.defaults.extensions || { renderers: {}, childTokens: {} };
      let hasExtensions;
      args.forEach((pack) => {
        if (pack.extensions) {
          hasExtensions = true;
          pack.extensions.forEach((ext) => {
            if (!ext.name) {
              throw new Error("extension name required");
            }
            if (ext.renderer) {
              const prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
              if (prevRenderer) {
                extensions.renderers[ext.name] = function(...args2) {
                  let ret = ext.renderer.apply(this, args2);
                  if (ret === false) {
                    ret = prevRenderer.apply(this, args2);
                  }
                  return ret;
                };
              } else {
                extensions.renderers[ext.name] = ext.renderer;
              }
            }
            if (ext.tokenizer) {
              if (!ext.level || ext.level !== "block" && ext.level !== "inline") {
                throw new Error("extension level must be 'block' or 'inline'");
              }
              if (extensions[ext.level]) {
                extensions[ext.level].unshift(ext.tokenizer);
              } else {
                extensions[ext.level] = [ext.tokenizer];
              }
              if (ext.start) {
                if (ext.level === "block") {
                  if (extensions.startBlock) {
                    extensions.startBlock.push(ext.start);
                  } else {
                    extensions.startBlock = [ext.start];
                  }
                } else if (ext.level === "inline") {
                  if (extensions.startInline) {
                    extensions.startInline.push(ext.start);
                  } else {
                    extensions.startInline = [ext.start];
                  }
                }
              }
            }
            if (ext.childTokens) {
              extensions.childTokens[ext.name] = ext.childTokens;
            }
          });
        }
        if (pack.renderer) {
          const renderer = marked.defaults.renderer || new Renderer();
          for (const prop in pack.renderer) {
            const prevRenderer = renderer[prop];
            renderer[prop] = (...args2) => {
              let ret = pack.renderer[prop].apply(renderer, args2);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args2);
              }
              return ret;
            };
          }
          opts.renderer = renderer;
        }
        if (pack.tokenizer) {
          const tokenizer = marked.defaults.tokenizer || new Tokenizer();
          for (const prop in pack.tokenizer) {
            const prevTokenizer = tokenizer[prop];
            tokenizer[prop] = (...args2) => {
              let ret = pack.tokenizer[prop].apply(tokenizer, args2);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args2);
              }
              return ret;
            };
          }
          opts.tokenizer = tokenizer;
        }
        if (pack.walkTokens) {
          const walkTokens2 = marked.defaults.walkTokens;
          opts.walkTokens = function(token) {
            let values = [];
            values.push(pack.walkTokens.call(this, token));
            if (walkTokens2) {
              values = values.concat(walkTokens2.call(this, token));
            }
            return values;
          };
        }
        if (hasExtensions) {
          opts.extensions = extensions;
        }
        marked.setOptions(opts);
      });
    };
    marked.walkTokens = function(tokens, callback) {
      let values = [];
      for (const token of tokens) {
        values = values.concat(callback.call(marked, token));
        switch (token.type) {
          case "table": {
            for (const cell of token.header) {
              values = values.concat(marked.walkTokens(cell.tokens, callback));
            }
            for (const row of token.rows) {
              for (const cell of row) {
                values = values.concat(marked.walkTokens(cell.tokens, callback));
              }
            }
            break;
          }
          case "list": {
            values = values.concat(marked.walkTokens(token.items, callback));
            break;
          }
          default: {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                values = values.concat(marked.walkTokens(token[childTokens], callback));
              });
            } else if (token.tokens) {
              values = values.concat(marked.walkTokens(token.tokens, callback));
            }
          }
        }
      }
      return values;
    };
    marked.parseInline = function(src, opt) {
      if (typeof src === "undefined" || src === null) {
        throw new Error("marked.parseInline(): input parameter is undefined or null");
      }
      if (typeof src !== "string") {
        throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
      }
      opt = merge({}, marked.defaults, opt || {});
      checkSanitizeDeprecation(opt);
      try {
        const tokens = Lexer.lexInline(src, opt);
        if (opt.walkTokens) {
          marked.walkTokens(tokens, opt.walkTokens);
        }
        return Parser.parseInline(tokens, opt);
      } catch (e2) {
        e2.message += "\nPlease report this to https://github.com/markedjs/marked.";
        if (opt.silent) {
          return "<p>An error occurred:</p><pre>" + escape(e2.message + "", true) + "</pre>";
        }
        throw e2;
      }
    };
    marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.parse = marked;
    options = marked.options;
    setOptions = marked.setOptions;
    use = marked.use;
    walkTokens = marked.walkTokens;
    parseInline = marked.parseInline;
    parser = Parser.parse;
    lexer = Lexer.lex;
  }
});

// studio/src/notify.tsx
var import_react245, hashNotification, notificationUniquenessChecker, notificationTypeChecker, NotificationContainer, NotificationTitle, NotificationMain, NotificationMessage, DismissButton, COLORS, IndicatorDot, createHandler, notify, ButtonContainer, Button3, NotifierContainer, NotificationScroller, EmptyState2, useEmptyNotificationsTooltip, Notifier, useNotifications;
var init_notify = __esm({
  "studio/src/notify.tsx"() {
    import_react245 = __toModule(require_react());
    init_headless();
    init_styled_components_browser_esm();
    init_css();
    init_src();
    init_getStudio();
    init_marked_esm();
    init_useTooltip();
    init_MinimalTooltip();
    hashNotification = ({ title, message }) => `${title} ${message}`;
    notificationUniquenessChecker = (() => {
      const map = new Map();
      return {
        add: (notification) => {
          const key = hashNotification(notification);
          if (map.has(key)) {
            map.set(key, map.get(key) + 1);
          } else {
            map.set(key, 1);
          }
        },
        delete: (notification) => {
          const key = hashNotification(notification);
          if (map.has(key) && map.get(key) > 1) {
            map.set(key, map.get(key) - 1);
          } else {
            map.delete(key);
          }
        },
        clear: () => {
          map.clear();
        },
        check: (notification) => map.has(hashNotification(notification))
      };
    })();
    notificationTypeChecker = (() => {
      const map = new Map();
      return {
        add: (type) => {
          if (map.has(type)) {
            map.set(type, map.get(type) + 1);
          } else {
            map.set(type, 1);
          }
        },
        delete: (type) => {
          if (map.has(type) && map.get(type) > 1) {
            map.set(type, map.get(type) - 1);
          } else {
            map.delete(type);
          }
        },
        clear: () => {
          map.clear();
        },
        check: (type) => map.has(type),
        get types() {
          return Array.of(...map.keys());
        }
      };
    })();
    NotificationContainer = styled_components_browser_esm_default.div`
  width: 100%;
  border-radius: 4px;
  display: flex;
  gap: 12px;
  ${pointerEventsAutoInNormalMode};
  background-color: rgba(40, 43, 47, 0.8);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(14px);

  @supports not (backdrop-filter: blur()) {
    background: rgba(40, 43, 47, 0.95);
  }
`;
    NotificationTitle = styled_components_browser_esm_default.div`
  font-size: 14px;
  font-weight: bold;
  color: #fff;
`;
    NotificationMain = styled_components_browser_esm_default.div`
  flex: 1;
  flex-direction: column;
  width: 0;
  display: flex;
  padding: 16px 0;
  gap: 12px;
`;
    NotificationMessage = styled_components_browser_esm_default.div`
  color: #b4b4b4;
  font-size: 12px;
  line-height: 1.4;

  a {
    color: rgba(255, 255, 255, 0.9);
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: bold;
    color: #d5d5d5;
  }

  p {
    margin-bottom: 8px;
  }

  code {
    font-family: monospace;
    background: rgba(0, 0, 0, 0.3);
    padding: 1px 1px 2px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    white-space: pre-wrap;
  }

  pre > code {
    white-space: pre;
    display: block;
    overflow: auto;
    padding: 4px;
  }

  pre {
    white-space: pre-wrap;
    margin-bottom: 8px;
  }
`;
    DismissButton = styled_components_browser_esm_default.button`
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding-left: 12px;
  padding-right: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.05);

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;
    COLORS = {
      info: "#3b82f6",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444"
    };
    IndicatorDot = styled_components_browser_esm_default.div`
  display: flex;
  justify-content: center;
  margin-left: 12px;
  padding-top: 21px;

  ::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 999999px;
    background-color: ${({ type }) => COLORS[type]};
  }
`;
    createHandler = (type) => (title, message, docs = [], allowDuplicates = false) => {
      if (allowDuplicates || !notificationUniquenessChecker.check({ title, message })) {
        notificationUniquenessChecker.add({ title, message });
        notificationTypeChecker.add(type);
        ie2.custom((t3) => /* @__PURE__ */ import_react245.default.createElement(NotificationContainer, null, /* @__PURE__ */ import_react245.default.createElement(IndicatorDot, {
          type
        }), /* @__PURE__ */ import_react245.default.createElement(NotificationMain, null, /* @__PURE__ */ import_react245.default.createElement(NotificationTitle, null, title), /* @__PURE__ */ import_react245.default.createElement(NotificationMessage, {
          dangerouslySetInnerHTML: {
            __html: marked.parse(message)
          }
        }), docs.length > 0 && /* @__PURE__ */ import_react245.default.createElement(NotificationMessage, null, /* @__PURE__ */ import_react245.default.createElement("span", null, "Docs:", " ", docs.map((doc, i3) => /* @__PURE__ */ import_react245.default.createElement(import_react245.Fragment, {
          key: i3
        }, i3 > 0 && ", ", /* @__PURE__ */ import_react245.default.createElement("a", {
          target: "_blank",
          href: doc.url
        }, doc.title)))))), /* @__PURE__ */ import_react245.default.createElement(DismissButton, {
          onClick: () => {
            ie2.remove(t3.id);
            notificationUniquenessChecker.delete({ title, message });
            notificationTypeChecker.delete(type);
          }
        }, "Close")), { duration: Infinity });
      }
    };
    notify = {
      warning: createHandler("warning"),
      success: createHandler("success"),
      info: createHandler("info"),
      error: createHandler("error")
    };
    ButtonContainer = styled_components_browser_esm_default.div`
  display: flex;
  justify-content: ${({ align }) => align === "center" ? "center" : "flex-end"};
  gap: 12px;
`;
    Button3 = styled_components_browser_esm_default.button`
  position: relative;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  ${pointerEventsAutoInNormalMode};
  background-color: rgba(40, 43, 47, 0.8);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(14px);
  border: none;
  padding: 12px;
  color: #fff;
  overflow: hidden;

  ::before {
    content: '';
    position: absolute;
    inset: 0;
  }

  :hover::before {
    background: ${({ danger }) => danger ? "rgba(255, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  }

  @supports not (backdrop-filter: blur()) {
    background: rgba(40, 43, 47, 0.95);
  }
`;
    NotifierContainer = styled_components_browser_esm_default.div`
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: fixed;
  right: 92px;
  top: 50px;
  width: 500px;
  height: 85vh;
  min-height: 400px;
`;
    NotificationScroller = styled_components_browser_esm_default.div`
  overflow: hidden;
  pointer-events: auto;
  border-radius: 4px;

  & > div {
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    overflow: scroll;
    height: 100%;
  }
`;
    EmptyState2 = styled_components_browser_esm_default.div`
  width: fit-content;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #b4b4b4;
  font-size: 12px;
  line-height: 1.4;
`;
    useEmptyNotificationsTooltip = () => {
      const { hasNotifications } = useNotifications();
      return useTooltip({ enabled: !hasNotifications }, () => /* @__PURE__ */ import_react245.default.createElement(MinimalTooltip_default, null, /* @__PURE__ */ import_react245.default.createElement(EmptyState2, null, /* @__PURE__ */ import_react245.default.createElement(NotificationTitle, null, "No notifications"), "Notifications will appear here when you get them.")));
    };
    Notifier = () => {
      var _a2;
      const { toasts, handlers } = H3();
      const { startPause, endPause } = handlers;
      const pinNotifications = (_a2 = useVal(getStudio().atomP.ahistoric.pinNotifications)) != null ? _a2 : false;
      return /* @__PURE__ */ import_react245.default.createElement(NotifierContainer, null, !pinNotifications ? null : toasts.length > 0 && /* @__PURE__ */ import_react245.default.createElement(NotificationScroller, {
        onMouseEnter: startPause,
        onMouseLeave: endPause
      }, /* @__PURE__ */ import_react245.default.createElement("div", null, toasts.map((toast) => {
        return /* @__PURE__ */ import_react245.default.createElement("div", {
          key: toast.id
        }, toast.message(toast));
      }))), /* @__PURE__ */ import_react245.default.createElement(ButtonContainer, {
        align: "side"
      }, pinNotifications && toasts.length > 0 && /* @__PURE__ */ import_react245.default.createElement(Button3, {
        onClick: () => {
          notificationTypeChecker.clear();
          notificationUniquenessChecker.clear();
          ie2.remove();
        },
        danger: true
      }, "Clear")));
    };
    useNotifications = () => {
      const { toasts } = H3();
      return {
        hasNotifications: toasts.length > 0
      };
    };
  }
});

// studio/src/toolbars/GlobalToolbar.tsx
var import_react248, import_dataverse78, Container59, NumberOfConflictsIndicator, SubContainer, HasUpdatesBadge, GroupDivider2, showedVisualTestingWarning, GlobalToolbar, GlobalToolbar_default;
var init_GlobalToolbar = __esm({
  "studio/src/toolbars/GlobalToolbar.tsx"() {
    init_src();
    init_getStudio();
    import_react248 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_useTooltip();
    init_ErrorTooltip();
    init_BasicTooltip();
    import_dataverse78 = __toModule(require("@theatre/dataverse"));
    init_ExtensionToolbar();
    init_PinButton();
    init_icons();
    init_DoubleChevronLeft();
    init_DoubleChevronRight();
    init_ToolbarIconButton();
    init_usePopover();
    init_MoreMenu();
    init_notify();
    Container59 = styled_components_browser_esm_default.div`
  height: 36px;
  pointer-events: none;

  display: flex;
  justify-content: space-between;
  padding: 12px;
`;
    NumberOfConflictsIndicator = styled_components_browser_esm_default.div`
  color: white;
  width: 14px;
  height: 14px;
  background: #d00;
  border-radius: 4px;
  text-align: center;
  line-height: 14px;
  font-weight: 600;
  font-size: 8px;
  position: relative;
  left: -6px;
  top: -11px;
  margin-right: -14px;
  box-shadow: 0 4px 6px -4px #00000059;
`;
    SubContainer = styled_components_browser_esm_default.div`
  display: flex;
  gap: 8px;
`;
    HasUpdatesBadge = styled_components_browser_esm_default.div`
  position: absolute;
  background: ${({ type }) => type === "info" ? "#40aaa4" : "#f59e0b"};
  width: 6px;
  height: 6px;
  border-radius: 50%;
  right: -2px;
  top: -2px;
`;
    GroupDivider2 = styled_components_browser_esm_default.div`
  position: absolute;
  height: 32px;
  width: 1px;
  background: #373b40;
  opacity: 0.4;
`;
    showedVisualTestingWarning = false;
    GlobalToolbar = () => {
      var _a2, _b, _c;
      const conflicts = usePrism(() => {
        const ephemeralStateOfAllProjects = (0, import_dataverse78.val)(getStudio().atomP.ephemeral.coreByProject);
        return Object.entries(ephemeralStateOfAllProjects).map(([projectId, state]) => ({ projectId, state })).filter(({ state }) => state.loadingState.type === "browserStateIsNotBasedOnDiskState");
      }, []);
      const [triggerTooltip, triggerButtonRef] = useTooltip({ enabled: conflicts.length > 0, enterDelay: conflicts.length > 0 ? 0 : 200 }, () => conflicts.length > 0 ? /* @__PURE__ */ import_react248.default.createElement(ErrorTooltip_default, null, conflicts.length === 1 ? `There is a state conflict in project "${conflicts[0].projectId}". Select the project in the outline below in order to fix it.` : `There are ${conflicts.length} projects that have state conflicts. They are highlighted in the outline below. `) : /* @__PURE__ */ import_react248.default.createElement(BasicTooltip_default, null, "Outline"));
      const outlinePinned = (_a2 = useVal(getStudio().atomP.ahistoric.pinOutline)) != null ? _a2 : true;
      const detailsPinned = (_b = useVal(getStudio().atomP.ahistoric.pinDetails)) != null ? _b : true;
      const hasUpdates = useVal(getStudio().atomP.ahistoric.updateChecker.result.hasUpdates) === true;
      const moreMenu = usePopover(() => {
        const triggerBounds = moreMenuTriggerRef.current.getBoundingClientRect();
        return {
          debugName: "More Menu",
          constraints: {
            maxX: triggerBounds.right,
            maxY: 8,
            minX: triggerBounds.left - 140,
            minY: 8
          },
          verticalGap: 2
        };
      }, () => {
        return /* @__PURE__ */ import_react248.default.createElement(MoreMenu_default, null);
      });
      const moreMenuTriggerRef = (0, import_react248.useRef)(null);
      const showUpdatesBadge = (0, import_react248.useMemo)(() => {
        if (hasUpdates || window.__IS_VISUAL_REGRESSION_TESTING) {
          if (!showedVisualTestingWarning) {
            showedVisualTestingWarning = true;
            console.warn("Visual regression testing enabled, so we're showing the updates badge unconditionally");
          }
          return true;
        }
        return hasUpdates;
      }, [hasUpdates]);
      const { hasNotifications } = useNotifications();
      const [notificationsTooltip, notificationsTriggerRef] = useEmptyNotificationsTooltip();
      return /* @__PURE__ */ import_react248.default.createElement(Container59, null, /* @__PURE__ */ import_react248.default.createElement(SubContainer, null, triggerTooltip, /* @__PURE__ */ import_react248.default.createElement(PinButton_default, {
        ref: triggerButtonRef,
        "data-testid": "OutlinePanel-TriggerButton",
        onClick: () => {
          getStudio().transaction(({ stateEditors: stateEditors2, drafts: drafts2 }) => {
            var _a3;
            stateEditors2.studio.ahistoric.setPinOutline(!((_a3 = drafts2.ahistoric.pinOutline) != null ? _a3 : true));
          });
        },
        icon: /* @__PURE__ */ import_react248.default.createElement(Outline_default, null),
        pinHintIcon: /* @__PURE__ */ import_react248.default.createElement(DoubleChevronRight_default, null),
        unpinHintIcon: /* @__PURE__ */ import_react248.default.createElement(DoubleChevronLeft_default, null),
        pinned: outlinePinned
      }), conflicts.length > 0 ? /* @__PURE__ */ import_react248.default.createElement(NumberOfConflictsIndicator, null, conflicts.length) : null, /* @__PURE__ */ import_react248.default.createElement(ExtensionToolbar_default, {
        showLeftDivider: true,
        toolbarId: "global"
      })), /* @__PURE__ */ import_react248.default.createElement(SubContainer, null, notificationsTooltip, /* @__PURE__ */ import_react248.default.createElement(PinButton_default, {
        ref: notificationsTriggerRef,
        onClick: () => {
          getStudio().transaction(({ stateEditors: stateEditors2, drafts: drafts2 }) => {
            var _a3;
            stateEditors2.studio.ahistoric.setPinNotifications(!((_a3 = drafts2.ahistoric.pinNotifications) != null ? _a3 : false));
          });
        },
        icon: /* @__PURE__ */ import_react248.default.createElement(Bell_default, null),
        pinHintIcon: /* @__PURE__ */ import_react248.default.createElement(Bell_default, null),
        unpinHintIcon: /* @__PURE__ */ import_react248.default.createElement(Bell_default, null),
        pinned: (_c = useVal(getStudio().atomP.ahistoric.pinNotifications)) != null ? _c : false
      }, hasNotifications && /* @__PURE__ */ import_react248.default.createElement(HasUpdatesBadge, {
        type: "warning"
      })), moreMenu.node, /* @__PURE__ */ import_react248.default.createElement(ToolbarIconButton_default, {
        ref: moreMenuTriggerRef,
        onClick: (e2) => {
          moreMenu.toggle(e2, moreMenuTriggerRef.current);
        }
      }, /* @__PURE__ */ import_react248.default.createElement(Ellipsis_default, null), showUpdatesBadge && /* @__PURE__ */ import_react248.default.createElement(HasUpdatesBadge, {
        type: "info"
      })), /* @__PURE__ */ import_react248.default.createElement(PinButton_default, {
        ref: triggerButtonRef,
        onClick: () => {
          getStudio().transaction(({ stateEditors: stateEditors2, drafts: drafts2 }) => {
            var _a3;
            stateEditors2.studio.ahistoric.setPinDetails(!((_a3 = drafts2.ahistoric.pinDetails) != null ? _a3 : true));
          });
        },
        icon: /* @__PURE__ */ import_react248.default.createElement(Details_default, null),
        pinHintIcon: /* @__PURE__ */ import_react248.default.createElement(DoubleChevronLeft_default, null),
        unpinHintIcon: /* @__PURE__ */ import_react248.default.createElement(DoubleChevronRight_default, null),
        pinned: detailsPinned
      })));
    };
    GlobalToolbar_default = GlobalToolbar;
  }
});

// studio/src/utils/renderInPortalInContext.tsx
var import_dataverse79, import_react250, import_react_dom8, theAtom, lastId, getMounter, MountAll, Mount;
var init_renderInPortalInContext = __esm({
  "studio/src/utils/renderInPortalInContext.tsx"() {
    import_dataverse79 = __toModule(require("@theatre/dataverse"));
    init_src();
    import_react250 = __toModule(require_react());
    import_react_dom8 = __toModule(require_react_dom());
    theAtom = new import_dataverse79.Atom({
      set: {},
      byId: {}
    });
    lastId = 1;
    getMounter = () => {
      const id = lastId++;
      function mountOrRender(comp, props, portalNode) {
        theAtom.reduceState([], (s3) => {
          return {
            byId: __spreadProps(__spreadValues({}, s3.byId), { [id]: { comp, props, portalNode } }),
            set: __spreadProps(__spreadValues({}, s3.set), { [id]: true })
          };
        });
      }
      function unmount() {
        theAtom.reduceState([], (s3) => {
          const set2 = __spreadValues({}, s3.set);
          const byId = __spreadValues({}, s3.byId);
          delete set2[id];
          return { byId, set: set2 };
        });
      }
      return { mountOrRender, unmount };
    };
    MountAll = () => {
      const ids = Object.keys(useVal(theAtom.pointer.set));
      return /* @__PURE__ */ import_react250.default.createElement(import_react250.default.Fragment, null, ids.map((id) => /* @__PURE__ */ import_react250.default.createElement(Mount, {
        key: "id-" + id,
        id
      })));
    };
    Mount = ({ id }) => {
      const { comp, portalNode, props } = useVal(theAtom.pointer.byId[id]);
      const Comp = comp;
      return (0, import_react_dom8.createPortal)(/* @__PURE__ */ import_react250.default.createElement(Comp, __spreadValues({}, props)), portalNode);
    };
  }
});

// studio/src/UIRoot/UIRoot.tsx
function UIRoot() {
  const studio3 = getStudio();
  const [portalLayerRef, portalLayer] = useRefAndState(void 0);
  const uiRootLogger = createTheatreInternalLogger();
  uiRootLogger.configureLogging({
    min: TheatreLoggerLevel.DEBUG,
    dev: INTERNAL_LOGGING,
    internal: INTERNAL_LOGGING
  });
  const logger = uiRootLogger.getLogger().named("Theatre.js UIRoot");
  useKeyboardShortcuts();
  const visiblityState = useVal(studio3.atomP.ahistoric.visibilityState);
  (0, import_react252.useEffect)(() => {
    if (visiblityState === "everythingIsHidden") {
      console.warn(`Theatre.js Studio is hidden. Use the keyboard shortcut 'alt + \\' to restore the studio, or call studio.ui.restore().`);
    }
    return () => {
    };
  }, [visiblityState]);
  const inside = usePrism(() => {
    const visiblityState2 = (0, import_dataverse80.val)(studio3.atomP.ahistoric.visibilityState);
    const initialised = (0, import_dataverse80.val)(studio3.atomP.ephemeral.initialised);
    return !initialised ? null : /* @__PURE__ */ import_react252.default.createElement(ProvideLogger, {
      logger
    }, /* @__PURE__ */ import_react252.default.createElement(TooltipContext_default, null, /* @__PURE__ */ import_react252.default.createElement(ProvidePointerCapturing, null, /* @__PURE__ */ import_react252.default.createElement(MountExtensionComponents, null), /* @__PURE__ */ import_react252.default.createElement(PortalContext.Provider, {
      value: portalLayer
    }, /* @__PURE__ */ import_react252.default.createElement(ProvideStyles, {
      target: window.__IS_VISUAL_REGRESSION_TESTING === true ? void 0 : getStudio().ui.containerShadow
    }, /* @__PURE__ */ import_react252.default.createElement(import_react252.default.Fragment, null, /* @__PURE__ */ import_react252.default.createElement(MakeRootHostContainStatic, null), /* @__PURE__ */ import_react252.default.createElement(Container60, {
      className: visiblityState2 === "everythingIsHidden" ? "invisible" : ""
    }, /* @__PURE__ */ import_react252.default.createElement(PortalLayer, {
      ref: portalLayerRef
    }), /* @__PURE__ */ import_react252.default.createElement(GlobalToolbar_default, null), /* @__PURE__ */ import_react252.default.createElement(PanelsRoot_default, null), /* @__PURE__ */ import_react252.default.createElement(Notifier, null))))))));
  }, [studio3, portalLayerRef, portalLayer]);
  return inside;
}
var import_dataverse80, import_react252, MakeRootHostContainStatic, Container60, _a, INTERNAL_LOGGING, MountExtensionComponents;
var init_UIRoot = __esm({
  "studio/src/UIRoot/UIRoot.tsx"() {
    init_getStudio();
    init_src();
    import_dataverse80 = __toModule(require("@theatre/dataverse"));
    import_react252 = __toModule(require_react());
    init_styled_components_browser_esm();
    init_PanelsRoot();
    init_GlobalToolbar();
    init_useRefAndState();
    init_es2();
    init_useKeyboardShortcuts();
    init_PointerEventsHandler();
    init_TooltipContext();
    init_PointerCapturing();
    init_renderInPortalInContext();
    init_css();
    init_logger2();
    init_useLogger();
    init_notify();
    MakeRootHostContainStatic = typeof window !== "undefined" ? We`
  :host {
    contain: strict;
  }
` : {};
    Container60 = styled_components_browser_esm_default(PointerEventsHandler_default)`
  z-index: 50;
  position: fixed;
  inset: 0;

  &.invisible {
    pointer-events: none !important;
    opacity: 0;
    transform: translateX(1000000px);
  }
`;
    INTERNAL_LOGGING = /Playground.+Theatre\.js/.test((_a = typeof document !== "undefined" ? document == null ? void 0 : document.title : null) != null ? _a : "");
    MountExtensionComponents = () => {
      return /* @__PURE__ */ import_react252.default.createElement(MountAll, null);
    };
  }
});

// studio/src/UI.ts
var UI_exports = {};
__export(UI_exports, {
  default: () => UI
});
var import_react253, import_react_dom9, import_dataverse81, UI;
var init_UI = __esm({
  "studio/src/UI.ts"() {
    init_UIRoot();
    import_react253 = __toModule(require_react());
    import_react_dom9 = __toModule(require_react_dom());
    import_dataverse81 = __toModule(require("@theatre/dataverse"));
    init_renderInPortalInContext();
    init_css();
    init_ExtensionToolbar();
    UI = class {
      constructor(studio3) {
        this.studio = studio3;
        __publicField(this, "containerEl", document.createElement("div"));
        __publicField(this, "_rendered", false);
        __publicField(this, "_renderTimeout");
        __publicField(this, "_documentBodyUIIsRenderedIn");
        __publicField(this, "containerShadow");
        this.containerEl.id = "theatrejs-studio-root";
        this.containerEl.style.cssText = `
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: none;
      z-index: 100;
    `;
        const createShadowRoot = () => {
          if (window.__IS_VISUAL_REGRESSION_TESTING === true) {
            const fauxRoot = document.createElement("div");
            fauxRoot.id = "theatrejs-faux-shadow-root";
            document.body.appendChild(fauxRoot);
            return fauxRoot;
          } else {
            return this.containerEl.attachShadow({
              mode: "open"
            });
          }
        };
        this.containerShadow = createShadowRoot();
      }
      render() {
        if (this._rendered) {
          return;
        }
        this._rendered = true;
        this._render();
      }
      _render() {
        const renderCallback = () => {
          if (!document.body) {
            this._renderTimeout = setTimeout(renderCallback, 5);
            return;
          }
          this._renderTimeout = void 0;
          this._documentBodyUIIsRenderedIn = document.body;
          this._documentBodyUIIsRenderedIn.appendChild(this.containerEl);
          import_react_dom9.default.render(import_react253.default.createElement(UIRoot), this.containerShadow);
        };
        this._renderTimeout = setTimeout(renderCallback, 10);
      }
      hide() {
        this.studio.transaction(({ drafts: drafts2 }) => {
          drafts2.ahistoric.visibilityState = "everythingIsHidden";
        });
      }
      restore() {
        this.render();
        this.studio.transaction(({ drafts: drafts2 }) => {
          drafts2.ahistoric.visibilityState = "everythingIsVisible";
        });
      }
      get isHidden() {
        return (0, import_dataverse81.val)(this.studio.atomP.ahistoric.visibilityState) === "everythingIsHidden";
      }
      renderToolset(toolsetId, htmlNode) {
        const s3 = getMounter();
        s3.mountOrRender(withStyledShadow(ExtensionToolbar_default), { toolbarId: toolsetId }, htmlNode);
        return s3.unmount;
      }
    };
  }
});

// studio/src/index.ts
__export(exports, {
  ToolbarDropdownSelect: () => ToolbarDropdownSelect_default,
  default: () => src_default
});
init_getStudio();

// shared/src/utils/forEachDeep.ts
function forEachDeep(m3, fn2, startingPath = []) {
  if (typeof m3 === "object" && m3) {
    for (const [key, value] of Object.entries(m3)) {
      forEachDeep(value, fn2, [...startingPath, key]);
    }
  } else if (m3 === void 0 || m3 === null) {
    return;
  } else {
    fn2(m3, startingPath);
  }
}

// studio/src/Scrub.ts
var import_dataverse = __toModule(require("@theatre/dataverse"));
init_instanceTypes();
var lastScrubIdAsNumber = 0;
var Scrub = class {
  constructor(_studio) {
    this._studio = _studio;
    __publicField(this, "_id");
    __publicField(this, "_state", { type: "Ready" });
    this._id = String(lastScrubIdAsNumber++);
  }
  get status() {
    return this._state.type;
  }
  reset() {
    const { _state: state } = this;
    if (state.type === "Ready") {
      return;
    } else if (state.type === "Captured") {
      this._state = { type: "Ready" };
      state.transaction.discard();
      state.flagsTransaction.discard();
    } else if (state.type === "Committed") {
      throw new Error(`This scrub is already committed and can't be reset.`);
    } else {
      throw new Error(`This scrub is already discarded and can't be reset.`);
    }
  }
  commit() {
    const { _state: state } = this;
    if (state.type === "Captured") {
      state.transaction.commit();
      state.flagsTransaction.discard();
      this._state = { type: "Committed" };
    } else if (state.type === "Ready") {
      console.warn(`Scrub is empty. Nothing to commit.`);
      return;
    } else if (state.type === "Committed") {
      throw new Error(`This scrub is already committed.`);
    } else {
      throw new Error(`This scrub is already discarded and can't be comitted.`);
    }
  }
  capture(fn2) {
    if (this._state.type === "Captured") {
      this.reset();
    }
    if (this._state.type === "Ready") {
      let errored = true;
      try {
        this._state = __spreadValues({ type: "Captured" }, this._capture(fn2));
        errored = false;
      } finally {
        if (errored) {
          console.error(`This scrub's callback threw an error. We're undo-ing all of the changes made by this scrub, and marking it as discarded.`);
          this._state = { type: "Discarded" };
        }
      }
    } else {
      if (this._state.type === "Committed") {
        throw new Error(`This scrub is already committed and cannot capture again. If you wish to capture more, you can start a new studio.scrub() or do so before scrub.commit()`);
      } else {
        throw new Error(`This scrub is already discarded and cannot capture again. If you wish to capture more, you can start a new studio.scrub() or do so before scrub.discard()`);
      }
    }
  }
  _capture(fn2) {
    const sets = [];
    const transaction = this._studio.tempTransaction((transactionApi) => {
      let running = true;
      const api = {
        set: (pointer2, value) => {
          if (!running) {
            throw new Error(`You seem to have called the scrub api after scrub.capture()`);
          }
          const { root: root3, path } = (0, import_dataverse.getPointerParts)(pointer2);
          if (!isSheetObject(root3)) {
            throw new Error(`We can only scrub props of Sheet Objects for now`);
          }
          transactionApi.set(pointer2, value);
          sets.push(pointer2);
        }
      };
      try {
        fn2(api);
      } finally {
        running = false;
      }
    });
    const flagsTransaction = this._studio.tempTransaction(({ stateEditors: stateEditors2 }) => {
      sets.forEach((pointer2) => {
        const { root: root3, path } = (0, import_dataverse.getPointerParts)(pointer2);
        if (!isSheetObject(root3)) {
          return;
        }
        const defaultValueOfProp = root3.template.getDefaultsAtPointer(pointer2);
        forEachDeep(defaultValueOfProp, (val59, pathToProp) => {
          stateEditors2.studio.ephemeral.projects.stateByProjectId.stateBySheetId.stateByObjectKey.propsBeingScrubbed.flag(__spreadProps(__spreadValues({}, root3.address), { pathToProp }));
        }, path);
      });
    });
    return { transaction, flagsTransaction };
  }
  discard() {
    const { _state: state } = this;
    if (state.type === "Captured" || state.type === "Ready") {
      if (state.type === "Captured") {
        state.transaction.discard();
        state.flagsTransaction.discard();
      }
      this._state = { type: "Discarded" };
    } else if (state.type === "Committed") {
      throw new Error(`This scrub is already committed and can't be discarded.`);
    } else {
      throw new Error(`This scrub is already discarded`);
    }
  }
};

// studio/src/Studio.ts
var import_dataverse82 = __toModule(require("@theatre/dataverse"));

// studio/src/utils/redux/actionCreator.ts
function identity(a4) {
  return a4;
}
var actionCreator = (actionType, transformer = identity) => {
  const originalActionCreator = (payload) => ({ type: actionType, payload: transformer(payload) });
  originalActionCreator.type = actionType;
  originalActionCreator.is = (o3) => o3 && o3.type && o3.type === actionType;
  return originalActionCreator;
};
var actionCreator_default = actionCreator;

// studio/src/utils/redux/withHistory/withHistory.ts
var import_jiff = __toModule(require_jiff());
var import_json_touch_patch = __toModule(require_lib());
init_last();

// ../node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}

// ../node_modules/uuid/dist/esm-browser/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

// ../node_modules/uuid/dist/esm-browser/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default = validate;

// ../node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (var i3 = 0; i3 < 256; ++i3) {
  byteToHex.push((i3 + 256).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate_default(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var stringify_default = stringify;

// ../node_modules/uuid/dist/esm-browser/v4.js
function v4(options2, buf, offset) {
  options2 = options2 || {};
  var rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i3 = 0; i3 < 16; ++i3) {
      buf[offset + i3] = rnds[i3];
    }
    return buf;
  }
  return stringify_default(rnds);
}
var v4_default = v4;

// studio/src/utils/redux/withHistory/withHistory.ts
var historicActions = {
  replaceHistory: actionCreator_default("@history/replaceHistory"),
  startHistoryFromScratch: actionCreator_default("@history/startHistoryFromScratch"),
  undo: actionCreator_default("@history/undo"),
  redo: actionCreator_default("@history/redo")
};
var unknownAction = { type: "@history/unknownAction", payload: "" };
var defaultConfig = {
  maxNumberOfCommits: 100
};
var withHistory = (innerReducer, config = defaultConfig) => {
  const cachedEmptyHistory = createEmptyHistory(innerReducer(void 0, unknownAction));
  return function historicReducer(state, action) {
    if (historicActions.startHistoryFromScratch.is(action)) {
      return createEmptyHistory(innerReducer(void 0, action.payload));
    } else if (historicActions.replaceHistory.is(action)) {
      return action.payload;
    } else {
      if (historicActions.undo.is(action)) {
        return state ? undo(state) : cachedEmptyHistory;
      } else if (historicActions.redo.is(action)) {
        return state ? redo(state) : cachedEmptyHistory;
      } else {
        if (state) {
          return pushCommit(state, innerReducer(state.innerState, action), config);
        } else {
          return createEmptyHistory(innerReducer(void 0, action));
        }
      }
    }
  };
};
function createEmptyHistory(innerState) {
  return {
    currentCommitHash: void 0,
    commitsByHash: {},
    listOfCommitHashes: [],
    innerState
  };
}
function pushCommit(prevHistory, newInnerState, config) {
  if (newInnerState === prevHistory.innerState)
    return prevHistory;
  const commit = createCommit(prevHistory.innerState, newInnerState);
  if (commit.forwardDiff.length === 0) {
    return prevHistory;
  }
  const prevLastCommitHash = last_default(prevHistory.listOfCommitHashes);
  const newHistory = {
    currentCommitHash: commit.hash,
    commitsByHash: __spreadValues({}, prevHistory.commitsByHash),
    listOfCommitHashes: [...prevHistory.listOfCommitHashes],
    innerState: newInnerState
  };
  if (prevHistory.currentCommitHash !== prevLastCommitHash) {
    const indexOfCurrentCommitHash = prevHistory.listOfCommitHashes.findIndex((v5) => v5 === prevHistory.currentCommitHash);
    const listOfCommitHashesToDiscard = prevHistory.listOfCommitHashes.slice(indexOfCurrentCommitHash + 1);
    listOfCommitHashesToDiscard.forEach((hash) => {
      delete newHistory.commitsByHash[hash];
    });
    newHistory.listOfCommitHashes.splice(indexOfCurrentCommitHash + 1, newHistory.listOfCommitHashes.length);
  }
  newHistory.listOfCommitHashes.push(commit.hash);
  newHistory.commitsByHash[commit.hash] = commit;
  if (newHistory.listOfCommitHashes.length > config.maxNumberOfCommits) {
    const numberOfCommitsToDiscard = newHistory.listOfCommitHashes.length - config.maxNumberOfCommits;
    const listOfCommitHashesToDiscard = newHistory.listOfCommitHashes.slice(0, numberOfCommitsToDiscard);
    listOfCommitHashesToDiscard.forEach((hash) => {
      delete newHistory.commitsByHash[hash];
    });
    newHistory.listOfCommitHashes.splice(0, numberOfCommitsToDiscard);
  }
  return newHistory;
}
function createCommit(oldSnapshot, newSnapshot) {
  const forwardDiff = import_jiff.default.diff(oldSnapshot, newSnapshot, { invertible: false });
  const backwardDiff = import_jiff.default.diff(newSnapshot, oldSnapshot, { invertible: false });
  const timestamp = Date.now();
  const commitHash = v4_default();
  const commit = {
    forwardDiff,
    backwardDiff,
    timestamp,
    hash: commitHash
  };
  return commit;
}
function undo(prevHistory) {
  if (prevHistory.currentCommitHash === void 0) {
    return prevHistory;
  }
  const indexOfCurrentCommitHash = prevHistory.listOfCommitHashes.findIndex((v5) => v5 === prevHistory.currentCommitHash);
  if (indexOfCurrentCommitHash === -1) {
    throw new Error("This should never happen");
  }
  const currentCommit = prevHistory.commitsByHash[prevHistory.currentCommitHash];
  const newInnerState = (0, import_json_touch_patch.default)(prevHistory.innerState, currentCommit.backwardDiff);
  const indexOfNewCommitHash = indexOfCurrentCommitHash - 1;
  const newCommitHash = indexOfNewCommitHash === -1 ? void 0 : prevHistory.listOfCommitHashes[indexOfNewCommitHash];
  const newHistory = __spreadProps(__spreadValues({}, prevHistory), {
    currentCommitHash: newCommitHash,
    innerState: newInnerState
  });
  return newHistory;
}
function redo(prevHistory) {
  if (prevHistory.listOfCommitHashes.length === 0) {
    return prevHistory;
  }
  const indexOfCurrentCommitHash = prevHistory.listOfCommitHashes.findIndex((v5) => v5 === prevHistory.currentCommitHash);
  if (indexOfCurrentCommitHash === prevHistory.listOfCommitHashes.length - 1) {
    return prevHistory;
  }
  const indexOfNewCommitHash = indexOfCurrentCommitHash + 1;
  const newCommitHash = prevHistory.listOfCommitHashes[indexOfNewCommitHash];
  const currentCommit = prevHistory.commitsByHash[newCommitHash];
  const newInnerState = (0, import_json_touch_patch.default)(prevHistory.innerState, currentCommit.forwardDiff);
  const newHistory = __spreadProps(__spreadValues({}, prevHistory), {
    currentCommitHash: newCommitHash,
    innerState: newInnerState
  });
  return newHistory;
}

// studio/src/store/index.ts
init_logger2();
var initialState = {
  ahistoric: {
    visibilityState: "everythingIsVisible",
    theTrigger: {
      position: {
        closestCorner: "bottomLeft",
        distanceFromHorizontalEdge: 0.02,
        distanceFromVerticalEdge: 0.02
      }
    },
    coreByProject: {},
    projects: {
      stateByProjectId: {}
    }
  },
  historic: {
    projects: {
      stateByProjectId: {}
    },
    autoKey: true,
    coreByProject: {},
    panelInstanceDesceriptors: {}
  },
  ephemeral: {
    initialised: false,
    coreByProject: {},
    projects: {
      stateByProjectId: {}
    },
    extensions: {
      byId: {},
      paneClasses: {}
    },
    showOutline: false
  }
};
var replacePersistentState = actionCreator_default("@storeBundle/replacePersistentState", (s3) => s3);
var reduceParts = actionCreator_default("@storeBundle/reduceParts", (fn2) => fn2);
var studioActions = {
  historic: historicActions,
  replacePersistentState,
  reduceParts
};
var setInnerHistoricState = actionCreator_default("@storeBundle/setInnerHistoricState", (s3) => s3);
var historicInnerReducer = (s3 = initialState.historic, action) => {
  if (setInnerHistoricState.is(action)) {
    return action.payload;
  } else {
    return s3;
  }
};
var historicWrappedReducer = withHistory(historicInnerReducer);
var permanentReducer = (prevState, action) => {
  if (replacePersistentState.is(action)) {
    const { historic, ahistoric } = action.payload;
    const ephemeral = (prevState == null ? void 0 : prevState.ephemeral) || initialState.ephemeral;
    return {
      $persistent: { historic, ahistoric },
      ephemeral
    };
  } else if (!prevState) {
    const historic = historicWrappedReducer(void 0, {});
    const ahistoric = initialState.ahistoric;
    const ephemeral = initialState.ephemeral;
    return {
      $persistent: { historic, ahistoric },
      ephemeral
    };
  } else {
    let { historic, ahistoric } = prevState.$persistent;
    let { ephemeral } = prevState;
    if (reduceParts.is(action)) {
      const wholeState = {
        historic: prevState.$persistent.historic.innerState,
        ahistoric: prevState.$persistent.ahistoric,
        ephemeral: prevState.ephemeral
      };
      const reduced = action.payload(wholeState);
      if (reduced === wholeState)
        return prevState;
      if (historic.innerState !== reduced.historic) {
        historic = historicWrappedReducer(historic, setInnerHistoricState(reduced.historic));
      }
      ahistoric = reduced.ahistoric;
      ephemeral = reduced.ephemeral;
    } else {
      const newHistoric = historicWrappedReducer(historic, action);
      if (newHistoric === historic)
        return prevState;
      historic = newHistoric;
    }
    const persistent = historic === prevState.$persistent.historic && ahistoric === prevState.$persistent.ahistoric ? prevState.$persistent : { historic, ahistoric };
    return {
      $persistent: persistent,
      ephemeral
    };
  }
};
var _pushTemporaryAction = actionCreator_default("@history/pushTempAction", (input) => input);
var _discardTemporaryAction = actionCreator_default("@history/discardTempAction", (id) => id);
var _commitTemporaryAction = actionCreator_default("@history/commitTempAction", (id) => id);
var lastTempActionGroupId = 0;
var tempActionGroup = () => {
  const id = lastTempActionGroupId++;
  const push = (originalAction) => _pushTemporaryAction({
    id,
    originalAction
  });
  const discard = () => _discardTemporaryAction(id);
  const commit = () => _commitTemporaryAction(id);
  return {
    push,
    discard,
    commit
  };
};
var studioReducer = (prevState, action) => {
  if (!prevState) {
    const permanent = permanentReducer(void 0, action);
    return {
      $temps: {
        permanent,
        tempActions: []
      },
      $persistent: permanent.$persistent,
      historic: permanent.$persistent.historic.innerState,
      ahistoric: permanent.$persistent.ahistoric,
      ephemeral: permanent.ephemeral
    };
  } else {
    let { tempActions, permanent } = prevState.$temps;
    let actionToPassInToPermanentReducer = void 0;
    if (_pushTemporaryAction.is(action)) {
      tempActions = [...tempActions, action];
    } else if (_commitTemporaryAction.is(action)) {
      const toCommit = tempActions.find((a4) => a4.payload.id === action.payload);
      if (!toCommit) {
        logger_default.error(`Comitting temp action group ${action.payload} isn't possible as this group doesn't exist`);
      } else {
        actionToPassInToPermanentReducer = toCommit.payload.originalAction;
        tempActions = tempActions.filter((a4) => a4.payload.id !== action.payload);
      }
    } else if (_discardTemporaryAction.is(action)) {
      tempActions = tempActions.filter((a4) => a4.payload.id !== action.payload);
    } else {
      actionToPassInToPermanentReducer = action;
    }
    if (actionToPassInToPermanentReducer) {
      permanent = permanentReducer(prevState.$temps.permanent, actionToPassInToPermanentReducer);
    }
    let surface = {
      historic: permanent.$persistent.historic.innerState,
      ahistoric: permanent.$persistent.ahistoric,
      ephemeral: permanent.ephemeral
    };
    for (const tempAction of tempActions) {
      const orig = tempAction.payload.originalAction;
      surface = orig.payload(surface);
    }
    return __spreadValues({
      $temps: {
        tempActions,
        permanent
      },
      $persistent: permanent.$persistent
    }, surface);
  }
};

// studio/src/store/stateEditors.ts
init_addresses();
init_addresses();
init_ids();

// shared/src/utils/removePathFromObject.ts
function removePathFromObject(base, path) {
  if (typeof base !== "object" || base === null)
    return;
  if (path.length === 0) {
    for (const key of Object.keys(base)) {
      delete base[key];
    }
    return;
  }
  const keysUpToLastKey = path.slice(0, path.length - 1);
  let cur = base;
  const childToParentMapping = new WeakMap();
  for (const key of keysUpToLastKey) {
    const parent = cur;
    const child = parent[key];
    if (typeof child !== "object" || child === null) {
      return;
    } else {
      childToParentMapping.set(child, parent);
      cur = child;
    }
  }
  const keysReversed = path.slice().reverse();
  for (const key of keysReversed) {
    delete cur[key];
    if (Object.keys(cur).length > 0) {
      return;
    } else {
      cur = childToParentMapping.get(cur);
      continue;
    }
  }
}

// shared/src/utils/transformNumber.ts
function transformNumber(initialPos, {
  scale,
  origin,
  translate
}) {
  const scaled = origin + (initialPos - origin) * scale;
  return translate + scaled;
}

// ../node_modules/immer/dist/immer.esm.js
function n(n3) {
  for (var t3 = arguments.length, r3 = Array(t3 > 1 ? t3 - 1 : 0), e2 = 1; e2 < t3; e2++)
    r3[e2 - 1] = arguments[e2];
  if (true) {
    var i3 = Y[n3], o3 = i3 ? typeof i3 == "function" ? i3.apply(null, r3) : i3 : "unknown error nr: " + n3;
    throw Error("[Immer] " + o3);
  }
  throw Error("[Immer] minified error nr: " + n3 + (r3.length ? " " + r3.map(function(n4) {
    return "'" + n4 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n3) {
  return !!n3 && !!n3[Q];
}
function r(n3) {
  return !!n3 && (function(n4) {
    if (!n4 || typeof n4 != "object")
      return false;
    var t3 = Object.getPrototypeOf(n4);
    if (t3 === null)
      return true;
    var r3 = Object.hasOwnProperty.call(t3, "constructor") && t3.constructor;
    return r3 === Object || typeof r3 == "function" && Function.toString.call(r3) === Z;
  }(n3) || Array.isArray(n3) || !!n3[L] || !!n3.constructor[L] || s(n3) || v(n3));
}
function i(n3, t3, r3) {
  r3 === void 0 && (r3 = false), o(n3) === 0 ? (r3 ? Object.keys : nn)(n3).forEach(function(e2) {
    r3 && typeof e2 == "symbol" || t3(e2, n3[e2], n3);
  }) : n3.forEach(function(r4, e2) {
    return t3(e2, r4, n3);
  });
}
function o(n3) {
  var t3 = n3[Q];
  return t3 ? t3.i > 3 ? t3.i - 4 : t3.i : Array.isArray(n3) ? 1 : s(n3) ? 2 : v(n3) ? 3 : 0;
}
function u(n3, t3) {
  return o(n3) === 2 ? n3.has(t3) : Object.prototype.hasOwnProperty.call(n3, t3);
}
function a(n3, t3) {
  return o(n3) === 2 ? n3.get(t3) : n3[t3];
}
function f(n3, t3, r3) {
  var e2 = o(n3);
  e2 === 2 ? n3.set(t3, r3) : e2 === 3 ? (n3.delete(t3), n3.add(r3)) : n3[t3] = r3;
}
function c(n3, t3) {
  return n3 === t3 ? n3 !== 0 || 1 / n3 == 1 / t3 : n3 != n3 && t3 != t3;
}
function s(n3) {
  return X && n3 instanceof Map;
}
function v(n3) {
  return q && n3 instanceof Set;
}
function p(n3) {
  return n3.o || n3.t;
}
function l(n3) {
  if (Array.isArray(n3))
    return Array.prototype.slice.call(n3);
  var t3 = tn(n3);
  delete t3[Q];
  for (var r3 = nn(t3), e2 = 0; e2 < r3.length; e2++) {
    var i3 = r3[e2], o3 = t3[i3];
    o3.writable === false && (o3.writable = true, o3.configurable = true), (o3.get || o3.set) && (t3[i3] = { configurable: true, writable: true, enumerable: o3.enumerable, value: n3[i3] });
  }
  return Object.create(Object.getPrototypeOf(n3), t3);
}
function d(n3, e2) {
  return e2 === void 0 && (e2 = false), y(n3) || t(n3) || !r(n3) ? n3 : (o(n3) > 1 && (n3.set = n3.add = n3.clear = n3.delete = h), Object.freeze(n3), e2 && i(n3, function(n4, t3) {
    return d(t3, true);
  }, true), n3);
}
function h() {
  n(2);
}
function y(n3) {
  return n3 == null || typeof n3 != "object" || Object.isFrozen(n3);
}
function b(t3) {
  var r3 = rn[t3];
  return r3 || n(18, t3), r3;
}
function _() {
  return U || n(0), U;
}
function j(n3, t3) {
  t3 && (b("Patches"), n3.u = [], n3.s = [], n3.v = t3);
}
function O(n3) {
  g(n3), n3.p.forEach(S), n3.p = null;
}
function g(n3) {
  n3 === U && (U = n3.l);
}
function w(n3) {
  return U = { p: [], l: U, h: n3, m: true, _: 0 };
}
function S(n3) {
  var t3 = n3[Q];
  t3.i === 0 || t3.i === 1 ? t3.j() : t3.O = true;
}
function P(t3, e2) {
  e2._ = e2.p.length;
  var i3 = e2.p[0], o3 = t3 !== void 0 && t3 !== i3;
  return e2.h.g || b("ES5").S(e2, t3, o3), o3 ? (i3[Q].P && (O(e2), n(4)), r(t3) && (t3 = M(e2, t3), e2.l || x(e2, t3)), e2.u && b("Patches").M(i3[Q], t3, e2.u, e2.s)) : t3 = M(e2, i3, []), O(e2), e2.u && e2.v(e2.u, e2.s), t3 !== H ? t3 : void 0;
}
function M(n3, t3, r3) {
  if (y(t3))
    return t3;
  var e2 = t3[Q];
  if (!e2)
    return i(t3, function(i3, o4) {
      return A(n3, e2, t3, i3, o4, r3);
    }, true), t3;
  if (e2.A !== n3)
    return t3;
  if (!e2.P)
    return x(n3, e2.t, true), e2.t;
  if (!e2.I) {
    e2.I = true, e2.A._--;
    var o3 = e2.i === 4 || e2.i === 5 ? e2.o = l(e2.k) : e2.o;
    i(e2.i === 3 ? new Set(o3) : o3, function(t4, i3) {
      return A(n3, e2, o3, t4, i3, r3);
    }), x(n3, o3, false), r3 && n3.u && b("Patches").R(e2, r3, n3.u, n3.s);
  }
  return e2.o;
}
function A(e2, i3, o3, a4, c3, s3) {
  if (c3 === o3 && n(5), t(c3)) {
    var v5 = M(e2, c3, s3 && i3 && i3.i !== 3 && !u(i3.D, a4) ? s3.concat(a4) : void 0);
    if (f(o3, a4, v5), !t(v5))
      return;
    e2.m = false;
  }
  if (r(c3) && !y(c3)) {
    if (!e2.h.F && e2._ < 1)
      return;
    M(e2, c3), i3 && i3.A.l || x(e2, c3);
  }
}
function x(n3, t3, r3) {
  r3 === void 0 && (r3 = false), n3.h.F && n3.m && d(t3, r3);
}
function z(n3, t3) {
  var r3 = n3[Q];
  return (r3 ? p(r3) : n3)[t3];
}
function I(n3, t3) {
  if (t3 in n3)
    for (var r3 = Object.getPrototypeOf(n3); r3; ) {
      var e2 = Object.getOwnPropertyDescriptor(r3, t3);
      if (e2)
        return e2;
      r3 = Object.getPrototypeOf(r3);
    }
}
function k(n3) {
  n3.P || (n3.P = true, n3.l && k(n3.l));
}
function E(n3) {
  n3.o || (n3.o = l(n3.t));
}
function R(n3, t3, r3) {
  var e2 = s(t3) ? b("MapSet").N(t3, r3) : v(t3) ? b("MapSet").T(t3, r3) : n3.g ? function(n4, t4) {
    var r4 = Array.isArray(n4), e3 = { i: r4 ? 1 : 0, A: t4 ? t4.A : _(), P: false, I: false, D: {}, l: t4, t: n4, k: null, o: null, j: null, C: false }, i3 = e3, o3 = en;
    r4 && (i3 = [e3], o3 = on);
    var u3 = Proxy.revocable(i3, o3), a4 = u3.revoke, f3 = u3.proxy;
    return e3.k = f3, e3.j = a4, f3;
  }(t3, r3) : b("ES5").J(t3, r3);
  return (r3 ? r3.A : _()).p.push(e2), e2;
}
function D(e2) {
  return t(e2) || n(22, e2), function n3(t3) {
    if (!r(t3))
      return t3;
    var e3, u3 = t3[Q], c3 = o(t3);
    if (u3) {
      if (!u3.P && (u3.i < 4 || !b("ES5").K(u3)))
        return u3.t;
      u3.I = true, e3 = F(t3, c3), u3.I = false;
    } else
      e3 = F(t3, c3);
    return i(e3, function(t4, r3) {
      u3 && a(u3.t, t4) === r3 || f(e3, t4, n3(r3));
    }), c3 === 3 ? new Set(e3) : e3;
  }(e2);
}
function F(n3, t3) {
  switch (t3) {
    case 2:
      return new Map(n3);
    case 3:
      return Array.from(n3);
  }
  return l(n3);
}
var G;
var U;
var W = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol";
var X = typeof Map != "undefined";
var q = typeof Set != "undefined";
var B = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined";
var H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = true, G);
var L = W ? Symbol.for("immer-draftable") : "__$immer_draftable";
var Q = W ? Symbol.for("immer-state") : "__$immer_state";
var V = typeof Symbol != "undefined" && Symbol.iterator || "@@iterator";
var Y = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(n3) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n3;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(n3) {
  return "Cannot apply patch, path doesn't resolve: " + n3;
}, 16: 'Sets cannot have "replace" patches.', 17: function(n3) {
  return "Unsupported patch operation: " + n3;
}, 18: function(n3) {
  return "The plugin for '" + n3 + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n3 + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(n3) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n3 + "'";
}, 22: function(n3) {
  return "'current' expects a draft, got: " + n3;
}, 23: function(n3) {
  return "'original' expects a draft, got: " + n3;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" };
var Z = "" + Object.prototype.constructor;
var nn = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(n3) {
  return Object.getOwnPropertyNames(n3).concat(Object.getOwnPropertySymbols(n3));
} : Object.getOwnPropertyNames;
var tn = Object.getOwnPropertyDescriptors || function(n3) {
  var t3 = {};
  return nn(n3).forEach(function(r3) {
    t3[r3] = Object.getOwnPropertyDescriptor(n3, r3);
  }), t3;
};
var rn = {};
var en = { get: function(n3, t3) {
  if (t3 === Q)
    return n3;
  var e2 = p(n3);
  if (!u(e2, t3))
    return function(n4, t4, r3) {
      var e3, i4 = I(t4, r3);
      return i4 ? "value" in i4 ? i4.value : (e3 = i4.get) === null || e3 === void 0 ? void 0 : e3.call(n4.k) : void 0;
    }(n3, e2, t3);
  var i3 = e2[t3];
  return n3.I || !r(i3) ? i3 : i3 === z(n3.t, t3) ? (E(n3), n3.o[t3] = R(n3.A.h, i3, n3)) : i3;
}, has: function(n3, t3) {
  return t3 in p(n3);
}, ownKeys: function(n3) {
  return Reflect.ownKeys(p(n3));
}, set: function(n3, t3, r3) {
  var e2 = I(p(n3), t3);
  if (e2 == null ? void 0 : e2.set)
    return e2.set.call(n3.k, r3), true;
  if (!n3.P) {
    var i3 = z(p(n3), t3), o3 = i3 == null ? void 0 : i3[Q];
    if (o3 && o3.t === r3)
      return n3.o[t3] = r3, n3.D[t3] = false, true;
    if (c(r3, i3) && (r3 !== void 0 || u(n3.t, t3)))
      return true;
    E(n3), k(n3);
  }
  return n3.o[t3] === r3 && typeof r3 != "number" && (r3 !== void 0 || t3 in n3.o) || (n3.o[t3] = r3, n3.D[t3] = true, true);
}, deleteProperty: function(n3, t3) {
  return z(n3.t, t3) !== void 0 || t3 in n3.t ? (n3.D[t3] = false, E(n3), k(n3)) : delete n3.D[t3], n3.o && delete n3.o[t3], true;
}, getOwnPropertyDescriptor: function(n3, t3) {
  var r3 = p(n3), e2 = Reflect.getOwnPropertyDescriptor(r3, t3);
  return e2 ? { writable: true, configurable: n3.i !== 1 || t3 !== "length", enumerable: e2.enumerable, value: r3[t3] } : e2;
}, defineProperty: function() {
  n(11);
}, getPrototypeOf: function(n3) {
  return Object.getPrototypeOf(n3.t);
}, setPrototypeOf: function() {
  n(12);
} };
var on = {};
i(en, function(n3, t3) {
  on[n3] = function() {
    return arguments[0] = arguments[0][0], t3.apply(this, arguments);
  };
}), on.deleteProperty = function(t3, r3) {
  return isNaN(parseInt(r3)) && n(13), en.deleteProperty.call(this, t3[0], r3);
}, on.set = function(t3, r3, e2) {
  return r3 !== "length" && isNaN(parseInt(r3)) && n(14), en.set.call(this, t3[0], r3, e2, t3[0]);
};
var un = function() {
  function e2(t3) {
    var e3 = this;
    this.g = B, this.F = true, this.produce = function(t4, i4, o3) {
      if (typeof t4 == "function" && typeof i4 != "function") {
        var u3 = i4;
        i4 = t4;
        var a4 = e3;
        return function(n3) {
          var t5 = this;
          n3 === void 0 && (n3 = u3);
          for (var r3 = arguments.length, e4 = Array(r3 > 1 ? r3 - 1 : 0), o4 = 1; o4 < r3; o4++)
            e4[o4 - 1] = arguments[o4];
          return a4.produce(n3, function(n4) {
            var r4;
            return (r4 = i4).call.apply(r4, [t5, n4].concat(e4));
          });
        };
      }
      var f3;
      if (typeof i4 != "function" && n(6), o3 !== void 0 && typeof o3 != "function" && n(7), r(t4)) {
        var c3 = w(e3), s3 = R(e3, t4, void 0), v5 = true;
        try {
          f3 = i4(s3), v5 = false;
        } finally {
          v5 ? O(c3) : g(c3);
        }
        return typeof Promise != "undefined" && f3 instanceof Promise ? f3.then(function(n3) {
          return j(c3, o3), P(n3, c3);
        }, function(n3) {
          throw O(c3), n3;
        }) : (j(c3, o3), P(f3, c3));
      }
      if (!t4 || typeof t4 != "object") {
        if ((f3 = i4(t4)) === H)
          return;
        return f3 === void 0 && (f3 = t4), e3.F && d(f3, true), f3;
      }
      n(21, t4);
    }, this.produceWithPatches = function(n3, t4) {
      return typeof n3 == "function" ? function(t5) {
        for (var r4 = arguments.length, i5 = Array(r4 > 1 ? r4 - 1 : 0), o3 = 1; o3 < r4; o3++)
          i5[o3 - 1] = arguments[o3];
        return e3.produceWithPatches(t5, function(t6) {
          return n3.apply(void 0, [t6].concat(i5));
        });
      } : [e3.produce(n3, t4, function(n4, t5) {
        r3 = n4, i4 = t5;
      }), r3, i4];
      var r3, i4;
    }, typeof (t3 == null ? void 0 : t3.useProxies) == "boolean" && this.setUseProxies(t3.useProxies), typeof (t3 == null ? void 0 : t3.autoFreeze) == "boolean" && this.setAutoFreeze(t3.autoFreeze);
  }
  var i3 = e2.prototype;
  return i3.createDraft = function(e3) {
    r(e3) || n(8), t(e3) && (e3 = D(e3));
    var i4 = w(this), o3 = R(this, e3, void 0);
    return o3[Q].C = true, g(i4), o3;
  }, i3.finishDraft = function(t3, r3) {
    var e3 = t3 && t3[Q];
    e3 && e3.C || n(9), e3.I && n(10);
    var i4 = e3.A;
    return j(i4, r3), P(void 0, i4);
  }, i3.setAutoFreeze = function(n3) {
    this.F = n3;
  }, i3.setUseProxies = function(t3) {
    t3 && !B && n(20), this.g = t3;
  }, i3.applyPatches = function(n3, r3) {
    var e3;
    for (e3 = r3.length - 1; e3 >= 0; e3--) {
      var i4 = r3[e3];
      if (i4.path.length === 0 && i4.op === "replace") {
        n3 = i4.value;
        break;
      }
    }
    var o3 = b("Patches").$;
    return t(n3) ? o3(n3, r3) : this.produce(n3, function(n4) {
      return o3(n4, r3.slice(e3 + 1));
    });
  }, e2;
}();
var an = new un();
var fn = an.produce;
var cn = an.produceWithPatches.bind(an);
var sn = an.setAutoFreeze.bind(an);
var vn = an.setUseProxies.bind(an);
var pn = an.applyPatches.bind(an);
var ln = an.createDraft.bind(an);
var dn = an.finishDraft.bind(an);

// studio/src/store/stateEditors.ts
init_findLastIndex();
init_keyBy();
init_pull();
init_set();
init_sortBy();
init_GraphEditor();
init_lodash();
init_instanceTypes();

// shared/src/utils/PointableSet.ts
var pointableSetUtil = {
  create(values) {
    const set2 = { byId: {}, allIds: {} };
    if (values) {
      for (const [id, value] of values) {
        set2.byId[id] = value;
        set2.allIds[id] = true;
      }
    }
    return set2;
  },
  shallowCopy(existing) {
    return {
      byId: __spreadValues({}, existing == null ? void 0 : existing.byId),
      allIds: __spreadValues({}, existing == null ? void 0 : existing.allIds)
    };
  },
  add(existing, id, value) {
    return {
      byId: __spreadProps(__spreadValues({}, existing == null ? void 0 : existing.byId), { [id]: value }),
      allIds: __spreadProps(__spreadValues({}, existing == null ? void 0 : existing.allIds), { [id]: true })
    };
  },
  merge(sets) {
    const target = pointableSetUtil.create();
    for (let i3 = 0; i3 < sets.length; i3++) {
      target.byId = __spreadValues(__spreadValues({}, target.byId), sets[i3].byId);
      target.allIds = __spreadValues(__spreadValues({}, target.allIds), sets[i3].allIds);
    }
    return target;
  },
  remove(existing, id) {
    const set2 = pointableSetUtil.shallowCopy(existing);
    delete set2.allIds[id];
    delete set2.byId[id];
    return set2;
  },
  filter(existing, predicate) {
    const set2 = pointableSetUtil.shallowCopy(existing);
    for (const [id, value] of Object.entries(set2.byId)) {
      if (!predicate(value)) {
        delete set2.allIds[id];
        delete set2.byId[id];
      }
    }
    return set2;
  }
};

// studio/src/store/stateEditors.ts
var setDrafts__onlyMeantToBeCalledByTransaction = (drafts2) => {
  currentDrafts = drafts2;
  return stateEditors;
};
var currentDrafts;
var drafts = () => {
  if (currentDrafts === void 0) {
    throw new Error(`Calling stateEditors outside of a transaction is not allowed.`);
  }
  return currentDrafts;
};
var stateEditors;
(function(stateEditors2) {
  let studio3;
  (function(studio4) {
    let historic;
    (function(historic2) {
      let panelPositions;
      (function(panelPositions2) {
        function setPanelPosition(p3) {
          var _a2;
          const h4 = drafts().historic;
          (_a2 = h4.panelPositions) != null ? _a2 : h4.panelPositions = {};
          h4.panelPositions[p3.panelId] = p3.position;
        }
        panelPositions2.setPanelPosition = setPanelPosition;
      })(panelPositions = historic2.panelPositions || (historic2.panelPositions = {}));
      let panels;
      (function(panels2) {
        function _ensure() {
          var _a2, _b;
          (_b = (_a2 = drafts().historic).panels) != null ? _b : _a2.panels = {};
          return drafts().historic.panels;
        }
        panels2._ensure = _ensure;
        let outline;
        (function(outline2) {
          function _ensure2() {
            var _a2;
            const panels3 = stateEditors2.studio.historic.panels._ensure();
            (_a2 = panels3.outlinePanel) != null ? _a2 : panels3.outlinePanel = {};
            return panels3.outlinePanel;
          }
          outline2._ensure = _ensure2;
          let selection;
          (function(selection2) {
            function set2(selection3) {
              const newSelectionState = [];
              for (const item of uniq_default(selection3)) {
                if (isProject(item)) {
                  newSelectionState.push(__spreadValues({ type: "Project" }, item.address));
                } else if (isSheet(item)) {
                  newSelectionState.push(__spreadValues({
                    type: "Sheet"
                  }, item.template.address));
                  stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.setSelectedInstanceId(item.address);
                } else if (isSheetTemplate(item)) {
                  newSelectionState.push(__spreadValues({ type: "Sheet" }, item.address));
                } else if (isSheetObject(item)) {
                  newSelectionState.push(__spreadValues({
                    type: "SheetObject"
                  }, item.template.address));
                  stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId.setSelectedInstanceId(item.sheet.address);
                } else if (isSheetObjectTemplate(item)) {
                  newSelectionState.push(__spreadValues({ type: "SheetObject" }, item.address));
                }
              }
              outline2._ensure().selection = newSelectionState;
            }
            selection2.set = set2;
            function unset() {
              outline2._ensure().selection = [];
            }
            selection2.unset = unset;
          })(selection = outline2.selection || (outline2.selection = {}));
        })(outline = panels2.outline || (panels2.outline = {}));
        let sequenceEditor;
        (function(sequenceEditor2) {
          function _ensure2() {
            var _a2;
            const panels3 = stateEditors2.studio.historic.panels._ensure();
            (_a2 = panels3.sequenceEditor) != null ? _a2 : panels3.sequenceEditor = {};
            return panels3.sequenceEditor;
          }
          sequenceEditor2._ensure = _ensure2;
          let graphEditor;
          (function(graphEditor2) {
            function _ensure3() {
              var _a2;
              const s3 = sequenceEditor2._ensure();
              (_a2 = s3.graphEditor) != null ? _a2 : s3.graphEditor = { height: 0.5, isOpen: false };
              return s3.graphEditor;
            }
            function setIsOpen(p3) {
              _ensure3().isOpen = p3.isOpen;
            }
            graphEditor2.setIsOpen = setIsOpen;
          })(graphEditor = sequenceEditor2.graphEditor || (sequenceEditor2.graphEditor = {}));
        })(sequenceEditor = panels2.sequenceEditor || (panels2.sequenceEditor = {}));
      })(panels = historic2.panels || (historic2.panels = {}));
      let projects;
      (function(projects2) {
        let stateByProjectId;
        (function(stateByProjectId2) {
          function _ensure(p3) {
            const s3 = drafts().historic;
            if (!s3.projects.stateByProjectId[p3.projectId]) {
              s3.projects.stateByProjectId[p3.projectId] = {
                stateBySheetId: {}
              };
            }
            return s3.projects.stateByProjectId[p3.projectId];
          }
          stateByProjectId2._ensure = _ensure;
          let stateBySheetId;
          (function(stateBySheetId2) {
            function _ensure2(p3) {
              const projectState = stateEditors2.studio.historic.projects.stateByProjectId._ensure(p3);
              if (!projectState.stateBySheetId[p3.sheetId]) {
                projectState.stateBySheetId[p3.sheetId] = {
                  selectedInstanceId: void 0,
                  sequenceEditor: {
                    selectedPropsByObject: {}
                  }
                };
              }
              return projectState.stateBySheetId[p3.sheetId];
            }
            stateBySheetId2._ensure = _ensure2;
            function setSelectedInstanceId(p3) {
              stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId._ensure(p3).selectedInstanceId = p3.sheetInstanceId;
            }
            stateBySheetId2.setSelectedInstanceId = setSelectedInstanceId;
            let sequenceEditor;
            (function(sequenceEditor2) {
              function addPropToGraphEditor(p3) {
                const { selectedPropsByObject } = stateBySheetId2._ensure(p3).sequenceEditor;
                if (!selectedPropsByObject[p3.objectKey]) {
                  selectedPropsByObject[p3.objectKey] = {};
                }
                const selectedProps = selectedPropsByObject[p3.objectKey];
                const path = encodePathToProp(p3.pathToProp);
                const possibleColors = new Set(Object.keys(graphEditorColors));
                for (const [_3, selectedProps2] of Object.entries(D(selectedPropsByObject))) {
                  for (const [_4, takenColor] of Object.entries(selectedProps2)) {
                    possibleColors.delete(takenColor);
                  }
                }
                const color2 = possibleColors.size > 0 ? possibleColors.values().next().value : Object.keys(graphEditorColors)[0];
                selectedProps[path] = color2;
              }
              sequenceEditor2.addPropToGraphEditor = addPropToGraphEditor;
              function removePropFromGraphEditor(p3) {
                const { selectedPropsByObject } = stateBySheetId2._ensure(p3).sequenceEditor;
                if (!selectedPropsByObject[p3.objectKey]) {
                  return;
                }
                const selectedProps = selectedPropsByObject[p3.objectKey];
                const path = encodePathToProp(p3.pathToProp);
                if (selectedProps[path]) {
                  removePathFromObject(selectedPropsByObject, [
                    p3.objectKey,
                    path
                  ]);
                }
              }
              sequenceEditor2.removePropFromGraphEditor = removePropFromGraphEditor;
              function _ensureMarkers(sheetAddress) {
                const sequenceEditor3 = stateEditors2.studio.historic.projects.stateByProjectId.stateBySheetId._ensure(sheetAddress).sequenceEditor;
                if (!sequenceEditor3.markerSet) {
                  sequenceEditor3.markerSet = pointableSetUtil.create();
                }
                return sequenceEditor3.markerSet;
              }
              function replaceMarkers(p3) {
                const currentMarkerSet = _ensureMarkers(p3.sheetAddress);
                const sanitizedMarkers = p3.markers.filter((marker) => {
                  if (!isFinite(marker.position))
                    return false;
                  return true;
                }).map((marker) => __spreadProps(__spreadValues({}, marker), {
                  position: p3.snappingFunction(marker.position)
                }));
                const newMarkersById = keyBy_default(sanitizedMarkers, "id");
                let markersThatArentBeingReplaced = pointableSetUtil.filter(currentMarkerSet, (marker) => marker && !newMarkersById[marker.id]);
                const markersThatArentBeingReplacedByPosition = keyBy_default(Object.values(markersThatArentBeingReplaced.byId), "position");
                sanitizedMarkers.forEach(({ position: position2 }) => {
                  const existingMarkerAtThisPosition = markersThatArentBeingReplacedByPosition[position2];
                  if (existingMarkerAtThisPosition) {
                    markersThatArentBeingReplaced = pointableSetUtil.remove(markersThatArentBeingReplaced, existingMarkerAtThisPosition.id);
                  }
                });
                Object.assign(currentMarkerSet, pointableSetUtil.merge([
                  markersThatArentBeingReplaced,
                  pointableSetUtil.create(sanitizedMarkers.map((marker) => [marker.id, marker]))
                ]));
              }
              sequenceEditor2.replaceMarkers = replaceMarkers;
              function removeMarker(options2) {
                const currentMarkerSet = _ensureMarkers(options2.sheetAddress);
                Object.assign(currentMarkerSet, pointableSetUtil.remove(currentMarkerSet, options2.markerId));
              }
              sequenceEditor2.removeMarker = removeMarker;
            })(sequenceEditor = stateBySheetId2.sequenceEditor || (stateBySheetId2.sequenceEditor = {}));
          })(stateBySheetId = stateByProjectId2.stateBySheetId || (stateByProjectId2.stateBySheetId = {}));
        })(stateByProjectId = projects2.stateByProjectId || (projects2.stateByProjectId = {}));
      })(projects = historic2.projects || (historic2.projects = {}));
    })(historic = studio4.historic || (studio4.historic = {}));
    let ephemeral;
    (function(ephemeral2) {
      function setShowOutline(showOutline) {
        drafts().ephemeral.showOutline = showOutline;
      }
      ephemeral2.setShowOutline = setShowOutline;
      let projects;
      (function(projects2) {
        let stateByProjectId;
        (function(stateByProjectId2) {
          function _ensure(p3) {
            const s3 = drafts().ephemeral;
            if (!s3.projects.stateByProjectId[p3.projectId]) {
              s3.projects.stateByProjectId[p3.projectId] = {
                stateBySheetId: {}
              };
            }
            return s3.projects.stateByProjectId[p3.projectId];
          }
          stateByProjectId2._ensure = _ensure;
          let stateBySheetId;
          (function(stateBySheetId2) {
            function _ensure2(p3) {
              const projectState = stateEditors2.studio.ephemeral.projects.stateByProjectId._ensure(p3);
              if (!projectState.stateBySheetId[p3.sheetId]) {
                projectState.stateBySheetId[p3.sheetId] = {
                  stateByObjectKey: {}
                };
              }
              return projectState.stateBySheetId[p3.sheetId];
            }
            stateBySheetId2._ensure = _ensure2;
            let stateByObjectKey;
            (function(stateByObjectKey2) {
              function _ensure3(p3) {
                var _a2, _b;
                const s3 = stateEditors2.studio.ephemeral.projects.stateByProjectId.stateBySheetId._ensure(p3).stateByObjectKey;
                (_b = s3[_a2 = p3.objectKey]) != null ? _b : s3[_a2] = {};
                return s3[p3.objectKey];
              }
              stateByObjectKey2._ensure = _ensure3;
              let propsBeingScrubbed;
              (function(propsBeingScrubbed2) {
                function _ensure4(p3) {
                  var _a2;
                  const s3 = stateEditors2.studio.ephemeral.projects.stateByProjectId.stateBySheetId.stateByObjectKey._ensure(p3);
                  (_a2 = s3.valuesBeingScrubbed) != null ? _a2 : s3.valuesBeingScrubbed = {};
                  return s3.valuesBeingScrubbed;
                }
                propsBeingScrubbed2._ensure = _ensure4;
                function flag(p3) {
                  set_default(_ensure4(p3), p3.pathToProp, true);
                }
                propsBeingScrubbed2.flag = flag;
              })(propsBeingScrubbed = stateByObjectKey2.propsBeingScrubbed || (stateByObjectKey2.propsBeingScrubbed = {}));
            })(stateByObjectKey = stateBySheetId2.stateByObjectKey || (stateBySheetId2.stateByObjectKey = {}));
          })(stateBySheetId = stateByProjectId2.stateBySheetId || (stateByProjectId2.stateBySheetId = {}));
        })(stateByProjectId = projects2.stateByProjectId || (projects2.stateByProjectId = {}));
      })(projects = ephemeral2.projects || (ephemeral2.projects = {}));
    })(ephemeral = studio4.ephemeral || (studio4.ephemeral = {}));
    let ahistoric;
    (function(ahistoric2) {
      function setPinOutline(pinOutline) {
        drafts().ahistoric.pinOutline = pinOutline;
      }
      ahistoric2.setPinOutline = setPinOutline;
      function setPinDetails(pinDetails) {
        drafts().ahistoric.pinDetails = pinDetails;
      }
      ahistoric2.setPinDetails = setPinDetails;
      function setPinNotifications(pinNotifications) {
        drafts().ahistoric.pinNotifications = pinNotifications;
      }
      ahistoric2.setPinNotifications = setPinNotifications;
      function setVisibilityState(visibilityState) {
        drafts().ahistoric.visibilityState = visibilityState;
      }
      ahistoric2.setVisibilityState = setVisibilityState;
      function setClipboardKeyframes(keyframes) {
        const commonPath = commonRootOfPathsToProps(keyframes.map((kf) => kf.pathToProp));
        const keyframesWithCommonRootPath = keyframes.map(({ keyframe, pathToProp }) => ({
          keyframe,
          pathToProp: pathToProp.slice(commonPath.length)
        }));
        const draft = drafts();
        if (draft.ahistoric.clipboard) {
          draft.ahistoric.clipboard.keyframesWithRelativePaths = keyframesWithCommonRootPath;
        } else {
          draft.ahistoric.clipboard = {
            keyframesWithRelativePaths: keyframesWithCommonRootPath
          };
        }
      }
      ahistoric2.setClipboardKeyframes = setClipboardKeyframes;
      let projects;
      (function(projects2) {
        let stateByProjectId;
        (function(stateByProjectId2) {
          function _ensure(p3) {
            const s3 = drafts().ahistoric;
            if (!s3.projects.stateByProjectId[p3.projectId]) {
              s3.projects.stateByProjectId[p3.projectId] = {
                stateBySheetId: {}
              };
            }
            return s3.projects.stateByProjectId[p3.projectId];
          }
          stateByProjectId2._ensure = _ensure;
          let stateBySheetId;
          (function(stateBySheetId2) {
            function _ensure2(p3) {
              const projectState = stateEditors2.studio.ahistoric.projects.stateByProjectId._ensure(p3);
              if (!projectState.stateBySheetId[p3.sheetId]) {
                projectState.stateBySheetId[p3.sheetId] = {};
              }
              return projectState.stateBySheetId[p3.sheetId];
            }
            stateBySheetId2._ensure = _ensure2;
            let sequence;
            (function(sequence2) {
              function _ensure3(p3) {
                const sheetState = stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId._ensure(p3);
                if (!sheetState.sequence) {
                  sheetState.sequence = {};
                }
                return sheetState.sequence;
              }
              sequence2._ensure = _ensure3;
              let focusRange;
              (function(focusRange2) {
                function set2(p3) {
                  stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence._ensure(p3).focusRange = { range: p3.range, enabled: p3.enabled };
                }
                focusRange2.set = set2;
                function unset(p3) {
                  stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence._ensure(p3).focusRange = void 0;
                }
                focusRange2.unset = unset;
              })(focusRange = sequence2.focusRange || (sequence2.focusRange = {}));
              let clippedSpaceRange;
              (function(clippedSpaceRange2) {
                function set2(p3) {
                  stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence._ensure(p3).clippedSpaceRange = __spreadValues({}, p3.range);
                }
                clippedSpaceRange2.set = set2;
              })(clippedSpaceRange = sequence2.clippedSpaceRange || (sequence2.clippedSpaceRange = {}));
              let sequenceEditorCollapsableItems;
              (function(sequenceEditorCollapsableItems2) {
                function _ensure4(p3) {
                  const seq = stateEditors2.studio.ahistoric.projects.stateByProjectId.stateBySheetId.sequence._ensure(p3);
                  let existing = seq.collapsableItems;
                  if (!existing) {
                    existing = seq.collapsableItems = pointableSetUtil.create();
                  }
                  return existing;
                }
                function set2(p3) {
                  const collapsableSet = _ensure4(p3);
                  Object.assign(collapsableSet, pointableSetUtil.add(collapsableSet, p3.studioSheetItemKey, {
                    isCollapsed: p3.isCollapsed
                  }));
                }
                sequenceEditorCollapsableItems2.set = set2;
              })(sequenceEditorCollapsableItems = sequence2.sequenceEditorCollapsableItems || (sequence2.sequenceEditorCollapsableItems = {}));
            })(sequence = stateBySheetId2.sequence || (stateBySheetId2.sequence = {}));
          })(stateBySheetId = stateByProjectId2.stateBySheetId || (stateByProjectId2.stateBySheetId = {}));
        })(stateByProjectId = projects2.stateByProjectId || (projects2.stateByProjectId = {}));
      })(projects = ahistoric2.projects || (ahistoric2.projects = {}));
    })(ahistoric = studio4.ahistoric || (studio4.ahistoric = {}));
  })(studio3 = stateEditors2.studio || (stateEditors2.studio = {}));
  let coreByProject;
  (function(coreByProject2) {
    let historic;
    (function(historic2) {
      let revisionHistory;
      (function(revisionHistory2) {
        function add(p3) {
          const revisionHistory3 = drafts().historic.coreByProject[p3.projectId].revisionHistory;
          const maxNumOfRevisionsToKeep = 50;
          revisionHistory3.unshift(p3.revision);
          if (revisionHistory3.length > maxNumOfRevisionsToKeep) {
            revisionHistory3.length = maxNumOfRevisionsToKeep;
          }
        }
        revisionHistory2.add = add;
      })(revisionHistory = historic2.revisionHistory || (historic2.revisionHistory = {}));
      let sheetsById;
      (function(sheetsById2) {
        function _ensure(p3) {
          const sheetsById3 = drafts().historic.coreByProject[p3.projectId].sheetsById;
          if (!sheetsById3[p3.sheetId]) {
            sheetsById3[p3.sheetId] = { staticOverrides: { byObject: {} } };
          }
          return sheetsById3[p3.sheetId];
        }
        sheetsById2._ensure = _ensure;
        let sequence;
        (function(sequence2) {
          function _ensure2(p3) {
            var _a2;
            const s3 = stateEditors2.coreByProject.historic.sheetsById._ensure(p3);
            (_a2 = s3.sequence) != null ? _a2 : s3.sequence = {
              subUnitsPerUnit: 30,
              length: 10,
              type: "PositionalSequence",
              tracksByObject: {}
            };
            return s3.sequence;
          }
          sequence2._ensure = _ensure2;
          function setLength(p3) {
            _ensure2(p3).length = clamp_default(parseFloat(p3.length.toFixed(2)), 0.01, Infinity);
          }
          sequence2.setLength = setLength;
          function _ensureTracksOfObject(p3) {
            var _a2, _b;
            const s3 = stateEditors2.coreByProject.historic.sheetsById.sequence._ensure(p3).tracksByObject;
            (_b = s3[_a2 = p3.objectKey]) != null ? _b : s3[_a2] = { trackData: {}, trackIdByPropPath: {} };
            return s3[p3.objectKey];
          }
          function setPrimitivePropAsSequenced(p3, config) {
            const tracks = _ensureTracksOfObject(p3);
            const pathEncoded = encodePathToProp(p3.pathToProp);
            const possibleTrackId = tracks.trackIdByPropPath[pathEncoded];
            if (typeof possibleTrackId === "string")
              return;
            const trackId = generateSequenceTrackId();
            const track = {
              type: "BasicKeyframedTrack",
              __debugName: `${p3.objectKey}:${pathEncoded}`,
              keyframes: []
            };
            tracks.trackData[trackId] = track;
            tracks.trackIdByPropPath[pathEncoded] = trackId;
          }
          sequence2.setPrimitivePropAsSequenced = setPrimitivePropAsSequenced;
          function setPrimitivePropAsStatic(p3) {
            const tracks = _ensureTracksOfObject(p3);
            const encodedPropPath = encodePathToProp(p3.pathToProp);
            const trackId = tracks.trackIdByPropPath[encodedPropPath];
            if (typeof trackId !== "string")
              return;
            delete tracks.trackIdByPropPath[encodedPropPath];
            delete tracks.trackData[trackId];
            stateEditors2.coreByProject.historic.sheetsById.staticOverrides.byObject.setValueOfPrimitiveProp(p3);
          }
          sequence2.setPrimitivePropAsStatic = setPrimitivePropAsStatic;
          function setCompoundPropAsStatic(p3) {
            const tracks = _ensureTracksOfObject(p3);
            for (const encodedPropPath of Object.keys(tracks.trackIdByPropPath)) {
              const propPath = JSON.parse(encodedPropPath);
              const isSubOfTargetPath = p3.pathToProp.every((key, i3) => propPath[i3] === key);
              if (isSubOfTargetPath) {
                const trackId = tracks.trackIdByPropPath[encodedPropPath];
                if (typeof trackId !== "string")
                  continue;
                delete tracks.trackIdByPropPath[encodedPropPath];
                delete tracks.trackData[trackId];
              }
            }
            stateEditors2.coreByProject.historic.sheetsById.staticOverrides.byObject.setValueOfCompoundProp(p3);
          }
          sequence2.setCompoundPropAsStatic = setCompoundPropAsStatic;
          function _getTrack(p3) {
            return _ensureTracksOfObject(p3).trackData[p3.trackId];
          }
          function setKeyframeAtPosition(p3) {
            const position2 = p3.snappingFunction(p3.position);
            const track = _getTrack(p3);
            if (!track)
              return;
            const { keyframes } = track;
            const existingKeyframeIndex = keyframes.findIndex((kf) => kf.position === position2);
            if (existingKeyframeIndex !== -1) {
              const kf = keyframes[existingKeyframeIndex];
              kf.value = p3.value;
              return;
            }
            const indexOfLeftKeyframe = findLastIndex_default(keyframes, (kf) => kf.position < position2);
            if (indexOfLeftKeyframe === -1) {
              keyframes.unshift({
                id: generateKeyframeId(),
                position: position2,
                connectedRight: true,
                handles: p3.handles || [0.5, 1, 0.5, 0],
                value: p3.value
              });
              return;
            }
            const leftKeyframe = keyframes[indexOfLeftKeyframe];
            keyframes.splice(indexOfLeftKeyframe + 1, 0, {
              id: generateKeyframeId(),
              position: position2,
              connectedRight: leftKeyframe.connectedRight,
              handles: p3.handles || [0.5, 1, 0.5, 0],
              value: p3.value
            });
          }
          sequence2.setKeyframeAtPosition = setKeyframeAtPosition;
          function unsetKeyframeAtPosition(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            const { keyframes } = track;
            const index = keyframes.findIndex((kf) => kf.position === p3.position);
            if (index === -1)
              return;
            keyframes.splice(index, 1);
          }
          sequence2.unsetKeyframeAtPosition = unsetKeyframeAtPosition;
          function transformKeyframes(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            const initialKeyframes = D(track.keyframes);
            const selectedKeyframes = initialKeyframes.filter((kf) => p3.keyframeIds.includes(kf.id));
            const transformed = selectedKeyframes.map((untransformedKf) => {
              const oldPosition = untransformedKf.position;
              const newPosition = p3.snappingFunction(transformNumber(oldPosition, p3));
              return __spreadProps(__spreadValues({}, untransformedKf), { position: newPosition });
            });
            replaceKeyframes(__spreadProps(__spreadValues({}, p3), { keyframes: transformed }));
          }
          sequence2.transformKeyframes = transformKeyframes;
          function setTweenBetweenKeyframes(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            track.keyframes = track.keyframes.map((kf, i3) => {
              const prevKf = track.keyframes[i3 - 1];
              const isBeingEdited = p3.keyframeIds.includes(kf.id);
              const isAfterEditedKeyframe = p3.keyframeIds.includes(prevKf == null ? void 0 : prevKf.id);
              if (isBeingEdited && !isAfterEditedKeyframe) {
                return __spreadProps(__spreadValues({}, kf), {
                  handles: [
                    kf.handles[0],
                    kf.handles[1],
                    p3.handles[0],
                    p3.handles[1]
                  ]
                });
              } else if (isBeingEdited && isAfterEditedKeyframe) {
                return __spreadProps(__spreadValues({}, kf), {
                  handles: [
                    p3.handles[2],
                    p3.handles[3],
                    p3.handles[0],
                    p3.handles[1]
                  ]
                });
              } else if (isAfterEditedKeyframe) {
                return __spreadProps(__spreadValues({}, kf), {
                  handles: [
                    p3.handles[2],
                    p3.handles[3],
                    kf.handles[2],
                    kf.handles[3]
                  ]
                });
              } else {
                return kf;
              }
            });
          }
          sequence2.setTweenBetweenKeyframes = setTweenBetweenKeyframes;
          function setHandlesForKeyframe(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            track.keyframes = track.keyframes.map((kf) => {
              var _a2, _b, _c, _d, _e2, _f, _g, _h;
              if (kf.id === p3.keyframeId) {
                return __spreadProps(__spreadValues({}, kf), {
                  handles: [
                    (_b = (_a2 = p3.end) == null ? void 0 : _a2[0]) != null ? _b : kf.handles[0],
                    (_d = (_c = p3.end) == null ? void 0 : _c[1]) != null ? _d : kf.handles[1],
                    (_f = (_e2 = p3.start) == null ? void 0 : _e2[0]) != null ? _f : kf.handles[2],
                    (_h = (_g = p3.start) == null ? void 0 : _g[1]) != null ? _h : kf.handles[3]
                  ]
                });
              } else
                return kf;
            });
          }
          sequence2.setHandlesForKeyframe = setHandlesForKeyframe;
          function deleteKeyframes(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            track.keyframes = track.keyframes.filter((kf) => p3.keyframeIds.indexOf(kf.id) === -1);
          }
          sequence2.deleteKeyframes = deleteKeyframes;
          function replaceKeyframes(p3) {
            const track = _getTrack(p3);
            if (!track)
              return;
            const initialKeyframes = D(track.keyframes);
            const sanitizedKeyframes = p3.keyframes.filter((kf) => {
              if (typeof kf.value === "number" && !isFinite(kf.value))
                return false;
              if (!kf.handles.every((handleValue) => isFinite(handleValue)))
                return false;
              return true;
            }).map((kf) => __spreadProps(__spreadValues({}, kf), { position: p3.snappingFunction(kf.position) }));
            const newKeyframesById = keyBy_default(sanitizedKeyframes, "id");
            const unselected = initialKeyframes.filter((kf) => !newKeyframesById[kf.id]);
            const unselectedByPosition = keyBy_default(unselected, "position");
            sanitizedKeyframes.forEach(({ position: position2 }) => {
              const existingKeyframeAtThisPosition = unselectedByPosition[position2];
              if (existingKeyframeAtThisPosition) {
                pull_default(unselected, existingKeyframeAtThisPosition);
              }
            });
            const sorted = sortBy_default([...unselected, ...sanitizedKeyframes], "position");
            track.keyframes = sorted;
          }
          sequence2.replaceKeyframes = replaceKeyframes;
        })(sequence = sheetsById2.sequence || (sheetsById2.sequence = {}));
        let staticOverrides;
        (function(staticOverrides2) {
          let byObject;
          (function(byObject2) {
            function _ensure2(p3) {
              var _a2, _b;
              const byObject3 = stateEditors2.coreByProject.historic.sheetsById._ensure(p3).staticOverrides.byObject;
              (_b = byObject3[_a2 = p3.objectKey]) != null ? _b : byObject3[_a2] = {};
              return byObject3[p3.objectKey];
            }
            function setValueOfCompoundProp(p3) {
              const existingOverrides = _ensure2(p3);
              set_default(existingOverrides, p3.pathToProp, p3.value);
            }
            byObject2.setValueOfCompoundProp = setValueOfCompoundProp;
            function setValueOfPrimitiveProp(p3) {
              const existingOverrides = _ensure2(p3);
              set_default(existingOverrides, p3.pathToProp, p3.value);
            }
            byObject2.setValueOfPrimitiveProp = setValueOfPrimitiveProp;
            function unsetValueOfPrimitiveProp(p3) {
              const existingStaticOverrides = stateEditors2.coreByProject.historic.sheetsById._ensure(p3).staticOverrides.byObject[p3.objectKey];
              if (!existingStaticOverrides)
                return;
              removePathFromObject(existingStaticOverrides, p3.pathToProp);
            }
            byObject2.unsetValueOfPrimitiveProp = unsetValueOfPrimitiveProp;
          })(byObject = staticOverrides2.byObject || (staticOverrides2.byObject = {}));
        })(staticOverrides = sheetsById2.staticOverrides || (sheetsById2.staticOverrides = {}));
      })(sheetsById = historic2.sheetsById || (historic2.sheetsById = {}));
    })(historic = coreByProject2.historic || (coreByProject2.historic = {}));
  })(coreByProject = stateEditors2.coreByProject || (stateEditors2.coreByProject = {}));
})(stateEditors || (stateEditors = {}));

// shared/src/utils/defer.ts
function defer() {
  let resolve;
  let reject;
  const promise = new Promise((rs, rj) => {
    resolve = (v5) => {
      rs(v5);
      deferred.status = "resolved";
    };
    reject = (v5) => {
      rj(v5);
      deferred.status = "rejected";
    };
  });
  const deferred = {
    resolve,
    reject,
    promise,
    status: "pending"
  };
  return deferred;
}

// studio/src/utils/redux/atomFromReduxStore.ts
var import_dataverse67 = __toModule(require("@theatre/dataverse"));
function atomFromReduxStore(store) {
  let lastState = store.getState();
  const a4 = new import_dataverse67.Atom(lastState);
  store.subscribe(() => {
    const newState = store.getState();
    a4.setState(newState);
    lastState = newState;
  });
  return a4;
}

// studio/src/utils/redux/configureStore.ts
init_identity();

// ../node_modules/redux/es/createStore.js
init_isPlainObject();

// ../node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root3) {
  var result2;
  var Symbol3 = root3.Symbol;
  if (typeof Symbol3 === "function") {
    if (Symbol3.observable) {
      result2 = Symbol3.observable;
    } else {
      result2 = Symbol3("observable");
      Symbol3.observable = result2;
    }
  } else {
    result2 = "@@observable";
  }
  return result2;
}

// ../node_modules/symbol-observable/es/index.js
var root2;
if (typeof self !== "undefined") {
  root2 = self;
} else if (typeof window !== "undefined") {
  root2 = window;
} else if (typeof global !== "undefined") {
  root2 = global;
} else if (typeof module !== "undefined") {
  root2 = module;
} else {
  root2 = Function("return this")();
}
var result = symbolObservablePonyfill(root2);
var es_default = result;

// ../node_modules/redux/es/createStore.js
var ActionTypes = {
  INIT: "@@redux/INIT"
};
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error("Expected the enhancer to be a function.");
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== "function") {
    throw new Error("Expected the reducer to be a function.");
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  function getState() {
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error("Expected listener to be a function.");
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  function dispatch(action) {
    if (!isPlainObject_default(action)) {
      throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
    }
    if (typeof action.type === "undefined") {
      throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
    }
    if (isDispatching) {
      throw new Error("Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i3 = 0; i3 < listeners.length; i3++) {
      var listener = listeners[i3];
      listener();
    }
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error("Expected the nextReducer to be a function.");
    }
    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }
  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      subscribe: function subscribe2(observer) {
        if (typeof observer !== "object") {
          throw new TypeError("Expected the observer to be an object.");
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe };
      }
    }, _ref[es_default] = function() {
      return this;
    }, _ref;
  }
  dispatch({ type: ActionTypes.INIT });
  return _ref2 = {
    dispatch,
    subscribe,
    getState,
    replaceReducer
  }, _ref2[es_default] = observable, _ref2;
}

// ../node_modules/redux/es/utils/warning.js
function warning2(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e2) {
  }
}

// ../node_modules/redux/es/compose.js
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function(arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function(a4, b4) {
    return function() {
      return a4(b4.apply(void 0, arguments));
    };
  });
}

// ../node_modules/redux/es/index.js
function isCrushed() {
}
if (typeof isCrushed.name === "string" && isCrushed.name !== "isCrushed") {
  warning2("You are currently using minified code outside of NODE_ENV === 'production'. This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) to ensure you have the correct code for your production build.");
}

// studio/src/utils/redux/configureStore.ts
function configureStore(conf) {
  const enhancers = [];
  if (true) {
    const devtoolsEnhancer = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__(conf.devtoolsOptions) : identity_default;
    enhancers.push(devtoolsEnhancer);
  }
  const enhancer = compose(...enhancers);
  const store = createStore(conf.rootReducer, void 0, enhancer);
  return store;
}

// studio/src/StudioStore/persistStateOfStudio.ts
init_logger2();
init_debounce();
var persistStateOfStudio = (reduxStore, onInitialize, localStoragePrefix) => {
  const loadState = (s3) => {
    reduxStore.dispatch(studioActions.replacePersistentState(s3));
  };
  const storageKey = localStoragePrefix + ".persistent";
  const getState = () => reduxStore.getState().$persistent;
  loadFromPersistentStorage();
  let lastState = getState();
  const persist = () => {
    const newState = getState();
    if (newState === lastState)
      return;
    lastState = newState;
    localStorage.setItem(storageKey, JSON.stringify(newState));
  };
  reduxStore.subscribe(debounce_default(persist, 1e3));
  if (window) {
    window.addEventListener("beforeunload", persist);
  }
  function loadFromPersistentStorage() {
    const persistedS = localStorage.getItem(storageKey);
    if (persistedS) {
      let persistedObj;
      let errored = true;
      try {
        persistedObj = JSON.parse(persistedS);
        errored = false;
      } catch (e2) {
        logger_default.warn(`Could not parse Theatre's persisted state. This must be a bug. Please report it.`);
      } finally {
        if (!errored) {
          loadState(persistedObj);
        }
        onInitialize();
      }
    } else {
      onInitialize();
    }
  }
};

// studio/src/StudioStore/StudioStore.ts
init_generateDiskStateRevision();

// studio/src/StudioStore/createTransactionPrivateApi.ts
init_instanceTypes();
init_get();
init_getDeep();
var import_dataverse68 = __toModule(require("@theatre/dataverse"));
init_utils();
init_lodash();
init_userReadableTypeOfValue();
function cloneDeepSerializableAndPrune(v5) {
  if (typeof v5 === "boolean" || typeof v5 === "string" || typeof v5 === "number") {
    return v5;
  } else if (isPlainObject_default(v5)) {
    const cloned = {};
    let clonedAtLeastOneProp = false;
    for (const [key, val59] of Object.entries(v5)) {
      const clonedVal = cloneDeepSerializableAndPrune(val59);
      if (clonedVal !== void 0) {
        cloned[key] = val59;
        clonedAtLeastOneProp = true;
      }
    }
    if (clonedAtLeastOneProp) {
      return cloned;
    }
  } else {
    return void 0;
  }
}
function forEachDeepSimplePropOfCompoundProp(propType, path, callback) {
  for (const [key, subType] of Object.entries(propType.props)) {
    if (subType.type === "compound") {
      forEachDeepSimplePropOfCompoundProp(subType, [...path, key], callback);
    } else if (subType.type === "enum") {
      throw new Error(`Not yet implemented`);
    } else {
      callback(subType, [...path, key]);
    }
  }
}
function createTransactionPrivateApi(ensureRunning, stateEditors2, drafts2) {
  return {
    set: (pointer2, value) => {
      ensureRunning();
      const _value = cloneDeepSerializableAndPrune(value);
      if (typeof _value === "undefined")
        return;
      const { root: root3, path } = (0, import_dataverse68.getPointerParts)(pointer2);
      if (isSheetObject(root3)) {
        const sequenceTracksTree = root3.template.getMapOfValidSequenceTracks_forStudio().getValue();
        const propConfig = getPropConfigByPath(root3.template.staticConfig, path);
        if (!propConfig) {
          throw new Error(`Object ${root3.address.objectKey} does not have a prop at ${JSON.stringify(path)}`);
        }
        const setStaticOrKeyframeProp = (value2, propConfig2, path2) => {
          if (value2 === void 0 || value2 === null) {
            return;
          }
          const deserialized = cloneDeepSerializableAndPrune(propConfig2.deserializeAndSanitize(value2));
          if (deserialized === void 0) {
            throw new Error(`Invalid value ${userReadableTypeOfValue_default(value2)} for object.props${path2.map((key) => `[${JSON.stringify(key)}]`).join("")} is invalid`);
          }
          const propAddress = __spreadProps(__spreadValues({}, root3.address), { pathToProp: path2 });
          const trackId = get_default(sequenceTracksTree, path2);
          if (typeof trackId === "string") {
            const seq = root3.sheet.getSequence();
            seq.position = seq.closestGridPosition(seq.position);
            stateEditors2.coreByProject.historic.sheetsById.sequence.setKeyframeAtPosition(__spreadProps(__spreadValues({}, propAddress), {
              trackId,
              position: seq.position,
              value: value2,
              snappingFunction: seq.closestGridPosition
            }));
          } else {
            stateEditors2.coreByProject.historic.sheetsById.staticOverrides.byObject.setValueOfPrimitiveProp(__spreadProps(__spreadValues({}, propAddress), { value: value2 }));
          }
        };
        if (propConfig.type === "compound") {
          const pathToTopPointer = (0, import_dataverse68.getPointerParts)(pointer2).path;
          const lengthOfTopPointer = pathToTopPointer.length;
          forEachDeepSimplePropOfCompoundProp(propConfig, pathToTopPointer, (primitivePropConfig, pathToProp) => {
            const pathToPropInProvidedValue = pathToProp.slice(lengthOfTopPointer);
            const v5 = getDeep(_value, pathToPropInProvidedValue);
            if (typeof v5 !== "undefined") {
              setStaticOrKeyframeProp(v5, primitivePropConfig, pathToProp);
            } else {
              throw new Error(`Property object.props${pathToProp.map((key) => `[${JSON.stringify(key)}]`).join("")} is required but not provided`);
            }
          });
        } else if (propConfig.type === "enum") {
          throw new Error(`Enums aren't implemented yet`);
        } else {
          setStaticOrKeyframeProp(_value, propConfig, path);
        }
      } else {
        throw new Error("Only setting props of SheetObject-s is supported in a transaction so far");
      }
    },
    unset: (pointer2) => {
      ensureRunning();
      const { root: root3, path } = (0, import_dataverse68.getPointerParts)(pointer2);
      if (isSheetObject(root3)) {
        const sequenceTracksTree = root3.template.getMapOfValidSequenceTracks_forStudio().getValue();
        const defaultValue = getDeep(root3.template.getDefaultValues().getValue(), path);
        const propConfig = getPropConfigByPath(root3.template.staticConfig, path);
        const unsetStaticOrKeyframeProp = (value, path2) => {
          const propAddress = __spreadProps(__spreadValues({}, root3.address), { pathToProp: path2 });
          const trackId = get_default(sequenceTracksTree, path2);
          if (typeof trackId === "string") {
            stateEditors2.coreByProject.historic.sheetsById.sequence.unsetKeyframeAtPosition(__spreadProps(__spreadValues({}, propAddress), {
              trackId,
              position: root3.sheet.getSequence().positionSnappedToGrid
            }));
          } else if (propConfig !== void 0) {
            stateEditors2.coreByProject.historic.sheetsById.staticOverrides.byObject.unsetValueOfPrimitiveProp(propAddress);
          }
        };
        if (propConfig.type === "compound") {
          forEachDeep(defaultValue, (v5, pathToProp) => {
            unsetStaticOrKeyframeProp(v5, pathToProp);
          }, (0, import_dataverse68.getPointerParts)(pointer2).path);
        } else {
          unsetStaticOrKeyframeProp(defaultValue, path);
        }
      } else {
        throw new Error("Only setting props of SheetObject-s is supported in a transaction so far");
      }
    },
    get drafts() {
      ensureRunning();
      return drafts2;
    },
    get stateEditors() {
      return stateEditors2;
    }
  };
}

// studio/src/StudioStore/StudioStore.ts
var StudioStore = class {
  constructor() {
    __publicField(this, "_reduxStore");
    __publicField(this, "_atom");
    __publicField(this, "atomP");
    this._reduxStore = configureStore({
      rootReducer: studioReducer,
      devtoolsOptions: { name: "Theatre.js Studio" }
    });
    this._atom = atomFromReduxStore(this._reduxStore);
    this.atomP = this._atom.pointer;
  }
  initialize(opts) {
    const d3 = defer();
    if (opts.usePersistentStorage === true) {
      persistStateOfStudio(this._reduxStore, () => {
        this.tempTransaction(({ drafts: drafts2 }) => {
          drafts2.ephemeral.initialised = true;
        }).commit();
        d3.resolve();
      }, opts.persistenceKey);
    } else {
      this.tempTransaction(({ drafts: drafts2 }) => {
        drafts2.ephemeral.initialised = true;
      }).commit();
      d3.resolve();
    }
    return d3.promise;
  }
  getState() {
    return this._reduxStore.getState();
  }
  __dev_startHistoryFromScratch(newHistoricPart) {
    this._reduxStore.dispatch(studioActions.historic.startHistoryFromScratch(studioActions.reduceParts((s3) => __spreadProps(__spreadValues({}, s3), { historic: newHistoricPart }))));
  }
  tempTransaction(fn2) {
    const group = tempActionGroup();
    let errorDuringTransaction;
    const action = group.push(studioActions.reduceParts((wholeState) => {
      const drafts2 = {
        historic: ln(wholeState.historic),
        ahistoric: ln(wholeState.ahistoric),
        ephemeral: ln(wholeState.ephemeral)
      };
      let running = true;
      let ensureRunning = () => {
        if (!running) {
          throw new Error(`You seem to have called the transaction api after studio.transaction() has finished running`);
        }
      };
      const stateEditors2 = setDrafts__onlyMeantToBeCalledByTransaction(drafts2);
      const api = createTransactionPrivateApi(ensureRunning, stateEditors2, drafts2);
      try {
        fn2(api);
        running = false;
        return {
          historic: dn(drafts2.historic),
          ahistoric: dn(drafts2.ahistoric),
          ephemeral: dn(drafts2.ephemeral)
        };
      } catch (err) {
        errorDuringTransaction = err;
        return wholeState;
      } finally {
        setDrafts__onlyMeantToBeCalledByTransaction(void 0);
      }
    }));
    this._reduxStore.dispatch(action);
    if (errorDuringTransaction) {
      this._reduxStore.dispatch(group.discard());
      throw errorDuringTransaction;
    }
    return {
      commit: () => {
        this._reduxStore.dispatch(group.commit());
      },
      discard: () => {
        this._reduxStore.dispatch(group.discard());
      }
    };
  }
  undo() {
    this._reduxStore.dispatch(studioActions.historic.undo());
  }
  redo() {
    this._reduxStore.dispatch(studioActions.historic.redo());
  }
  createContentOfSaveFile(projectId) {
    const projectState = this._reduxStore.getState().$persistent.historic.innerState.coreByProject[projectId];
    if (!projectState) {
      throw new Error(`Project ${projectId} has not been initialized.`);
    }
    const revision = generateDiskStateRevision();
    this.tempTransaction(({ stateEditors: stateEditors2 }) => {
      stateEditors2.coreByProject.historic.revisionHistory.add({
        projectId,
        revision
      });
    }).commit();
    const projectHistoricState = this._reduxStore.getState().$persistent.historic.innerState.coreByProject[projectId];
    const generatedOnDiskState = __spreadValues({}, projectHistoricState);
    return generatedOnDiskState;
  }
};

// studio/src/TheatreStudio.ts
init_studioTicker();
var import_dataverse69 = __toModule(require("@theatre/dataverse"));

// shared/src/utils/SimpleCache.ts
var SimpleCache = class {
  constructor() {
    __publicField(this, "_values", {});
  }
  get(key, producer) {
    if (this.has(key)) {
      return this._values[key];
    } else {
      const cachedValue = producer();
      this._values[key] = cachedValue;
      return cachedValue;
    }
  }
  has(key) {
    return this._values.hasOwnProperty(key);
  }
};

// studio/src/TheatreStudio.ts
init_instanceTypes();
init_selectors();
init_getStudio();
init_lodash();
var TheatreStudio = class {
  constructor(internals) {
    __publicField(this, "ui", {
      hide() {
        getStudio().ui.hide();
      },
      get isHidden() {
        return getStudio().ui.isHidden;
      },
      restore() {
        getStudio().ui.restore();
      },
      renderToolset(toolsetId, htmlNode) {
        return getStudio().ui.renderToolset(toolsetId, htmlNode);
      }
    });
    __publicField(this, "_cache", new SimpleCache());
  }
  initialize(opts) {
    const studio3 = getStudio();
    return studio3.initialize(opts);
  }
  extend(extension) {
    getStudio().extend(extension);
  }
  transaction(fn2) {
    return getStudio().transaction(({ set: set2, unset }) => {
      return fn2({ set: set2, unset });
    });
  }
  _getSelectionDerivation() {
    return this._cache.get("_getStateDerivation()", () => (0, import_dataverse69.prism)(() => {
      return getOutlineSelection().filter((s3) => s3.type === "Theatre_SheetObject" || s3.type === "Theatre_Sheet").map((s3) => s3.publicApi);
    }));
  }
  _getSelection() {
    return this._getSelectionDerivation().getValue();
  }
  setSelection(selection) {
    const sanitizedSelection = [...selection].filter((s3) => isSheetObjectPublicAPI(s3) || isSheetPublicAPI(s3)).map((s3) => getStudio().corePrivateAPI(s3));
    getStudio().transaction(({ stateEditors: stateEditors2 }) => {
      stateEditors2.studio.historic.panels.outline.selection.set(sanitizedSelection);
    });
  }
  onSelectionChange(fn2) {
    return this._getSelectionDerivation().tapImmediate(studioTicker_default, fn2);
  }
  get selection() {
    return this._getSelection();
  }
  scrub() {
    return getStudio().scrub();
  }
  getStudioProject() {
    const core = getStudio().core;
    if (!core) {
      throw new Error(`You're calling studio.getStudioProject() before \`@theatre/core\` is loaded. To fix this:
1. Check if \`@theatre/core\` is import/required in your bundle.
2. Check the stack trace of this error and make sure the funciton that calls getStudioProject() is run after \`@theatre/core\` is loaded.`);
    }
    return getStudio().getStudioProject(core);
  }
  debouncedScrub(threshold = 1e3) {
    let currentScrub;
    const scheduleCommit = debounce_default(() => {
      const s3 = currentScrub;
      if (!s3)
        return;
      currentScrub = void 0;
      s3.commit();
    }, threshold);
    const capture = (arg) => {
      if (!currentScrub) {
        currentScrub = this.scrub();
      }
      let errored = true;
      try {
        currentScrub.capture(arg);
        errored = false;
      } finally {
        if (errored) {
          const s3 = currentScrub;
          currentScrub = void 0;
          s3.discard();
        } else {
          scheduleCommit();
        }
      }
    };
    return { capture };
  }
  createPane(paneClass) {
    return getStudio().paneManager.createPane(paneClass);
  }
  destroyPane(paneId) {
    return getStudio().paneManager.destroyPane(paneId);
  }
  createContentOfSaveFile(projectId) {
    return getStudio().createContentOfSaveFile(projectId);
  }
};

// studio/src/Studio.ts
init_non_secure();

// studio/src/PaneManager.ts
var import_dataverse70 = __toModule(require("@theatre/dataverse"));
init_utils2();
var PaneManager = class {
  constructor(_studio) {
    this._studio = _studio;
    __publicField(this, "_cache", new SimpleCache());
    this._instantiatePanesAsTheyComeIn();
  }
  _instantiatePanesAsTheyComeIn() {
    const allPanesD = this._getAllPanes();
    allPanesD.changesWithoutValues().tap(() => {
      allPanesD.getValue();
    });
  }
  _getAllPanes() {
    return this._cache.get("_getAllPanels()", () => (0, import_dataverse70.prism)(() => {
      const core = (0, import_dataverse70.val)(this._studio.coreP);
      if (!core)
        return {};
      const instanceDescriptors = (0, import_dataverse70.val)(this._studio.atomP.historic.panelInstanceDesceriptors);
      const paneClasses = (0, import_dataverse70.val)(this._studio.atomP.ephemeral.extensions.paneClasses);
      const instances = {};
      for (const instanceDescriptor of Object.values(instanceDescriptors)) {
        if (!instanceDescriptor)
          continue;
        const panelClass = paneClasses[instanceDescriptor.paneClass];
        if (!panelClass)
          continue;
        const { instanceId } = instanceDescriptor;
        const { extensionId, classDefinition: definition } = panelClass;
        const instance = import_dataverse70.prism.memo(`instance-${instanceDescriptor.instanceId}`, () => {
          const inst = {
            extensionId,
            instanceId,
            definition
          };
          return inst;
        }, emptyArray);
        instances[instanceId] = instance;
      }
      return instances;
    }));
  }
  get allPanesD() {
    return this._getAllPanes();
  }
  createPane(paneClass) {
    const core = this._studio.core;
    if (!core) {
      throw new Error(`Can't create a pane because @theatre/core is not yet loaded`);
    }
    const extensionId = (0, import_dataverse70.val)(this._studio.atomP.ephemeral.extensions.paneClasses[paneClass].extensionId);
    const allPaneInstances = (0, import_dataverse70.val)(this._studio.atomP.historic.panelInstanceDesceriptors);
    let instanceId;
    for (let i3 = 1; i3 < 1e3; i3++) {
      instanceId = `${paneClass} #${i3}`;
      if (!allPaneInstances[instanceId])
        break;
    }
    if (!extensionId) {
      throw new Error(`Pane class "${paneClass}" is not registered.`);
    }
    this._studio.transaction(({ drafts: drafts2 }) => {
      drafts2.historic.panelInstanceDesceriptors[instanceId] = {
        instanceId,
        paneClass
      };
    });
    return this._getAllPanes().getValue()[instanceId];
  }
  destroyPane(instanceId) {
    const core = this._studio.core;
    if (!core) {
      throw new Error(`Can't do this yet because @theatre/core is not yet loaded`);
    }
    this._studio.transaction(({ drafts: drafts2 }) => {
      delete drafts2.historic.panelInstanceDesceriptors[instanceId];
    });
  }
};

// studio/src/checkForUpdates.ts
var import_dataverse71 = __toModule(require("@theatre/dataverse"));
init_getStudio();
var UPDATE_CHECK_INTERVAL = 30 * 60 * 1e3;
var TIME_TO_WAIT_ON_ERROR = 1e3 * 60 * 60;
function checkForUpdates() {
  return __async(this, null, function* () {
    while (true) {
      const state = (0, import_dataverse71.val)(getStudio().atomP.ahistoric.updateChecker);
      if (state) {
        if (state.result !== "error") {
          const lastChecked = state.lastChecked;
          const now2 = Date.now();
          const timeElapsedSinceLastCheckedForUpdate = Math.abs(now2 - lastChecked);
          if (timeElapsedSinceLastCheckedForUpdate < UPDATE_CHECK_INTERVAL) {
            yield wait(UPDATE_CHECK_INTERVAL - timeElapsedSinceLastCheckedForUpdate);
          }
        }
      }
      try {
        const response = yield fetch(new Request(`https://updates.theatrejs.com/updates/${"0.5.1"}`));
        if (response.ok) {
          const json = yield response.json();
          if (!isValidUpdateCheckerResponse(json)) {
            throw new Error(`Bad response`);
          }
          getStudio().transaction(({ drafts: drafts2 }) => {
            drafts2.ahistoric.updateChecker = {
              lastChecked: Date.now(),
              result: __spreadValues({}, json)
            };
          });
          yield wait(1e3);
        } else {
          throw new Error(`HTTP Error ${response.statusText}`);
        }
      } catch (error) {
        yield wait(TIME_TO_WAIT_ON_ERROR);
      }
    }
  });
}
var wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
function isValidUpdateCheckerResponse(json) {
  if (typeof json !== "object")
    return false;
  const obj = json;
  if (typeof obj["hasUpdates"] !== "boolean")
    return false;
  return obj.hasUpdates === true && typeof obj.newVersion === "string" && typeof obj.releasePage === "string" || obj.hasUpdates === false;
}

// studio/src/Studio.ts
var import_shallowequal2 = __toModule(require_shallowequal());
var UIConstructorModule = typeof window !== "undefined" ? (init_UI(), UI_exports) : null;
var STUDIO_NOT_INITIALIZED_MESSAGE = `You seem to have imported '@theatre/studio' but haven't initialized it. You can initialize the studio by:
\`\`\`
import studio from '@theatre/studio'
studio.initialize()
\`\`\`

* If you didn't mean to import '@theatre/studio', this means that your bundler is not tree-shaking it. This is most likely a bundler misconfiguration.

* If you meant to import '@theatre/studio' without showing its UI, you can do that by running:

\`\`\`
import studio from '@theatre/studio'
studio.initialize()
studio.ui.hide()
\`\`\`
`;
var STUDIO_INITIALIZED_LATE_MSG = `You seem to have imported '@theatre/studio' but called \`studio.initialize()\` after some delay.
Theatre.js projects remain in pending mode (won't play their sequences) until the studio is initialized, so you should place the \`studio.initialize()\` line right after the import line:

\`\`\`
import studio from '@theatre/studio'
// ... and other imports

studio.initialize()
\`\`\`
`;
var Studio = class {
  constructor() {
    __publicField(this, "ui");
    __publicField(this, "publicApi");
    __publicField(this, "address");
    __publicField(this, "_projectsProxy", new import_dataverse82.PointerProxy(new import_dataverse82.Atom({}).pointer));
    __publicField(this, "projectsP", this._projectsProxy.pointer);
    __publicField(this, "_store", new StudioStore());
    __publicField(this, "_corePrivateApi");
    __publicField(this, "_cache", new SimpleCache());
    __publicField(this, "paneManager");
    __publicField(this, "_coreAtom", new import_dataverse82.Atom({}));
    __publicField(this, "_initializedDeferred", defer());
    __publicField(this, "_initializeFnCalled", false);
    __publicField(this, "_didWarnAboutNotInitializing", false);
    this.address = { studioId: nanoid(10) };
    this.publicApi = new TheatreStudio(this);
    if (typeof window !== "undefined") {
      this.ui = new UIConstructorModule.default(this);
    }
    this._attachToIncomingProjects();
    this.paneManager = new PaneManager(this);
    if (typeof window !== "undefined") {
      setTimeout(() => {
        if (!this._initializeFnCalled) {
          console.error(STUDIO_NOT_INITIALIZED_MESSAGE);
          this._didWarnAboutNotInitializing = true;
        }
      }, 100);
    }
  }
  get atomP() {
    return this._store.atomP;
  }
  initialize(opts) {
    return __async(this, null, function* () {
      if (this._initializeFnCalled) {
        console.log(`\`studio.initialize()\` is already called. Ignoring subsequent calls.`);
        return this._initializedDeferred.promise;
      }
      this._initializeFnCalled = true;
      if (this._didWarnAboutNotInitializing) {
        console.warn(STUDIO_INITIALIZED_LATE_MSG);
      }
      const storeOpts = {
        persistenceKey: "theatre-0.4",
        usePersistentStorage: true
      };
      if (typeof (opts == null ? void 0 : opts.persistenceKey) === "string") {
        storeOpts.persistenceKey = opts.persistenceKey;
      }
      if ((opts == null ? void 0 : opts.usePersistentStorage) === false || typeof window === "undefined") {
        storeOpts.usePersistentStorage = false;
      }
      try {
        yield this._store.initialize(storeOpts);
      } catch (e2) {
        this._initializedDeferred.reject(e2);
        return;
      }
      this._initializedDeferred.resolve();
      if (this.ui) {
        this.ui.render();
        checkForUpdates();
      }
    });
  }
  get initialized() {
    return this._initializedDeferred.promise;
  }
  _attachToIncomingProjects() {
    const projectsD = (0, import_dataverse82.valueDerivation)(this.projectsP);
    const attachToProjects = (projects) => {
      for (const project of Object.values(projects)) {
        if (!project.isAttachedToStudio) {
          project.attachToStudio(this);
        }
      }
    };
    projectsD.changesWithoutValues().tap(() => {
      attachToProjects(projectsD.getValue());
    });
    attachToProjects(projectsD.getValue());
  }
  setCoreBits(coreBits) {
    this._corePrivateApi = coreBits.privateAPI;
    this._coreAtom.setIn(["core"], coreBits.coreExports);
    this._setProjectsP(coreBits.projectsP);
  }
  _setProjectsP(projectsP) {
    this._projectsProxy.setPointer(projectsP);
  }
  scrub() {
    return new Scrub(this);
  }
  tempTransaction(fn2) {
    return this._store.tempTransaction(fn2);
  }
  transaction(fn2) {
    return this.tempTransaction(fn2).commit();
  }
  __dev_startHistoryFromScratch(newHistoricPart) {
    return this._store.__dev_startHistoryFromScratch(newHistoricPart);
  }
  get corePrivateAPI() {
    return this._corePrivateApi;
  }
  get core() {
    return this._coreAtom.getState().core;
  }
  get coreP() {
    return this._coreAtom.pointer.core;
  }
  extend(extension) {
    if (!extension || typeof extension !== "object") {
      throw new Error(`Extensions must be JS objects`);
    }
    if (typeof extension.id !== "string") {
      throw new Error(`extension.id must be a string`);
    }
    this.transaction(({ drafts: drafts2 }) => {
      var _a2;
      if (drafts2.ephemeral.extensions.byId[extension.id]) {
        const prevExtension = drafts2.ephemeral.extensions.byId[extension.id];
        if (extension === prevExtension || (0, import_shallowequal2.default)(extension, prevExtension)) {
          return;
        }
        throw new Error(`Extension id "${extension.id}" is already defined`);
      }
      drafts2.ephemeral.extensions.byId[extension.id] = extension;
      const allPaneClasses = drafts2.ephemeral.extensions.paneClasses;
      (_a2 = extension.panes) == null ? void 0 : _a2.forEach((classDefinition) => {
        if (typeof classDefinition.class !== "string") {
          throw new Error(`pane.class must be a string`);
        }
        if (classDefinition.class.length < 3) {
          throw new Error(`pane.class should be a string with 3 or more characters`);
        }
        const existing = allPaneClasses[classDefinition.class];
        if (existing) {
          throw new Error(`Pane class "${classDefinition.class}" already exists and is supplied by extension ${existing}`);
        }
        allPaneClasses[classDefinition.class] = {
          extensionId: extension.id,
          classDefinition
        };
      });
    });
  }
  getStudioProject(core) {
    return this._cache.get("getStudioProject", () => core.getProject("Studio"));
  }
  getExtensionSheet(extensionId, core) {
    return this._cache.get("extensionSheet-" + extensionId, () => this.getStudioProject(core).sheet("Extension " + extensionId));
  }
  undo() {
    this._store.undo();
  }
  redo() {
    this._store.redo();
  }
  createContentOfSaveFile(projectId) {
    return this._store.createContentOfSaveFile(projectId);
  }
};

// shared/src/globalVariableNames.ts
var studioBundle = "__TheatreJS_StudioBundle";
var coreBundle = "__TheatreJS_CoreBundle";
var notifications = "__TheatreJS_Notifications";

// studio/src/StudioBundle.ts
var StudioBundle = class {
  constructor(_studio) {
    this._studio = _studio;
    __publicField(this, "_coreBundle");
  }
  get type() {
    return "Theatre_StudioBundle";
  }
  registerCoreBundle(coreBundle2) {
    if (this._coreBundle) {
      throw new Error(`StudioBundle.coreBundle is already registered. This is a bug.`);
    }
    this._coreBundle = coreBundle2;
    let coreBits;
    coreBundle2.getBitsForStudio(this._studio, (bits) => {
      coreBits = bits;
    });
    this._studio.setCoreBits(coreBits);
  }
};

// studio/src/uiComponents/toolbar/ToolbarDropdownSelect.tsx
var import_react254 = __toModule(require_react());
init_styled_components_browser_esm();
var Container61 = styled_components_browser_esm_default.div``;
var ToolbarDropdownSelect = (props) => {
  return /* @__PURE__ */ import_react254.default.createElement(Container61, null);
};
var ToolbarDropdownSelect_default = ToolbarDropdownSelect;

// studio/src/index.ts
init_notify();
var studioPrivateAPI = new Studio();
setStudio(studioPrivateAPI);
var studio2 = studioPrivateAPI.publicApi;
var src_default = studio2;
registerStudioBundle();
function registerStudioBundle() {
  if (typeof window == "undefined")
    return;
  const existingStudioBundle = window[studioBundle];
  if (typeof existingStudioBundle !== "undefined") {
    if (typeof existingStudioBundle === "object" && existingStudioBundle && typeof existingStudioBundle.version === "string") {
      throw new Error(`It seems that the module '@theatre/studio' is loaded more than once. This could have two possible causes:
1. You might have two separate versions of Theatre.js in node_modules.
2. Or this might be a bundling misconfiguration, in case you're using a bundler like Webpack/ESBuild/Rollup.

Note that it **is okay** to import '@theatre/studio' multiple times. But those imports should point to the same module.`);
    } else {
      throw new Error(`The variable window.${studioBundle} seems to be already set by a module other than @theatre/core.`);
    }
  }
  const studioBundle2 = new StudioBundle(studioPrivateAPI);
  window[studioBundle] = studioBundle2;
  const possibleCoreBundle = window[coreBundle];
  if (possibleCoreBundle && possibleCoreBundle !== null && possibleCoreBundle.type === "Theatre_CoreBundle") {
    studioBundle2.registerCoreBundle(possibleCoreBundle);
  }
}
if (typeof window !== "undefined") {
  window[notifications] = {
    notify
  };
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
//# sourceMappingURL=index.js.map
